import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A date string, such as 2007-12-03 (YYYY-MM-DD), compliant with ISO 8601 standard
   * for representation of dates using the Gregorian calendar.
   */
  Date: { input: string; output: string; }
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the
   * date-timeformat outlined in section 5.6 of the RFC 3339 profile of the ISO 8601
   * standard for representationof dates and times using the Gregorian calendar.
   */
  DateTime: { input: string; output: string; }
  /** An human-friendly string representing an Integer. */
  FriendlyNumeral: { input: string | number; output: string | number; }
  Hex: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /** Raw JSON value */
  Json: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /**
   * The Long scalar type represents non-fractional signed whole numeric values. Long
   * can represent values between -(2^63) and 2^63 - 1.
   */
  Long: { input: number; output: number; }
  RGBAHue: { input: number; output: number; }
  RGBATransparency: { input: number; output: number; }
  /** Slate-compatible RichText AST */
  RichTextAST: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: string; output: string; }
};

export type AcceptBootcampShareInput = {
  bootcampShareId: Scalars['String']['input'];
};

export type AcceptBootcampSharePayload = {
  __typename?: 'AcceptBootcampSharePayload';
  bootcampShare?: Maybe<ScoBootcampShare>;
};

export type AcceptToolTestRunInput = {
  toolTestRunId: Scalars['String']['input'];
};

export type AcceptToolTestRunPayload = {
  __typename?: 'AcceptToolTestRunPayload';
  toolTestRun?: Maybe<ScoToolTestRun>;
};

export type AddCrmInboxInput = {
  bookingUrl?: InputMaybe<Scalars['String']['input']>;
  crmEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  toolId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AddCrmInboxPayload = {
  __typename?: 'AddCrmInboxPayload';
  /** True when a new reply tool was made; false when a spare one was used. */
  created?: Maybe<Scalars['Boolean']['output']>;
  crmEnabled?: Maybe<Scalars['Boolean']['output']>;
  toolId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AddUserSkillInput = {
  skillId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AddUserSkillPayload = {
  __typename?: 'AddUserSkillPayload';
  user: ScoUser;
};

export type AdminActionMarkAsFgMembersPayload = {
  __typename?: 'AdminActionMarkAsFGMembersPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminBanUserInput = {
  deleteComments: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AdminBanUserPayload = {
  __typename?: 'AdminBanUserPayload';
  user: ScoUser;
};

export type AdminCancelSubscriptionInput = {
  cancellationMessage?: InputMaybe<Scalars['String']['input']>;
  delay: Scalars['Boolean']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type AdminCancelSubscriptionPayload = {
  __typename?: 'AdminCancelSubscriptionPayload';
  subscription: ScoSubscription;
};

export type AdminReassignRecordInput = {
  destinationEmailConfirm: Scalars['String']['input'];
  destinationUserId: Scalars['String']['input'];
  rootId: Scalars['String']['input'];
  rootType: ScoAdminReassignableType;
};

export type AdminReassignRecordPayload = {
  __typename?: 'AdminReassignRecordPayload';
  preview: ScoAdminRecordReassignPreview;
};

export type AdminRefundAdvisorSessionInput = {
  advisorSessionId?: InputMaybe<Scalars['String']['input']>;
  amountUsd?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AdminRefundAdvisorSessionPayload = {
  __typename?: 'AdminRefundAdvisorSessionPayload';
  advisorSession?: Maybe<ScoAdvisorSession>;
};

export type AdminRefundPaymentInput = {
  amount: Scalars['Float']['input'];
  chargifyPaymentId: Scalars['Int']['input'];
  chargifySubscriptionId: Scalars['Int']['input'];
  memo: Scalars['String']['input'];
};

export type AdminRefundPaymentPayload = {
  __typename?: 'AdminRefundPaymentPayload';
  subscription: ScoSubscription;
};

export type AdminRemindAdvisorSessionPendingPartyInput = {
  advisorSessionId: Scalars['String']['input'];
};

export type AdminRemindAdvisorSessionPendingPartyPayload = {
  __typename?: 'AdminRemindAdvisorSessionPendingPartyPayload';
  advisorSession?: Maybe<ScoAdvisorSession>;
};

export type AdminRemoveGroupEventAttendanceInput = {
  groupEventAttendanceId: Scalars['String']['input'];
};

export type AdminRemoveGroupEventAttendancePayload = {
  __typename?: 'AdminRemoveGroupEventAttendancePayload';
  groupEvent?: Maybe<GroupEvent>;
  groupEventAttendance?: Maybe<GroupEventAttendance>;
};

export type AdminRemoveSocialConnectionInput = {
  socialConnectionId: Scalars['String']['input'];
};

export type AdminRemoveSocialConnectionPayload = {
  __typename?: 'AdminRemoveSocialConnectionPayload';
  user: ScoUser;
};

export type AdminRemoveUserBanInput = {
  userId: Scalars['String']['input'];
};

export type AdminRemoveUserBanPayload = {
  __typename?: 'AdminRemoveUserBanPayload';
  user: ScoUser;
};

export type AdminRemoveUserPhotoInput = {
  userId: Scalars['String']['input'];
};

export type AdminRemoveUserPhotoPayload = {
  __typename?: 'AdminRemoveUserPhotoPayload';
  user: ScoUser;
};

export type AdminResyncGroupEventToGoogleCalendarInput = {
  groupEventId: Scalars['String']['input'];
};

export type AdminResyncGroupEventToGoogleCalendarPayload = {
  __typename?: 'AdminResyncGroupEventToGoogleCalendarPayload';
  groupEvent?: Maybe<GroupEvent>;
};

export type AdminUpdateAdvisorEngagementInput = {
  advisorEngagementId?: InputMaybe<Scalars['String']['input']>;
  categoryKey?: InputMaybe<Scalars['String']['input']>;
  compensationNotes?: InputMaybe<Scalars['String']['input']>;
  notifyMatches?: InputMaybe<Scalars['Boolean']['input']>;
  statusKey?: InputMaybe<Scalars['String']['input']>;
  timeCommitmentNotes?: InputMaybe<Scalars['String']['input']>;
  whyText?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateAdvisorEngagementPayload = {
  __typename?: 'AdminUpdateAdvisorEngagementPayload';
  advisorEngagement?: Maybe<ScoAdvisorEngagement>;
};

export type AdminUpdateAdvisorProfileInput = {
  advisingNote?: InputMaybe<Scalars['String']['input']>;
  advisorProfileId?: InputMaybe<Scalars['String']['input']>;
  availabilityHoursPerMonth?: InputMaybe<Scalars['Int']['input']>;
  bioForAdvising?: InputMaybe<Scalars['String']['input']>;
  categoryKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  engagementIntroductionIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  engagementIntroductionMessage?: InputMaybe<Scalars['String']['input']>;
  engagementStyleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  isSessionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notableBrands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rankScoreBoost?: InputMaybe<Scalars['Int']['input']>;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  skillTagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  warmIntroKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AdminUpdateAdvisorProfilePayload = {
  __typename?: 'AdminUpdateAdvisorProfilePayload';
  advisorProfile?: Maybe<ScoAdvisorProfile>;
};

export type AdminUpdateCompanyInput = {
  annualRevenue?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  elevatorPitch?: InputMaybe<Scalars['String']['input']>;
  fundingRaised?: InputMaybe<Scalars['String']['input']>;
  headcount?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  yearFounded?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateCompanyPayload = {
  __typename?: 'AdminUpdateCompanyPayload';
  company: ScoCompany;
};

export type AdminUpdateFgChargifyBillingInput = {
  groupId: Scalars['String']['input'];
};

export type AdminUpdateFgChargifyBillingPayload = {
  __typename?: 'AdminUpdateFGChargifyBillingPayload';
  group?: Maybe<Group>;
  result?: Maybe<Scalars['String']['output']>;
};

export type AdminUpdateFgMemberChargifyBillingInput = {
  groupMemberId: Scalars['String']['input'];
};

export type AdminUpdateFgMemberChargifyBillingPayload = {
  __typename?: 'AdminUpdateFGMemberChargifyBillingPayload';
  result?: Maybe<Scalars['String']['output']>;
};

export type AdminUpdateProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAccountsAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AdminUpdateProfilePayload = {
  __typename?: 'AdminUpdateProfilePayload';
  user: ScoUser;
};

/** Advisor-side respondToAdvisorAgreement action (signing is Documenso / V2-E). */
export enum AdvisorAgreementResponseAction {
  Decline = 'DECLINE',
  RequestChanges = 'REQUEST_CHANGES'
}

/** AdvisorAgreement.statusKey lifecycle (draft → sent → signed | declined; revise → superseded). */
export enum AdvisorAgreementStatus {
  Declined = 'declined',
  Draft = 'draft',
  Sent = 'sent',
  Signed = 'signed',
  Superseded = 'superseded',
  Voided = 'voided'
}

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int']['output'];
};

export type AggregateCalculation = {
  __typename?: 'AggregateCalculation';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
};

/** Parameters forwarded to the Vercel AI SDK for a single AI call. Use either prompt or messages, not both. */
export type AiActionInput = {
  /** Allowed enum values when output is "enum". */
  enum?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Penalty applied to tokens proportional to how often they have already appeared. Reduces repetition. */
  frequencyPenalty?: InputMaybe<Scalars['Float']['input']>;
  /** Number of times the SDK will automatically retry on transient provider errors. */
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of agentic tool-call steps before the SDK stops. Only applies to generateText and streamText. */
  maxSteps?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of tokens to generate in the response. */
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Ordered conversation history. Mutually exclusive with prompt. Each message has
   * a role and either plain text content or rich content parts.
   */
  messages?: InputMaybe<Array<InputMaybe<AiActionMessageInput>>>;
  /** Structured output extraction mode: "auto", "json", or "tool". Only applies to generateObject and streamObject. */
  mode?: InputMaybe<Scalars['String']['input']>;
  /** Shape of the expected output: "object", "array", "no-schema", or "enum". Only applies to generateObject and streamObject. */
  output?: InputMaybe<Scalars['String']['input']>;
  /** JSON Schema string defining the expected output shape. Required when output is "object" or "array". */
  outputSchemaAsJson?: InputMaybe<Scalars['String']['input']>;
  /** Flat penalty applied to any token that has appeared at least once. Encourages topic diversity. */
  presencePenalty?: InputMaybe<Scalars['Float']['input']>;
  /** Single-turn text prompt. Mutually exclusive with messages. */
  prompt?: InputMaybe<Scalars['String']['input']>;
  /** Description of what the output object represents, passed to the model as a hint. */
  schemaDescription?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable name of the output schema, passed to the model as a hint. */
  schemaName?: InputMaybe<Scalars['String']['input']>;
  /** Random seed for deterministic output. Not supported by all providers. */
  seed?: InputMaybe<Scalars['Int']['input']>;
  /** List of strings that will halt generation when encountered. */
  stopSequences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** System prompt prepended to every call. Works with both prompt and messages. */
  system?: InputMaybe<Scalars['String']['input']>;
  /** Sampling temperature (0–2). Higher values produce more varied output; lower values are more deterministic. */
  temperature?: InputMaybe<Scalars['Float']['input']>;
  /** Limits sampling to the top K most probable tokens at each step. */
  topK?: InputMaybe<Scalars['Int']['input']>;
  /** Nucleus sampling threshold. Only tokens whose cumulative probability mass is within topP are considered. */
  topP?: InputMaybe<Scalars['Float']['input']>;
};

/** A single content part within a rich message. Set type to determine which other fields are required. */
export type AiActionMessageContentPartInput = {
  /**
   * MIME type of the asset (e.g. "application/pdf", "image/png"). Required when
   * type is "file"; optional but recommended for "image" to help the model
   * interpret the format.
   */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Text content. Required when type is "text". */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Part type: "text", "image", or "file". */
  type: Scalars['String']['input'];
  /**
   * Publicly accessible URL of the asset. Required when type is "image" or "file".
   * AiAction.process downloads http(s) URLs to bytes before calling Gemini —
   * public HTTPS PDFs sent as fileUri return 429 RESOURCE_EXHAUSTED. Short-lived
   * signed URLs may expire before replay via processInBackground.
   */
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A single message in a conversation history. Use content for plain text or
 * contentParts for mixed text/image/file messages. contentParts takes priority if
 * both are provided.
 */
export type AiActionMessageInput = {
  /** Plain text content of the message. Use this for simple text messages; use contentParts for rich content. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Rich message body composed of multiple parts (text, images, files). Takes priority over content when both are provided. */
  contentParts?: InputMaybe<Array<InputMaybe<AiActionMessageContentPartInput>>>;
  /** Who authored the message. Accepted values: "system", "user", "assistant". */
  role: Scalars['String']['input'];
};

/** The AI SDK operation to perform for a given AiAction. */
export enum AiActionOperation {
  /** Generate a structured object conforming to the provided JSON Schema and return it when finished. */
  GenerateObject = 'generateObject',
  /** Generate a complete text response and return it when finished. */
  GenerateText = 'generateText',
  /** Stream a structured object, delivering partial results incrementally as they are generated. */
  StreamObject = 'streamObject',
  /** Stream a text response, delivering tokens incrementally as they are generated. */
  StreamText = 'streamText'
}

export type AnalyzeScoCustomerExperimentInput = {
  acceptNextPlay?: InputMaybe<Scalars['Boolean']['input']>;
  customerExperimentCheckinId?: InputMaybe<Scalars['String']['input']>;
  customerExperimentId: Scalars['String']['input'];
  diagnosisKey?: InputMaybe<Scalars['String']['input']>;
  narrative?: InputMaybe<Scalars['String']['input']>;
  nextPlayKey?: InputMaybe<Scalars['String']['input']>;
  verdictKey?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyzeScoCustomerExperimentPayload = {
  __typename?: 'AnalyzeScoCustomerExperimentPayload';
  customerExperiment?: Maybe<ScoCustomerExperiment>;
  customerExperimentAnalysis?: Maybe<ScoCustomerExperimentAnalysis>;
  customerExperimentCheckin?: Maybe<ScoCustomerExperimentCheckin>;
  customerSearch?: Maybe<ScoCustomerSearch>;
  nextExperiment?: Maybe<ScoCustomerExperiment>;
};

export enum AppReactComponent {
  TrackAccountCompanyProfile = 'TRACK_ACCOUNT_COMPANY_PROFILE',
  TrackAccountGoals = 'TRACK_ACCOUNT_GOALS',
  TrackAccountIntroCall = 'TRACK_ACCOUNT_INTRO_CALL',
  TrackAccountUserProfile = 'TRACK_ACCOUNT_USER_PROFILE',
  TrackChatCta = 'TRACK_CHAT_CTA',
  TrackOfficeHoursLookup = 'TRACK_OFFICE_HOURS_LOOKUP',
  TrackWorkshopLookup = 'TRACK_WORKSHOP_LOOKUP'
}

export type ApplyCancellationDiscountInput = {
  subscriptionId: Scalars['String']['input'];
};

export type ApplyCancellationDiscountPayload = {
  __typename?: 'ApplyCancellationDiscountPayload';
  subscription?: Maybe<ScoSubscription>;
};

export type ApplyToBoardSeatInput = {
  advisorEngagementId?: InputMaybe<Scalars['String']['input']>;
  groupRequestId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type ApplyToBoardSeatPayload = {
  __typename?: 'ApplyToBoardSeatPayload';
  advisorEngagement?: Maybe<ScoAdvisorEngagement>;
  groupCommitment?: Maybe<GroupCommitment>;
};

export type ApplyToolStudioEditInput = {
  action: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  toolId?: InputMaybe<Scalars['String']['input']>;
  toolRuleId?: InputMaybe<Scalars['String']['input']>;
  toolSessionId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ApplyToolStudioEditPayload = {
  __typename?: 'ApplyToolStudioEditPayload';
  ok?: Maybe<Scalars['Boolean']['output']>;
  revisionId?: Maybe<Scalars['String']['output']>;
};

export type ApproveGroupRequestInput = {
  groupRequestId: Scalars['String']['input'];
};

export type ApproveGroupRequestPayload = {
  __typename?: 'ApproveGroupRequestPayload';
  groupRequest?: Maybe<GroupRequest>;
};

export type Article = Entity & Node & {
  __typename?: 'Article';
  authors: Array<Person>;
  body?: Maybe<Scalars['String']['output']>;
  contentTrackSteps: Array<ContentTrackStep>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Article>;
  featuredImage?: Maybe<Asset>;
  /** List of Article versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  originalPublicationDate?: Maybe<Scalars['Date']['output']>;
  playlists: Array<Playlist>;
  podcastEpisodes: Array<PodcastEpisode>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoImage?: Maybe<Asset>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoStructuredData?: Maybe<Scalars['Json']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  /**
   * WARNING - once this field is published, DO NOT CHANGE IT. Changing this value
   * will cause any existing URL to this Article to error (404). Only change this
   * with assistance from dev team.
   */
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  subjectLogos: Array<Asset>;
  /** List of key people or interview subjects in the article. */
  subjectNames: Array<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  synopsis?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms: Array<Term>;
  title: Scalars['String']['output'];
  tldr?: Maybe<Scalars['String']['output']>;
  type: ArticleType;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ArticleAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PersonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonWhereInput>;
};


export type ArticleContentTrackStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackStepWhereInput>;
};


export type ArticleCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ArticleDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ArticleFeaturedImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type ArticleHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ArticlePlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PlaylistOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PlaylistWhereInput>;
};


export type ArticlePodcastEpisodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PodcastEpisodeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PodcastEpisodeWhereInput>;
};


export type ArticlePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ArticleScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ArticleSeoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type ArticleSubjectLogosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


export type ArticleTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


export type ArticleUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ArticleConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ArticleWhereUniqueInput;
};

/** A connection to a list of items. */
export type ArticleConnection = {
  __typename?: 'ArticleConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ArticleEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ArticleCreateInput = {
  authors?: InputMaybe<PersonCreateManyInlineInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  contentTrackSteps?: InputMaybe<ContentTrackStepCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  featuredImage?: InputMaybe<AssetCreateOneInlineInput>;
  originalPublicationDate?: InputMaybe<Scalars['Date']['input']>;
  playlists?: InputMaybe<PlaylistCreateManyInlineInput>;
  podcastEpisodes?: InputMaybe<PodcastEpisodeCreateManyInlineInput>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoImage?: InputMaybe<AssetCreateOneInlineInput>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoStructuredData?: InputMaybe<Scalars['Json']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  subjectLogos?: InputMaybe<AssetCreateManyInlineInput>;
  subjectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermCreateManyInlineInput>;
  title: Scalars['String']['input'];
  tldr?: InputMaybe<Scalars['String']['input']>;
  type: ArticleType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleCreateManyInlineInput = {
  /** Connect multiple existing Article documents */
  connect?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  /** Create and connect multiple existing Article documents */
  create?: InputMaybe<Array<ArticleCreateInput>>;
};

export type ArticleCreateOneInlineInput = {
  /** Connect one existing Article document */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create and connect one Article document */
  create?: InputMaybe<ArticleCreateInput>;
};

/** An edge in a connection. */
export type ArticleEdge = {
  __typename?: 'ArticleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Article;
};

/** Identifies documents */
export type ArticleManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  authors_every?: InputMaybe<PersonWhereInput>;
  authors_none?: InputMaybe<PersonWhereInput>;
  authors_some?: InputMaybe<PersonWhereInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  contentTrackSteps_every?: InputMaybe<ContentTrackStepWhereInput>;
  contentTrackSteps_none?: InputMaybe<ContentTrackStepWhereInput>;
  contentTrackSteps_some?: InputMaybe<ContentTrackStepWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ArticleWhereStageInput>;
  documentInStages_none?: InputMaybe<ArticleWhereStageInput>;
  documentInStages_some?: InputMaybe<ArticleWhereStageInput>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  originalPublicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  originalPublicationDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  originalPublicationDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  originalPublicationDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  originalPublicationDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  originalPublicationDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  originalPublicationDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  originalPublicationDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  playlists_every?: InputMaybe<PlaylistWhereInput>;
  playlists_none?: InputMaybe<PlaylistWhereInput>;
  playlists_some?: InputMaybe<PlaylistWhereInput>;
  podcastEpisodes_every?: InputMaybe<PodcastEpisodeWhereInput>;
  podcastEpisodes_none?: InputMaybe<PodcastEpisodeWhereInput>;
  podcastEpisodes_some?: InputMaybe<PodcastEpisodeWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  seoImage?: InputMaybe<AssetWhereInput>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoKeywords_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoKeywords_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoKeywords_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoKeywords_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoKeywords_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoKeywords_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoKeywords_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoKeywords_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoKeywords_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given json path. */
  seoStructuredData_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  seoStructuredData_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subjectLogos_every?: InputMaybe<AssetWhereInput>;
  subjectLogos_none?: InputMaybe<AssetWhereInput>;
  subjectLogos_some?: InputMaybe<AssetWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  subjectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  subjectNames_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  subjectNames_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  subjectNames_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  subjectNames_not?: InputMaybe<Array<Scalars['String']['input']>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  synopsis_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  synopsis_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  synopsis_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  synopsis_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  synopsis_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  synopsis_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  synopsis_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  synopsis_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  synopsis_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  teaser_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  teaser_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  teaser_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  teaser_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  teaser_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  teaser_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  teaser_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  teaser_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  teaser_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  tldr?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tldr_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tldr_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tldr_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tldr_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tldr_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tldr_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tldr_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tldr_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tldr_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ArticleType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<ArticleType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<ArticleType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<ArticleType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ArticleOrderByInput {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  OriginalPublicationDateAsc = 'originalPublicationDate_ASC',
  OriginalPublicationDateDesc = 'originalPublicationDate_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SeoKeywordsAsc = 'seoKeywords_ASC',
  SeoKeywordsDesc = 'seoKeywords_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubjectNamesAsc = 'subjectNames_ASC',
  SubjectNamesDesc = 'subjectNames_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SynopsisAsc = 'synopsis_ASC',
  SynopsisDesc = 'synopsis_DESC',
  TeaserAsc = 'teaser_ASC',
  TeaserDesc = 'teaser_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TldrAsc = 'tldr_ASC',
  TldrDesc = 'tldr_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export enum ArticleType {
  BlogPost = 'BlogPost',
  ExpertAdvice = 'ExpertAdvice',
  FounderStory = 'FounderStory',
  Lexicon = 'Lexicon'
}

export type ArticleUpdateInput = {
  authors?: InputMaybe<PersonUpdateManyInlineInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  contentTrackSteps?: InputMaybe<ContentTrackStepUpdateManyInlineInput>;
  featuredImage?: InputMaybe<AssetUpdateOneInlineInput>;
  originalPublicationDate?: InputMaybe<Scalars['Date']['input']>;
  playlists?: InputMaybe<PlaylistUpdateManyInlineInput>;
  podcastEpisodes?: InputMaybe<PodcastEpisodeUpdateManyInlineInput>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoImage?: InputMaybe<AssetUpdateOneInlineInput>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoStructuredData?: InputMaybe<Scalars['Json']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subjectLogos?: InputMaybe<AssetUpdateManyInlineInput>;
  subjectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  tldr?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ArticleType>;
};

export type ArticleUpdateManyInlineInput = {
  /** Connect multiple existing Article documents */
  connect?: InputMaybe<Array<ArticleConnectInput>>;
  /** Create and connect multiple Article documents */
  create?: InputMaybe<Array<ArticleCreateInput>>;
  /** Delete multiple Article documents */
  delete?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  /** Disconnect multiple Article documents */
  disconnect?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Article documents */
  set?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  /** Update multiple Article documents */
  update?: InputMaybe<Array<ArticleUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Article documents */
  upsert?: InputMaybe<Array<ArticleUpsertWithNestedWhereUniqueInput>>;
};

export type ArticleUpdateManyInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  originalPublicationDate?: InputMaybe<Scalars['Date']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoStructuredData?: InputMaybe<Scalars['Json']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  subjectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tldr?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ArticleType>;
};

export type ArticleUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ArticleUpdateManyInput;
  /** Document search */
  where: ArticleWhereInput;
};

export type ArticleUpdateOneInlineInput = {
  /** Connect existing Article document */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create and connect one Article document */
  create?: InputMaybe<ArticleCreateInput>;
  /** Delete currently connected Article document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Article document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Article document */
  update?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Article document */
  upsert?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>;
};

export type ArticleUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ArticleUpdateInput;
  /** Unique document search */
  where: ArticleWhereUniqueInput;
};

export type ArticleUpsertInput = {
  /** Create document if it didn't exist */
  create: ArticleCreateInput;
  /** Update document if it exists */
  update: ArticleUpdateInput;
};

export type ArticleUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ArticleUpsertInput;
  /** Unique document search */
  where: ArticleWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ArticleWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ArticleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  authors_every?: InputMaybe<PersonWhereInput>;
  authors_none?: InputMaybe<PersonWhereInput>;
  authors_some?: InputMaybe<PersonWhereInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  contentTrackSteps_every?: InputMaybe<ContentTrackStepWhereInput>;
  contentTrackSteps_none?: InputMaybe<ContentTrackStepWhereInput>;
  contentTrackSteps_some?: InputMaybe<ContentTrackStepWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ArticleWhereStageInput>;
  documentInStages_none?: InputMaybe<ArticleWhereStageInput>;
  documentInStages_some?: InputMaybe<ArticleWhereStageInput>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  originalPublicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  originalPublicationDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  originalPublicationDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  originalPublicationDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  originalPublicationDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  originalPublicationDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  originalPublicationDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  originalPublicationDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  playlists_every?: InputMaybe<PlaylistWhereInput>;
  playlists_none?: InputMaybe<PlaylistWhereInput>;
  playlists_some?: InputMaybe<PlaylistWhereInput>;
  podcastEpisodes_every?: InputMaybe<PodcastEpisodeWhereInput>;
  podcastEpisodes_none?: InputMaybe<PodcastEpisodeWhereInput>;
  podcastEpisodes_some?: InputMaybe<PodcastEpisodeWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  seoImage?: InputMaybe<AssetWhereInput>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoKeywords_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoKeywords_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoKeywords_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoKeywords_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoKeywords_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoKeywords_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoKeywords_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoKeywords_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoKeywords_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given json path. */
  seoStructuredData_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  seoStructuredData_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subjectLogos_every?: InputMaybe<AssetWhereInput>;
  subjectLogos_none?: InputMaybe<AssetWhereInput>;
  subjectLogos_some?: InputMaybe<AssetWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  subjectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  subjectNames_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  subjectNames_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  subjectNames_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  subjectNames_not?: InputMaybe<Array<Scalars['String']['input']>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  synopsis_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  synopsis_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  synopsis_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  synopsis_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  synopsis_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  synopsis_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  synopsis_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  synopsis_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  synopsis_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  teaser_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  teaser_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  teaser_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  teaser_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  teaser_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  teaser_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  teaser_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  teaser_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  teaser_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  tldr?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tldr_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tldr_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tldr_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tldr_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tldr_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tldr_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tldr_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tldr_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tldr_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ArticleType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<ArticleType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<ArticleType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<ArticleType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ArticleWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ArticleWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ArticleWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ArticleWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ArticleWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Article record uniquely */
export type ArticleWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Asset system model */
export type Asset = Entity & Node & {
  __typename?: 'Asset';
  altText?: Maybe<Scalars['String']['output']>;
  audioFilePodcastEpisode: Array<PodcastEpisode>;
  avatarPerson: Array<Person>;
  backgroundImageContentTrack: Array<ContentTrack>;
  backgroundImageContentTrackSection: Array<ContentTrackSection>;
  backgroundImageContentTrackStep: Array<ContentTrackStep>;
  caption?: Maybe<Scalars['String']['output']>;
  cardImageBenefit: Array<Benefit>;
  companyLogoPerson: Array<Person>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Asset>;
  featuredImageArticle: Array<Article>;
  featuredImageContentTrack: Array<ContentTrack>;
  featuredImageContentTrackSection: Array<ContentTrackSection>;
  featuredImageContentTrackStep: Array<ContentTrackStep>;
  featuredImageVideo: Array<Video>;
  featuredImageVideoCourse: Array<VideoCourse>;
  featuredImageVideoList: Array<VideoList>;
  featuredImageVideoPlaylist: Array<VideoPlaylist>;
  /** The file name */
  fileName: Scalars['String']['output'];
  /** The file handle */
  handle: Scalars['String']['output'];
  /** The height of the file */
  height?: Maybe<Scalars['Float']['output']>;
  heroImageBenefit: Array<Benefit>;
  /** List of Asset versions */
  history: Array<Version>;
  iconBusinessStage: Array<BusinessStage>;
  iconTerm: Array<Term>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Original URL this asset was imported from, to help link records. */
  importUrl?: Maybe<Scalars['String']['output']>;
  /** S3 key returned from Filestack */
  key?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Asset>;
  logoImageBenefit: Array<Benefit>;
  /** The mime type of the file */
  mimeType?: Maybe<Scalars['String']['output']>;
  posterImagePodcastEpisode: Array<PodcastEpisode>;
  posterImageVideoLesson: Array<VideoLesson>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  screenshotImagesBenefit: Array<Benefit>;
  seoImageArticle: Array<Article>;
  seoImagePodcastEpisode: Array<PodcastEpisode>;
  /** The file size */
  size?: Maybe<Scalars['Float']['output']>;
  /** System stage field */
  stage: Stage;
  subjectLogosArticle: Array<Article>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /**
   * Returns information you need to upload the asset. The type of upload is
   * dependant on what you pass into asset creations as upload type.
   */
  upload?: Maybe<AssetUpload>;
  /** Get the url for the asset with provided transformations applied. */
  url: Scalars['String']['output'];
  /** The file width */
  width?: Maybe<Scalars['Float']['output']>;
};


/** Asset system model */
export type AssetAudioFilePodcastEpisodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PodcastEpisodeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PodcastEpisodeWhereInput>;
};


/** Asset system model */
export type AssetAvatarPersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PersonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonWhereInput>;
};


/** Asset system model */
export type AssetBackgroundImageContentTrackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContentTrackOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackWhereInput>;
};


/** Asset system model */
export type AssetBackgroundImageContentTrackSectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContentTrackSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackSectionWhereInput>;
};


/** Asset system model */
export type AssetBackgroundImageContentTrackStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContentTrackStepOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackStepWhereInput>;
};


/** Asset system model */
export type AssetCardImageBenefitArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BenefitOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BenefitWhereInput>;
};


/** Asset system model */
export type AssetCompanyLogoPersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PersonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonWhereInput>;
};


/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Asset system model */
export type AssetFeaturedImageArticleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};


/** Asset system model */
export type AssetFeaturedImageContentTrackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContentTrackOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackWhereInput>;
};


/** Asset system model */
export type AssetFeaturedImageContentTrackSectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContentTrackSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackSectionWhereInput>;
};


/** Asset system model */
export type AssetFeaturedImageContentTrackStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContentTrackStepOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackStepWhereInput>;
};


/** Asset system model */
export type AssetFeaturedImageVideoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoWhereInput>;
};


/** Asset system model */
export type AssetFeaturedImageVideoCourseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoCourseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoCourseWhereInput>;
};


/** Asset system model */
export type AssetFeaturedImageVideoListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoListWhereInput>;
};


/** Asset system model */
export type AssetFeaturedImageVideoPlaylistArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoPlaylistOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoPlaylistWhereInput>;
};


/** Asset system model */
export type AssetHeroImageBenefitArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BenefitOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BenefitWhereInput>;
};


/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Asset system model */
export type AssetIconBusinessStageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BusinessStageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BusinessStageWhereInput>;
};


/** Asset system model */
export type AssetIconTermArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


/** Asset system model */
export type AssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Asset system model */
export type AssetLogoImageBenefitArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BenefitOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BenefitWhereInput>;
};


/** Asset system model */
export type AssetPosterImagePodcastEpisodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PodcastEpisodeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PodcastEpisodeWhereInput>;
};


/** Asset system model */
export type AssetPosterImageVideoLessonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoLessonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoLessonWhereInput>;
};


/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Asset system model */
export type AssetScreenshotImagesBenefitArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BenefitOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BenefitWhereInput>;
};


/** Asset system model */
export type AssetSeoImageArticleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};


/** Asset system model */
export type AssetSeoImagePodcastEpisodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PodcastEpisodeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PodcastEpisodeWhereInput>;
};


/** Asset system model */
export type AssetSubjectLogosArticleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};


/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetUrlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};

export type AssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetCreateInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  audioFilePodcastEpisode?: InputMaybe<PodcastEpisodeCreateManyInlineInput>;
  avatarPerson?: InputMaybe<PersonCreateManyInlineInput>;
  backgroundImageContentTrack?: InputMaybe<ContentTrackCreateManyInlineInput>;
  backgroundImageContentTrackSection?: InputMaybe<ContentTrackSectionCreateManyInlineInput>;
  backgroundImageContentTrackStep?: InputMaybe<ContentTrackStepCreateManyInlineInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  cardImageBenefit?: InputMaybe<BenefitCreateManyInlineInput>;
  companyLogoPerson?: InputMaybe<PersonCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  featuredImageArticle?: InputMaybe<ArticleCreateManyInlineInput>;
  featuredImageContentTrack?: InputMaybe<ContentTrackCreateManyInlineInput>;
  featuredImageContentTrackSection?: InputMaybe<ContentTrackSectionCreateManyInlineInput>;
  featuredImageContentTrackStep?: InputMaybe<ContentTrackStepCreateManyInlineInput>;
  featuredImageVideo?: InputMaybe<VideoCreateManyInlineInput>;
  featuredImageVideoCourse?: InputMaybe<VideoCourseCreateManyInlineInput>;
  featuredImageVideoList?: InputMaybe<VideoListCreateManyInlineInput>;
  featuredImageVideoPlaylist?: InputMaybe<VideoPlaylistCreateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  heroImageBenefit?: InputMaybe<BenefitCreateManyInlineInput>;
  iconBusinessStage?: InputMaybe<BusinessStageCreateManyInlineInput>;
  iconTerm?: InputMaybe<TermCreateManyInlineInput>;
  importUrl?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AssetCreateLocalizationsInput>;
  logoImageBenefit?: InputMaybe<BenefitCreateManyInlineInput>;
  posterImagePodcastEpisode?: InputMaybe<PodcastEpisodeCreateManyInlineInput>;
  posterImageVideoLesson?: InputMaybe<VideoLessonCreateManyInlineInput>;
  screenshotImagesBenefit?: InputMaybe<BenefitCreateManyInlineInput>;
  seoImageArticle?: InputMaybe<ArticleCreateManyInlineInput>;
  seoImagePodcastEpisode?: InputMaybe<PodcastEpisodeCreateManyInlineInput>;
  subjectLogosArticle?: InputMaybe<ArticleCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Create and connect multiple existing Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
};

export type AssetCreateOneInlineInput = {
  /** Connect one existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Asset;
};

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  altText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  altText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  altText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  altText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  altText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  altText_starts_with?: InputMaybe<Scalars['String']['input']>;
  audioFilePodcastEpisode_every?: InputMaybe<PodcastEpisodeWhereInput>;
  audioFilePodcastEpisode_none?: InputMaybe<PodcastEpisodeWhereInput>;
  audioFilePodcastEpisode_some?: InputMaybe<PodcastEpisodeWhereInput>;
  avatarPerson_every?: InputMaybe<PersonWhereInput>;
  avatarPerson_none?: InputMaybe<PersonWhereInput>;
  avatarPerson_some?: InputMaybe<PersonWhereInput>;
  backgroundImageContentTrackSection_every?: InputMaybe<ContentTrackSectionWhereInput>;
  backgroundImageContentTrackSection_none?: InputMaybe<ContentTrackSectionWhereInput>;
  backgroundImageContentTrackSection_some?: InputMaybe<ContentTrackSectionWhereInput>;
  backgroundImageContentTrackStep_every?: InputMaybe<ContentTrackStepWhereInput>;
  backgroundImageContentTrackStep_none?: InputMaybe<ContentTrackStepWhereInput>;
  backgroundImageContentTrackStep_some?: InputMaybe<ContentTrackStepWhereInput>;
  backgroundImageContentTrack_every?: InputMaybe<ContentTrackWhereInput>;
  backgroundImageContentTrack_none?: InputMaybe<ContentTrackWhereInput>;
  backgroundImageContentTrack_some?: InputMaybe<ContentTrackWhereInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardImageBenefit_every?: InputMaybe<BenefitWhereInput>;
  cardImageBenefit_none?: InputMaybe<BenefitWhereInput>;
  cardImageBenefit_some?: InputMaybe<BenefitWhereInput>;
  companyLogoPerson_every?: InputMaybe<PersonWhereInput>;
  companyLogoPerson_none?: InputMaybe<PersonWhereInput>;
  companyLogoPerson_some?: InputMaybe<PersonWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  featuredImageArticle_every?: InputMaybe<ArticleWhereInput>;
  featuredImageArticle_none?: InputMaybe<ArticleWhereInput>;
  featuredImageArticle_some?: InputMaybe<ArticleWhereInput>;
  featuredImageContentTrackSection_every?: InputMaybe<ContentTrackSectionWhereInput>;
  featuredImageContentTrackSection_none?: InputMaybe<ContentTrackSectionWhereInput>;
  featuredImageContentTrackSection_some?: InputMaybe<ContentTrackSectionWhereInput>;
  featuredImageContentTrackStep_every?: InputMaybe<ContentTrackStepWhereInput>;
  featuredImageContentTrackStep_none?: InputMaybe<ContentTrackStepWhereInput>;
  featuredImageContentTrackStep_some?: InputMaybe<ContentTrackStepWhereInput>;
  featuredImageContentTrack_every?: InputMaybe<ContentTrackWhereInput>;
  featuredImageContentTrack_none?: InputMaybe<ContentTrackWhereInput>;
  featuredImageContentTrack_some?: InputMaybe<ContentTrackWhereInput>;
  featuredImageVideoCourse_every?: InputMaybe<VideoCourseWhereInput>;
  featuredImageVideoCourse_none?: InputMaybe<VideoCourseWhereInput>;
  featuredImageVideoCourse_some?: InputMaybe<VideoCourseWhereInput>;
  featuredImageVideoList_every?: InputMaybe<VideoListWhereInput>;
  featuredImageVideoList_none?: InputMaybe<VideoListWhereInput>;
  featuredImageVideoList_some?: InputMaybe<VideoListWhereInput>;
  featuredImageVideoPlaylist_every?: InputMaybe<VideoPlaylistWhereInput>;
  featuredImageVideoPlaylist_none?: InputMaybe<VideoPlaylistWhereInput>;
  featuredImageVideoPlaylist_some?: InputMaybe<VideoPlaylistWhereInput>;
  featuredImageVideo_every?: InputMaybe<VideoWhereInput>;
  featuredImageVideo_none?: InputMaybe<VideoWhereInput>;
  featuredImageVideo_some?: InputMaybe<VideoWhereInput>;
  heroImageBenefit_every?: InputMaybe<BenefitWhereInput>;
  heroImageBenefit_none?: InputMaybe<BenefitWhereInput>;
  heroImageBenefit_some?: InputMaybe<BenefitWhereInput>;
  iconBusinessStage_every?: InputMaybe<BusinessStageWhereInput>;
  iconBusinessStage_none?: InputMaybe<BusinessStageWhereInput>;
  iconBusinessStage_some?: InputMaybe<BusinessStageWhereInput>;
  iconTerm_every?: InputMaybe<TermWhereInput>;
  iconTerm_none?: InputMaybe<TermWhereInput>;
  iconTerm_some?: InputMaybe<TermWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  importUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  importUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  importUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  importUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  importUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  importUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  importUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  importUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  importUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  importUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  logoImageBenefit_every?: InputMaybe<BenefitWhereInput>;
  logoImageBenefit_none?: InputMaybe<BenefitWhereInput>;
  logoImageBenefit_some?: InputMaybe<BenefitWhereInput>;
  posterImagePodcastEpisode_every?: InputMaybe<PodcastEpisodeWhereInput>;
  posterImagePodcastEpisode_none?: InputMaybe<PodcastEpisodeWhereInput>;
  posterImagePodcastEpisode_some?: InputMaybe<PodcastEpisodeWhereInput>;
  posterImageVideoLesson_every?: InputMaybe<VideoLessonWhereInput>;
  posterImageVideoLesson_none?: InputMaybe<VideoLessonWhereInput>;
  posterImageVideoLesson_some?: InputMaybe<VideoLessonWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  screenshotImagesBenefit_every?: InputMaybe<BenefitWhereInput>;
  screenshotImagesBenefit_none?: InputMaybe<BenefitWhereInput>;
  screenshotImagesBenefit_some?: InputMaybe<BenefitWhereInput>;
  seoImageArticle_every?: InputMaybe<ArticleWhereInput>;
  seoImageArticle_none?: InputMaybe<ArticleWhereInput>;
  seoImageArticle_some?: InputMaybe<ArticleWhereInput>;
  seoImagePodcastEpisode_every?: InputMaybe<PodcastEpisodeWhereInput>;
  seoImagePodcastEpisode_none?: InputMaybe<PodcastEpisodeWhereInput>;
  seoImagePodcastEpisode_some?: InputMaybe<PodcastEpisodeWhereInput>;
  subjectLogosArticle_every?: InputMaybe<ArticleWhereInput>;
  subjectLogosArticle_none?: InputMaybe<ArticleWhereInput>;
  subjectLogosArticle_some?: InputMaybe<ArticleWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

export enum AssetOrderByInput {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HandleAsc = 'handle_ASC',
  HandleDesc = 'handle_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ImportUrlAsc = 'importUrl_ASC',
  ImportUrlDesc = 'importUrl_DESC',
  KeyAsc = 'key_ASC',
  KeyDesc = 'key_DESC',
  MimeTypeAsc = 'mimeType_ASC',
  MimeTypeDesc = 'mimeType_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>;
  image?: InputMaybe<ImageTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetUpdateInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  audioFilePodcastEpisode?: InputMaybe<PodcastEpisodeUpdateManyInlineInput>;
  avatarPerson?: InputMaybe<PersonUpdateManyInlineInput>;
  backgroundImageContentTrack?: InputMaybe<ContentTrackUpdateManyInlineInput>;
  backgroundImageContentTrackSection?: InputMaybe<ContentTrackSectionUpdateManyInlineInput>;
  backgroundImageContentTrackStep?: InputMaybe<ContentTrackStepUpdateManyInlineInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  cardImageBenefit?: InputMaybe<BenefitUpdateManyInlineInput>;
  companyLogoPerson?: InputMaybe<PersonUpdateManyInlineInput>;
  featuredImageArticle?: InputMaybe<ArticleUpdateManyInlineInput>;
  featuredImageContentTrack?: InputMaybe<ContentTrackUpdateManyInlineInput>;
  featuredImageContentTrackSection?: InputMaybe<ContentTrackSectionUpdateManyInlineInput>;
  featuredImageContentTrackStep?: InputMaybe<ContentTrackStepUpdateManyInlineInput>;
  featuredImageVideo?: InputMaybe<VideoUpdateManyInlineInput>;
  featuredImageVideoCourse?: InputMaybe<VideoCourseUpdateManyInlineInput>;
  featuredImageVideoList?: InputMaybe<VideoListUpdateManyInlineInput>;
  featuredImageVideoPlaylist?: InputMaybe<VideoPlaylistUpdateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  heroImageBenefit?: InputMaybe<BenefitUpdateManyInlineInput>;
  iconBusinessStage?: InputMaybe<BusinessStageUpdateManyInlineInput>;
  iconTerm?: InputMaybe<TermUpdateManyInlineInput>;
  importUrl?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<AssetUpdateLocalizationsInput>;
  logoImageBenefit?: InputMaybe<BenefitUpdateManyInlineInput>;
  posterImagePodcastEpisode?: InputMaybe<PodcastEpisodeUpdateManyInlineInput>;
  posterImageVideoLesson?: InputMaybe<VideoLessonUpdateManyInlineInput>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  screenshotImagesBenefit?: InputMaybe<BenefitUpdateManyInlineInput>;
  seoImageArticle?: InputMaybe<ArticleUpdateManyInlineInput>;
  seoImagePodcastEpisode?: InputMaybe<PodcastEpisodeUpdateManyInlineInput>;
  subjectLogosArticle?: InputMaybe<ArticleUpdateManyInlineInput>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationDataInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>;
};

export type AssetUpdateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetConnectInput>>;
  /** Create and connect multiple Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
  /** Delete multiple Asset documents */
  delete?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Disconnect multiple Asset documents */
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Asset documents */
  set?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Update multiple Asset documents */
  update?: InputMaybe<Array<AssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Asset documents */
  upsert?: InputMaybe<Array<AssetUpsertWithNestedWhereUniqueInput>>;
};

export type AssetUpdateManyInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  importUrl?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AssetUpdateManyInput;
  /** Document search */
  where: AssetWhereInput;
};

export type AssetUpdateOneInlineInput = {
  /** Connect existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
  /** Delete currently connected Asset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Asset document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Asset document */
  update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Asset document */
  upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetUpdateInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** Asset Upload */
export type AssetUpload = {
  __typename?: 'AssetUpload';
  /** Asset Upload Error */
  error?: Maybe<AssetUploadError>;
  /** Expiry Timestamp */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Asset Request Data for upload */
  requestPostData?: Maybe<AssetUploadRequestPostData>;
  /** Asset Request Data for upload */
  status?: Maybe<AssetUploadStatus>;
};

/** Represents asset upload error */
export type AssetUploadError = {
  __typename?: 'AssetUploadError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
  __typename?: 'AssetUploadRequestPostData';
  /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
  algorithm: Scalars['String']['output'];
  /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
  credential: Scalars['String']['output'];
  /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
  date: Scalars['String']['output'];
  /** The key to use in the form field. This value should be passed in the `Key` form field. */
  key: Scalars['String']['output'];
  /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
  policy: Scalars['String']['output'];
  /**
   * The security token to use in the form field. This field is optional only pass
   * it if its not null. This value should be passed in the `X-Amz-Security-Token`
   * form field if not null.
   */
  securityToken?: Maybe<Scalars['String']['output']>;
  /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
  signature: Scalars['String']['output'];
  /** The URL to which the file should be uploaded with a POST request. */
  url: Scalars['String']['output'];
};

/** System Asset Upload Status */
export enum AssetUploadStatus {
  AssetCreatePending = 'ASSET_CREATE_PENDING',
  AssetErrorUpload = 'ASSET_ERROR_UPLOAD',
  AssetUpdatePending = 'ASSET_UPDATE_PENDING',
  AssetUploadComplete = 'ASSET_UPLOAD_COMPLETE'
}

/** Identifies documents */
export type AssetUploadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

/** Identifies documents */
export type AssetUploadWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput;
  /** Update document if it exists */
  update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
  create: AssetCreateLocalizationDataInput;
  locale: Locale;
  update: AssetUpdateLocalizationDataInput;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetUpsertInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  altText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  altText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  altText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  altText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  altText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  altText_starts_with?: InputMaybe<Scalars['String']['input']>;
  audioFilePodcastEpisode_every?: InputMaybe<PodcastEpisodeWhereInput>;
  audioFilePodcastEpisode_none?: InputMaybe<PodcastEpisodeWhereInput>;
  audioFilePodcastEpisode_some?: InputMaybe<PodcastEpisodeWhereInput>;
  avatarPerson_every?: InputMaybe<PersonWhereInput>;
  avatarPerson_none?: InputMaybe<PersonWhereInput>;
  avatarPerson_some?: InputMaybe<PersonWhereInput>;
  backgroundImageContentTrackSection_every?: InputMaybe<ContentTrackSectionWhereInput>;
  backgroundImageContentTrackSection_none?: InputMaybe<ContentTrackSectionWhereInput>;
  backgroundImageContentTrackSection_some?: InputMaybe<ContentTrackSectionWhereInput>;
  backgroundImageContentTrackStep_every?: InputMaybe<ContentTrackStepWhereInput>;
  backgroundImageContentTrackStep_none?: InputMaybe<ContentTrackStepWhereInput>;
  backgroundImageContentTrackStep_some?: InputMaybe<ContentTrackStepWhereInput>;
  backgroundImageContentTrack_every?: InputMaybe<ContentTrackWhereInput>;
  backgroundImageContentTrack_none?: InputMaybe<ContentTrackWhereInput>;
  backgroundImageContentTrack_some?: InputMaybe<ContentTrackWhereInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardImageBenefit_every?: InputMaybe<BenefitWhereInput>;
  cardImageBenefit_none?: InputMaybe<BenefitWhereInput>;
  cardImageBenefit_some?: InputMaybe<BenefitWhereInput>;
  companyLogoPerson_every?: InputMaybe<PersonWhereInput>;
  companyLogoPerson_none?: InputMaybe<PersonWhereInput>;
  companyLogoPerson_some?: InputMaybe<PersonWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  featuredImageArticle_every?: InputMaybe<ArticleWhereInput>;
  featuredImageArticle_none?: InputMaybe<ArticleWhereInput>;
  featuredImageArticle_some?: InputMaybe<ArticleWhereInput>;
  featuredImageContentTrackSection_every?: InputMaybe<ContentTrackSectionWhereInput>;
  featuredImageContentTrackSection_none?: InputMaybe<ContentTrackSectionWhereInput>;
  featuredImageContentTrackSection_some?: InputMaybe<ContentTrackSectionWhereInput>;
  featuredImageContentTrackStep_every?: InputMaybe<ContentTrackStepWhereInput>;
  featuredImageContentTrackStep_none?: InputMaybe<ContentTrackStepWhereInput>;
  featuredImageContentTrackStep_some?: InputMaybe<ContentTrackStepWhereInput>;
  featuredImageContentTrack_every?: InputMaybe<ContentTrackWhereInput>;
  featuredImageContentTrack_none?: InputMaybe<ContentTrackWhereInput>;
  featuredImageContentTrack_some?: InputMaybe<ContentTrackWhereInput>;
  featuredImageVideoCourse_every?: InputMaybe<VideoCourseWhereInput>;
  featuredImageVideoCourse_none?: InputMaybe<VideoCourseWhereInput>;
  featuredImageVideoCourse_some?: InputMaybe<VideoCourseWhereInput>;
  featuredImageVideoList_every?: InputMaybe<VideoListWhereInput>;
  featuredImageVideoList_none?: InputMaybe<VideoListWhereInput>;
  featuredImageVideoList_some?: InputMaybe<VideoListWhereInput>;
  featuredImageVideoPlaylist_every?: InputMaybe<VideoPlaylistWhereInput>;
  featuredImageVideoPlaylist_none?: InputMaybe<VideoPlaylistWhereInput>;
  featuredImageVideoPlaylist_some?: InputMaybe<VideoPlaylistWhereInput>;
  featuredImageVideo_every?: InputMaybe<VideoWhereInput>;
  featuredImageVideo_none?: InputMaybe<VideoWhereInput>;
  featuredImageVideo_some?: InputMaybe<VideoWhereInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  heroImageBenefit_every?: InputMaybe<BenefitWhereInput>;
  heroImageBenefit_none?: InputMaybe<BenefitWhereInput>;
  heroImageBenefit_some?: InputMaybe<BenefitWhereInput>;
  iconBusinessStage_every?: InputMaybe<BusinessStageWhereInput>;
  iconBusinessStage_none?: InputMaybe<BusinessStageWhereInput>;
  iconBusinessStage_some?: InputMaybe<BusinessStageWhereInput>;
  iconTerm_every?: InputMaybe<TermWhereInput>;
  iconTerm_none?: InputMaybe<TermWhereInput>;
  iconTerm_some?: InputMaybe<TermWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  importUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  importUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  importUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  importUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  importUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  importUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  importUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  importUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  importUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  importUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  logoImageBenefit_every?: InputMaybe<BenefitWhereInput>;
  logoImageBenefit_none?: InputMaybe<BenefitWhereInput>;
  logoImageBenefit_some?: InputMaybe<BenefitWhereInput>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']['input']>;
  posterImagePodcastEpisode_every?: InputMaybe<PodcastEpisodeWhereInput>;
  posterImagePodcastEpisode_none?: InputMaybe<PodcastEpisodeWhereInput>;
  posterImagePodcastEpisode_some?: InputMaybe<PodcastEpisodeWhereInput>;
  posterImageVideoLesson_every?: InputMaybe<VideoLessonWhereInput>;
  posterImageVideoLesson_none?: InputMaybe<VideoLessonWhereInput>;
  posterImageVideoLesson_some?: InputMaybe<VideoLessonWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  screenshotImagesBenefit_every?: InputMaybe<BenefitWhereInput>;
  screenshotImagesBenefit_none?: InputMaybe<BenefitWhereInput>;
  screenshotImagesBenefit_some?: InputMaybe<BenefitWhereInput>;
  seoImageArticle_every?: InputMaybe<ArticleWhereInput>;
  seoImageArticle_none?: InputMaybe<ArticleWhereInput>;
  seoImageArticle_some?: InputMaybe<ArticleWhereInput>;
  seoImagePodcastEpisode_every?: InputMaybe<PodcastEpisodeWhereInput>;
  seoImagePodcastEpisode_none?: InputMaybe<PodcastEpisodeWhereInput>;
  seoImagePodcastEpisode_some?: InputMaybe<PodcastEpisodeWhereInput>;
  size?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  subjectLogosArticle_every?: InputMaybe<ArticleWhereInput>;
  subjectLogosArticle_none?: InputMaybe<ArticleWhereInput>;
  subjectLogosArticle_some?: InputMaybe<ArticleWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
  width?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AttachChargifySubscriptionInput = {
  chargifySubscriptionId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AttachChargifySubscriptionPayload = {
  __typename?: 'AttachChargifySubscriptionPayload';
  subscription?: Maybe<ScoSubscription>;
  user?: Maybe<ScoUser>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long']['output'];
};

/**
 * Legacy Beancounter CRM-style contact (name, email, customer flag) with traits
 * and per-app accounts. Not used by the primary payment/transaction admin queries.
 */
export type BeancounterContact = ScoNode & {
  __typename?: 'BeancounterContact';
  /** Per-product app accounts linked to this contact. */
  accounts?: Maybe<Array<Maybe<BeancounterContactAppAccount>>>;
  /** Contact email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** Contact first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** GraphQL node id for the contact. */
  id: Scalars['ID']['output'];
  /** Whether this contact is marked as a paying customer. */
  isCustomer?: Maybe<Scalars['Boolean']['output']>;
  /** Contact last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Arbitrary name/value traits attached to the contact. */
  traits?: Maybe<Array<Maybe<BeancounterContactTrait>>>;
};

/**
 * Legacy Beancounter link between a contact and an external product account
 * (product id/name and external id), including roles on that account.
 */
export type BeancounterContactAppAccount = ScoNode & {
  __typename?: 'BeancounterContactAppAccount';
  /** External system id for this account in the product application. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** GraphQL node id for the app account. */
  id: Scalars['ID']['output'];
  /** Product identifier for the application this account belongs to. */
  productId?: Maybe<Scalars['String']['output']>;
  /** Display name of the product, resolved from the related product record. */
  productName?: Maybe<Scalars['String']['output']>;
  /** Roles granted to the contact on this app account. */
  roles?: Maybe<Array<Maybe<BeancounterContactAppAccountRole>>>;
};

/** Legacy role assignment for a BeancounterContactAppAccount. */
export type BeancounterContactAppAccountRole = ScoNode & {
  __typename?: 'BeancounterContactAppAccountRole';
  /** GraphQL node id for the role assignment. */
  id: Scalars['ID']['output'];
  /** Name of the role on the app account. */
  roleName?: Maybe<Scalars['String']['output']>;
};

/** Legacy free-form name/value attribute on a BeancounterContact. */
export type BeancounterContactTrait = ScoNode & {
  __typename?: 'BeancounterContactTrait';
  /** GraphQL node id for the trait. */
  id: Scalars['ID']['output'];
  /** Trait key / attribute name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Trait value as a string. */
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * Point-in-time Founder Groups / Accelerator subscription metrics from the
 * Subscription model (not Beancounter payment rows). Defaults to core Accelerator
 * product ids when productIds is omitted.
 */
export type BeancounterFgSubscriberReport = {
  __typename?: 'BeancounterFGSubscriberReport';
  /** Count of active paying monthly subscriptions (interval 1 month, balanceInCents = 0, mrr > 0). */
  activePayingMonthlySubscriptionsCount?: Maybe<Scalars['Int']['output']>;
  /** Sum of mrrValueInCents for active paying monthly subscriptions only. */
  activePayingMonthlySubscriptionsMRRValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Count of active paying non-monthly subscriptions (not 1-month interval, balanceInCents = 0, mrr > 0). */
  activePayingNonMonthlySubscriptionsCount?: Maybe<Scalars['Int']['output']>;
  /** Sum of mrrValueInCents for active paying non-monthly subscriptions only. */
  activePayingNonMonthlySubscriptionsMRRValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Count of active paying subscriptions: nextAssessmentAt in the future, not canceled/delayed-cancel, mrrValueInCents > 0. */
  activePayingSubscriptionsCount?: Maybe<Scalars['Int']['output']>;
  /** Sum of mrrValueInCents for all active paying subscriptions (mrr > 0). */
  activePayingSubscriptionsMRRValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Count of active subscriptions in dunning: state "active", balanceInCents > 0, still due for assessment, not canceled. */
  dunningSubscriptionsCount?: Maybe<Scalars['Int']['output']>;
  /** Sum of mrrValueInCents for subscriptions currently in dunning (balance > 0). */
  dunningSubscriptionsMRRValueInCents?: Maybe<Scalars['Int']['output']>;
};


/**
 * Point-in-time Founder Groups / Accelerator subscription metrics from the
 * Subscription model (not Beancounter payment rows). Defaults to core Accelerator
 * product ids when productIds is omitted.
 */
export type BeancounterFgSubscriberReportActivePayingMonthlySubscriptionsCountArgs = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * Point-in-time Founder Groups / Accelerator subscription metrics from the
 * Subscription model (not Beancounter payment rows). Defaults to core Accelerator
 * product ids when productIds is omitted.
 */
export type BeancounterFgSubscriberReportActivePayingMonthlySubscriptionsMrrValueInCentsArgs = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * Point-in-time Founder Groups / Accelerator subscription metrics from the
 * Subscription model (not Beancounter payment rows). Defaults to core Accelerator
 * product ids when productIds is omitted.
 */
export type BeancounterFgSubscriberReportActivePayingNonMonthlySubscriptionsCountArgs = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * Point-in-time Founder Groups / Accelerator subscription metrics from the
 * Subscription model (not Beancounter payment rows). Defaults to core Accelerator
 * product ids when productIds is omitted.
 */
export type BeancounterFgSubscriberReportActivePayingNonMonthlySubscriptionsMrrValueInCentsArgs = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * Point-in-time Founder Groups / Accelerator subscription metrics from the
 * Subscription model (not Beancounter payment rows). Defaults to core Accelerator
 * product ids when productIds is omitted.
 */
export type BeancounterFgSubscriberReportActivePayingSubscriptionsCountArgs = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * Point-in-time Founder Groups / Accelerator subscription metrics from the
 * Subscription model (not Beancounter payment rows). Defaults to core Accelerator
 * product ids when productIds is omitted.
 */
export type BeancounterFgSubscriberReportActivePayingSubscriptionsMrrValueInCentsArgs = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * Point-in-time Founder Groups / Accelerator subscription metrics from the
 * Subscription model (not Beancounter payment rows). Defaults to core Accelerator
 * product ids when productIds is omitted.
 */
export type BeancounterFgSubscriberReportDunningSubscriptionsCountArgs = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * Point-in-time Founder Groups / Accelerator subscription metrics from the
 * Subscription model (not Beancounter payment rows). Defaults to core Accelerator
 * product ids when productIds is omitted.
 */
export type BeancounterFgSubscriberReportDunningSubscriptionsMrrValueInCentsArgs = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** New-unit metrics derived from Beancounter payments with sequencePosition 0 (first payment / signup) in a date range. */
export type BeancounterFgUnitsReport = {
  __typename?: 'BeancounterFGUnitsReport';
  /**
   * Sum of totalCaptureInCents for signup payments (sequencePosition = 0) in the
   * date range, converted to dollars and divided by days in the period.
   */
  averageNewDollarsPerDay?: Maybe<Scalars['Float']['output']>;
  /**
   * Count of signup payments (sequencePosition = 0) in the date range, divided by
   * days in the period. Defaults to the current calendar month when dates are omitted.
   */
  averageNewUnitsPerDay?: Maybe<Scalars['Float']['output']>;
};


/** New-unit metrics derived from Beancounter payments with sequencePosition 0 (first payment / signup) in a date range. */
export type BeancounterFgUnitsReportAverageNewDollarsPerDayArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** New-unit metrics derived from Beancounter payments with sequencePosition 0 (first payment / signup) in a date range. */
export type BeancounterFgUnitsReportAverageNewUnitsPerDayArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Legacy Beancounter group/organization entity (name, phone, email, entity type). Not used by the primary payment admin UI. */
export type BeancounterGroup = ScoNode & {
  __typename?: 'BeancounterGroup';
  /** Contact email for the group. */
  email?: Maybe<Scalars['String']['output']>;
  /** Classification of the entity (group type). */
  entityType?: Maybe<Scalars['String']['output']>;
  /** GraphQL node id for the group. */
  id: Scalars['ID']['output'];
  /** Group or organization display name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Contact phone number for the group. */
  phone?: Maybe<Scalars['String']['output']>;
};

/**
 * Normalized payment record in Beancounter, built from Stripe charges or WePay
 * checkouts. One payment groups related capture/refund/chargeback transactions and
 * is classified by brand, product, and recurring type.
 */
export type BeancounterPayment = ScoNode & {
  __typename?: 'BeancounterPayment';
  /**
   * Product brand id from beancounter/brands.js. Expected values:
   * "accelerator_saas", "founder_groups", "startups_co", "startups_com_sessions",
   * "bizplan", "launchrock", "invstor", "fundable", "platform_fees", "clarity",
   * "clarity_new", "unknown", and legacy ids "consulting", "killerstartups",
   * "coaching", "bootcamp", "zirtual".
   */
  brand?: Maybe<Scalars['String']['output']>;
  /**
   * Card network brand from the processor (e.g. "Visa", "Mastercard", "American
   * Express") or "N/A" / "Unknown" when unavailable.
   */
  cardBrand?: Maybe<Scalars['String']['output']>;
  /** Last four digits of the payment method. Defaults to "XXXX" when unknown. */
  cardLast4?: Maybe<Scalars['String']['output']>;
  /** Card funding type from the processor. For Stripe: "credit", "debit", "prepaid", or "N/A". For WePay often "card". */
  cardType?: Maybe<Scalars['String']['output']>;
  /** Chargebee customer id linked to this payment when matched via Chargebee transaction records. */
  chargebeeCustomerIdentifier?: Maybe<Scalars['String']['output']>;
  /** Chargebee invoice id linked to this payment when available. */
  chargebeeInvoiceIdentifier?: Maybe<Scalars['String']['output']>;
  /** Chargebee subscription id associated with this payment (reads model field chargebeeSubscriptionIdentifier). */
  chargebeeSubscriptionId?: Maybe<Scalars['String']['output']>;
  /** Chargify customer id linked to this payment when matched via Chargify statement records. */
  chargifyCustomerIdentifier?: Maybe<Scalars['String']['output']>;
  /** Chargify statement id linked to this payment when available. */
  chargifyStatementIdentifier?: Maybe<Scalars['String']['output']>;
  /** Chargify subscription id associated with this payment (reads model field chargifySubscriptionIdentifier). */
  chargifySubscriptionId?: Maybe<Scalars['String']['output']>;
  /** When this Beancounter payment row was first created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Human-readable payment description, usually from Chargebee invoice line items
   * or the Stripe charge description. Used for product matching and search.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** Business-effective timestamp of the original charge (from the processor record), used for reporting date ranges. */
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** GraphQL node id; same value as paymentId. */
  id: Scalars['ID']['output'];
  /** Payer email address from the processor customer/checkout record. */
  payerEmail?: Maybe<Scalars['String']['output']>;
  /** Payer display name from the processor (Stripe billing_details/source name, Chargebee customer name, or WePay payer name). */
  payerName?: Maybe<Scalars['String']['output']>;
  /** Resolved subscription for the payer, when payerSubscriptionId is set. */
  payerSubscription?: Maybe<ScoSubscription>;
  /** Internal subscriptions.subscriptionId resolved from Chargebee/Chargify subscription identifiers. Null when not linked. */
  payerSubscriptionId?: Maybe<Scalars['String']['output']>;
  /** Resolved Startups.com user for the payer, when payerUserId is set. */
  payerUser?: Maybe<ScoUser>;
  /** Internal users.userId of the payer when matched by payerEmail. Null when no matching user is found. */
  payerUserId?: Maybe<Scalars['String']['output']>;
  /** Primary key UUID for this Beancounter payment. */
  paymentId?: Maybe<Scalars['String']['output']>;
  /** Payment processor that originated the charge. Expected values: "stripe", "wepay". */
  processor?: Maybe<Scalars['String']['output']>;
  /** JSON string of the raw processor charge/checkout payload (Stripe charge or WePay checkout) when available. */
  processorDataAsJson?: Maybe<Scalars['String']['output']>;
  /** Processor-side payment id: Stripe charge id (ch_…) or WePay checkout id. Used to join raw processor records. */
  processorPaymentId?: Maybe<Scalars['String']['output']>;
  /**
   * Deep link to the payment in the processor dashboard. Stripe returns a
   * dashboard URL; WePay returns a generic wepay.com link.
   */
  processorPaymentUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Classified product id from beancounter/products.js (e.g.
   * "online_accelerator_community", "clarity_call", "fundable_subscription",
   * "bizplan_starter_plan_monthly", "{brand}_unknown_product", "unknown"). Matched
   * from charge description, soft descriptor, and Stripe client.
   */
  product?: Maybe<Scalars['String']['output']>;
  /**
   * Lifecycle classification from beancounter/recurringTypes.js. Expected values:
   * "one_time_charge", "monthly_subscription_signup",
   * "monthly_subscription_renewal", "subscription_signup", "subscription_renewal",
   * "service_fee", "unknown". Derived from brand/product recurrence and
   * sequencePosition.
   */
  recurringType?: Maybe<Scalars['String']['output']>;
  /** Sales-tracking events attributed to this payment (commissions, assignments). */
  salesEvents?: Maybe<ScoSalesEventCollection>;
  /** Sales persons linked to this payment via sales events. */
  salesPersons?: Maybe<ScoSalesPersonCollection>;
  /**
   * Zero-based index of this payment in the payer’s history for the same brand
   * (and email). 0 is treated as signup; greater than 0 as renewal when
   * classifying recurringType.
   */
  sequencePosition?: Maybe<Scalars['Int']['output']>;
  /**
   * Derived payment outcome from transaction totals. Expected values: "capture"
   * (captured, no refund/dispute), "partial_refund", "full_refund", "chargeback",
   * "chargeback_won", "unknown".
   */
  status?: Maybe<Scalars['String']['output']>;
  /** Sum of grossValueInCents for related transactions with type "capture". */
  totalCaptureInCents?: Maybe<Scalars['Int']['output']>;
  /** Sum of grossValueInCents for related transactions with type "chargeback" (usually negative). */
  totalChargebackInCents?: Maybe<Scalars['Int']['output']>;
  /** Sum of grossValueInCents for related transactions with type "chargeback_won" (funds recovered after a dispute). */
  totalChargebackWonInCents?: Maybe<Scalars['Int']['output']>;
  /** Sum of feeInCents across all related transactions (processor fees; typically negative). */
  totalFeeInCents?: Maybe<Scalars['Int']['output']>;
  /**
   * Net amount after captures, refunds, fees, and chargebacks: totalCapture +
   * totalRefund + totalFee + totalChargeback + totalChargebackWon (all in cents).
   */
  totalNetInCents?: Maybe<Scalars['Int']['output']>;
  /** Sum of grossValueInCents for related transactions with type "refund" (usually negative). */
  totalRefundInCents?: Maybe<Scalars['Int']['output']>;
  /**
   * Virtual total of money returned: totalRefundInCents + totalChargebackInCents +
   * totalChargebackWonInCents. Typically negative or zero.
   */
  totalReturnInCents?: Maybe<Scalars['Int']['output']>;
  /** Ledger lines for this payment: captures, refunds, fees, and chargebacks/won chargebacks. */
  transactions?: Maybe<Array<Maybe<BeancounterTransaction>>>;
  /** When this Beancounter payment row was last updated (e.g. after reprocessing). */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Original charge amount in cents from the processor (Stripe charge.amount or WePay amount), before refunds/fees. */
  valueInCents?: Maybe<Scalars['Int']['output']>;
};


/**
 * Normalized payment record in Beancounter, built from Stripe charges or WePay
 * checkouts. One payment groups related capture/refund/chargeback transactions and
 * is classified by brand, product, and recurring type.
 */
export type BeancounterPaymentSalesEventsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Normalized payment record in Beancounter, built from Stripe charges or WePay
 * checkouts. One payment groups related capture/refund/chargeback transactions and
 * is classified by brand, product, and recurring type.
 */
export type BeancounterPaymentSalesPersonsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeancounterPaymentCollection = {
  __typename?: 'BeancounterPaymentCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<BeancounterPayment>>;
  pagination: Pagination;
};

export type BeancounterReports = {
  __typename?: 'BeancounterReports';
  /** Root object for Founder Groups / Accelerator active subscriber and MRR metrics (queries live Subscription rows). */
  fgSubscriberReport?: Maybe<BeancounterFgSubscriberReport>;
  /** JSON-stringified Founder Groups trial conversion report for the given date range (defaults to the current calendar month). */
  fgTrialConversionReportAsJson?: Maybe<Scalars['String']['output']>;
  /** Root object for new-unit and new-dollar daily averages from Beancounter payments with sequencePosition 0 (signups). */
  fgUnitsReport?: Maybe<BeancounterFgUnitsReport>;
  /** Latest payment.effectiveDate across all Beancounter payments (most recent charge covered). Requires admin auth. */
  mostRecentPaymentEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** Latest updatedAt across all Beancounter payments (import/reprocess freshness). Requires admin auth. */
  mostRecentPaymentUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Latest transaction.effectiveDate across all Beancounter transactions. Requires admin auth. */
  mostRecentTransactionEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** Latest updatedAt across all Beancounter transactions. Requires admin auth. */
  mostRecentTransactionUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type BeancounterReportsFgTrialConversionReportAsJsonArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Legacy Beancounter role name entity. */
export type BeancounterRole = ScoNode & {
  __typename?: 'BeancounterRole';
  /** GraphQL node id for the role. */
  id: Scalars['ID']['output'];
  /** Role display name. */
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * Imported Stripe BalanceTransaction raw record used to build
 * BeancounterTransaction lines (charges, refunds, adjustments). dataAsJson holds
 * the processor payload; effectiveDate is the business date used when building
 * payments/transactions.
 */
export type BeancounterStripeBalanceTransactionRecord = ScoNode & {
  __typename?: 'BeancounterStripeBalanceTransactionRecord';
  /** When this Beancounter import row was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** JSON-serialized raw Stripe API object for this record. */
  dataAsJson?: Maybe<Scalars['String']['output']>;
  /** Business-effective timestamp for reporting/import ordering. */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /** Stripe object id (or internal primary key) for this imported record. */
  id: Scalars['ID']['output'];
  /** When this Beancounter import row was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/**
 * Imported Stripe Card/payment-method raw record retained for Beancounter import
 * history. dataAsJson holds the processor payload; effectiveDate is the business
 * date used when building payments/transactions.
 */
export type BeancounterStripeCardRecord = ScoNode & {
  __typename?: 'BeancounterStripeCardRecord';
  /** When this Beancounter import row was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** JSON-serialized raw Stripe API object for this record. */
  dataAsJson?: Maybe<Scalars['String']['output']>;
  /** Business-effective timestamp for reporting/import ordering. */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /** Stripe object id (or internal primary key) for this imported record. */
  id: Scalars['ID']['output'];
  /** When this Beancounter import row was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/**
 * Imported Stripe Charge raw record; primary source for BeancounterPayment rows
 * when processor is stripe. dataAsJson holds the processor payload; effectiveDate
 * is the business date used when building payments/transactions.
 */
export type BeancounterStripeChargeRecord = ScoNode & {
  __typename?: 'BeancounterStripeChargeRecord';
  /** When this Beancounter import row was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** JSON-serialized raw Stripe API object for this record. */
  dataAsJson?: Maybe<Scalars['String']['output']>;
  /** Business-effective timestamp for reporting/import ordering. */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /** Stripe object id (or internal primary key) for this imported record. */
  id: Scalars['ID']['output'];
  /** When this Beancounter import row was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/**
 * Imported Stripe Customer raw record used for payer email/name and
 * sequence-position history. dataAsJson holds the processor payload; effectiveDate
 * is the business date used when building payments/transactions.
 */
export type BeancounterStripeCustomerRecord = ScoNode & {
  __typename?: 'BeancounterStripeCustomerRecord';
  /** When this Beancounter import row was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** JSON-serialized raw Stripe API object for this record. */
  dataAsJson?: Maybe<Scalars['String']['output']>;
  /** Business-effective timestamp for reporting/import ordering. */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /** Stripe object id (or internal primary key) for this imported record. */
  id: Scalars['ID']['output'];
  /** When this Beancounter import row was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/**
 * Imported Stripe Dispute raw record used when creating chargeback transaction
 * lines. dataAsJson holds the processor payload; effectiveDate is the business
 * date used when building payments/transactions.
 */
export type BeancounterStripeDisputeRecord = ScoNode & {
  __typename?: 'BeancounterStripeDisputeRecord';
  /** When this Beancounter import row was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** JSON-serialized raw Stripe API object for this record. */
  dataAsJson?: Maybe<Scalars['String']['output']>;
  /** Business-effective timestamp for reporting/import ordering. */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /** Stripe object id (or internal primary key) for this imported record. */
  id: Scalars['ID']['output'];
  /** When this Beancounter import row was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/**
 * Imported Stripe Event raw record retained for Beancounter webhook/import
 * auditing. dataAsJson holds the processor payload; effectiveDate is the business
 * date used when building payments/transactions.
 */
export type BeancounterStripeEventRecord = ScoNode & {
  __typename?: 'BeancounterStripeEventRecord';
  /** When this Beancounter import row was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** JSON-serialized raw Stripe API object for this record. */
  dataAsJson?: Maybe<Scalars['String']['output']>;
  /** Business-effective timestamp for reporting/import ordering. */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /** Stripe object id (or internal primary key) for this imported record. */
  id: Scalars['ID']['output'];
  /** When this Beancounter import row was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/**
 * Imported Stripe Refund raw record used when creating refund transaction lines.
 * dataAsJson holds the processor payload; effectiveDate is the business date used
 * when building payments/transactions.
 */
export type BeancounterStripeRefundRecord = ScoNode & {
  __typename?: 'BeancounterStripeRefundRecord';
  /** When this Beancounter import row was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** JSON-serialized raw Stripe API object for this record. */
  dataAsJson?: Maybe<Scalars['String']['output']>;
  /** Business-effective timestamp for reporting/import ordering. */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /** Stripe object id (or internal primary key) for this imported record. */
  id: Scalars['ID']['output'];
  /** When this Beancounter import row was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/**
 * Individual money-movement line under a BeancounterPayment (capture, refund,
 * chargeback, or chargeback won), including processor fees. Sourced from Stripe
 * balance transactions or WePay checkout events.
 */
export type BeancounterTransaction = ScoNode & {
  __typename?: 'BeancounterTransaction';
  /** When this Beancounter transaction row was first created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** When this money movement occurred according to the processor record. */
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** Human-readable fee label from the processor (e.g. Stripe fee_details description, defaulting to "Stripe fee"). */
  feeDescription?: Maybe<Scalars['String']['output']>;
  /** Processor fee for this line in cents. Stored as a negative amount for Stripe (fee * -1); may be zero when no fee applies. */
  feeInCents?: Maybe<Scalars['Int']['output']>;
  /**
   * Gross amount of this line in cents before fees. Positive for captures/won
   * chargebacks; typically negative for refunds and chargebacks.
   */
  grossValueInCents?: Maybe<Scalars['Int']['output']>;
  /** GraphQL node id; same value as transactionId. */
  id: Scalars['ID']['output'];
  /** Net amount for this line after fees (processor net, e.g. Stripe balance_transaction.net). */
  netValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Parent payment that owns this transaction line. */
  payment?: Maybe<BeancounterPayment>;
  /** Foreign key to the parent BeancounterPayment.paymentId. */
  paymentId?: Maybe<Scalars['String']['output']>;
  /**
   * Processor payment id this line belongs to (Stripe charge id or WePay checkout
   * id); matches parent payment.processorPaymentId.
   */
  processorPaymentId?: Maybe<Scalars['String']['output']>;
  /** Processor-side transaction id for this ledger line (e.g. Stripe balance_transaction id). Used for idempotent import. */
  processorTransactionId?: Maybe<Scalars['String']['output']>;
  /** Primary key UUID for this Beancounter transaction line. */
  transactionId?: Maybe<Scalars['String']['output']>;
  /**
   * Transaction kind from beancounter/transactionTypes.js. Expected values:
   * "capture", "refund", "chargeback", "chargeback_won". Mapped from Stripe
   * balance-transaction types (charge/refund/adjustment) or WePay events.
   */
  type?: Maybe<Scalars['String']['output']>;
  /** When this Beancounter transaction row was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BeancounterTransactionCollection = {
  __typename?: 'BeancounterTransactionCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<BeancounterTransaction>>;
  pagination: Pagination;
};

export type Benefit = Entity & Node & {
  __typename?: 'Benefit';
  /** Image used on full page displays */
  cardImage?: Maybe<Asset>;
  categories: Array<Term>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Web link describing the vendor or benefit in greater detail. */
  descriptiveUrl?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<Benefit>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  /** Complete description used on full page views of the benefit. */
  fullDescription?: Maybe<RichText>;
  /** Used in card/list displays */
  heroImage?: Maybe<Asset>;
  /** List of Benefit versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  legalTerms?: Maybe<RichText>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  /** Partner logo, in high quality PNG or SVG format, with knockout transparency as needed. */
  logoImage?: Maybe<Asset>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  redemptionCode?: Maybe<Scalars['String']['output']>;
  redemptionInstructions?: Maybe<Scalars['String']['output']>;
  redemptionUrl?: Maybe<Scalars['String']['output']>;
  removeHeroOverlay?: Maybe<Scalars['Boolean']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** High quality JPEG images, all at the same ratio/dimensions */
  screenshotImages: Array<Asset>;
  /**
   * Short text key used to generate URLs. Should be short, no spaces, using only
   * lowercase letters, numbers, and hyphens, just-like-this
   */
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  tagline?: Maybe<Scalars['String']['output']>;
  /** Short text description, used on cards and list layouts */
  teaser?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Five words or less describing the benefit's key value, e.g., "$100 credit", "50% off three months", etc. */
  valueDescription?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  youTubeUrl?: Maybe<Scalars['String']['output']>;
};


export type BenefitCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type BenefitCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


export type BenefitCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BenefitDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type BenefitHeroImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type BenefitHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type BenefitLogoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type BenefitPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BenefitScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type BenefitScreenshotImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


export type BenefitUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type BenefitConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BenefitWhereUniqueInput;
};

/** A connection to a list of items. */
export type BenefitConnection = {
  __typename?: 'BenefitConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BenefitEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BenefitCreateInput = {
  cardImage?: InputMaybe<AssetCreateOneInlineInput>;
  categories?: InputMaybe<TermCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  descriptiveUrl?: InputMaybe<Scalars['String']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  fullDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
  heroImage?: InputMaybe<AssetCreateOneInlineInput>;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  legalTerms?: InputMaybe<Scalars['RichTextAST']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<AssetCreateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  redemptionCode?: InputMaybe<Scalars['String']['input']>;
  redemptionInstructions?: InputMaybe<Scalars['String']['input']>;
  redemptionUrl?: InputMaybe<Scalars['String']['input']>;
  removeHeroOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  screenshotImages?: InputMaybe<AssetCreateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  valueDescription?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  youTubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type BenefitCreateManyInlineInput = {
  /** Connect multiple existing Benefit documents */
  connect?: InputMaybe<Array<BenefitWhereUniqueInput>>;
  /** Create and connect multiple existing Benefit documents */
  create?: InputMaybe<Array<BenefitCreateInput>>;
};

export type BenefitCreateOneInlineInput = {
  /** Connect one existing Benefit document */
  connect?: InputMaybe<BenefitWhereUniqueInput>;
  /** Create and connect one Benefit document */
  create?: InputMaybe<BenefitCreateInput>;
};

/** An edge in a connection. */
export type BenefitEdge = {
  __typename?: 'BenefitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Benefit;
};

/** Identifies documents */
export type BenefitManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BenefitWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BenefitWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BenefitWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<AssetWhereInput>;
  categories_every?: InputMaybe<TermWhereInput>;
  categories_none?: InputMaybe<TermWhereInput>;
  categories_some?: InputMaybe<TermWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  descriptiveUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  descriptiveUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  descriptiveUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  descriptiveUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  descriptiveUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  descriptiveUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  descriptiveUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  descriptiveUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  descriptiveUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  descriptiveUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<BenefitWhereStageInput>;
  documentInStages_none?: InputMaybe<BenefitWhereStageInput>;
  documentInStages_some?: InputMaybe<BenefitWhereStageInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  facebookUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  facebookUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  facebookUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  facebookUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  facebookUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  facebookUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  facebookUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  facebookUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  facebookUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  heroImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  instagramUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  instagramUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  instagramUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  instagramUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  instagramUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  instagramUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  instagramUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  instagramUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  instagramUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkedInUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkedInUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkedInUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkedInUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkedInUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkedInUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkedInUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkedInUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkedInUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<AssetWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  redemptionCode?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  redemptionCode_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  redemptionCode_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  redemptionCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  redemptionCode_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  redemptionCode_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  redemptionCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  redemptionCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  redemptionCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  redemptionCode_starts_with?: InputMaybe<Scalars['String']['input']>;
  redemptionInstructions?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  redemptionInstructions_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  redemptionInstructions_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  redemptionInstructions_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  redemptionInstructions_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  redemptionInstructions_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  redemptionInstructions_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  redemptionInstructions_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  redemptionInstructions_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  redemptionInstructions_starts_with?: InputMaybe<Scalars['String']['input']>;
  redemptionUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  redemptionUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  redemptionUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  redemptionUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  redemptionUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  redemptionUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  redemptionUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  redemptionUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  redemptionUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  redemptionUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  removeHeroOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  removeHeroOverlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  screenshotImages_every?: InputMaybe<AssetWhereInput>;
  screenshotImages_none?: InputMaybe<AssetWhereInput>;
  screenshotImages_some?: InputMaybe<AssetWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tagline_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tagline_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tagline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tagline_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tagline_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tagline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tagline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tagline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tagline_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  teaser_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  teaser_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  teaser_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  teaser_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  teaser_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  teaser_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  teaser_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  teaser_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  teaser_starts_with?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  twitterUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  twitterUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  twitterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  twitterUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  twitterUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  twitterUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  twitterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  twitterUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  twitterUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  valueDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  valueDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  valueDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  valueDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  valueDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  valueDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  valueDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  valueDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  valueDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  valueDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  youTubeUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  youTubeUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  youTubeUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  youTubeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  youTubeUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  youTubeUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  youTubeUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  youTubeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  youTubeUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  youTubeUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum BenefitOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptiveUrlAsc = 'descriptiveUrl_ASC',
  DescriptiveUrlDesc = 'descriptiveUrl_DESC',
  FacebookUrlAsc = 'facebookUrl_ASC',
  FacebookUrlDesc = 'facebookUrl_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InstagramUrlAsc = 'instagramUrl_ASC',
  InstagramUrlDesc = 'instagramUrl_DESC',
  LinkedInUrlAsc = 'linkedInUrl_ASC',
  LinkedInUrlDesc = 'linkedInUrl_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PriorityAsc = 'priority_ASC',
  PriorityDesc = 'priority_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  RedemptionCodeAsc = 'redemptionCode_ASC',
  RedemptionCodeDesc = 'redemptionCode_DESC',
  RedemptionInstructionsAsc = 'redemptionInstructions_ASC',
  RedemptionInstructionsDesc = 'redemptionInstructions_DESC',
  RedemptionUrlAsc = 'redemptionUrl_ASC',
  RedemptionUrlDesc = 'redemptionUrl_DESC',
  RemoveHeroOverlayAsc = 'removeHeroOverlay_ASC',
  RemoveHeroOverlayDesc = 'removeHeroOverlay_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC',
  TeaserAsc = 'teaser_ASC',
  TeaserDesc = 'teaser_DESC',
  TwitterUrlAsc = 'twitterUrl_ASC',
  TwitterUrlDesc = 'twitterUrl_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  ValueDescriptionAsc = 'valueDescription_ASC',
  ValueDescriptionDesc = 'valueDescription_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC',
  YouTubeUrlAsc = 'youTubeUrl_ASC',
  YouTubeUrlDesc = 'youTubeUrl_DESC'
}

export type BenefitUpdateInput = {
  cardImage?: InputMaybe<AssetUpdateOneInlineInput>;
  categories?: InputMaybe<TermUpdateManyInlineInput>;
  descriptiveUrl?: InputMaybe<Scalars['String']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  fullDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
  heroImage?: InputMaybe<AssetUpdateOneInlineInput>;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  legalTerms?: InputMaybe<Scalars['RichTextAST']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<AssetUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  redemptionCode?: InputMaybe<Scalars['String']['input']>;
  redemptionInstructions?: InputMaybe<Scalars['String']['input']>;
  redemptionUrl?: InputMaybe<Scalars['String']['input']>;
  removeHeroOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  screenshotImages?: InputMaybe<AssetUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  valueDescription?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  youTubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type BenefitUpdateManyInlineInput = {
  /** Connect multiple existing Benefit documents */
  connect?: InputMaybe<Array<BenefitConnectInput>>;
  /** Create and connect multiple Benefit documents */
  create?: InputMaybe<Array<BenefitCreateInput>>;
  /** Delete multiple Benefit documents */
  delete?: InputMaybe<Array<BenefitWhereUniqueInput>>;
  /** Disconnect multiple Benefit documents */
  disconnect?: InputMaybe<Array<BenefitWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Benefit documents */
  set?: InputMaybe<Array<BenefitWhereUniqueInput>>;
  /** Update multiple Benefit documents */
  update?: InputMaybe<Array<BenefitUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Benefit documents */
  upsert?: InputMaybe<Array<BenefitUpsertWithNestedWhereUniqueInput>>;
};

export type BenefitUpdateManyInput = {
  descriptiveUrl?: InputMaybe<Scalars['String']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  fullDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  legalTerms?: InputMaybe<Scalars['RichTextAST']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  redemptionCode?: InputMaybe<Scalars['String']['input']>;
  redemptionInstructions?: InputMaybe<Scalars['String']['input']>;
  redemptionUrl?: InputMaybe<Scalars['String']['input']>;
  removeHeroOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  valueDescription?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  youTubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type BenefitUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BenefitUpdateManyInput;
  /** Document search */
  where: BenefitWhereInput;
};

export type BenefitUpdateOneInlineInput = {
  /** Connect existing Benefit document */
  connect?: InputMaybe<BenefitWhereUniqueInput>;
  /** Create and connect one Benefit document */
  create?: InputMaybe<BenefitCreateInput>;
  /** Delete currently connected Benefit document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Benefit document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Benefit document */
  update?: InputMaybe<BenefitUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Benefit document */
  upsert?: InputMaybe<BenefitUpsertWithNestedWhereUniqueInput>;
};

export type BenefitUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BenefitUpdateInput;
  /** Unique document search */
  where: BenefitWhereUniqueInput;
};

export type BenefitUpsertInput = {
  /** Create document if it didn't exist */
  create: BenefitCreateInput;
  /** Update document if it exists */
  update: BenefitUpdateInput;
};

export type BenefitUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BenefitUpsertInput;
  /** Unique document search */
  where: BenefitWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type BenefitWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type BenefitWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BenefitWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BenefitWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BenefitWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<AssetWhereInput>;
  categories_every?: InputMaybe<TermWhereInput>;
  categories_none?: InputMaybe<TermWhereInput>;
  categories_some?: InputMaybe<TermWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  descriptiveUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  descriptiveUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  descriptiveUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  descriptiveUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  descriptiveUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  descriptiveUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  descriptiveUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  descriptiveUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  descriptiveUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  descriptiveUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<BenefitWhereStageInput>;
  documentInStages_none?: InputMaybe<BenefitWhereStageInput>;
  documentInStages_some?: InputMaybe<BenefitWhereStageInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  facebookUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  facebookUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  facebookUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  facebookUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  facebookUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  facebookUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  facebookUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  facebookUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  facebookUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  heroImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  instagramUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  instagramUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  instagramUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  instagramUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  instagramUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  instagramUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  instagramUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  instagramUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  instagramUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkedInUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkedInUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkedInUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkedInUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkedInUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkedInUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkedInUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkedInUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkedInUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<AssetWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  priority_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  priority_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  priority_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  priority_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  priority_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  redemptionCode?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  redemptionCode_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  redemptionCode_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  redemptionCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  redemptionCode_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  redemptionCode_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  redemptionCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  redemptionCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  redemptionCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  redemptionCode_starts_with?: InputMaybe<Scalars['String']['input']>;
  redemptionInstructions?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  redemptionInstructions_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  redemptionInstructions_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  redemptionInstructions_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  redemptionInstructions_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  redemptionInstructions_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  redemptionInstructions_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  redemptionInstructions_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  redemptionInstructions_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  redemptionInstructions_starts_with?: InputMaybe<Scalars['String']['input']>;
  redemptionUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  redemptionUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  redemptionUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  redemptionUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  redemptionUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  redemptionUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  redemptionUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  redemptionUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  redemptionUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  redemptionUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  removeHeroOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  removeHeroOverlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  screenshotImages_every?: InputMaybe<AssetWhereInput>;
  screenshotImages_none?: InputMaybe<AssetWhereInput>;
  screenshotImages_some?: InputMaybe<AssetWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tagline_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tagline_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tagline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tagline_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tagline_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tagline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tagline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tagline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tagline_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  teaser_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  teaser_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  teaser_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  teaser_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  teaser_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  teaser_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  teaser_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  teaser_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  teaser_starts_with?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  twitterUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  twitterUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  twitterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  twitterUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  twitterUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  twitterUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  twitterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  twitterUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  twitterUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  valueDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  valueDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  valueDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  valueDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  valueDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  valueDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  valueDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  valueDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  valueDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  valueDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  youTubeUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  youTubeUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  youTubeUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  youTubeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  youTubeUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  youTubeUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  youTubeUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  youTubeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  youTubeUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  youTubeUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type BenefitWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BenefitWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BenefitWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BenefitWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<BenefitWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Benefit record uniquely */
export type BenefitWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BootcampEvent = Entity & Node & {
  __typename?: 'BootcampEvent';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<BootcampEvent>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** List of BootcampEvent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  startDate: Scalars['DateTime']['output'];
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type BootcampEventCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BootcampEventDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type BootcampEventHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type BootcampEventPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BootcampEventScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type BootcampEventUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type BootcampEventConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BootcampEventWhereUniqueInput;
};

/** A connection to a list of items. */
export type BootcampEventConnection = {
  __typename?: 'BootcampEventConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BootcampEventEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BootcampEventCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BootcampEventCreateManyInlineInput = {
  /** Connect multiple existing BootcampEvent documents */
  connect?: InputMaybe<Array<BootcampEventWhereUniqueInput>>;
  /** Create and connect multiple existing BootcampEvent documents */
  create?: InputMaybe<Array<BootcampEventCreateInput>>;
};

export type BootcampEventCreateOneInlineInput = {
  /** Connect one existing BootcampEvent document */
  connect?: InputMaybe<BootcampEventWhereUniqueInput>;
  /** Create and connect one BootcampEvent document */
  create?: InputMaybe<BootcampEventCreateInput>;
};

/** An edge in a connection. */
export type BootcampEventEdge = {
  __typename?: 'BootcampEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BootcampEvent;
};

/** Identifies documents */
export type BootcampEventManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BootcampEventWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BootcampEventWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BootcampEventWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<BootcampEventWhereStageInput>;
  documentInStages_none?: InputMaybe<BootcampEventWhereStageInput>;
  documentInStages_some?: InputMaybe<BootcampEventWhereStageInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  startDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum BootcampEventOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EndDateAsc = 'endDate_ASC',
  EndDateDesc = 'endDate_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type BootcampEventUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BootcampEventUpdateManyInlineInput = {
  /** Connect multiple existing BootcampEvent documents */
  connect?: InputMaybe<Array<BootcampEventConnectInput>>;
  /** Create and connect multiple BootcampEvent documents */
  create?: InputMaybe<Array<BootcampEventCreateInput>>;
  /** Delete multiple BootcampEvent documents */
  delete?: InputMaybe<Array<BootcampEventWhereUniqueInput>>;
  /** Disconnect multiple BootcampEvent documents */
  disconnect?: InputMaybe<Array<BootcampEventWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing BootcampEvent documents */
  set?: InputMaybe<Array<BootcampEventWhereUniqueInput>>;
  /** Update multiple BootcampEvent documents */
  update?: InputMaybe<Array<BootcampEventUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BootcampEvent documents */
  upsert?: InputMaybe<Array<BootcampEventUpsertWithNestedWhereUniqueInput>>;
};

export type BootcampEventUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BootcampEventUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BootcampEventUpdateManyInput;
  /** Document search */
  where: BootcampEventWhereInput;
};

export type BootcampEventUpdateOneInlineInput = {
  /** Connect existing BootcampEvent document */
  connect?: InputMaybe<BootcampEventWhereUniqueInput>;
  /** Create and connect one BootcampEvent document */
  create?: InputMaybe<BootcampEventCreateInput>;
  /** Delete currently connected BootcampEvent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected BootcampEvent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single BootcampEvent document */
  update?: InputMaybe<BootcampEventUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BootcampEvent document */
  upsert?: InputMaybe<BootcampEventUpsertWithNestedWhereUniqueInput>;
};

export type BootcampEventUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BootcampEventUpdateInput;
  /** Unique document search */
  where: BootcampEventWhereUniqueInput;
};

export type BootcampEventUpsertInput = {
  /** Create document if it didn't exist */
  create: BootcampEventCreateInput;
  /** Update document if it exists */
  update: BootcampEventUpdateInput;
};

export type BootcampEventUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BootcampEventUpsertInput;
  /** Unique document search */
  where: BootcampEventWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type BootcampEventWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type BootcampEventWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BootcampEventWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BootcampEventWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BootcampEventWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<BootcampEventWhereStageInput>;
  documentInStages_none?: InputMaybe<BootcampEventWhereStageInput>;
  documentInStages_some?: InputMaybe<BootcampEventWhereStageInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  startDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type BootcampEventWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BootcampEventWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BootcampEventWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BootcampEventWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<BootcampEventWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References BootcampEvent record uniquely */
export type BootcampEventWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BrandPartner = ScoNode & {
  __typename?: 'BrandPartner';
  brandPartnerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type BulkCreateInvestorProfileUserSaveInput = {
  investorProfileIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type BulkCreateInvestorProfileUserSavePayload = {
  __typename?: 'BulkCreateInvestorProfileUserSavePayload';
  investorProfiles?: Maybe<Array<Maybe<ScoInvestorProfile>>>;
  viewer?: Maybe<Viewer>;
};

export type BulkUpsertInvestorMatchesInput = {
  upsertInvestorMatchInputs: Array<InputMaybe<UpsertInvestorMatchInput>>;
};

export type BulkUpsertInvestorMatchesPayload = {
  __typename?: 'BulkUpsertInvestorMatchesPayload';
  investorMatches?: Maybe<Array<Maybe<ScoInvestorMatch>>>;
  investorSearches?: Maybe<Array<Maybe<ScoInvestorSearch>>>;
};

/** Business Stage */
export type BusinessStage = Entity & Node & {
  __typename?: 'BusinessStage';
  businessStage?: Maybe<BusinessStage>;
  businessStages: Array<BusinessStage>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<BusinessStage>;
  /** List of BusinessStage versions */
  history: Array<Version>;
  icon?: Maybe<Asset>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  terms: Array<Term>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  weight?: Maybe<Scalars['Int']['output']>;
};


/** Business Stage */
export type BusinessStageBusinessStageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Business Stage */
export type BusinessStageBusinessStagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BusinessStageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BusinessStageWhereInput>;
};


/** Business Stage */
export type BusinessStageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Business Stage */
export type BusinessStageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Business Stage */
export type BusinessStageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Business Stage */
export type BusinessStageIconArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Business Stage */
export type BusinessStagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Business Stage */
export type BusinessStageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Business Stage */
export type BusinessStageTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


/** Business Stage */
export type BusinessStageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type BusinessStageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BusinessStageWhereUniqueInput;
};

/** A connection to a list of items. */
export type BusinessStageConnection = {
  __typename?: 'BusinessStageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BusinessStageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BusinessStageCreateInput = {
  businessStage?: InputMaybe<BusinessStageCreateOneInlineInput>;
  businessStages?: InputMaybe<BusinessStageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<AssetCreateOneInlineInput>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  terms?: InputMaybe<TermCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessStageCreateManyInlineInput = {
  /** Connect multiple existing BusinessStage documents */
  connect?: InputMaybe<Array<BusinessStageWhereUniqueInput>>;
  /** Create and connect multiple existing BusinessStage documents */
  create?: InputMaybe<Array<BusinessStageCreateInput>>;
};

export type BusinessStageCreateOneInlineInput = {
  /** Connect one existing BusinessStage document */
  connect?: InputMaybe<BusinessStageWhereUniqueInput>;
  /** Create and connect one BusinessStage document */
  create?: InputMaybe<BusinessStageCreateInput>;
};

/** An edge in a connection. */
export type BusinessStageEdge = {
  __typename?: 'BusinessStageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BusinessStage;
};

/** Identifies documents */
export type BusinessStageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BusinessStageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BusinessStageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BusinessStageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  businessStage?: InputMaybe<BusinessStageWhereInput>;
  businessStages_every?: InputMaybe<BusinessStageWhereInput>;
  businessStages_none?: InputMaybe<BusinessStageWhereInput>;
  businessStages_some?: InputMaybe<BusinessStageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<BusinessStageWhereStageInput>;
  documentInStages_none?: InputMaybe<BusinessStageWhereStageInput>;
  documentInStages_some?: InputMaybe<BusinessStageWhereStageInput>;
  icon?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isPrimary_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  weight_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  weight_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  weight_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  weight_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  weight_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  weight_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  weight_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum BusinessStageOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsPrimaryAsc = 'isPrimary_ASC',
  IsPrimaryDesc = 'isPrimary_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WeightAsc = 'weight_ASC',
  WeightDesc = 'weight_DESC'
}

export type BusinessStageUpdateInput = {
  businessStage?: InputMaybe<BusinessStageUpdateOneInlineInput>;
  businessStages?: InputMaybe<BusinessStageUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<AssetUpdateOneInlineInput>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermUpdateManyInlineInput>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessStageUpdateManyInlineInput = {
  /** Connect multiple existing BusinessStage documents */
  connect?: InputMaybe<Array<BusinessStageConnectInput>>;
  /** Create and connect multiple BusinessStage documents */
  create?: InputMaybe<Array<BusinessStageCreateInput>>;
  /** Delete multiple BusinessStage documents */
  delete?: InputMaybe<Array<BusinessStageWhereUniqueInput>>;
  /** Disconnect multiple BusinessStage documents */
  disconnect?: InputMaybe<Array<BusinessStageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing BusinessStage documents */
  set?: InputMaybe<Array<BusinessStageWhereUniqueInput>>;
  /** Update multiple BusinessStage documents */
  update?: InputMaybe<Array<BusinessStageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BusinessStage documents */
  upsert?: InputMaybe<Array<BusinessStageUpsertWithNestedWhereUniqueInput>>;
};

export type BusinessStageUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessStageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BusinessStageUpdateManyInput;
  /** Document search */
  where: BusinessStageWhereInput;
};

export type BusinessStageUpdateOneInlineInput = {
  /** Connect existing BusinessStage document */
  connect?: InputMaybe<BusinessStageWhereUniqueInput>;
  /** Create and connect one BusinessStage document */
  create?: InputMaybe<BusinessStageCreateInput>;
  /** Delete currently connected BusinessStage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected BusinessStage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single BusinessStage document */
  update?: InputMaybe<BusinessStageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BusinessStage document */
  upsert?: InputMaybe<BusinessStageUpsertWithNestedWhereUniqueInput>;
};

export type BusinessStageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BusinessStageUpdateInput;
  /** Unique document search */
  where: BusinessStageWhereUniqueInput;
};

export type BusinessStageUpsertInput = {
  /** Create document if it didn't exist */
  create: BusinessStageCreateInput;
  /** Update document if it exists */
  update: BusinessStageUpdateInput;
};

export type BusinessStageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BusinessStageUpsertInput;
  /** Unique document search */
  where: BusinessStageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type BusinessStageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type BusinessStageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BusinessStageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BusinessStageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BusinessStageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  businessStage?: InputMaybe<BusinessStageWhereInput>;
  businessStages_every?: InputMaybe<BusinessStageWhereInput>;
  businessStages_none?: InputMaybe<BusinessStageWhereInput>;
  businessStages_some?: InputMaybe<BusinessStageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<BusinessStageWhereStageInput>;
  documentInStages_none?: InputMaybe<BusinessStageWhereStageInput>;
  documentInStages_some?: InputMaybe<BusinessStageWhereStageInput>;
  icon?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isPrimary_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  weight_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  weight_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  weight_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  weight_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  weight_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  weight_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  weight_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type BusinessStageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BusinessStageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BusinessStageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BusinessStageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<BusinessStageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References BusinessStage record uniquely */
export type BusinessStageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CancelAdvisorSessionInput = {
  advisorSessionId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CancelAdvisorSessionPayload = {
  __typename?: 'CancelAdvisorSessionPayload';
  advisorSession?: Maybe<ScoAdvisorSession>;
};

export type CancelSubscriptionInput = {
  cancellationMessage?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type CancelSubscriptionPayload = {
  __typename?: 'CancelSubscriptionPayload';
  canceledSubscription?: Maybe<ScoSubscription>;
  viewer?: Maybe<Viewer>;
};

export type ChangeEmailNotificationScheduleInput = {
  emailNotificationSchedule: Scalars['String']['input'];
};

export type ChangeEmailNotificationSchedulePayload = {
  __typename?: 'ChangeEmailNotificationSchedulePayload';
  user: ScoUser;
};

export type ChangeSubscriptionProductInput = {
  doProratedUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  pricePointId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type ChangeSubscriptionProductPayload = {
  __typename?: 'ChangeSubscriptionProductPayload';
  subscription?: Maybe<ScoSubscription>;
};

export type ChangeSubscriptionScoProductInput = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  doProratedUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['String']['input'];
  termId?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeSubscriptionScoProductPayload = {
  __typename?: 'ChangeSubscriptionScoProductPayload';
  subscription?: Maybe<ScoSubscription>;
};

export type ChargebeeEstimate = ScoNode & {
  __typename?: 'ChargebeeEstimate';
  dataAsJson?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recurringPriceInCents?: Maybe<Scalars['Int']['output']>;
  signupPriceInCents?: Maybe<Scalars['Int']['output']>;
};

export type Chat = {
  __typename?: 'Chat';
  directThreads?: Maybe<ScoThreadCollection>;
  id: Scalars['ID']['output'];
  inboxThreads?: Maybe<ScoInboxThreadCollection>;
  privateThreads?: Maybe<ScoThreadCollection>;
  publicThreads?: Maybe<ScoThreadCollection>;
  thread?: Maybe<ScoThread>;
  threadAmongstUsers?: Maybe<ScoThread>;
  toolChatThreads?: Maybe<ScoThreadCollection>;
};


export type ChatDirectThreadsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
  includeEmptyThreads?: InputMaybe<Scalars['Boolean']['input']>;
  memberNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ChatInboxThreadsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  includeEmptyThreads?: InputMaybe<Scalars['Boolean']['input']>;
  memberNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  threadTypeKey?: InputMaybe<Scalars['String']['input']>;
  toolSessionAttachmentId?: InputMaybe<Scalars['String']['input']>;
  toolSessionAttachmentType?: InputMaybe<Scalars['String']['input']>;
};


export type ChatPrivateThreadsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ChatPublicThreadsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ChatThreadArgs = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  threadTypeKey?: InputMaybe<Scalars['String']['input']>;
};


export type ChatThreadAmongstUsersArgs = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  memberUserIds: Array<InputMaybe<Scalars['String']['input']>>;
  threadTypeKey?: InputMaybe<Scalars['String']['input']>;
};


export type ChatToolChatThreadsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  toolSessionAttachmentId?: InputMaybe<Scalars['String']['input']>;
  toolSessionAttachmentType?: InputMaybe<Scalars['String']['input']>;
};

export type CheckCrmConversationInput = {
  accountUserId: Scalars['String']['input'];
  keepDraft?: InputMaybe<Scalars['Boolean']['input']>;
  threadId: Scalars['String']['input'];
};

export type CheckCrmConversationPayload = {
  __typename?: 'CheckCrmConversationPayload';
  actionKey?: Maybe<Scalars['String']['output']>;
  checked?: Maybe<Scalars['Boolean']['output']>;
  draftBody?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  ruleName?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
};

export type ClaimClarityAdvisorImportInput = {
  confirm: Scalars['Boolean']['input'];
  handle: Scalars['String']['input'];
};

export type ClaimClarityAdvisorImportPayload = {
  __typename?: 'ClaimClarityAdvisorImportPayload';
  advisorProfile?: Maybe<ScoAdvisorProfile>;
  import: ScoClarityAdvisorImport;
  linkedAccount?: Maybe<ScoLinkedAccount>;
};

export type ClaimCrmThreadInput = {
  accountUserId?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
};

export type ClaimCrmThreadPayload = {
  __typename?: 'ClaimCrmThreadPayload';
  claimExpiresAt?: Maybe<Scalars['String']['output']>;
  ownedByViewer?: Maybe<Scalars['Boolean']['output']>;
  ownerDisplayName?: Maybe<Scalars['String']['output']>;
  ownerUserId?: Maybe<Scalars['String']['output']>;
};

export type ClarityAnswer = {
  __typename?: 'ClarityAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  answerId: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  expert?: Maybe<ClarityExpert>;
  formattedAnswer?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  question?: Maybe<ClarityQuestion>;
  scoUrl?: Maybe<Scalars['String']['output']>;
};

export type ClarityExpert = ScoNode & {
  __typename?: 'ClarityExpert';
  answers: Array<Maybe<ClarityAnswer>>;
  answersCount?: Maybe<Scalars['Int']['output']>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  clarityProfileUrl?: Maybe<Scalars['String']['output']>;
  expertId: Scalars['Int']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  formattedBio?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hourlyRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  scoUrl?: Maybe<Scalars['String']['output']>;
  screenName?: Maybe<Scalars['String']['output']>;
  shortBio?: Maybe<Scalars['String']['output']>;
  topics: Array<Maybe<ClarityTopic>>;
  totalCalls?: Maybe<Scalars['Int']['output']>;
};

export type ClarityQuestion = ScoNode & {
  __typename?: 'ClarityQuestion';
  answers: Array<Maybe<ClarityAnswer>>;
  answersCount?: Maybe<Scalars['Int']['output']>;
  /** Live Clarity url */
  clarityUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
  questionId: Scalars['Int']['output'];
  relatedQuestions: Array<Maybe<ClarityQuestion>>;
  /** Live Startups.com url */
  scoUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  topAnswer?: Maybe<ClarityAnswer>;
  topics: Array<Maybe<ClarityTopic>>;
};

export type ClarityTopic = {
  __typename?: 'ClarityTopic';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  questions: Array<Maybe<ClarityQuestion>>;
  scoUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  topicId: Scalars['Int']['output'];
};

export type CoachProfile = Entity & Node & {
  __typename?: 'CoachProfile';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CoachProfile>;
  /** List of CoachProfile versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  reviews: Array<Review>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  starRating?: Maybe<Scalars['Float']['output']>;
  totalMinutesAdvising?: Maybe<Scalars['Float']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CoachProfileCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CoachProfileDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CoachProfileHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CoachProfilePersonArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CoachProfilePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CoachProfileReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ReviewOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReviewWhereInput>;
};


export type CoachProfileScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CoachProfileUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CoachProfileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CoachProfileWhereUniqueInput;
};

/** A connection to a list of items. */
export type CoachProfileConnection = {
  __typename?: 'CoachProfileConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CoachProfileEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CoachProfileCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  person?: InputMaybe<PersonCreateOneInlineInput>;
  reviews?: InputMaybe<ReviewCreateManyInlineInput>;
  slug: Scalars['String']['input'];
  starRating?: InputMaybe<Scalars['Float']['input']>;
  totalMinutesAdvising?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CoachProfileCreateManyInlineInput = {
  /** Connect multiple existing CoachProfile documents */
  connect?: InputMaybe<Array<CoachProfileWhereUniqueInput>>;
  /** Create and connect multiple existing CoachProfile documents */
  create?: InputMaybe<Array<CoachProfileCreateInput>>;
};

export type CoachProfileCreateOneInlineInput = {
  /** Connect one existing CoachProfile document */
  connect?: InputMaybe<CoachProfileWhereUniqueInput>;
  /** Create and connect one CoachProfile document */
  create?: InputMaybe<CoachProfileCreateInput>;
};

/** An edge in a connection. */
export type CoachProfileEdge = {
  __typename?: 'CoachProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CoachProfile;
};

/** Identifies documents */
export type CoachProfileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CoachProfileWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CoachProfileWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CoachProfileWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CoachProfileWhereStageInput>;
  documentInStages_none?: InputMaybe<CoachProfileWhereStageInput>;
  documentInStages_some?: InputMaybe<CoachProfileWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  person?: InputMaybe<PersonWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  reviews_every?: InputMaybe<ReviewWhereInput>;
  reviews_none?: InputMaybe<ReviewWhereInput>;
  reviews_some?: InputMaybe<ReviewWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  starRating?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  starRating_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  starRating_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  starRating_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  starRating_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  starRating_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  starRating_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  starRating_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalMinutesAdvising?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  totalMinutesAdvising_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  totalMinutesAdvising_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  totalMinutesAdvising_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  totalMinutesAdvising_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  totalMinutesAdvising_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  totalMinutesAdvising_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  totalMinutesAdvising_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CoachProfileOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StarRatingAsc = 'starRating_ASC',
  StarRatingDesc = 'starRating_DESC',
  TotalMinutesAdvisingAsc = 'totalMinutesAdvising_ASC',
  TotalMinutesAdvisingDesc = 'totalMinutesAdvising_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CoachProfileUpdateInput = {
  person?: InputMaybe<PersonUpdateOneInlineInput>;
  reviews?: InputMaybe<ReviewUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  starRating?: InputMaybe<Scalars['Float']['input']>;
  totalMinutesAdvising?: InputMaybe<Scalars['Float']['input']>;
};

export type CoachProfileUpdateManyInlineInput = {
  /** Connect multiple existing CoachProfile documents */
  connect?: InputMaybe<Array<CoachProfileConnectInput>>;
  /** Create and connect multiple CoachProfile documents */
  create?: InputMaybe<Array<CoachProfileCreateInput>>;
  /** Delete multiple CoachProfile documents */
  delete?: InputMaybe<Array<CoachProfileWhereUniqueInput>>;
  /** Disconnect multiple CoachProfile documents */
  disconnect?: InputMaybe<Array<CoachProfileWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CoachProfile documents */
  set?: InputMaybe<Array<CoachProfileWhereUniqueInput>>;
  /** Update multiple CoachProfile documents */
  update?: InputMaybe<Array<CoachProfileUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CoachProfile documents */
  upsert?: InputMaybe<Array<CoachProfileUpsertWithNestedWhereUniqueInput>>;
};

export type CoachProfileUpdateManyInput = {
  starRating?: InputMaybe<Scalars['Float']['input']>;
  totalMinutesAdvising?: InputMaybe<Scalars['Float']['input']>;
};

export type CoachProfileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CoachProfileUpdateManyInput;
  /** Document search */
  where: CoachProfileWhereInput;
};

export type CoachProfileUpdateOneInlineInput = {
  /** Connect existing CoachProfile document */
  connect?: InputMaybe<CoachProfileWhereUniqueInput>;
  /** Create and connect one CoachProfile document */
  create?: InputMaybe<CoachProfileCreateInput>;
  /** Delete currently connected CoachProfile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CoachProfile document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CoachProfile document */
  update?: InputMaybe<CoachProfileUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CoachProfile document */
  upsert?: InputMaybe<CoachProfileUpsertWithNestedWhereUniqueInput>;
};

export type CoachProfileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CoachProfileUpdateInput;
  /** Unique document search */
  where: CoachProfileWhereUniqueInput;
};

export type CoachProfileUpsertInput = {
  /** Create document if it didn't exist */
  create: CoachProfileCreateInput;
  /** Update document if it exists */
  update: CoachProfileUpdateInput;
};

export type CoachProfileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CoachProfileUpsertInput;
  /** Unique document search */
  where: CoachProfileWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CoachProfileWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CoachProfileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CoachProfileWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CoachProfileWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CoachProfileWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CoachProfileWhereStageInput>;
  documentInStages_none?: InputMaybe<CoachProfileWhereStageInput>;
  documentInStages_some?: InputMaybe<CoachProfileWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  person?: InputMaybe<PersonWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  reviews_every?: InputMaybe<ReviewWhereInput>;
  reviews_none?: InputMaybe<ReviewWhereInput>;
  reviews_some?: InputMaybe<ReviewWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  starRating?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  starRating_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  starRating_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  starRating_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  starRating_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  starRating_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  starRating_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  starRating_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalMinutesAdvising?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  totalMinutesAdvising_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  totalMinutesAdvising_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  totalMinutesAdvising_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  totalMinutesAdvising_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  totalMinutesAdvising_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  totalMinutesAdvising_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  totalMinutesAdvising_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CoachProfileWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CoachProfileWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CoachProfileWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CoachProfileWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CoachProfileWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CoachProfile record uniquely */
export type CoachProfileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CoachingEnrollment = ScoNode & {
  __typename?: 'CoachingEnrollment';
  biggestChallenge?: Maybe<Scalars['String']['output']>;
  coachingEnrollmentId?: Maybe<Scalars['String']['output']>;
  commitment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<ScoCompany>;
  concierge?: Maybe<ScoUser>;
  createdAt?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  pursuit?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<Maybe<ScoSubscription>>>;
  user?: Maybe<ScoUser>;
};

export type CoachingEnrollmentCollection = {
  __typename?: 'CoachingEnrollmentCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<CoachingEnrollment>>;
  pagination: Pagination;
};

/** Representing a color value comprising of HEX, RGBA and css color values */
export type Color = {
  __typename?: 'Color';
  css: Scalars['String']['output'];
  hex: Scalars['Hex']['output'];
  rgba: Rgba;
};

/** Accepts either HEX or RGBA color value. At least one of hex or rgba value should be passed. If both are passed RGBA is used. */
export type ColorInput = {
  hex?: InputMaybe<Scalars['Hex']['input']>;
  rgba?: InputMaybe<RgbaInput>;
};

export type CompleteAdvisorSessionInput = {
  advisorSessionId?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type CompleteAdvisorSessionPayload = {
  __typename?: 'CompleteAdvisorSessionPayload';
  advisorSession?: Maybe<ScoAdvisorSession>;
};

export type ConfirmAdvisorSessionPrechargeInput = {
  advisorSessionId?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmAdvisorSessionPrechargePayload = {
  __typename?: 'ConfirmAdvisorSessionPrechargePayload';
  advisorSession?: Maybe<ScoAdvisorSession>;
  precharge?: Maybe<ScoAdvisorSessionCharge>;
};

export type ConfirmAdvisorSessionScheduleInput = {
  advisorSessionId?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConfirmAdvisorSessionSchedulePayload = {
  __typename?: 'ConfirmAdvisorSessionSchedulePayload';
  advisorSession?: Maybe<ScoAdvisorSession>;
};

export type ConfirmScoCustomerSearchSegmentsInput = {
  customerSearchId: Scalars['String']['input'];
  keepProfileIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConfirmScoCustomerSearchSegmentsPayload = {
  __typename?: 'ConfirmScoCustomerSearchSegmentsPayload';
  customerSearch?: Maybe<ScoCustomerSearch>;
};

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document before specified document */
  before?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document at last position */
  end?: InputMaybe<Scalars['Boolean']['input']>;
  /** Connect document at first position */
  start?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentTrack = Entity & Node & {
  __typename?: 'ContentTrack';
  backgroundImage?: Maybe<Asset>;
  color?: Maybe<Color>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ContentTrack>;
  featuredImage?: Maybe<Asset>;
  /** List of ContentTrack versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  longDescription?: Maybe<Scalars['String']['output']>;
  /** Specify how the user is expected to complete this track. */
  progressionType?: Maybe<ContentTrackProgression>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  richLongDescription?: Maybe<RichText>;
  scheduledIn: Array<ScheduledOperation>;
  /**
   * Do NOT "Add Existing" unless you are re-linking an orphaned item; otherwise it
   * will remove the item from its current use elsewhere.
   */
  sections: Array<ContentTrackSection>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  terms: Array<Term>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ContentTrackType>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ContentTrackBackgroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type ContentTrackCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ContentTrackFeaturedImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type ContentTrackHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ContentTrackPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ContentTrackSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContentTrackSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackSectionWhereInput>;
};


export type ContentTrackTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


export type ContentTrackUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContentTrackCallToAction = Entity & {
  __typename?: 'ContentTrackCallToAction';
  callToActionUrl?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentTrackCallToActionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentTrackCallToActionWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentTrackCallToActionConnection = {
  __typename?: 'ContentTrackCallToActionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentTrackCallToActionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentTrackCallToActionCreateInput = {
  callToActionUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentTrackCallToActionCreateManyInlineInput = {
  /** Create and connect multiple existing ContentTrackCallToAction documents */
  create?: InputMaybe<Array<ContentTrackCallToActionCreateInput>>;
};

export type ContentTrackCallToActionCreateOneInlineInput = {
  /** Create and connect one ContentTrackCallToAction document */
  create?: InputMaybe<ContentTrackCallToActionCreateInput>;
};

export type ContentTrackCallToActionCreateWithPositionInput = {
  /** Document to create */
  data: ContentTrackCallToActionCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ContentTrackCallToActionEdge = {
  __typename?: 'ContentTrackCallToActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContentTrackCallToAction;
};

/** Identifies documents */
export type ContentTrackCallToActionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackCallToActionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackCallToActionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackCallToActionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  callToActionUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  callToActionUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  callToActionUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  callToActionUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  callToActionUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  callToActionUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  callToActionUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  callToActionUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  callToActionUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  callToActionUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ContentTrackCallToActionOrderByInput {
  CallToActionUrlAsc = 'callToActionUrl_ASC',
  CallToActionUrlDesc = 'callToActionUrl_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ContentTrackCallToActionParent = ContentTrackTask;

export type ContentTrackCallToActionParentConnectInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskConnectInput>;
};

export type ContentTrackCallToActionParentCreateInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskCreateInput>;
};

export type ContentTrackCallToActionParentCreateManyInlineInput = {
  /** Connect multiple existing ContentTrackCallToActionParent documents */
  connect?: InputMaybe<Array<ContentTrackCallToActionParentWhereUniqueInput>>;
  /** Create and connect multiple existing ContentTrackCallToActionParent documents */
  create?: InputMaybe<Array<ContentTrackCallToActionParentCreateInput>>;
};

export type ContentTrackCallToActionParentCreateOneInlineInput = {
  /** Connect one existing ContentTrackCallToActionParent document */
  connect?: InputMaybe<ContentTrackCallToActionParentWhereUniqueInput>;
  /** Create and connect one ContentTrackCallToActionParent document */
  create?: InputMaybe<ContentTrackCallToActionParentCreateInput>;
};

export type ContentTrackCallToActionParentUpdateInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskUpdateInput>;
};

export type ContentTrackCallToActionParentUpdateManyInlineInput = {
  /** Connect multiple existing ContentTrackCallToActionParent documents */
  connect?: InputMaybe<Array<ContentTrackCallToActionParentConnectInput>>;
  /** Create and connect multiple ContentTrackCallToActionParent documents */
  create?: InputMaybe<Array<ContentTrackCallToActionParentCreateInput>>;
  /** Delete multiple ContentTrackCallToActionParent documents */
  delete?: InputMaybe<Array<ContentTrackCallToActionParentWhereUniqueInput>>;
  /** Disconnect multiple ContentTrackCallToActionParent documents */
  disconnect?: InputMaybe<Array<ContentTrackCallToActionParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContentTrackCallToActionParent documents */
  set?: InputMaybe<Array<ContentTrackCallToActionParentWhereUniqueInput>>;
  /** Update multiple ContentTrackCallToActionParent documents */
  update?: InputMaybe<Array<ContentTrackCallToActionParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContentTrackCallToActionParent documents */
  upsert?: InputMaybe<Array<ContentTrackCallToActionParentUpsertWithNestedWhereUniqueInput>>;
};

export type ContentTrackCallToActionParentUpdateManyWithNestedWhereInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskUpdateManyWithNestedWhereInput>;
};

export type ContentTrackCallToActionParentUpdateOneInlineInput = {
  /** Connect existing ContentTrackCallToActionParent document */
  connect?: InputMaybe<ContentTrackCallToActionParentWhereUniqueInput>;
  /** Create and connect one ContentTrackCallToActionParent document */
  create?: InputMaybe<ContentTrackCallToActionParentCreateInput>;
  /** Delete currently connected ContentTrackCallToActionParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContentTrackCallToActionParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrackCallToActionParent document */
  update?: InputMaybe<ContentTrackCallToActionParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrackCallToActionParent document */
  upsert?: InputMaybe<ContentTrackCallToActionParentUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackCallToActionParentUpdateWithNestedWhereUniqueInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskUpdateWithNestedWhereUniqueInput>;
};

export type ContentTrackCallToActionParentUpsertWithNestedWhereUniqueInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackCallToActionParentWhereInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskWhereInput>;
};

export type ContentTrackCallToActionParentWhereUniqueInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskWhereUniqueInput>;
};

export type ContentTrackCallToActionUpdateInput = {
  callToActionUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTrackCallToActionUpdateManyInlineInput = {
  /** Create and connect multiple ContentTrackCallToAction component instances */
  create?: InputMaybe<Array<ContentTrackCallToActionCreateWithPositionInput>>;
  /** Delete multiple ContentTrackCallToAction documents */
  delete?: InputMaybe<Array<ContentTrackCallToActionWhereUniqueInput>>;
  /** Update multiple ContentTrackCallToAction component instances */
  update?: InputMaybe<Array<ContentTrackCallToActionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ContentTrackCallToAction component instances */
  upsert?: InputMaybe<Array<ContentTrackCallToActionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ContentTrackCallToActionUpdateManyInput = {
  callToActionUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTrackCallToActionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentTrackCallToActionUpdateManyInput;
  /** Document search */
  where: ContentTrackCallToActionWhereInput;
};

export type ContentTrackCallToActionUpdateOneInlineInput = {
  /** Create and connect one ContentTrackCallToAction document */
  create?: InputMaybe<ContentTrackCallToActionCreateInput>;
  /** Delete currently connected ContentTrackCallToAction document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrackCallToAction document */
  update?: InputMaybe<ContentTrackCallToActionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrackCallToAction document */
  upsert?: InputMaybe<ContentTrackCallToActionUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackCallToActionUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ContentTrackCallToActionUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentTrackCallToActionWhereUniqueInput;
};

export type ContentTrackCallToActionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentTrackCallToActionUpdateInput;
  /** Unique document search */
  where: ContentTrackCallToActionWhereUniqueInput;
};

export type ContentTrackCallToActionUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentTrackCallToActionCreateInput;
  /** Update document if it exists */
  update: ContentTrackCallToActionUpdateInput;
};

export type ContentTrackCallToActionUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ContentTrackCallToActionUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentTrackCallToActionWhereUniqueInput;
};

export type ContentTrackCallToActionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentTrackCallToActionUpsertInput;
  /** Unique document search */
  where: ContentTrackCallToActionWhereUniqueInput;
};

/** Identifies documents */
export type ContentTrackCallToActionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackCallToActionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackCallToActionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackCallToActionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  callToActionUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  callToActionUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  callToActionUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  callToActionUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  callToActionUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  callToActionUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  callToActionUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  callToActionUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  callToActionUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  callToActionUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References ContentTrackCallToAction record uniquely */
export type ContentTrackCallToActionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentTrackConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentTrackWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentTrackConnection = {
  __typename?: 'ContentTrackConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentTrackEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentTrackCreateInput = {
  backgroundImage?: InputMaybe<AssetCreateOneInlineInput>;
  color?: InputMaybe<ColorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  featuredImage?: InputMaybe<AssetCreateOneInlineInput>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  richLongDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
  sections?: InputMaybe<ContentTrackSectionCreateManyInlineInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  terms?: InputMaybe<TermCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContentTrackType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentTrackCreateManyInlineInput = {
  /** Connect multiple existing ContentTrack documents */
  connect?: InputMaybe<Array<ContentTrackWhereUniqueInput>>;
  /** Create and connect multiple existing ContentTrack documents */
  create?: InputMaybe<Array<ContentTrackCreateInput>>;
};

export type ContentTrackCreateOneInlineInput = {
  /** Connect one existing ContentTrack document */
  connect?: InputMaybe<ContentTrackWhereUniqueInput>;
  /** Create and connect one ContentTrack document */
  create?: InputMaybe<ContentTrackCreateInput>;
};

/** An edge in a connection. */
export type ContentTrackEdge = {
  __typename?: 'ContentTrackEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContentTrack;
};

/** Identifies documents */
export type ContentTrackManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ContentTrackWhereStageInput>;
  documentInStages_none?: InputMaybe<ContentTrackWhereStageInput>;
  documentInStages_some?: InputMaybe<ContentTrackWhereStageInput>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  longDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  longDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  longDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  longDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  longDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  longDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  longDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  longDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  longDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  /** All values that are contained in given list. */
  progressionType_in?: InputMaybe<Array<InputMaybe<ContentTrackProgression>>>;
  /** Any other value that exists and is not equal to the given value. */
  progressionType_not?: InputMaybe<ContentTrackProgression>;
  /** All values that are not contained in given list. */
  progressionType_not_in?: InputMaybe<Array<InputMaybe<ContentTrackProgression>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<ContentTrackSectionWhereInput>;
  sections_none?: InputMaybe<ContentTrackSectionWhereInput>;
  sections_some?: InputMaybe<ContentTrackSectionWhereInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContentTrackType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<ContentTrackType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<ContentTrackType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<ContentTrackType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ContentTrackOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LongDescriptionAsc = 'longDescription_ASC',
  LongDescriptionDesc = 'longDescription_DESC',
  ProgressionTypeAsc = 'progressionType_ASC',
  ProgressionTypeDesc = 'progressionType_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export enum ContentTrackProgression {
  Fluid = 'FLUID',
  SequentialRecommended = 'SEQUENTIAL_RECOMMENDED',
  SequentialRequired = 'SEQUENTIAL_REQUIRED'
}

export type ContentTrackPrompt = Entity & {
  __typename?: 'ContentTrackPrompt';
  body?: Maybe<Scalars['String']['output']>;
  exampleResponse?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Optional label to show on the UX response input. */
  inputLabel?: Maybe<Scalars['String']['output']>;
  responseIsRequired?: Maybe<Scalars['Boolean']['output']>;
  responseType: ContentTrackPromptResponseType;
  /** The instructive text or question of the prompt. */
  richBody?: Maybe<RichText>;
  richExampleResponse?: Maybe<RichText>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentTrackPromptConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentTrackPromptWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentTrackPromptConnection = {
  __typename?: 'ContentTrackPromptConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentTrackPromptEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentTrackPromptCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  exampleResponse?: InputMaybe<Scalars['String']['input']>;
  inputLabel?: InputMaybe<Scalars['String']['input']>;
  responseIsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  responseType: ContentTrackPromptResponseType;
  richBody?: InputMaybe<Scalars['RichTextAST']['input']>;
  richExampleResponse?: InputMaybe<Scalars['RichTextAST']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentTrackPromptCreateManyInlineInput = {
  /** Create and connect multiple existing ContentTrackPrompt documents */
  create?: InputMaybe<Array<ContentTrackPromptCreateInput>>;
};

export type ContentTrackPromptCreateOneInlineInput = {
  /** Create and connect one ContentTrackPrompt document */
  create?: InputMaybe<ContentTrackPromptCreateInput>;
};

export type ContentTrackPromptCreateWithPositionInput = {
  /** Document to create */
  data: ContentTrackPromptCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ContentTrackPromptEdge = {
  __typename?: 'ContentTrackPromptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContentTrackPrompt;
};

/** Identifies documents */
export type ContentTrackPromptManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackPromptWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackPromptWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackPromptWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  exampleResponse?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  exampleResponse_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  exampleResponse_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  exampleResponse_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  exampleResponse_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  exampleResponse_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  exampleResponse_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  exampleResponse_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  exampleResponse_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  exampleResponse_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inputLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  inputLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  inputLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  inputLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  inputLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  inputLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  inputLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  inputLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  inputLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  inputLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  responseIsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  responseIsRequired_not?: InputMaybe<Scalars['Boolean']['input']>;
  responseType?: InputMaybe<ContentTrackPromptResponseType>;
  /** All values that are contained in given list. */
  responseType_in?: InputMaybe<Array<InputMaybe<ContentTrackPromptResponseType>>>;
  /** Any other value that exists and is not equal to the given value. */
  responseType_not?: InputMaybe<ContentTrackPromptResponseType>;
  /** All values that are not contained in given list. */
  responseType_not_in?: InputMaybe<Array<InputMaybe<ContentTrackPromptResponseType>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ContentTrackPromptOrderByInput {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  ExampleResponseAsc = 'exampleResponse_ASC',
  ExampleResponseDesc = 'exampleResponse_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InputLabelAsc = 'inputLabel_ASC',
  InputLabelDesc = 'inputLabel_DESC',
  ResponseIsRequiredAsc = 'responseIsRequired_ASC',
  ResponseIsRequiredDesc = 'responseIsRequired_DESC',
  ResponseTypeAsc = 'responseType_ASC',
  ResponseTypeDesc = 'responseType_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ContentTrackPromptParent = ContentTrackTask;

export type ContentTrackPromptParentConnectInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskConnectInput>;
};

export type ContentTrackPromptParentCreateInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskCreateInput>;
};

export type ContentTrackPromptParentCreateManyInlineInput = {
  /** Connect multiple existing ContentTrackPromptParent documents */
  connect?: InputMaybe<Array<ContentTrackPromptParentWhereUniqueInput>>;
  /** Create and connect multiple existing ContentTrackPromptParent documents */
  create?: InputMaybe<Array<ContentTrackPromptParentCreateInput>>;
};

export type ContentTrackPromptParentCreateOneInlineInput = {
  /** Connect one existing ContentTrackPromptParent document */
  connect?: InputMaybe<ContentTrackPromptParentWhereUniqueInput>;
  /** Create and connect one ContentTrackPromptParent document */
  create?: InputMaybe<ContentTrackPromptParentCreateInput>;
};

export type ContentTrackPromptParentUpdateInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskUpdateInput>;
};

export type ContentTrackPromptParentUpdateManyInlineInput = {
  /** Connect multiple existing ContentTrackPromptParent documents */
  connect?: InputMaybe<Array<ContentTrackPromptParentConnectInput>>;
  /** Create and connect multiple ContentTrackPromptParent documents */
  create?: InputMaybe<Array<ContentTrackPromptParentCreateInput>>;
  /** Delete multiple ContentTrackPromptParent documents */
  delete?: InputMaybe<Array<ContentTrackPromptParentWhereUniqueInput>>;
  /** Disconnect multiple ContentTrackPromptParent documents */
  disconnect?: InputMaybe<Array<ContentTrackPromptParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContentTrackPromptParent documents */
  set?: InputMaybe<Array<ContentTrackPromptParentWhereUniqueInput>>;
  /** Update multiple ContentTrackPromptParent documents */
  update?: InputMaybe<Array<ContentTrackPromptParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContentTrackPromptParent documents */
  upsert?: InputMaybe<Array<ContentTrackPromptParentUpsertWithNestedWhereUniqueInput>>;
};

export type ContentTrackPromptParentUpdateManyWithNestedWhereInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskUpdateManyWithNestedWhereInput>;
};

export type ContentTrackPromptParentUpdateOneInlineInput = {
  /** Connect existing ContentTrackPromptParent document */
  connect?: InputMaybe<ContentTrackPromptParentWhereUniqueInput>;
  /** Create and connect one ContentTrackPromptParent document */
  create?: InputMaybe<ContentTrackPromptParentCreateInput>;
  /** Delete currently connected ContentTrackPromptParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContentTrackPromptParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrackPromptParent document */
  update?: InputMaybe<ContentTrackPromptParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrackPromptParent document */
  upsert?: InputMaybe<ContentTrackPromptParentUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackPromptParentUpdateWithNestedWhereUniqueInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskUpdateWithNestedWhereUniqueInput>;
};

export type ContentTrackPromptParentUpsertWithNestedWhereUniqueInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackPromptParentWhereInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskWhereInput>;
};

export type ContentTrackPromptParentWhereUniqueInput = {
  ContentTrackTask?: InputMaybe<ContentTrackTaskWhereUniqueInput>;
};

/** The type of response expected from the user; i.e. how are they supposed to answer the prompt in the UX. */
export enum ContentTrackPromptResponseType {
  Checkbox = 'Checkbox',
  MultiFileUpload = 'MultiFileUpload',
  MultiLineTextInput = 'MultiLineTextInput',
  SingleFileUpload = 'SingleFileUpload',
  SingleLineTextInput = 'SingleLineTextInput'
}

export type ContentTrackPromptUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  exampleResponse?: InputMaybe<Scalars['String']['input']>;
  inputLabel?: InputMaybe<Scalars['String']['input']>;
  responseIsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  responseType?: InputMaybe<ContentTrackPromptResponseType>;
  richBody?: InputMaybe<Scalars['RichTextAST']['input']>;
  richExampleResponse?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTrackPromptUpdateManyInlineInput = {
  /** Create and connect multiple ContentTrackPrompt component instances */
  create?: InputMaybe<Array<ContentTrackPromptCreateWithPositionInput>>;
  /** Delete multiple ContentTrackPrompt documents */
  delete?: InputMaybe<Array<ContentTrackPromptWhereUniqueInput>>;
  /** Update multiple ContentTrackPrompt component instances */
  update?: InputMaybe<Array<ContentTrackPromptUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ContentTrackPrompt component instances */
  upsert?: InputMaybe<Array<ContentTrackPromptUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ContentTrackPromptUpdateManyInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  exampleResponse?: InputMaybe<Scalars['String']['input']>;
  inputLabel?: InputMaybe<Scalars['String']['input']>;
  responseIsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  responseType?: InputMaybe<ContentTrackPromptResponseType>;
  richBody?: InputMaybe<Scalars['RichTextAST']['input']>;
  richExampleResponse?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTrackPromptUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentTrackPromptUpdateManyInput;
  /** Document search */
  where: ContentTrackPromptWhereInput;
};

export type ContentTrackPromptUpdateOneInlineInput = {
  /** Create and connect one ContentTrackPrompt document */
  create?: InputMaybe<ContentTrackPromptCreateInput>;
  /** Delete currently connected ContentTrackPrompt document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrackPrompt document */
  update?: InputMaybe<ContentTrackPromptUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrackPrompt document */
  upsert?: InputMaybe<ContentTrackPromptUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackPromptUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ContentTrackPromptUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentTrackPromptWhereUniqueInput;
};

export type ContentTrackPromptUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentTrackPromptUpdateInput;
  /** Unique document search */
  where: ContentTrackPromptWhereUniqueInput;
};

export type ContentTrackPromptUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentTrackPromptCreateInput;
  /** Update document if it exists */
  update: ContentTrackPromptUpdateInput;
};

export type ContentTrackPromptUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ContentTrackPromptUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentTrackPromptWhereUniqueInput;
};

export type ContentTrackPromptUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentTrackPromptUpsertInput;
  /** Unique document search */
  where: ContentTrackPromptWhereUniqueInput;
};

/** Identifies documents */
export type ContentTrackPromptWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackPromptWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackPromptWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackPromptWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  exampleResponse?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  exampleResponse_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  exampleResponse_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  exampleResponse_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  exampleResponse_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  exampleResponse_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  exampleResponse_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  exampleResponse_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  exampleResponse_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  exampleResponse_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inputLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  inputLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  inputLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  inputLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  inputLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  inputLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  inputLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  inputLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  inputLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  inputLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  responseIsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  responseIsRequired_not?: InputMaybe<Scalars['Boolean']['input']>;
  responseType?: InputMaybe<ContentTrackPromptResponseType>;
  /** All values that are contained in given list. */
  responseType_in?: InputMaybe<Array<InputMaybe<ContentTrackPromptResponseType>>>;
  /** Any other value that exists and is not equal to the given value. */
  responseType_not?: InputMaybe<ContentTrackPromptResponseType>;
  /** All values that are not contained in given list. */
  responseType_not_in?: InputMaybe<Array<InputMaybe<ContentTrackPromptResponseType>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References ContentTrackPrompt record uniquely */
export type ContentTrackPromptWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** A set of defined components which can be rendered at runtime from the app. This maps to actual code in our app. */
export type ContentTrackReactComponent = Entity & {
  __typename?: 'ContentTrackReactComponent';
  componentKey?: Maybe<AppReactComponent>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  propsAsJson?: Maybe<Scalars['Json']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentTrackReactComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentTrackReactComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentTrackReactComponentConnection = {
  __typename?: 'ContentTrackReactComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentTrackReactComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentTrackReactComponentCreateInput = {
  componentKey?: InputMaybe<AppReactComponent>;
  label?: InputMaybe<Scalars['String']['input']>;
  propsAsJson?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentTrackReactComponentCreateManyInlineInput = {
  /** Create and connect multiple existing ContentTrackReactComponent documents */
  create?: InputMaybe<Array<ContentTrackReactComponentCreateInput>>;
};

export type ContentTrackReactComponentCreateOneInlineInput = {
  /** Create and connect one ContentTrackReactComponent document */
  create?: InputMaybe<ContentTrackReactComponentCreateInput>;
};

export type ContentTrackReactComponentCreateWithPositionInput = {
  /** Document to create */
  data: ContentTrackReactComponentCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ContentTrackReactComponentEdge = {
  __typename?: 'ContentTrackReactComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContentTrackReactComponent;
};

/** Identifies documents */
export type ContentTrackReactComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackReactComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackReactComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackReactComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  componentKey?: InputMaybe<AppReactComponent>;
  /** All values that are contained in given list. */
  componentKey_in?: InputMaybe<Array<InputMaybe<AppReactComponent>>>;
  /** Any other value that exists and is not equal to the given value. */
  componentKey_not?: InputMaybe<AppReactComponent>;
  /** All values that are not contained in given list. */
  componentKey_not_in?: InputMaybe<Array<InputMaybe<AppReactComponent>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given json path. */
  propsAsJson_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  propsAsJson_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ContentTrackReactComponentOrderByInput {
  ComponentKeyAsc = 'componentKey_ASC',
  ComponentKeyDesc = 'componentKey_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ContentTrackReactComponentParent = ContentTrackStep | ContentTrackTask;

export type ContentTrackReactComponentParentConnectInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepConnectInput>;
  ContentTrackTask?: InputMaybe<ContentTrackTaskConnectInput>;
};

export type ContentTrackReactComponentParentCreateInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepCreateInput>;
  ContentTrackTask?: InputMaybe<ContentTrackTaskCreateInput>;
};

export type ContentTrackReactComponentParentCreateManyInlineInput = {
  /** Connect multiple existing ContentTrackReactComponentParent documents */
  connect?: InputMaybe<Array<ContentTrackReactComponentParentWhereUniqueInput>>;
  /** Create and connect multiple existing ContentTrackReactComponentParent documents */
  create?: InputMaybe<Array<ContentTrackReactComponentParentCreateInput>>;
};

export type ContentTrackReactComponentParentCreateOneInlineInput = {
  /** Connect one existing ContentTrackReactComponentParent document */
  connect?: InputMaybe<ContentTrackReactComponentParentWhereUniqueInput>;
  /** Create and connect one ContentTrackReactComponentParent document */
  create?: InputMaybe<ContentTrackReactComponentParentCreateInput>;
};

export type ContentTrackReactComponentParentUpdateInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepUpdateInput>;
  ContentTrackTask?: InputMaybe<ContentTrackTaskUpdateInput>;
};

export type ContentTrackReactComponentParentUpdateManyInlineInput = {
  /** Connect multiple existing ContentTrackReactComponentParent documents */
  connect?: InputMaybe<Array<ContentTrackReactComponentParentConnectInput>>;
  /** Create and connect multiple ContentTrackReactComponentParent documents */
  create?: InputMaybe<Array<ContentTrackReactComponentParentCreateInput>>;
  /** Delete multiple ContentTrackReactComponentParent documents */
  delete?: InputMaybe<Array<ContentTrackReactComponentParentWhereUniqueInput>>;
  /** Disconnect multiple ContentTrackReactComponentParent documents */
  disconnect?: InputMaybe<Array<ContentTrackReactComponentParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContentTrackReactComponentParent documents */
  set?: InputMaybe<Array<ContentTrackReactComponentParentWhereUniqueInput>>;
  /** Update multiple ContentTrackReactComponentParent documents */
  update?: InputMaybe<Array<ContentTrackReactComponentParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContentTrackReactComponentParent documents */
  upsert?: InputMaybe<Array<ContentTrackReactComponentParentUpsertWithNestedWhereUniqueInput>>;
};

export type ContentTrackReactComponentParentUpdateManyWithNestedWhereInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepUpdateManyWithNestedWhereInput>;
  ContentTrackTask?: InputMaybe<ContentTrackTaskUpdateManyWithNestedWhereInput>;
};

export type ContentTrackReactComponentParentUpdateOneInlineInput = {
  /** Connect existing ContentTrackReactComponentParent document */
  connect?: InputMaybe<ContentTrackReactComponentParentWhereUniqueInput>;
  /** Create and connect one ContentTrackReactComponentParent document */
  create?: InputMaybe<ContentTrackReactComponentParentCreateInput>;
  /** Delete currently connected ContentTrackReactComponentParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContentTrackReactComponentParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrackReactComponentParent document */
  update?: InputMaybe<ContentTrackReactComponentParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrackReactComponentParent document */
  upsert?: InputMaybe<ContentTrackReactComponentParentUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackReactComponentParentUpdateWithNestedWhereUniqueInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepUpdateWithNestedWhereUniqueInput>;
  ContentTrackTask?: InputMaybe<ContentTrackTaskUpdateWithNestedWhereUniqueInput>;
};

export type ContentTrackReactComponentParentUpsertWithNestedWhereUniqueInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepUpsertWithNestedWhereUniqueInput>;
  ContentTrackTask?: InputMaybe<ContentTrackTaskUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackReactComponentParentWhereInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepWhereInput>;
  ContentTrackTask?: InputMaybe<ContentTrackTaskWhereInput>;
};

export type ContentTrackReactComponentParentWhereUniqueInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepWhereUniqueInput>;
  ContentTrackTask?: InputMaybe<ContentTrackTaskWhereUniqueInput>;
};

export type ContentTrackReactComponentUpdateInput = {
  componentKey?: InputMaybe<AppReactComponent>;
  label?: InputMaybe<Scalars['String']['input']>;
  propsAsJson?: InputMaybe<Scalars['Json']['input']>;
};

export type ContentTrackReactComponentUpdateManyInlineInput = {
  /** Create and connect multiple ContentTrackReactComponent component instances */
  create?: InputMaybe<Array<ContentTrackReactComponentCreateWithPositionInput>>;
  /** Delete multiple ContentTrackReactComponent documents */
  delete?: InputMaybe<Array<ContentTrackReactComponentWhereUniqueInput>>;
  /** Update multiple ContentTrackReactComponent component instances */
  update?: InputMaybe<Array<ContentTrackReactComponentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ContentTrackReactComponent component instances */
  upsert?: InputMaybe<Array<ContentTrackReactComponentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ContentTrackReactComponentUpdateManyInput = {
  componentKey?: InputMaybe<AppReactComponent>;
  label?: InputMaybe<Scalars['String']['input']>;
  propsAsJson?: InputMaybe<Scalars['Json']['input']>;
};

export type ContentTrackReactComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentTrackReactComponentUpdateManyInput;
  /** Document search */
  where: ContentTrackReactComponentWhereInput;
};

export type ContentTrackReactComponentUpdateOneInlineInput = {
  /** Create and connect one ContentTrackReactComponent document */
  create?: InputMaybe<ContentTrackReactComponentCreateInput>;
  /** Delete currently connected ContentTrackReactComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrackReactComponent document */
  update?: InputMaybe<ContentTrackReactComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrackReactComponent document */
  upsert?: InputMaybe<ContentTrackReactComponentUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackReactComponentUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ContentTrackReactComponentUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentTrackReactComponentWhereUniqueInput;
};

export type ContentTrackReactComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentTrackReactComponentUpdateInput;
  /** Unique document search */
  where: ContentTrackReactComponentWhereUniqueInput;
};

export type ContentTrackReactComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentTrackReactComponentCreateInput;
  /** Update document if it exists */
  update: ContentTrackReactComponentUpdateInput;
};

export type ContentTrackReactComponentUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ContentTrackReactComponentUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentTrackReactComponentWhereUniqueInput;
};

export type ContentTrackReactComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentTrackReactComponentUpsertInput;
  /** Unique document search */
  where: ContentTrackReactComponentWhereUniqueInput;
};

/** Identifies documents */
export type ContentTrackReactComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackReactComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackReactComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackReactComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  componentKey?: InputMaybe<AppReactComponent>;
  /** All values that are contained in given list. */
  componentKey_in?: InputMaybe<Array<InputMaybe<AppReactComponent>>>;
  /** Any other value that exists and is not equal to the given value. */
  componentKey_not?: InputMaybe<AppReactComponent>;
  /** All values that are not contained in given list. */
  componentKey_not_in?: InputMaybe<Array<InputMaybe<AppReactComponent>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given json path. */
  propsAsJson_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  propsAsJson_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References ContentTrackReactComponent record uniquely */
export type ContentTrackReactComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentTrackSection = Entity & Node & {
  __typename?: 'ContentTrackSection';
  backgroundImage?: Maybe<Asset>;
  color?: Maybe<Color>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ContentTrackSection>;
  featuredImage?: Maybe<Asset>;
  /** List of ContentTrackSection versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  parentContentTrack?: Maybe<ContentTrack>;
  progressionType?: Maybe<ContentTrackProgression>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /**
   * Do NOT "Add Existing" unless you are re-linking an orphaned item; otherwise it
   * will remove the item from its current use elsewhere.
   */
  steps: Array<ContentTrackStep>;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ContentTrackSectionBackgroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type ContentTrackSectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackSectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ContentTrackSectionFeaturedImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type ContentTrackSectionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ContentTrackSectionParentContentTrackArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackSectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackSectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ContentTrackSectionStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContentTrackStepOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackStepWhereInput>;
};


export type ContentTrackSectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContentTrackSectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentTrackSectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentTrackSectionConnection = {
  __typename?: 'ContentTrackSectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentTrackSectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentTrackSectionCreateInput = {
  backgroundImage?: InputMaybe<AssetCreateOneInlineInput>;
  color?: InputMaybe<ColorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  featuredImage?: InputMaybe<AssetCreateOneInlineInput>;
  parentContentTrack?: InputMaybe<ContentTrackCreateOneInlineInput>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  steps?: InputMaybe<ContentTrackStepCreateManyInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentTrackSectionCreateManyInlineInput = {
  /** Connect multiple existing ContentTrackSection documents */
  connect?: InputMaybe<Array<ContentTrackSectionWhereUniqueInput>>;
  /** Create and connect multiple existing ContentTrackSection documents */
  create?: InputMaybe<Array<ContentTrackSectionCreateInput>>;
};

export type ContentTrackSectionCreateOneInlineInput = {
  /** Connect one existing ContentTrackSection document */
  connect?: InputMaybe<ContentTrackSectionWhereUniqueInput>;
  /** Create and connect one ContentTrackSection document */
  create?: InputMaybe<ContentTrackSectionCreateInput>;
};

/** An edge in a connection. */
export type ContentTrackSectionEdge = {
  __typename?: 'ContentTrackSectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContentTrackSection;
};

/** Identifies documents */
export type ContentTrackSectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ContentTrackSectionWhereStageInput>;
  documentInStages_none?: InputMaybe<ContentTrackSectionWhereStageInput>;
  documentInStages_some?: InputMaybe<ContentTrackSectionWhereStageInput>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  parentContentTrack?: InputMaybe<ContentTrackWhereInput>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  /** All values that are contained in given list. */
  progressionType_in?: InputMaybe<Array<InputMaybe<ContentTrackProgression>>>;
  /** Any other value that exists and is not equal to the given value. */
  progressionType_not?: InputMaybe<ContentTrackProgression>;
  /** All values that are not contained in given list. */
  progressionType_not_in?: InputMaybe<Array<InputMaybe<ContentTrackProgression>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  steps_every?: InputMaybe<ContentTrackStepWhereInput>;
  steps_none?: InputMaybe<ContentTrackStepWhereInput>;
  steps_some?: InputMaybe<ContentTrackStepWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ContentTrackSectionOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProgressionTypeAsc = 'progressionType_ASC',
  ProgressionTypeDesc = 'progressionType_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ContentTrackSectionUpdateInput = {
  backgroundImage?: InputMaybe<AssetUpdateOneInlineInput>;
  color?: InputMaybe<ColorInput>;
  featuredImage?: InputMaybe<AssetUpdateOneInlineInput>;
  parentContentTrack?: InputMaybe<ContentTrackUpdateOneInlineInput>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<ContentTrackStepUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTrackSectionUpdateManyInlineInput = {
  /** Connect multiple existing ContentTrackSection documents */
  connect?: InputMaybe<Array<ContentTrackSectionConnectInput>>;
  /** Create and connect multiple ContentTrackSection documents */
  create?: InputMaybe<Array<ContentTrackSectionCreateInput>>;
  /** Delete multiple ContentTrackSection documents */
  delete?: InputMaybe<Array<ContentTrackSectionWhereUniqueInput>>;
  /** Disconnect multiple ContentTrackSection documents */
  disconnect?: InputMaybe<Array<ContentTrackSectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContentTrackSection documents */
  set?: InputMaybe<Array<ContentTrackSectionWhereUniqueInput>>;
  /** Update multiple ContentTrackSection documents */
  update?: InputMaybe<Array<ContentTrackSectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContentTrackSection documents */
  upsert?: InputMaybe<Array<ContentTrackSectionUpsertWithNestedWhereUniqueInput>>;
};

export type ContentTrackSectionUpdateManyInput = {
  color?: InputMaybe<ColorInput>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTrackSectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentTrackSectionUpdateManyInput;
  /** Document search */
  where: ContentTrackSectionWhereInput;
};

export type ContentTrackSectionUpdateOneInlineInput = {
  /** Connect existing ContentTrackSection document */
  connect?: InputMaybe<ContentTrackSectionWhereUniqueInput>;
  /** Create and connect one ContentTrackSection document */
  create?: InputMaybe<ContentTrackSectionCreateInput>;
  /** Delete currently connected ContentTrackSection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContentTrackSection document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrackSection document */
  update?: InputMaybe<ContentTrackSectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrackSection document */
  upsert?: InputMaybe<ContentTrackSectionUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackSectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentTrackSectionUpdateInput;
  /** Unique document search */
  where: ContentTrackSectionWhereUniqueInput;
};

export type ContentTrackSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentTrackSectionCreateInput;
  /** Update document if it exists */
  update: ContentTrackSectionUpdateInput;
};

export type ContentTrackSectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentTrackSectionUpsertInput;
  /** Unique document search */
  where: ContentTrackSectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ContentTrackSectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ContentTrackSectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ContentTrackSectionWhereStageInput>;
  documentInStages_none?: InputMaybe<ContentTrackSectionWhereStageInput>;
  documentInStages_some?: InputMaybe<ContentTrackSectionWhereStageInput>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  parentContentTrack?: InputMaybe<ContentTrackWhereInput>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  /** All values that are contained in given list. */
  progressionType_in?: InputMaybe<Array<InputMaybe<ContentTrackProgression>>>;
  /** Any other value that exists and is not equal to the given value. */
  progressionType_not?: InputMaybe<ContentTrackProgression>;
  /** All values that are not contained in given list. */
  progressionType_not_in?: InputMaybe<Array<InputMaybe<ContentTrackProgression>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  steps_every?: InputMaybe<ContentTrackStepWhereInput>;
  steps_none?: InputMaybe<ContentTrackStepWhereInput>;
  steps_some?: InputMaybe<ContentTrackStepWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ContentTrackSectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackSectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackSectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackSectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ContentTrackSectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ContentTrackSection record uniquely */
export type ContentTrackSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentTrackStep = Entity & Node & {
  __typename?: 'ContentTrackStep';
  backgroundImage?: Maybe<Asset>;
  body?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Color>;
  contentAttachments: Array<ContentTrackStepContentAttachments>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  customReactComponent?: Maybe<ContentTrackReactComponent>;
  /** Get the document in other stages */
  documentInStages: Array<ContentTrackStep>;
  featuredImage?: Maybe<Asset>;
  /** List of ContentTrackStep versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  parentContentTrackSection?: Maybe<ContentTrackSection>;
  progressionType?: Maybe<ContentTrackProgression>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  richBody?: Maybe<RichText>;
  scheduledIn: Array<ScheduledOperation>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /**
   * Do NOT "Add Existing" unless you are re-linking an orphaned item; otherwise it
   * will remove the item from its current use elsewhere.
   */
  tasks: Array<ContentTrackTask>;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  video?: Maybe<ContentTrackVideo>;
};


export type ContentTrackStepBackgroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type ContentTrackStepContentAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTrackStepCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackStepCustomReactComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackStepDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ContentTrackStepFeaturedImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type ContentTrackStepHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ContentTrackStepParentContentTrackSectionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackStepPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackStepScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ContentTrackStepTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContentTrackTaskOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackTaskWhereInput>;
};


export type ContentTrackStepUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackStepVideoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContentTrackStepConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentTrackStepWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentTrackStepConnection = {
  __typename?: 'ContentTrackStepConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentTrackStepEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentTrackStepContentAttachments = Article | PodcastEpisode;

export type ContentTrackStepContentAttachmentsConnectInput = {
  Article?: InputMaybe<ArticleConnectInput>;
  PodcastEpisode?: InputMaybe<PodcastEpisodeConnectInput>;
};

export type ContentTrackStepContentAttachmentsCreateInput = {
  Article?: InputMaybe<ArticleCreateInput>;
  PodcastEpisode?: InputMaybe<PodcastEpisodeCreateInput>;
};

export type ContentTrackStepContentAttachmentsCreateManyInlineInput = {
  /** Connect multiple existing ContentTrackStepContentAttachments documents */
  connect?: InputMaybe<Array<ContentTrackStepContentAttachmentsWhereUniqueInput>>;
  /** Create and connect multiple existing ContentTrackStepContentAttachments documents */
  create?: InputMaybe<Array<ContentTrackStepContentAttachmentsCreateInput>>;
};

export type ContentTrackStepContentAttachmentsCreateOneInlineInput = {
  /** Connect one existing ContentTrackStepContentAttachments document */
  connect?: InputMaybe<ContentTrackStepContentAttachmentsWhereUniqueInput>;
  /** Create and connect one ContentTrackStepContentAttachments document */
  create?: InputMaybe<ContentTrackStepContentAttachmentsCreateInput>;
};

export type ContentTrackStepContentAttachmentsUpdateInput = {
  Article?: InputMaybe<ArticleUpdateInput>;
  PodcastEpisode?: InputMaybe<PodcastEpisodeUpdateInput>;
};

export type ContentTrackStepContentAttachmentsUpdateManyInlineInput = {
  /** Connect multiple existing ContentTrackStepContentAttachments documents */
  connect?: InputMaybe<Array<ContentTrackStepContentAttachmentsConnectInput>>;
  /** Create and connect multiple ContentTrackStepContentAttachments documents */
  create?: InputMaybe<Array<ContentTrackStepContentAttachmentsCreateInput>>;
  /** Delete multiple ContentTrackStepContentAttachments documents */
  delete?: InputMaybe<Array<ContentTrackStepContentAttachmentsWhereUniqueInput>>;
  /** Disconnect multiple ContentTrackStepContentAttachments documents */
  disconnect?: InputMaybe<Array<ContentTrackStepContentAttachmentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContentTrackStepContentAttachments documents */
  set?: InputMaybe<Array<ContentTrackStepContentAttachmentsWhereUniqueInput>>;
  /** Update multiple ContentTrackStepContentAttachments documents */
  update?: InputMaybe<Array<ContentTrackStepContentAttachmentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContentTrackStepContentAttachments documents */
  upsert?: InputMaybe<Array<ContentTrackStepContentAttachmentsUpsertWithNestedWhereUniqueInput>>;
};

export type ContentTrackStepContentAttachmentsUpdateManyWithNestedWhereInput = {
  Article?: InputMaybe<ArticleUpdateManyWithNestedWhereInput>;
  PodcastEpisode?: InputMaybe<PodcastEpisodeUpdateManyWithNestedWhereInput>;
};

export type ContentTrackStepContentAttachmentsUpdateOneInlineInput = {
  /** Connect existing ContentTrackStepContentAttachments document */
  connect?: InputMaybe<ContentTrackStepContentAttachmentsWhereUniqueInput>;
  /** Create and connect one ContentTrackStepContentAttachments document */
  create?: InputMaybe<ContentTrackStepContentAttachmentsCreateInput>;
  /** Delete currently connected ContentTrackStepContentAttachments document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContentTrackStepContentAttachments document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrackStepContentAttachments document */
  update?: InputMaybe<ContentTrackStepContentAttachmentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrackStepContentAttachments document */
  upsert?: InputMaybe<ContentTrackStepContentAttachmentsUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackStepContentAttachmentsUpdateWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpdateWithNestedWhereUniqueInput>;
  PodcastEpisode?: InputMaybe<PodcastEpisodeUpdateWithNestedWhereUniqueInput>;
};

export type ContentTrackStepContentAttachmentsUpsertWithNestedWhereUniqueInput = {
  Article?: InputMaybe<ArticleUpsertWithNestedWhereUniqueInput>;
  PodcastEpisode?: InputMaybe<PodcastEpisodeUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackStepContentAttachmentsWhereInput = {
  Article?: InputMaybe<ArticleWhereInput>;
  PodcastEpisode?: InputMaybe<PodcastEpisodeWhereInput>;
};

export type ContentTrackStepContentAttachmentsWhereUniqueInput = {
  Article?: InputMaybe<ArticleWhereUniqueInput>;
  PodcastEpisode?: InputMaybe<PodcastEpisodeWhereUniqueInput>;
};

export type ContentTrackStepCreateInput = {
  backgroundImage?: InputMaybe<AssetCreateOneInlineInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<ColorInput>;
  contentAttachments?: InputMaybe<ContentTrackStepContentAttachmentsCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customReactComponent?: InputMaybe<ContentTrackReactComponentCreateOneInlineInput>;
  featuredImage?: InputMaybe<AssetCreateOneInlineInput>;
  parentContentTrackSection?: InputMaybe<ContentTrackSectionCreateOneInlineInput>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  richBody?: InputMaybe<Scalars['RichTextAST']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  tasks?: InputMaybe<ContentTrackTaskCreateManyInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  video?: InputMaybe<ContentTrackVideoCreateOneInlineInput>;
};

export type ContentTrackStepCreateManyInlineInput = {
  /** Connect multiple existing ContentTrackStep documents */
  connect?: InputMaybe<Array<ContentTrackStepWhereUniqueInput>>;
  /** Create and connect multiple existing ContentTrackStep documents */
  create?: InputMaybe<Array<ContentTrackStepCreateInput>>;
};

export type ContentTrackStepCreateOneInlineInput = {
  /** Connect one existing ContentTrackStep document */
  connect?: InputMaybe<ContentTrackStepWhereUniqueInput>;
  /** Create and connect one ContentTrackStep document */
  create?: InputMaybe<ContentTrackStepCreateInput>;
};

/** An edge in a connection. */
export type ContentTrackStepEdge = {
  __typename?: 'ContentTrackStepEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContentTrackStep;
};

/** Identifies documents */
export type ContentTrackStepManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackStepWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackStepWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackStepWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<AssetWhereInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  contentAttachments_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  contentAttachments_some?: InputMaybe<ContentTrackStepContentAttachmentsWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  customReactComponent?: InputMaybe<ContentTrackReactComponentWhereInput>;
  documentInStages_every?: InputMaybe<ContentTrackStepWhereStageInput>;
  documentInStages_none?: InputMaybe<ContentTrackStepWhereStageInput>;
  documentInStages_some?: InputMaybe<ContentTrackStepWhereStageInput>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  parentContentTrackSection?: InputMaybe<ContentTrackSectionWhereInput>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  /** All values that are contained in given list. */
  progressionType_in?: InputMaybe<Array<InputMaybe<ContentTrackProgression>>>;
  /** Any other value that exists and is not equal to the given value. */
  progressionType_not?: InputMaybe<ContentTrackProgression>;
  /** All values that are not contained in given list. */
  progressionType_not_in?: InputMaybe<Array<InputMaybe<ContentTrackProgression>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  tasks_every?: InputMaybe<ContentTrackTaskWhereInput>;
  tasks_none?: InputMaybe<ContentTrackTaskWhereInput>;
  tasks_some?: InputMaybe<ContentTrackTaskWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<ContentTrackVideoWhereInput>;
};

export enum ContentTrackStepOrderByInput {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProgressionTypeAsc = 'progressionType_ASC',
  ProgressionTypeDesc = 'progressionType_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ContentTrackStepUpdateInput = {
  backgroundImage?: InputMaybe<AssetUpdateOneInlineInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<ColorInput>;
  contentAttachments?: InputMaybe<ContentTrackStepContentAttachmentsUpdateManyInlineInput>;
  customReactComponent?: InputMaybe<ContentTrackReactComponentUpdateOneInlineInput>;
  featuredImage?: InputMaybe<AssetUpdateOneInlineInput>;
  parentContentTrackSection?: InputMaybe<ContentTrackSectionUpdateOneInlineInput>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  richBody?: InputMaybe<Scalars['RichTextAST']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<ContentTrackTaskUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<ContentTrackVideoUpdateOneInlineInput>;
};

export type ContentTrackStepUpdateManyInlineInput = {
  /** Connect multiple existing ContentTrackStep documents */
  connect?: InputMaybe<Array<ContentTrackStepConnectInput>>;
  /** Create and connect multiple ContentTrackStep documents */
  create?: InputMaybe<Array<ContentTrackStepCreateInput>>;
  /** Delete multiple ContentTrackStep documents */
  delete?: InputMaybe<Array<ContentTrackStepWhereUniqueInput>>;
  /** Disconnect multiple ContentTrackStep documents */
  disconnect?: InputMaybe<Array<ContentTrackStepWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContentTrackStep documents */
  set?: InputMaybe<Array<ContentTrackStepWhereUniqueInput>>;
  /** Update multiple ContentTrackStep documents */
  update?: InputMaybe<Array<ContentTrackStepUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContentTrackStep documents */
  upsert?: InputMaybe<Array<ContentTrackStepUpsertWithNestedWhereUniqueInput>>;
};

export type ContentTrackStepUpdateManyInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<ColorInput>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  richBody?: InputMaybe<Scalars['RichTextAST']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTrackStepUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentTrackStepUpdateManyInput;
  /** Document search */
  where: ContentTrackStepWhereInput;
};

export type ContentTrackStepUpdateOneInlineInput = {
  /** Connect existing ContentTrackStep document */
  connect?: InputMaybe<ContentTrackStepWhereUniqueInput>;
  /** Create and connect one ContentTrackStep document */
  create?: InputMaybe<ContentTrackStepCreateInput>;
  /** Delete currently connected ContentTrackStep document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContentTrackStep document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrackStep document */
  update?: InputMaybe<ContentTrackStepUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrackStep document */
  upsert?: InputMaybe<ContentTrackStepUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackStepUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentTrackStepUpdateInput;
  /** Unique document search */
  where: ContentTrackStepWhereUniqueInput;
};

export type ContentTrackStepUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentTrackStepCreateInput;
  /** Update document if it exists */
  update: ContentTrackStepUpdateInput;
};

export type ContentTrackStepUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentTrackStepUpsertInput;
  /** Unique document search */
  where: ContentTrackStepWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ContentTrackStepWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ContentTrackStepWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackStepWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackStepWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackStepWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<AssetWhereInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  contentAttachments_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  contentAttachments_some?: InputMaybe<ContentTrackStepContentAttachmentsWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  customReactComponent?: InputMaybe<ContentTrackReactComponentWhereInput>;
  documentInStages_every?: InputMaybe<ContentTrackStepWhereStageInput>;
  documentInStages_none?: InputMaybe<ContentTrackStepWhereStageInput>;
  documentInStages_some?: InputMaybe<ContentTrackStepWhereStageInput>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  parentContentTrackSection?: InputMaybe<ContentTrackSectionWhereInput>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  /** All values that are contained in given list. */
  progressionType_in?: InputMaybe<Array<InputMaybe<ContentTrackProgression>>>;
  /** Any other value that exists and is not equal to the given value. */
  progressionType_not?: InputMaybe<ContentTrackProgression>;
  /** All values that are not contained in given list. */
  progressionType_not_in?: InputMaybe<Array<InputMaybe<ContentTrackProgression>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  tasks_every?: InputMaybe<ContentTrackTaskWhereInput>;
  tasks_none?: InputMaybe<ContentTrackTaskWhereInput>;
  tasks_some?: InputMaybe<ContentTrackTaskWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<ContentTrackVideoWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ContentTrackStepWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackStepWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackStepWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackStepWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ContentTrackStepWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ContentTrackStep record uniquely */
export type ContentTrackStepWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentTrackTask = Entity & Node & {
  __typename?: 'ContentTrackTask';
  action?: Maybe<ContentTrackTaskactionUnion>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ContentTrackTask>;
  /** List of ContentTrackTask versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  parentContentTrackStep?: Maybe<ContentTrackStep>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ContentTrackTaskActionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackTaskCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackTaskDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ContentTrackTaskHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ContentTrackTaskParentContentTrackStepArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackTaskPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentTrackTaskScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ContentTrackTaskUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContentTrackTaskConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentTrackTaskWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentTrackTaskConnection = {
  __typename?: 'ContentTrackTaskConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentTrackTaskEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentTrackTaskCreateInput = {
  action?: InputMaybe<ContentTrackTaskactionUnionCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  parentContentTrackStep?: InputMaybe<ContentTrackStepCreateOneInlineInput>;
  slug: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentTrackTaskCreateManyInlineInput = {
  /** Connect multiple existing ContentTrackTask documents */
  connect?: InputMaybe<Array<ContentTrackTaskWhereUniqueInput>>;
  /** Create and connect multiple existing ContentTrackTask documents */
  create?: InputMaybe<Array<ContentTrackTaskCreateInput>>;
};

export type ContentTrackTaskCreateOneInlineInput = {
  /** Connect one existing ContentTrackTask document */
  connect?: InputMaybe<ContentTrackTaskWhereUniqueInput>;
  /** Create and connect one ContentTrackTask document */
  create?: InputMaybe<ContentTrackTaskCreateInput>;
};

/** An edge in a connection. */
export type ContentTrackTaskEdge = {
  __typename?: 'ContentTrackTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContentTrackTask;
};

/** Identifies documents */
export type ContentTrackTaskManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackTaskWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackTaskWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackTaskWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  action?: InputMaybe<ContentTrackTaskactionUnionWhereInput>;
  /** All values in which the union is empty. */
  action_empty?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ContentTrackTaskWhereStageInput>;
  documentInStages_none?: InputMaybe<ContentTrackTaskWhereStageInput>;
  documentInStages_some?: InputMaybe<ContentTrackTaskWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  parentContentTrackStep?: InputMaybe<ContentTrackStepWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ContentTrackTaskOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ContentTrackTaskUpdateInput = {
  action?: InputMaybe<ContentTrackTaskactionUnionUpdateOneInlineInput>;
  parentContentTrackStep?: InputMaybe<ContentTrackStepUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTrackTaskUpdateManyInlineInput = {
  /** Connect multiple existing ContentTrackTask documents */
  connect?: InputMaybe<Array<ContentTrackTaskConnectInput>>;
  /** Create and connect multiple ContentTrackTask documents */
  create?: InputMaybe<Array<ContentTrackTaskCreateInput>>;
  /** Delete multiple ContentTrackTask documents */
  delete?: InputMaybe<Array<ContentTrackTaskWhereUniqueInput>>;
  /** Disconnect multiple ContentTrackTask documents */
  disconnect?: InputMaybe<Array<ContentTrackTaskWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContentTrackTask documents */
  set?: InputMaybe<Array<ContentTrackTaskWhereUniqueInput>>;
  /** Update multiple ContentTrackTask documents */
  update?: InputMaybe<Array<ContentTrackTaskUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContentTrackTask documents */
  upsert?: InputMaybe<Array<ContentTrackTaskUpsertWithNestedWhereUniqueInput>>;
};

export type ContentTrackTaskUpdateManyInput = {
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTrackTaskUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentTrackTaskUpdateManyInput;
  /** Document search */
  where: ContentTrackTaskWhereInput;
};

export type ContentTrackTaskUpdateOneInlineInput = {
  /** Connect existing ContentTrackTask document */
  connect?: InputMaybe<ContentTrackTaskWhereUniqueInput>;
  /** Create and connect one ContentTrackTask document */
  create?: InputMaybe<ContentTrackTaskCreateInput>;
  /** Delete currently connected ContentTrackTask document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContentTrackTask document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrackTask document */
  update?: InputMaybe<ContentTrackTaskUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrackTask document */
  upsert?: InputMaybe<ContentTrackTaskUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackTaskUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentTrackTaskUpdateInput;
  /** Unique document search */
  where: ContentTrackTaskWhereUniqueInput;
};

export type ContentTrackTaskUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentTrackTaskCreateInput;
  /** Update document if it exists */
  update: ContentTrackTaskUpdateInput;
};

export type ContentTrackTaskUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentTrackTaskUpsertInput;
  /** Unique document search */
  where: ContentTrackTaskWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ContentTrackTaskWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ContentTrackTaskWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackTaskWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackTaskWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackTaskWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  action?: InputMaybe<ContentTrackTaskactionUnionWhereInput>;
  /** All values in which the union is empty. */
  action_empty?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ContentTrackTaskWhereStageInput>;
  documentInStages_none?: InputMaybe<ContentTrackTaskWhereStageInput>;
  documentInStages_some?: InputMaybe<ContentTrackTaskWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  parentContentTrackStep?: InputMaybe<ContentTrackStepWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ContentTrackTaskWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackTaskWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackTaskWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackTaskWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ContentTrackTaskWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ContentTrackTask record uniquely */
export type ContentTrackTaskWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentTrackTaskactionUnion = ContentTrackCallToAction | ContentTrackPrompt | ContentTrackReactComponent;

export type ContentTrackTaskactionUnionConnectInput = {
  ContentTrackCallToAction?: InputMaybe<ContentTrackCallToActionConnectInput>;
  ContentTrackPrompt?: InputMaybe<ContentTrackPromptConnectInput>;
  ContentTrackReactComponent?: InputMaybe<ContentTrackReactComponentConnectInput>;
};

export type ContentTrackTaskactionUnionCreateInput = {
  ContentTrackCallToAction?: InputMaybe<ContentTrackCallToActionCreateInput>;
  ContentTrackPrompt?: InputMaybe<ContentTrackPromptCreateInput>;
  ContentTrackReactComponent?: InputMaybe<ContentTrackReactComponentCreateInput>;
};

export type ContentTrackTaskactionUnionCreateManyInlineInput = {
  /** Create and connect multiple existing ContentTrackTaskactionUnion documents */
  create?: InputMaybe<Array<ContentTrackTaskactionUnionCreateInput>>;
};

export type ContentTrackTaskactionUnionCreateOneInlineInput = {
  /** Create and connect one ContentTrackTaskactionUnion document */
  create?: InputMaybe<ContentTrackTaskactionUnionCreateInput>;
};

export type ContentTrackTaskactionUnionCreateWithPositionInput = {
  ContentTrackCallToAction?: InputMaybe<ContentTrackCallToActionCreateWithPositionInput>;
  ContentTrackPrompt?: InputMaybe<ContentTrackPromptCreateWithPositionInput>;
  ContentTrackReactComponent?: InputMaybe<ContentTrackReactComponentCreateWithPositionInput>;
};

export type ContentTrackTaskactionUnionUpdateInput = {
  ContentTrackCallToAction?: InputMaybe<ContentTrackCallToActionUpdateInput>;
  ContentTrackPrompt?: InputMaybe<ContentTrackPromptUpdateInput>;
  ContentTrackReactComponent?: InputMaybe<ContentTrackReactComponentUpdateInput>;
};

export type ContentTrackTaskactionUnionUpdateManyInlineInput = {
  /** Create and connect multiple ContentTrackTaskactionUnion component instances */
  create?: InputMaybe<Array<ContentTrackTaskactionUnionCreateWithPositionInput>>;
  /** Delete multiple ContentTrackTaskactionUnion documents */
  delete?: InputMaybe<Array<ContentTrackTaskactionUnionWhereUniqueInput>>;
  /** Update multiple ContentTrackTaskactionUnion component instances */
  update?: InputMaybe<Array<ContentTrackTaskactionUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ContentTrackTaskactionUnion component instances */
  upsert?: InputMaybe<Array<ContentTrackTaskactionUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ContentTrackTaskactionUnionUpdateManyWithNestedWhereInput = {
  ContentTrackCallToAction?: InputMaybe<ContentTrackCallToActionUpdateManyWithNestedWhereInput>;
  ContentTrackPrompt?: InputMaybe<ContentTrackPromptUpdateManyWithNestedWhereInput>;
  ContentTrackReactComponent?: InputMaybe<ContentTrackReactComponentUpdateManyWithNestedWhereInput>;
};

export type ContentTrackTaskactionUnionUpdateOneInlineInput = {
  /** Create and connect one ContentTrackTaskactionUnion document */
  create?: InputMaybe<ContentTrackTaskactionUnionCreateInput>;
  /** Delete currently connected ContentTrackTaskactionUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrackTaskactionUnion document */
  update?: InputMaybe<ContentTrackTaskactionUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrackTaskactionUnion document */
  upsert?: InputMaybe<ContentTrackTaskactionUnionUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackTaskactionUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  ContentTrackCallToAction?: InputMaybe<ContentTrackCallToActionUpdateWithNestedWhereUniqueAndPositionInput>;
  ContentTrackPrompt?: InputMaybe<ContentTrackPromptUpdateWithNestedWhereUniqueAndPositionInput>;
  ContentTrackReactComponent?: InputMaybe<ContentTrackReactComponentUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ContentTrackTaskactionUnionUpdateWithNestedWhereUniqueInput = {
  ContentTrackCallToAction?: InputMaybe<ContentTrackCallToActionUpdateWithNestedWhereUniqueInput>;
  ContentTrackPrompt?: InputMaybe<ContentTrackPromptUpdateWithNestedWhereUniqueInput>;
  ContentTrackReactComponent?: InputMaybe<ContentTrackReactComponentUpdateWithNestedWhereUniqueInput>;
};

export type ContentTrackTaskactionUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  ContentTrackCallToAction?: InputMaybe<ContentTrackCallToActionUpsertWithNestedWhereUniqueAndPositionInput>;
  ContentTrackPrompt?: InputMaybe<ContentTrackPromptUpsertWithNestedWhereUniqueAndPositionInput>;
  ContentTrackReactComponent?: InputMaybe<ContentTrackReactComponentUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ContentTrackTaskactionUnionUpsertWithNestedWhereUniqueInput = {
  ContentTrackCallToAction?: InputMaybe<ContentTrackCallToActionUpsertWithNestedWhereUniqueInput>;
  ContentTrackPrompt?: InputMaybe<ContentTrackPromptUpsertWithNestedWhereUniqueInput>;
  ContentTrackReactComponent?: InputMaybe<ContentTrackReactComponentUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackTaskactionUnionWhereInput = {
  ContentTrackCallToAction?: InputMaybe<ContentTrackCallToActionWhereInput>;
  ContentTrackPrompt?: InputMaybe<ContentTrackPromptWhereInput>;
  ContentTrackReactComponent?: InputMaybe<ContentTrackReactComponentWhereInput>;
};

export type ContentTrackTaskactionUnionWhereUniqueInput = {
  ContentTrackCallToAction?: InputMaybe<ContentTrackCallToActionWhereUniqueInput>;
  ContentTrackPrompt?: InputMaybe<ContentTrackPromptWhereUniqueInput>;
  ContentTrackReactComponent?: InputMaybe<ContentTrackReactComponentWhereUniqueInput>;
};

export enum ContentTrackType {
  AgencyService = 'AgencyService',
  Bootcamp = 'Bootcamp',
  Course = 'Course',
  Private = 'Private',
  Sprint = 'Sprint',
  Track = 'Track'
}

export type ContentTrackUpdateInput = {
  backgroundImage?: InputMaybe<AssetUpdateOneInlineInput>;
  color?: InputMaybe<ColorInput>;
  featuredImage?: InputMaybe<AssetUpdateOneInlineInput>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  richLongDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
  sections?: InputMaybe<ContentTrackSectionUpdateManyInlineInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContentTrackType>;
};

export type ContentTrackUpdateManyInlineInput = {
  /** Connect multiple existing ContentTrack documents */
  connect?: InputMaybe<Array<ContentTrackConnectInput>>;
  /** Create and connect multiple ContentTrack documents */
  create?: InputMaybe<Array<ContentTrackCreateInput>>;
  /** Delete multiple ContentTrack documents */
  delete?: InputMaybe<Array<ContentTrackWhereUniqueInput>>;
  /** Disconnect multiple ContentTrack documents */
  disconnect?: InputMaybe<Array<ContentTrackWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContentTrack documents */
  set?: InputMaybe<Array<ContentTrackWhereUniqueInput>>;
  /** Update multiple ContentTrack documents */
  update?: InputMaybe<Array<ContentTrackUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContentTrack documents */
  upsert?: InputMaybe<Array<ContentTrackUpsertWithNestedWhereUniqueInput>>;
};

export type ContentTrackUpdateManyInput = {
  color?: InputMaybe<ColorInput>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  richLongDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContentTrackType>;
};

export type ContentTrackUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentTrackUpdateManyInput;
  /** Document search */
  where: ContentTrackWhereInput;
};

export type ContentTrackUpdateOneInlineInput = {
  /** Connect existing ContentTrack document */
  connect?: InputMaybe<ContentTrackWhereUniqueInput>;
  /** Create and connect one ContentTrack document */
  create?: InputMaybe<ContentTrackCreateInput>;
  /** Delete currently connected ContentTrack document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContentTrack document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrack document */
  update?: InputMaybe<ContentTrackUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrack document */
  upsert?: InputMaybe<ContentTrackUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentTrackUpdateInput;
  /** Unique document search */
  where: ContentTrackWhereUniqueInput;
};

export type ContentTrackUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentTrackCreateInput;
  /** Update document if it exists */
  update: ContentTrackUpdateInput;
};

export type ContentTrackUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentTrackUpsertInput;
  /** Unique document search */
  where: ContentTrackWhereUniqueInput;
};

export type ContentTrackVideo = Entity & {
  __typename?: 'ContentTrackVideo';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  playbackDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  playbackEndInSeconds?: Maybe<Scalars['Int']['output']>;
  playbackStartInSeconds?: Maybe<Scalars['Int']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentTrackVideoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentTrackVideoWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentTrackVideoConnection = {
  __typename?: 'ContentTrackVideoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentTrackVideoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentTrackVideoCreateInput = {
  playbackDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  playbackEndInSeconds?: InputMaybe<Scalars['Int']['input']>;
  playbackStartInSeconds?: InputMaybe<Scalars['Int']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentTrackVideoCreateManyInlineInput = {
  /** Create and connect multiple existing ContentTrackVideo documents */
  create?: InputMaybe<Array<ContentTrackVideoCreateInput>>;
};

export type ContentTrackVideoCreateOneInlineInput = {
  /** Create and connect one ContentTrackVideo document */
  create?: InputMaybe<ContentTrackVideoCreateInput>;
};

export type ContentTrackVideoCreateWithPositionInput = {
  /** Document to create */
  data: ContentTrackVideoCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ContentTrackVideoEdge = {
  __typename?: 'ContentTrackVideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContentTrackVideo;
};

/** Identifies documents */
export type ContentTrackVideoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackVideoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackVideoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackVideoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  playbackDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  playbackDurationInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  playbackDurationInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  playbackDurationInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  playbackDurationInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  playbackDurationInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  playbackDurationInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  playbackDurationInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  playbackEndInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  playbackEndInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  playbackEndInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  playbackEndInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  playbackEndInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  playbackEndInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  playbackEndInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  playbackEndInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  playbackStartInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  playbackStartInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  playbackStartInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  playbackStartInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  playbackStartInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  playbackStartInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  playbackStartInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  playbackStartInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sourceUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sourceUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sourceUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sourceUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sourceUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sourceUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sourceUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sourceUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sourceUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ContentTrackVideoOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PlaybackDurationInSecondsAsc = 'playbackDurationInSeconds_ASC',
  PlaybackDurationInSecondsDesc = 'playbackDurationInSeconds_DESC',
  PlaybackEndInSecondsAsc = 'playbackEndInSeconds_ASC',
  PlaybackEndInSecondsDesc = 'playbackEndInSeconds_DESC',
  PlaybackStartInSecondsAsc = 'playbackStartInSeconds_ASC',
  PlaybackStartInSecondsDesc = 'playbackStartInSeconds_DESC',
  SourceUrlAsc = 'sourceUrl_ASC',
  SourceUrlDesc = 'sourceUrl_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ContentTrackVideoParent = ContentTrackStep;

export type ContentTrackVideoParentConnectInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepConnectInput>;
};

export type ContentTrackVideoParentCreateInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepCreateInput>;
};

export type ContentTrackVideoParentCreateManyInlineInput = {
  /** Connect multiple existing ContentTrackVideoParent documents */
  connect?: InputMaybe<Array<ContentTrackVideoParentWhereUniqueInput>>;
  /** Create and connect multiple existing ContentTrackVideoParent documents */
  create?: InputMaybe<Array<ContentTrackVideoParentCreateInput>>;
};

export type ContentTrackVideoParentCreateOneInlineInput = {
  /** Connect one existing ContentTrackVideoParent document */
  connect?: InputMaybe<ContentTrackVideoParentWhereUniqueInput>;
  /** Create and connect one ContentTrackVideoParent document */
  create?: InputMaybe<ContentTrackVideoParentCreateInput>;
};

export type ContentTrackVideoParentUpdateInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepUpdateInput>;
};

export type ContentTrackVideoParentUpdateManyInlineInput = {
  /** Connect multiple existing ContentTrackVideoParent documents */
  connect?: InputMaybe<Array<ContentTrackVideoParentConnectInput>>;
  /** Create and connect multiple ContentTrackVideoParent documents */
  create?: InputMaybe<Array<ContentTrackVideoParentCreateInput>>;
  /** Delete multiple ContentTrackVideoParent documents */
  delete?: InputMaybe<Array<ContentTrackVideoParentWhereUniqueInput>>;
  /** Disconnect multiple ContentTrackVideoParent documents */
  disconnect?: InputMaybe<Array<ContentTrackVideoParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContentTrackVideoParent documents */
  set?: InputMaybe<Array<ContentTrackVideoParentWhereUniqueInput>>;
  /** Update multiple ContentTrackVideoParent documents */
  update?: InputMaybe<Array<ContentTrackVideoParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContentTrackVideoParent documents */
  upsert?: InputMaybe<Array<ContentTrackVideoParentUpsertWithNestedWhereUniqueInput>>;
};

export type ContentTrackVideoParentUpdateManyWithNestedWhereInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepUpdateManyWithNestedWhereInput>;
};

export type ContentTrackVideoParentUpdateOneInlineInput = {
  /** Connect existing ContentTrackVideoParent document */
  connect?: InputMaybe<ContentTrackVideoParentWhereUniqueInput>;
  /** Create and connect one ContentTrackVideoParent document */
  create?: InputMaybe<ContentTrackVideoParentCreateInput>;
  /** Delete currently connected ContentTrackVideoParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContentTrackVideoParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrackVideoParent document */
  update?: InputMaybe<ContentTrackVideoParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrackVideoParent document */
  upsert?: InputMaybe<ContentTrackVideoParentUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackVideoParentUpdateWithNestedWhereUniqueInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepUpdateWithNestedWhereUniqueInput>;
};

export type ContentTrackVideoParentUpsertWithNestedWhereUniqueInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackVideoParentWhereInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepWhereInput>;
};

export type ContentTrackVideoParentWhereUniqueInput = {
  ContentTrackStep?: InputMaybe<ContentTrackStepWhereUniqueInput>;
};

export type ContentTrackVideoUpdateInput = {
  playbackDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  playbackEndInSeconds?: InputMaybe<Scalars['Int']['input']>;
  playbackStartInSeconds?: InputMaybe<Scalars['Int']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTrackVideoUpdateManyInlineInput = {
  /** Create and connect multiple ContentTrackVideo component instances */
  create?: InputMaybe<Array<ContentTrackVideoCreateWithPositionInput>>;
  /** Delete multiple ContentTrackVideo documents */
  delete?: InputMaybe<Array<ContentTrackVideoWhereUniqueInput>>;
  /** Update multiple ContentTrackVideo component instances */
  update?: InputMaybe<Array<ContentTrackVideoUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ContentTrackVideo component instances */
  upsert?: InputMaybe<Array<ContentTrackVideoUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ContentTrackVideoUpdateManyInput = {
  playbackDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  playbackEndInSeconds?: InputMaybe<Scalars['Int']['input']>;
  playbackStartInSeconds?: InputMaybe<Scalars['Int']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTrackVideoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentTrackVideoUpdateManyInput;
  /** Document search */
  where: ContentTrackVideoWhereInput;
};

export type ContentTrackVideoUpdateOneInlineInput = {
  /** Create and connect one ContentTrackVideo document */
  create?: InputMaybe<ContentTrackVideoCreateInput>;
  /** Delete currently connected ContentTrackVideo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentTrackVideo document */
  update?: InputMaybe<ContentTrackVideoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentTrackVideo document */
  upsert?: InputMaybe<ContentTrackVideoUpsertWithNestedWhereUniqueInput>;
};

export type ContentTrackVideoUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ContentTrackVideoUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentTrackVideoWhereUniqueInput;
};

export type ContentTrackVideoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentTrackVideoUpdateInput;
  /** Unique document search */
  where: ContentTrackVideoWhereUniqueInput;
};

export type ContentTrackVideoUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentTrackVideoCreateInput;
  /** Update document if it exists */
  update: ContentTrackVideoUpdateInput;
};

export type ContentTrackVideoUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ContentTrackVideoUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentTrackVideoWhereUniqueInput;
};

export type ContentTrackVideoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentTrackVideoUpsertInput;
  /** Unique document search */
  where: ContentTrackVideoWhereUniqueInput;
};

/** Identifies documents */
export type ContentTrackVideoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackVideoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackVideoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackVideoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  playbackDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  playbackDurationInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  playbackDurationInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  playbackDurationInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  playbackDurationInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  playbackDurationInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  playbackDurationInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  playbackDurationInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  playbackEndInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  playbackEndInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  playbackEndInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  playbackEndInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  playbackEndInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  playbackEndInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  playbackEndInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  playbackEndInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  playbackStartInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  playbackStartInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  playbackStartInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  playbackStartInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  playbackStartInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  playbackStartInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  playbackStartInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  playbackStartInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sourceUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sourceUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sourceUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sourceUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sourceUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sourceUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sourceUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sourceUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sourceUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References ContentTrackVideo record uniquely */
export type ContentTrackVideoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type ContentTrackWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ContentTrackWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ContentTrackWhereStageInput>;
  documentInStages_none?: InputMaybe<ContentTrackWhereStageInput>;
  documentInStages_some?: InputMaybe<ContentTrackWhereStageInput>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  longDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  longDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  longDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  longDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  longDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  longDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  longDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  longDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  longDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  progressionType?: InputMaybe<ContentTrackProgression>;
  /** All values that are contained in given list. */
  progressionType_in?: InputMaybe<Array<InputMaybe<ContentTrackProgression>>>;
  /** Any other value that exists and is not equal to the given value. */
  progressionType_not?: InputMaybe<ContentTrackProgression>;
  /** All values that are not contained in given list. */
  progressionType_not_in?: InputMaybe<Array<InputMaybe<ContentTrackProgression>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sections_every?: InputMaybe<ContentTrackSectionWhereInput>;
  sections_none?: InputMaybe<ContentTrackSectionWhereInput>;
  sections_some?: InputMaybe<ContentTrackSectionWhereInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContentTrackType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<ContentTrackType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<ContentTrackType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<ContentTrackType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ContentTrackWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentTrackWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentTrackWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentTrackWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ContentTrackWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ContentTrack record uniquely */
export type ContentTrackWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdvisorConnectDashboardLinkPayload = {
  __typename?: 'CreateAdvisorConnectDashboardLinkPayload';
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateAdvisorConnectOnboardingLinkInput = {
  country?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdvisorConnectOnboardingLinkPayload = {
  __typename?: 'CreateAdvisorConnectOnboardingLinkPayload';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  stripeConnectAccountId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateAdvisorSessionJoinCredentialsInput = {
  advisorSessionId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdvisorSessionJoinCredentialsPayload = {
  __typename?: 'CreateAdvisorSessionJoinCredentialsPayload';
  advisorSession?: Maybe<ScoAdvisorSession>;
  credentials?: Maybe<ScoStreamJoinCredentials>;
};

export type CreateCommentInput = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  storedFileIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  threadId: Scalars['String']['input'];
};

export type CreateCommentPayload = {
  __typename?: 'CreateCommentPayload';
  comment?: Maybe<ScoComment>;
  thread?: Maybe<ScoThread>;
};

export type CreateCourseEnrollmentInput = {
  courseId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCourseEnrollmentPayload = {
  __typename?: 'CreateCourseEnrollmentPayload';
  createdCourseEnrollment: ScoCourseEnrollment;
  viewer?: Maybe<Viewer>;
};

export type CreateFlagInput = {
  flaggableId: Scalars['String']['input'];
  flaggableType: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFlagPayload = {
  __typename?: 'CreateFlagPayload';
  comment?: Maybe<ScoComment>;
  flag?: Maybe<ScoFlag>;
  groupRequest?: Maybe<GroupRequest>;
  thread?: Maybe<ScoThread>;
};

export type CreateGroupCommentInput = {
  attachmentId: Scalars['String']['input'];
  attachmentType: Scalars['String']['input'];
  body: Scalars['String']['input'];
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
};

export type CreateGroupCommentPayload = {
  __typename?: 'CreateGroupCommentPayload';
  comment?: Maybe<ScoComment>;
  thread?: Maybe<ScoThread>;
};

export type CreateGroupMemberInput = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateGroupMemberPayload = {
  __typename?: 'CreateGroupMemberPayload';
  created?: Maybe<Scalars['Boolean']['output']>;
  group?: Maybe<Group>;
  groupMember?: Maybe<GroupMember>;
};

export type CreateGroupMemberReviewInput = {
  iHelped?: InputMaybe<Scalars['Int']['input']>;
  iListened?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  othersHelped?: InputMaybe<Scalars['Int']['input']>;
  othersListened?: InputMaybe<Scalars['Int']['input']>;
  reviewSubjectId: Scalars['String']['input'];
  reviewSubjectType: Scalars['String']['input'];
  score?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateGroupMemberReviewPayload = {
  __typename?: 'CreateGroupMemberReviewPayload';
  review?: Maybe<GroupMemberReview>;
};

export type CreateGroupThreadInput = {
  attachmentId: Scalars['String']['input'];
  attachmentType: Scalars['String']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  tagSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicTermSlug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGroupThreadPayload = {
  __typename?: 'CreateGroupThreadPayload';
  thread?: Maybe<ScoThread>;
};

export type CreateLinkedAccountInput = {
  app: Scalars['String']['input'];
  externalEmail?: InputMaybe<Scalars['String']['input']>;
  externalPassword?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLinkedAccountPayload = {
  __typename?: 'CreateLinkedAccountPayload';
  linkedAccount?: Maybe<ScoLinkedAccount>;
};

export type CreateProvisionedAccountInput = {
  application: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProvisionedAccountPayload = {
  __typename?: 'CreateProvisionedAccountPayload';
  provisionedAccount?: Maybe<ProvisionedAccount>;
  viewer?: Maybe<Viewer>;
};

export type CreateStripePaymentIntentInput = {
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateStripePaymentIntentPayload = {
  __typename?: 'CreateStripePaymentIntentPayload';
  dataAsJson?: Maybe<Scalars['String']['output']>;
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
};

export type CreateSubscriptionChangeChargebeeHostedPageInput = {
  newCouponCode?: InputMaybe<Scalars['String']['input']>;
  newProductId?: InputMaybe<Scalars['String']['input']>;
  newProductTermId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['String']['input'];
};

export type CreateSubscriptionChangeChargebeeHostedPagePayload = {
  __typename?: 'CreateSubscriptionChangeChargebeeHostedPagePayload';
  chargebeeHostedPageUrl?: Maybe<Scalars['String']['output']>;
  newProduct?: Maybe<ScoProduct>;
  subscription?: Maybe<ScoSubscription>;
};

export type CreateThreadInput = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  tagSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicTermSlug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateThreadPayload = {
  __typename?: 'CreateThreadPayload';
  thread?: Maybe<ScoThread>;
};

export type CreateUserAuthTokenInput = {
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserAuthTokenPayload = {
  __typename?: 'CreateUserAuthTokenPayload';
  token: Scalars['String']['output'];
  userAuthToken: ScoUserAuthToken;
  viewer?: Maybe<Viewer>;
};

export type CreateViewInput = {
  viewableId: Scalars['String']['input'];
  viewableType: Scalars['String']['input'];
};

export type CreateViewPayload = {
  __typename?: 'CreateViewPayload';
  comment?: Maybe<ScoComment>;
  thread?: Maybe<ScoThread>;
  view?: Maybe<ScoView>;
};

export type DealsPartnerInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountOffered?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  restrictions?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DealsPartnerPayload = {
  __typename?: 'DealsPartnerPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DelaySubscriptionRenewalInput = {
  nextAssessmentAt?: InputMaybe<Scalars['DateTime']['input']>;
  subscriptionId: Scalars['String']['input'];
};

export type DelaySubscriptionRenewalPayload = {
  __typename?: 'DelaySubscriptionRenewalPayload';
  subscription?: Maybe<ScoSubscription>;
};

export type DeleteAccountInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAccountPayload = {
  __typename?: 'DeleteAccountPayload';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAdvisorAgreementInput = {
  advisorAgreementId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAdvisorAgreementPayload = {
  __typename?: 'DeleteAdvisorAgreementPayload';
  advisorAgreement?: Maybe<ScoAdvisorAgreement>;
};

export type DeleteBootcampShareInput = {
  bootcampShareId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteBootcampSharePayload = {
  __typename?: 'DeleteBootcampSharePayload';
  bootcamp?: Maybe<ScoBootcamp>;
  bootcampEnrollment?: Maybe<ScoBootcampEnrollment>;
  currentUser?: Maybe<ScoUser>;
};

export type DeleteCommentInput = {
  commentId: Scalars['String']['input'];
};

export type DeleteCommentPayload = {
  __typename?: 'DeleteCommentPayload';
  comment?: Maybe<ScoComment>;
  thread?: Maybe<ScoThread>;
};

export type DeleteCrmSavedReplyInput = {
  savedReplyId: Scalars['String']['input'];
};

export type DeleteCrmSavedReplyPayload = {
  __typename?: 'DeleteCrmSavedReplyPayload';
  deleted?: Maybe<Scalars['Boolean']['output']>;
  savedReplyId?: Maybe<Scalars['String']['output']>;
};

export type DeleteGroupEventInput = {
  groupEventId: Scalars['String']['input'];
};

export type DeleteGroupEventPayload = {
  __typename?: 'DeleteGroupEventPayload';
  event?: Maybe<GroupEvent>;
  group?: Maybe<Group>;
};

export type DeleteGroupGoalInput = {
  groupGoalId: Scalars['String']['input'];
};

export type DeleteGroupGoalPayload = {
  __typename?: 'DeleteGroupGoalPayload';
  goal?: Maybe<GroupGoal>;
  group?: Maybe<Group>;
};

export type DeleteGroupInput = {
  groupId: Scalars['String']['input'];
};

export type DeleteGroupMemberReviewInput = {
  groupMemberReviewId: Scalars['String']['input'];
};

export type DeleteGroupMemberReviewPayload = {
  __typename?: 'DeleteGroupMemberReviewPayload';
  review?: Maybe<GroupMemberReview>;
};

export type DeleteGroupMembershipInput = {
  groupId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteGroupMembershipPayload = {
  __typename?: 'DeleteGroupMembershipPayload';
  group?: Maybe<Group>;
  membership?: Maybe<GroupMember>;
  user?: Maybe<ScoUser>;
};

export type DeleteGroupPayload = {
  __typename?: 'DeleteGroupPayload';
  group?: Maybe<Group>;
};

export type DeleteScoAnalyticsSavedReportInput = {
  scoAnalyticsSavedReportId: Scalars['UUID']['input'];
};

export type DeleteScoAnalyticsSavedReportPayload = {
  __typename?: 'DeleteScoAnalyticsSavedReportPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSocialConnectionInput = {
  socialConnectionId: Scalars['String']['input'];
};

export type DeleteSocialConnectionPayload = {
  __typename?: 'DeleteSocialConnectionPayload';
  socialConnection?: Maybe<SocialConnection>;
  user?: Maybe<ScoUser>;
};

export type DeleteThreadInput = {
  threadId: Scalars['String']['input'];
};

export type DeleteThreadPayload = {
  __typename?: 'DeleteThreadPayload';
  thread?: Maybe<ScoThread>;
};

export type DeleteToolKnowledgeCardInput = {
  toolKnowledgeCardId: Scalars['String']['input'];
};

export type DeleteToolKnowledgeCardPayload = {
  __typename?: 'DeleteToolKnowledgeCardPayload';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteToolReplyTemplateInput = {
  toolReplyTemplateId: Scalars['String']['input'];
};

export type DeleteToolReplyTemplatePayload = {
  __typename?: 'DeleteToolReplyTemplatePayload';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteToolRuleInput = {
  confirmHardStop?: InputMaybe<Scalars['Boolean']['input']>;
  toolRuleId: Scalars['String']['input'];
};

export type DeleteToolRulePayload = {
  __typename?: 'DeleteToolRulePayload';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DiscardToolDraftInput = {
  inboundCommentId?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
  toolId: Scalars['String']['input'];
};

export type DiscardToolDraftPayload = {
  __typename?: 'DiscardToolDraftPayload';
  discarded?: Maybe<Scalars['Boolean']['output']>;
};

export type DismissCrmThreadInput = {
  accountUserId: Scalars['String']['input'];
  reasonKey?: InputMaybe<Scalars['String']['input']>;
  seenInboundCommentId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};

export type DismissCrmThreadPayload = {
  __typename?: 'DismissCrmThreadPayload';
  changed?: Maybe<Scalars['Boolean']['output']>;
  dismissed?: Maybe<Scalars['Boolean']['output']>;
  toolRuleRunId?: Maybe<Scalars['String']['output']>;
};

export type DismissNotificationInput = {
  notificationId: Scalars['String']['input'];
};

export type DismissNotificationPayload = {
  __typename?: 'DismissNotificationPayload';
  notification?: Maybe<ScoNotification>;
};

export type DismissNotificationsInput = {
  notificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DismissNotificationsPayload = {
  __typename?: 'DismissNotificationsPayload';
  notifications?: Maybe<Array<Maybe<ScoNotification>>>;
};

export enum DocumentFileTypes {
  /** Automatically selects the best format for the image based on the browser's capabilities. */
  AutoImage = 'autoImage',
  Avif = 'avif',
  Bmp = 'bmp',
  Gif = 'gif',
  Heic = 'heic',
  Jpg = 'jpg',
  Png = 'png',
  Svg = 'svg',
  Tiff = 'tiff',
  Webp = 'webp'
}

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * PDF: 	autoImage, gif, jpg, png, webp, tiff
   */
  format?: InputMaybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export type DownloadEbookInput = {
  email: Scalars['String']['input'];
};

export type DownloadEbookPayload = {
  __typename?: 'DownloadEbookPayload';
  email?: Maybe<Scalars['String']['output']>;
};

export type DuplicateScoAnalyticsSavedReportInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  scoAnalyticsSavedReportId: Scalars['UUID']['input'];
};

export type DuplicateScoAnalyticsSavedReportPayload = {
  __typename?: 'DuplicateScoAnalyticsSavedReportPayload';
  scoAnalyticsSavedReport?: Maybe<ScoAnalyticsSavedReport>;
};

export type EndAdvisorEngagementInput = {
  advisorEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export type EndAdvisorEngagementPayload = {
  __typename?: 'EndAdvisorEngagementPayload';
  advisorEngagement?: Maybe<ScoAdvisorEngagement>;
};

export type EnsureScoPitchDeckSlideChatInput = {
  pitchDeckSlideId: Scalars['String']['input'];
};

export type EnsureScoPitchDeckSlideChatPayload = {
  __typename?: 'EnsureScoPitchDeckSlideChatPayload';
  pitchDeckSlide?: Maybe<ScoPitchDeckSlide>;
};

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

/**
 * This enumeration holds all typenames that implement the Entity interface.
 * Components and models implement the Entity interface.
 */
export enum EntityTypeName {
  Article = 'Article',
  /** Asset system model */
  Asset = 'Asset',
  Benefit = 'Benefit',
  BootcampEvent = 'BootcampEvent',
  /** Business Stage */
  BusinessStage = 'BusinessStage',
  CoachProfile = 'CoachProfile',
  ContentTrack = 'ContentTrack',
  ContentTrackCallToAction = 'ContentTrackCallToAction',
  ContentTrackPrompt = 'ContentTrackPrompt',
  /** A set of defined components which can be rendered at runtime from the app. This maps to actual code in our app. */
  ContentTrackReactComponent = 'ContentTrackReactComponent',
  ContentTrackSection = 'ContentTrackSection',
  ContentTrackStep = 'ContentTrackStep',
  ContentTrackTask = 'ContentTrackTask',
  ContentTrackVideo = 'ContentTrackVideo',
  FounderTrack = 'FounderTrack',
  FounderTrackStep = 'FounderTrackStep',
  FounderTrackTask = 'FounderTrackTask',
  Link = 'Link',
  Person = 'Person',
  Playlist = 'Playlist',
  PodcastEpisode = 'PodcastEpisode',
  ProductName = 'ProductName',
  Review = 'Review',
  /** Scheduled Operation system model */
  ScheduledOperation = 'ScheduledOperation',
  /** Scheduled Release system model */
  ScheduledRelease = 'ScheduledRelease',
  SupportArticle = 'SupportArticle',
  SupportCategory = 'SupportCategory',
  Term = 'Term',
  /** User system model */
  User = 'User',
  Video = 'Video',
  VideoCourse = 'VideoCourse',
  VideoCourseListEntry = 'VideoCourseListEntry',
  VideoLesson = 'VideoLesson',
  VideoList = 'VideoList',
  /** Assigns a video to another type, with sortable number field. */
  VideoListEntry = 'VideoListEntry',
  VideoPlaylist = 'VideoPlaylist'
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Locale>;
  stage: Stage;
  /** The Type name of an object */
  typename: EntityTypeName;
};

export type ExtractAdvisorApplicationFromBioInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  profileStoredFileId?: InputMaybe<Scalars['String']['input']>;
};

export type ExtractAdvisorApplicationFromBioPayload = {
  __typename?: 'ExtractAdvisorApplicationFromBioPayload';
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  headline?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  user?: Maybe<ScoUser>;
  userExperiences?: Maybe<Array<Maybe<ScoUserExperience>>>;
  viewer?: Maybe<Viewer>;
};

export type ExtractSkillsForUserInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ExtractSkillsForUserPayload = {
  __typename?: 'ExtractSkillsForUserPayload';
  user?: Maybe<ScoUser>;
  viewer?: Maybe<Viewer>;
};

export type FgAirtableMember = ScoNode & {
  __typename?: 'FGAirtableMember';
  airtableRecordIdentifier?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyElevatorPitch?: Maybe<Scalars['String']['output']>;
  companyIndustries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyStage?: Maybe<Scalars['String']['output']>;
  companyWebsite?: Maybe<Scalars['String']['output']>;
  companyYearFounded?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOpenToNetworking?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  longBio?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  powers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shortBio?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type FgAirtableMemberCollection = {
  __typename?: 'FGAirtableMemberCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<FgAirtableMember>>;
  pagination: Pagination;
};

export type FgStats = ScoNode & {
  __typename?: 'FGStats';
  activeSubscriptionsForReportingPeriod?: Maybe<Scalars['Int']['output']>;
  canceledSubscriptionsForReportingPeriod?: Maybe<Scalars['Int']['output']>;
  groupAttendancesForReportingPeriod?: Maybe<Scalars['Int']['output']>;
  groupMeetingsForReportingPeriod?: Maybe<Scalars['Int']['output']>;
  groupsByMember?: Maybe<Scalars['JSON']['output']>;
  groupsLaunchedForReportingPeriod?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  launchedGroups?: Maybe<Scalars['Int']['output']>;
  reportingPeriod?: Maybe<ReportingPeriod>;
  subscriptionCancellationRequestedForReportingPeriod?: Maybe<Scalars['Int']['output']>;
  totalGroups?: Maybe<Scalars['Int']['output']>;
  totalSubscriptions?: Maybe<Scalars['Int']['output']>;
};

export type FgTrack = ScoNode & {
  __typename?: 'FGTrack';
  airtableRecordIdentifier?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  outline?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FgTrackCollection = {
  __typename?: 'FGTrackCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<FgTrack>>;
  pagination: Pagination;
};

export type FgJoinEventInput = {
  eventIdentifier: Scalars['String']['input'];
};

export type FgJoinEventPayload = {
  __typename?: 'FgJoinEventPayload';
  redirectTo?: Maybe<Scalars['String']['output']>;
};

export type Forum = {
  __typename?: 'Forum';
  allThreads?: Maybe<Array<Maybe<ScoThread>>>;
  comment?: Maybe<ScoComment>;
  comments?: Maybe<ScoCommentCollection>;
  id: Scalars['ID']['output'];
  thread?: Maybe<ScoThread>;
  threads?: Maybe<ScoThreadCollection>;
};


export type ForumCommentArgs = {
  commentId: Scalars['String']['input'];
};


export type ForumCommentsArgs = {
  afterCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  afterUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  beforeCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  beforeUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  longPollInSeconds?: InputMaybe<Scalars['Int']['input']>;
  maxFlags?: InputMaybe<Scalars['Int']['input']>;
  onlyMyDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPublicComments?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  spam?: InputMaybe<SpamFilter>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};


export type ForumThreadArgs = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  threadTypeKey?: InputMaybe<Scalars['String']['input']>;
};


export type ForumThreadsArgs = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  spam?: InputMaybe<Scalars['String']['input']>;
  threadTypeKey?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type FounderTrack = Entity & Node & {
  __typename?: 'FounderTrack';
  color?: Maybe<Color>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FounderTrack>;
  founderTrackSteps: Array<FounderTrackStep>;
  /** List of FounderTrack versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Intro text displayed when viewing a single track, above the Track Steps List. */
  introduction?: Maybe<RichText>;
  /** A URL to a video file, Vimeo, or Youtube. The link will be rendered with the appropriate embed code. */
  introductionVideoUrl?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** Summary text shown at the end of a Track, when viewing a single Track, below the Track Steps List. */
  summary?: Maybe<RichText>;
  /** Short (1-2 setence) summary of the track, appears in lists/cards showing multiple tracks. */
  teaser?: Maybe<RichText>;
  terms: Array<Term>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FounderTrackCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FounderTrackDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FounderTrackFounderTrackStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FounderTrackStepOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FounderTrackStepWhereInput>;
};


export type FounderTrackHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FounderTrackPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FounderTrackScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FounderTrackTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


export type FounderTrackUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FounderTrackConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FounderTrackWhereUniqueInput;
};

/** A connection to a list of items. */
export type FounderTrackConnection = {
  __typename?: 'FounderTrackConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FounderTrackEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FounderTrackCreateInput = {
  color?: InputMaybe<ColorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  founderTrackSteps?: InputMaybe<FounderTrackStepCreateManyInlineInput>;
  introduction?: InputMaybe<Scalars['RichTextAST']['input']>;
  introductionVideoUrl?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['RichTextAST']['input']>;
  teaser?: InputMaybe<Scalars['RichTextAST']['input']>;
  terms?: InputMaybe<TermCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FounderTrackCreateManyInlineInput = {
  /** Connect multiple existing FounderTrack documents */
  connect?: InputMaybe<Array<FounderTrackWhereUniqueInput>>;
  /** Create and connect multiple existing FounderTrack documents */
  create?: InputMaybe<Array<FounderTrackCreateInput>>;
};

export type FounderTrackCreateOneInlineInput = {
  /** Connect one existing FounderTrack document */
  connect?: InputMaybe<FounderTrackWhereUniqueInput>;
  /** Create and connect one FounderTrack document */
  create?: InputMaybe<FounderTrackCreateInput>;
};

/** An edge in a connection. */
export type FounderTrackEdge = {
  __typename?: 'FounderTrackEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FounderTrack;
};

/** Identifies documents */
export type FounderTrackManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FounderTrackWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FounderTrackWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FounderTrackWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FounderTrackWhereStageInput>;
  documentInStages_none?: InputMaybe<FounderTrackWhereStageInput>;
  documentInStages_some?: InputMaybe<FounderTrackWhereStageInput>;
  founderTrackSteps_every?: InputMaybe<FounderTrackStepWhereInput>;
  founderTrackSteps_none?: InputMaybe<FounderTrackStepWhereInput>;
  founderTrackSteps_some?: InputMaybe<FounderTrackStepWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introductionVideoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  introductionVideoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  introductionVideoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  introductionVideoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  introductionVideoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  introductionVideoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  introductionVideoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  introductionVideoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  introductionVideoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  introductionVideoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FounderTrackOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IntroductionVideoUrlAsc = 'introductionVideoUrl_ASC',
  IntroductionVideoUrlDesc = 'introductionVideoUrl_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type FounderTrackStep = Entity & Node & {
  __typename?: 'FounderTrackStep';
  color?: Maybe<Color>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FounderTrackStep>;
  founderTrack?: Maybe<FounderTrack>;
  founderTrackTasks: Array<FounderTrackTask>;
  /** List of FounderTrackStep versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  introduction?: Maybe<RichText>;
  nextStep?: Maybe<RichText>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  videoPlaybackEndInSeconds?: Maybe<Scalars['Int']['output']>;
  videoPlaybackStartInSeconds?: Maybe<Scalars['Int']['output']>;
  /** URL to video as supported by React-Player (i.e. Vimeo, YouTube, or browser-compatible media file like MP4). */
  videoUrl?: Maybe<Scalars['String']['output']>;
};


export type FounderTrackStepCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FounderTrackStepDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FounderTrackStepFounderTrackArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FounderTrackStepFounderTrackTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FounderTrackTaskOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FounderTrackTaskWhereInput>;
};


export type FounderTrackStepHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FounderTrackStepPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FounderTrackStepScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FounderTrackStepUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FounderTrackStepConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FounderTrackStepWhereUniqueInput;
};

/** A connection to a list of items. */
export type FounderTrackStepConnection = {
  __typename?: 'FounderTrackStepConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FounderTrackStepEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FounderTrackStepCreateInput = {
  color?: InputMaybe<ColorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  founderTrack?: InputMaybe<FounderTrackCreateOneInlineInput>;
  founderTrackTasks?: InputMaybe<FounderTrackTaskCreateManyInlineInput>;
  introduction?: InputMaybe<Scalars['RichTextAST']['input']>;
  nextStep?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoPlaybackEndInSeconds?: InputMaybe<Scalars['Int']['input']>;
  videoPlaybackStartInSeconds?: InputMaybe<Scalars['Int']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type FounderTrackStepCreateManyInlineInput = {
  /** Connect multiple existing FounderTrackStep documents */
  connect?: InputMaybe<Array<FounderTrackStepWhereUniqueInput>>;
  /** Create and connect multiple existing FounderTrackStep documents */
  create?: InputMaybe<Array<FounderTrackStepCreateInput>>;
};

export type FounderTrackStepCreateOneInlineInput = {
  /** Connect one existing FounderTrackStep document */
  connect?: InputMaybe<FounderTrackStepWhereUniqueInput>;
  /** Create and connect one FounderTrackStep document */
  create?: InputMaybe<FounderTrackStepCreateInput>;
};

/** An edge in a connection. */
export type FounderTrackStepEdge = {
  __typename?: 'FounderTrackStepEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FounderTrackStep;
};

/** Identifies documents */
export type FounderTrackStepManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FounderTrackStepWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FounderTrackStepWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FounderTrackStepWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FounderTrackStepWhereStageInput>;
  documentInStages_none?: InputMaybe<FounderTrackStepWhereStageInput>;
  documentInStages_some?: InputMaybe<FounderTrackStepWhereStageInput>;
  founderTrack?: InputMaybe<FounderTrackWhereInput>;
  founderTrackTasks_every?: InputMaybe<FounderTrackTaskWhereInput>;
  founderTrackTasks_none?: InputMaybe<FounderTrackTaskWhereInput>;
  founderTrackTasks_some?: InputMaybe<FounderTrackTaskWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoPlaybackEndInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  videoPlaybackEndInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  videoPlaybackEndInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  videoPlaybackEndInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  videoPlaybackEndInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  videoPlaybackEndInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  videoPlaybackEndInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  videoPlaybackEndInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  videoPlaybackStartInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  videoPlaybackStartInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  videoPlaybackStartInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  videoPlaybackStartInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  videoPlaybackStartInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  videoPlaybackStartInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  videoPlaybackStartInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  videoPlaybackStartInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum FounderTrackStepOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VideoPlaybackEndInSecondsAsc = 'videoPlaybackEndInSeconds_ASC',
  VideoPlaybackEndInSecondsDesc = 'videoPlaybackEndInSeconds_DESC',
  VideoPlaybackStartInSecondsAsc = 'videoPlaybackStartInSeconds_ASC',
  VideoPlaybackStartInSecondsDesc = 'videoPlaybackStartInSeconds_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type FounderTrackStepUpdateInput = {
  color?: InputMaybe<ColorInput>;
  founderTrack?: InputMaybe<FounderTrackUpdateOneInlineInput>;
  founderTrackTasks?: InputMaybe<FounderTrackTaskUpdateManyInlineInput>;
  introduction?: InputMaybe<Scalars['RichTextAST']['input']>;
  nextStep?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoPlaybackEndInSeconds?: InputMaybe<Scalars['Int']['input']>;
  videoPlaybackStartInSeconds?: InputMaybe<Scalars['Int']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type FounderTrackStepUpdateManyInlineInput = {
  /** Connect multiple existing FounderTrackStep documents */
  connect?: InputMaybe<Array<FounderTrackStepConnectInput>>;
  /** Create and connect multiple FounderTrackStep documents */
  create?: InputMaybe<Array<FounderTrackStepCreateInput>>;
  /** Delete multiple FounderTrackStep documents */
  delete?: InputMaybe<Array<FounderTrackStepWhereUniqueInput>>;
  /** Disconnect multiple FounderTrackStep documents */
  disconnect?: InputMaybe<Array<FounderTrackStepWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FounderTrackStep documents */
  set?: InputMaybe<Array<FounderTrackStepWhereUniqueInput>>;
  /** Update multiple FounderTrackStep documents */
  update?: InputMaybe<Array<FounderTrackStepUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FounderTrackStep documents */
  upsert?: InputMaybe<Array<FounderTrackStepUpsertWithNestedWhereUniqueInput>>;
};

export type FounderTrackStepUpdateManyInput = {
  color?: InputMaybe<ColorInput>;
  introduction?: InputMaybe<Scalars['RichTextAST']['input']>;
  nextStep?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoPlaybackEndInSeconds?: InputMaybe<Scalars['Int']['input']>;
  videoPlaybackStartInSeconds?: InputMaybe<Scalars['Int']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type FounderTrackStepUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FounderTrackStepUpdateManyInput;
  /** Document search */
  where: FounderTrackStepWhereInput;
};

export type FounderTrackStepUpdateOneInlineInput = {
  /** Connect existing FounderTrackStep document */
  connect?: InputMaybe<FounderTrackStepWhereUniqueInput>;
  /** Create and connect one FounderTrackStep document */
  create?: InputMaybe<FounderTrackStepCreateInput>;
  /** Delete currently connected FounderTrackStep document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FounderTrackStep document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FounderTrackStep document */
  update?: InputMaybe<FounderTrackStepUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FounderTrackStep document */
  upsert?: InputMaybe<FounderTrackStepUpsertWithNestedWhereUniqueInput>;
};

export type FounderTrackStepUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FounderTrackStepUpdateInput;
  /** Unique document search */
  where: FounderTrackStepWhereUniqueInput;
};

export type FounderTrackStepUpsertInput = {
  /** Create document if it didn't exist */
  create: FounderTrackStepCreateInput;
  /** Update document if it exists */
  update: FounderTrackStepUpdateInput;
};

export type FounderTrackStepUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FounderTrackStepUpsertInput;
  /** Unique document search */
  where: FounderTrackStepWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FounderTrackStepWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FounderTrackStepWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FounderTrackStepWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FounderTrackStepWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FounderTrackStepWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FounderTrackStepWhereStageInput>;
  documentInStages_none?: InputMaybe<FounderTrackStepWhereStageInput>;
  documentInStages_some?: InputMaybe<FounderTrackStepWhereStageInput>;
  founderTrack?: InputMaybe<FounderTrackWhereInput>;
  founderTrackTasks_every?: InputMaybe<FounderTrackTaskWhereInput>;
  founderTrackTasks_none?: InputMaybe<FounderTrackTaskWhereInput>;
  founderTrackTasks_some?: InputMaybe<FounderTrackTaskWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoPlaybackEndInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  videoPlaybackEndInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  videoPlaybackEndInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  videoPlaybackEndInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  videoPlaybackEndInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  videoPlaybackEndInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  videoPlaybackEndInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  videoPlaybackEndInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  videoPlaybackStartInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  videoPlaybackStartInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  videoPlaybackStartInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  videoPlaybackStartInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  videoPlaybackStartInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  videoPlaybackStartInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  videoPlaybackStartInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  videoPlaybackStartInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FounderTrackStepWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FounderTrackStepWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FounderTrackStepWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FounderTrackStepWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FounderTrackStepWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FounderTrackStep record uniquely */
export type FounderTrackStepWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FounderTrackTask = Entity & Node & {
  __typename?: 'FounderTrackTask';
  /** If enabled, then a textarea will be displayed + tracked on this task. */
  allowFounderResponse?: Maybe<Scalars['Boolean']['output']>;
  /** If enabled, a file-uploader will be shown on this task. */
  allowFounderUploads?: Maybe<Scalars['Boolean']['output']>;
  body?: Maybe<FounderTrackTaskBodyRichText>;
  color?: Maybe<Color>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<FounderTrackTask>;
  founderTrackStep?: Maybe<FounderTrackStep>;
  /** List of FounderTrackTask versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** The question/prompt to which the Founder should respond. Use with the response/uploads checkboxes. */
  responsePrompt?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** A URL to a video file, Vimeo, or Youtube. If provided it will render below the Task Body as the appropriate embed code. */
  videoUrl?: Maybe<Scalars['String']['output']>;
};


export type FounderTrackTaskCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FounderTrackTaskDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FounderTrackTaskFounderTrackStepArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FounderTrackTaskHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FounderTrackTaskPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FounderTrackTaskScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FounderTrackTaskUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FounderTrackTaskBodyRichText = {
  __typename?: 'FounderTrackTaskBodyRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<FounderTrackTaskBodyRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type FounderTrackTaskBodyRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type FounderTrackTaskBodyRichTextEmbeddedTypes = Article | Benefit | FounderTrack | Playlist | PodcastEpisode | VideoCourse | VideoLesson | VideoPlaylist;

export type FounderTrackTaskConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FounderTrackTaskWhereUniqueInput;
};

/** A connection to a list of items. */
export type FounderTrackTaskConnection = {
  __typename?: 'FounderTrackTaskConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FounderTrackTaskEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FounderTrackTaskCreateInput = {
  allowFounderResponse?: InputMaybe<Scalars['Boolean']['input']>;
  allowFounderUploads?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  color?: InputMaybe<ColorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  founderTrackStep?: InputMaybe<FounderTrackStepCreateOneInlineInput>;
  responsePrompt?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type FounderTrackTaskCreateManyInlineInput = {
  /** Connect multiple existing FounderTrackTask documents */
  connect?: InputMaybe<Array<FounderTrackTaskWhereUniqueInput>>;
  /** Create and connect multiple existing FounderTrackTask documents */
  create?: InputMaybe<Array<FounderTrackTaskCreateInput>>;
};

export type FounderTrackTaskCreateOneInlineInput = {
  /** Connect one existing FounderTrackTask document */
  connect?: InputMaybe<FounderTrackTaskWhereUniqueInput>;
  /** Create and connect one FounderTrackTask document */
  create?: InputMaybe<FounderTrackTaskCreateInput>;
};

/** An edge in a connection. */
export type FounderTrackTaskEdge = {
  __typename?: 'FounderTrackTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FounderTrackTask;
};

/** Identifies documents */
export type FounderTrackTaskManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FounderTrackTaskWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FounderTrackTaskWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FounderTrackTaskWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  allowFounderResponse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  allowFounderResponse_not?: InputMaybe<Scalars['Boolean']['input']>;
  allowFounderUploads?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  allowFounderUploads_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<FounderTrackTaskWhereStageInput>;
  documentInStages_none?: InputMaybe<FounderTrackTaskWhereStageInput>;
  documentInStages_some?: InputMaybe<FounderTrackTaskWhereStageInput>;
  founderTrackStep?: InputMaybe<FounderTrackStepWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  responsePrompt?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  responsePrompt_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  responsePrompt_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  responsePrompt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  responsePrompt_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  responsePrompt_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  responsePrompt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  responsePrompt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  responsePrompt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  responsePrompt_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum FounderTrackTaskOrderByInput {
  AllowFounderResponseAsc = 'allowFounderResponse_ASC',
  AllowFounderResponseDesc = 'allowFounderResponse_DESC',
  AllowFounderUploadsAsc = 'allowFounderUploads_ASC',
  AllowFounderUploadsDesc = 'allowFounderUploads_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  CtaUrlAsc = 'ctaUrl_ASC',
  CtaUrlDesc = 'ctaUrl_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ResponsePromptAsc = 'responsePrompt_ASC',
  ResponsePromptDesc = 'responsePrompt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type FounderTrackTaskUpdateInput = {
  allowFounderResponse?: InputMaybe<Scalars['Boolean']['input']>;
  allowFounderUploads?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  color?: InputMaybe<ColorInput>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  founderTrackStep?: InputMaybe<FounderTrackStepUpdateOneInlineInput>;
  responsePrompt?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type FounderTrackTaskUpdateManyInlineInput = {
  /** Connect multiple existing FounderTrackTask documents */
  connect?: InputMaybe<Array<FounderTrackTaskConnectInput>>;
  /** Create and connect multiple FounderTrackTask documents */
  create?: InputMaybe<Array<FounderTrackTaskCreateInput>>;
  /** Delete multiple FounderTrackTask documents */
  delete?: InputMaybe<Array<FounderTrackTaskWhereUniqueInput>>;
  /** Disconnect multiple FounderTrackTask documents */
  disconnect?: InputMaybe<Array<FounderTrackTaskWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FounderTrackTask documents */
  set?: InputMaybe<Array<FounderTrackTaskWhereUniqueInput>>;
  /** Update multiple FounderTrackTask documents */
  update?: InputMaybe<Array<FounderTrackTaskUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FounderTrackTask documents */
  upsert?: InputMaybe<Array<FounderTrackTaskUpsertWithNestedWhereUniqueInput>>;
};

export type FounderTrackTaskUpdateManyInput = {
  allowFounderResponse?: InputMaybe<Scalars['Boolean']['input']>;
  allowFounderUploads?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  color?: InputMaybe<ColorInput>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  responsePrompt?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type FounderTrackTaskUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FounderTrackTaskUpdateManyInput;
  /** Document search */
  where: FounderTrackTaskWhereInput;
};

export type FounderTrackTaskUpdateOneInlineInput = {
  /** Connect existing FounderTrackTask document */
  connect?: InputMaybe<FounderTrackTaskWhereUniqueInput>;
  /** Create and connect one FounderTrackTask document */
  create?: InputMaybe<FounderTrackTaskCreateInput>;
  /** Delete currently connected FounderTrackTask document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FounderTrackTask document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FounderTrackTask document */
  update?: InputMaybe<FounderTrackTaskUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FounderTrackTask document */
  upsert?: InputMaybe<FounderTrackTaskUpsertWithNestedWhereUniqueInput>;
};

export type FounderTrackTaskUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FounderTrackTaskUpdateInput;
  /** Unique document search */
  where: FounderTrackTaskWhereUniqueInput;
};

export type FounderTrackTaskUpsertInput = {
  /** Create document if it didn't exist */
  create: FounderTrackTaskCreateInput;
  /** Update document if it exists */
  update: FounderTrackTaskUpdateInput;
};

export type FounderTrackTaskUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FounderTrackTaskUpsertInput;
  /** Unique document search */
  where: FounderTrackTaskWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FounderTrackTaskWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FounderTrackTaskWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FounderTrackTaskWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FounderTrackTaskWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FounderTrackTaskWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  allowFounderResponse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  allowFounderResponse_not?: InputMaybe<Scalars['Boolean']['input']>;
  allowFounderUploads?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  allowFounderUploads_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ctaUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ctaUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ctaUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ctaUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<FounderTrackTaskWhereStageInput>;
  documentInStages_none?: InputMaybe<FounderTrackTaskWhereStageInput>;
  documentInStages_some?: InputMaybe<FounderTrackTaskWhereStageInput>;
  founderTrackStep?: InputMaybe<FounderTrackStepWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  responsePrompt?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  responsePrompt_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  responsePrompt_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  responsePrompt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  responsePrompt_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  responsePrompt_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  responsePrompt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  responsePrompt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  responsePrompt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  responsePrompt_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FounderTrackTaskWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FounderTrackTaskWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FounderTrackTaskWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FounderTrackTaskWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FounderTrackTaskWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FounderTrackTask record uniquely */
export type FounderTrackTaskWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FounderTrackUpdateInput = {
  color?: InputMaybe<ColorInput>;
  founderTrackSteps?: InputMaybe<FounderTrackStepUpdateManyInlineInput>;
  introduction?: InputMaybe<Scalars['RichTextAST']['input']>;
  introductionVideoUrl?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['RichTextAST']['input']>;
  teaser?: InputMaybe<Scalars['RichTextAST']['input']>;
  terms?: InputMaybe<TermUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FounderTrackUpdateManyInlineInput = {
  /** Connect multiple existing FounderTrack documents */
  connect?: InputMaybe<Array<FounderTrackConnectInput>>;
  /** Create and connect multiple FounderTrack documents */
  create?: InputMaybe<Array<FounderTrackCreateInput>>;
  /** Delete multiple FounderTrack documents */
  delete?: InputMaybe<Array<FounderTrackWhereUniqueInput>>;
  /** Disconnect multiple FounderTrack documents */
  disconnect?: InputMaybe<Array<FounderTrackWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FounderTrack documents */
  set?: InputMaybe<Array<FounderTrackWhereUniqueInput>>;
  /** Update multiple FounderTrack documents */
  update?: InputMaybe<Array<FounderTrackUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FounderTrack documents */
  upsert?: InputMaybe<Array<FounderTrackUpsertWithNestedWhereUniqueInput>>;
};

export type FounderTrackUpdateManyInput = {
  color?: InputMaybe<ColorInput>;
  introduction?: InputMaybe<Scalars['RichTextAST']['input']>;
  introductionVideoUrl?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['RichTextAST']['input']>;
  teaser?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FounderTrackUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FounderTrackUpdateManyInput;
  /** Document search */
  where: FounderTrackWhereInput;
};

export type FounderTrackUpdateOneInlineInput = {
  /** Connect existing FounderTrack document */
  connect?: InputMaybe<FounderTrackWhereUniqueInput>;
  /** Create and connect one FounderTrack document */
  create?: InputMaybe<FounderTrackCreateInput>;
  /** Delete currently connected FounderTrack document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FounderTrack document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FounderTrack document */
  update?: InputMaybe<FounderTrackUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FounderTrack document */
  upsert?: InputMaybe<FounderTrackUpsertWithNestedWhereUniqueInput>;
};

export type FounderTrackUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FounderTrackUpdateInput;
  /** Unique document search */
  where: FounderTrackWhereUniqueInput;
};

export type FounderTrackUpsertInput = {
  /** Create document if it didn't exist */
  create: FounderTrackCreateInput;
  /** Update document if it exists */
  update: FounderTrackUpdateInput;
};

export type FounderTrackUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FounderTrackUpsertInput;
  /** Unique document search */
  where: FounderTrackWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FounderTrackWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FounderTrackWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FounderTrackWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FounderTrackWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FounderTrackWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FounderTrackWhereStageInput>;
  documentInStages_none?: InputMaybe<FounderTrackWhereStageInput>;
  documentInStages_some?: InputMaybe<FounderTrackWhereStageInput>;
  founderTrackSteps_every?: InputMaybe<FounderTrackStepWhereInput>;
  founderTrackSteps_none?: InputMaybe<FounderTrackStepWhereInput>;
  founderTrackSteps_some?: InputMaybe<FounderTrackStepWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introductionVideoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  introductionVideoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  introductionVideoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  introductionVideoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  introductionVideoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  introductionVideoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  introductionVideoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  introductionVideoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  introductionVideoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  introductionVideoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FounderTrackWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FounderTrackWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FounderTrackWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FounderTrackWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FounderTrackWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FounderTrack record uniquely */
export type FounderTrackWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type FundingProfile = ScoNode & {
  __typename?: 'FundingProfile';
  description?: Maybe<Scalars['String']['output']>;
  goalAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  raiseAmount?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GenerateCrmReplyInput = {
  accountUserId: Scalars['String']['input'];
  includeFiles?: InputMaybe<Scalars['Boolean']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  scope: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
  toolId?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateCrmReplyPayload = {
  __typename?: 'GenerateCrmReplyPayload';
  body?: Maybe<Scalars['String']['output']>;
};

/** A group of users */
export type Group = ScoNode & {
  __typename?: 'Group';
  appLabel?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  commitmentLabel?: Maybe<Scalars['String']['output']>;
  commitments?: Maybe<GroupCommitmentCollection>;
  createdByUser?: Maybe<ScoUser>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  events?: Maybe<GroupEventCollection>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCurrentUserAdmin?: Maybe<Scalars['Boolean']['output']>;
  isCurrentUserMember?: Maybe<Scalars['Boolean']['output']>;
  isCurrentUserModerator?: Maybe<Scalars['Boolean']['output']>;
  launchedAt?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  memberUsers?: Maybe<ScoUserCollection>;
  members?: Maybe<GroupMemberCollection>;
  moderators?: Maybe<GroupMemberCollection>;
  nextEvent?: Maybe<GroupEvent>;
  notifications?: Maybe<ScoNotificationCollection>;
  requestLabel?: Maybe<Scalars['String']['output']>;
  requests?: Maybe<GroupRequestCollection>;
  requiredProduct?: Maybe<ScoProduct>;
  requiredProductId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<GroupStatus>;
  threads?: Maybe<ScoThreadCollection>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** A group of users */
export type GroupCommitmentsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  filter?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


/** A group of users */
export type GroupEventsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  filter?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A group of users */
export type GroupMemberUsersArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A group of users */
export type GroupMembersArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A group of users */
export type GroupModeratorsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A group of users */
export type GroupNotificationsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A group of users */
export type GroupRequestsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  filter?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


/** A group of users */
export type GroupThreadsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupCandidate = ScoNode & {
  __typename?: 'GroupCandidate';
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  group?: Maybe<Group>;
  groupCandidateId?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  groupMember?: Maybe<Group>;
  groupMemberId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  product?: Maybe<ScoProduct>;
  productId?: Maybe<Scalars['String']['output']>;
  quality?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<ScoThread>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
};

export type GroupCandidateCollection = {
  __typename?: 'GroupCandidateCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<GroupCandidate>>;
  pagination: Pagination;
};

export type GroupCollection = {
  __typename?: 'GroupCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<Group>>;
  pagination: Pagination;
};

export type GroupCommitment = ScoNode & {
  __typename?: 'GroupCommitment';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  acceptedNotes?: Maybe<Scalars['String']['output']>;
  bodyAsMarkdown?: Maybe<Scalars['String']['output']>;
  committingCompany?: Maybe<ScoCompany>;
  committingCompanyId?: Maybe<Scalars['String']['output']>;
  committingUser?: Maybe<ScoUser>;
  committingUserId?: Maybe<Scalars['String']['output']>;
  compensationNotes?: Maybe<Scalars['String']['output']>;
  compensationTypeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  compensationTypes?: Maybe<Array<Maybe<ScoStaticOption>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fulfilledAt?: Maybe<Scalars['DateTime']['output']>;
  fulfillmentNotes?: Maybe<Scalars['String']['output']>;
  groupCommitmentId?: Maybe<Scalars['String']['output']>;
  groupRequest?: Maybe<GroupRequest>;
  groupRequestId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionNotes?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  timeCommitmentNotes?: Maybe<Scalars['String']['output']>;
  timeCommitmentTypeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timeCommitmentTypes?: Maybe<Array<Maybe<ScoStaticOption>>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GroupCommitmentCollection = {
  __typename?: 'GroupCommitmentCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<GroupCommitment>>;
  pagination: Pagination;
};

export type GroupCommunity = ScoNode & {
  __typename?: 'GroupCommunity';
  description?: Maybe<Scalars['String']['output']>;
  groupCommunityId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  moderator1Name?: Maybe<Scalars['String']['output']>;
  moderator1PhotoUrl?: Maybe<Scalars['String']['output']>;
  moderator1Tagline?: Maybe<Scalars['String']['output']>;
  moderator2Name?: Maybe<Scalars['String']['output']>;
  moderator2PhotoUrl?: Maybe<Scalars['String']['output']>;
  moderator2Tagline?: Maybe<Scalars['String']['output']>;
  slackChannelName?: Maybe<Scalars['String']['output']>;
  slackChannelUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GroupEvent = ScoNode & {
  __typename?: 'GroupEvent';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  attendanceCount?: Maybe<Scalars['Int']['output']>;
  attendances?: Maybe<GroupEventAttendanceCollection>;
  attendingUsers?: Maybe<ScoUserCollection>;
  callUrl?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  currentUserAttendances?: Maybe<Array<Maybe<GroupEventAttendance>>>;
  description?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  eventAirtableRecordIdentifier?: Maybe<Scalars['String']['output']>;
  featuredImageUrl?: Maybe<Scalars['String']['output']>;
  featuredVideoUrl?: Maybe<Scalars['String']['output']>;
  googleCalendarEventId?: Maybe<Scalars['String']['output']>;
  googleCalendarHtmlLink?: Maybe<Scalars['String']['output']>;
  googleCalendarId?: Maybe<Scalars['String']['output']>;
  googleCalendarSyncError?: Maybe<Scalars['String']['output']>;
  googleCalendarSyncStatus?: Maybe<Scalars['String']['output']>;
  googleCalendarSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  group?: Maybe<Group>;
  groupEventId?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  hosts?: Maybe<Array<Maybe<GroupEventHost>>>;
  id: Scalars['ID']['output'];
  isAirtableManaged?: Maybe<Scalars['Boolean']['output']>;
  isCurrentUserAttending?: Maybe<Scalars['Boolean']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  isFree?: Maybe<Scalars['Boolean']['output']>;
  isFutureEvent?: Maybe<Scalars['Boolean']['output']>;
  isPremium?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  maximumAttendeeLimit?: Maybe<Scalars['Int']['output']>;
  maximumAttendeesRemaining?: Maybe<Scalars['Int']['output']>;
  memberReviews?: Maybe<GroupMemberReviewCollection>;
  postalCode?: Maybe<Scalars['String']['output']>;
  schedulingUrl?: Maybe<Scalars['String']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suggestedTimesAsJSON?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<ScoThread>;
  title?: Maybe<Scalars['String']['output']>;
  topicKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  topics?: Maybe<Array<Maybe<GroupTopic>>>;
  type?: Maybe<GroupEventType>;
  typeKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type GroupEventAttendancesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GroupEventAttendingUsersArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GroupEventMemberReviewsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupEventAttendance = ScoNode & {
  __typename?: 'GroupEventAttendance';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  attendeeNote?: Maybe<Scalars['String']['output']>;
  attendingUser?: Maybe<ScoUser>;
  attendingUserId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  declinedAt?: Maybe<Scalars['DateTime']['output']>;
  didAttend?: Maybe<Scalars['Boolean']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  googleCalendarAttendeeEmail?: Maybe<Scalars['String']['output']>;
  googleCalendarInviteSentAt?: Maybe<Scalars['DateTime']['output']>;
  groupEvent?: Maybe<GroupEvent>;
  groupEventAttendanceId?: Maybe<Scalars['String']['output']>;
  groupEventId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  thread?: Maybe<ScoThread>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GroupEventAttendanceCollection = {
  __typename?: 'GroupEventAttendanceCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<GroupEventAttendance>>;
  pagination: Pagination;
};

export type GroupEventCollection = {
  __typename?: 'GroupEventCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<GroupEvent>>;
  pagination: Pagination;
};

export type GroupEventHost = ScoNode & {
  __typename?: 'GroupEventHost';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groupEvent?: Maybe<GroupEvent>;
  groupEventHostId?: Maybe<Scalars['String']['output']>;
  groupEventId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GroupEventHostInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GroupEventInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  callUrl?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  groupId: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

/** The type of a group event, ex: meeting, workshop, etc. */
export type GroupEventType = ScoNode & {
  __typename?: 'GroupEventType';
  colorHexCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupEventTypeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GroupGoal = ScoNode & {
  __typename?: 'GroupGoal';
  assignedToUser?: Maybe<ScoUser>;
  assignedToUserId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  groupGoalId?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  thread?: Maybe<ScoThread>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GroupInteractionType = ScoNode & {
  __typename?: 'GroupInteractionType';
  children?: Maybe<Array<Maybe<GroupInteractionType>>>;
  colorHexCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupInteractionId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GroupMember = ScoNode & {
  __typename?: 'GroupMember';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['String']['output']>;
  groupMemberId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isModerator?: Maybe<Scalars['Boolean']['output']>;
  thread?: Maybe<ScoThread>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GroupMemberCollection = {
  __typename?: 'GroupMemberCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<GroupMember>>;
  pagination: Pagination;
};

export type GroupMemberReview = ScoNode & {
  __typename?: 'GroupMemberReview';
  groupId?: Maybe<Scalars['String']['output']>;
  groupMemberReviewId?: Maybe<Scalars['String']['output']>;
  iHelped?: Maybe<Scalars['Int']['output']>;
  iListened?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  othersHelped?: Maybe<Scalars['Int']['output']>;
  othersListened?: Maybe<Scalars['Int']['output']>;
  reviewSubjectId?: Maybe<Scalars['String']['output']>;
  reviewSubjectType?: Maybe<Scalars['String']['output']>;
  reviewedByUser?: Maybe<ScoUser>;
  score?: Maybe<Scalars['Int']['output']>;
};

export type GroupMemberReviewCollection = {
  __typename?: 'GroupMemberReviewCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<GroupMemberReview>>;
  pagination: Pagination;
};

export type GroupNotification = ScoNode & {
  __typename?: 'GroupNotification';
  actingUser?: Maybe<ScoUser>;
  /** optional comma-delimited list of user ids for grouped notifications */
  actingUserIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  actionAt?: Maybe<Scalars['DateTime']['output']>;
  attachment?: Maybe<GroupNotificationAttachment>;
  attachmentAction?: Maybe<Scalars['String']['output']>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentOwnerUserId?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<ScoComment>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  formattedMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  like?: Maybe<ScoLike>;
  message?: Maybe<Scalars['String']['output']>;
  notifiable?: Maybe<ScoAttachment>;
  notifiableAction?: Maybe<Scalars['String']['output']>;
  notifiableId?: Maybe<Scalars['String']['output']>;
  notifiableType?: Maybe<Scalars['String']['output']>;
  notificationId?: Maybe<Scalars['String']['output']>;
  notificationIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  receivingUser?: Maybe<ScoUser>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GroupNotificationAttachment = ScoNode & {
  __typename?: 'GroupNotificationAttachment';
  abridgedBody?: Maybe<Scalars['String']['output']>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  categorySlug?: Maybe<Scalars['String']['output']>;
  categoryUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featuredImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GroupNotificationCollection = {
  __typename?: 'GroupNotificationCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<GroupNotification>>;
  pagination: Pagination;
};

export type GroupOfficeHourSession = ScoNode & {
  __typename?: 'GroupOfficeHourSession';
  description?: Maybe<Scalars['String']['output']>;
  groupOfficeHourSessionId?: Maybe<Scalars['String']['output']>;
  hostName?: Maybe<Scalars['String']['output']>;
  hostPhotoUrl?: Maybe<Scalars['String']['output']>;
  hostTagline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rsvpNotes?: Maybe<Scalars['String']['output']>;
  rsvpUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GroupPost = ScoNode & {
  __typename?: 'GroupPost';
  attachment?: Maybe<ScoAttachment>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  authorUser?: Maybe<ScoUser>;
  authorUserId?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  canUserDelete?: Maybe<Scalars['Boolean']['output']>;
  canUserEdit?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<ScoUser>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  featuredAt?: Maybe<Scalars['DateTime']['output']>;
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['String']['output']>;
  groupPostId?: Maybe<Scalars['String']['output']>;
  groupPostType?: Maybe<GroupPostType>;
  groupPostTypeKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  thread?: Maybe<ScoThread>;
  title?: Maybe<Scalars['String']['output']>;
  topicKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  topics?: Maybe<Array<Maybe<GroupTopic>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GroupPostCollection = {
  __typename?: 'GroupPostCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<GroupPost>>;
  pagination: Pagination;
};

export type GroupPostType = ScoNode & {
  __typename?: 'GroupPostType';
  colorHexCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupPostTypeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** A preview of Founder Group */
export type GroupPreview = ScoNode & {
  __typename?: 'GroupPreview';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  requiredProductId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<GroupStatus>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GroupRequest = ScoNode & {
  __typename?: 'GroupRequest';
  bodyAsMarkdown?: Maybe<Scalars['String']['output']>;
  bodyIsGenerated?: Maybe<Scalars['Boolean']['output']>;
  bodyPrompt?: Maybe<Scalars['String']['output']>;
  bodyPromptAdditionalItems?: Maybe<Scalars['String']['output']>;
  bodyPromptToneKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  canUserEdit?: Maybe<Scalars['Boolean']['output']>;
  compensationNotes?: Maybe<Scalars['String']['output']>;
  compensationTypeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  compensationTypes?: Maybe<Array<Maybe<ScoStaticOption>>>;
  compensationUnit?: Maybe<Scalars['String']['output']>;
  compensationValue?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentUserGroupCommitment?: Maybe<GroupCommitment>;
  currentUserOpenSeatMatch?: Maybe<ScoUserMatch>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directChatThreads?: Maybe<ScoThreadCollection>;
  displayBodyAsMarkdown?: Maybe<Scalars['String']['output']>;
  displayTitle?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  featuredAt?: Maybe<Scalars['DateTime']['output']>;
  fulfilledAt?: Maybe<Scalars['DateTime']['output']>;
  fulfillmentStatus?: Maybe<ScoStaticOption>;
  fulfillmentStatusKey?: Maybe<Scalars['String']['output']>;
  generatedBodyAsMarkdown?: Maybe<Scalars['String']['output']>;
  generatedTitle?: Maybe<Scalars['String']['output']>;
  groupCommitments?: Maybe<GroupCommitmentCollection>;
  groupRequestId?: Maybe<Scalars['String']['output']>;
  groupRequestType?: Maybe<ScoStaticOption>;
  groupRequestTypeKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  investorIndustryTagTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  investorSearch?: Maybe<ScoInvestorSearch>;
  investorSearchId?: Maybe<Scalars['String']['output']>;
  investorVerticalTagTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isOpenToRemoteLocation?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountryKey?: Maybe<Scalars['String']['output']>;
  locationLatitude?: Maybe<Scalars['Float']['output']>;
  locationLongitude?: Maybe<Scalars['Float']['output']>;
  locationPostalCode?: Maybe<Scalars['String']['output']>;
  locationRadiusInMiles?: Maybe<Scalars['Int']['output']>;
  locationState?: Maybe<Scalars['String']['output']>;
  naturalLanguagePrompt?: Maybe<Scalars['String']['output']>;
  needExplanation?: Maybe<Scalars['String']['output']>;
  pitchDeck?: Maybe<ScoPitchDeck>;
  pitchDeckId?: Maybe<Scalars['String']['output']>;
  publicCommentThread?: Maybe<ScoThread>;
  publishApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  publishDeniedAt?: Maybe<Scalars['DateTime']['output']>;
  publishDeniedNotes?: Maybe<Scalars['String']['output']>;
  publishRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  publishRequestedNotes?: Maybe<Scalars['String']['output']>;
  publishStatus?: Maybe<ScoStaticOption>;
  publishStatusKey?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  requestAdvisorToolSession?: Maybe<ScoToolSession>;
  requestingCompany?: Maybe<ScoCompany>;
  requestingCompanyId?: Maybe<Scalars['String']['output']>;
  requestingUser?: Maybe<ScoUser>;
  requestingUserId?: Maybe<Scalars['String']['output']>;
  skillTagTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  storedFiles?: Maybe<ScoStoredFileCollection>;
  tagAttachments?: Maybe<Array<Maybe<ScoTagAttachment>>>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tagTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<ScoTag>>>;
  tasks?: Maybe<ScoTaskCollection>;
  timeCommitmentNotes?: Maybe<Scalars['String']['output']>;
  timeCommitmentTypeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timeCommitmentTypes?: Maybe<Array<Maybe<ScoStaticOption>>>;
  timeCommitmentUnit?: Maybe<Scalars['String']['output']>;
  timeCommitmentValue?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  topicKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userSearch?: Maybe<ScoUserSearch>;
  userSearchId?: Maybe<Scalars['String']['output']>;
  valueToRequester?: Maybe<Scalars['String']['output']>;
  valueToResponder?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<ScoStaticOption>;
  visibilityKey?: Maybe<Scalars['String']['output']>;
  wilAiToolSession?: Maybe<ScoToolSession>;
};


export type GroupRequestDirectChatThreadsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GroupRequestGroupCommitmentsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GroupRequestStoredFilesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GroupRequestTasksArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupRequestCollection = {
  __typename?: 'GroupRequestCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<GroupRequest>>;
  pagination: Pagination;
};

export type GroupRequestType = ScoNode & {
  __typename?: 'GroupRequestType';
  colorHexCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupRequestTypeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum GroupStatus {
  Active = 'ACTIVE',
  ComingSoon = 'COMING_SOON',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export type GroupTopic = ScoNode & {
  __typename?: 'GroupTopic';
  colorHexCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupTopicId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GroupTrackStatus = ScoNode & {
  __typename?: 'GroupTrackStatus';
  attachmentUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attachmentUrlsAsJSON?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  groupTrackStatusId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  response?: Maybe<Scalars['String']['output']>;
  trackSlug?: Maybe<Scalars['String']['output']>;
  trackStepIdentifier?: Maybe<Scalars['String']['output']>;
  trackTaskIdentifier?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ScoUser>;
};

export type GroupWorkshop = ScoNode & {
  __typename?: 'GroupWorkshop';
  activityType?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  callUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detailsUrl?: Maybe<Scalars['String']['output']>;
  detailsUrlWithPrefill?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  groupWorkshopId?: Maybe<Scalars['String']['output']>;
  host1Name?: Maybe<Scalars['String']['output']>;
  host1PhotoUrl?: Maybe<Scalars['String']['output']>;
  host1Tagline?: Maybe<Scalars['String']['output']>;
  host2Name?: Maybe<Scalars['String']['output']>;
  host2PhotoUrl?: Maybe<Scalars['String']['output']>;
  host2Tagline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  relatedGroupEvent?: Maybe<GroupEvent>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HandoffCrmThreadToSupportInput = {
  accountUserId?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
};

export type HandoffCrmThreadToSupportPayload = {
  __typename?: 'HandoffCrmThreadToSupportPayload';
  handedOff?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  supportTicketId?: Maybe<Scalars['String']['output']>;
};

export type HelloWorldSubscriptionPayload = {
  __typename?: 'HelloWorldSubscriptionPayload';
  currentUser?: Maybe<ScoUser>;
  message?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ImageBlurInput = {
  /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Adds a border to the image. */
export type ImageBorderInput = {
  /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  background: Scalars['String']['input'];
  /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  color: Scalars['String']['input'];
  /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
  width: Scalars['Int']['input'];
};

export type ImageCompressInput = {
  /** Preserves the metadata of the image. */
  metadata: Scalars['Boolean']['input'];
};

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height: Scalars['Int']['input'];
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width: Scalars['Int']['input'];
  /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
  x: Scalars['Int']['input'];
  /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
  y: Scalars['Int']['input'];
};

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  Clip = 'clip',
  /**
   * Resizes the image to fit the specified parameters exactly by removing any
   * parts of the image that don't fit within the boundaries.
   */
  Crop = 'crop',
  /**
   * Resizes the image to fit within the parameters, but as opposed to 'fit:clip'
   * will not scale the image if the image is smaller than the output size.
   */
  Max = 'max',
  /**
   * Resizes the image to fit the specified parameters exactly by scaling the image
   * to the desired size. The aspect ratio of the image is not respected and the
   * image can be distorted using this method.
   */
  Scale = 'scale'
}

export type ImageQualityInput = {
  /** The quality of the image. The value must be an integer from 1 to 100. */
  value: Scalars['Int']['input'];
};

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageSharpenInput = {
  /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Blurs the image. */
  blur?: InputMaybe<ImageBlurInput>;
  /** Adds a border to the image. */
  border?: InputMaybe<ImageBorderInput>;
  /** Compresses the image. */
  compress?: InputMaybe<ImageCompressInput>;
  /** Crops the image to the specified dimensions. */
  crop?: InputMaybe<ImageCropInput>;
  /**
   * Changes the quality of the image. The value must be an integer from 1 to 100.
   * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
   */
  quality?: InputMaybe<ImageQualityInput>;
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
  /** Sharpens the image. */
  sharpen?: InputMaybe<ImageSharpenInput>;
};

export type InitiateBizplanConnectionInput = {
  email: Scalars['String']['input'];
};

export type InitiateBizplanConnectionPayload = {
  __typename?: 'InitiateBizplanConnectionPayload';
  email?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type InitiateLaunchrockConnectionInput = {
  email: Scalars['String']['input'];
};

export type InitiateLaunchrockConnectionPayload = {
  __typename?: 'InitiateLaunchrockConnectionPayload';
  email?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type InviteAdvisorToBoardInput = {
  advisorEmail?: InputMaybe<Scalars['String']['input']>;
  advisorEngagementId?: InputMaybe<Scalars['String']['input']>;
  advisorName?: InputMaybe<Scalars['String']['input']>;
  advisorUserId?: InputMaybe<Scalars['String']['input']>;
  categoryKey?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type InviteAdvisorToBoardPayload = {
  __typename?: 'InviteAdvisorToBoardPayload';
  advisorEngagement?: Maybe<ScoAdvisorEngagement>;
};

export type JoinGroupInput = {
  groupSlug: Scalars['String']['input'];
};

export type JoinGroupPayload = {
  __typename?: 'JoinGroupPayload';
  groupMember?: Maybe<GroupMember>;
};

export type LaunchFgProfileInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type LaunchFgProfilePayload = {
  __typename?: 'LaunchFGProfilePayload';
  user?: Maybe<ScoUser>;
};

export type LaunchProfile = ScoNode & {
  __typename?: 'LaunchProfile';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LaunchStats = ScoNode & {
  __typename?: 'LaunchStats';
  id: Scalars['ID']['output'];
  totalCustomers?: Maybe<Scalars['Int']['output']>;
  totalSites?: Maybe<Scalars['Int']['output']>;
};

export type LegacyProductCoupon = {
  __typename?: 'LegacyProductCoupon';
  code?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  isPrepaid?: Maybe<Scalars['Boolean']['output']>;
  productIds: Array<Maybe<Scalars['String']['output']>>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  terms?: Maybe<LegacyProductCouponTerms>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LegacyProductCouponTerms = {
  __typename?: 'LegacyProductCouponTerms';
  recurringDiscountAmount?: Maybe<Scalars['Float']['output']>;
  recurringDiscountPercent?: Maybe<Scalars['Float']['output']>;
  signupDiscountAmount?: Maybe<Scalars['Float']['output']>;
  signupDiscountPercent?: Maybe<Scalars['Float']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

export type LegacyProductFeature = {
  __typename?: 'LegacyProductFeature';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LegacyProductPricing = {
  __typename?: 'LegacyProductPricing';
  id: Scalars['ID']['output'];
  recurring: Scalars['Float']['output'];
  signup: Scalars['Float']['output'];
};

export type LegacyProductTerm = {
  __typename?: 'LegacyProductTerm';
  abbreviation?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  termId?: Maybe<Scalars['String']['output']>;
};

export type Link = Entity & Node & {
  __typename?: 'Link';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<Link>;
  /** List of Link versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  url?: Maybe<Scalars['String']['output']>;
  videoLessons: Array<VideoLesson>;
};


export type LinkCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type LinkHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type LinkPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type LinkUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkVideoLessonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoLessonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoLessonWhereInput>;
};

export type LinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type LinkConnection = {
  __typename?: 'LinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LinkCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  newWindow?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  videoLessons?: InputMaybe<VideoLessonCreateManyInlineInput>;
};

export type LinkCreateManyInlineInput = {
  /** Connect multiple existing Link documents */
  connect?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Create and connect multiple existing Link documents */
  create?: InputMaybe<Array<LinkCreateInput>>;
};

export type LinkCreateOneInlineInput = {
  /** Connect one existing Link document */
  connect?: InputMaybe<LinkWhereUniqueInput>;
  /** Create and connect one Link document */
  create?: InputMaybe<LinkCreateInput>;
};

/** An edge in a connection. */
export type LinkEdge = {
  __typename?: 'LinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Link;
};

/** Identifies documents */
export type LinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<LinkWhereStageInput>;
  documentInStages_none?: InputMaybe<LinkWhereStageInput>;
  documentInStages_some?: InputMaybe<LinkWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  newWindow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  newWindow_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoLessons_every?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_none?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_some?: InputMaybe<VideoLessonWhereInput>;
};

export enum LinkOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NewWindowAsc = 'newWindow_ASC',
  NewWindowDesc = 'newWindow_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type LinkUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  newWindow?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  videoLessons?: InputMaybe<VideoLessonUpdateManyInlineInput>;
};

export type LinkUpdateManyInlineInput = {
  /** Connect multiple existing Link documents */
  connect?: InputMaybe<Array<LinkConnectInput>>;
  /** Create and connect multiple Link documents */
  create?: InputMaybe<Array<LinkCreateInput>>;
  /** Delete multiple Link documents */
  delete?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Disconnect multiple Link documents */
  disconnect?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Link documents */
  set?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Update multiple Link documents */
  update?: InputMaybe<Array<LinkUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Link documents */
  upsert?: InputMaybe<Array<LinkUpsertWithNestedWhereUniqueInput>>;
};

export type LinkUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  newWindow?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LinkUpdateManyInput;
  /** Document search */
  where: LinkWhereInput;
};

export type LinkUpdateOneInlineInput = {
  /** Connect existing Link document */
  connect?: InputMaybe<LinkWhereUniqueInput>;
  /** Create and connect one Link document */
  create?: InputMaybe<LinkCreateInput>;
  /** Delete currently connected Link document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Link document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Link document */
  update?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Link document */
  upsert?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type LinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LinkUpdateInput;
  /** Unique document search */
  where: LinkWhereUniqueInput;
};

export type LinkUpsertInput = {
  /** Create document if it didn't exist */
  create: LinkCreateInput;
  /** Update document if it exists */
  update: LinkUpdateInput;
};

export type LinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LinkUpsertInput;
  /** Unique document search */
  where: LinkWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LinkWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type LinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<LinkWhereStageInput>;
  documentInStages_none?: InputMaybe<LinkWhereStageInput>;
  documentInStages_some?: InputMaybe<LinkWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  newWindow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  newWindow_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoLessons_every?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_none?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_some?: InputMaybe<VideoLessonWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LinkWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LinkWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Link record uniquely */
export type LinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Locale system enumeration */
export enum Locale {
  En = 'en'
}

/** Representing a geolocation point with latitude and longitude */
export type Location = {
  __typename?: 'Location';
  distance: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};


/** Representing a geolocation point with latitude and longitude */
export type LocationDistanceArgs = {
  from: LocationInput;
};

/** Input for a geolocation point with latitude and longitude */
export type LocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type LoginByPhoneInput = {
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type LoginInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  redirectTo?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ScoUser>;
  viewer?: Maybe<Viewer>;
};

export type MarkAdvisorAgreementSignedInput = {
  advisorAgreementId?: InputMaybe<Scalars['String']['input']>;
  signedStoredFileId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkAdvisorAgreementSignedPayload = {
  __typename?: 'MarkAdvisorAgreementSignedPayload';
  advisorAgreement?: Maybe<ScoAdvisorAgreement>;
};

export type MarkScoCustomerExperimentFirstActionInput = {
  customerExperimentId: Scalars['String']['input'];
};

export type MarkScoCustomerExperimentFirstActionPayload = {
  __typename?: 'MarkScoCustomerExperimentFirstActionPayload';
  customerExperiment?: Maybe<ScoCustomerExperiment>;
  customerSearch?: Maybe<ScoCustomerSearch>;
};

export type ModelLog = ScoNode & {
  __typename?: 'ModelLog';
  actingUser?: Maybe<ScoUser>;
  actingUserId?: Maybe<Scalars['String']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataAsJson?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modelLogId?: Maybe<Scalars['String']['output']>;
  relatedModelId?: Maybe<Scalars['String']['output']>;
  relatedModelType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ModelLogCollection = {
  __typename?: 'ModelLogCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ModelLog>>;
  pagination: Pagination;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptBootcampShare?: Maybe<AcceptBootcampSharePayload>;
  acceptToolTestRun?: Maybe<AcceptToolTestRunPayload>;
  addCrmInbox?: Maybe<AddCrmInboxPayload>;
  addUserSkill?: Maybe<AddUserSkillPayload>;
  adminActionMarkAsFGMembers?: Maybe<AdminActionMarkAsFgMembersPayload>;
  adminBanUser?: Maybe<AdminBanUserPayload>;
  adminCancelSubscription?: Maybe<AdminCancelSubscriptionPayload>;
  adminReassignRecord?: Maybe<AdminReassignRecordPayload>;
  adminRefundAdvisorSession?: Maybe<AdminRefundAdvisorSessionPayload>;
  adminRefundPayment?: Maybe<AdminRefundPaymentPayload>;
  adminRemindAdvisorSessionPendingParty?: Maybe<AdminRemindAdvisorSessionPendingPartyPayload>;
  adminRemoveGroupEventAttendance?: Maybe<AdminRemoveGroupEventAttendancePayload>;
  adminRemoveSocialConnection?: Maybe<AdminRemoveSocialConnectionPayload>;
  adminRemoveUserBan?: Maybe<AdminRemoveUserBanPayload>;
  adminRemoveUserPhoto?: Maybe<AdminRemoveUserPhotoPayload>;
  adminResyncGroupEventToGoogleCalendar?: Maybe<AdminResyncGroupEventToGoogleCalendarPayload>;
  adminUpdateAdvisorEngagement?: Maybe<AdminUpdateAdvisorEngagementPayload>;
  adminUpdateAdvisorProfile?: Maybe<AdminUpdateAdvisorProfilePayload>;
  adminUpdateCompany?: Maybe<AdminUpdateCompanyPayload>;
  adminUpdateFGChargifyBilling?: Maybe<AdminUpdateFgChargifyBillingPayload>;
  adminUpdateFGMemberChargifyBilling?: Maybe<AdminUpdateFgMemberChargifyBillingPayload>;
  adminUpdateProfile?: Maybe<AdminUpdateProfilePayload>;
  analyzeScoCustomerExperiment?: Maybe<AnalyzeScoCustomerExperimentPayload>;
  applyCancellationDiscount?: Maybe<ApplyCancellationDiscountPayload>;
  applyToBoardSeat?: Maybe<ApplyToBoardSeatPayload>;
  applyToolStudioEdit?: Maybe<ApplyToolStudioEditPayload>;
  approveGroupRequest?: Maybe<ApproveGroupRequestPayload>;
  attachChargifySubscription?: Maybe<AttachChargifySubscriptionPayload>;
  bulkCreateInvestorProfileUserSave?: Maybe<BulkCreateInvestorProfileUserSavePayload>;
  bulkUpsertInvestorMatches?: Maybe<BulkUpsertInvestorMatchesPayload>;
  cancelAdvisorSession?: Maybe<CancelAdvisorSessionPayload>;
  cancelSubscription?: Maybe<CancelSubscriptionPayload>;
  changeEmailNotificationSchedule?: Maybe<ChangeEmailNotificationSchedulePayload>;
  changeSubscriptionProduct?: Maybe<ChangeSubscriptionProductPayload>;
  changeSubscriptionScoProduct?: Maybe<ChangeSubscriptionScoProductPayload>;
  checkCrmConversation?: Maybe<CheckCrmConversationPayload>;
  claimClarityAdvisorImport?: Maybe<ClaimClarityAdvisorImportPayload>;
  claimCrmThread?: Maybe<ClaimCrmThreadPayload>;
  completeAdvisorSession?: Maybe<CompleteAdvisorSessionPayload>;
  confirmAdvisorSessionPrecharge?: Maybe<ConfirmAdvisorSessionPrechargePayload>;
  confirmAdvisorSessionSchedule?: Maybe<ConfirmAdvisorSessionSchedulePayload>;
  confirmScoCustomerSearchSegments?: Maybe<ConfirmScoCustomerSearchSegmentsPayload>;
  createAdvisorConnectDashboardLink?: Maybe<CreateAdvisorConnectDashboardLinkPayload>;
  createAdvisorConnectOnboardingLink?: Maybe<CreateAdvisorConnectOnboardingLinkPayload>;
  createAdvisorSessionJoinCredentials?: Maybe<CreateAdvisorSessionJoinCredentialsPayload>;
  /** Create one article */
  createArticle?: Maybe<Article>;
  /** Create an asset. Use the returned info to finish the creation process by uploading the asset. */
  createAsset?: Maybe<Asset>;
  /** Create one benefit */
  createBenefit?: Maybe<Benefit>;
  /** Create one bootcampEvent */
  createBootcampEvent?: Maybe<BootcampEvent>;
  /** Create one businessStage */
  createBusinessStage?: Maybe<BusinessStage>;
  /** Create one coachProfile */
  createCoachProfile?: Maybe<CoachProfile>;
  createComment?: Maybe<CreateCommentPayload>;
  /** Create one contentTrack */
  createContentTrack?: Maybe<ContentTrack>;
  /** Create one contentTrackSection */
  createContentTrackSection?: Maybe<ContentTrackSection>;
  /** Create one contentTrackStep */
  createContentTrackStep?: Maybe<ContentTrackStep>;
  /** Create one contentTrackTask */
  createContentTrackTask?: Maybe<ContentTrackTask>;
  createCourseEnrollment?: Maybe<CreateCourseEnrollmentPayload>;
  createFlag?: Maybe<CreateFlagPayload>;
  /** Create one founderTrack */
  createFounderTrack?: Maybe<FounderTrack>;
  /** Create one founderTrackStep */
  createFounderTrackStep?: Maybe<FounderTrackStep>;
  /** Create one founderTrackTask */
  createFounderTrackTask?: Maybe<FounderTrackTask>;
  createGroupComment?: Maybe<CreateGroupCommentPayload>;
  createGroupMember?: Maybe<CreateGroupMemberPayload>;
  createGroupMemberReview?: Maybe<CreateGroupMemberReviewPayload>;
  createGroupThread?: Maybe<CreateGroupThreadPayload>;
  /** Create one link */
  createLink?: Maybe<Link>;
  createLinkedAccount?: Maybe<CreateLinkedAccountPayload>;
  /** Create one person */
  createPerson?: Maybe<Person>;
  /** Create one playlist */
  createPlaylist?: Maybe<Playlist>;
  /** Create one podcastEpisode */
  createPodcastEpisode?: Maybe<PodcastEpisode>;
  /** Create one productName */
  createProductName?: Maybe<ProductName>;
  createProvisionedAccount?: Maybe<CreateProvisionedAccountPayload>;
  /** Create one review */
  createReview?: Maybe<Review>;
  /** Create one scheduledRelease */
  createScheduledRelease?: Maybe<ScheduledRelease>;
  createStripePaymentIntent?: Maybe<CreateStripePaymentIntentPayload>;
  createSubscriptionChangeChargebeeHostedPage?: Maybe<CreateSubscriptionChangeChargebeeHostedPagePayload>;
  /** Create one supportArticle */
  createSupportArticle?: Maybe<SupportArticle>;
  /** Create one supportCategory */
  createSupportCategory?: Maybe<SupportCategory>;
  /** Create one term */
  createTerm?: Maybe<Term>;
  createThread?: Maybe<CreateThreadPayload>;
  createUserAuthToken?: Maybe<CreateUserAuthTokenPayload>;
  /** Create one video */
  createVideo?: Maybe<Video>;
  /** Create one videoCourse */
  createVideoCourse?: Maybe<VideoCourse>;
  /** Create one videoCourseListEntry */
  createVideoCourseListEntry?: Maybe<VideoCourseListEntry>;
  /** Create one videoLesson */
  createVideoLesson?: Maybe<VideoLesson>;
  /** Create one videoList */
  createVideoList?: Maybe<VideoList>;
  /** Create one videoListEntry */
  createVideoListEntry?: Maybe<VideoListEntry>;
  /** Create one videoPlaylist */
  createVideoPlaylist?: Maybe<VideoPlaylist>;
  createView?: Maybe<CreateViewPayload>;
  dealsPartner?: Maybe<DealsPartnerPayload>;
  delaySubscriptionRenewal?: Maybe<DelaySubscriptionRenewalPayload>;
  deleteAccount?: Maybe<DeleteAccountPayload>;
  deleteAdvisorAgreement?: Maybe<DeleteAdvisorAgreementPayload>;
  /** Delete one article from _all_ existing stages. Returns deleted document. */
  deleteArticle?: Maybe<Article>;
  /** Delete one asset from _all_ existing stages. Returns deleted document. */
  deleteAsset?: Maybe<Asset>;
  /** Delete one benefit from _all_ existing stages. Returns deleted document. */
  deleteBenefit?: Maybe<Benefit>;
  /** Delete one bootcampEvent from _all_ existing stages. Returns deleted document. */
  deleteBootcampEvent?: Maybe<BootcampEvent>;
  deleteBootcampShare?: Maybe<DeleteBootcampSharePayload>;
  /** Delete one businessStage from _all_ existing stages. Returns deleted document. */
  deleteBusinessStage?: Maybe<BusinessStage>;
  /** Delete one coachProfile from _all_ existing stages. Returns deleted document. */
  deleteCoachProfile?: Maybe<CoachProfile>;
  deleteComment?: Maybe<DeleteCommentPayload>;
  /** Delete one contentTrack from _all_ existing stages. Returns deleted document. */
  deleteContentTrack?: Maybe<ContentTrack>;
  /** Delete one contentTrackSection from _all_ existing stages. Returns deleted document. */
  deleteContentTrackSection?: Maybe<ContentTrackSection>;
  /** Delete one contentTrackStep from _all_ existing stages. Returns deleted document. */
  deleteContentTrackStep?: Maybe<ContentTrackStep>;
  /** Delete one contentTrackTask from _all_ existing stages. Returns deleted document. */
  deleteContentTrackTask?: Maybe<ContentTrackTask>;
  deleteCrmSavedReply?: Maybe<DeleteCrmSavedReplyPayload>;
  /** Delete one founderTrack from _all_ existing stages. Returns deleted document. */
  deleteFounderTrack?: Maybe<FounderTrack>;
  /** Delete one founderTrackStep from _all_ existing stages. Returns deleted document. */
  deleteFounderTrackStep?: Maybe<FounderTrackStep>;
  /** Delete one founderTrackTask from _all_ existing stages. Returns deleted document. */
  deleteFounderTrackTask?: Maybe<FounderTrackTask>;
  deleteGroup?: Maybe<DeleteGroupPayload>;
  deleteGroupEvent?: Maybe<DeleteGroupEventPayload>;
  deleteGroupGoal?: Maybe<DeleteGroupGoalPayload>;
  deleteGroupMemberReview?: Maybe<DeleteGroupMemberReviewPayload>;
  deleteGroupMembership?: Maybe<DeleteGroupMembershipPayload>;
  /** Delete one link from _all_ existing stages. Returns deleted document. */
  deleteLink?: Maybe<Link>;
  /**
   * Delete many Article documents
   * @deprecated Please use the new paginated many mutation (deleteManyArticlesConnection)
   */
  deleteManyArticles: BatchPayload;
  /** Delete many Article documents, return deleted documents */
  deleteManyArticlesConnection: ArticleConnection;
  /**
   * Delete many Asset documents
   * @deprecated Please use the new paginated many mutation (deleteManyAssetsConnection)
   */
  deleteManyAssets: BatchPayload;
  /** Delete many Asset documents, return deleted documents */
  deleteManyAssetsConnection: AssetConnection;
  /**
   * Delete many Benefit documents
   * @deprecated Please use the new paginated many mutation (deleteManyBenefitsConnection)
   */
  deleteManyBenefits: BatchPayload;
  /** Delete many Benefit documents, return deleted documents */
  deleteManyBenefitsConnection: BenefitConnection;
  /**
   * Delete many BootcampEvent documents
   * @deprecated Please use the new paginated many mutation (deleteManyBootcampEventsConnection)
   */
  deleteManyBootcampEvents: BatchPayload;
  /** Delete many BootcampEvent documents, return deleted documents */
  deleteManyBootcampEventsConnection: BootcampEventConnection;
  /**
   * Delete many BusinessStage documents
   * @deprecated Please use the new paginated many mutation (deleteManyBusinessStagesConnection)
   */
  deleteManyBusinessStages: BatchPayload;
  /** Delete many BusinessStage documents, return deleted documents */
  deleteManyBusinessStagesConnection: BusinessStageConnection;
  /**
   * Delete many CoachProfile documents
   * @deprecated Please use the new paginated many mutation (deleteManyCoachProfilesConnection)
   */
  deleteManyCoachProfiles: BatchPayload;
  /** Delete many CoachProfile documents, return deleted documents */
  deleteManyCoachProfilesConnection: CoachProfileConnection;
  /**
   * Delete many ContentTrackSection documents
   * @deprecated Please use the new paginated many mutation (deleteManyContentTrackSectionsConnection)
   */
  deleteManyContentTrackSections: BatchPayload;
  /** Delete many ContentTrackSection documents, return deleted documents */
  deleteManyContentTrackSectionsConnection: ContentTrackSectionConnection;
  /**
   * Delete many ContentTrackStep documents
   * @deprecated Please use the new paginated many mutation (deleteManyContentTrackStepsConnection)
   */
  deleteManyContentTrackSteps: BatchPayload;
  /** Delete many ContentTrackStep documents, return deleted documents */
  deleteManyContentTrackStepsConnection: ContentTrackStepConnection;
  /**
   * Delete many ContentTrackTask documents
   * @deprecated Please use the new paginated many mutation (deleteManyContentTrackTasksConnection)
   */
  deleteManyContentTrackTasks: BatchPayload;
  /** Delete many ContentTrackTask documents, return deleted documents */
  deleteManyContentTrackTasksConnection: ContentTrackTaskConnection;
  /**
   * Delete many ContentTrack documents
   * @deprecated Please use the new paginated many mutation (deleteManyContentTracksConnection)
   */
  deleteManyContentTracks: BatchPayload;
  /** Delete many ContentTrack documents, return deleted documents */
  deleteManyContentTracksConnection: ContentTrackConnection;
  /**
   * Delete many FounderTrackStep documents
   * @deprecated Please use the new paginated many mutation (deleteManyFounderTrackStepsConnection)
   */
  deleteManyFounderTrackSteps: BatchPayload;
  /** Delete many FounderTrackStep documents, return deleted documents */
  deleteManyFounderTrackStepsConnection: FounderTrackStepConnection;
  /**
   * Delete many FounderTrackTask documents
   * @deprecated Please use the new paginated many mutation (deleteManyFounderTrackTasksConnection)
   */
  deleteManyFounderTrackTasks: BatchPayload;
  /** Delete many FounderTrackTask documents, return deleted documents */
  deleteManyFounderTrackTasksConnection: FounderTrackTaskConnection;
  /**
   * Delete many FounderTrack documents
   * @deprecated Please use the new paginated many mutation (deleteManyFounderTracksConnection)
   */
  deleteManyFounderTracks: BatchPayload;
  /** Delete many FounderTrack documents, return deleted documents */
  deleteManyFounderTracksConnection: FounderTrackConnection;
  /**
   * Delete many Link documents
   * @deprecated Please use the new paginated many mutation (deleteManyLinksConnection)
   */
  deleteManyLinks: BatchPayload;
  /** Delete many Link documents, return deleted documents */
  deleteManyLinksConnection: LinkConnection;
  /**
   * Delete many Person documents
   * @deprecated Please use the new paginated many mutation (deleteManyPersonsConnection)
   */
  deleteManyPersons: BatchPayload;
  /** Delete many Person documents, return deleted documents */
  deleteManyPersonsConnection: PersonConnection;
  /**
   * Delete many Playlist documents
   * @deprecated Please use the new paginated many mutation (deleteManyPlaylistsConnection)
   */
  deleteManyPlaylists: BatchPayload;
  /** Delete many Playlist documents, return deleted documents */
  deleteManyPlaylistsConnection: PlaylistConnection;
  /**
   * Delete many PodcastEpisode documents
   * @deprecated Please use the new paginated many mutation (deleteManyPodcastEpisodesConnection)
   */
  deleteManyPodcastEpisodes: BatchPayload;
  /** Delete many PodcastEpisode documents, return deleted documents */
  deleteManyPodcastEpisodesConnection: PodcastEpisodeConnection;
  /**
   * Delete many ProductName documents
   * @deprecated Please use the new paginated many mutation (deleteManyProductNamesConnection)
   */
  deleteManyProductNames: BatchPayload;
  /** Delete many ProductName documents, return deleted documents */
  deleteManyProductNamesConnection: ProductNameConnection;
  /**
   * Delete many Review documents
   * @deprecated Please use the new paginated many mutation (deleteManyReviewsConnection)
   */
  deleteManyReviews: BatchPayload;
  /** Delete many Review documents, return deleted documents */
  deleteManyReviewsConnection: ReviewConnection;
  /**
   * Delete many SupportArticle documents
   * @deprecated Please use the new paginated many mutation (deleteManySupportArticlesConnection)
   */
  deleteManySupportArticles: BatchPayload;
  /** Delete many SupportArticle documents, return deleted documents */
  deleteManySupportArticlesConnection: SupportArticleConnection;
  /**
   * Delete many SupportCategory documents
   * @deprecated Please use the new paginated many mutation (deleteManySupportCategoriesConnection)
   */
  deleteManySupportCategories: BatchPayload;
  /** Delete many SupportCategory documents, return deleted documents */
  deleteManySupportCategoriesConnection: SupportCategoryConnection;
  /**
   * Delete many Term documents
   * @deprecated Please use the new paginated many mutation (deleteManyTermsConnection)
   */
  deleteManyTerms: BatchPayload;
  /** Delete many Term documents, return deleted documents */
  deleteManyTermsConnection: TermConnection;
  /**
   * Delete many VideoCourseListEntry documents
   * @deprecated Please use the new paginated many mutation (deleteManyVideoCourseListEntriesConnection)
   */
  deleteManyVideoCourseListEntries: BatchPayload;
  /** Delete many VideoCourseListEntry documents, return deleted documents */
  deleteManyVideoCourseListEntriesConnection: VideoCourseListEntryConnection;
  /**
   * Delete many VideoCourse documents
   * @deprecated Please use the new paginated many mutation (deleteManyVideoCoursesConnection)
   */
  deleteManyVideoCourses: BatchPayload;
  /** Delete many VideoCourse documents, return deleted documents */
  deleteManyVideoCoursesConnection: VideoCourseConnection;
  /**
   * Delete many VideoLesson documents
   * @deprecated Please use the new paginated many mutation (deleteManyVideoLessonsConnection)
   */
  deleteManyVideoLessons: BatchPayload;
  /** Delete many VideoLesson documents, return deleted documents */
  deleteManyVideoLessonsConnection: VideoLessonConnection;
  /**
   * Delete many VideoListEntry documents
   * @deprecated Please use the new paginated many mutation (deleteManyVideoListEntriesConnection)
   */
  deleteManyVideoListEntries: BatchPayload;
  /** Delete many VideoListEntry documents, return deleted documents */
  deleteManyVideoListEntriesConnection: VideoListEntryConnection;
  /**
   * Delete many VideoList documents
   * @deprecated Please use the new paginated many mutation (deleteManyVideoListsConnection)
   */
  deleteManyVideoLists: BatchPayload;
  /** Delete many VideoList documents, return deleted documents */
  deleteManyVideoListsConnection: VideoListConnection;
  /**
   * Delete many VideoPlaylist documents
   * @deprecated Please use the new paginated many mutation (deleteManyVideoPlaylistsConnection)
   */
  deleteManyVideoPlaylists: BatchPayload;
  /** Delete many VideoPlaylist documents, return deleted documents */
  deleteManyVideoPlaylistsConnection: VideoPlaylistConnection;
  /**
   * Delete many Video documents
   * @deprecated Please use the new paginated many mutation (deleteManyVideosConnection)
   */
  deleteManyVideos: BatchPayload;
  /** Delete many Video documents, return deleted documents */
  deleteManyVideosConnection: VideoConnection;
  /** Delete one person from _all_ existing stages. Returns deleted document. */
  deletePerson?: Maybe<Person>;
  /** Delete one playlist from _all_ existing stages. Returns deleted document. */
  deletePlaylist?: Maybe<Playlist>;
  /** Delete one podcastEpisode from _all_ existing stages. Returns deleted document. */
  deletePodcastEpisode?: Maybe<PodcastEpisode>;
  /** Delete one productName from _all_ existing stages. Returns deleted document. */
  deleteProductName?: Maybe<ProductName>;
  /** Delete one review from _all_ existing stages. Returns deleted document. */
  deleteReview?: Maybe<Review>;
  /** Delete and return scheduled operation */
  deleteScheduledOperation?: Maybe<ScheduledOperation>;
  /** Delete one scheduledRelease from _all_ existing stages. Returns deleted document. */
  deleteScheduledRelease?: Maybe<ScheduledRelease>;
  deleteScoAnalyticsSavedReport?: Maybe<DeleteScoAnalyticsSavedReportPayload>;
  deleteSocialConnection?: Maybe<DeleteSocialConnectionPayload>;
  /** Delete one supportArticle from _all_ existing stages. Returns deleted document. */
  deleteSupportArticle?: Maybe<SupportArticle>;
  /** Delete one supportCategory from _all_ existing stages. Returns deleted document. */
  deleteSupportCategory?: Maybe<SupportCategory>;
  /** Delete one term from _all_ existing stages. Returns deleted document. */
  deleteTerm?: Maybe<Term>;
  deleteThread?: Maybe<DeleteThreadPayload>;
  deleteToolKnowledgeCard?: Maybe<DeleteToolKnowledgeCardPayload>;
  deleteToolReplyTemplate?: Maybe<DeleteToolReplyTemplatePayload>;
  deleteToolRule?: Maybe<DeleteToolRulePayload>;
  /** Delete one video from _all_ existing stages. Returns deleted document. */
  deleteVideo?: Maybe<Video>;
  /** Delete one videoCourse from _all_ existing stages. Returns deleted document. */
  deleteVideoCourse?: Maybe<VideoCourse>;
  /** Delete one videoCourseListEntry from _all_ existing stages. Returns deleted document. */
  deleteVideoCourseListEntry?: Maybe<VideoCourseListEntry>;
  /** Delete one videoLesson from _all_ existing stages. Returns deleted document. */
  deleteVideoLesson?: Maybe<VideoLesson>;
  /** Delete one videoList from _all_ existing stages. Returns deleted document. */
  deleteVideoList?: Maybe<VideoList>;
  /** Delete one videoListEntry from _all_ existing stages. Returns deleted document. */
  deleteVideoListEntry?: Maybe<VideoListEntry>;
  /** Delete one videoPlaylist from _all_ existing stages. Returns deleted document. */
  deleteVideoPlaylist?: Maybe<VideoPlaylist>;
  discardToolDraft?: Maybe<DiscardToolDraftPayload>;
  dismissCrmThread?: Maybe<DismissCrmThreadPayload>;
  dismissNotification?: Maybe<DismissNotificationPayload>;
  dismissNotifications?: Maybe<DismissNotificationsPayload>;
  downloadEbook?: Maybe<DownloadEbookPayload>;
  duplicateScoAnalyticsSavedReport?: Maybe<DuplicateScoAnalyticsSavedReportPayload>;
  endAdvisorEngagement?: Maybe<EndAdvisorEngagementPayload>;
  ensureScoPitchDeckSlideChat?: Maybe<EnsureScoPitchDeckSlideChatPayload>;
  extractAdvisorApplicationFromBio?: Maybe<ExtractAdvisorApplicationFromBioPayload>;
  extractSkillsForUser?: Maybe<ExtractSkillsForUserPayload>;
  fgJoinEvent?: Maybe<FgJoinEventPayload>;
  generateCrmReply?: Maybe<GenerateCrmReplyPayload>;
  handoffCrmThreadToSupport?: Maybe<HandoffCrmThreadToSupportPayload>;
  initiateBizplanConnection?: Maybe<InitiateBizplanConnectionPayload>;
  initiateLaunchrockConnection?: Maybe<InitiateLaunchrockConnectionPayload>;
  inviteAdvisorToBoard?: Maybe<InviteAdvisorToBoardPayload>;
  joinGroup?: Maybe<JoinGroupPayload>;
  launchFGProfile?: Maybe<LaunchFgProfilePayload>;
  login?: Maybe<LoginPayload>;
  loginByPhone?: Maybe<Scalars['String']['output']>;
  logout?: Maybe<Scalars['String']['output']>;
  markAdvisorAgreementSigned?: Maybe<MarkAdvisorAgreementSignedPayload>;
  markScoCustomerExperimentFirstAction?: Maybe<MarkScoCustomerExperimentFirstActionPayload>;
  newsletterSignup?: Maybe<NewsletterSignupPayload>;
  nominateStartupsLiveGuest?: Maybe<Scalars['String']['output']>;
  openToolThread?: Maybe<OpenToolThreadPayload>;
  patchToolCopy?: Maybe<PatchToolCopyPayload>;
  promoteScoCustomerSegment?: Maybe<PromoteScoCustomerSegmentPayload>;
  proposeAdvisorSessionSchedule?: Maybe<ProposeAdvisorSessionSchedulePayload>;
  /** Publish one article */
  publishArticle?: Maybe<Article>;
  /** Publish one asset */
  publishAsset?: Maybe<Asset>;
  /** Publish one benefit */
  publishBenefit?: Maybe<Benefit>;
  /** Publish one bootcampEvent */
  publishBootcampEvent?: Maybe<BootcampEvent>;
  /** Publish one businessStage */
  publishBusinessStage?: Maybe<BusinessStage>;
  /** Publish one coachProfile */
  publishCoachProfile?: Maybe<CoachProfile>;
  /** Publish one contentTrack */
  publishContentTrack?: Maybe<ContentTrack>;
  /** Publish one contentTrackSection */
  publishContentTrackSection?: Maybe<ContentTrackSection>;
  /** Publish one contentTrackStep */
  publishContentTrackStep?: Maybe<ContentTrackStep>;
  /** Publish one contentTrackTask */
  publishContentTrackTask?: Maybe<ContentTrackTask>;
  /** Publish one founderTrack */
  publishFounderTrack?: Maybe<FounderTrack>;
  /** Publish one founderTrackStep */
  publishFounderTrackStep?: Maybe<FounderTrackStep>;
  /** Publish one founderTrackTask */
  publishFounderTrackTask?: Maybe<FounderTrackTask>;
  /** Publish one link */
  publishLink?: Maybe<Link>;
  /**
   * Publish many Article documents
   * @deprecated Please use the new paginated many mutation (publishManyArticlesConnection)
   */
  publishManyArticles: BatchPayload;
  /** Publish many Article documents */
  publishManyArticlesConnection: ArticleConnection;
  /**
   * Publish many Asset documents
   * @deprecated Please use the new paginated many mutation (publishManyAssetsConnection)
   */
  publishManyAssets: BatchPayload;
  /** Publish many Asset documents */
  publishManyAssetsConnection: AssetConnection;
  /**
   * Publish many Benefit documents
   * @deprecated Please use the new paginated many mutation (publishManyBenefitsConnection)
   */
  publishManyBenefits: BatchPayload;
  /** Publish many Benefit documents */
  publishManyBenefitsConnection: BenefitConnection;
  /**
   * Publish many BootcampEvent documents
   * @deprecated Please use the new paginated many mutation (publishManyBootcampEventsConnection)
   */
  publishManyBootcampEvents: BatchPayload;
  /** Publish many BootcampEvent documents */
  publishManyBootcampEventsConnection: BootcampEventConnection;
  /**
   * Publish many BusinessStage documents
   * @deprecated Please use the new paginated many mutation (publishManyBusinessStagesConnection)
   */
  publishManyBusinessStages: BatchPayload;
  /** Publish many BusinessStage documents */
  publishManyBusinessStagesConnection: BusinessStageConnection;
  /**
   * Publish many CoachProfile documents
   * @deprecated Please use the new paginated many mutation (publishManyCoachProfilesConnection)
   */
  publishManyCoachProfiles: BatchPayload;
  /** Publish many CoachProfile documents */
  publishManyCoachProfilesConnection: CoachProfileConnection;
  /**
   * Publish many ContentTrackSection documents
   * @deprecated Please use the new paginated many mutation (publishManyContentTrackSectionsConnection)
   */
  publishManyContentTrackSections: BatchPayload;
  /** Publish many ContentTrackSection documents */
  publishManyContentTrackSectionsConnection: ContentTrackSectionConnection;
  /**
   * Publish many ContentTrackStep documents
   * @deprecated Please use the new paginated many mutation (publishManyContentTrackStepsConnection)
   */
  publishManyContentTrackSteps: BatchPayload;
  /** Publish many ContentTrackStep documents */
  publishManyContentTrackStepsConnection: ContentTrackStepConnection;
  /**
   * Publish many ContentTrackTask documents
   * @deprecated Please use the new paginated many mutation (publishManyContentTrackTasksConnection)
   */
  publishManyContentTrackTasks: BatchPayload;
  /** Publish many ContentTrackTask documents */
  publishManyContentTrackTasksConnection: ContentTrackTaskConnection;
  /**
   * Publish many ContentTrack documents
   * @deprecated Please use the new paginated many mutation (publishManyContentTracksConnection)
   */
  publishManyContentTracks: BatchPayload;
  /** Publish many ContentTrack documents */
  publishManyContentTracksConnection: ContentTrackConnection;
  /**
   * Publish many FounderTrackStep documents
   * @deprecated Please use the new paginated many mutation (publishManyFounderTrackStepsConnection)
   */
  publishManyFounderTrackSteps: BatchPayload;
  /** Publish many FounderTrackStep documents */
  publishManyFounderTrackStepsConnection: FounderTrackStepConnection;
  /**
   * Publish many FounderTrackTask documents
   * @deprecated Please use the new paginated many mutation (publishManyFounderTrackTasksConnection)
   */
  publishManyFounderTrackTasks: BatchPayload;
  /** Publish many FounderTrackTask documents */
  publishManyFounderTrackTasksConnection: FounderTrackTaskConnection;
  /**
   * Publish many FounderTrack documents
   * @deprecated Please use the new paginated many mutation (publishManyFounderTracksConnection)
   */
  publishManyFounderTracks: BatchPayload;
  /** Publish many FounderTrack documents */
  publishManyFounderTracksConnection: FounderTrackConnection;
  /**
   * Publish many Link documents
   * @deprecated Please use the new paginated many mutation (publishManyLinksConnection)
   */
  publishManyLinks: BatchPayload;
  /** Publish many Link documents */
  publishManyLinksConnection: LinkConnection;
  /**
   * Publish many Person documents
   * @deprecated Please use the new paginated many mutation (publishManyPersonsConnection)
   */
  publishManyPersons: BatchPayload;
  /** Publish many Person documents */
  publishManyPersonsConnection: PersonConnection;
  /**
   * Publish many Playlist documents
   * @deprecated Please use the new paginated many mutation (publishManyPlaylistsConnection)
   */
  publishManyPlaylists: BatchPayload;
  /** Publish many Playlist documents */
  publishManyPlaylistsConnection: PlaylistConnection;
  /**
   * Publish many PodcastEpisode documents
   * @deprecated Please use the new paginated many mutation (publishManyPodcastEpisodesConnection)
   */
  publishManyPodcastEpisodes: BatchPayload;
  /** Publish many PodcastEpisode documents */
  publishManyPodcastEpisodesConnection: PodcastEpisodeConnection;
  /**
   * Publish many ProductName documents
   * @deprecated Please use the new paginated many mutation (publishManyProductNamesConnection)
   */
  publishManyProductNames: BatchPayload;
  /** Publish many ProductName documents */
  publishManyProductNamesConnection: ProductNameConnection;
  /**
   * Publish many Review documents
   * @deprecated Please use the new paginated many mutation (publishManyReviewsConnection)
   */
  publishManyReviews: BatchPayload;
  /** Publish many Review documents */
  publishManyReviewsConnection: ReviewConnection;
  /**
   * Publish many SupportArticle documents
   * @deprecated Please use the new paginated many mutation (publishManySupportArticlesConnection)
   */
  publishManySupportArticles: BatchPayload;
  /** Publish many SupportArticle documents */
  publishManySupportArticlesConnection: SupportArticleConnection;
  /**
   * Publish many SupportCategory documents
   * @deprecated Please use the new paginated many mutation (publishManySupportCategoriesConnection)
   */
  publishManySupportCategories: BatchPayload;
  /** Publish many SupportCategory documents */
  publishManySupportCategoriesConnection: SupportCategoryConnection;
  /**
   * Publish many Term documents
   * @deprecated Please use the new paginated many mutation (publishManyTermsConnection)
   */
  publishManyTerms: BatchPayload;
  /** Publish many Term documents */
  publishManyTermsConnection: TermConnection;
  /**
   * Publish many VideoCourseListEntry documents
   * @deprecated Please use the new paginated many mutation (publishManyVideoCourseListEntriesConnection)
   */
  publishManyVideoCourseListEntries: BatchPayload;
  /** Publish many VideoCourseListEntry documents */
  publishManyVideoCourseListEntriesConnection: VideoCourseListEntryConnection;
  /**
   * Publish many VideoCourse documents
   * @deprecated Please use the new paginated many mutation (publishManyVideoCoursesConnection)
   */
  publishManyVideoCourses: BatchPayload;
  /** Publish many VideoCourse documents */
  publishManyVideoCoursesConnection: VideoCourseConnection;
  /**
   * Publish many VideoLesson documents
   * @deprecated Please use the new paginated many mutation (publishManyVideoLessonsConnection)
   */
  publishManyVideoLessons: BatchPayload;
  /** Publish many VideoLesson documents */
  publishManyVideoLessonsConnection: VideoLessonConnection;
  /**
   * Publish many VideoListEntry documents
   * @deprecated Please use the new paginated many mutation (publishManyVideoListEntriesConnection)
   */
  publishManyVideoListEntries: BatchPayload;
  /** Publish many VideoListEntry documents */
  publishManyVideoListEntriesConnection: VideoListEntryConnection;
  /**
   * Publish many VideoList documents
   * @deprecated Please use the new paginated many mutation (publishManyVideoListsConnection)
   */
  publishManyVideoLists: BatchPayload;
  /** Publish many VideoList documents */
  publishManyVideoListsConnection: VideoListConnection;
  /**
   * Publish many VideoPlaylist documents
   * @deprecated Please use the new paginated many mutation (publishManyVideoPlaylistsConnection)
   */
  publishManyVideoPlaylists: BatchPayload;
  /** Publish many VideoPlaylist documents */
  publishManyVideoPlaylistsConnection: VideoPlaylistConnection;
  /**
   * Publish many Video documents
   * @deprecated Please use the new paginated many mutation (publishManyVideosConnection)
   */
  publishManyVideos: BatchPayload;
  /** Publish many Video documents */
  publishManyVideosConnection: VideoConnection;
  /** Publish one person */
  publishPerson?: Maybe<Person>;
  /** Publish one playlist */
  publishPlaylist?: Maybe<Playlist>;
  /** Publish one podcastEpisode */
  publishPodcastEpisode?: Maybe<PodcastEpisode>;
  /** Publish one productName */
  publishProductName?: Maybe<ProductName>;
  /** Publish one review */
  publishReview?: Maybe<Review>;
  /** Publish one supportArticle */
  publishSupportArticle?: Maybe<SupportArticle>;
  /** Publish one supportCategory */
  publishSupportCategory?: Maybe<SupportCategory>;
  /** Publish one term */
  publishTerm?: Maybe<Term>;
  /** Publish one video */
  publishVideo?: Maybe<Video>;
  /** Publish one videoCourse */
  publishVideoCourse?: Maybe<VideoCourse>;
  /** Publish one videoCourseListEntry */
  publishVideoCourseListEntry?: Maybe<VideoCourseListEntry>;
  /** Publish one videoLesson */
  publishVideoLesson?: Maybe<VideoLesson>;
  /** Publish one videoList */
  publishVideoList?: Maybe<VideoList>;
  /** Publish one videoListEntry */
  publishVideoListEntry?: Maybe<VideoListEntry>;
  /** Publish one videoPlaylist */
  publishVideoPlaylist?: Maybe<VideoPlaylist>;
  reanalyzeScoPitchDeck?: Maybe<ReanalyzeScoPitchDeckPayload>;
  recallToolMessage?: Maybe<RecallToolMessagePayload>;
  recordScoCustomerExperimentTally?: Maybe<RecordScoCustomerExperimentTallyPayload>;
  refreshAdvisorConnectStatus?: Maybe<RefreshAdvisorConnectStatusPayload>;
  refreshCrmHubspotSnapshot?: Maybe<RefreshCrmHubspotSnapshotPayload>;
  refreshCrmMemberSummary?: Maybe<RefreshCrmMemberSummaryPayload>;
  regenerateCrmReply?: Maybe<RegenerateCrmReplyPayload>;
  registerUser?: Maybe<RegisterUserPayload>;
  reindexRagSource?: Maybe<ReindexRagSourcePayload>;
  rejectGroupRequest?: Maybe<RejectGroupRequestPayload>;
  releaseCrmThread?: Maybe<ReleaseCrmThreadPayload>;
  removeUserSkill?: Maybe<RemoveUserSkillPayload>;
  reopenCrmThread?: Maybe<ReopenCrmThreadPayload>;
  reorderToolRules?: Maybe<ReorderToolRulesPayload>;
  reportAdvisorSessionPresence?: Maybe<ReportAdvisorSessionPresencePayload>;
  requestAdvisorPayout?: Maybe<RequestAdvisorPayoutPayload>;
  requestAdvisorSession?: Maybe<RequestAdvisorSessionPayload>;
  requestConsultation?: Maybe<Scalars['String']['output']>;
  requestEmailConfirmation?: Maybe<Scalars['String']['output']>;
  requestFounderGroupEntry?: Maybe<Scalars['String']['output']>;
  requestFundingConsultation?: Maybe<RequestFundingConsultationPayload>;
  requestLoginToken?: Maybe<RequestLoginTokenPayload>;
  requestMasterclass?: Maybe<Scalars['String']['output']>;
  requestPasswordReset?: Maybe<RequestPasswordResetPayload>;
  requestPasswordResetByPhone?: Maybe<Scalars['String']['output']>;
  requestPhoneConfirmation?: Maybe<Scalars['String']['output']>;
  requestSlackInvite?: Maybe<RequestSlackInvitePayload>;
  resetAdvisorStripeConnect?: Maybe<ResetAdvisorStripeConnectPayload>;
  resetPassword?: Maybe<Scalars['String']['output']>;
  resolveCrmSupportHandoff?: Maybe<ResolveCrmSupportHandoffPayload>;
  respondToAdvisorAgreement?: Maybe<RespondToAdvisorAgreementPayload>;
  respondToBoardInvite?: Maybe<RespondToBoardInvitePayload>;
  respondToSeatApplication?: Maybe<RespondToSeatApplicationPayload>;
  reviewAdvisorProfile?: Maybe<ReviewAdvisorProfilePayload>;
  reviseAdvisorAgreement?: Maybe<ReviseAdvisorAgreementPayload>;
  revokeUserAuthToken?: Maybe<RevokeUserAuthTokenPayload>;
  rewriteCrmReply?: Maybe<RewriteCrmReplyPayload>;
  runScoCustomerChannelGeneration?: Maybe<RunScoCustomerChannelGenerationPayload>;
  runScoCustomerChannelMessage?: Maybe<RunScoCustomerChannelMessagePayload>;
  runScoCustomerExperimentGeneration?: Maybe<RunScoCustomerExperimentGenerationPayload>;
  runScoCustomerSearchStep?: Maybe<RunScoCustomerSearchStepPayload>;
  /** Schedule to publish one article */
  schedulePublishArticle?: Maybe<Article>;
  /** Schedule to publish one asset */
  schedulePublishAsset?: Maybe<Asset>;
  /** Schedule to publish one benefit */
  schedulePublishBenefit?: Maybe<Benefit>;
  /** Schedule to publish one bootcampEvent */
  schedulePublishBootcampEvent?: Maybe<BootcampEvent>;
  /** Schedule to publish one businessStage */
  schedulePublishBusinessStage?: Maybe<BusinessStage>;
  /** Schedule to publish one coachProfile */
  schedulePublishCoachProfile?: Maybe<CoachProfile>;
  /** Schedule to publish one contentTrack */
  schedulePublishContentTrack?: Maybe<ContentTrack>;
  /** Schedule to publish one contentTrackSection */
  schedulePublishContentTrackSection?: Maybe<ContentTrackSection>;
  /** Schedule to publish one contentTrackStep */
  schedulePublishContentTrackStep?: Maybe<ContentTrackStep>;
  /** Schedule to publish one contentTrackTask */
  schedulePublishContentTrackTask?: Maybe<ContentTrackTask>;
  /** Schedule to publish one founderTrack */
  schedulePublishFounderTrack?: Maybe<FounderTrack>;
  /** Schedule to publish one founderTrackStep */
  schedulePublishFounderTrackStep?: Maybe<FounderTrackStep>;
  /** Schedule to publish one founderTrackTask */
  schedulePublishFounderTrackTask?: Maybe<FounderTrackTask>;
  /** Schedule to publish one link */
  schedulePublishLink?: Maybe<Link>;
  /** Schedule to publish one person */
  schedulePublishPerson?: Maybe<Person>;
  /** Schedule to publish one playlist */
  schedulePublishPlaylist?: Maybe<Playlist>;
  /** Schedule to publish one podcastEpisode */
  schedulePublishPodcastEpisode?: Maybe<PodcastEpisode>;
  /** Schedule to publish one productName */
  schedulePublishProductName?: Maybe<ProductName>;
  /** Schedule to publish one review */
  schedulePublishReview?: Maybe<Review>;
  /** Schedule to publish one supportArticle */
  schedulePublishSupportArticle?: Maybe<SupportArticle>;
  /** Schedule to publish one supportCategory */
  schedulePublishSupportCategory?: Maybe<SupportCategory>;
  /** Schedule to publish one term */
  schedulePublishTerm?: Maybe<Term>;
  /** Schedule to publish one video */
  schedulePublishVideo?: Maybe<Video>;
  /** Schedule to publish one videoCourse */
  schedulePublishVideoCourse?: Maybe<VideoCourse>;
  /** Schedule to publish one videoCourseListEntry */
  schedulePublishVideoCourseListEntry?: Maybe<VideoCourseListEntry>;
  /** Schedule to publish one videoLesson */
  schedulePublishVideoLesson?: Maybe<VideoLesson>;
  /** Schedule to publish one videoList */
  schedulePublishVideoList?: Maybe<VideoList>;
  /** Schedule to publish one videoListEntry */
  schedulePublishVideoListEntry?: Maybe<VideoListEntry>;
  /** Schedule to publish one videoPlaylist */
  schedulePublishVideoPlaylist?: Maybe<VideoPlaylist>;
  /**
   * Unpublish one article from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishArticle?: Maybe<Article>;
  /**
   * Unpublish one asset from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishAsset?: Maybe<Asset>;
  /**
   * Unpublish one benefit from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishBenefit?: Maybe<Benefit>;
  /**
   * Unpublish one bootcampEvent from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishBootcampEvent?: Maybe<BootcampEvent>;
  /**
   * Unpublish one businessStage from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishBusinessStage?: Maybe<BusinessStage>;
  /**
   * Unpublish one coachProfile from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishCoachProfile?: Maybe<CoachProfile>;
  /**
   * Unpublish one contentTrack from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishContentTrack?: Maybe<ContentTrack>;
  /**
   * Unpublish one contentTrackSection from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishContentTrackSection?: Maybe<ContentTrackSection>;
  /**
   * Unpublish one contentTrackStep from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishContentTrackStep?: Maybe<ContentTrackStep>;
  /**
   * Unpublish one contentTrackTask from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishContentTrackTask?: Maybe<ContentTrackTask>;
  /**
   * Unpublish one founderTrack from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishFounderTrack?: Maybe<FounderTrack>;
  /**
   * Unpublish one founderTrackStep from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishFounderTrackStep?: Maybe<FounderTrackStep>;
  /**
   * Unpublish one founderTrackTask from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishFounderTrackTask?: Maybe<FounderTrackTask>;
  /**
   * Unpublish one link from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishLink?: Maybe<Link>;
  /**
   * Unpublish one person from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishPerson?: Maybe<Person>;
  /**
   * Unpublish one playlist from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishPlaylist?: Maybe<Playlist>;
  /**
   * Unpublish one podcastEpisode from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishPodcastEpisode?: Maybe<PodcastEpisode>;
  /**
   * Unpublish one productName from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishProductName?: Maybe<ProductName>;
  /**
   * Unpublish one review from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishReview?: Maybe<Review>;
  /**
   * Unpublish one supportArticle from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishSupportArticle?: Maybe<SupportArticle>;
  /**
   * Unpublish one supportCategory from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishSupportCategory?: Maybe<SupportCategory>;
  /**
   * Unpublish one term from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishTerm?: Maybe<Term>;
  /**
   * Unpublish one video from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishVideo?: Maybe<Video>;
  /**
   * Unpublish one videoCourse from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishVideoCourse?: Maybe<VideoCourse>;
  /**
   * Unpublish one videoCourseListEntry from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishVideoCourseListEntry?: Maybe<VideoCourseListEntry>;
  /**
   * Unpublish one videoLesson from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishVideoLesson?: Maybe<VideoLesson>;
  /**
   * Unpublish one videoList from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishVideoList?: Maybe<VideoList>;
  /**
   * Unpublish one videoListEntry from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishVideoListEntry?: Maybe<VideoListEntry>;
  /**
   * Unpublish one videoPlaylist from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  scheduleUnpublishVideoPlaylist?: Maybe<VideoPlaylist>;
  scoreToolTestRun?: Maybe<ScoreToolTestRunPayload>;
  sendAdvisorAgreement?: Maybe<SendAdvisorAgreementPayload>;
  sendToolMessage?: Maybe<SendToolMessagePayload>;
  setCrmBookingUrl?: Maybe<SetCrmBookingUrlPayload>;
  setCrmToolModel?: Maybe<SetCrmToolModelPayload>;
  setToolReplySettings?: Maybe<SetToolReplySettingsPayload>;
  setToolRuleRunLane?: Maybe<SetToolRuleRunLanePayload>;
  setToolServes?: Maybe<SetToolServesPayload>;
  setUserCrm?: Maybe<SetUserCrmPayload>;
  startCrmThread?: Maybe<StartCrmThreadPayload>;
  startLegacySubscription?: Maybe<StartLegacySubscriptionPayload>;
  submitAwsActivateRequest?: Maybe<SubmitAwsActivateRequestPayload>;
  submitCheckout?: Maybe<SubmitCheckoutPayload>;
  submitCoachEntry?: Maybe<Scalars['String']['output']>;
  submitFinancingApplication?: Maybe<SubmitFinancingApplicationPayload>;
  submitGroupRequest?: Maybe<SubmitGroupRequestPayload>;
  submitHubspotForm?: Maybe<SubmitHubspotFormPayload>;
  submitHubspotNote?: Maybe<SubmitHubspotNotePayload>;
  submitPitchDeckRequest?: Maybe<SubmitPitchDeckRequestPayload>;
  submitPurchase?: Maybe<SubmitPurchasePayload>;
  submitScoCustomerKnownIntake?: Maybe<SubmitScoCustomerKnownIntakePayload>;
  syncAdvisorAgreementSignature?: Maybe<SyncAdvisorAgreementSignaturePayload>;
  syncFGProfile?: Maybe<SyncFgProfilePayload>;
  syncRagCollection?: Maybe<SyncRagCollectionPayload>;
  toggleCommentFeatured?: Maybe<ToggleCommentFeaturedPayload>;
  toggleCommentIsSpam?: Maybe<ToggleCommentIsSpamPayload>;
  toggleFlag?: Maybe<ToggleFlagPayload>;
  toggleFollow?: Maybe<ToggleFollowPayload>;
  toggleGroupModerator?: Maybe<ToggleGroupModeratorPayload>;
  toggleInvestorProfileUserRequest?: Maybe<ToggleInvestorProfileUserRequestPayload>;
  toggleInvestorProfileUserSave?: Maybe<ToggleInvestorProfileUserSavePayload>;
  toggleLike?: Maybe<ToggleLikePayload>;
  toggleThreadFeatured?: Maybe<ToggleThreadFeaturedPayload>;
  toggleThreadIsSpam?: Maybe<ToggleThreadIsSpamPayload>;
  undoToolStudioEdit?: Maybe<UndoToolStudioEditPayload>;
  /**
   * Unpublish one article from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishArticle?: Maybe<Article>;
  /**
   * Unpublish one asset from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishAsset?: Maybe<Asset>;
  /**
   * Unpublish one benefit from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishBenefit?: Maybe<Benefit>;
  /**
   * Unpublish one bootcampEvent from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishBootcampEvent?: Maybe<BootcampEvent>;
  /**
   * Unpublish one businessStage from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishBusinessStage?: Maybe<BusinessStage>;
  /**
   * Unpublish one coachProfile from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishCoachProfile?: Maybe<CoachProfile>;
  /**
   * Unpublish one contentTrack from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishContentTrack?: Maybe<ContentTrack>;
  /**
   * Unpublish one contentTrackSection from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishContentTrackSection?: Maybe<ContentTrackSection>;
  /**
   * Unpublish one contentTrackStep from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishContentTrackStep?: Maybe<ContentTrackStep>;
  /**
   * Unpublish one contentTrackTask from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishContentTrackTask?: Maybe<ContentTrackTask>;
  /**
   * Unpublish one founderTrack from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishFounderTrack?: Maybe<FounderTrack>;
  /**
   * Unpublish one founderTrackStep from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishFounderTrackStep?: Maybe<FounderTrackStep>;
  /**
   * Unpublish one founderTrackTask from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishFounderTrackTask?: Maybe<FounderTrackTask>;
  /**
   * Unpublish one link from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishLink?: Maybe<Link>;
  /**
   * Unpublish many Article documents
   * @deprecated Please use the new paginated many mutation (unpublishManyArticlesConnection)
   */
  unpublishManyArticles: BatchPayload;
  /** Find many Article documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyArticlesConnection: ArticleConnection;
  /**
   * Unpublish many Asset documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAssetsConnection)
   */
  unpublishManyAssets: BatchPayload;
  /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsConnection: AssetConnection;
  /**
   * Unpublish many Benefit documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBenefitsConnection)
   */
  unpublishManyBenefits: BatchPayload;
  /** Find many Benefit documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBenefitsConnection: BenefitConnection;
  /**
   * Unpublish many BootcampEvent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBootcampEventsConnection)
   */
  unpublishManyBootcampEvents: BatchPayload;
  /** Find many BootcampEvent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBootcampEventsConnection: BootcampEventConnection;
  /**
   * Unpublish many BusinessStage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBusinessStagesConnection)
   */
  unpublishManyBusinessStages: BatchPayload;
  /** Find many BusinessStage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBusinessStagesConnection: BusinessStageConnection;
  /**
   * Unpublish many CoachProfile documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCoachProfilesConnection)
   */
  unpublishManyCoachProfiles: BatchPayload;
  /** Find many CoachProfile documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCoachProfilesConnection: CoachProfileConnection;
  /**
   * Unpublish many ContentTrackSection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyContentTrackSectionsConnection)
   */
  unpublishManyContentTrackSections: BatchPayload;
  /** Find many ContentTrackSection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyContentTrackSectionsConnection: ContentTrackSectionConnection;
  /**
   * Unpublish many ContentTrackStep documents
   * @deprecated Please use the new paginated many mutation (unpublishManyContentTrackStepsConnection)
   */
  unpublishManyContentTrackSteps: BatchPayload;
  /** Find many ContentTrackStep documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyContentTrackStepsConnection: ContentTrackStepConnection;
  /**
   * Unpublish many ContentTrackTask documents
   * @deprecated Please use the new paginated many mutation (unpublishManyContentTrackTasksConnection)
   */
  unpublishManyContentTrackTasks: BatchPayload;
  /** Find many ContentTrackTask documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyContentTrackTasksConnection: ContentTrackTaskConnection;
  /**
   * Unpublish many ContentTrack documents
   * @deprecated Please use the new paginated many mutation (unpublishManyContentTracksConnection)
   */
  unpublishManyContentTracks: BatchPayload;
  /** Find many ContentTrack documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyContentTracksConnection: ContentTrackConnection;
  /**
   * Unpublish many FounderTrackStep documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFounderTrackStepsConnection)
   */
  unpublishManyFounderTrackSteps: BatchPayload;
  /** Find many FounderTrackStep documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFounderTrackStepsConnection: FounderTrackStepConnection;
  /**
   * Unpublish many FounderTrackTask documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFounderTrackTasksConnection)
   */
  unpublishManyFounderTrackTasks: BatchPayload;
  /** Find many FounderTrackTask documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFounderTrackTasksConnection: FounderTrackTaskConnection;
  /**
   * Unpublish many FounderTrack documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFounderTracksConnection)
   */
  unpublishManyFounderTracks: BatchPayload;
  /** Find many FounderTrack documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFounderTracksConnection: FounderTrackConnection;
  /**
   * Unpublish many Link documents
   * @deprecated Please use the new paginated many mutation (unpublishManyLinksConnection)
   */
  unpublishManyLinks: BatchPayload;
  /** Find many Link documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLinksConnection: LinkConnection;
  /**
   * Unpublish many Person documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPersonsConnection)
   */
  unpublishManyPersons: BatchPayload;
  /** Find many Person documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPersonsConnection: PersonConnection;
  /**
   * Unpublish many Playlist documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPlaylistsConnection)
   */
  unpublishManyPlaylists: BatchPayload;
  /** Find many Playlist documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPlaylistsConnection: PlaylistConnection;
  /**
   * Unpublish many PodcastEpisode documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPodcastEpisodesConnection)
   */
  unpublishManyPodcastEpisodes: BatchPayload;
  /** Find many PodcastEpisode documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPodcastEpisodesConnection: PodcastEpisodeConnection;
  /**
   * Unpublish many ProductName documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProductNamesConnection)
   */
  unpublishManyProductNames: BatchPayload;
  /** Find many ProductName documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProductNamesConnection: ProductNameConnection;
  /**
   * Unpublish many Review documents
   * @deprecated Please use the new paginated many mutation (unpublishManyReviewsConnection)
   */
  unpublishManyReviews: BatchPayload;
  /** Find many Review documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyReviewsConnection: ReviewConnection;
  /**
   * Unpublish many SupportArticle documents
   * @deprecated Please use the new paginated many mutation (unpublishManySupportArticlesConnection)
   */
  unpublishManySupportArticles: BatchPayload;
  /** Find many SupportArticle documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySupportArticlesConnection: SupportArticleConnection;
  /**
   * Unpublish many SupportCategory documents
   * @deprecated Please use the new paginated many mutation (unpublishManySupportCategoriesConnection)
   */
  unpublishManySupportCategories: BatchPayload;
  /** Find many SupportCategory documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySupportCategoriesConnection: SupportCategoryConnection;
  /**
   * Unpublish many Term documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTermsConnection)
   */
  unpublishManyTerms: BatchPayload;
  /** Find many Term documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTermsConnection: TermConnection;
  /**
   * Unpublish many VideoCourseListEntry documents
   * @deprecated Please use the new paginated many mutation (unpublishManyVideoCourseListEntriesConnection)
   */
  unpublishManyVideoCourseListEntries: BatchPayload;
  /** Find many VideoCourseListEntry documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyVideoCourseListEntriesConnection: VideoCourseListEntryConnection;
  /**
   * Unpublish many VideoCourse documents
   * @deprecated Please use the new paginated many mutation (unpublishManyVideoCoursesConnection)
   */
  unpublishManyVideoCourses: BatchPayload;
  /** Find many VideoCourse documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyVideoCoursesConnection: VideoCourseConnection;
  /**
   * Unpublish many VideoLesson documents
   * @deprecated Please use the new paginated many mutation (unpublishManyVideoLessonsConnection)
   */
  unpublishManyVideoLessons: BatchPayload;
  /** Find many VideoLesson documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyVideoLessonsConnection: VideoLessonConnection;
  /**
   * Unpublish many VideoListEntry documents
   * @deprecated Please use the new paginated many mutation (unpublishManyVideoListEntriesConnection)
   */
  unpublishManyVideoListEntries: BatchPayload;
  /** Find many VideoListEntry documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyVideoListEntriesConnection: VideoListEntryConnection;
  /**
   * Unpublish many VideoList documents
   * @deprecated Please use the new paginated many mutation (unpublishManyVideoListsConnection)
   */
  unpublishManyVideoLists: BatchPayload;
  /** Find many VideoList documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyVideoListsConnection: VideoListConnection;
  /**
   * Unpublish many VideoPlaylist documents
   * @deprecated Please use the new paginated many mutation (unpublishManyVideoPlaylistsConnection)
   */
  unpublishManyVideoPlaylists: BatchPayload;
  /** Find many VideoPlaylist documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyVideoPlaylistsConnection: VideoPlaylistConnection;
  /**
   * Unpublish many Video documents
   * @deprecated Please use the new paginated many mutation (unpublishManyVideosConnection)
   */
  unpublishManyVideos: BatchPayload;
  /** Find many Video documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyVideosConnection: VideoConnection;
  /**
   * Unpublish one person from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishPerson?: Maybe<Person>;
  /**
   * Unpublish one playlist from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishPlaylist?: Maybe<Playlist>;
  /**
   * Unpublish one podcastEpisode from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishPodcastEpisode?: Maybe<PodcastEpisode>;
  /**
   * Unpublish one productName from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishProductName?: Maybe<ProductName>;
  /**
   * Unpublish one review from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishReview?: Maybe<Review>;
  /**
   * Unpublish one supportArticle from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishSupportArticle?: Maybe<SupportArticle>;
  /**
   * Unpublish one supportCategory from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishSupportCategory?: Maybe<SupportCategory>;
  /**
   * Unpublish one term from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishTerm?: Maybe<Term>;
  /**
   * Unpublish one video from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishVideo?: Maybe<Video>;
  /**
   * Unpublish one videoCourse from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishVideoCourse?: Maybe<VideoCourse>;
  /**
   * Unpublish one videoCourseListEntry from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishVideoCourseListEntry?: Maybe<VideoCourseListEntry>;
  /**
   * Unpublish one videoLesson from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishVideoLesson?: Maybe<VideoLesson>;
  /**
   * Unpublish one videoList from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishVideoList?: Maybe<VideoList>;
  /**
   * Unpublish one videoListEntry from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishVideoListEntry?: Maybe<VideoListEntry>;
  /**
   * Unpublish one videoPlaylist from selected stages. Unpublish either the
   * complete document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishVideoPlaylist?: Maybe<VideoPlaylist>;
  /** Update one article */
  updateArticle?: Maybe<Article>;
  /** Update one asset */
  updateAsset?: Maybe<Asset>;
  /** Update one benefit */
  updateBenefit?: Maybe<Benefit>;
  /** Update one bootcampEvent */
  updateBootcampEvent?: Maybe<BootcampEvent>;
  /** Update one businessStage */
  updateBusinessStage?: Maybe<BusinessStage>;
  /** Update one coachProfile */
  updateCoachProfile?: Maybe<CoachProfile>;
  updateCoachingEnrollmentCoach?: Maybe<UpdateCoachingEnrollmentCoachPayload>;
  updateCoachingEnrollmentConcierge?: Maybe<UpdateCoachingEnrollmentConciergePayload>;
  updateComment?: Maybe<UpdateCommentPayload>;
  /** Update one contentTrack */
  updateContentTrack?: Maybe<ContentTrack>;
  /** Update one contentTrackSection */
  updateContentTrackSection?: Maybe<ContentTrackSection>;
  /** Update one contentTrackStep */
  updateContentTrackStep?: Maybe<ContentTrackStep>;
  /** Update one contentTrackTask */
  updateContentTrackTask?: Maybe<ContentTrackTask>;
  /** Update one founderTrack */
  updateFounderTrack?: Maybe<FounderTrack>;
  /** Update one founderTrackStep */
  updateFounderTrackStep?: Maybe<FounderTrackStep>;
  /** Update one founderTrackTask */
  updateFounderTrackTask?: Maybe<FounderTrackTask>;
  updateGroupEvent?: Maybe<UpdateGroupEventPayload>;
  updateGroupGoal?: Maybe<UpdateGroupGoalPayload>;
  updateGroupMemberReview?: Maybe<UpdateGroupMemberReviewPayload>;
  /** Update one link */
  updateLink?: Maybe<Link>;
  /**
   * Update many articles
   * @deprecated Please use the new paginated many mutation (updateManyArticlesConnection)
   */
  updateManyArticles: BatchPayload;
  /** Update many Article documents */
  updateManyArticlesConnection: ArticleConnection;
  /**
   * Update many assets
   * @deprecated Please use the new paginated many mutation (updateManyAssetsConnection)
   */
  updateManyAssets: BatchPayload;
  /** Update many Asset documents */
  updateManyAssetsConnection: AssetConnection;
  /**
   * Update many benefits
   * @deprecated Please use the new paginated many mutation (updateManyBenefitsConnection)
   */
  updateManyBenefits: BatchPayload;
  /** Update many Benefit documents */
  updateManyBenefitsConnection: BenefitConnection;
  /**
   * Update many bootcampEvents
   * @deprecated Please use the new paginated many mutation (updateManyBootcampEventsConnection)
   */
  updateManyBootcampEvents: BatchPayload;
  /** Update many BootcampEvent documents */
  updateManyBootcampEventsConnection: BootcampEventConnection;
  /**
   * Update many businessStages
   * @deprecated Please use the new paginated many mutation (updateManyBusinessStagesConnection)
   */
  updateManyBusinessStages: BatchPayload;
  /** Update many BusinessStage documents */
  updateManyBusinessStagesConnection: BusinessStageConnection;
  /**
   * Update many coachProfiles
   * @deprecated Please use the new paginated many mutation (updateManyCoachProfilesConnection)
   */
  updateManyCoachProfiles: BatchPayload;
  /** Update many CoachProfile documents */
  updateManyCoachProfilesConnection: CoachProfileConnection;
  /**
   * Update many contentTrackSections
   * @deprecated Please use the new paginated many mutation (updateManyContentTrackSectionsConnection)
   */
  updateManyContentTrackSections: BatchPayload;
  /** Update many ContentTrackSection documents */
  updateManyContentTrackSectionsConnection: ContentTrackSectionConnection;
  /**
   * Update many contentTrackSteps
   * @deprecated Please use the new paginated many mutation (updateManyContentTrackStepsConnection)
   */
  updateManyContentTrackSteps: BatchPayload;
  /** Update many ContentTrackStep documents */
  updateManyContentTrackStepsConnection: ContentTrackStepConnection;
  /**
   * Update many contentTrackTasks
   * @deprecated Please use the new paginated many mutation (updateManyContentTrackTasksConnection)
   */
  updateManyContentTrackTasks: BatchPayload;
  /** Update many ContentTrackTask documents */
  updateManyContentTrackTasksConnection: ContentTrackTaskConnection;
  /**
   * Update many contentTracks
   * @deprecated Please use the new paginated many mutation (updateManyContentTracksConnection)
   */
  updateManyContentTracks: BatchPayload;
  /** Update many ContentTrack documents */
  updateManyContentTracksConnection: ContentTrackConnection;
  /**
   * Update many founderTrackSteps
   * @deprecated Please use the new paginated many mutation (updateManyFounderTrackStepsConnection)
   */
  updateManyFounderTrackSteps: BatchPayload;
  /** Update many FounderTrackStep documents */
  updateManyFounderTrackStepsConnection: FounderTrackStepConnection;
  /**
   * Update many founderTrackTasks
   * @deprecated Please use the new paginated many mutation (updateManyFounderTrackTasksConnection)
   */
  updateManyFounderTrackTasks: BatchPayload;
  /** Update many FounderTrackTask documents */
  updateManyFounderTrackTasksConnection: FounderTrackTaskConnection;
  /**
   * Update many founderTracks
   * @deprecated Please use the new paginated many mutation (updateManyFounderTracksConnection)
   */
  updateManyFounderTracks: BatchPayload;
  /** Update many FounderTrack documents */
  updateManyFounderTracksConnection: FounderTrackConnection;
  /**
   * Update many links
   * @deprecated Please use the new paginated many mutation (updateManyLinksConnection)
   */
  updateManyLinks: BatchPayload;
  /** Update many Link documents */
  updateManyLinksConnection: LinkConnection;
  /**
   * Update many persons
   * @deprecated Please use the new paginated many mutation (updateManyPersonsConnection)
   */
  updateManyPersons: BatchPayload;
  /** Update many Person documents */
  updateManyPersonsConnection: PersonConnection;
  /**
   * Update many playlists
   * @deprecated Please use the new paginated many mutation (updateManyPlaylistsConnection)
   */
  updateManyPlaylists: BatchPayload;
  /** Update many Playlist documents */
  updateManyPlaylistsConnection: PlaylistConnection;
  /**
   * Update many podcastEpisodes
   * @deprecated Please use the new paginated many mutation (updateManyPodcastEpisodesConnection)
   */
  updateManyPodcastEpisodes: BatchPayload;
  /** Update many PodcastEpisode documents */
  updateManyPodcastEpisodesConnection: PodcastEpisodeConnection;
  /**
   * Update many productNames
   * @deprecated Please use the new paginated many mutation (updateManyProductNamesConnection)
   */
  updateManyProductNames: BatchPayload;
  /** Update many ProductName documents */
  updateManyProductNamesConnection: ProductNameConnection;
  /**
   * Update many reviews
   * @deprecated Please use the new paginated many mutation (updateManyReviewsConnection)
   */
  updateManyReviews: BatchPayload;
  /** Update many Review documents */
  updateManyReviewsConnection: ReviewConnection;
  /**
   * Update many supportArticles
   * @deprecated Please use the new paginated many mutation (updateManySupportArticlesConnection)
   */
  updateManySupportArticles: BatchPayload;
  /** Update many SupportArticle documents */
  updateManySupportArticlesConnection: SupportArticleConnection;
  /**
   * Update many supportCategories
   * @deprecated Please use the new paginated many mutation (updateManySupportCategoriesConnection)
   */
  updateManySupportCategories: BatchPayload;
  /** Update many SupportCategory documents */
  updateManySupportCategoriesConnection: SupportCategoryConnection;
  /**
   * Update many terms
   * @deprecated Please use the new paginated many mutation (updateManyTermsConnection)
   */
  updateManyTerms: BatchPayload;
  /** Update many Term documents */
  updateManyTermsConnection: TermConnection;
  /**
   * Update many videoCourseListEntries
   * @deprecated Please use the new paginated many mutation (updateManyVideoCourseListEntriesConnection)
   */
  updateManyVideoCourseListEntries: BatchPayload;
  /** Update many VideoCourseListEntry documents */
  updateManyVideoCourseListEntriesConnection: VideoCourseListEntryConnection;
  /**
   * Update many videoCourses
   * @deprecated Please use the new paginated many mutation (updateManyVideoCoursesConnection)
   */
  updateManyVideoCourses: BatchPayload;
  /** Update many VideoCourse documents */
  updateManyVideoCoursesConnection: VideoCourseConnection;
  /**
   * Update many videoLessons
   * @deprecated Please use the new paginated many mutation (updateManyVideoLessonsConnection)
   */
  updateManyVideoLessons: BatchPayload;
  /** Update many VideoLesson documents */
  updateManyVideoLessonsConnection: VideoLessonConnection;
  /**
   * Update many videoListEntries
   * @deprecated Please use the new paginated many mutation (updateManyVideoListEntriesConnection)
   */
  updateManyVideoListEntries: BatchPayload;
  /** Update many VideoListEntry documents */
  updateManyVideoListEntriesConnection: VideoListEntryConnection;
  /**
   * Update many videoLists
   * @deprecated Please use the new paginated many mutation (updateManyVideoListsConnection)
   */
  updateManyVideoLists: BatchPayload;
  /** Update many VideoList documents */
  updateManyVideoListsConnection: VideoListConnection;
  /**
   * Update many videoPlaylists
   * @deprecated Please use the new paginated many mutation (updateManyVideoPlaylistsConnection)
   */
  updateManyVideoPlaylists: BatchPayload;
  /** Update many VideoPlaylist documents */
  updateManyVideoPlaylistsConnection: VideoPlaylistConnection;
  /**
   * Update many videos
   * @deprecated Please use the new paginated many mutation (updateManyVideosConnection)
   */
  updateManyVideos: BatchPayload;
  /** Update many Video documents */
  updateManyVideosConnection: VideoConnection;
  /** Update one person */
  updatePerson?: Maybe<Person>;
  /** Update one playlist */
  updatePlaylist?: Maybe<Playlist>;
  /** Update one podcastEpisode */
  updatePodcastEpisode?: Maybe<PodcastEpisode>;
  /** Update one productName */
  updateProductName?: Maybe<ProductName>;
  updateProfile?: Maybe<UpdateProfilePayload>;
  /** Update one review */
  updateReview?: Maybe<Review>;
  /** Update one scheduledRelease */
  updateScheduledRelease?: Maybe<ScheduledRelease>;
  updateStatusOfGroupEvent?: Maybe<UpdateStatusOfGroupEventPayload>;
  updateSubscriptionPayment?: Maybe<Scalars['String']['output']>;
  /** Update one supportArticle */
  updateSupportArticle?: Maybe<SupportArticle>;
  /** Update one supportCategory */
  updateSupportCategory?: Maybe<SupportCategory>;
  /** Update one term */
  updateTerm?: Maybe<Term>;
  updateThread?: Maybe<UpdateThreadPayload>;
  updateUserActiveSprint?: Maybe<UpdateUserActiveSprintPayload>;
  updateUserEmail?: Maybe<UpdateUserEmailPayload>;
  updateUserLearningGoals?: Maybe<UpdateUserLearningGoalsPayload>;
  updateUserNetworkingSetting?: Maybe<UpdateUserNetworkingSettingPayload>;
  updateUserPassword?: Maybe<UpdateUserPasswordPayload>;
  updateUserPresence?: Maybe<UpdateUserPresencePayload>;
  /** Update one video */
  updateVideo?: Maybe<Video>;
  /** Update one videoCourse */
  updateVideoCourse?: Maybe<VideoCourse>;
  /** Update one videoCourseListEntry */
  updateVideoCourseListEntry?: Maybe<VideoCourseListEntry>;
  /** Update one videoLesson */
  updateVideoLesson?: Maybe<VideoLesson>;
  /** Update one videoList */
  updateVideoList?: Maybe<VideoList>;
  /** Update one videoListEntry */
  updateVideoListEntry?: Maybe<VideoListEntry>;
  /** Update one videoPlaylist */
  updateVideoPlaylist?: Maybe<VideoPlaylist>;
  upsertAdvisorAgreement?: Maybe<UpsertAdvisorAgreementPayload>;
  upsertAdvisorEngagement?: Maybe<UpsertAdvisorEngagementPayload>;
  upsertAdvisorProfile?: Maybe<UpsertAdvisorProfilePayload>;
  /** Upsert one article */
  upsertArticle?: Maybe<Article>;
  /** Upsert one asset */
  upsertAsset?: Maybe<Asset>;
  upsertAttachmentUserPresence?: Maybe<UpsertAttachmentUserPresencePayload>;
  /** Upsert one benefit */
  upsertBenefit?: Maybe<Benefit>;
  upsertBootcampEnrollment?: Maybe<UpsertBootcampEnrollmentPayload>;
  /** Upsert one bootcampEvent */
  upsertBootcampEvent?: Maybe<BootcampEvent>;
  upsertBootcampResponse?: Maybe<UpsertBootcampResponsePayload>;
  upsertBootcampShare?: Maybe<UpsertBootcampSharePayload>;
  upsertBootcampStatus?: Maybe<UpsertBootcampStatusPayload>;
  /** Upsert one businessStage */
  upsertBusinessStage?: Maybe<BusinessStage>;
  upsertChatComment?: Maybe<UpsertChatCommentPayload>;
  /** Upsert one coachProfile */
  upsertCoachProfile?: Maybe<CoachProfile>;
  upsertCoachingEnrollment?: Maybe<UpsertCoachingEnrollmentPayload>;
  upsertCompany?: Maybe<UpsertCompanyPayload>;
  /** Upsert one contentTrack */
  upsertContentTrack?: Maybe<ContentTrack>;
  upsertContentTrackEnrollment?: Maybe<UpsertContentTrackEnrollmentPayload>;
  upsertContentTrackResponse?: Maybe<UpsertContentTrackResponsePayload>;
  /** Upsert one contentTrackSection */
  upsertContentTrackSection?: Maybe<ContentTrackSection>;
  /** Upsert one contentTrackStep */
  upsertContentTrackStep?: Maybe<ContentTrackStep>;
  /** Upsert one contentTrackTask */
  upsertContentTrackTask?: Maybe<ContentTrackTask>;
  upsertCrmSavedReply?: Maybe<UpsertCrmSavedReplyPayload>;
  upsertDirectChatThread?: Maybe<UpsertDirectChatThreadPayload>;
  upsertEmailSender?: Maybe<UpsertEmailSenderPayload>;
  upsertFGProfile?: Maybe<UpsertFgProfilePayload>;
  /** Upsert one founderTrack */
  upsertFounderTrack?: Maybe<FounderTrack>;
  /** Upsert one founderTrackStep */
  upsertFounderTrackStep?: Maybe<FounderTrackStep>;
  /** Upsert one founderTrackTask */
  upsertFounderTrackTask?: Maybe<FounderTrackTask>;
  upsertGroup?: Maybe<UpsertGroupPayload>;
  upsertGroupCandidate?: Maybe<UpsertGroupCandidatePayload>;
  upsertGroupCommitment?: Maybe<UpsertGroupCommitmentPayload>;
  upsertGroupEvent?: Maybe<UpsertGroupEventPayload>;
  upsertGroupEventAttendance?: Maybe<UpsertGroupEventAttendancePayload>;
  upsertGroupGoal?: Maybe<UpsertGroupGoalPayload>;
  upsertGroupMembership?: Maybe<UpsertGroupMembershipPayload>;
  upsertGroupPost?: Maybe<UpsertGroupPostPayload>;
  upsertGroupRequest?: Maybe<UpsertGroupRequestPayload>;
  upsertGroupTrackStatus?: Maybe<UpsertGroupTrackStatusPayload>;
  upsertInvestorMatch?: Maybe<UpsertInvestorMatchPayload>;
  upsertInvestorMessage?: Maybe<UpsertInvestorMessagePayload>;
  upsertInvestorProfile?: Maybe<UpsertInvestorProfilePayload>;
  upsertInvestorProfileContact?: Maybe<UpsertInvestorProfileContactPayload>;
  upsertInvestorSearch?: Maybe<UpsertInvestorSearchPayload>;
  /** Upsert one link */
  upsertLink?: Maybe<Link>;
  /** Upsert one person */
  upsertPerson?: Maybe<Person>;
  /** Upsert one playlist */
  upsertPlaylist?: Maybe<Playlist>;
  /** Upsert one podcastEpisode */
  upsertPodcastEpisode?: Maybe<PodcastEpisode>;
  /** Upsert one productName */
  upsertProductName?: Maybe<ProductName>;
  upsertRagCollection?: Maybe<UpsertRagCollectionPayload>;
  upsertRagSource?: Maybe<UpsertRagSourcePayload>;
  upsertRating?: Maybe<UpsertRatingPayload>;
  /** Upsert one review */
  upsertReview?: Maybe<Review>;
  upsertSalesEvent?: Maybe<UpsertSalesEventPayload>;
  upsertScoAiAction?: Maybe<UpsertScoAiActionPayload>;
  upsertScoAnalyticsSavedReport?: Maybe<UpsertScoAnalyticsSavedReportPayload>;
  upsertScoCustomerChannel?: Maybe<UpsertScoCustomerChannelPayload>;
  upsertScoCustomerExperiment?: Maybe<UpsertScoCustomerExperimentPayload>;
  upsertScoCustomerExperimentCheckin?: Maybe<UpsertScoCustomerExperimentCheckinPayload>;
  upsertScoCustomerSearch?: Maybe<UpsertScoCustomerSearchPayload>;
  upsertScoPitchDeck?: Maybe<UpsertScoPitchDeckPayload>;
  upsertScoPitchDeckAudit?: Maybe<UpsertScoPitchDeckAuditPayload>;
  upsertScoPitchDeckAuditSlide?: Maybe<UpsertScoPitchDeckAuditSlidePayload>;
  upsertSignupRequest?: Maybe<UpsertSignupRequestPayload>;
  upsertStoredFile?: Maybe<UpsertStoredFilePayload>;
  /** Upsert one supportArticle */
  upsertSupportArticle?: Maybe<SupportArticle>;
  /** Upsert one supportCategory */
  upsertSupportCategory?: Maybe<SupportCategory>;
  upsertTask?: Maybe<UpsertTaskPayload>;
  upsertTaskTemplate?: Maybe<UpsertTaskTemplatePayload>;
  /** Upsert one term */
  upsertTerm?: Maybe<Term>;
  upsertThread?: Maybe<UpsertThreadPayload>;
  upsertTool?: Maybe<UpsertToolPayload>;
  upsertToolCapability?: Maybe<UpsertToolCapabilityPayload>;
  upsertToolDraft?: Maybe<UpsertToolDraftPayload>;
  upsertToolInput?: Maybe<UpsertToolInputPayload>;
  upsertToolKnowledgeCard?: Maybe<UpsertToolKnowledgeCardPayload>;
  upsertToolOutput?: Maybe<UpsertToolOutputPayload>;
  upsertToolReplyTemplate?: Maybe<UpsertToolReplyTemplatePayload>;
  upsertToolRule?: Maybe<UpsertToolRulePayload>;
  upsertToolRuleBinding?: Maybe<UpsertToolRuleBindingPayload>;
  upsertToolSession?: Maybe<UpsertToolSessionPayload>;
  upsertUser?: Maybe<UpsertUserPayload>;
  upsertUserDevice?: Maybe<UpsertUserDevicePayload>;
  upsertUserExperience?: Maybe<UpsertUserExperiencePayload>;
  upsertUserFounderNeeds?: Maybe<UpsertUserFounderNeedsPayload>;
  upsertUserMatch?: Maybe<UpsertUserMatchPayload>;
  upsertUserPreference?: Maybe<UpsertUserPreferencePayload>;
  upsertUserPreferences?: Maybe<UpsertUserPreferencesPayload>;
  upsertUserPreferredInteractions?: Maybe<UpsertUserPreferredInteractionsPayload>;
  upsertUserSearch?: Maybe<UpsertUserSearchPayload>;
  upsertUserSkill?: Maybe<UpsertUserSkillPayload>;
  upsertUserSkills?: Maybe<UpsertUserSkillsPayload>;
  /** Upsert one video */
  upsertVideo?: Maybe<Video>;
  /** Upsert one videoCourse */
  upsertVideoCourse?: Maybe<VideoCourse>;
  /** Upsert one videoCourseListEntry */
  upsertVideoCourseListEntry?: Maybe<VideoCourseListEntry>;
  /** Upsert one videoLesson */
  upsertVideoLesson?: Maybe<VideoLesson>;
  /** Upsert one videoList */
  upsertVideoList?: Maybe<VideoList>;
  /** Upsert one videoListEntry */
  upsertVideoListEntry?: Maybe<VideoListEntry>;
  /** Upsert one videoPlaylist */
  upsertVideoPlaylist?: Maybe<VideoPlaylist>;
  upsertView?: Maybe<UpsertViewPayload>;
  viewNotification?: Maybe<ViewNotificationPayload>;
  withdrawBoardInvite?: Maybe<WithdrawBoardInvitePayload>;
};


export type MutationAcceptBootcampShareArgs = {
  input: AcceptBootcampShareInput;
};


export type MutationAcceptToolTestRunArgs = {
  input: AcceptToolTestRunInput;
};


export type MutationAddCrmInboxArgs = {
  input: AddCrmInboxInput;
};


export type MutationAddUserSkillArgs = {
  input: AddUserSkillInput;
};


export type MutationAdminBanUserArgs = {
  input: AdminBanUserInput;
};


export type MutationAdminCancelSubscriptionArgs = {
  input: AdminCancelSubscriptionInput;
};


export type MutationAdminReassignRecordArgs = {
  input: AdminReassignRecordInput;
};


export type MutationAdminRefundAdvisorSessionArgs = {
  input: AdminRefundAdvisorSessionInput;
};


export type MutationAdminRefundPaymentArgs = {
  input: AdminRefundPaymentInput;
};


export type MutationAdminRemindAdvisorSessionPendingPartyArgs = {
  input: AdminRemindAdvisorSessionPendingPartyInput;
};


export type MutationAdminRemoveGroupEventAttendanceArgs = {
  input: AdminRemoveGroupEventAttendanceInput;
};


export type MutationAdminRemoveSocialConnectionArgs = {
  input: AdminRemoveSocialConnectionInput;
};


export type MutationAdminRemoveUserBanArgs = {
  input: AdminRemoveUserBanInput;
};


export type MutationAdminRemoveUserPhotoArgs = {
  input: AdminRemoveUserPhotoInput;
};


export type MutationAdminResyncGroupEventToGoogleCalendarArgs = {
  input: AdminResyncGroupEventToGoogleCalendarInput;
};


export type MutationAdminUpdateAdvisorEngagementArgs = {
  input: AdminUpdateAdvisorEngagementInput;
};


export type MutationAdminUpdateAdvisorProfileArgs = {
  input: AdminUpdateAdvisorProfileInput;
};


export type MutationAdminUpdateCompanyArgs = {
  input: AdminUpdateCompanyInput;
};


export type MutationAdminUpdateFgChargifyBillingArgs = {
  input: AdminUpdateFgChargifyBillingInput;
};


export type MutationAdminUpdateFgMemberChargifyBillingArgs = {
  input: AdminUpdateFgMemberChargifyBillingInput;
};


export type MutationAdminUpdateProfileArgs = {
  input: AdminUpdateProfileInput;
};


export type MutationAnalyzeScoCustomerExperimentArgs = {
  input: AnalyzeScoCustomerExperimentInput;
};


export type MutationApplyCancellationDiscountArgs = {
  input: ApplyCancellationDiscountInput;
};


export type MutationApplyToBoardSeatArgs = {
  input: ApplyToBoardSeatInput;
};


export type MutationApplyToolStudioEditArgs = {
  input: ApplyToolStudioEditInput;
};


export type MutationApproveGroupRequestArgs = {
  input: ApproveGroupRequestInput;
};


export type MutationAttachChargifySubscriptionArgs = {
  input: AttachChargifySubscriptionInput;
};


export type MutationBulkCreateInvestorProfileUserSaveArgs = {
  input: BulkCreateInvestorProfileUserSaveInput;
};


export type MutationBulkUpsertInvestorMatchesArgs = {
  input: BulkUpsertInvestorMatchesInput;
};


export type MutationCancelAdvisorSessionArgs = {
  input: CancelAdvisorSessionInput;
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationChangeEmailNotificationScheduleArgs = {
  input: ChangeEmailNotificationScheduleInput;
};


export type MutationChangeSubscriptionProductArgs = {
  input: ChangeSubscriptionProductInput;
};


export type MutationChangeSubscriptionScoProductArgs = {
  input: ChangeSubscriptionScoProductInput;
};


export type MutationCheckCrmConversationArgs = {
  input: CheckCrmConversationInput;
};


export type MutationClaimClarityAdvisorImportArgs = {
  input: ClaimClarityAdvisorImportInput;
};


export type MutationClaimCrmThreadArgs = {
  input: ClaimCrmThreadInput;
};


export type MutationCompleteAdvisorSessionArgs = {
  input: CompleteAdvisorSessionInput;
};


export type MutationConfirmAdvisorSessionPrechargeArgs = {
  input: ConfirmAdvisorSessionPrechargeInput;
};


export type MutationConfirmAdvisorSessionScheduleArgs = {
  input: ConfirmAdvisorSessionScheduleInput;
};


export type MutationConfirmScoCustomerSearchSegmentsArgs = {
  input: ConfirmScoCustomerSearchSegmentsInput;
};


export type MutationCreateAdvisorConnectOnboardingLinkArgs = {
  input: CreateAdvisorConnectOnboardingLinkInput;
};


export type MutationCreateAdvisorSessionJoinCredentialsArgs = {
  input: CreateAdvisorSessionJoinCredentialsInput;
};


export type MutationCreateArticleArgs = {
  data: ArticleCreateInput;
};


export type MutationCreateAssetArgs = {
  data: AssetCreateInput;
};


export type MutationCreateBenefitArgs = {
  data: BenefitCreateInput;
};


export type MutationCreateBootcampEventArgs = {
  data: BootcampEventCreateInput;
};


export type MutationCreateBusinessStageArgs = {
  data: BusinessStageCreateInput;
};


export type MutationCreateCoachProfileArgs = {
  data: CoachProfileCreateInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateContentTrackArgs = {
  data: ContentTrackCreateInput;
};


export type MutationCreateContentTrackSectionArgs = {
  data: ContentTrackSectionCreateInput;
};


export type MutationCreateContentTrackStepArgs = {
  data: ContentTrackStepCreateInput;
};


export type MutationCreateContentTrackTaskArgs = {
  data: ContentTrackTaskCreateInput;
};


export type MutationCreateCourseEnrollmentArgs = {
  input: CreateCourseEnrollmentInput;
};


export type MutationCreateFlagArgs = {
  input: CreateFlagInput;
};


export type MutationCreateFounderTrackArgs = {
  data: FounderTrackCreateInput;
};


export type MutationCreateFounderTrackStepArgs = {
  data: FounderTrackStepCreateInput;
};


export type MutationCreateFounderTrackTaskArgs = {
  data: FounderTrackTaskCreateInput;
};


export type MutationCreateGroupCommentArgs = {
  input: CreateGroupCommentInput;
};


export type MutationCreateGroupMemberArgs = {
  input: CreateGroupMemberInput;
};


export type MutationCreateGroupMemberReviewArgs = {
  input: CreateGroupMemberReviewInput;
};


export type MutationCreateGroupThreadArgs = {
  input: CreateGroupThreadInput;
};


export type MutationCreateLinkArgs = {
  data: LinkCreateInput;
};


export type MutationCreateLinkedAccountArgs = {
  input: CreateLinkedAccountInput;
};


export type MutationCreatePersonArgs = {
  data: PersonCreateInput;
};


export type MutationCreatePlaylistArgs = {
  data: PlaylistCreateInput;
};


export type MutationCreatePodcastEpisodeArgs = {
  data: PodcastEpisodeCreateInput;
};


export type MutationCreateProductNameArgs = {
  data: ProductNameCreateInput;
};


export type MutationCreateProvisionedAccountArgs = {
  input: CreateProvisionedAccountInput;
};


export type MutationCreateReviewArgs = {
  data: ReviewCreateInput;
};


export type MutationCreateScheduledReleaseArgs = {
  data: ScheduledReleaseCreateInput;
};


export type MutationCreateStripePaymentIntentArgs = {
  input: CreateStripePaymentIntentInput;
};


export type MutationCreateSubscriptionChangeChargebeeHostedPageArgs = {
  input: CreateSubscriptionChangeChargebeeHostedPageInput;
};


export type MutationCreateSupportArticleArgs = {
  data: SupportArticleCreateInput;
};


export type MutationCreateSupportCategoryArgs = {
  data: SupportCategoryCreateInput;
};


export type MutationCreateTermArgs = {
  data: TermCreateInput;
};


export type MutationCreateThreadArgs = {
  input: CreateThreadInput;
};


export type MutationCreateUserAuthTokenArgs = {
  input: CreateUserAuthTokenInput;
};


export type MutationCreateVideoArgs = {
  data: VideoCreateInput;
};


export type MutationCreateVideoCourseArgs = {
  data: VideoCourseCreateInput;
};


export type MutationCreateVideoCourseListEntryArgs = {
  data: VideoCourseListEntryCreateInput;
};


export type MutationCreateVideoLessonArgs = {
  data: VideoLessonCreateInput;
};


export type MutationCreateVideoListArgs = {
  data: VideoListCreateInput;
};


export type MutationCreateVideoListEntryArgs = {
  data: VideoListEntryCreateInput;
};


export type MutationCreateVideoPlaylistArgs = {
  data: VideoPlaylistCreateInput;
};


export type MutationCreateViewArgs = {
  input: CreateViewInput;
};


export type MutationDealsPartnerArgs = {
  input: DealsPartnerInput;
};


export type MutationDelaySubscriptionRenewalArgs = {
  input: DelaySubscriptionRenewalInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteAdvisorAgreementArgs = {
  input: DeleteAdvisorAgreementInput;
};


export type MutationDeleteArticleArgs = {
  where: ArticleWhereUniqueInput;
};


export type MutationDeleteAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type MutationDeleteBenefitArgs = {
  where: BenefitWhereUniqueInput;
};


export type MutationDeleteBootcampEventArgs = {
  where: BootcampEventWhereUniqueInput;
};


export type MutationDeleteBootcampShareArgs = {
  input: DeleteBootcampShareInput;
};


export type MutationDeleteBusinessStageArgs = {
  where: BusinessStageWhereUniqueInput;
};


export type MutationDeleteCoachProfileArgs = {
  where: CoachProfileWhereUniqueInput;
};


export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type MutationDeleteContentTrackArgs = {
  where: ContentTrackWhereUniqueInput;
};


export type MutationDeleteContentTrackSectionArgs = {
  where: ContentTrackSectionWhereUniqueInput;
};


export type MutationDeleteContentTrackStepArgs = {
  where: ContentTrackStepWhereUniqueInput;
};


export type MutationDeleteContentTrackTaskArgs = {
  where: ContentTrackTaskWhereUniqueInput;
};


export type MutationDeleteCrmSavedReplyArgs = {
  input: DeleteCrmSavedReplyInput;
};


export type MutationDeleteFounderTrackArgs = {
  where: FounderTrackWhereUniqueInput;
};


export type MutationDeleteFounderTrackStepArgs = {
  where: FounderTrackStepWhereUniqueInput;
};


export type MutationDeleteFounderTrackTaskArgs = {
  where: FounderTrackTaskWhereUniqueInput;
};


export type MutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};


export type MutationDeleteGroupEventArgs = {
  input: DeleteGroupEventInput;
};


export type MutationDeleteGroupGoalArgs = {
  input: DeleteGroupGoalInput;
};


export type MutationDeleteGroupMemberReviewArgs = {
  input: DeleteGroupMemberReviewInput;
};


export type MutationDeleteGroupMembershipArgs = {
  input: DeleteGroupMembershipInput;
};


export type MutationDeleteLinkArgs = {
  where: LinkWhereUniqueInput;
};


export type MutationDeleteManyArticlesArgs = {
  where?: InputMaybe<ArticleManyWhereInput>;
};


export type MutationDeleteManyArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleManyWhereInput>;
};


export type MutationDeleteManyAssetsArgs = {
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyBenefitsArgs = {
  where?: InputMaybe<BenefitManyWhereInput>;
};


export type MutationDeleteManyBenefitsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BenefitManyWhereInput>;
};


export type MutationDeleteManyBootcampEventsArgs = {
  where?: InputMaybe<BootcampEventManyWhereInput>;
};


export type MutationDeleteManyBootcampEventsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BootcampEventManyWhereInput>;
};


export type MutationDeleteManyBusinessStagesArgs = {
  where?: InputMaybe<BusinessStageManyWhereInput>;
};


export type MutationDeleteManyBusinessStagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BusinessStageManyWhereInput>;
};


export type MutationDeleteManyCoachProfilesArgs = {
  where?: InputMaybe<CoachProfileManyWhereInput>;
};


export type MutationDeleteManyCoachProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CoachProfileManyWhereInput>;
};


export type MutationDeleteManyContentTrackSectionsArgs = {
  where?: InputMaybe<ContentTrackSectionManyWhereInput>;
};


export type MutationDeleteManyContentTrackSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackSectionManyWhereInput>;
};


export type MutationDeleteManyContentTrackStepsArgs = {
  where?: InputMaybe<ContentTrackStepManyWhereInput>;
};


export type MutationDeleteManyContentTrackStepsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackStepManyWhereInput>;
};


export type MutationDeleteManyContentTrackTasksArgs = {
  where?: InputMaybe<ContentTrackTaskManyWhereInput>;
};


export type MutationDeleteManyContentTrackTasksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackTaskManyWhereInput>;
};


export type MutationDeleteManyContentTracksArgs = {
  where?: InputMaybe<ContentTrackManyWhereInput>;
};


export type MutationDeleteManyContentTracksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackManyWhereInput>;
};


export type MutationDeleteManyFounderTrackStepsArgs = {
  where?: InputMaybe<FounderTrackStepManyWhereInput>;
};


export type MutationDeleteManyFounderTrackStepsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FounderTrackStepManyWhereInput>;
};


export type MutationDeleteManyFounderTrackTasksArgs = {
  where?: InputMaybe<FounderTrackTaskManyWhereInput>;
};


export type MutationDeleteManyFounderTrackTasksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FounderTrackTaskManyWhereInput>;
};


export type MutationDeleteManyFounderTracksArgs = {
  where?: InputMaybe<FounderTrackManyWhereInput>;
};


export type MutationDeleteManyFounderTracksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FounderTrackManyWhereInput>;
};


export type MutationDeleteManyLinksArgs = {
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationDeleteManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationDeleteManyPersonsArgs = {
  where?: InputMaybe<PersonManyWhereInput>;
};


export type MutationDeleteManyPersonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonManyWhereInput>;
};


export type MutationDeleteManyPlaylistsArgs = {
  where?: InputMaybe<PlaylistManyWhereInput>;
};


export type MutationDeleteManyPlaylistsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PlaylistManyWhereInput>;
};


export type MutationDeleteManyPodcastEpisodesArgs = {
  where?: InputMaybe<PodcastEpisodeManyWhereInput>;
};


export type MutationDeleteManyPodcastEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PodcastEpisodeManyWhereInput>;
};


export type MutationDeleteManyProductNamesArgs = {
  where?: InputMaybe<ProductNameManyWhereInput>;
};


export type MutationDeleteManyProductNamesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductNameManyWhereInput>;
};


export type MutationDeleteManyReviewsArgs = {
  where?: InputMaybe<ReviewManyWhereInput>;
};


export type MutationDeleteManyReviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReviewManyWhereInput>;
};


export type MutationDeleteManySupportArticlesArgs = {
  where?: InputMaybe<SupportArticleManyWhereInput>;
};


export type MutationDeleteManySupportArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SupportArticleManyWhereInput>;
};


export type MutationDeleteManySupportCategoriesArgs = {
  where?: InputMaybe<SupportCategoryManyWhereInput>;
};


export type MutationDeleteManySupportCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SupportCategoryManyWhereInput>;
};


export type MutationDeleteManyTermsArgs = {
  where?: InputMaybe<TermManyWhereInput>;
};


export type MutationDeleteManyTermsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermManyWhereInput>;
};


export type MutationDeleteManyVideoCourseListEntriesArgs = {
  where?: InputMaybe<VideoCourseListEntryManyWhereInput>;
};


export type MutationDeleteManyVideoCourseListEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoCourseListEntryManyWhereInput>;
};


export type MutationDeleteManyVideoCoursesArgs = {
  where?: InputMaybe<VideoCourseManyWhereInput>;
};


export type MutationDeleteManyVideoCoursesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoCourseManyWhereInput>;
};


export type MutationDeleteManyVideoLessonsArgs = {
  where?: InputMaybe<VideoLessonManyWhereInput>;
};


export type MutationDeleteManyVideoLessonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoLessonManyWhereInput>;
};


export type MutationDeleteManyVideoListEntriesArgs = {
  where?: InputMaybe<VideoListEntryManyWhereInput>;
};


export type MutationDeleteManyVideoListEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoListEntryManyWhereInput>;
};


export type MutationDeleteManyVideoListsArgs = {
  where?: InputMaybe<VideoListManyWhereInput>;
};


export type MutationDeleteManyVideoListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoListManyWhereInput>;
};


export type MutationDeleteManyVideoPlaylistsArgs = {
  where?: InputMaybe<VideoPlaylistManyWhereInput>;
};


export type MutationDeleteManyVideoPlaylistsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoPlaylistManyWhereInput>;
};


export type MutationDeleteManyVideosArgs = {
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationDeleteManyVideosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationDeletePersonArgs = {
  where: PersonWhereUniqueInput;
};


export type MutationDeletePlaylistArgs = {
  where: PlaylistWhereUniqueInput;
};


export type MutationDeletePodcastEpisodeArgs = {
  where: PodcastEpisodeWhereUniqueInput;
};


export type MutationDeleteProductNameArgs = {
  where: ProductNameWhereUniqueInput;
};


export type MutationDeleteReviewArgs = {
  where: ReviewWhereUniqueInput;
};


export type MutationDeleteScheduledOperationArgs = {
  where: ScheduledOperationWhereUniqueInput;
};


export type MutationDeleteScheduledReleaseArgs = {
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationDeleteScoAnalyticsSavedReportArgs = {
  input: DeleteScoAnalyticsSavedReportInput;
};


export type MutationDeleteSocialConnectionArgs = {
  input: DeleteSocialConnectionInput;
};


export type MutationDeleteSupportArticleArgs = {
  where: SupportArticleWhereUniqueInput;
};


export type MutationDeleteSupportCategoryArgs = {
  where: SupportCategoryWhereUniqueInput;
};


export type MutationDeleteTermArgs = {
  where: TermWhereUniqueInput;
};


export type MutationDeleteThreadArgs = {
  input: DeleteThreadInput;
};


export type MutationDeleteToolKnowledgeCardArgs = {
  input: DeleteToolKnowledgeCardInput;
};


export type MutationDeleteToolReplyTemplateArgs = {
  input: DeleteToolReplyTemplateInput;
};


export type MutationDeleteToolRuleArgs = {
  input: DeleteToolRuleInput;
};


export type MutationDeleteVideoArgs = {
  where: VideoWhereUniqueInput;
};


export type MutationDeleteVideoCourseArgs = {
  where: VideoCourseWhereUniqueInput;
};


export type MutationDeleteVideoCourseListEntryArgs = {
  where: VideoCourseListEntryWhereUniqueInput;
};


export type MutationDeleteVideoLessonArgs = {
  where: VideoLessonWhereUniqueInput;
};


export type MutationDeleteVideoListArgs = {
  where: VideoListWhereUniqueInput;
};


export type MutationDeleteVideoListEntryArgs = {
  where: VideoListEntryWhereUniqueInput;
};


export type MutationDeleteVideoPlaylistArgs = {
  where: VideoPlaylistWhereUniqueInput;
};


export type MutationDiscardToolDraftArgs = {
  input: DiscardToolDraftInput;
};


export type MutationDismissCrmThreadArgs = {
  input: DismissCrmThreadInput;
};


export type MutationDismissNotificationArgs = {
  input: DismissNotificationInput;
};


export type MutationDismissNotificationsArgs = {
  input: DismissNotificationsInput;
};


export type MutationDownloadEbookArgs = {
  input: DownloadEbookInput;
};


export type MutationDuplicateScoAnalyticsSavedReportArgs = {
  input: DuplicateScoAnalyticsSavedReportInput;
};


export type MutationEndAdvisorEngagementArgs = {
  input: EndAdvisorEngagementInput;
};


export type MutationEnsureScoPitchDeckSlideChatArgs = {
  input: EnsureScoPitchDeckSlideChatInput;
};


export type MutationExtractAdvisorApplicationFromBioArgs = {
  input: ExtractAdvisorApplicationFromBioInput;
};


export type MutationExtractSkillsForUserArgs = {
  input: ExtractSkillsForUserInput;
};


export type MutationFgJoinEventArgs = {
  input: FgJoinEventInput;
};


export type MutationGenerateCrmReplyArgs = {
  input: GenerateCrmReplyInput;
};


export type MutationHandoffCrmThreadToSupportArgs = {
  input: HandoffCrmThreadToSupportInput;
};


export type MutationInitiateBizplanConnectionArgs = {
  input: InitiateBizplanConnectionInput;
};


export type MutationInitiateLaunchrockConnectionArgs = {
  input: InitiateLaunchrockConnectionInput;
};


export type MutationInviteAdvisorToBoardArgs = {
  input: InviteAdvisorToBoardInput;
};


export type MutationJoinGroupArgs = {
  input: JoinGroupInput;
};


export type MutationLaunchFgProfileArgs = {
  input: LaunchFgProfileInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLoginByPhoneArgs = {
  input: LoginByPhoneInput;
};


export type MutationMarkAdvisorAgreementSignedArgs = {
  input: MarkAdvisorAgreementSignedInput;
};


export type MutationMarkScoCustomerExperimentFirstActionArgs = {
  input: MarkScoCustomerExperimentFirstActionInput;
};


export type MutationNewsletterSignupArgs = {
  input: NewsletterSignupInput;
};


export type MutationNominateStartupsLiveGuestArgs = {
  input: NominateStartupsLiveGuestInput;
};


export type MutationOpenToolThreadArgs = {
  input: OpenToolThreadInput;
};


export type MutationPatchToolCopyArgs = {
  input: PatchToolCopyInput;
};


export type MutationPromoteScoCustomerSegmentArgs = {
  input: PromoteScoCustomerSegmentInput;
};


export type MutationProposeAdvisorSessionScheduleArgs = {
  input: ProposeAdvisorSessionScheduleInput;
};


export type MutationPublishArticleArgs = {
  to?: Array<Stage>;
  where: ArticleWhereUniqueInput;
};


export type MutationPublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishBenefitArgs = {
  to?: Array<Stage>;
  where: BenefitWhereUniqueInput;
};


export type MutationPublishBootcampEventArgs = {
  to?: Array<Stage>;
  where: BootcampEventWhereUniqueInput;
};


export type MutationPublishBusinessStageArgs = {
  to?: Array<Stage>;
  where: BusinessStageWhereUniqueInput;
};


export type MutationPublishCoachProfileArgs = {
  to?: Array<Stage>;
  where: CoachProfileWhereUniqueInput;
};


export type MutationPublishContentTrackArgs = {
  to?: Array<Stage>;
  where: ContentTrackWhereUniqueInput;
};


export type MutationPublishContentTrackSectionArgs = {
  to?: Array<Stage>;
  where: ContentTrackSectionWhereUniqueInput;
};


export type MutationPublishContentTrackStepArgs = {
  to?: Array<Stage>;
  where: ContentTrackStepWhereUniqueInput;
};


export type MutationPublishContentTrackTaskArgs = {
  to?: Array<Stage>;
  where: ContentTrackTaskWhereUniqueInput;
};


export type MutationPublishFounderTrackArgs = {
  to?: Array<Stage>;
  where: FounderTrackWhereUniqueInput;
};


export type MutationPublishFounderTrackStepArgs = {
  to?: Array<Stage>;
  where: FounderTrackStepWhereUniqueInput;
};


export type MutationPublishFounderTrackTaskArgs = {
  to?: Array<Stage>;
  where: FounderTrackTaskWhereUniqueInput;
};


export type MutationPublishLinkArgs = {
  to?: Array<Stage>;
  where: LinkWhereUniqueInput;
};


export type MutationPublishManyArticlesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ArticleManyWhereInput>;
};


export type MutationPublishManyArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ArticleManyWhereInput>;
};


export type MutationPublishManyAssetsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyBenefitsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<BenefitManyWhereInput>;
};


export type MutationPublishManyBenefitsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<BenefitManyWhereInput>;
};


export type MutationPublishManyBootcampEventsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<BootcampEventManyWhereInput>;
};


export type MutationPublishManyBootcampEventsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<BootcampEventManyWhereInput>;
};


export type MutationPublishManyBusinessStagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<BusinessStageManyWhereInput>;
};


export type MutationPublishManyBusinessStagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<BusinessStageManyWhereInput>;
};


export type MutationPublishManyCoachProfilesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CoachProfileManyWhereInput>;
};


export type MutationPublishManyCoachProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CoachProfileManyWhereInput>;
};


export type MutationPublishManyContentTrackSectionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ContentTrackSectionManyWhereInput>;
};


export type MutationPublishManyContentTrackSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ContentTrackSectionManyWhereInput>;
};


export type MutationPublishManyContentTrackStepsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ContentTrackStepManyWhereInput>;
};


export type MutationPublishManyContentTrackStepsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ContentTrackStepManyWhereInput>;
};


export type MutationPublishManyContentTrackTasksArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ContentTrackTaskManyWhereInput>;
};


export type MutationPublishManyContentTrackTasksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ContentTrackTaskManyWhereInput>;
};


export type MutationPublishManyContentTracksArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ContentTrackManyWhereInput>;
};


export type MutationPublishManyContentTracksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ContentTrackManyWhereInput>;
};


export type MutationPublishManyFounderTrackStepsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FounderTrackStepManyWhereInput>;
};


export type MutationPublishManyFounderTrackStepsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FounderTrackStepManyWhereInput>;
};


export type MutationPublishManyFounderTrackTasksArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FounderTrackTaskManyWhereInput>;
};


export type MutationPublishManyFounderTrackTasksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FounderTrackTaskManyWhereInput>;
};


export type MutationPublishManyFounderTracksArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FounderTrackManyWhereInput>;
};


export type MutationPublishManyFounderTracksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FounderTrackManyWhereInput>;
};


export type MutationPublishManyLinksArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationPublishManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationPublishManyPersonsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PersonManyWhereInput>;
};


export type MutationPublishManyPersonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PersonManyWhereInput>;
};


export type MutationPublishManyPlaylistsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PlaylistManyWhereInput>;
};


export type MutationPublishManyPlaylistsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PlaylistManyWhereInput>;
};


export type MutationPublishManyPodcastEpisodesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PodcastEpisodeManyWhereInput>;
};


export type MutationPublishManyPodcastEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PodcastEpisodeManyWhereInput>;
};


export type MutationPublishManyProductNamesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ProductNameManyWhereInput>;
};


export type MutationPublishManyProductNamesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProductNameManyWhereInput>;
};


export type MutationPublishManyReviewsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ReviewManyWhereInput>;
};


export type MutationPublishManyReviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ReviewManyWhereInput>;
};


export type MutationPublishManySupportArticlesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SupportArticleManyWhereInput>;
};


export type MutationPublishManySupportArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SupportArticleManyWhereInput>;
};


export type MutationPublishManySupportCategoriesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SupportCategoryManyWhereInput>;
};


export type MutationPublishManySupportCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SupportCategoryManyWhereInput>;
};


export type MutationPublishManyTermsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TermManyWhereInput>;
};


export type MutationPublishManyTermsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TermManyWhereInput>;
};


export type MutationPublishManyVideoCourseListEntriesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<VideoCourseListEntryManyWhereInput>;
};


export type MutationPublishManyVideoCourseListEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<VideoCourseListEntryManyWhereInput>;
};


export type MutationPublishManyVideoCoursesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<VideoCourseManyWhereInput>;
};


export type MutationPublishManyVideoCoursesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<VideoCourseManyWhereInput>;
};


export type MutationPublishManyVideoLessonsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<VideoLessonManyWhereInput>;
};


export type MutationPublishManyVideoLessonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<VideoLessonManyWhereInput>;
};


export type MutationPublishManyVideoListEntriesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<VideoListEntryManyWhereInput>;
};


export type MutationPublishManyVideoListEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<VideoListEntryManyWhereInput>;
};


export type MutationPublishManyVideoListsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<VideoListManyWhereInput>;
};


export type MutationPublishManyVideoListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<VideoListManyWhereInput>;
};


export type MutationPublishManyVideoPlaylistsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<VideoPlaylistManyWhereInput>;
};


export type MutationPublishManyVideoPlaylistsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<VideoPlaylistManyWhereInput>;
};


export type MutationPublishManyVideosArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationPublishManyVideosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationPublishPersonArgs = {
  to?: Array<Stage>;
  where: PersonWhereUniqueInput;
};


export type MutationPublishPlaylistArgs = {
  to?: Array<Stage>;
  where: PlaylistWhereUniqueInput;
};


export type MutationPublishPodcastEpisodeArgs = {
  to?: Array<Stage>;
  where: PodcastEpisodeWhereUniqueInput;
};


export type MutationPublishProductNameArgs = {
  to?: Array<Stage>;
  where: ProductNameWhereUniqueInput;
};


export type MutationPublishReviewArgs = {
  to?: Array<Stage>;
  where: ReviewWhereUniqueInput;
};


export type MutationPublishSupportArticleArgs = {
  to?: Array<Stage>;
  where: SupportArticleWhereUniqueInput;
};


export type MutationPublishSupportCategoryArgs = {
  to?: Array<Stage>;
  where: SupportCategoryWhereUniqueInput;
};


export type MutationPublishTermArgs = {
  to?: Array<Stage>;
  where: TermWhereUniqueInput;
};


export type MutationPublishVideoArgs = {
  to?: Array<Stage>;
  where: VideoWhereUniqueInput;
};


export type MutationPublishVideoCourseArgs = {
  to?: Array<Stage>;
  where: VideoCourseWhereUniqueInput;
};


export type MutationPublishVideoCourseListEntryArgs = {
  to?: Array<Stage>;
  where: VideoCourseListEntryWhereUniqueInput;
};


export type MutationPublishVideoLessonArgs = {
  to?: Array<Stage>;
  where: VideoLessonWhereUniqueInput;
};


export type MutationPublishVideoListArgs = {
  to?: Array<Stage>;
  where: VideoListWhereUniqueInput;
};


export type MutationPublishVideoListEntryArgs = {
  to?: Array<Stage>;
  where: VideoListEntryWhereUniqueInput;
};


export type MutationPublishVideoPlaylistArgs = {
  to?: Array<Stage>;
  where: VideoPlaylistWhereUniqueInput;
};


export type MutationReanalyzeScoPitchDeckArgs = {
  input: ReanalyzeScoPitchDeckInput;
};


export type MutationRecallToolMessageArgs = {
  input: RecallToolMessageInput;
};


export type MutationRecordScoCustomerExperimentTallyArgs = {
  input: RecordScoCustomerExperimentTallyInput;
};


export type MutationRefreshCrmHubspotSnapshotArgs = {
  input: RefreshCrmHubspotSnapshotInput;
};


export type MutationRefreshCrmMemberSummaryArgs = {
  input: RefreshCrmMemberSummaryInput;
};


export type MutationRegenerateCrmReplyArgs = {
  input: RegenerateCrmReplyInput;
};


export type MutationRegisterUserArgs = {
  input: RegisterUserInput;
};


export type MutationReindexRagSourceArgs = {
  input: ReindexRagSourceInput;
};


export type MutationRejectGroupRequestArgs = {
  input: RejectGroupRequestInput;
};


export type MutationReleaseCrmThreadArgs = {
  input: ReleaseCrmThreadInput;
};


export type MutationRemoveUserSkillArgs = {
  input: RemoveUserSkillInput;
};


export type MutationReopenCrmThreadArgs = {
  input: ReopenCrmThreadInput;
};


export type MutationReorderToolRulesArgs = {
  input: ReorderToolRulesInput;
};


export type MutationReportAdvisorSessionPresenceArgs = {
  input: ReportAdvisorSessionPresenceInput;
};


export type MutationRequestAdvisorPayoutArgs = {
  input: RequestAdvisorPayoutInput;
};


export type MutationRequestAdvisorSessionArgs = {
  input: RequestAdvisorSessionInput;
};


export type MutationRequestConsultationArgs = {
  input: RequestConsultationInput;
};


export type MutationRequestEmailConfirmationArgs = {
  input: RequestEmailConfirmationInput;
};


export type MutationRequestFounderGroupEntryArgs = {
  input: RequestFounderGroupEntryInput;
};


export type MutationRequestFundingConsultationArgs = {
  input: RequestFundingConsultationInput;
};


export type MutationRequestLoginTokenArgs = {
  input: RequestLoginTokenInput;
};


export type MutationRequestMasterclassArgs = {
  input: RequestMasterclassInput;
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationRequestPasswordResetByPhoneArgs = {
  input: RequestPasswordResetByPhoneInput;
};


export type MutationRequestPhoneConfirmationArgs = {
  input: RequestPhoneConfirmationInput;
};


export type MutationRequestSlackInviteArgs = {
  input: RequestSlackInviteInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResolveCrmSupportHandoffArgs = {
  input: ResolveCrmSupportHandoffInput;
};


export type MutationRespondToAdvisorAgreementArgs = {
  input: RespondToAdvisorAgreementInput;
};


export type MutationRespondToBoardInviteArgs = {
  input: RespondToBoardInviteInput;
};


export type MutationRespondToSeatApplicationArgs = {
  input: RespondToSeatApplicationInput;
};


export type MutationReviewAdvisorProfileArgs = {
  input: ReviewAdvisorProfileInput;
};


export type MutationReviseAdvisorAgreementArgs = {
  input: ReviseAdvisorAgreementInput;
};


export type MutationRevokeUserAuthTokenArgs = {
  input: RevokeUserAuthTokenInput;
};


export type MutationRewriteCrmReplyArgs = {
  input: RewriteCrmReplyInput;
};


export type MutationRunScoCustomerChannelGenerationArgs = {
  input: RunScoCustomerChannelGenerationInput;
};


export type MutationRunScoCustomerChannelMessageArgs = {
  input: RunScoCustomerChannelMessageInput;
};


export type MutationRunScoCustomerExperimentGenerationArgs = {
  input: RunScoCustomerExperimentGenerationInput;
};


export type MutationRunScoCustomerSearchStepArgs = {
  input: RunScoCustomerSearchStepInput;
};


export type MutationSchedulePublishArticleArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ArticleWhereUniqueInput;
};


export type MutationSchedulePublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishBenefitArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: BenefitWhereUniqueInput;
};


export type MutationSchedulePublishBootcampEventArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: BootcampEventWhereUniqueInput;
};


export type MutationSchedulePublishBusinessStageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: BusinessStageWhereUniqueInput;
};


export type MutationSchedulePublishCoachProfileArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CoachProfileWhereUniqueInput;
};


export type MutationSchedulePublishContentTrackArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ContentTrackWhereUniqueInput;
};


export type MutationSchedulePublishContentTrackSectionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ContentTrackSectionWhereUniqueInput;
};


export type MutationSchedulePublishContentTrackStepArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ContentTrackStepWhereUniqueInput;
};


export type MutationSchedulePublishContentTrackTaskArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ContentTrackTaskWhereUniqueInput;
};


export type MutationSchedulePublishFounderTrackArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FounderTrackWhereUniqueInput;
};


export type MutationSchedulePublishFounderTrackStepArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FounderTrackStepWhereUniqueInput;
};


export type MutationSchedulePublishFounderTrackTaskArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FounderTrackTaskWhereUniqueInput;
};


export type MutationSchedulePublishLinkArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: LinkWhereUniqueInput;
};


export type MutationSchedulePublishPersonArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PersonWhereUniqueInput;
};


export type MutationSchedulePublishPlaylistArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PlaylistWhereUniqueInput;
};


export type MutationSchedulePublishPodcastEpisodeArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PodcastEpisodeWhereUniqueInput;
};


export type MutationSchedulePublishProductNameArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ProductNameWhereUniqueInput;
};


export type MutationSchedulePublishReviewArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ReviewWhereUniqueInput;
};


export type MutationSchedulePublishSupportArticleArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SupportArticleWhereUniqueInput;
};


export type MutationSchedulePublishSupportCategoryArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SupportCategoryWhereUniqueInput;
};


export type MutationSchedulePublishTermArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TermWhereUniqueInput;
};


export type MutationSchedulePublishVideoArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: VideoWhereUniqueInput;
};


export type MutationSchedulePublishVideoCourseArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: VideoCourseWhereUniqueInput;
};


export type MutationSchedulePublishVideoCourseListEntryArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: VideoCourseListEntryWhereUniqueInput;
};


export type MutationSchedulePublishVideoLessonArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: VideoLessonWhereUniqueInput;
};


export type MutationSchedulePublishVideoListArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: VideoListWhereUniqueInput;
};


export type MutationSchedulePublishVideoListEntryArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: VideoListEntryWhereUniqueInput;
};


export type MutationSchedulePublishVideoPlaylistArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: VideoPlaylistWhereUniqueInput;
};


export type MutationScheduleUnpublishArticleArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ArticleWhereUniqueInput;
};


export type MutationScheduleUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};


export type MutationScheduleUnpublishBenefitArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: BenefitWhereUniqueInput;
};


export type MutationScheduleUnpublishBootcampEventArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: BootcampEventWhereUniqueInput;
};


export type MutationScheduleUnpublishBusinessStageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: BusinessStageWhereUniqueInput;
};


export type MutationScheduleUnpublishCoachProfileArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CoachProfileWhereUniqueInput;
};


export type MutationScheduleUnpublishContentTrackArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ContentTrackWhereUniqueInput;
};


export type MutationScheduleUnpublishContentTrackSectionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ContentTrackSectionWhereUniqueInput;
};


export type MutationScheduleUnpublishContentTrackStepArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ContentTrackStepWhereUniqueInput;
};


export type MutationScheduleUnpublishContentTrackTaskArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ContentTrackTaskWhereUniqueInput;
};


export type MutationScheduleUnpublishFounderTrackArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FounderTrackWhereUniqueInput;
};


export type MutationScheduleUnpublishFounderTrackStepArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FounderTrackStepWhereUniqueInput;
};


export type MutationScheduleUnpublishFounderTrackTaskArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FounderTrackTaskWhereUniqueInput;
};


export type MutationScheduleUnpublishLinkArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: LinkWhereUniqueInput;
};


export type MutationScheduleUnpublishPersonArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: PersonWhereUniqueInput;
};


export type MutationScheduleUnpublishPlaylistArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: PlaylistWhereUniqueInput;
};


export type MutationScheduleUnpublishPodcastEpisodeArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: PodcastEpisodeWhereUniqueInput;
};


export type MutationScheduleUnpublishProductNameArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ProductNameWhereUniqueInput;
};


export type MutationScheduleUnpublishReviewArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ReviewWhereUniqueInput;
};


export type MutationScheduleUnpublishSupportArticleArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SupportArticleWhereUniqueInput;
};


export type MutationScheduleUnpublishSupportCategoryArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SupportCategoryWhereUniqueInput;
};


export type MutationScheduleUnpublishTermArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TermWhereUniqueInput;
};


export type MutationScheduleUnpublishVideoArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: VideoWhereUniqueInput;
};


export type MutationScheduleUnpublishVideoCourseArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: VideoCourseWhereUniqueInput;
};


export type MutationScheduleUnpublishVideoCourseListEntryArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: VideoCourseListEntryWhereUniqueInput;
};


export type MutationScheduleUnpublishVideoLessonArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: VideoLessonWhereUniqueInput;
};


export type MutationScheduleUnpublishVideoListArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: VideoListWhereUniqueInput;
};


export type MutationScheduleUnpublishVideoListEntryArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: VideoListEntryWhereUniqueInput;
};


export type MutationScheduleUnpublishVideoPlaylistArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: VideoPlaylistWhereUniqueInput;
};


export type MutationScoreToolTestRunArgs = {
  input: ScoreToolTestRunInput;
};


export type MutationSendAdvisorAgreementArgs = {
  input: SendAdvisorAgreementInput;
};


export type MutationSendToolMessageArgs = {
  input: SendToolMessageInput;
};


export type MutationSetCrmBookingUrlArgs = {
  input: SetCrmBookingUrlInput;
};


export type MutationSetCrmToolModelArgs = {
  input: SetCrmToolModelInput;
};


export type MutationSetToolReplySettingsArgs = {
  input: SetToolReplySettingsInput;
};


export type MutationSetToolRuleRunLaneArgs = {
  input: SetToolRuleRunLaneInput;
};


export type MutationSetToolServesArgs = {
  input: SetToolServesInput;
};


export type MutationSetUserCrmArgs = {
  input: SetUserCrmInput;
};


export type MutationStartCrmThreadArgs = {
  input: StartCrmThreadInput;
};


export type MutationStartLegacySubscriptionArgs = {
  input: StartLegacySubscriptionInput;
};


export type MutationSubmitAwsActivateRequestArgs = {
  input: SubmitAwsActivateRequestInput;
};


export type MutationSubmitCheckoutArgs = {
  input: SubmitCheckoutInput;
};


export type MutationSubmitCoachEntryArgs = {
  input: SubmitCoachEntryInput;
};


export type MutationSubmitFinancingApplicationArgs = {
  input: SubmitFinancingApplicationInput;
};


export type MutationSubmitGroupRequestArgs = {
  input: SubmitGroupRequestInput;
};


export type MutationSubmitHubspotFormArgs = {
  input: SubmitHubspotFormInput;
};


export type MutationSubmitHubspotNoteArgs = {
  input: SubmitHubspotNoteInput;
};


export type MutationSubmitPitchDeckRequestArgs = {
  input: SubmitPitchDeckRequestInput;
};


export type MutationSubmitPurchaseArgs = {
  input: SubmitPurchaseInput;
};


export type MutationSubmitScoCustomerKnownIntakeArgs = {
  input: SubmitScoCustomerKnownIntakeInput;
};


export type MutationSyncAdvisorAgreementSignatureArgs = {
  input: SyncAdvisorAgreementSignatureInput;
};


export type MutationSyncFgProfileArgs = {
  input: SyncFgProfileInput;
};


export type MutationSyncRagCollectionArgs = {
  input: SyncRagCollectionInput;
};


export type MutationToggleCommentFeaturedArgs = {
  input: ToggleCommentFeaturedInput;
};


export type MutationToggleCommentIsSpamArgs = {
  input: ToggleCommentIsSpamInput;
};


export type MutationToggleFlagArgs = {
  input: ToggleFlagInput;
};


export type MutationToggleFollowArgs = {
  input: ToggleFollowInput;
};


export type MutationToggleGroupModeratorArgs = {
  input: ToggleGroupModeratorInput;
};


export type MutationToggleInvestorProfileUserRequestArgs = {
  input: ToggleInvestorProfileUserRequestInput;
};


export type MutationToggleInvestorProfileUserSaveArgs = {
  input: ToggleInvestorProfileUserSaveInput;
};


export type MutationToggleLikeArgs = {
  input: ToggleLikeInput;
};


export type MutationToggleThreadFeaturedArgs = {
  input: ToggleThreadFeaturedInput;
};


export type MutationToggleThreadIsSpamArgs = {
  input: ToggleThreadIsSpamInput;
};


export type MutationUndoToolStudioEditArgs = {
  input: UndoToolStudioEditInput;
};


export type MutationUnpublishArticleArgs = {
  from?: Array<Stage>;
  where: ArticleWhereUniqueInput;
};


export type MutationUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};


export type MutationUnpublishBenefitArgs = {
  from?: Array<Stage>;
  where: BenefitWhereUniqueInput;
};


export type MutationUnpublishBootcampEventArgs = {
  from?: Array<Stage>;
  where: BootcampEventWhereUniqueInput;
};


export type MutationUnpublishBusinessStageArgs = {
  from?: Array<Stage>;
  where: BusinessStageWhereUniqueInput;
};


export type MutationUnpublishCoachProfileArgs = {
  from?: Array<Stage>;
  where: CoachProfileWhereUniqueInput;
};


export type MutationUnpublishContentTrackArgs = {
  from?: Array<Stage>;
  where: ContentTrackWhereUniqueInput;
};


export type MutationUnpublishContentTrackSectionArgs = {
  from?: Array<Stage>;
  where: ContentTrackSectionWhereUniqueInput;
};


export type MutationUnpublishContentTrackStepArgs = {
  from?: Array<Stage>;
  where: ContentTrackStepWhereUniqueInput;
};


export type MutationUnpublishContentTrackTaskArgs = {
  from?: Array<Stage>;
  where: ContentTrackTaskWhereUniqueInput;
};


export type MutationUnpublishFounderTrackArgs = {
  from?: Array<Stage>;
  where: FounderTrackWhereUniqueInput;
};


export type MutationUnpublishFounderTrackStepArgs = {
  from?: Array<Stage>;
  where: FounderTrackStepWhereUniqueInput;
};


export type MutationUnpublishFounderTrackTaskArgs = {
  from?: Array<Stage>;
  where: FounderTrackTaskWhereUniqueInput;
};


export type MutationUnpublishLinkArgs = {
  from?: Array<Stage>;
  where: LinkWhereUniqueInput;
};


export type MutationUnpublishManyArticlesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ArticleManyWhereInput>;
};


export type MutationUnpublishManyArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ArticleManyWhereInput>;
};


export type MutationUnpublishManyAssetsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyBenefitsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<BenefitManyWhereInput>;
};


export type MutationUnpublishManyBenefitsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<BenefitManyWhereInput>;
};


export type MutationUnpublishManyBootcampEventsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<BootcampEventManyWhereInput>;
};


export type MutationUnpublishManyBootcampEventsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<BootcampEventManyWhereInput>;
};


export type MutationUnpublishManyBusinessStagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<BusinessStageManyWhereInput>;
};


export type MutationUnpublishManyBusinessStagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<BusinessStageManyWhereInput>;
};


export type MutationUnpublishManyCoachProfilesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CoachProfileManyWhereInput>;
};


export type MutationUnpublishManyCoachProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CoachProfileManyWhereInput>;
};


export type MutationUnpublishManyContentTrackSectionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ContentTrackSectionManyWhereInput>;
};


export type MutationUnpublishManyContentTrackSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ContentTrackSectionManyWhereInput>;
};


export type MutationUnpublishManyContentTrackStepsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ContentTrackStepManyWhereInput>;
};


export type MutationUnpublishManyContentTrackStepsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ContentTrackStepManyWhereInput>;
};


export type MutationUnpublishManyContentTrackTasksArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ContentTrackTaskManyWhereInput>;
};


export type MutationUnpublishManyContentTrackTasksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ContentTrackTaskManyWhereInput>;
};


export type MutationUnpublishManyContentTracksArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ContentTrackManyWhereInput>;
};


export type MutationUnpublishManyContentTracksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ContentTrackManyWhereInput>;
};


export type MutationUnpublishManyFounderTrackStepsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FounderTrackStepManyWhereInput>;
};


export type MutationUnpublishManyFounderTrackStepsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FounderTrackStepManyWhereInput>;
};


export type MutationUnpublishManyFounderTrackTasksArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FounderTrackTaskManyWhereInput>;
};


export type MutationUnpublishManyFounderTrackTasksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FounderTrackTaskManyWhereInput>;
};


export type MutationUnpublishManyFounderTracksArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FounderTrackManyWhereInput>;
};


export type MutationUnpublishManyFounderTracksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FounderTrackManyWhereInput>;
};


export type MutationUnpublishManyLinksArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUnpublishManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUnpublishManyPersonsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PersonManyWhereInput>;
};


export type MutationUnpublishManyPersonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PersonManyWhereInput>;
};


export type MutationUnpublishManyPlaylistsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PlaylistManyWhereInput>;
};


export type MutationUnpublishManyPlaylistsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PlaylistManyWhereInput>;
};


export type MutationUnpublishManyPodcastEpisodesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PodcastEpisodeManyWhereInput>;
};


export type MutationUnpublishManyPodcastEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PodcastEpisodeManyWhereInput>;
};


export type MutationUnpublishManyProductNamesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ProductNameManyWhereInput>;
};


export type MutationUnpublishManyProductNamesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ProductNameManyWhereInput>;
};


export type MutationUnpublishManyReviewsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ReviewManyWhereInput>;
};


export type MutationUnpublishManyReviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ReviewManyWhereInput>;
};


export type MutationUnpublishManySupportArticlesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SupportArticleManyWhereInput>;
};


export type MutationUnpublishManySupportArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SupportArticleManyWhereInput>;
};


export type MutationUnpublishManySupportCategoriesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SupportCategoryManyWhereInput>;
};


export type MutationUnpublishManySupportCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SupportCategoryManyWhereInput>;
};


export type MutationUnpublishManyTermsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TermManyWhereInput>;
};


export type MutationUnpublishManyTermsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TermManyWhereInput>;
};


export type MutationUnpublishManyVideoCourseListEntriesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<VideoCourseListEntryManyWhereInput>;
};


export type MutationUnpublishManyVideoCourseListEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<VideoCourseListEntryManyWhereInput>;
};


export type MutationUnpublishManyVideoCoursesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<VideoCourseManyWhereInput>;
};


export type MutationUnpublishManyVideoCoursesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<VideoCourseManyWhereInput>;
};


export type MutationUnpublishManyVideoLessonsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<VideoLessonManyWhereInput>;
};


export type MutationUnpublishManyVideoLessonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<VideoLessonManyWhereInput>;
};


export type MutationUnpublishManyVideoListEntriesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<VideoListEntryManyWhereInput>;
};


export type MutationUnpublishManyVideoListEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<VideoListEntryManyWhereInput>;
};


export type MutationUnpublishManyVideoListsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<VideoListManyWhereInput>;
};


export type MutationUnpublishManyVideoListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<VideoListManyWhereInput>;
};


export type MutationUnpublishManyVideoPlaylistsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<VideoPlaylistManyWhereInput>;
};


export type MutationUnpublishManyVideoPlaylistsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<VideoPlaylistManyWhereInput>;
};


export type MutationUnpublishManyVideosArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationUnpublishManyVideosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationUnpublishPersonArgs = {
  from?: Array<Stage>;
  where: PersonWhereUniqueInput;
};


export type MutationUnpublishPlaylistArgs = {
  from?: Array<Stage>;
  where: PlaylistWhereUniqueInput;
};


export type MutationUnpublishPodcastEpisodeArgs = {
  from?: Array<Stage>;
  where: PodcastEpisodeWhereUniqueInput;
};


export type MutationUnpublishProductNameArgs = {
  from?: Array<Stage>;
  where: ProductNameWhereUniqueInput;
};


export type MutationUnpublishReviewArgs = {
  from?: Array<Stage>;
  where: ReviewWhereUniqueInput;
};


export type MutationUnpublishSupportArticleArgs = {
  from?: Array<Stage>;
  where: SupportArticleWhereUniqueInput;
};


export type MutationUnpublishSupportCategoryArgs = {
  from?: Array<Stage>;
  where: SupportCategoryWhereUniqueInput;
};


export type MutationUnpublishTermArgs = {
  from?: Array<Stage>;
  where: TermWhereUniqueInput;
};


export type MutationUnpublishVideoArgs = {
  from?: Array<Stage>;
  where: VideoWhereUniqueInput;
};


export type MutationUnpublishVideoCourseArgs = {
  from?: Array<Stage>;
  where: VideoCourseWhereUniqueInput;
};


export type MutationUnpublishVideoCourseListEntryArgs = {
  from?: Array<Stage>;
  where: VideoCourseListEntryWhereUniqueInput;
};


export type MutationUnpublishVideoLessonArgs = {
  from?: Array<Stage>;
  where: VideoLessonWhereUniqueInput;
};


export type MutationUnpublishVideoListArgs = {
  from?: Array<Stage>;
  where: VideoListWhereUniqueInput;
};


export type MutationUnpublishVideoListEntryArgs = {
  from?: Array<Stage>;
  where: VideoListEntryWhereUniqueInput;
};


export type MutationUnpublishVideoPlaylistArgs = {
  from?: Array<Stage>;
  where: VideoPlaylistWhereUniqueInput;
};


export type MutationUpdateArticleArgs = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};


export type MutationUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpdateBenefitArgs = {
  data: BenefitUpdateInput;
  where: BenefitWhereUniqueInput;
};


export type MutationUpdateBootcampEventArgs = {
  data: BootcampEventUpdateInput;
  where: BootcampEventWhereUniqueInput;
};


export type MutationUpdateBusinessStageArgs = {
  data: BusinessStageUpdateInput;
  where: BusinessStageWhereUniqueInput;
};


export type MutationUpdateCoachProfileArgs = {
  data: CoachProfileUpdateInput;
  where: CoachProfileWhereUniqueInput;
};


export type MutationUpdateCoachingEnrollmentCoachArgs = {
  input: UpdateCoachingEnrollmentCoachInput;
};


export type MutationUpdateCoachingEnrollmentConciergeArgs = {
  input: UpdateCoachingEnrollmentConciergeInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateContentTrackArgs = {
  data: ContentTrackUpdateInput;
  where: ContentTrackWhereUniqueInput;
};


export type MutationUpdateContentTrackSectionArgs = {
  data: ContentTrackSectionUpdateInput;
  where: ContentTrackSectionWhereUniqueInput;
};


export type MutationUpdateContentTrackStepArgs = {
  data: ContentTrackStepUpdateInput;
  where: ContentTrackStepWhereUniqueInput;
};


export type MutationUpdateContentTrackTaskArgs = {
  data: ContentTrackTaskUpdateInput;
  where: ContentTrackTaskWhereUniqueInput;
};


export type MutationUpdateFounderTrackArgs = {
  data: FounderTrackUpdateInput;
  where: FounderTrackWhereUniqueInput;
};


export type MutationUpdateFounderTrackStepArgs = {
  data: FounderTrackStepUpdateInput;
  where: FounderTrackStepWhereUniqueInput;
};


export type MutationUpdateFounderTrackTaskArgs = {
  data: FounderTrackTaskUpdateInput;
  where: FounderTrackTaskWhereUniqueInput;
};


export type MutationUpdateGroupEventArgs = {
  input: UpdateGroupEventInput;
};


export type MutationUpdateGroupGoalArgs = {
  input: UpdateGroupGoalInput;
};


export type MutationUpdateGroupMemberReviewArgs = {
  input: UpdateGroupMemberReviewInput;
};


export type MutationUpdateLinkArgs = {
  data: LinkUpdateInput;
  where: LinkWhereUniqueInput;
};


export type MutationUpdateManyArticlesArgs = {
  data: ArticleUpdateManyInput;
  where?: InputMaybe<ArticleManyWhereInput>;
};


export type MutationUpdateManyArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ArticleUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleManyWhereInput>;
};


export type MutationUpdateManyAssetsArgs = {
  data: AssetUpdateManyInput;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AssetUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyBenefitsArgs = {
  data: BenefitUpdateManyInput;
  where?: InputMaybe<BenefitManyWhereInput>;
};


export type MutationUpdateManyBenefitsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: BenefitUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BenefitManyWhereInput>;
};


export type MutationUpdateManyBootcampEventsArgs = {
  data: BootcampEventUpdateManyInput;
  where?: InputMaybe<BootcampEventManyWhereInput>;
};


export type MutationUpdateManyBootcampEventsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: BootcampEventUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BootcampEventManyWhereInput>;
};


export type MutationUpdateManyBusinessStagesArgs = {
  data: BusinessStageUpdateManyInput;
  where?: InputMaybe<BusinessStageManyWhereInput>;
};


export type MutationUpdateManyBusinessStagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: BusinessStageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BusinessStageManyWhereInput>;
};


export type MutationUpdateManyCoachProfilesArgs = {
  data: CoachProfileUpdateManyInput;
  where?: InputMaybe<CoachProfileManyWhereInput>;
};


export type MutationUpdateManyCoachProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CoachProfileUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CoachProfileManyWhereInput>;
};


export type MutationUpdateManyContentTrackSectionsArgs = {
  data: ContentTrackSectionUpdateManyInput;
  where?: InputMaybe<ContentTrackSectionManyWhereInput>;
};


export type MutationUpdateManyContentTrackSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ContentTrackSectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackSectionManyWhereInput>;
};


export type MutationUpdateManyContentTrackStepsArgs = {
  data: ContentTrackStepUpdateManyInput;
  where?: InputMaybe<ContentTrackStepManyWhereInput>;
};


export type MutationUpdateManyContentTrackStepsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ContentTrackStepUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackStepManyWhereInput>;
};


export type MutationUpdateManyContentTrackTasksArgs = {
  data: ContentTrackTaskUpdateManyInput;
  where?: InputMaybe<ContentTrackTaskManyWhereInput>;
};


export type MutationUpdateManyContentTrackTasksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ContentTrackTaskUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackTaskManyWhereInput>;
};


export type MutationUpdateManyContentTracksArgs = {
  data: ContentTrackUpdateManyInput;
  where?: InputMaybe<ContentTrackManyWhereInput>;
};


export type MutationUpdateManyContentTracksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ContentTrackUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackManyWhereInput>;
};


export type MutationUpdateManyFounderTrackStepsArgs = {
  data: FounderTrackStepUpdateManyInput;
  where?: InputMaybe<FounderTrackStepManyWhereInput>;
};


export type MutationUpdateManyFounderTrackStepsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FounderTrackStepUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FounderTrackStepManyWhereInput>;
};


export type MutationUpdateManyFounderTrackTasksArgs = {
  data: FounderTrackTaskUpdateManyInput;
  where?: InputMaybe<FounderTrackTaskManyWhereInput>;
};


export type MutationUpdateManyFounderTrackTasksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FounderTrackTaskUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FounderTrackTaskManyWhereInput>;
};


export type MutationUpdateManyFounderTracksArgs = {
  data: FounderTrackUpdateManyInput;
  where?: InputMaybe<FounderTrackManyWhereInput>;
};


export type MutationUpdateManyFounderTracksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FounderTrackUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FounderTrackManyWhereInput>;
};


export type MutationUpdateManyLinksArgs = {
  data: LinkUpdateManyInput;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUpdateManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: LinkUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUpdateManyPersonsArgs = {
  data: PersonUpdateManyInput;
  where?: InputMaybe<PersonManyWhereInput>;
};


export type MutationUpdateManyPersonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PersonUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonManyWhereInput>;
};


export type MutationUpdateManyPlaylistsArgs = {
  data: PlaylistUpdateManyInput;
  where?: InputMaybe<PlaylistManyWhereInput>;
};


export type MutationUpdateManyPlaylistsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PlaylistUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PlaylistManyWhereInput>;
};


export type MutationUpdateManyPodcastEpisodesArgs = {
  data: PodcastEpisodeUpdateManyInput;
  where?: InputMaybe<PodcastEpisodeManyWhereInput>;
};


export type MutationUpdateManyPodcastEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PodcastEpisodeUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PodcastEpisodeManyWhereInput>;
};


export type MutationUpdateManyProductNamesArgs = {
  data: ProductNameUpdateManyInput;
  where?: InputMaybe<ProductNameManyWhereInput>;
};


export type MutationUpdateManyProductNamesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ProductNameUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductNameManyWhereInput>;
};


export type MutationUpdateManyReviewsArgs = {
  data: ReviewUpdateManyInput;
  where?: InputMaybe<ReviewManyWhereInput>;
};


export type MutationUpdateManyReviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ReviewUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReviewManyWhereInput>;
};


export type MutationUpdateManySupportArticlesArgs = {
  data: SupportArticleUpdateManyInput;
  where?: InputMaybe<SupportArticleManyWhereInput>;
};


export type MutationUpdateManySupportArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SupportArticleUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SupportArticleManyWhereInput>;
};


export type MutationUpdateManySupportCategoriesArgs = {
  data: SupportCategoryUpdateManyInput;
  where?: InputMaybe<SupportCategoryManyWhereInput>;
};


export type MutationUpdateManySupportCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SupportCategoryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SupportCategoryManyWhereInput>;
};


export type MutationUpdateManyTermsArgs = {
  data: TermUpdateManyInput;
  where?: InputMaybe<TermManyWhereInput>;
};


export type MutationUpdateManyTermsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TermUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermManyWhereInput>;
};


export type MutationUpdateManyVideoCourseListEntriesArgs = {
  data: VideoCourseListEntryUpdateManyInput;
  where?: InputMaybe<VideoCourseListEntryManyWhereInput>;
};


export type MutationUpdateManyVideoCourseListEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: VideoCourseListEntryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoCourseListEntryManyWhereInput>;
};


export type MutationUpdateManyVideoCoursesArgs = {
  data: VideoCourseUpdateManyInput;
  where?: InputMaybe<VideoCourseManyWhereInput>;
};


export type MutationUpdateManyVideoCoursesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: VideoCourseUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoCourseManyWhereInput>;
};


export type MutationUpdateManyVideoLessonsArgs = {
  data: VideoLessonUpdateManyInput;
  where?: InputMaybe<VideoLessonManyWhereInput>;
};


export type MutationUpdateManyVideoLessonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: VideoLessonUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoLessonManyWhereInput>;
};


export type MutationUpdateManyVideoListEntriesArgs = {
  data: VideoListEntryUpdateManyInput;
  where?: InputMaybe<VideoListEntryManyWhereInput>;
};


export type MutationUpdateManyVideoListEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: VideoListEntryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoListEntryManyWhereInput>;
};


export type MutationUpdateManyVideoListsArgs = {
  data: VideoListUpdateManyInput;
  where?: InputMaybe<VideoListManyWhereInput>;
};


export type MutationUpdateManyVideoListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: VideoListUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoListManyWhereInput>;
};


export type MutationUpdateManyVideoPlaylistsArgs = {
  data: VideoPlaylistUpdateManyInput;
  where?: InputMaybe<VideoPlaylistManyWhereInput>;
};


export type MutationUpdateManyVideoPlaylistsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: VideoPlaylistUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoPlaylistManyWhereInput>;
};


export type MutationUpdateManyVideosArgs = {
  data: VideoUpdateManyInput;
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationUpdateManyVideosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: VideoUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoManyWhereInput>;
};


export type MutationUpdatePersonArgs = {
  data: PersonUpdateInput;
  where: PersonWhereUniqueInput;
};


export type MutationUpdatePlaylistArgs = {
  data: PlaylistUpdateInput;
  where: PlaylistWhereUniqueInput;
};


export type MutationUpdatePodcastEpisodeArgs = {
  data: PodcastEpisodeUpdateInput;
  where: PodcastEpisodeWhereUniqueInput;
};


export type MutationUpdateProductNameArgs = {
  data: ProductNameUpdateInput;
  where: ProductNameWhereUniqueInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateReviewArgs = {
  data: ReviewUpdateInput;
  where: ReviewWhereUniqueInput;
};


export type MutationUpdateScheduledReleaseArgs = {
  data: ScheduledReleaseUpdateInput;
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationUpdateStatusOfGroupEventArgs = {
  input: UpdateStatusOfGroupEventInput;
};


export type MutationUpdateSubscriptionPaymentArgs = {
  input: UpdateSubscriptionPaymentInput;
};


export type MutationUpdateSupportArticleArgs = {
  data: SupportArticleUpdateInput;
  where: SupportArticleWhereUniqueInput;
};


export type MutationUpdateSupportCategoryArgs = {
  data: SupportCategoryUpdateInput;
  where: SupportCategoryWhereUniqueInput;
};


export type MutationUpdateTermArgs = {
  data: TermUpdateInput;
  where: TermWhereUniqueInput;
};


export type MutationUpdateThreadArgs = {
  input: UpdateThreadInput;
};


export type MutationUpdateUserActiveSprintArgs = {
  input: UpdateUserActiveSprintInput;
};


export type MutationUpdateUserEmailArgs = {
  input: UpdateUserEmailInput;
};


export type MutationUpdateUserLearningGoalsArgs = {
  input: UpdateUserLearningGoalsInput;
};


export type MutationUpdateUserNetworkingSettingArgs = {
  input: UpdateUserNetworkingSettingInput;
};


export type MutationUpdateUserPasswordArgs = {
  input: UpdateUserPasswordInput;
};


export type MutationUpdateUserPresenceArgs = {
  input: UpdateUserPresenceInput;
};


export type MutationUpdateVideoArgs = {
  data: VideoUpdateInput;
  where: VideoWhereUniqueInput;
};


export type MutationUpdateVideoCourseArgs = {
  data: VideoCourseUpdateInput;
  where: VideoCourseWhereUniqueInput;
};


export type MutationUpdateVideoCourseListEntryArgs = {
  data: VideoCourseListEntryUpdateInput;
  where: VideoCourseListEntryWhereUniqueInput;
};


export type MutationUpdateVideoLessonArgs = {
  data: VideoLessonUpdateInput;
  where: VideoLessonWhereUniqueInput;
};


export type MutationUpdateVideoListArgs = {
  data: VideoListUpdateInput;
  where: VideoListWhereUniqueInput;
};


export type MutationUpdateVideoListEntryArgs = {
  data: VideoListEntryUpdateInput;
  where: VideoListEntryWhereUniqueInput;
};


export type MutationUpdateVideoPlaylistArgs = {
  data: VideoPlaylistUpdateInput;
  where: VideoPlaylistWhereUniqueInput;
};


export type MutationUpsertAdvisorAgreementArgs = {
  input: UpsertAdvisorAgreementInput;
};


export type MutationUpsertAdvisorEngagementArgs = {
  input: UpsertAdvisorEngagementInput;
};


export type MutationUpsertAdvisorProfileArgs = {
  input: UpsertAdvisorProfileInput;
};


export type MutationUpsertArticleArgs = {
  upsert: ArticleUpsertInput;
  where: ArticleWhereUniqueInput;
};


export type MutationUpsertAssetArgs = {
  upsert: AssetUpsertInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpsertAttachmentUserPresenceArgs = {
  input: UpsertAttachmentUserPresenceInput;
};


export type MutationUpsertBenefitArgs = {
  upsert: BenefitUpsertInput;
  where: BenefitWhereUniqueInput;
};


export type MutationUpsertBootcampEnrollmentArgs = {
  input: UpsertBootcampEnrollmentInput;
};


export type MutationUpsertBootcampEventArgs = {
  upsert: BootcampEventUpsertInput;
  where: BootcampEventWhereUniqueInput;
};


export type MutationUpsertBootcampResponseArgs = {
  input: UpsertBootcampResponseInput;
};


export type MutationUpsertBootcampShareArgs = {
  input: UpsertBootcampShareInput;
};


export type MutationUpsertBootcampStatusArgs = {
  input: UpsertBootcampStatusInput;
};


export type MutationUpsertBusinessStageArgs = {
  upsert: BusinessStageUpsertInput;
  where: BusinessStageWhereUniqueInput;
};


export type MutationUpsertChatCommentArgs = {
  input: UpsertChatCommentInput;
};


export type MutationUpsertCoachProfileArgs = {
  upsert: CoachProfileUpsertInput;
  where: CoachProfileWhereUniqueInput;
};


export type MutationUpsertCoachingEnrollmentArgs = {
  input: UpsertCoachingEnrollmentInput;
};


export type MutationUpsertCompanyArgs = {
  input: UpsertCompanyInput;
};


export type MutationUpsertContentTrackArgs = {
  upsert: ContentTrackUpsertInput;
  where: ContentTrackWhereUniqueInput;
};


export type MutationUpsertContentTrackEnrollmentArgs = {
  input: UpsertContentTrackEnrollmentInput;
};


export type MutationUpsertContentTrackResponseArgs = {
  input: UpsertContentTrackResponseInput;
};


export type MutationUpsertContentTrackSectionArgs = {
  upsert: ContentTrackSectionUpsertInput;
  where: ContentTrackSectionWhereUniqueInput;
};


export type MutationUpsertContentTrackStepArgs = {
  upsert: ContentTrackStepUpsertInput;
  where: ContentTrackStepWhereUniqueInput;
};


export type MutationUpsertContentTrackTaskArgs = {
  upsert: ContentTrackTaskUpsertInput;
  where: ContentTrackTaskWhereUniqueInput;
};


export type MutationUpsertCrmSavedReplyArgs = {
  input: UpsertCrmSavedReplyInput;
};


export type MutationUpsertDirectChatThreadArgs = {
  input: UpsertDirectChatThreadInput;
};


export type MutationUpsertEmailSenderArgs = {
  input: UpsertEmailSenderInput;
};


export type MutationUpsertFgProfileArgs = {
  input: UpsertFgProfileInput;
};


export type MutationUpsertFounderTrackArgs = {
  upsert: FounderTrackUpsertInput;
  where: FounderTrackWhereUniqueInput;
};


export type MutationUpsertFounderTrackStepArgs = {
  upsert: FounderTrackStepUpsertInput;
  where: FounderTrackStepWhereUniqueInput;
};


export type MutationUpsertFounderTrackTaskArgs = {
  upsert: FounderTrackTaskUpsertInput;
  where: FounderTrackTaskWhereUniqueInput;
};


export type MutationUpsertGroupArgs = {
  input: UpsertGroupInput;
};


export type MutationUpsertGroupCandidateArgs = {
  input: UpsertGroupCandidateInput;
};


export type MutationUpsertGroupCommitmentArgs = {
  input: UpsertGroupCommitmentInput;
};


export type MutationUpsertGroupEventArgs = {
  input: UpsertGroupEventInput;
};


export type MutationUpsertGroupEventAttendanceArgs = {
  input: UpsertGroupEventAttendanceInput;
};


export type MutationUpsertGroupGoalArgs = {
  input: UpsertGroupGoalInput;
};


export type MutationUpsertGroupMembershipArgs = {
  input: UpsertGroupMembershipInput;
};


export type MutationUpsertGroupPostArgs = {
  input: UpsertGroupPostInput;
};


export type MutationUpsertGroupRequestArgs = {
  input: UpsertGroupRequestInput;
};


export type MutationUpsertGroupTrackStatusArgs = {
  input: UpsertGroupTrackStatusInput;
};


export type MutationUpsertInvestorMatchArgs = {
  input: UpsertInvestorMatchInput;
};


export type MutationUpsertInvestorMessageArgs = {
  input: UpsertInvestorMessageInput;
};


export type MutationUpsertInvestorProfileArgs = {
  input: UpsertInvestorProfileInput;
};


export type MutationUpsertInvestorProfileContactArgs = {
  input: UpsertInvestorProfileContactInput;
};


export type MutationUpsertInvestorSearchArgs = {
  input: UpsertInvestorSearchInput;
};


export type MutationUpsertLinkArgs = {
  upsert: LinkUpsertInput;
  where: LinkWhereUniqueInput;
};


export type MutationUpsertPersonArgs = {
  upsert: PersonUpsertInput;
  where: PersonWhereUniqueInput;
};


export type MutationUpsertPlaylistArgs = {
  upsert: PlaylistUpsertInput;
  where: PlaylistWhereUniqueInput;
};


export type MutationUpsertPodcastEpisodeArgs = {
  upsert: PodcastEpisodeUpsertInput;
  where: PodcastEpisodeWhereUniqueInput;
};


export type MutationUpsertProductNameArgs = {
  upsert: ProductNameUpsertInput;
  where: ProductNameWhereUniqueInput;
};


export type MutationUpsertRagCollectionArgs = {
  input: UpsertRagCollectionInput;
};


export type MutationUpsertRagSourceArgs = {
  input: UpsertRagSourceInput;
};


export type MutationUpsertRatingArgs = {
  input: UpsertRatingInput;
};


export type MutationUpsertReviewArgs = {
  upsert: ReviewUpsertInput;
  where: ReviewWhereUniqueInput;
};


export type MutationUpsertSalesEventArgs = {
  input: UpsertSalesEventInput;
};


export type MutationUpsertScoAiActionArgs = {
  input: UpsertScoAiActionInput;
};


export type MutationUpsertScoAnalyticsSavedReportArgs = {
  input: UpsertScoAnalyticsSavedReportInput;
};


export type MutationUpsertScoCustomerChannelArgs = {
  input: UpsertScoCustomerChannelInput;
};


export type MutationUpsertScoCustomerExperimentArgs = {
  input: UpsertScoCustomerExperimentInput;
};


export type MutationUpsertScoCustomerExperimentCheckinArgs = {
  input: UpsertScoCustomerExperimentCheckinInput;
};


export type MutationUpsertScoCustomerSearchArgs = {
  input: UpsertScoCustomerSearchInput;
};


export type MutationUpsertScoPitchDeckArgs = {
  input: UpsertScoPitchDeckInput;
};


export type MutationUpsertScoPitchDeckAuditArgs = {
  input: UpsertScoPitchDeckAuditInput;
};


export type MutationUpsertScoPitchDeckAuditSlideArgs = {
  input: UpsertScoPitchDeckAuditSlideInput;
};


export type MutationUpsertSignupRequestArgs = {
  input: UpsertSignupRequestInput;
};


export type MutationUpsertStoredFileArgs = {
  input: UpsertStoredFileInput;
};


export type MutationUpsertSupportArticleArgs = {
  upsert: SupportArticleUpsertInput;
  where: SupportArticleWhereUniqueInput;
};


export type MutationUpsertSupportCategoryArgs = {
  upsert: SupportCategoryUpsertInput;
  where: SupportCategoryWhereUniqueInput;
};


export type MutationUpsertTaskArgs = {
  input: UpsertTaskInput;
};


export type MutationUpsertTaskTemplateArgs = {
  input: UpsertTaskTemplateInput;
};


export type MutationUpsertTermArgs = {
  upsert: TermUpsertInput;
  where: TermWhereUniqueInput;
};


export type MutationUpsertThreadArgs = {
  input: UpsertThreadInput;
};


export type MutationUpsertToolArgs = {
  input: UpsertToolInput;
};


export type MutationUpsertToolCapabilityArgs = {
  input: UpsertToolCapabilityInput;
};


export type MutationUpsertToolDraftArgs = {
  input: UpsertToolDraftInput;
};


export type MutationUpsertToolInputArgs = {
  input: UpsertToolInputInput;
};


export type MutationUpsertToolKnowledgeCardArgs = {
  input: UpsertToolKnowledgeCardInput;
};


export type MutationUpsertToolOutputArgs = {
  input: UpsertToolOutputInput;
};


export type MutationUpsertToolReplyTemplateArgs = {
  input: UpsertToolReplyTemplateInput;
};


export type MutationUpsertToolRuleArgs = {
  input: UpsertToolRuleInput;
};


export type MutationUpsertToolRuleBindingArgs = {
  input: UpsertToolRuleBindingInput;
};


export type MutationUpsertToolSessionArgs = {
  input: UpsertToolSessionInput;
};


export type MutationUpsertUserArgs = {
  input: UpsertUserInput;
};


export type MutationUpsertUserDeviceArgs = {
  input: UpsertUserDeviceInput;
};


export type MutationUpsertUserExperienceArgs = {
  input: UpsertUserExperienceInput;
};


export type MutationUpsertUserFounderNeedsArgs = {
  input: UpsertUserFounderNeedsInput;
};


export type MutationUpsertUserMatchArgs = {
  input: UpsertUserMatchInput;
};


export type MutationUpsertUserPreferenceArgs = {
  input: UpsertUserPreferenceInput;
};


export type MutationUpsertUserPreferencesArgs = {
  input: UpsertUserPreferencesInput;
};


export type MutationUpsertUserPreferredInteractionsArgs = {
  input: UpsertUserPreferredInteractionsInput;
};


export type MutationUpsertUserSearchArgs = {
  input: UpsertUserSearchInput;
};


export type MutationUpsertUserSkillArgs = {
  input: UpsertUserSkillInput;
};


export type MutationUpsertUserSkillsArgs = {
  input: UpsertUserSkillsInput;
};


export type MutationUpsertVideoArgs = {
  upsert: VideoUpsertInput;
  where: VideoWhereUniqueInput;
};


export type MutationUpsertVideoCourseArgs = {
  upsert: VideoCourseUpsertInput;
  where: VideoCourseWhereUniqueInput;
};


export type MutationUpsertVideoCourseListEntryArgs = {
  upsert: VideoCourseListEntryUpsertInput;
  where: VideoCourseListEntryWhereUniqueInput;
};


export type MutationUpsertVideoLessonArgs = {
  upsert: VideoLessonUpsertInput;
  where: VideoLessonWhereUniqueInput;
};


export type MutationUpsertVideoListArgs = {
  upsert: VideoListUpsertInput;
  where: VideoListWhereUniqueInput;
};


export type MutationUpsertVideoListEntryArgs = {
  upsert: VideoListEntryUpsertInput;
  where: VideoListEntryWhereUniqueInput;
};


export type MutationUpsertVideoPlaylistArgs = {
  upsert: VideoPlaylistUpsertInput;
  where: VideoPlaylistWhereUniqueInput;
};


export type MutationUpsertViewArgs = {
  input: UpsertViewInput;
};


export type MutationViewNotificationArgs = {
  input: ViewNotificationInput;
};


export type MutationWithdrawBoardInviteArgs = {
  input: WithdrawBoardInviteInput;
};

export type NewsletterSignupInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  hubspotFormKey?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterSignupPayload = {
  __typename?: 'NewsletterSignupPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

export type NominateStartupsLiveGuestInput = {
  nomineeCompanyName?: InputMaybe<Scalars['String']['input']>;
  nomineeCompanyUrl?: InputMaybe<Scalars['String']['input']>;
  nomineeDescription?: InputMaybe<Scalars['String']['input']>;
  nomineeEmail?: InputMaybe<Scalars['String']['input']>;
  nomineeFullName?: InputMaybe<Scalars['String']['input']>;
  nomineeSocialUrl?: InputMaybe<Scalars['String']['input']>;
  nomineeTitle?: InputMaybe<Scalars['String']['input']>;
  submittedByEmail?: InputMaybe<Scalars['String']['input']>;
  submittedByName?: InputMaybe<Scalars['String']['input']>;
};

export enum NotifiableAction {
  Created = 'CREATED'
}

export enum NotifiableType {
  Comment = 'COMMENT',
  Like = 'LIKE',
  Notification = 'NOTIFICATION'
}

export type OpenToolThreadInput = {
  accountUserId?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
};

export type OpenToolThreadPayload = {
  __typename?: 'OpenToolThreadPayload';
  toolThreadRead?: Maybe<ScoToolThreadRead>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  order?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type PatchToolCopyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toolId: Scalars['String']['input'];
  toolUserId?: InputMaybe<Scalars['String']['input']>;
};

export type PatchToolCopyPayload = {
  __typename?: 'PatchToolCopyPayload';
  toolId?: Maybe<Scalars['String']['output']>;
};

export type Person = Entity & Node & {
  __typename?: 'Person';
  articles: Array<Article>;
  avatar?: Maybe<Asset>;
  byline?: Maybe<Scalars['String']['output']>;
  clarityId?: Maybe<Scalars['Int']['output']>;
  coachProfile?: Maybe<CoachProfile>;
  coachReview?: Maybe<Review>;
  companyLogo?: Maybe<Asset>;
  companyName?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Person>;
  email?: Maybe<Scalars['String']['output']>;
  expertise: Array<Term>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullBio?: Maybe<Scalars['String']['output']>;
  /** List of Person versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  knownFor?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  notables: Array<Scalars['String']['output']>;
  originalId?: Maybe<Scalars['Int']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  quotes: Array<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  scoId?: Maybe<Scalars['String']['output']>;
  shortBio?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  topTips: Array<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  video: Array<Video>;
  videoCourses: Array<VideoCourse>;
  videoLessons: Array<VideoLesson>;
  videoLists: Array<VideoList>;
  website?: Maybe<Scalars['String']['output']>;
};


export type PersonArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};


export type PersonAvatarArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type PersonCoachProfileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PersonCoachReviewArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PersonCompanyLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type PersonCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PersonDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PersonExpertiseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


export type PersonHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PersonPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PersonScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PersonUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PersonVideoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoWhereInput>;
};


export type PersonVideoCoursesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoCourseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoCourseWhereInput>;
};


export type PersonVideoLessonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoLessonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoLessonWhereInput>;
};


export type PersonVideoListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoListWhereInput>;
};

export type PersonConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PersonWhereUniqueInput;
};

/** A connection to a list of items. */
export type PersonConnection = {
  __typename?: 'PersonConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PersonEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PersonCreateInput = {
  articles?: InputMaybe<ArticleCreateManyInlineInput>;
  avatar?: InputMaybe<AssetCreateOneInlineInput>;
  byline?: InputMaybe<Scalars['String']['input']>;
  clarityId?: InputMaybe<Scalars['Int']['input']>;
  coachProfile?: InputMaybe<CoachProfileCreateOneInlineInput>;
  coachReview?: InputMaybe<ReviewCreateOneInlineInput>;
  companyLogo?: InputMaybe<AssetCreateOneInlineInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expertise?: InputMaybe<TermCreateManyInlineInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullBio?: InputMaybe<Scalars['String']['input']>;
  knownFor?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  notables?: InputMaybe<Array<Scalars['String']['input']>>;
  originalId?: InputMaybe<Scalars['Int']['input']>;
  quotes?: InputMaybe<Array<Scalars['String']['input']>>;
  scoId?: InputMaybe<Scalars['String']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  topTips?: InputMaybe<Array<Scalars['String']['input']>>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  video?: InputMaybe<VideoCreateManyInlineInput>;
  videoCourses?: InputMaybe<VideoCourseCreateManyInlineInput>;
  videoLessons?: InputMaybe<VideoLessonCreateManyInlineInput>;
  videoLists?: InputMaybe<VideoListCreateManyInlineInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type PersonCreateManyInlineInput = {
  /** Connect multiple existing Person documents */
  connect?: InputMaybe<Array<PersonWhereUniqueInput>>;
  /** Create and connect multiple existing Person documents */
  create?: InputMaybe<Array<PersonCreateInput>>;
};

export type PersonCreateOneInlineInput = {
  /** Connect one existing Person document */
  connect?: InputMaybe<PersonWhereUniqueInput>;
  /** Create and connect one Person document */
  create?: InputMaybe<PersonCreateInput>;
};

/** An edge in a connection. */
export type PersonEdge = {
  __typename?: 'PersonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Person;
};

/** Identifies documents */
export type PersonManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PersonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PersonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PersonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  avatar?: InputMaybe<AssetWhereInput>;
  byline?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  byline_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  byline_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  byline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  byline_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  byline_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  byline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  byline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  byline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  byline_starts_with?: InputMaybe<Scalars['String']['input']>;
  clarityId?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  clarityId_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  clarityId_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  clarityId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  clarityId_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  clarityId_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  clarityId_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  clarityId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  coachProfile?: InputMaybe<CoachProfileWhereInput>;
  coachReview?: InputMaybe<ReviewWhereInput>;
  companyLogo?: InputMaybe<AssetWhereInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  companyName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  companyName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  companyName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  companyName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  companyName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  companyName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  companyName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  companyName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  companyName_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PersonWhereStageInput>;
  documentInStages_none?: InputMaybe<PersonWhereStageInput>;
  documentInStages_some?: InputMaybe<PersonWhereStageInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  email_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  email_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  email_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  email_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  email_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  email_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  email_starts_with?: InputMaybe<Scalars['String']['input']>;
  expertise_every?: InputMaybe<TermWhereInput>;
  expertise_none?: InputMaybe<TermWhereInput>;
  expertise_some?: InputMaybe<TermWhereInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  firstName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  firstName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  firstName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  firstName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  firstName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  firstName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  firstName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  firstName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  firstName_starts_with?: InputMaybe<Scalars['String']['input']>;
  fullBio?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fullBio_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fullBio_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fullBio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fullBio_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fullBio_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fullBio_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fullBio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fullBio_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fullBio_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  knownFor?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  knownFor_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  knownFor_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  knownFor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  knownFor_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  knownFor_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  knownFor_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  knownFor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  knownFor_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  knownFor_starts_with?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  lastName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  lastName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  lastName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  lastName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  lastName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  lastName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  lastName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  lastName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  lastName_starts_with?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkedInUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkedInUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkedInUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkedInUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkedInUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkedInUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkedInUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkedInUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkedInUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  notables?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  notables_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  notables_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  notables_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  notables_not?: InputMaybe<Array<Scalars['String']['input']>>;
  originalId?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  originalId_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  originalId_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  originalId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  originalId_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  originalId_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  originalId_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  originalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  quotes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  quotes_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  quotes_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  quotes_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  quotes_not?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  scoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  scoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  scoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  scoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  scoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  scoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  scoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  scoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  scoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  scoId_starts_with?: InputMaybe<Scalars['String']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortBio_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortBio_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortBio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortBio_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortBio_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortBio_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortBio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortBio_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortBio_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  topTips?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  topTips_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  topTips_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  topTips_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  topTips_not?: InputMaybe<Array<Scalars['String']['input']>>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  twitter_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  twitter_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  twitter_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  twitter_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  twitter_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  twitter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  twitter_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  twitter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  twitter_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoCourses_every?: InputMaybe<VideoCourseWhereInput>;
  videoCourses_none?: InputMaybe<VideoCourseWhereInput>;
  videoCourses_some?: InputMaybe<VideoCourseWhereInput>;
  videoLessons_every?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_none?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_some?: InputMaybe<VideoLessonWhereInput>;
  videoLists_every?: InputMaybe<VideoListWhereInput>;
  videoLists_none?: InputMaybe<VideoListWhereInput>;
  videoLists_some?: InputMaybe<VideoListWhereInput>;
  video_every?: InputMaybe<VideoWhereInput>;
  video_none?: InputMaybe<VideoWhereInput>;
  video_some?: InputMaybe<VideoWhereInput>;
  website?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  website_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  website_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  website_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  website_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  website_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  website_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  website_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum PersonOrderByInput {
  BylineAsc = 'byline_ASC',
  BylineDesc = 'byline_DESC',
  ClarityIdAsc = 'clarityId_ASC',
  ClarityIdDesc = 'clarityId_DESC',
  CompanyNameAsc = 'companyName_ASC',
  CompanyNameDesc = 'companyName_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  FullBioAsc = 'fullBio_ASC',
  FullBioDesc = 'fullBio_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  KnownForAsc = 'knownFor_ASC',
  KnownForDesc = 'knownFor_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  LinkedInUrlAsc = 'linkedInUrl_ASC',
  LinkedInUrlDesc = 'linkedInUrl_DESC',
  NotablesAsc = 'notables_ASC',
  NotablesDesc = 'notables_DESC',
  OriginalIdAsc = 'originalId_ASC',
  OriginalIdDesc = 'originalId_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  QuotesAsc = 'quotes_ASC',
  QuotesDesc = 'quotes_DESC',
  ScoIdAsc = 'scoId_ASC',
  ScoIdDesc = 'scoId_DESC',
  ShortBioAsc = 'shortBio_ASC',
  ShortBioDesc = 'shortBio_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TopTipsAsc = 'topTips_ASC',
  TopTipsDesc = 'topTips_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WebsiteAsc = 'website_ASC',
  WebsiteDesc = 'website_DESC'
}

export type PersonUpdateInput = {
  articles?: InputMaybe<ArticleUpdateManyInlineInput>;
  avatar?: InputMaybe<AssetUpdateOneInlineInput>;
  byline?: InputMaybe<Scalars['String']['input']>;
  clarityId?: InputMaybe<Scalars['Int']['input']>;
  coachProfile?: InputMaybe<CoachProfileUpdateOneInlineInput>;
  coachReview?: InputMaybe<ReviewUpdateOneInlineInput>;
  companyLogo?: InputMaybe<AssetUpdateOneInlineInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expertise?: InputMaybe<TermUpdateManyInlineInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullBio?: InputMaybe<Scalars['String']['input']>;
  knownFor?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  notables?: InputMaybe<Array<Scalars['String']['input']>>;
  originalId?: InputMaybe<Scalars['Int']['input']>;
  quotes?: InputMaybe<Array<Scalars['String']['input']>>;
  scoId?: InputMaybe<Scalars['String']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topTips?: InputMaybe<Array<Scalars['String']['input']>>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<VideoUpdateManyInlineInput>;
  videoCourses?: InputMaybe<VideoCourseUpdateManyInlineInput>;
  videoLessons?: InputMaybe<VideoLessonUpdateManyInlineInput>;
  videoLists?: InputMaybe<VideoListUpdateManyInlineInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type PersonUpdateManyInlineInput = {
  /** Connect multiple existing Person documents */
  connect?: InputMaybe<Array<PersonConnectInput>>;
  /** Create and connect multiple Person documents */
  create?: InputMaybe<Array<PersonCreateInput>>;
  /** Delete multiple Person documents */
  delete?: InputMaybe<Array<PersonWhereUniqueInput>>;
  /** Disconnect multiple Person documents */
  disconnect?: InputMaybe<Array<PersonWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Person documents */
  set?: InputMaybe<Array<PersonWhereUniqueInput>>;
  /** Update multiple Person documents */
  update?: InputMaybe<Array<PersonUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Person documents */
  upsert?: InputMaybe<Array<PersonUpsertWithNestedWhereUniqueInput>>;
};

export type PersonUpdateManyInput = {
  byline?: InputMaybe<Scalars['String']['input']>;
  clarityId?: InputMaybe<Scalars['Int']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullBio?: InputMaybe<Scalars['String']['input']>;
  knownFor?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  notables?: InputMaybe<Array<Scalars['String']['input']>>;
  originalId?: InputMaybe<Scalars['Int']['input']>;
  quotes?: InputMaybe<Array<Scalars['String']['input']>>;
  scoId?: InputMaybe<Scalars['String']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topTips?: InputMaybe<Array<Scalars['String']['input']>>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type PersonUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PersonUpdateManyInput;
  /** Document search */
  where: PersonWhereInput;
};

export type PersonUpdateOneInlineInput = {
  /** Connect existing Person document */
  connect?: InputMaybe<PersonWhereUniqueInput>;
  /** Create and connect one Person document */
  create?: InputMaybe<PersonCreateInput>;
  /** Delete currently connected Person document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Person document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Person document */
  update?: InputMaybe<PersonUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Person document */
  upsert?: InputMaybe<PersonUpsertWithNestedWhereUniqueInput>;
};

export type PersonUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PersonUpdateInput;
  /** Unique document search */
  where: PersonWhereUniqueInput;
};

export type PersonUpsertInput = {
  /** Create document if it didn't exist */
  create: PersonCreateInput;
  /** Update document if it exists */
  update: PersonUpdateInput;
};

export type PersonUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PersonUpsertInput;
  /** Unique document search */
  where: PersonWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PersonWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PersonWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PersonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PersonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PersonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  avatar?: InputMaybe<AssetWhereInput>;
  byline?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  byline_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  byline_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  byline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  byline_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  byline_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  byline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  byline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  byline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  byline_starts_with?: InputMaybe<Scalars['String']['input']>;
  clarityId?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  clarityId_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  clarityId_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  clarityId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  clarityId_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  clarityId_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  clarityId_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  clarityId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  coachProfile?: InputMaybe<CoachProfileWhereInput>;
  coachReview?: InputMaybe<ReviewWhereInput>;
  companyLogo?: InputMaybe<AssetWhereInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  companyName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  companyName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  companyName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  companyName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  companyName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  companyName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  companyName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  companyName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  companyName_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PersonWhereStageInput>;
  documentInStages_none?: InputMaybe<PersonWhereStageInput>;
  documentInStages_some?: InputMaybe<PersonWhereStageInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  email_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  email_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  email_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  email_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  email_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  email_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  email_starts_with?: InputMaybe<Scalars['String']['input']>;
  expertise_every?: InputMaybe<TermWhereInput>;
  expertise_none?: InputMaybe<TermWhereInput>;
  expertise_some?: InputMaybe<TermWhereInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  firstName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  firstName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  firstName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  firstName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  firstName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  firstName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  firstName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  firstName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  firstName_starts_with?: InputMaybe<Scalars['String']['input']>;
  fullBio?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fullBio_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fullBio_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fullBio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fullBio_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fullBio_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fullBio_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fullBio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fullBio_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fullBio_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  knownFor?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  knownFor_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  knownFor_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  knownFor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  knownFor_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  knownFor_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  knownFor_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  knownFor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  knownFor_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  knownFor_starts_with?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  lastName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  lastName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  lastName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  lastName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  lastName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  lastName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  lastName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  lastName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  lastName_starts_with?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkedInUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkedInUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkedInUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkedInUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkedInUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkedInUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkedInUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkedInUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkedInUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  notables?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  notables_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  notables_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  notables_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  notables_not?: InputMaybe<Array<Scalars['String']['input']>>;
  originalId?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  originalId_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  originalId_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  originalId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  originalId_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  originalId_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  originalId_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  originalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  quotes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  quotes_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  quotes_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  quotes_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  quotes_not?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  scoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  scoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  scoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  scoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  scoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  scoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  scoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  scoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  scoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  scoId_starts_with?: InputMaybe<Scalars['String']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortBio_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortBio_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortBio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortBio_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortBio_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortBio_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortBio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortBio_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortBio_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  topTips?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  topTips_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  topTips_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  topTips_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  topTips_not?: InputMaybe<Array<Scalars['String']['input']>>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  twitter_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  twitter_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  twitter_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  twitter_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  twitter_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  twitter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  twitter_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  twitter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  twitter_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoCourses_every?: InputMaybe<VideoCourseWhereInput>;
  videoCourses_none?: InputMaybe<VideoCourseWhereInput>;
  videoCourses_some?: InputMaybe<VideoCourseWhereInput>;
  videoLessons_every?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_none?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_some?: InputMaybe<VideoLessonWhereInput>;
  videoLists_every?: InputMaybe<VideoListWhereInput>;
  videoLists_none?: InputMaybe<VideoListWhereInput>;
  videoLists_some?: InputMaybe<VideoListWhereInput>;
  video_every?: InputMaybe<VideoWhereInput>;
  video_none?: InputMaybe<VideoWhereInput>;
  video_some?: InputMaybe<VideoWhereInput>;
  website?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  website_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  website_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  website_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  website_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  website_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  website_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  website_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PersonWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PersonWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PersonWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PersonWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PersonWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Person record uniquely */
export type PersonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type Playlist = Entity & Node & {
  __typename?: 'Playlist';
  articles: Array<Article>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Playlist>;
  /** List of Playlist versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  questionIDs: Array<Scalars['Int']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  textBookSlugs: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  videoLessons: Array<VideoLesson>;
};


export type PlaylistArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};


export type PlaylistCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlaylistDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PlaylistHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PlaylistPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlaylistScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PlaylistUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PlaylistVideoLessonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoLessonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoLessonWhereInput>;
};

export type PlaylistConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PlaylistWhereUniqueInput;
};

/** A connection to a list of items. */
export type PlaylistConnection = {
  __typename?: 'PlaylistConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PlaylistEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PlaylistCreateInput = {
  articles?: InputMaybe<ArticleCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  questionIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  slug: Scalars['String']['input'];
  textBookSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoLessons?: InputMaybe<VideoLessonCreateManyInlineInput>;
};

export type PlaylistCreateManyInlineInput = {
  /** Connect multiple existing Playlist documents */
  connect?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  /** Create and connect multiple existing Playlist documents */
  create?: InputMaybe<Array<PlaylistCreateInput>>;
};

export type PlaylistCreateOneInlineInput = {
  /** Connect one existing Playlist document */
  connect?: InputMaybe<PlaylistWhereUniqueInput>;
  /** Create and connect one Playlist document */
  create?: InputMaybe<PlaylistCreateInput>;
};

/** An edge in a connection. */
export type PlaylistEdge = {
  __typename?: 'PlaylistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Playlist;
};

/** Identifies documents */
export type PlaylistManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PlaylistWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PlaylistWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PlaylistWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PlaylistWhereStageInput>;
  documentInStages_none?: InputMaybe<PlaylistWhereStageInput>;
  documentInStages_some?: InputMaybe<PlaylistWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  questionIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  questionIDs_contains_all?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  questionIDs_contains_none?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  questionIDs_contains_some?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  questionIDs_not?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  textBookSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  textBookSlugs_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  textBookSlugs_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  textBookSlugs_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  textBookSlugs_not?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoLessons_every?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_none?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_some?: InputMaybe<VideoLessonWhereInput>;
};

export enum PlaylistOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  QuestionIDsAsc = 'questionIDs_ASC',
  QuestionIDsDesc = 'questionIDs_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TextBookSlugsAsc = 'textBookSlugs_ASC',
  TextBookSlugsDesc = 'textBookSlugs_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type PlaylistUpdateInput = {
  articles?: InputMaybe<ArticleUpdateManyInlineInput>;
  questionIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  textBookSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoLessons?: InputMaybe<VideoLessonUpdateManyInlineInput>;
};

export type PlaylistUpdateManyInlineInput = {
  /** Connect multiple existing Playlist documents */
  connect?: InputMaybe<Array<PlaylistConnectInput>>;
  /** Create and connect multiple Playlist documents */
  create?: InputMaybe<Array<PlaylistCreateInput>>;
  /** Delete multiple Playlist documents */
  delete?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  /** Disconnect multiple Playlist documents */
  disconnect?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Playlist documents */
  set?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  /** Update multiple Playlist documents */
  update?: InputMaybe<Array<PlaylistUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Playlist documents */
  upsert?: InputMaybe<Array<PlaylistUpsertWithNestedWhereUniqueInput>>;
};

export type PlaylistUpdateManyInput = {
  questionIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  textBookSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PlaylistUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PlaylistUpdateManyInput;
  /** Document search */
  where: PlaylistWhereInput;
};

export type PlaylistUpdateOneInlineInput = {
  /** Connect existing Playlist document */
  connect?: InputMaybe<PlaylistWhereUniqueInput>;
  /** Create and connect one Playlist document */
  create?: InputMaybe<PlaylistCreateInput>;
  /** Delete currently connected Playlist document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Playlist document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Playlist document */
  update?: InputMaybe<PlaylistUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Playlist document */
  upsert?: InputMaybe<PlaylistUpsertWithNestedWhereUniqueInput>;
};

export type PlaylistUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PlaylistUpdateInput;
  /** Unique document search */
  where: PlaylistWhereUniqueInput;
};

export type PlaylistUpsertInput = {
  /** Create document if it didn't exist */
  create: PlaylistCreateInput;
  /** Update document if it exists */
  update: PlaylistUpdateInput;
};

export type PlaylistUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PlaylistUpsertInput;
  /** Unique document search */
  where: PlaylistWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PlaylistWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PlaylistWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PlaylistWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PlaylistWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PlaylistWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PlaylistWhereStageInput>;
  documentInStages_none?: InputMaybe<PlaylistWhereStageInput>;
  documentInStages_some?: InputMaybe<PlaylistWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  questionIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  questionIDs_contains_all?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  questionIDs_contains_none?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  questionIDs_contains_some?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  questionIDs_not?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  textBookSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  textBookSlugs_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  textBookSlugs_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  textBookSlugs_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  textBookSlugs_not?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoLessons_every?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_none?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_some?: InputMaybe<VideoLessonWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PlaylistWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PlaylistWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PlaylistWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PlaylistWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PlaylistWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Playlist record uniquely */
export type PlaylistWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type PodcastEpisode = Entity & Node & {
  __typename?: 'PodcastEpisode';
  audioFile?: Maybe<Asset>;
  automatedTranscript?: Maybe<RichText>;
  contentTrackSteps: Array<ContentTrackStep>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<PodcastEpisode>;
  durationInSeconds?: Maybe<Scalars['Int']['output']>;
  /** List of PodcastEpisode versions */
  history: Array<Version>;
  iTunesLink?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  isComingSoon?: Maybe<Scalars['Boolean']['output']>;
  megaphoneLink?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  posterImage?: Maybe<Asset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  relatedArticle?: Maybe<Article>;
  relatedUrl?: Maybe<Scalars['String']['output']>;
  /** The date on which this episode was publicly released. */
  releaseDate?: Maybe<Scalars['Date']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoImage?: Maybe<Asset>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  spotifyLink?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  stitcherLink?: Maybe<Scalars['String']['output']>;
  terms: Array<Term>;
  title: Scalars['String']['output'];
  transcript?: Maybe<RichText>;
  transistorLink?: Maybe<Scalars['String']['output']>;
  tuneInLink?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PodcastEpisodeAudioFileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type PodcastEpisodeContentTrackStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackStepWhereInput>;
};


export type PodcastEpisodeCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PodcastEpisodeDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PodcastEpisodeHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PodcastEpisodePosterImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type PodcastEpisodePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PodcastEpisodeRelatedArticleArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PodcastEpisodeScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PodcastEpisodeSeoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type PodcastEpisodeTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


export type PodcastEpisodeUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PodcastEpisodeConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PodcastEpisodeWhereUniqueInput;
};

/** A connection to a list of items. */
export type PodcastEpisodeConnection = {
  __typename?: 'PodcastEpisodeConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PodcastEpisodeEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PodcastEpisodeCreateInput = {
  audioFile?: InputMaybe<AssetCreateOneInlineInput>;
  automatedTranscript?: InputMaybe<Scalars['RichTextAST']['input']>;
  contentTrackSteps?: InputMaybe<ContentTrackStepCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  iTunesLink?: InputMaybe<Scalars['String']['input']>;
  isComingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  megaphoneLink?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  posterImage?: InputMaybe<AssetCreateOneInlineInput>;
  relatedArticle?: InputMaybe<ArticleCreateOneInlineInput>;
  relatedUrl?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoImage?: InputMaybe<AssetCreateOneInlineInput>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  spotifyLink?: InputMaybe<Scalars['String']['input']>;
  stitcherLink?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermCreateManyInlineInput>;
  title: Scalars['String']['input'];
  transcript?: InputMaybe<Scalars['RichTextAST']['input']>;
  transistorLink?: InputMaybe<Scalars['String']['input']>;
  tuneInLink?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PodcastEpisodeCreateManyInlineInput = {
  /** Connect multiple existing PodcastEpisode documents */
  connect?: InputMaybe<Array<PodcastEpisodeWhereUniqueInput>>;
  /** Create and connect multiple existing PodcastEpisode documents */
  create?: InputMaybe<Array<PodcastEpisodeCreateInput>>;
};

export type PodcastEpisodeCreateOneInlineInput = {
  /** Connect one existing PodcastEpisode document */
  connect?: InputMaybe<PodcastEpisodeWhereUniqueInput>;
  /** Create and connect one PodcastEpisode document */
  create?: InputMaybe<PodcastEpisodeCreateInput>;
};

/** An edge in a connection. */
export type PodcastEpisodeEdge = {
  __typename?: 'PodcastEpisodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PodcastEpisode;
};

/** Identifies documents */
export type PodcastEpisodeManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PodcastEpisodeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PodcastEpisodeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PodcastEpisodeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  audioFile?: InputMaybe<AssetWhereInput>;
  contentTrackSteps_every?: InputMaybe<ContentTrackStepWhereInput>;
  contentTrackSteps_none?: InputMaybe<ContentTrackStepWhereInput>;
  contentTrackSteps_some?: InputMaybe<ContentTrackStepWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<PodcastEpisodeWhereStageInput>;
  documentInStages_none?: InputMaybe<PodcastEpisodeWhereStageInput>;
  documentInStages_some?: InputMaybe<PodcastEpisodeWhereStageInput>;
  durationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  durationInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  durationInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  durationInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  durationInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  durationInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  durationInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  durationInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  iTunesLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  iTunesLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  iTunesLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  iTunesLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  iTunesLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  iTunesLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  iTunesLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  iTunesLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  iTunesLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  iTunesLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isComingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isComingSoon_not?: InputMaybe<Scalars['Boolean']['input']>;
  megaphoneLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  megaphoneLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  megaphoneLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  megaphoneLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  megaphoneLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  megaphoneLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  megaphoneLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  megaphoneLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  megaphoneLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  megaphoneLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  number_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  number_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  number_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  number_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  number_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  number_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  number_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  posterImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  relatedArticle?: InputMaybe<ArticleWhereInput>;
  relatedUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  relatedUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  relatedUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  relatedUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  relatedUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  relatedUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  relatedUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  relatedUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  relatedUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  relatedUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  releaseDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  releaseDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  releaseDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  releaseDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  releaseDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  releaseDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  seoImage?: InputMaybe<AssetWhereInput>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoKeywords_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoKeywords_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoKeywords_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoKeywords_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoKeywords_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoKeywords_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoKeywords_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoKeywords_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoKeywords_starts_with?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  spotifyLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  spotifyLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  spotifyLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  spotifyLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  spotifyLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  spotifyLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  spotifyLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  spotifyLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  spotifyLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  spotifyLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  stitcherLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  stitcherLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  stitcherLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  stitcherLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  stitcherLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  stitcherLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  stitcherLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  stitcherLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  stitcherLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  stitcherLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  transistorLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  transistorLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  transistorLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  transistorLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  transistorLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  transistorLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  transistorLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  transistorLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  transistorLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  transistorLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  tuneInLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tuneInLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tuneInLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tuneInLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tuneInLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tuneInLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tuneInLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tuneInLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tuneInLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tuneInLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PodcastEpisodeOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  DurationInSecondsAsc = 'durationInSeconds_ASC',
  DurationInSecondsDesc = 'durationInSeconds_DESC',
  ITunesLinkAsc = 'iTunesLink_ASC',
  ITunesLinkDesc = 'iTunesLink_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsComingSoonAsc = 'isComingSoon_ASC',
  IsComingSoonDesc = 'isComingSoon_DESC',
  MegaphoneLinkAsc = 'megaphoneLink_ASC',
  MegaphoneLinkDesc = 'megaphoneLink_DESC',
  NumberAsc = 'number_ASC',
  NumberDesc = 'number_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  RelatedUrlAsc = 'relatedUrl_ASC',
  RelatedUrlDesc = 'relatedUrl_DESC',
  ReleaseDateAsc = 'releaseDate_ASC',
  ReleaseDateDesc = 'releaseDate_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SeoKeywordsAsc = 'seoKeywords_ASC',
  SeoKeywordsDesc = 'seoKeywords_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpotifyLinkAsc = 'spotifyLink_ASC',
  SpotifyLinkDesc = 'spotifyLink_DESC',
  StitcherLinkAsc = 'stitcherLink_ASC',
  StitcherLinkDesc = 'stitcherLink_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TransistorLinkAsc = 'transistorLink_ASC',
  TransistorLinkDesc = 'transistorLink_DESC',
  TuneInLinkAsc = 'tuneInLink_ASC',
  TuneInLinkDesc = 'tuneInLink_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type PodcastEpisodeUpdateInput = {
  audioFile?: InputMaybe<AssetUpdateOneInlineInput>;
  automatedTranscript?: InputMaybe<Scalars['RichTextAST']['input']>;
  contentTrackSteps?: InputMaybe<ContentTrackStepUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  iTunesLink?: InputMaybe<Scalars['String']['input']>;
  isComingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  megaphoneLink?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  posterImage?: InputMaybe<AssetUpdateOneInlineInput>;
  relatedArticle?: InputMaybe<ArticleUpdateOneInlineInput>;
  relatedUrl?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoImage?: InputMaybe<AssetUpdateOneInlineInput>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spotifyLink?: InputMaybe<Scalars['String']['input']>;
  stitcherLink?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['RichTextAST']['input']>;
  transistorLink?: InputMaybe<Scalars['String']['input']>;
  tuneInLink?: InputMaybe<Scalars['String']['input']>;
};

export type PodcastEpisodeUpdateManyInlineInput = {
  /** Connect multiple existing PodcastEpisode documents */
  connect?: InputMaybe<Array<PodcastEpisodeConnectInput>>;
  /** Create and connect multiple PodcastEpisode documents */
  create?: InputMaybe<Array<PodcastEpisodeCreateInput>>;
  /** Delete multiple PodcastEpisode documents */
  delete?: InputMaybe<Array<PodcastEpisodeWhereUniqueInput>>;
  /** Disconnect multiple PodcastEpisode documents */
  disconnect?: InputMaybe<Array<PodcastEpisodeWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PodcastEpisode documents */
  set?: InputMaybe<Array<PodcastEpisodeWhereUniqueInput>>;
  /** Update multiple PodcastEpisode documents */
  update?: InputMaybe<Array<PodcastEpisodeUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PodcastEpisode documents */
  upsert?: InputMaybe<Array<PodcastEpisodeUpsertWithNestedWhereUniqueInput>>;
};

export type PodcastEpisodeUpdateManyInput = {
  automatedTranscript?: InputMaybe<Scalars['RichTextAST']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  iTunesLink?: InputMaybe<Scalars['String']['input']>;
  isComingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  megaphoneLink?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  relatedUrl?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  spotifyLink?: InputMaybe<Scalars['String']['input']>;
  stitcherLink?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['RichTextAST']['input']>;
  transistorLink?: InputMaybe<Scalars['String']['input']>;
  tuneInLink?: InputMaybe<Scalars['String']['input']>;
};

export type PodcastEpisodeUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PodcastEpisodeUpdateManyInput;
  /** Document search */
  where: PodcastEpisodeWhereInput;
};

export type PodcastEpisodeUpdateOneInlineInput = {
  /** Connect existing PodcastEpisode document */
  connect?: InputMaybe<PodcastEpisodeWhereUniqueInput>;
  /** Create and connect one PodcastEpisode document */
  create?: InputMaybe<PodcastEpisodeCreateInput>;
  /** Delete currently connected PodcastEpisode document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PodcastEpisode document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PodcastEpisode document */
  update?: InputMaybe<PodcastEpisodeUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PodcastEpisode document */
  upsert?: InputMaybe<PodcastEpisodeUpsertWithNestedWhereUniqueInput>;
};

export type PodcastEpisodeUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PodcastEpisodeUpdateInput;
  /** Unique document search */
  where: PodcastEpisodeWhereUniqueInput;
};

export type PodcastEpisodeUpsertInput = {
  /** Create document if it didn't exist */
  create: PodcastEpisodeCreateInput;
  /** Update document if it exists */
  update: PodcastEpisodeUpdateInput;
};

export type PodcastEpisodeUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PodcastEpisodeUpsertInput;
  /** Unique document search */
  where: PodcastEpisodeWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PodcastEpisodeWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PodcastEpisodeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PodcastEpisodeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PodcastEpisodeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PodcastEpisodeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  audioFile?: InputMaybe<AssetWhereInput>;
  contentTrackSteps_every?: InputMaybe<ContentTrackStepWhereInput>;
  contentTrackSteps_none?: InputMaybe<ContentTrackStepWhereInput>;
  contentTrackSteps_some?: InputMaybe<ContentTrackStepWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<PodcastEpisodeWhereStageInput>;
  documentInStages_none?: InputMaybe<PodcastEpisodeWhereStageInput>;
  documentInStages_some?: InputMaybe<PodcastEpisodeWhereStageInput>;
  durationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  durationInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  durationInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  durationInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  durationInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  durationInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  durationInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  durationInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  iTunesLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  iTunesLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  iTunesLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  iTunesLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  iTunesLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  iTunesLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  iTunesLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  iTunesLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  iTunesLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  iTunesLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isComingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isComingSoon_not?: InputMaybe<Scalars['Boolean']['input']>;
  megaphoneLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  megaphoneLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  megaphoneLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  megaphoneLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  megaphoneLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  megaphoneLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  megaphoneLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  megaphoneLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  megaphoneLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  megaphoneLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  number_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  number_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  number_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  number_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  number_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  number_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  number_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  posterImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  relatedArticle?: InputMaybe<ArticleWhereInput>;
  relatedUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  relatedUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  relatedUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  relatedUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  relatedUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  relatedUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  relatedUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  relatedUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  relatedUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  relatedUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  releaseDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  releaseDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  releaseDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  releaseDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  releaseDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  releaseDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  seoImage?: InputMaybe<AssetWhereInput>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoKeywords_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoKeywords_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoKeywords_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoKeywords_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoKeywords_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoKeywords_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoKeywords_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoKeywords_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoKeywords_starts_with?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  seoTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  seoTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  seoTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  seoTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  seoTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  spotifyLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  spotifyLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  spotifyLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  spotifyLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  spotifyLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  spotifyLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  spotifyLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  spotifyLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  spotifyLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  spotifyLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  stitcherLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  stitcherLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  stitcherLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  stitcherLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  stitcherLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  stitcherLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  stitcherLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  stitcherLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  stitcherLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  stitcherLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  transistorLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  transistorLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  transistorLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  transistorLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  transistorLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  transistorLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  transistorLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  transistorLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  transistorLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  transistorLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  tuneInLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tuneInLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tuneInLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tuneInLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tuneInLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tuneInLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tuneInLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tuneInLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tuneInLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tuneInLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PodcastEpisodeWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PodcastEpisodeWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PodcastEpisodeWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PodcastEpisodeWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PodcastEpisodeWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PodcastEpisode record uniquely */
export type PodcastEpisodeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductName = Entity & Node & {
  __typename?: 'ProductName';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ProductName>;
  /** List of ProductName versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  supportArticles: Array<SupportArticle>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ProductNameCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductNameDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ProductNameHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ProductNamePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductNameScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ProductNameSupportArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SupportArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SupportArticleWhereInput>;
};


export type ProductNameUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductNameConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProductNameWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProductNameConnection = {
  __typename?: 'ProductNameConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProductNameEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProductNameCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  supportArticles?: InputMaybe<SupportArticleCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductNameCreateManyInlineInput = {
  /** Connect multiple existing ProductName documents */
  connect?: InputMaybe<Array<ProductNameWhereUniqueInput>>;
  /** Create and connect multiple existing ProductName documents */
  create?: InputMaybe<Array<ProductNameCreateInput>>;
};

export type ProductNameCreateOneInlineInput = {
  /** Connect one existing ProductName document */
  connect?: InputMaybe<ProductNameWhereUniqueInput>;
  /** Create and connect one ProductName document */
  create?: InputMaybe<ProductNameCreateInput>;
};

/** An edge in a connection. */
export type ProductNameEdge = {
  __typename?: 'ProductNameEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductName;
};

/** Identifies documents */
export type ProductNameManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductNameWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductNameWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductNameWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductNameWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductNameWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductNameWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  supportArticles_every?: InputMaybe<SupportArticleWhereInput>;
  supportArticles_none?: InputMaybe<SupportArticleWhereInput>;
  supportArticles_some?: InputMaybe<SupportArticleWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProductNameOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ProductNameUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  supportArticles?: InputMaybe<SupportArticleUpdateManyInlineInput>;
};

export type ProductNameUpdateManyInlineInput = {
  /** Connect multiple existing ProductName documents */
  connect?: InputMaybe<Array<ProductNameConnectInput>>;
  /** Create and connect multiple ProductName documents */
  create?: InputMaybe<Array<ProductNameCreateInput>>;
  /** Delete multiple ProductName documents */
  delete?: InputMaybe<Array<ProductNameWhereUniqueInput>>;
  /** Disconnect multiple ProductName documents */
  disconnect?: InputMaybe<Array<ProductNameWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductName documents */
  set?: InputMaybe<Array<ProductNameWhereUniqueInput>>;
  /** Update multiple ProductName documents */
  update?: InputMaybe<Array<ProductNameUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductName documents */
  upsert?: InputMaybe<Array<ProductNameUpsertWithNestedWhereUniqueInput>>;
};

export type ProductNameUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type ProductNameUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProductNameUpdateManyInput;
  /** Document search */
  where: ProductNameWhereInput;
};

export type ProductNameUpdateOneInlineInput = {
  /** Connect existing ProductName document */
  connect?: InputMaybe<ProductNameWhereUniqueInput>;
  /** Create and connect one ProductName document */
  create?: InputMaybe<ProductNameCreateInput>;
  /** Delete currently connected ProductName document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductName document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductName document */
  update?: InputMaybe<ProductNameUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductName document */
  upsert?: InputMaybe<ProductNameUpsertWithNestedWhereUniqueInput>;
};

export type ProductNameUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProductNameUpdateInput;
  /** Unique document search */
  where: ProductNameWhereUniqueInput;
};

export type ProductNameUpsertInput = {
  /** Create document if it didn't exist */
  create: ProductNameCreateInput;
  /** Update document if it exists */
  update: ProductNameUpdateInput;
};

export type ProductNameUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProductNameUpsertInput;
  /** Unique document search */
  where: ProductNameWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProductNameWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductNameWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductNameWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductNameWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductNameWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductNameWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductNameWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductNameWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  supportArticles_every?: InputMaybe<SupportArticleWhereInput>;
  supportArticles_none?: InputMaybe<SupportArticleWhereInput>;
  supportArticles_some?: InputMaybe<SupportArticleWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductNameWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductNameWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductNameWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductNameWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductNameWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ProductName record uniquely */
export type ProductNameWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type PromoteScoCustomerSegmentInput = {
  customerSegmentId: Scalars['String']['input'];
};

export type PromoteScoCustomerSegmentPayload = {
  __typename?: 'PromoteScoCustomerSegmentPayload';
  customerProfile?: Maybe<ScoCustomerProfile>;
  customerSearch?: Maybe<ScoCustomerSearch>;
  customerSegment?: Maybe<ScoCustomerSegment>;
};

export type ProposeAdvisorSessionScheduleInput = {
  advisorSessionId?: InputMaybe<Scalars['String']['input']>;
  suggestedTimes?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type ProposeAdvisorSessionSchedulePayload = {
  __typename?: 'ProposeAdvisorSessionSchedulePayload';
  advisorSession?: Maybe<ScoAdvisorSession>;
};

export type ProvisionedAccount = ScoNode & {
  __typename?: 'ProvisionedAccount';
  application: Scalars['String']['output'];
  couponCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** UUID */
  provisionedAccountId: Scalars['String']['output'];
  redeemedAt: Scalars['DateTime']['output'];
  /** The external account's id */
  reference: Scalars['String']['output'];
  subscription?: Maybe<ScoSubscription>;
  user?: Maybe<ScoUser>;
};

export type PublishLocaleInput = {
  /** Locales to publish */
  locale: Locale;
  /** Stages to publish selected locales to */
  stages: Array<Stage>;
};

export type PurchaseAttempt = ScoNode & {
  __typename?: 'PurchaseAttempt';
  cardLast4Digits?: Maybe<Scalars['String']['output']>;
  chargifyResponseAsJSON?: Maybe<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  purchaseAttemptId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<ScoSubscription>;
  successfulAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ScoUser>;
};

export type PurchaseAttemptCollection = {
  __typename?: 'PurchaseAttemptCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<PurchaseAttempt>>;
  pagination: Pagination;
};

export type Query = {
  __typename?: 'Query';
  accountGroupBySlug?: Maybe<ScoAccountGroup>;
  accountGroups?: Maybe<ScoAccountGroupCollection>;
  adminAdvisorAgreements?: Maybe<ScoAdvisorAgreementCollection>;
  adminAdvisorEngagements?: Maybe<ScoAdvisorEngagementCollection>;
  adminAdvisorPayout?: Maybe<ScoAdvisorPayout>;
  adminAdvisorPayouts?: Maybe<ScoAdvisorPayoutCollection>;
  adminAdvisorProfiles?: Maybe<ScoAdvisorProfileCollection>;
  adminAdvisorRatings?: Maybe<ScoRatingCollection>;
  adminAdvisorSessions?: Maybe<ScoAdvisorSessionCollection>;
  adminGroupRequests?: Maybe<GroupRequestCollection>;
  adminRecordReassignPreview?: Maybe<ScoAdminRecordReassignPreview>;
  advisorAgreement?: Maybe<ScoAdvisorAgreement>;
  advisorAgreementPdf?: Maybe<ScoAdvisorAgreementPdf>;
  advisorAgreements?: Maybe<ScoAdvisorAgreementCollection>;
  advisorBoard?: Maybe<Array<Maybe<ScoAdvisorEngagement>>>;
  advisorCompOverviewPdf?: Maybe<ScoAdvisorAgreementPdf>;
  advisorDirectory?: Maybe<ScoAdvisorProfileCollection>;
  advisorEngagement?: Maybe<ScoAdvisorEngagement>;
  advisorEngagements?: Maybe<ScoAdvisorEngagementCollection>;
  advisorLedgerEntries?: Maybe<ScoAdvisorLedgerEntryCollection>;
  advisorMatchedOpenSeats?: Maybe<ScoUserMatchCollection>;
  advisorPayoutBalance?: Maybe<ScoAdvisorPayoutBalance>;
  advisorPayouts?: Maybe<ScoAdvisorPayoutCollection>;
  advisorProfile?: Maybe<ScoAdvisorProfile>;
  advisorSeatApplications?: Maybe<GroupCommitmentCollection>;
  advisorSession?: Maybe<ScoAdvisorSession>;
  advisorSessions?: Maybe<ScoAdvisorSessionCollection>;
  advisorWilThread?: Maybe<ScoToolSession>;
  /** Retrieve a single article */
  article?: Maybe<Article>;
  /** Retrieve document version */
  articleVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple articles */
  articles: Array<Article>;
  /** Retrieve multiple articles using the Relay connection interface */
  articlesConnection: ArticleConnection;
  /** Retrieve a single asset */
  asset?: Maybe<Asset>;
  /** Retrieve document version */
  assetVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple assets */
  assets: Array<Asset>;
  /** Retrieve multiple assets using the Relay connection interface */
  assetsConnection: AssetConnection;
  /**
   * Admin-only paginated search over Beancounter payments. Filters by brand,
   * product, status, recurring type, amount, dates, payer details, and sales
   * attribution. Default order is effectiveDate descending. Requires admin auth.
   */
  beancounterPayments?: Maybe<BeancounterPaymentCollection>;
  beancounterReports?: Maybe<BeancounterReports>;
  /**
   * Admin-only paginated search over Beancounter transaction lines. Filters on
   * transaction type/amount/date and on parent payment attributes (brand, product,
   * recurring type, payer, sales person). Always joins the parent payment. Default
   * order is effectiveDate descending. Requires admin auth.
   */
  beancounterTransactions?: Maybe<BeancounterTransactionCollection>;
  /** Retrieve a single benefit */
  benefit?: Maybe<Benefit>;
  /** Retrieve document version */
  benefitVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple benefits */
  benefits: Array<Benefit>;
  /** Retrieve multiple benefits using the Relay connection interface */
  benefitsConnection: BenefitConnection;
  /** Retrieve a single bootcampEvent */
  bootcampEvent?: Maybe<BootcampEvent>;
  /** Retrieve document version */
  bootcampEventVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple bootcampEvents */
  bootcampEvents: Array<BootcampEvent>;
  /** Retrieve multiple bootcampEvents using the Relay connection interface */
  bootcampEventsConnection: BootcampEventConnection;
  brandPartners: Array<Maybe<BrandPartner>>;
  /** Retrieve a single businessStage */
  businessStage?: Maybe<BusinessStage>;
  /** Retrieve document version */
  businessStageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple businessStages */
  businessStages: Array<BusinessStage>;
  /** Retrieve multiple businessStages using the Relay connection interface */
  businessStagesConnection: BusinessStageConnection;
  chat?: Maybe<Chat>;
  clarityAdvisorImport: ScoClarityAdvisorImport;
  clarityAnswer?: Maybe<ClarityAnswer>;
  clarityExpert?: Maybe<ClarityExpert>;
  clarityExperts: Array<Maybe<ClarityExpert>>;
  clarityQuestion?: Maybe<ClarityQuestion>;
  clarityQuestions?: Maybe<Array<Maybe<ClarityQuestion>>>;
  clarityTopic?: Maybe<ClarityTopic>;
  clarityTopics?: Maybe<Array<Maybe<ClarityTopic>>>;
  /** Retrieve a single coachProfile */
  coachProfile?: Maybe<CoachProfile>;
  /** Retrieve document version */
  coachProfileVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple coachProfiles */
  coachProfiles: Array<CoachProfile>;
  /** Retrieve multiple coachProfiles using the Relay connection interface */
  coachProfilesConnection: CoachProfileConnection;
  coachingEnrollment?: Maybe<CoachingEnrollment>;
  coachingEnrollments?: Maybe<CoachingEnrollmentCollection>;
  communityGroups?: Maybe<GroupCollection>;
  companyById?: Maybe<ScoCompany>;
  /** Retrieve a single contentTrack */
  contentTrack?: Maybe<ContentTrack>;
  /** Retrieve a single contentTrackSection */
  contentTrackSection?: Maybe<ContentTrackSection>;
  /** Retrieve document version */
  contentTrackSectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple contentTrackSections */
  contentTrackSections: Array<ContentTrackSection>;
  /** Retrieve multiple contentTrackSections using the Relay connection interface */
  contentTrackSectionsConnection: ContentTrackSectionConnection;
  /** Retrieve a single contentTrackStep */
  contentTrackStep?: Maybe<ContentTrackStep>;
  /** Retrieve document version */
  contentTrackStepVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple contentTrackSteps */
  contentTrackSteps: Array<ContentTrackStep>;
  /** Retrieve multiple contentTrackSteps using the Relay connection interface */
  contentTrackStepsConnection: ContentTrackStepConnection;
  /** Retrieve a single contentTrackTask */
  contentTrackTask?: Maybe<ContentTrackTask>;
  /** Retrieve document version */
  contentTrackTaskVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple contentTrackTasks */
  contentTrackTasks: Array<ContentTrackTask>;
  /** Retrieve multiple contentTrackTasks using the Relay connection interface */
  contentTrackTasksConnection: ContentTrackTaskConnection;
  /** Retrieve document version */
  contentTrackVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple contentTracks */
  contentTracks: Array<ContentTrack>;
  /** Retrieve multiple contentTracks using the Relay connection interface */
  contentTracksConnection: ContentTrackConnection;
  currentUser?: Maybe<ScoUser>;
  /** Fetches an object given its ID */
  entities?: Maybe<Array<Entity>>;
  fgAirtableEvent?: Maybe<GroupWorkshop>;
  fgAirtableIndustries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fgAirtableMemberSearch?: Maybe<FgAirtableMemberCollection>;
  fgStats: FgStats;
  fgTracks?: Maybe<FgTrackCollection>;
  forum?: Maybe<Forum>;
  /** Retrieve a single founderTrack */
  founderTrack?: Maybe<FounderTrack>;
  /** Retrieve a single founderTrackStep */
  founderTrackStep?: Maybe<FounderTrackStep>;
  /** Retrieve document version */
  founderTrackStepVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple founderTrackSteps */
  founderTrackSteps: Array<FounderTrackStep>;
  /** Retrieve multiple founderTrackSteps using the Relay connection interface */
  founderTrackStepsConnection: FounderTrackStepConnection;
  /** Retrieve a single founderTrackTask */
  founderTrackTask?: Maybe<FounderTrackTask>;
  /** Retrieve document version */
  founderTrackTaskVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple founderTrackTasks */
  founderTrackTasks: Array<FounderTrackTask>;
  /** Retrieve multiple founderTrackTasks using the Relay connection interface */
  founderTrackTasksConnection: FounderTrackTaskConnection;
  /** Retrieve document version */
  founderTrackVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple founderTracks */
  founderTracks: Array<FounderTrack>;
  /** Retrieve multiple founderTracks using the Relay connection interface */
  founderTracksConnection: FounderTrackConnection;
  fundingProfiles: Array<Maybe<FundingProfile>>;
  group?: Maybe<Group>;
  groupCandidate?: Maybe<GroupCandidate>;
  groupCandidates?: Maybe<GroupCandidateCollection>;
  groupCommitment?: Maybe<GroupCommitment>;
  groupCommitments?: Maybe<GroupCommitmentCollection>;
  groupCommunities?: Maybe<Array<Maybe<GroupCommunity>>>;
  groupDiscussions?: Maybe<ScoThreadCollection>;
  groupEvent?: Maybe<GroupEvent>;
  groupEventAttendance?: Maybe<GroupEventAttendance>;
  groupEventTypes?: Maybe<Array<Maybe<GroupEventType>>>;
  groupEvents?: Maybe<GroupEventCollection>;
  groupInteractions?: Maybe<Array<Maybe<GroupInteractionType>>>;
  groupMember?: Maybe<GroupMember>;
  groupMemberUser?: Maybe<ScoUser>;
  groupMemberUsers?: Maybe<ScoUserCollection>;
  groupMembers?: Maybe<GroupMemberCollection>;
  groupNotifications?: Maybe<GroupNotificationCollection>;
  groupOfficeHourSessions?: Maybe<Array<Maybe<GroupOfficeHourSession>>>;
  groupPost?: Maybe<GroupPost>;
  groupPosts?: Maybe<GroupPostCollection>;
  groupPreview?: Maybe<GroupPreview>;
  groupRequest?: Maybe<GroupRequest>;
  groupRequestTypes?: Maybe<Array<Maybe<GroupRequestType>>>;
  groupRequests?: Maybe<GroupRequestCollection>;
  groupTopics?: Maybe<Array<Maybe<GroupTopic>>>;
  groupWorkshops?: Maybe<Array<Maybe<GroupWorkshop>>>;
  groupedNotifications?: Maybe<Array<Maybe<ScoNotification>>>;
  groups?: Maybe<GroupCollection>;
  launchProfiles: Array<Maybe<LaunchProfile>>;
  launchStats: LaunchStats;
  likesByLikeableId?: Maybe<Array<Maybe<ScoLike>>>;
  /** Retrieve a single link */
  link?: Maybe<Link>;
  /** Retrieve document version */
  linkVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple links */
  links: Array<Link>;
  /** Retrieve multiple links using the Relay connection interface */
  linksConnection: LinkConnection;
  modelLog?: Maybe<ModelLog>;
  modelLogs?: Maybe<ModelLogCollection>;
  myAdvisorProfile?: Maybe<ScoAdvisorProfile>;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  notification?: Maybe<ScoNotification>;
  notifications?: Maybe<Array<Maybe<ScoNotification>>>;
  /** Retrieve a single person */
  person?: Maybe<Person>;
  /** Retrieve document version */
  personVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple persons */
  persons: Array<Person>;
  /** Retrieve multiple persons using the Relay connection interface */
  personsConnection: PersonConnection;
  /** Retrieve a single playlist */
  playlist?: Maybe<Playlist>;
  /** Retrieve document version */
  playlistVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple playlists */
  playlists: Array<Playlist>;
  /** Retrieve multiple playlists using the Relay connection interface */
  playlistsConnection: PlaylistConnection;
  /** Retrieve a single podcastEpisode */
  podcastEpisode?: Maybe<PodcastEpisode>;
  /** Retrieve document version */
  podcastEpisodeVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple podcastEpisodes */
  podcastEpisodes: Array<PodcastEpisode>;
  /** Retrieve multiple podcastEpisodes using the Relay connection interface */
  podcastEpisodesConnection: PodcastEpisodeConnection;
  product: ScoProduct;
  /** Retrieve a single productName */
  productName?: Maybe<ProductName>;
  /** Retrieve document version */
  productNameVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple productNames */
  productNames: Array<ProductName>;
  /** Retrieve multiple productNames using the Relay connection interface */
  productNamesConnection: ProductNameConnection;
  purchaseAttempts?: Maybe<PurchaseAttemptCollection>;
  /**
   * A saved reply's text for one desk conversation, with {{first_name}} filled
   * from the member's first name ("there" when unknown). The reply must be shared
   * or this inbox's own, and the thread on this account's desk. Inserting replaces
   * the box. Sco admins only.
   */
  renderCrmSavedReply?: Maybe<Scalars['String']['output']>;
  /** Retrieve a single review */
  review?: Maybe<Review>;
  /** Retrieve document version */
  reviewVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple reviews */
  reviews: Array<Review>;
  /** Retrieve multiple reviews using the Relay connection interface */
  reviewsConnection: ReviewConnection;
  /** Retrieve a single scheduledOperation */
  scheduledOperation?: Maybe<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations */
  scheduledOperations: Array<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations using the Relay connection interface */
  scheduledOperationsConnection: ScheduledOperationConnection;
  /** Retrieve a single scheduledRelease */
  scheduledRelease?: Maybe<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases */
  scheduledReleases: Array<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases using the Relay connection interface */
  scheduledReleasesConnection: ScheduledReleaseConnection;
  scoAiAction?: Maybe<ScoAiAction>;
  scoAiActions?: Maybe<ScoAiActionCollection>;
  /** Admin-only AI cost report from AiAction logs: daily spend by model and top users by cost. */
  scoAiCostReport: ScoAiCostReport;
  scoAnalytics?: Maybe<ScoAnalytics>;
  scoAnalyticsSavedReport?: Maybe<ScoAnalyticsSavedReport>;
  scoAnalyticsSavedReports?: Maybe<ScoAnalyticsSavedReportCollection>;
  scoAssets: Array<Maybe<ScoAsset>>;
  scoBootcamp?: Maybe<ScoBootcamp>;
  scoBootcampEnrollment?: Maybe<ScoBootcampEnrollment>;
  scoBootcampEnrollments?: Maybe<ScoBootcampEnrollmentCollection>;
  scoBootcamps?: Maybe<Array<Maybe<ScoBootcamp>>>;
  scoCompanies?: Maybe<ScoCompanyCollection>;
  scoCompanyStages?: Maybe<Array<Maybe<ScoCompanyStage>>>;
  scoContentTrackEnrollment?: Maybe<ScoContentTrackEnrollment>;
  scoContentTrackEnrollments?: Maybe<ScoContentTrackEnrollmentCollection>;
  scoContentTrackResponse?: Maybe<ScoContentTrackResponse>;
  scoContentTrackResponses?: Maybe<ScoContentTrackResponseCollection>;
  scoContentTrackViews?: Maybe<ScoViewCollection>;
  scoCourse?: Maybe<ScoCourse>;
  scoCourses: Array<Maybe<ScoCourse>>;
  /**
   * Desk account picker and the Settings Inboxes tab. Empty search is crmEnabled
   * users, newest first; with includeEligible, also the people a live responder
   * tool sends as who are not on the desk yet (turn one on with setUserCrm). A
   * search can match any user by name or email. Each row carries hasResponderTool,
   * sentAsName and bookingUrl. No consent fields (V2-L6). Sco admins only.
   */
  scoCrmAccounts?: Maybe<Array<Maybe<ScoCrmAccount>>>;
  /** Last 90 days of inbound volume and median first reply on direct chats with a crmEnabled participant. Sco admins only. */
  scoCrmBaseline?: Maybe<ScoCrmBaseline>;
  /**
   * What the rules pipeline would do with one pasted member message in this inbox:
   * the rule, the action, every step and gate, the template and card, and the
   * reply that would be written (with the writer's prompt). toolRuleId skips
   * scoring and uses that rule. Writes no draft, comment, run, claim or audit; a
   * model call logs a CrmDraftPreview ai_actions row. Sco admins only.
   */
  scoCrmDraftPreview?: Maybe<ScoCrmDraftPreview>;
  /** Member facts from users and company, plus counts on direct chats shared with the selected account. Sco admins only. */
  scoCrmMember?: Maybe<ScoCrmMember>;
  /**
   * Members to start a conversation with from one inbox (Inbox search, no
   * results): up to 5 people whose name or email matches `query` (at least 2
   * characters) who are not crmEnabled, not sco admins and not bots (V2-L16). Each
   * carries existingThreadId, their direct chat with this inbox when there is one,
   * so the desk opens it instead of making another. `accountUserId` must be a
   * crmEnabled inbox, never All inboxes. Sco admins only.
   */
  scoCrmMemberLookup?: Maybe<Array<Maybe<ScoCrmMemberMatch>>>;
  /**
   * CRM Reports (V2-L9): on time, AI help and longest waiting for one inbox (a
   * crmEnabled account) or All inboxes (accountUserId null). range is 7d, 30d or
   * qtd. Sco admins only.
   */
  scoCrmReport?: Maybe<ScoCrmReport>;
  /**
   * The inbox's responder tool (prompt, model, temperature, who replies are sent
   * as, and the model choices). Null when the account has no valid responder tool.
   * Sco admins only.
   */
  scoCrmResponderTool?: Maybe<ScoCrmResponderTool>;
  /**
   * Try it: score one member message against a reply tool's rules with every send
   * gate closed. Returns the winning rule, its score, its lane and the lane's
   * action. No writes. With rule scoring off, scoringLive is false and no rule is
   * returned. Sco admins only.
   */
  scoCrmRuleCheck?: Maybe<ScoCrmRuleCheck>;
  /**
   * Saved replies for one inbox: the shared replies plus that inbox's own (an
   * inbox reply overrides a shared one with the same title). With no
   * accountUserId, shared replies only. Bodies are unfilled ({{first_name}}
   * stays). Sco admins only.
   */
  scoCrmSavedReplies?: Maybe<Array<Maybe<ScoCrmSavedReply>>>;
  /**
   * Reply tools that send as nobody yet (audienceKey responder, no servesUserId):
   * what Add inbox offers beside making a new one. Newest first. Sco admins only.
   */
  scoCrmSpareReplyTools?: Maybe<Array<Maybe<ScoTool>>>;
  /**
   * The CRM pipeline switches as booleans (never env values): rule scoring,
   * drafts, the server and team auto-send switches, and this tool's switch (null
   * with no toolId). Sco admins only.
   */
  scoCrmSwitches?: Maybe<ScoCrmSwitches>;
  /**
   * Published transcript for one desk thread, including withdrawn tool messages.
   * Writes a read-audit row for the operator when there is none for this thread in
   * the last 15 minutes. Sco admins only.
   */
  scoCrmThread?: Maybe<ScoCrmThreadTranscript>;
  /**
   * Tool sessions for the desk, including guests when userId is omitted. Does not
   * apply userKeywords or hideEmpty. Sco admins only.
   */
  scoCrmToolSessions?: Maybe<ScoCrmToolSessionPage>;
  /**
   * The approved notes included in every advisor draft. Read only. Sco admins
   * only. These are writing boundaries, not a search index.
   */
  scoCrmWritingGuide?: Maybe<Array<Maybe<ScoCrmWritingNote>>>;
  scoCustomerProfile?: Maybe<ScoCustomerProfile>;
  scoCustomerProfileByShareToken?: Maybe<ScoCustomerProfileShare>;
  scoCustomerSearch?: Maybe<ScoCustomerSearch>;
  scoCustomerSearches?: Maybe<ScoCustomerSearchCollection>;
  scoEmailMessage?: Maybe<ScoEmailMessage>;
  scoEmailMessages?: Maybe<ScoEmailMessageCollection>;
  scoEmailSender?: Maybe<ScoEmailSender>;
  scoEmailSenders?: Maybe<ScoEmailSenderCollection>;
  scoEmptiesQuery?: Maybe<ScoEmptyTypeCollection>;
  scoEmptyFieldedQuery?: Maybe<ScoEmptyFieldedQuery>;
  scoEmptyQuery?: Maybe<ScoEmptyType>;
  scoIndustries?: Maybe<Array<Maybe<ScoIndustry>>>;
  scoInvestorMatch?: Maybe<ScoInvestorMatch>;
  scoInvestorMatches?: Maybe<ScoInvestorMatchCollection>;
  scoInvestorMessage?: Maybe<ScoInvestorMessage>;
  scoInvestorMessages?: Maybe<ScoInvestorMessageCollection>;
  scoInvestorProfile?: Maybe<ScoInvestorProfile>;
  scoInvestorProfileSearchOptions?: Maybe<ScoInvestorProfileSearchOptions>;
  scoInvestorProfiles?: Maybe<ScoInvestorProfileCollection>;
  scoInvestorSearch?: Maybe<ScoInvestorSearch>;
  scoInvestorSearchDraft?: Maybe<ScoInvestorSearchDraft>;
  scoInvestorSearches?: Maybe<ScoInvestorSearchCollection>;
  scoInvestorTags?: Maybe<Array<Maybe<ScoInvestorTag>>>;
  scoLikeable?: Maybe<ScoLikeable>;
  scoLoginAttempts?: Maybe<ScoLoginAttemptCollection>;
  scoMembers?: Maybe<ScoUserCollection>;
  scoNode?: Maybe<ScoNode>;
  scoPitchDeck?: Maybe<ScoPitchDeck>;
  scoPitchDeckAudit?: Maybe<ScoPitchDeckAudit>;
  scoPitchDeckAudits?: Maybe<Array<Maybe<ScoPitchDeckAudit>>>;
  scoPitchDeckSearch?: Maybe<ScoPitchDeckCollection>;
  scoPitchDecks?: Maybe<Array<Maybe<ScoPitchDeck>>>;
  scoPlaybook?: Maybe<ScoPlaybook>;
  scoPlaybooks: Array<Maybe<ScoPlaybook>>;
  scoProducts?: Maybe<Array<Maybe<ScoProduct>>>;
  scoPurchaseQuote?: Maybe<ScoPurchaseQuote>;
  scoRagCollection?: Maybe<ScoRagCollection>;
  scoRagCollections?: Maybe<ScoRagCollectionCollection>;
  scoRagSource?: Maybe<ScoRagSource>;
  scoSalesEvent?: Maybe<ScoSalesEvent>;
  scoSalesEvents?: Maybe<ScoSalesEventCollection>;
  scoSalesLead?: Maybe<ScoSalesLead>;
  scoSalesLeads?: Maybe<ScoSalesLeadCollection>;
  scoSalesPerson?: Maybe<ScoSalesPerson>;
  scoSalesPersons?: Maybe<ScoSalesPersonCollection>;
  scoSignupRequest?: Maybe<ScoSignupRequest>;
  scoSignupRequests?: Maybe<ScoSignupRequestCollection>;
  scoStaticOptions?: Maybe<ScoStaticOptions>;
  scoStats: ScoStats;
  scoSubscriptionChangeQuote?: Maybe<ScoSubscriptionChangeQuote>;
  scoTags?: Maybe<ScoTagCollection>;
  scoTask?: Maybe<ScoTask>;
  scoTaskTemplate?: Maybe<ScoTaskTemplate>;
  scoTaskTemplates?: Maybe<ScoTaskTemplateCollection>;
  scoTasks?: Maybe<ScoTaskCollection>;
  scoTeamMembers?: Maybe<Array<Maybe<ScoTeamMember>>>;
  scoTimeSeries?: Maybe<ScoTimeSeries>;
  scoTool?: Maybe<ScoTool>;
  /**
   * Knowledge cards, oldest first, with the rules that cite each one. With toolId:
   * the shared cards plus that tool's own; without: shared only. At most 100 a
   * page. Sco admins only.
   */
  scoToolKnowledgeCards?: Maybe<ScoToolKnowledgeCardPage>;
  /** Shared reply library in position order. Sco admins only. */
  scoToolReplyRules?: Maybe<Array<Maybe<ScoToolRule>>>;
  /** One reply-settings row. Omit toolId for the global switch. A missing row is off. Sco admins only. */
  scoToolReplySettings?: Maybe<ScoToolReplySettings>;
  /**
   * Reply templates (CRM Settings). With no toolId: the shared templates only.
   * With a toolId: the shared templates plus that responder tool's own. Sco admins only.
   */
  scoToolReplyTemplates?: Maybe<Array<Maybe<ScoToolReplyTemplate>>>;
  /** Library rules merged with one reply tool. toolId null is the library only. Sco admins only. */
  scoToolRuleBindings?: Maybe<ScoToolRuleBindingSet>;
  /**
   * Run counts for one responder tool, or every responder tool when scopeKey is
   * every-responder. The what-if bar is not saved. Sco admins only.
   */
  scoToolRuleMetrics?: Maybe<ScoToolRuleMetrics>;
  /**
   * Why each reply on this tool can or cannot send. Lists every blocker, the
   * visible sender, and the final wording. Sco admins only. Does not send.
   */
  scoToolRuleReadiness?: Maybe<ScoToolRuleReadiness>;
  /**
   * Production runs for one responder tool, newest first, at most 100 a page, with
   * counts over the whole filter. Member text comes back only with
   * includeMessages, only for desk threads. Sco admins only.
   */
  scoToolRuleRuns?: Maybe<ScoToolRuleRunPage>;
  scoToolSession?: Maybe<ScoToolSession>;
  scoToolSessions?: Maybe<ScoToolSessionCollection>;
  /** Recent fixture scores. Pass toolId to limit to one reply tool. Sco admins only. */
  scoToolTestRuns?: Maybe<Array<Maybe<ScoToolTestRun>>>;
  /**
   * The inbox of one crmEnabled account: direct chats with a member whose picked
   * account is this user, one person per row group, ordered by attention (owed
   * longest first, then waiting, then done newest) and paged by person. Carries
   * the people counts, the oldest owed person and the late threshold. `group`
   * (reply, older, waiting or done) pages one Inbox section; counts stay those of
   * the whole inbox. `search` (at least 2 characters) lists only the conversations
   * whose member name or email, or any published message, contains it: every
   * conversation of the inbox, past the 30-day window, in the same groups and
   * order, with counts of the matches and each row's matched message in
   * matchedCommentBody. Does not record a read. Sco admins only.
   */
  scoToolTriage?: Maybe<ScoToolTriagePayload>;
  /**
   * Every crmEnabled inbox in one queue: each conversation once, under its picked
   * account, grouped and paged by person across inboxes and ordered by attention.
   * Each row names its account. `group` (reply, older, waiting or done) pages one
   * Inbox section; counts stay those of the whole inbox. `search` (at least 2
   * characters) lists only the matching conversations across every inbox, as
   * scoToolTriage does. Does not record a read. Sco admins only.
   */
  scoToolTriageAll?: Maybe<ScoToolTriagePayload>;
  scoTools?: Maybe<ScoToolCollection>;
  scoUserMatch?: Maybe<ScoUserMatch>;
  scoUserMatches?: Maybe<ScoUserMatchCollection>;
  scoUserMentionOptions?: Maybe<Array<Maybe<ScoUserMentionOption>>>;
  scoUserSearch?: Maybe<ScoUserSearch>;
  scoUserSearchDraft?: Maybe<ScoUserSearchDraft>;
  scoUserSearches?: Maybe<ScoUserSearchCollection>;
  scoUsers?: Maybe<ScoUserCollection>;
  scoView?: Maybe<ScoView>;
  scoViews?: Maybe<ScoViewCollection>;
  skills?: Maybe<Array<Maybe<ScoTag>>>;
  storedFile?: Maybe<ScoStoredFile>;
  storedFiles?: Maybe<ScoStoredFileCollection>;
  subscription: ScoSubscription;
  subscriptions?: Maybe<ScoSubscriptionCollection>;
  /** Retrieve a single supportArticle */
  supportArticle?: Maybe<SupportArticle>;
  /** Retrieve document version */
  supportArticleVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple supportArticles */
  supportArticles: Array<SupportArticle>;
  /** Retrieve multiple supportArticles using the Relay connection interface */
  supportArticlesConnection: SupportArticleConnection;
  /** Retrieve multiple supportCategories */
  supportCategories: Array<SupportCategory>;
  /** Retrieve multiple supportCategories using the Relay connection interface */
  supportCategoriesConnection: SupportCategoryConnection;
  /** Retrieve a single supportCategory */
  supportCategory?: Maybe<SupportCategory>;
  /** Retrieve document version */
  supportCategoryVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single term */
  term?: Maybe<Term>;
  /** Retrieve document version */
  termVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple terms */
  terms: Array<Term>;
  /** Retrieve multiple terms using the Relay connection interface */
  termsConnection: TermConnection;
  threadFollows?: Maybe<ScoThreadCollection>;
  /** Tool drafts on one desk thread. Never personal drafts. Sco admins only. */
  toolDrafts?: Maybe<Array<Maybe<ScoCrmThreadComment>>>;
  unmatchedFGSubscriptions?: Maybe<Array<Maybe<ScoSubscription>>>;
  /** Retrieve a single user */
  user?: Maybe<User>;
  userById?: Maybe<ScoUser>;
  userBySlug?: Maybe<ScoUser>;
  /** Retrieve multiple users */
  users: Array<User>;
  /** Retrieve multiple users using the Relay connection interface */
  usersConnection: UserConnection;
  verifyAccount?: Maybe<ScoUserVerification>;
  /** Retrieve a single video */
  video?: Maybe<Video>;
  /** Retrieve a single videoCourse */
  videoCourse?: Maybe<VideoCourse>;
  /** Retrieve multiple videoCourseListEntries */
  videoCourseListEntries: Array<VideoCourseListEntry>;
  /** Retrieve multiple videoCourseListEntries using the Relay connection interface */
  videoCourseListEntriesConnection: VideoCourseListEntryConnection;
  /** Retrieve a single videoCourseListEntry */
  videoCourseListEntry?: Maybe<VideoCourseListEntry>;
  /** Retrieve document version */
  videoCourseListEntryVersion?: Maybe<DocumentVersion>;
  /** Retrieve document version */
  videoCourseVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple videoCourses */
  videoCourses: Array<VideoCourse>;
  /** Retrieve multiple videoCourses using the Relay connection interface */
  videoCoursesConnection: VideoCourseConnection;
  /** Retrieve a single videoLesson */
  videoLesson?: Maybe<VideoLesson>;
  /** Retrieve document version */
  videoLessonVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple videoLessons */
  videoLessons: Array<VideoLesson>;
  /** Retrieve multiple videoLessons using the Relay connection interface */
  videoLessonsConnection: VideoLessonConnection;
  /** Retrieve a single videoList */
  videoList?: Maybe<VideoList>;
  /** Retrieve multiple videoListEntries */
  videoListEntries: Array<VideoListEntry>;
  /** Retrieve multiple videoListEntries using the Relay connection interface */
  videoListEntriesConnection: VideoListEntryConnection;
  /** Retrieve a single videoListEntry */
  videoListEntry?: Maybe<VideoListEntry>;
  /** Retrieve document version */
  videoListEntryVersion?: Maybe<DocumentVersion>;
  /** Retrieve document version */
  videoListVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple videoLists */
  videoLists: Array<VideoList>;
  /** Retrieve multiple videoLists using the Relay connection interface */
  videoListsConnection: VideoListConnection;
  /** Retrieve a single videoPlaylist */
  videoPlaylist?: Maybe<VideoPlaylist>;
  /** Retrieve document version */
  videoPlaylistVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple videoPlaylists */
  videoPlaylists: Array<VideoPlaylist>;
  /** Retrieve multiple videoPlaylists using the Relay connection interface */
  videoPlaylistsConnection: VideoPlaylistConnection;
  /** Retrieve document version */
  videoVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple videos */
  videos: Array<Video>;
  /** Retrieve multiple videos using the Relay connection interface */
  videosConnection: VideoConnection;
  viewer?: Maybe<Viewer>;
};


export type QueryAccountGroupBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryAccountGroupsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminAdvisorAgreementsArgs = {
  advisorEngagementId?: InputMaybe<Scalars['String']['input']>;
  advisorUserNameOrEmail?: InputMaybe<Scalars['String']['input']>;
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  founderUserNameOrEmail?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  statusKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAdminAdvisorEngagementsArgs = {
  advisorUserNameOrEmail?: InputMaybe<Scalars['String']['input']>;
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  founderUserNameOrEmail?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  sourceKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAdminAdvisorPayoutArgs = {
  advisorPayoutId: Scalars['String']['input'];
};


export type QueryAdminAdvisorPayoutsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  statusKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userNameOrEmail?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminAdvisorProfilesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  categoryKey?: InputMaybe<Scalars['String']['input']>;
  isSessionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  statusKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripeConnectStatusKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userNameOrEmail?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminAdvisorRatingsArgs = {
  advisorSessionId?: InputMaybe<Scalars['String']['input']>;
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  scoreMax?: InputMaybe<Scalars['Int']['input']>;
  seekerOrExpertUserNameOrEmail?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminAdvisorSessionsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  expertUserNameOrEmail?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  seekerUserNameOrEmail?: InputMaybe<Scalars['String']['input']>;
  statusKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAdminGroupRequestsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  groupRequestTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  publishStatusKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestingUserNameOrEmail?: InputMaybe<Scalars['String']['input']>;
  requestingUserPaidTiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAdminRecordReassignPreviewArgs = {
  destinationUserId: Scalars['String']['input'];
  rootId: Scalars['String']['input'];
  rootType: ScoAdminReassignableType;
};


export type QueryAdvisorAgreementArgs = {
  advisorAgreementId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorAgreementPdfArgs = {
  advisorAgreementId?: InputMaybe<Scalars['String']['input']>;
  sourceKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorAgreementsArgs = {
  advisorEngagementId?: InputMaybe<Scalars['String']['input']>;
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  statusKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAdvisorCompOverviewPdfArgs = {
  caliberKey?: InputMaybe<Scalars['String']['input']>;
  companyStageKey?: InputMaybe<Scalars['String']['input']>;
  contributionTierKey?: InputMaybe<Scalars['String']['input']>;
  hoursPerMonth?: InputMaybe<Scalars['Int']['input']>;
  valuationInDollars?: InputMaybe<Scalars['Float']['input']>;
  warmIntroKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorDirectoryArgs = {
  acceptingSessions?: InputMaybe<Scalars['Boolean']['input']>;
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  categoryKey?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAdvisorEngagementArgs = {
  advisorEngagementId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorEngagementsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  founderUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAdvisorLedgerEntriesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAdvisorMatchedOpenSeatsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAdvisorPayoutsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAdvisorProfileArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorSeatApplicationsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  statusKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAdvisorSessionArgs = {
  advisorSessionId: Scalars['String']['input'];
};


export type QueryAdvisorSessionsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  statusKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryArticleArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ArticleWhereUniqueInput;
};


export type QueryArticleVersionArgs = {
  where: VersionWhereInput;
};


export type QueryArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ArticleWhereInput>;
};


export type QueryArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ArticleWhereInput>;
};


export type QueryAssetArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AssetWhereUniqueInput;
};


export type QueryAssetVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryBeancounterPaymentsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxValueInCents?: InputMaybe<Scalars['Int']['input']>;
  minValueInCents?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  payerCardLast4?: InputMaybe<Scalars['String']['input']>;
  payerEmail?: InputMaybe<Scalars['String']['input']>;
  payerName?: InputMaybe<Scalars['String']['input']>;
  payerUserId?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  recurringType?: InputMaybe<Scalars['String']['input']>;
  salesPersonId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBeancounterTransactionsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxValueInCents?: InputMaybe<Scalars['Int']['input']>;
  minValueInCents?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  payerCardLast4?: InputMaybe<Scalars['String']['input']>;
  payerEmail?: InputMaybe<Scalars['String']['input']>;
  payerName?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  recurringType?: InputMaybe<Scalars['String']['input']>;
  salesPersonId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBenefitArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: BenefitWhereUniqueInput;
};


export type QueryBenefitVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBenefitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BenefitOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<BenefitWhereInput>;
};


export type QueryBenefitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BenefitOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<BenefitWhereInput>;
};


export type QueryBootcampEventArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: BootcampEventWhereUniqueInput;
};


export type QueryBootcampEventVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBootcampEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BootcampEventOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<BootcampEventWhereInput>;
};


export type QueryBootcampEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BootcampEventOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<BootcampEventWhereInput>;
};


export type QueryBrandPartnersArgs = {
  unlimited?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBusinessStageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: BusinessStageWhereUniqueInput;
};


export type QueryBusinessStageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBusinessStagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BusinessStageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<BusinessStageWhereInput>;
};


export type QueryBusinessStagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BusinessStageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<BusinessStageWhereInput>;
};


export type QueryClarityAdvisorImportArgs = {
  handle: Scalars['String']['input'];
};


export type QueryClarityAnswerArgs = {
  answerId: Scalars['Int']['input'];
  questionId: Scalars['Int']['input'];
};


export type QueryClarityExpertArgs = {
  expertId: Scalars['Int']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClarityExpertsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClarityQuestionArgs = {
  questionId: Scalars['Int']['input'];
};


export type QueryClarityQuestionsArgs = {
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClarityTopicArgs = {
  slug: Scalars['String']['input'];
};


export type QueryClarityTopicsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCoachProfileArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CoachProfileWhereUniqueInput;
};


export type QueryCoachProfileVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCoachProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CoachProfileOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CoachProfileWhereInput>;
};


export type QueryCoachProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CoachProfileOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CoachProfileWhereInput>;
};


export type QueryCoachingEnrollmentArgs = {
  id: Scalars['String']['input'];
};


export type QueryCoachingEnrollmentsArgs = {
  coachSlug?: InputMaybe<Scalars['String']['input']>;
  conciergeId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommunityGroupsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyByIdArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryContentTrackArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ContentTrackWhereUniqueInput;
};


export type QueryContentTrackSectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ContentTrackSectionWhereUniqueInput;
};


export type QueryContentTrackSectionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryContentTrackSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContentTrackSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContentTrackSectionWhereInput>;
};


export type QueryContentTrackSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContentTrackSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContentTrackSectionWhereInput>;
};


export type QueryContentTrackStepArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ContentTrackStepWhereUniqueInput;
};


export type QueryContentTrackStepVersionArgs = {
  where: VersionWhereInput;
};


export type QueryContentTrackStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContentTrackStepOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContentTrackStepWhereInput>;
};


export type QueryContentTrackStepsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContentTrackStepOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContentTrackStepWhereInput>;
};


export type QueryContentTrackTaskArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ContentTrackTaskWhereUniqueInput;
};


export type QueryContentTrackTaskVersionArgs = {
  where: VersionWhereInput;
};


export type QueryContentTrackTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContentTrackTaskOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContentTrackTaskWhereInput>;
};


export type QueryContentTrackTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContentTrackTaskOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContentTrackTaskWhereInput>;
};


export type QueryContentTrackVersionArgs = {
  where: VersionWhereInput;
};


export type QueryContentTracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContentTrackOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContentTrackWhereInput>;
};


export type QueryContentTracksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContentTrackOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContentTrackWhereInput>;
};


export type QueryEntitiesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  where: Array<EntityWhereInput>;
};


export type QueryFgAirtableEventArgs = {
  eventIdentifier?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFgAirtableMemberSearchArgs = {
  companyIndustry?: InputMaybe<Scalars['String']['input']>;
  companyStage?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFgStatsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryFgTracksArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFounderTrackArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FounderTrackWhereUniqueInput;
};


export type QueryFounderTrackStepArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FounderTrackStepWhereUniqueInput;
};


export type QueryFounderTrackStepVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFounderTrackStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FounderTrackStepOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FounderTrackStepWhereInput>;
};


export type QueryFounderTrackStepsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FounderTrackStepOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FounderTrackStepWhereInput>;
};


export type QueryFounderTrackTaskArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FounderTrackTaskWhereUniqueInput;
};


export type QueryFounderTrackTaskVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFounderTrackTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FounderTrackTaskOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FounderTrackTaskWhereInput>;
};


export type QueryFounderTrackTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FounderTrackTaskOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FounderTrackTaskWhereInput>;
};


export type QueryFounderTrackVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFounderTracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FounderTrackOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FounderTrackWhereInput>;
};


export type QueryFounderTracksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FounderTrackOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FounderTrackWhereInput>;
};


export type QueryFundingProfilesArgs = {
  keywords?: InputMaybe<Scalars['String']['input']>;
  listName?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGroupArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupCandidateArgs = {
  groupCandidateId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupCandidatesArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userFullName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupCommitmentArgs = {
  groupCommitmentId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupCommitmentsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  committingUserId?: InputMaybe<Scalars['String']['input']>;
  groupRequestId?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  requestingUserId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupDiscussionsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  groupSlug?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupEventArgs = {
  groupEventId?: InputMaybe<Scalars['String']['input']>;
  groupSlug?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupEventAttendanceArgs = {
  groupEventAttendanceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupEventsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  groupSlug?: InputMaybe<Scalars['String']['input']>;
  hasGoogleCalendarError?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isAirtableManaged?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrentUserAttending?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  isFuture?: InputMaybe<Scalars['Boolean']['input']>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  maximumStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  minimumStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  topicKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeKey?: InputMaybe<Scalars['String']['input']>;
  typeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withFeaturedVideo?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGroupMemberArgs = {
  groupMemberId?: InputMaybe<Scalars['String']['input']>;
  groupSlug?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupMemberUserArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
  userSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupMemberUsersArgs = {
  companyIndustryKey?: InputMaybe<Scalars['String']['input']>;
  companyIndustryKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStageKey?: InputMaybe<Scalars['String']['input']>;
  companyStageKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  groupSlug?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  matchAll?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skillIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGroupMembersArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skillIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupNotificationsArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  groupSlug?: InputMaybe<Scalars['String']['input']>;
  isFollowingActingUser?: InputMaybe<Scalars['Boolean']['input']>;
  notifiableTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGroupOfficeHourSessionsArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGroupPostArgs = {
  groupPostId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupPostsArgs = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  groupPostTypeKey?: InputMaybe<Scalars['String']['input']>;
  groupSlug?: InputMaybe<Scalars['String']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  topicKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupPreviewArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupRequestArgs = {
  groupRequestId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupRequestsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  compensationTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupRequestTypeKey?: InputMaybe<Scalars['String']['input']>;
  groupRequestTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  publishStatusKey?: InputMaybe<Scalars['String']['input']>;
  publishStatusKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestingUserEmail?: InputMaybe<Scalars['String']['input']>;
  requestingUserFullName?: InputMaybe<Scalars['String']['input']>;
  requestingUserId?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGroupTopicsArgs = {
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGroupWorkshopsArgs = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGroupedNotificationsArgs = {
  includeDismissedNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  includeEmailedNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  includeExpiredNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  includeUsersOwnPosts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGroupsArgs = {
  excludeDefaultGroup?: InputMaybe<Scalars['Boolean']['input']>;
  memberNameOrEmail?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  statusKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLaunchProfilesArgs = {
  keywords?: InputMaybe<Scalars['String']['input']>;
  listName?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLikesByLikeableIdArgs = {
  likeableId: Scalars['String']['input'];
};


export type QueryLinkArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: LinkWhereUniqueInput;
};


export type QueryLinkVersionArgs = {
  where: VersionWhereInput;
};


export type QueryLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LinkWhereInput>;
};


export type QueryLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LinkWhereInput>;
};


export type QueryModelLogArgs = {
  modelLogId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryModelLogsArgs = {
  actingUserId?: InputMaybe<Scalars['String']['input']>;
  action?: InputMaybe<Scalars['String']['input']>;
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  relatedModelId?: InputMaybe<Scalars['String']['input']>;
  relatedModelType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
  locales?: Array<Locale>;
  stage?: Stage;
};


export type QueryNotificationArgs = {
  notificationId: Scalars['String']['input'];
};


export type QueryNotificationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPersonArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PersonWhereUniqueInput;
};


export type QueryPersonVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPersonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PersonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PersonWhereInput>;
};


export type QueryPersonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PersonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PersonWhereInput>;
};


export type QueryPlaylistArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PlaylistWhereUniqueInput;
};


export type QueryPlaylistVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PlaylistOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PlaylistWhereInput>;
};


export type QueryPlaylistsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PlaylistOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PlaylistWhereInput>;
};


export type QueryPodcastEpisodeArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PodcastEpisodeWhereUniqueInput;
};


export type QueryPodcastEpisodeVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPodcastEpisodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PodcastEpisodeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PodcastEpisodeWhereInput>;
};


export type QueryPodcastEpisodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PodcastEpisodeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PodcastEpisodeWhereInput>;
};


export type QueryProductArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  pricePointId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  termId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductNameArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ProductNameWhereUniqueInput;
};


export type QueryProductNameVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProductNamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductNameOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductNameWhereInput>;
};


export type QueryProductNamesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductNameOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductNameWhereInput>;
};


export type QueryPurchaseAttemptsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRenderCrmSavedReplyArgs = {
  accountUserId: Scalars['String']['input'];
  savedReplyId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type QueryReviewArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ReviewWhereUniqueInput;
};


export type QueryReviewVersionArgs = {
  where: VersionWhereInput;
};


export type QueryReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ReviewOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ReviewWhereInput>;
};


export type QueryReviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ReviewOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ReviewWhereInput>;
};


export type QueryScheduledOperationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledOperationWhereUniqueInput;
};


export type QueryScheduledOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledReleaseWhereUniqueInput;
};


export type QueryScheduledReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QueryScheduledReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QueryScoAiActionArgs = {
  aiActionId: Scalars['String']['input'];
};


export type QueryScoAiActionsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  createdAtRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoAiCostReportArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryScoAnalyticsSavedReportArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  scoAnalyticsSavedReportId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryScoAnalyticsSavedReportsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoAssetsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoBootcampArgs = {
  slug: Scalars['String']['input'];
};


export type QueryScoBootcampEnrollmentArgs = {
  bootcampEnrollmentId: Scalars['String']['input'];
};


export type QueryScoBootcampEnrollmentsArgs = {
  bootcampSlug?: InputMaybe<Scalars['String']['input']>;
  enrollmentTitle?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoCompaniesArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  founderEmail?: InputMaybe<Scalars['String']['input']>;
  founderName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScoContentTrackEnrollmentArgs = {
  contentTrackEnrollmentId?: InputMaybe<Scalars['String']['input']>;
  contentTrackId?: InputMaybe<Scalars['String']['input']>;
  contentTrackSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoContentTrackEnrollmentsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  contentTrackId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryScoContentTrackResponseArgs = {
  contentTrackEnrollmentId?: InputMaybe<Scalars['String']['input']>;
  contentTrackId?: InputMaybe<Scalars['String']['input']>;
  contentTrackResponseId?: InputMaybe<Scalars['String']['input']>;
  contentTrackSectionId?: InputMaybe<Scalars['String']['input']>;
  contentTrackStepId?: InputMaybe<Scalars['String']['input']>;
  contentTrackTaskId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoContentTrackResponsesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryScoContentTrackViewsArgs = {
  contentTrackEnrollmentId: Scalars['String']['input'];
  contentTrackId?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parentContext?: InputMaybe<Scalars['String']['input']>;
  viewableContext?: InputMaybe<Scalars['String']['input']>;
  viewableId?: InputMaybe<Scalars['String']['input']>;
  viewableType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoCourseArgs = {
  slug: Scalars['String']['input'];
};


export type QueryScoCrmAccountsArgs = {
  includeEligible?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoCrmDraftPreviewArgs = {
  accountUserId: Scalars['String']['input'];
  text: Scalars['String']['input'];
  toolRuleId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoCrmMemberArgs = {
  accountUserId: Scalars['String']['input'];
  memberUserId: Scalars['String']['input'];
};


export type QueryScoCrmMemberLookupArgs = {
  accountUserId: Scalars['String']['input'];
  query: Scalars['String']['input'];
};


export type QueryScoCrmReportArgs = {
  accountUserId?: InputMaybe<Scalars['String']['input']>;
  range: Scalars['String']['input'];
};


export type QueryScoCrmResponderToolArgs = {
  accountUserId: Scalars['String']['input'];
};


export type QueryScoCrmRuleCheckArgs = {
  text: Scalars['String']['input'];
  toolId: Scalars['String']['input'];
};


export type QueryScoCrmSavedRepliesArgs = {
  accountUserId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoCrmSwitchesArgs = {
  toolId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoCrmThreadArgs = {
  accountUserId?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
};


export type QueryScoCrmToolSessionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoCustomerProfileArgs = {
  customerProfileId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoCustomerProfileByShareTokenArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoCustomerSearchArgs = {
  customerSearchId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoCustomerSearchesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  statusKey?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoEmailMessageArgs = {
  emailMessageId: Scalars['String']['input'];
};


export type QueryScoEmailMessagesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  clickedAtRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAtRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  from?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openedAtRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  sendStatus?: InputMaybe<Scalars['String']['input']>;
  sentAtRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  templateKey?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoEmailSenderArgs = {
  emailSenderId: Scalars['String']['input'];
};


export type QueryScoEmailSendersArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoEmptiesQueryArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryScoEmptyQueryArgs = {
  emptyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoInvestorMatchArgs = {
  investorMatchId: Scalars['String']['input'];
};


export type QueryScoInvestorMatchesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  hqDistanceInMiles?: InputMaybe<Scalars['Int']['input']>;
  hqLatitude?: InputMaybe<Scalars['Float']['input']>;
  hqLocation?: InputMaybe<Scalars['String']['input']>;
  hqLocationCity?: InputMaybe<Scalars['String']['input']>;
  hqLocationCountry?: InputMaybe<Scalars['String']['input']>;
  hqLocationRegion?: InputMaybe<Scalars['String']['input']>;
  hqLocationState?: InputMaybe<Scalars['String']['input']>;
  hqLongitude?: InputMaybe<Scalars['Float']['input']>;
  investmentStages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  investorProfileIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  investorSearchId?: InputMaybe<Scalars['String']['input']>;
  investorTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSavedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  matchAll?: InputMaybe<Scalars['Boolean']['input']>;
  maximumInvestmentInDollars?: InputMaybe<Scalars['FriendlyNumeral']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  minimumInvestmentInDollars?: InputMaybe<Scalars['FriendlyNumeral']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  preferredIndustries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferredIndustriesAndVerticals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferredVerticals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchingUserHasSaved?: InputMaybe<Scalars['Boolean']['input']>;
  searchingUserId?: InputMaybe<Scalars['String']['input']>;
  targetInvestorProfileId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoInvestorMessageArgs = {
  investorMessageId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoInvestorMessagesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  filter?: InputMaybe<Scalars['String']['input']>;
  investorMatchId?: InputMaybe<Scalars['String']['input']>;
  investorSearchId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryScoInvestorProfileArgs = {
  investorProfileId: Scalars['String']['input'];
};


export type QueryScoInvestorProfilesArgs = {
  hqDistanceInMiles?: InputMaybe<Scalars['Int']['input']>;
  hqLatitude?: InputMaybe<Scalars['Float']['input']>;
  hqLocation?: InputMaybe<Scalars['String']['input']>;
  hqLocationCity?: InputMaybe<Scalars['String']['input']>;
  hqLocationCountry?: InputMaybe<Scalars['String']['input']>;
  hqLocationRegion?: InputMaybe<Scalars['String']['input']>;
  hqLocationState?: InputMaybe<Scalars['String']['input']>;
  hqLongitude?: InputMaybe<Scalars['Float']['input']>;
  investmentStages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  investorProfileIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  investorTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSavedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  matchAll?: InputMaybe<Scalars['Boolean']['input']>;
  maximumInvestmentInDollars?: InputMaybe<Scalars['FriendlyNumeral']['input']>;
  minimumInvestmentInDollars?: InputMaybe<Scalars['FriendlyNumeral']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  preferredIndustries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferredIndustriesAndVerticals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferredVerticals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suggestedForUser?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryScoInvestorSearchArgs = {
  investorSearchId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoInvestorSearchDraftArgs = {
  matchedInvestorProfilesLimit?: InputMaybe<Scalars['Int']['input']>;
  relevantInvestorTags?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  selectedInvestorTagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userSearchId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoInvestorSearchesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  excludeEmptyResults?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  searchingUserEmail?: InputMaybe<Scalars['String']['input']>;
  searchingUserFullName?: InputMaybe<Scalars['String']['input']>;
  searchingUserId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoInvestorTagsArgs = {
  investorTagTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoLikeableArgs = {
  likeableId: Scalars['String']['input'];
  likeableType: Scalars['String']['input'];
};


export type QueryScoLoginAttemptsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  createdAtRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryScoMembersArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  companyIndustryKey?: InputMaybe<Scalars['String']['input']>;
  companyIndustryKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStageKey?: InputMaybe<Scalars['String']['input']>;
  companyStageKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  groupSlug?: InputMaybe<Scalars['String']['input']>;
  isFounderCommunityUser?: InputMaybe<Scalars['Boolean']['input']>;
  isFounderGroupsUser?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  locationLatitude?: InputMaybe<Scalars['Float']['input']>;
  locationLongitude?: InputMaybe<Scalars['Float']['input']>;
  locationState?: InputMaybe<Scalars['String']['input']>;
  matchAll?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  skillIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryScoNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScoPitchDeckArgs = {
  pitchDeckId: Scalars['String']['input'];
};


export type QueryScoPitchDeckAuditArgs = {
  pitchDeckAuditId: Scalars['String']['input'];
};


export type QueryScoPitchDeckAuditsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pitchDeckId: Scalars['String']['input'];
};


export type QueryScoPitchDeckSearchArgs = {
  keywords?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScoPitchDecksArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoPlaybookArgs = {
  slug: Scalars['String']['input'];
};


export type QueryScoPlaybooksArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  topicKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryScoProductsArgs = {
  chargebeeItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productAndTermIds?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termId?: InputMaybe<Scalars['String']['input']>;
  termIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryScoPurchaseQuoteArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  termId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoRagCollectionArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  ragCollectionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoRagCollectionsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryScoRagSourceArgs = {
  ragSourceId: Scalars['String']['input'];
};


export type QueryScoSalesEventArgs = {
  salesEventId: Scalars['String']['input'];
};


export type QueryScoSalesEventsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  beancounterPaymentId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  maxPaymentTotalNetInCents?: InputMaybe<Scalars['Int']['input']>;
  minPaymentTotalNetInCents?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  paymentBrand?: InputMaybe<Scalars['String']['input']>;
  paymentProduct?: InputMaybe<Scalars['String']['input']>;
  salesEventTypeKey?: InputMaybe<Scalars['String']['input']>;
  salesPersonId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryScoSalesLeadArgs = {
  salesLeadId: Scalars['String']['input'];
};


export type QueryScoSalesLeadsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  salesPersonId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoSalesPersonArgs = {
  salesPersonId: Scalars['String']['input'];
};


export type QueryScoSalesPersonsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryScoSignupRequestArgs = {
  signupRequestId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoSignupRequestsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  funnelIdentifier?: InputMaybe<Scalars['String']['input']>;
  groupRequestTypeKey?: InputMaybe<Scalars['String']['input']>;
  groupRequestTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryScoSubscriptionChangeQuoteArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
  termId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoTagsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagTypeKey?: InputMaybe<Scalars['String']['input']>;
  tagTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoTaskArgs = {
  taskId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoTaskTemplateArgs = {
  taskTemplateId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoTaskTemplatesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  groupRequestTypeKey?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  parentTaskTemplateId?: InputMaybe<Scalars['String']['input']>;
  taskTypeKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoTasksArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  assignedToUserId?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  taskTypeKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoToolArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
  toolId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoToolKnowledgeCardsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  toolId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoToolReplySettingsArgs = {
  toolId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoToolReplyTemplatesArgs = {
  toolId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoToolRuleBindingsArgs = {
  toolId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoToolRuleMetricsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  scopeKey?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  toolId?: InputMaybe<Scalars['String']['input']>;
  whatIfBar?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryScoToolRuleReadinessArgs = {
  toolId: Scalars['String']['input'];
};


export type QueryScoToolRuleRunsArgs = {
  commentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  includeMessages?: InputMaybe<Scalars['Boolean']['input']>;
  matchedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  toolId: Scalars['String']['input'];
  toolRuleId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoToolSessionArgs = {
  toolSessionId: Scalars['String']['input'];
};


export type QueryScoToolSessionsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  toolId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userKeywords?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoToolTestRunsArgs = {
  toolId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoToolTriageArgs = {
  group?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryScoToolTriageAllArgs = {
  group?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoToolsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryScoUserMatchArgs = {
  userMatchId: Scalars['String']['input'];
};


export type QueryScoUserMatchesArgs = {
  advisorOpenSeatsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  searchingUserHasSaved?: InputMaybe<Scalars['Boolean']['input']>;
  searchingUserId?: InputMaybe<Scalars['String']['input']>;
  targetUserHasSaved?: InputMaybe<Scalars['Boolean']['input']>;
  targetUserId?: InputMaybe<Scalars['String']['input']>;
  userSearchId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoUserMentionOptionsArgs = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScoUserSearchArgs = {
  userSearchId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoUserSearchDraftArgs = {
  matchedUsersLimit?: InputMaybe<Scalars['Int']['input']>;
  relevantSkills?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  selectedSkillTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userSearchId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoUserSearchesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  excludeEmptyResults?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  searchingUserId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoUsersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  excludeBanned?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isCoachingConcierge?: InputMaybe<Scalars['Boolean']['input']>;
  isFounderGroupsUser?: InputMaybe<Scalars['Boolean']['input']>;
  isPaying?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScoViewArgs = {
  parentContext?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentType?: InputMaybe<Scalars['String']['input']>;
  viewId?: InputMaybe<Scalars['String']['input']>;
  viewableContext?: InputMaybe<Scalars['String']['input']>;
  viewableId?: InputMaybe<Scalars['String']['input']>;
  viewableType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScoViewsArgs = {
  minimumCompletionAsPercent?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  viewableId?: InputMaybe<Scalars['String']['input']>;
  viewableType?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySkillsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStoredFileArgs = {
  storedFileId: Scalars['String']['input'];
};


export type QueryStoredFilesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  contextKey?: InputMaybe<Scalars['String']['input']>;
  createdByUserId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySubscriptionArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QuerySubscriptionsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupportArticleArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SupportArticleWhereUniqueInput;
};


export type QuerySupportArticleVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySupportArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SupportArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SupportArticleWhereInput>;
};


export type QuerySupportArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SupportArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SupportArticleWhereInput>;
};


export type QuerySupportCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SupportCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SupportCategoryWhereInput>;
};


export type QuerySupportCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SupportCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SupportCategoryWhereInput>;
};


export type QuerySupportCategoryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SupportCategoryWhereUniqueInput;
};


export type QuerySupportCategoryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTermArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TermWhereUniqueInput;
};


export type QueryTermVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TermWhereInput>;
};


export type QueryTermsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TermWhereInput>;
};


export type QueryThreadFollowsArgs = {
  followableType?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryToolDraftsArgs = {
  threadId: Scalars['String']['input'];
};


export type QueryUserArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: UserWhereUniqueInput;
};


export type QueryUserByIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryVerifyAccountArgs = {
  email: Scalars['String']['input'];
  partnerId: Scalars['String']['input'];
};


export type QueryVideoArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: VideoWhereUniqueInput;
};


export type QueryVideoCourseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: VideoCourseWhereUniqueInput;
};


export type QueryVideoCourseListEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoCourseListEntryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoCourseListEntryWhereInput>;
};


export type QueryVideoCourseListEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoCourseListEntryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoCourseListEntryWhereInput>;
};


export type QueryVideoCourseListEntryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: VideoCourseListEntryWhereUniqueInput;
};


export type QueryVideoCourseListEntryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryVideoCourseVersionArgs = {
  where: VersionWhereInput;
};


export type QueryVideoCoursesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoCourseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoCourseWhereInput>;
};


export type QueryVideoCoursesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoCourseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoCourseWhereInput>;
};


export type QueryVideoLessonArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: VideoLessonWhereUniqueInput;
};


export type QueryVideoLessonVersionArgs = {
  where: VersionWhereInput;
};


export type QueryVideoLessonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoLessonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoLessonWhereInput>;
};


export type QueryVideoLessonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoLessonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoLessonWhereInput>;
};


export type QueryVideoListArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: VideoListWhereUniqueInput;
};


export type QueryVideoListEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoListEntryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoListEntryWhereInput>;
};


export type QueryVideoListEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoListEntryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoListEntryWhereInput>;
};


export type QueryVideoListEntryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: VideoListEntryWhereUniqueInput;
};


export type QueryVideoListEntryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryVideoListVersionArgs = {
  where: VersionWhereInput;
};


export type QueryVideoListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoListWhereInput>;
};


export type QueryVideoListsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoListWhereInput>;
};


export type QueryVideoPlaylistArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: VideoPlaylistWhereUniqueInput;
};


export type QueryVideoPlaylistVersionArgs = {
  where: VersionWhereInput;
};


export type QueryVideoPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoPlaylistOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoPlaylistWhereInput>;
};


export type QueryVideoPlaylistsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoPlaylistOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoPlaylistWhereInput>;
};


export type QueryVideoVersionArgs = {
  where: VersionWhereInput;
};


export type QueryVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoWhereInput>;
};


export type QueryVideosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<VideoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<VideoWhereInput>;
};

/** Representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type Rgba = {
  __typename?: 'RGBA';
  a: Scalars['RGBATransparency']['output'];
  b: Scalars['RGBAHue']['output'];
  g: Scalars['RGBAHue']['output'];
  r: Scalars['RGBAHue']['output'];
};

/** Input type representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RgbaInput = {
  a: Scalars['RGBATransparency']['input'];
  b: Scalars['RGBAHue']['input'];
  g: Scalars['RGBAHue']['input'];
  r: Scalars['RGBAHue']['input'];
};

export type ReanalyzeScoPitchDeckInput = {
  pitchDeckId: Scalars['String']['input'];
};

export type ReanalyzeScoPitchDeckPayload = {
  __typename?: 'ReanalyzeScoPitchDeckPayload';
  pitchDeck?: Maybe<ScoPitchDeck>;
  pitchDeckAudit?: Maybe<ScoPitchDeckAudit>;
};

export type RecallToolMessageInput = {
  commentId: Scalars['String']['input'];
};

export type RecallToolMessagePayload = {
  __typename?: 'RecallToolMessagePayload';
  comment?: Maybe<ScoCrmThreadComment>;
  toolMessageAudit?: Maybe<ScoToolMessageAudit>;
};

export type RecordScoCustomerExperimentTallyInput = {
  customerExperimentId: Scalars['String']['input'];
  customerExperimentMetricSlotId: Scalars['String']['input'];
  increment?: InputMaybe<Scalars['Float']['input']>;
  valueText?: InputMaybe<Scalars['String']['input']>;
  valueYes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordScoCustomerExperimentTallyPayload = {
  __typename?: 'RecordScoCustomerExperimentTallyPayload';
  customerExperiment?: Maybe<ScoCustomerExperiment>;
  customerExperimentCheckin?: Maybe<ScoCustomerExperimentCheckin>;
  customerSearch?: Maybe<ScoCustomerSearch>;
};

export type RefreshAdvisorConnectStatusPayload = {
  __typename?: 'RefreshAdvisorConnectStatusPayload';
  advisorProfile?: Maybe<ScoAdvisorProfile>;
};

export type RefreshCrmHubspotSnapshotInput = {
  accountUserId: Scalars['String']['input'];
  memberUserId: Scalars['String']['input'];
};

export type RefreshCrmHubspotSnapshotPayload = {
  __typename?: 'RefreshCrmHubspotSnapshotPayload';
  member?: Maybe<ScoCrmMember>;
};

export type RefreshCrmMemberSummaryInput = {
  accountUserId: Scalars['String']['input'];
  memberUserId: Scalars['String']['input'];
};

export type RefreshCrmMemberSummaryPayload = {
  __typename?: 'RefreshCrmMemberSummaryPayload';
  member?: Maybe<ScoCrmMember>;
};

export type RegenerateCrmReplyInput = {
  accountUserId: Scalars['String']['input'];
  seenInboundCommentId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
  toolRuleId?: InputMaybe<Scalars['String']['input']>;
};

export type RegenerateCrmReplyPayload = {
  __typename?: 'RegenerateCrmReplyPayload';
  changed?: Maybe<Scalars['Boolean']['output']>;
  matchedToolRuleId?: Maybe<Scalars['String']['output']>;
  missingKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  regenerated?: Maybe<Scalars['Boolean']['output']>;
  suggestedBody?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
  toolRuleRunId?: Maybe<Scalars['String']['output']>;
};

export type RegisterUserInput = {
  activeSprintSlug?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  companyElevatorPitch?: InputMaybe<Scalars['String']['input']>;
  companyIndustry?: InputMaybe<Scalars['String']['input']>;
  companyLocation?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  doNotLogin?: InputMaybe<Scalars['Boolean']['input']>;
  doNotRegister?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hubspotFormKey?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  noAuth?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  returnToUrl?: InputMaybe<Scalars['String']['input']>;
  sendConfirmationRequest?: InputMaybe<Scalars['Boolean']['input']>;
  signupRequestId?: InputMaybe<Scalars['String']['input']>;
  userPreferences?: InputMaybe<Array<InputMaybe<UpsertUserPreferenceInput>>>;
};

export type RegisterUserPayload = {
  __typename?: 'RegisterUserPayload';
  loginTokenSent?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<ScoUser>;
  viewer?: Maybe<Viewer>;
};

export type ReindexRagSourceInput = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  ragSourceId: Scalars['UUID']['input'];
};

export type ReindexRagSourcePayload = {
  __typename?: 'ReindexRagSourcePayload';
  ragSource?: Maybe<ScoRagSource>;
};

export type RejectGroupRequestInput = {
  groupRequestId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type RejectGroupRequestPayload = {
  __typename?: 'RejectGroupRequestPayload';
  groupRequest?: Maybe<GroupRequest>;
};

export type ReleaseCrmThreadInput = {
  accountUserId?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
};

export type ReleaseCrmThreadPayload = {
  __typename?: 'ReleaseCrmThreadPayload';
  claimExpiresAt?: Maybe<Scalars['String']['output']>;
  ownedByViewer?: Maybe<Scalars['Boolean']['output']>;
  ownerDisplayName?: Maybe<Scalars['String']['output']>;
  ownerUserId?: Maybe<Scalars['String']['output']>;
};

export type RemoveUserSkillInput = {
  skillId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveUserSkillPayload = {
  __typename?: 'RemoveUserSkillPayload';
  user: ScoUser;
};

export type ReopenCrmThreadInput = {
  accountUserId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};

export type ReopenCrmThreadPayload = {
  __typename?: 'ReopenCrmThreadPayload';
  reopened?: Maybe<Scalars['Boolean']['output']>;
  toolRuleRunId?: Maybe<Scalars['String']['output']>;
};

export type ReorderToolRulesInput = {
  groupKey: Scalars['String']['input'];
  orderedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderedRuleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReorderToolRulesPayload = {
  __typename?: 'ReorderToolRulesPayload';
  toolRules?: Maybe<Array<Maybe<ScoToolRule>>>;
};

export type ReportAdvisorSessionPresenceInput = {
  advisorSessionId?: InputMaybe<Scalars['String']['input']>;
  present?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportAdvisorSessionPresencePayload = {
  __typename?: 'ReportAdvisorSessionPresencePayload';
  advisorSession?: Maybe<ScoAdvisorSession>;
};

export type ReportingPeriod = {
  __typename?: 'ReportingPeriod';
  end?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

export type RequestAdvisorPayoutInput = {
  amountUsd?: InputMaybe<Scalars['Float']['input']>;
};

export type RequestAdvisorPayoutPayload = {
  __typename?: 'RequestAdvisorPayoutPayload';
  advisorPayout?: Maybe<ScoAdvisorPayout>;
};

export type RequestAdvisorSessionInput = {
  approximateLengthMinutes?: InputMaybe<Scalars['Int']['input']>;
  createPrecharge?: InputMaybe<Scalars['Boolean']['input']>;
  expertUserId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  suggestedTimes?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  waiveCode?: InputMaybe<Scalars['String']['input']>;
};

export type RequestAdvisorSessionPayload = {
  __typename?: 'RequestAdvisorSessionPayload';
  advisorSession?: Maybe<ScoAdvisorSession>;
  precharge?: Maybe<ScoAdvisorSessionCharge>;
};

export type RequestConsultationInput = {
  companyDescription?: InputMaybe<Scalars['String']['input']>;
  companyIndustry?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fundingAmount?: InputMaybe<Scalars['String']['input']>;
  hubspotFormKey?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type RequestEmailConfirmationInput = {
  email: Scalars['String']['input'];
  /** If the user's password isn't set yet, we ask them to do that here. */
  password?: InputMaybe<Scalars['String']['input']>;
};

export type RequestFounderGroupEntryInput = {
  ageRange?: InputMaybe<Scalars['String']['input']>;
  annualRevenue?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  birthdate?: InputMaybe<Scalars['String']['input']>;
  college?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expertise?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  founderExperience?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  founderNeeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  founderNeedsOther?: InputMaybe<Scalars['String']['input']>;
  fundingRaised?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hubspotFormKey?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredGroupComposition?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferredGroupGoals?: InputMaybe<Scalars['String']['input']>;
  preferredGroupMeetingFrequency?: InputMaybe<Scalars['String']['input']>;
  preferredGroupModeration?: InputMaybe<Scalars['String']['input']>;
  preferredGroupVenue?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  workExperience?: InputMaybe<Scalars['String']['input']>;
  yearFounded?: InputMaybe<Scalars['String']['input']>;
};

export type RequestFundingConsultationInput = {
  capitalSeeking?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyOverview?: InputMaybe<Scalars['String']['input']>;
  companyRegisteredIn?: InputMaybe<Scalars['String']['input']>;
  companyRevenueStage?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fundraiseBudget?: InputMaybe<Scalars['String']['input']>;
  hubspotFormKey?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInProfile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  timeframe?: InputMaybe<Scalars['String']['input']>;
};

export type RequestFundingConsultationPayload = {
  __typename?: 'RequestFundingConsultationPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestLoginTokenInput = {
  email: Scalars['String']['input'];
  returnToUrl?: InputMaybe<Scalars['String']['input']>;
};

export type RequestLoginTokenPayload = {
  __typename?: 'RequestLoginTokenPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestMasterclassInput = {
  companyDescription?: InputMaybe<Scalars['String']['input']>;
  companyIndustry?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  fundingAmount?: InputMaybe<Scalars['String']['input']>;
  hubspotFormKey?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type RequestPasswordResetByPhoneInput = {
  phone: Scalars['String']['input'];
  /** The path to return the user to after their password is reset */
  returnTo?: InputMaybe<Scalars['String']['input']>;
};

export type RequestPasswordResetInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  /** The path to return the user to after their password is reset */
  returnTo?: InputMaybe<Scalars['String']['input']>;
};

export type RequestPasswordResetPayload = {
  __typename?: 'RequestPasswordResetPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestPhoneConfirmationInput = {
  /** If the user's password isn't set yet, we ask them to do that here. */
  password?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type RequestSlackInviteInput = {
  currentUserEmail: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  group?: InputMaybe<Scalars['String']['input']>;
  requestSlackEmail: Scalars['String']['input'];
};

export type RequestSlackInvitePayload = {
  __typename?: 'RequestSlackInvitePayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum RequestStatus {
  Complete = 'COMPLETE',
  Open = 'OPEN'
}

export type ResetAdvisorStripeConnectPayload = {
  __typename?: 'ResetAdvisorStripeConnectPayload';
  stripeConnectAccountId?: Maybe<Scalars['String']['output']>;
  stripeConnectStatusKey?: Maybe<Scalars['String']['output']>;
};

export type ResetPasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ResolveCrmSupportHandoffInput = {
  accountUserId?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
};

export type ResolveCrmSupportHandoffPayload = {
  __typename?: 'ResolveCrmSupportHandoffPayload';
  resolved?: Maybe<Scalars['Boolean']['output']>;
  supportTicketId?: Maybe<Scalars['String']['output']>;
};

export type RespondToAdvisorAgreementInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  advisorAgreementId?: InputMaybe<Scalars['String']['input']>;
  advisorNotes?: InputMaybe<Scalars['String']['input']>;
};

export type RespondToAdvisorAgreementPayload = {
  __typename?: 'RespondToAdvisorAgreementPayload';
  advisorAgreement?: Maybe<ScoAdvisorAgreement>;
};

export type RespondToBoardInviteInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  advisorEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export type RespondToBoardInvitePayload = {
  __typename?: 'RespondToBoardInvitePayload';
  advisorEngagement?: Maybe<ScoAdvisorEngagement>;
};

export type RespondToSeatApplicationInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  groupCommitmentId?: InputMaybe<Scalars['String']['input']>;
};

export type RespondToSeatApplicationPayload = {
  __typename?: 'RespondToSeatApplicationPayload';
  advisorEngagement?: Maybe<ScoAdvisorEngagement>;
  groupCommitment?: Maybe<GroupCommitment>;
};

export type Review = Entity & Node & {
  __typename?: 'Review';
  body?: Maybe<Scalars['String']['output']>;
  coachProfile?: Maybe<CoachProfile>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Review>;
  /** List of Review versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  starRating?: Maybe<Scalars['Float']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ReviewCoachProfileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ReviewCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ReviewDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ReviewHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ReviewPersonArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ReviewPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ReviewScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ReviewUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ReviewAdvisorProfileInput = {
  advisorProfileId?: InputMaybe<Scalars['String']['input']>;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  statusKey?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewAdvisorProfilePayload = {
  __typename?: 'ReviewAdvisorProfilePayload';
  advisorProfile?: Maybe<ScoAdvisorProfile>;
};

export type ReviewConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ReviewWhereUniqueInput;
};

/** A connection to a list of items. */
export type ReviewConnection = {
  __typename?: 'ReviewConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ReviewEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ReviewCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  coachProfile?: InputMaybe<CoachProfileCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  person?: InputMaybe<PersonCreateOneInlineInput>;
  reviewCount?: InputMaybe<Scalars['Int']['input']>;
  starRating?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ReviewCreateManyInlineInput = {
  /** Connect multiple existing Review documents */
  connect?: InputMaybe<Array<ReviewWhereUniqueInput>>;
  /** Create and connect multiple existing Review documents */
  create?: InputMaybe<Array<ReviewCreateInput>>;
};

export type ReviewCreateOneInlineInput = {
  /** Connect one existing Review document */
  connect?: InputMaybe<ReviewWhereUniqueInput>;
  /** Create and connect one Review document */
  create?: InputMaybe<ReviewCreateInput>;
};

/** An edge in a connection. */
export type ReviewEdge = {
  __typename?: 'ReviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Review;
};

/** Identifies documents */
export type ReviewManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  coachProfile?: InputMaybe<CoachProfileWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ReviewWhereStageInput>;
  documentInStages_none?: InputMaybe<ReviewWhereStageInput>;
  documentInStages_some?: InputMaybe<ReviewWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  person?: InputMaybe<PersonWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  reviewCount?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  reviewCount_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  reviewCount_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  reviewCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  reviewCount_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  reviewCount_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  reviewCount_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  reviewCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  starRating?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  starRating_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  starRating_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  starRating_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  starRating_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  starRating_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  starRating_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  starRating_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ReviewOrderByInput {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ReviewCountAsc = 'reviewCount_ASC',
  ReviewCountDesc = 'reviewCount_DESC',
  StarRatingAsc = 'starRating_ASC',
  StarRatingDesc = 'starRating_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ReviewUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  coachProfile?: InputMaybe<CoachProfileUpdateOneInlineInput>;
  person?: InputMaybe<PersonUpdateOneInlineInput>;
  reviewCount?: InputMaybe<Scalars['Int']['input']>;
  starRating?: InputMaybe<Scalars['Float']['input']>;
};

export type ReviewUpdateManyInlineInput = {
  /** Connect multiple existing Review documents */
  connect?: InputMaybe<Array<ReviewConnectInput>>;
  /** Create and connect multiple Review documents */
  create?: InputMaybe<Array<ReviewCreateInput>>;
  /** Delete multiple Review documents */
  delete?: InputMaybe<Array<ReviewWhereUniqueInput>>;
  /** Disconnect multiple Review documents */
  disconnect?: InputMaybe<Array<ReviewWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Review documents */
  set?: InputMaybe<Array<ReviewWhereUniqueInput>>;
  /** Update multiple Review documents */
  update?: InputMaybe<Array<ReviewUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Review documents */
  upsert?: InputMaybe<Array<ReviewUpsertWithNestedWhereUniqueInput>>;
};

export type ReviewUpdateManyInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  reviewCount?: InputMaybe<Scalars['Int']['input']>;
  starRating?: InputMaybe<Scalars['Float']['input']>;
};

export type ReviewUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ReviewUpdateManyInput;
  /** Document search */
  where: ReviewWhereInput;
};

export type ReviewUpdateOneInlineInput = {
  /** Connect existing Review document */
  connect?: InputMaybe<ReviewWhereUniqueInput>;
  /** Create and connect one Review document */
  create?: InputMaybe<ReviewCreateInput>;
  /** Delete currently connected Review document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Review document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Review document */
  update?: InputMaybe<ReviewUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Review document */
  upsert?: InputMaybe<ReviewUpsertWithNestedWhereUniqueInput>;
};

export type ReviewUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ReviewUpdateInput;
  /** Unique document search */
  where: ReviewWhereUniqueInput;
};

export type ReviewUpsertInput = {
  /** Create document if it didn't exist */
  create: ReviewCreateInput;
  /** Update document if it exists */
  update: ReviewUpdateInput;
};

export type ReviewUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ReviewUpsertInput;
  /** Unique document search */
  where: ReviewWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ReviewWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ReviewWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  coachProfile?: InputMaybe<CoachProfileWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ReviewWhereStageInput>;
  documentInStages_none?: InputMaybe<ReviewWhereStageInput>;
  documentInStages_some?: InputMaybe<ReviewWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  person?: InputMaybe<PersonWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  reviewCount?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  reviewCount_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  reviewCount_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  reviewCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  reviewCount_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  reviewCount_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  reviewCount_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  reviewCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  starRating?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  starRating_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  starRating_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  starRating_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  starRating_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  starRating_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  starRating_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  starRating_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ReviewWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ReviewWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Review record uniquely */
export type ReviewWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviseAdvisorAgreementInput = {
  advisorAgreementId?: InputMaybe<Scalars['String']['input']>;
};

export type ReviseAdvisorAgreementPayload = {
  __typename?: 'ReviseAdvisorAgreementPayload';
  advisorAgreement?: Maybe<ScoAdvisorAgreement>;
};

export type RevokeUserAuthTokenInput = {
  userAuthTokenId: Scalars['String']['input'];
};

export type RevokeUserAuthTokenPayload = {
  __typename?: 'RevokeUserAuthTokenPayload';
  userAuthToken?: Maybe<ScoUserAuthToken>;
  viewer?: Maybe<Viewer>;
};

export type RewriteCrmReplyInput = {
  accountUserId: Scalars['String']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  mode: Scalars['String']['input'];
  seenInboundCommentId?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
};

export type RewriteCrmReplyPayload = {
  __typename?: 'RewriteCrmReplyPayload';
  body?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  sources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** Returns AST representation */
  raw: Scalars['RichTextAST']['output'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

export type RunScoCustomerChannelGenerationInput = {
  customerProfileId: Scalars['String']['input'];
  customerSearchId: Scalars['String']['input'];
};

export type RunScoCustomerChannelGenerationPayload = {
  __typename?: 'RunScoCustomerChannelGenerationPayload';
  aiAction?: Maybe<ScoAiAction>;
  customerSearch?: Maybe<ScoCustomerSearch>;
  customerSearchRun?: Maybe<ScoCustomerSearchRun>;
};

export type RunScoCustomerChannelMessageInput = {
  customerChannelId: Scalars['String']['input'];
  customerProfileId?: InputMaybe<Scalars['String']['input']>;
  customerSearchId?: InputMaybe<Scalars['String']['input']>;
};

export type RunScoCustomerChannelMessagePayload = {
  __typename?: 'RunScoCustomerChannelMessagePayload';
  aiAction?: Maybe<ScoAiAction>;
  customerSearch?: Maybe<ScoCustomerSearch>;
  customerSearchRun?: Maybe<ScoCustomerSearchRun>;
};

export type RunScoCustomerExperimentGenerationInput = {
  customerChannelId: Scalars['String']['input'];
  customerChannelMessageId?: InputMaybe<Scalars['String']['input']>;
  customerChannelOpenerId?: InputMaybe<Scalars['String']['input']>;
  customerProfileId?: InputMaybe<Scalars['String']['input']>;
  customerSearchId?: InputMaybe<Scalars['String']['input']>;
  recipeKey: Scalars['String']['input'];
};

export type RunScoCustomerExperimentGenerationPayload = {
  __typename?: 'RunScoCustomerExperimentGenerationPayload';
  aiAction?: Maybe<ScoAiAction>;
  customerExperiment?: Maybe<ScoCustomerExperiment>;
  customerSearch?: Maybe<ScoCustomerSearch>;
  customerSearchRun?: Maybe<ScoCustomerSearchRun>;
};

export type RunScoCustomerSearchStepInput = {
  customerProfileId?: InputMaybe<Scalars['String']['input']>;
  customerSearchId: Scalars['String']['input'];
  depth?: InputMaybe<Scalars['Int']['input']>;
  step: Scalars['String']['input'];
};

export type RunScoCustomerSearchStepPayload = {
  __typename?: 'RunScoCustomerSearchStepPayload';
  aiAction?: Maybe<ScoAiAction>;
  customerSearch?: Maybe<ScoCustomerSearch>;
  customerSearchRun?: Maybe<ScoCustomerSearchRun>;
};

/** Scheduled Operation system model */
export type ScheduledOperation = Entity & Node & {
  __typename?: 'ScheduledOperation';
  affectedDocuments: Array<ScheduledOperationAffectedDocument>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Operation description */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledOperation>;
  /** Operation error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Raw operation payload including all details, this field is subject to change */
  rawPayload: Scalars['Json']['output'];
  /** The release this operation is scheduled for */
  release?: Maybe<ScheduledRelease>;
  /** System stage field */
  stage: Stage;
  /** operation Status */
  status: ScheduledOperationStatus;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument = Article | Asset | Benefit | BootcampEvent | BusinessStage | CoachProfile | ContentTrack | ContentTrackSection | ContentTrackStep | ContentTrackTask | FounderTrack | FounderTrackStep | FounderTrackTask | Link | Person | Playlist | PodcastEpisode | ProductName | Review | SupportArticle | SupportCategory | Term | Video | VideoCourse | VideoCourseListEntry | VideoLesson | VideoList | VideoListEntry | VideoPlaylist;

export type ScheduledOperationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledOperationWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
  __typename?: 'ScheduledOperationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledOperationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledOperationCreateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationCreateOneInlineInput = {
  /** Connect one existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
};

/** An edge in a connection. */
export type ScheduledOperationEdge = {
  __typename?: 'ScheduledOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledOperation;
};

/** Identifies documents */
export type ScheduledOperationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledOperationOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ScheduledOperationUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationConnectInput>>;
  /** Disconnect multiple ScheduledOperation documents */
  disconnect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledOperation documents */
  set?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationUpdateOneInlineInput = {
  /** Connect existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
  /** Disconnect currently connected ScheduledOperation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity & Node & {
  __typename?: 'ScheduledRelease';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Release description */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledRelease>;
  /** Release error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Whether scheduled release should be run */
  isActive: Scalars['Boolean']['output'];
  /** Whether scheduled release is implicit */
  isImplicit: Scalars['Boolean']['output'];
  /** Operations to run with this release */
  operations: Array<ScheduledOperation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Release date and time */
  releaseAt?: Maybe<Scalars['DateTime']['output']>;
  /** System stage field */
  stage: Stage;
  /** Release Status */
  status: ScheduledReleaseStatus;
  /** Release Title */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledReleaseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledReleaseWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
  __typename?: 'ScheduledReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScheduledReleaseCreateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Create and connect multiple existing ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
};

export type ScheduledReleaseCreateOneInlineInput = {
  /** Connect one existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
};

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
  __typename?: 'ScheduledReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledRelease;
};

/** Identifies documents */
export type ScheduledReleaseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledReleaseOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  IsImplicitAsc = 'isImplicit_ASC',
  IsImplicitDesc = 'isImplicit_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ReleaseAtAsc = 'releaseAt_ASC',
  ReleaseAtDesc = 'releaseAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ScheduledReleaseUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseConnectInput>>;
  /** Create and connect multiple ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
  /** Delete multiple ScheduledRelease documents */
  delete?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Disconnect multiple ScheduledRelease documents */
  disconnect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledRelease documents */
  set?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Update multiple ScheduledRelease documents */
  update?: InputMaybe<Array<ScheduledReleaseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ScheduledRelease documents */
  upsert?: InputMaybe<Array<ScheduledReleaseUpsertWithNestedWhereUniqueInput>>;
};

export type ScheduledReleaseUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ScheduledReleaseUpdateManyInput;
  /** Document search */
  where: ScheduledReleaseWhereInput;
};

export type ScheduledReleaseUpdateOneInlineInput = {
  /** Connect existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
  /** Delete currently connected ScheduledRelease document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ScheduledRelease document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ScheduledRelease document */
  update?: InputMaybe<ScheduledReleaseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ScheduledRelease document */
  upsert?: InputMaybe<ScheduledReleaseUpsertWithNestedWhereUniqueInput>;
};

export type ScheduledReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ScheduledReleaseUpdateInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

export type ScheduledReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: ScheduledReleaseCreateInput;
  /** Update document if it exists */
  update: ScheduledReleaseUpdateInput;
};

export type ScheduledReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ScheduledReleaseUpsertInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ScoAccountGroup = ScoNode & {
  __typename?: 'ScoAccountGroup';
  accountGroupId?: Maybe<Scalars['String']['output']>;
  defaultCoupon?: Maybe<LegacyProductCoupon>;
  defaultCouponCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  members?: Maybe<Array<Maybe<ScoAccountGroupMember>>>;
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<ScoProduct>;
  productDurationInDays?: Maybe<Scalars['Int']['output']>;
  productDurationInMonths?: Maybe<Scalars['Int']['output']>;
  productExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productQuantity?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type ScoAccountGroupCollection = {
  __typename?: 'ScoAccountGroupCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoAccountGroup>>;
  pagination: Pagination;
};

export type ScoAccountGroupMember = ScoNode & {
  __typename?: 'ScoAccountGroupMember';
  accountGroup?: Maybe<ScoAccountGroup>;
  canManageMembers?: Maybe<Scalars['Boolean']['output']>;
  canManageSettings?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  product?: Maybe<ScoProduct>;
  productExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** Allowlisted roots for admin record reassignment. */
export enum ScoAdminReassignableType {
  CustomerSearch = 'CustomerSearch',
  GroupRequest = 'GroupRequest',
  InvestorSearch = 'InvestorSearch',
  PitchDeck = 'PitchDeck',
  UserSearch = 'UserSearch'
}

/** One owner-field rewrite the reassignment will apply. */
export type ScoAdminRecordReassignChange = {
  __typename?: 'ScoAdminRecordReassignChange';
  field: Scalars['String']['output'];
  fromValue?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  modelType: Scalars['String']['output'];
  toValue?: Maybe<Scalars['String']['output']>;
};

/** A related row that will not be rewritten (other party, chat, intake). */
export type ScoAdminRecordReassignLinked = {
  __typename?: 'ScoAdminRecordReassignLinked';
  modelId: Scalars['String']['output'];
  modelType: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

/** Dry-run (or post-execute) result of an admin record reassignment. */
export type ScoAdminRecordReassignPreview = {
  __typename?: 'ScoAdminRecordReassignPreview';
  blockers: Array<Scalars['String']['output']>;
  changes: Array<ScoAdminRecordReassignChange>;
  destinationCompanyId?: Maybe<Scalars['String']['output']>;
  destinationUser?: Maybe<ScoUser>;
  linkedNotMoved: Array<ScoAdminRecordReassignLinked>;
  modelLog?: Maybe<ModelLog>;
  rootId: Scalars['String']['output'];
  rootLabel?: Maybe<Scalars['String']['output']>;
  rootType: ScoAdminReassignableType;
  sourceUser?: Maybe<ScoUser>;
};

export type ScoAdvisor = ScoNode & {
  __typename?: 'ScoAdvisor';
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
};

export type ScoAdvisorAgreement = ScoNode & {
  __typename?: 'ScoAdvisorAgreement';
  advisorAgreementId?: Maybe<Scalars['String']['output']>;
  /**
   * Admin-only Documenso signing URL for the advisor. Present only while the
   * agreement is out for signature and that party has not signed. Callers who are
   * not admins are rejected.
   */
  advisorDocumensoSigningUrl?: Maybe<Scalars['String']['output']>;
  advisorEmail?: Maybe<Scalars['String']['output']>;
  advisorEngagementId?: Maybe<Scalars['String']['output']>;
  advisorEntityName?: Maybe<Scalars['String']['output']>;
  advisorHasSigned?: Maybe<Scalars['Boolean']['output']>;
  advisorName?: Maybe<Scalars['String']['output']>;
  advisorNotes?: Maybe<Scalars['String']['output']>;
  advisorSignedAt?: Maybe<Scalars['DateTime']['output']>;
  advisorTitle?: Maybe<Scalars['String']['output']>;
  advisorUser?: Maybe<ScoUser>;
  advisorUserId?: Maybe<Scalars['String']['output']>;
  caliber?: Maybe<ScoStaticOption>;
  caliberKey?: Maybe<Scalars['String']['output']>;
  cashHourlyRateInDollars?: Maybe<Scalars['Float']['output']>;
  cliffMonths?: Maybe<Scalars['Int']['output']>;
  company?: Maybe<ScoCompany>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyStage?: Maybe<ScoStaticOption>;
  companyStageKey?: Maybe<Scalars['String']['output']>;
  contributionTier?: Maybe<ScoStaticOption>;
  contributionTierKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUser?: Maybe<ScoUser>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  currentUserCanDelete?: Maybe<Scalars['Boolean']['output']>;
  currentUserCanEdit?: Maybe<Scalars['Boolean']['output']>;
  currentUserRole?: Maybe<Scalars['String']['output']>;
  declinedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documensoDocumentId?: Maybe<Scalars['String']['output']>;
  documensoSigningUrl?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<ScoAdvisorEngagement>;
  equityPercent?: Maybe<Scalars['Float']['output']>;
  fastTrackApplied?: Maybe<Scalars['Boolean']['output']>;
  founderCompanyName?: Maybe<Scalars['String']['output']>;
  /**
   * Admin-only Documenso signing URL for the founder. Present only while the
   * agreement is out for signature and that party has not signed. Callers who are
   * not admins are rejected.
   */
  founderDocumensoSigningUrl?: Maybe<Scalars['String']['output']>;
  founderEmail?: Maybe<Scalars['String']['output']>;
  founderHasSigned?: Maybe<Scalars['Boolean']['output']>;
  founderName?: Maybe<Scalars['String']['output']>;
  founderSignedAt?: Maybe<Scalars['DateTime']['output']>;
  founderUser?: Maybe<ScoUser>;
  founderUserId?: Maybe<Scalars['String']['output']>;
  hoursPerMonth?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  initiatingPartyKey?: Maybe<Scalars['String']['output']>;
  legalTermsAsJson?: Maybe<Scalars['JSON']['output']>;
  parentAdvisorAgreementId?: Maybe<Scalars['String']['output']>;
  parentAgreement?: Maybe<ScoAdvisorAgreement>;
  recommendedEquity?: Maybe<Scalars['JSON']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signedFile?: Maybe<ScoStoredFile>;
  signedStoredFileId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ScoStaticOption>;
  statusKey?: Maybe<Scalars['String']['output']>;
  termMonths?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  valuationSnapshotInDollars?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  versions?: Maybe<Array<Maybe<ScoAdvisorAgreement>>>;
  vestingMonths?: Maybe<Scalars['Int']['output']>;
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  warmIntro?: Maybe<ScoStaticOption>;
  warmIntroKey?: Maybe<Scalars['String']['output']>;
};

export type ScoAdvisorAgreementCollection = {
  __typename?: 'ScoAdvisorAgreementCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoAdvisorAgreement>>;
  pagination: Pagination;
};

/** Downloadable FAST agreement or compensation-overview PDF. contentBase64 is the file bytes. */
export type ScoAdvisorAgreementPdf = {
  __typename?: 'ScoAdvisorAgreementPdf';
  contentBase64?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
};

export type ScoAdvisorConnectCountry = {
  __typename?: 'ScoAdvisorConnectCountry';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ScoAdvisorEngagement = ScoNode & {
  __typename?: 'ScoAdvisorEngagement';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  advisorEmail?: Maybe<Scalars['String']['output']>;
  advisorEngagementId?: Maybe<Scalars['String']['output']>;
  advisorName?: Maybe<Scalars['String']['output']>;
  advisorUser?: Maybe<ScoUser>;
  advisorUserId?: Maybe<Scalars['String']['output']>;
  candidateCount?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<ScoStaticOption>;
  categoryKey?: Maybe<Scalars['String']['output']>;
  chatLastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  chatThread?: Maybe<ScoThread>;
  chatThreadId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<ScoCompany>;
  companyId?: Maybe<Scalars['String']['output']>;
  compensationNotes?: Maybe<Scalars['String']['output']>;
  compensationTypeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentAgreement?: Maybe<ScoAdvisorAgreement>;
  currentUserCanEdit?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  filledByGroupCommitmentId?: Maybe<Scalars['String']['output']>;
  founderUser?: Maybe<ScoUser>;
  founderUserId?: Maybe<Scalars['String']['output']>;
  groupRequest?: Maybe<GroupRequest>;
  groupRequestId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industryKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  introductionCommentId?: Maybe<Scalars['String']['output']>;
  introductionSentAt?: Maybe<Scalars['DateTime']['output']>;
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  isAI?: Maybe<Scalars['Boolean']['output']>;
  linkedUserSearch?: Maybe<ScoUserSearch>;
  notifyMatches?: Maybe<Scalars['Boolean']['output']>;
  skillTagTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source?: Maybe<ScoStaticOption>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ScoStaticOption>;
  statusKey?: Maybe<Scalars['String']['output']>;
  timeCommitmentNotes?: Maybe<Scalars['String']['output']>;
  timeCommitmentTypeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  whyText?: Maybe<Scalars['String']['output']>;
};


export type ScoAdvisorEngagementChatThreadArgs = {
  createIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoAdvisorEngagementChatThreadIdArgs = {
  createIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoAdvisorEngagementCollection = {
  __typename?: 'ScoAdvisorEngagementCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoAdvisorEngagement>>;
  pagination: Pagination;
};

export type ScoAdvisorLedgerEntry = ScoNode & {
  __typename?: 'ScoAdvisorLedgerEntry';
  advisorLedgerEntryId?: Maybe<Scalars['String']['output']>;
  advisorPayoutId?: Maybe<Scalars['String']['output']>;
  advisorSessionId?: Maybe<Scalars['String']['output']>;
  amountUsd?: Maybe<Scalars['Float']['output']>;
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entryType?: Maybe<ScoStaticOption>;
  entryTypeKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoAdvisorLedgerEntryCollection = {
  __typename?: 'ScoAdvisorLedgerEntryCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoAdvisorLedgerEntry>>;
  pagination: Pagination;
};

export type ScoAdvisorPayout = ScoNode & {
  __typename?: 'ScoAdvisorPayout';
  advisorPayoutId?: Maybe<Scalars['String']['output']>;
  amountUsd?: Maybe<Scalars['Float']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ledgerEntries?: Maybe<ScoAdvisorLedgerEntryCollection>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ScoStaticOption>;
  statusKey?: Maybe<Scalars['String']['output']>;
  stripeConnectAccountId?: Maybe<Scalars['String']['output']>;
  stripeTransferId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type ScoAdvisorPayoutLedgerEntriesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoAdvisorPayoutBalance = {
  __typename?: 'ScoAdvisorPayoutBalance';
  availableBalanceUsd?: Maybe<Scalars['Float']['output']>;
  connectAccountType?: Maybe<Scalars['String']['output']>;
  connectCountryOptions?: Maybe<Array<Maybe<ScoAdvisorConnectCountry>>>;
  connectEnabled?: Maybe<Scalars['Boolean']['output']>;
  connectModel?: Maybe<Scalars['String']['output']>;
  payoutMinUsd?: Maybe<Scalars['Float']['output']>;
  pendingBalanceUsd?: Maybe<Scalars['Float']['output']>;
  stripeConnectAccountId?: Maybe<Scalars['String']['output']>;
  stripeConnectCountry?: Maybe<Scalars['String']['output']>;
  stripeConnectStatusKey?: Maybe<Scalars['String']['output']>;
  supportsPlatformPayout?: Maybe<Scalars['Boolean']['output']>;
  totalBalanceUsd?: Maybe<Scalars['Float']['output']>;
};

export type ScoAdvisorPayoutCollection = {
  __typename?: 'ScoAdvisorPayoutCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoAdvisorPayout>>;
  pagination: Pagination;
};

export type ScoAdvisorProfile = ScoNode & {
  __typename?: 'ScoAdvisorProfile';
  advisingNote?: Maybe<Scalars['String']['output']>;
  advisorProfileId?: Maybe<Scalars['String']['output']>;
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  availabilityHoursPerMonth?: Maybe<Scalars['Int']['output']>;
  bioForAdvising?: Maybe<Scalars['String']['output']>;
  canAcceptSessions?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<Maybe<ScoStaticOption>>>;
  categoryKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  engagementIntroductionIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  engagementIntroductionMessage?: Maybe<Scalars['String']['output']>;
  engagementStyleKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  engagementStyles?: Maybe<Array<Maybe<ScoStaticOption>>>;
  foundersHelpedCount?: Maybe<Scalars['Int']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  hourlyRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  isSessionEnabled?: Maybe<Scalars['Boolean']['output']>;
  notableBrands?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  preferredCompensationTypeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rankScore?: Maybe<Scalars['Int']['output']>;
  rankScoreBoost?: Maybe<Scalars['Int']['output']>;
  responsesCount?: Maybe<Scalars['Int']['output']>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  sessionBookingUrl?: Maybe<Scalars['String']['output']>;
  sessionFeeWaiveCode?: Maybe<Scalars['String']['output']>;
  sessionStatsAsJSON?: Maybe<Scalars['JSON']['output']>;
  sessionWeeklyHours?: Maybe<Scalars['JSON']['output']>;
  skillTagTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<ScoStaticOption>;
  statusKey?: Maybe<Scalars['String']['output']>;
  streamUserId?: Maybe<Scalars['String']['output']>;
  stripeConnectAccountId?: Maybe<Scalars['String']['output']>;
  stripeConnectStatusKey?: Maybe<Scalars['String']['output']>;
  suspendedAt?: Maybe<Scalars['DateTime']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
  warmIntroKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  warmIntros?: Maybe<Array<Maybe<ScoStaticOption>>>;
};

export type ScoAdvisorProfileCollection = {
  __typename?: 'ScoAdvisorProfileCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoAdvisorProfile>>;
  pagination: Pagination;
};

export type ScoAdvisorSession = ScoNode & {
  __typename?: 'ScoAdvisorSession';
  advisorProfile?: Maybe<ScoAdvisorProfile>;
  advisorProfileId?: Maybe<Scalars['String']['output']>;
  advisorSessionId?: Maybe<Scalars['String']['output']>;
  approximateLengthMinutes?: Maybe<Scalars['Int']['output']>;
  boardEngagement?: Maybe<ScoAdvisorEngagement>;
  canRate?: Maybe<Scalars['Boolean']['output']>;
  cancelationReason?: Maybe<Scalars['String']['output']>;
  canceledByUserId?: Maybe<Scalars['String']['output']>;
  charges?: Maybe<Array<Maybe<ScoAdvisorSessionCharge>>>;
  chatThread?: Maybe<ScoThread>;
  chatThreadId?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentUserRating?: Maybe<ScoRating>;
  currentUserRole?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  estimatedCostUsd?: Maybe<Scalars['Float']['output']>;
  expertShareAmount?: Maybe<Scalars['Float']['output']>;
  expertUser?: Maybe<ScoUser>;
  expertUserId?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  finalCostUsd?: Maybe<Scalars['Float']['output']>;
  hourlyRate?: Maybe<Scalars['Float']['output']>;
  ics?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  platformFeeAmount?: Maybe<Scalars['Float']['output']>;
  platformFeePercent?: Maybe<Scalars['Float']['output']>;
  ratingPromptedAt?: Maybe<Scalars['DateTime']['output']>;
  ratings?: Maybe<Array<Maybe<ScoRating>>>;
  reason?: Maybe<Scalars['String']['output']>;
  recording?: Maybe<Scalars['JSON']['output']>;
  recordingPartyExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  remainingCapturedUsd?: Maybe<Scalars['Float']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  seekerUser?: Maybe<ScoUser>;
  seekerUserId?: Maybe<Scalars['String']['output']>;
  settledAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ScoStaticOption>;
  statusKey?: Maybe<Scalars['String']['output']>;
  streamCallId?: Maybe<Scalars['String']['output']>;
  streamCallType?: Maybe<Scalars['String']['output']>;
  suggestedByUserId?: Maybe<Scalars['String']['output']>;
  suggestedTime1?: Maybe<Scalars['DateTime']['output']>;
  suggestedTime2?: Maybe<Scalars['DateTime']['output']>;
  suggestedTime3?: Maybe<Scalars['DateTime']['output']>;
  transcript?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoAdvisorSessionCharge = ScoNode & {
  __typename?: 'ScoAdvisorSessionCharge';
  advisorSessionChargeId?: Maybe<Scalars['String']['output']>;
  advisorSessionId?: Maybe<Scalars['String']['output']>;
  amountUsd?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  kindKey?: Maybe<Scalars['String']['output']>;
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  statusKey?: Maybe<Scalars['String']['output']>;
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  stripeConnectAccountId?: Maybe<Scalars['String']['output']>;
  stripeCustomerSessionClientSecret?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  succeededAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoAdvisorSessionCollection = {
  __typename?: 'ScoAdvisorSessionCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoAdvisorSession>>;
  pagination: Pagination;
};

/** Wil.ai free-tier message meter: human (non-tool-user) comments across the user’s advisor-wil ToolSessions. */
export type ScoAdvisorWilMessageUsage = {
  __typename?: 'ScoAdvisorWilMessageUsage';
  /** True when free-tier is enforced and usedMessages >= limit. */
  isLimitReached: Scalars['Boolean']['output'];
  /** True when free-tier metering applies (registered, not unlimited Wil). */
  isLimited: Scalars['Boolean']['output'];
  /** Free-tier cap (50 production / 5 non-production). */
  limit: Scalars['Int']['output'];
  /** Messages left before the free-tier cap (0 when exhausted). */
  remaining: Scalars['Int']['output'];
  /** Number of advisor-wil ToolSessions for the user. */
  sessionCount: Scalars['Int']['output'];
  /** Count of human messages across all of the user’s advisor-wil sessions. */
  usedMessages: Scalars['Int']['output'];
};

/**
 * A logged AI call — one record per request sent to an AI provider. Created before
 * the call is made and updated as it progresses.
 */
export type ScoAiAction = ScoNode & {
  __typename?: 'ScoAiAction';
  /** UUID primary key for this AI action record. */
  aiActionId?: Maybe<Scalars['String']['output']>;
  /**
   * Input tokens served from the provider prompt cache (cache hits / reads).
   * Denormalized from metrics.inputTokenDetails.cacheReadTokens (or legacy
   * cachedInputTokens alias). These are typically billed at a reduced rate.
   */
  cacheReadInputTokens?: Maybe<Scalars['Int']['output']>;
  /** Timestamp when the provider returned a successful response. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the record was first created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** IP address of the request that created this action. Used for rate-limiting unauthenticated callers. */
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  /** Error details if the call failed, including message and stack trace. */
  errorAsJson?: Maybe<Scalars['JSON']['output']>;
  /**
   * Estimated cost in micro-USD (cost in USD multiplied by 1,000,000), stored as
   * an integer. This provides high precision ($0.000001 resolution) so that even
   * small token counts (a few thousand total, or less on cheap cached rates)
   * produce a non-zero value instead of rounding to $0.
   */
  estimatedCostInMicroUSD?: Maybe<Scalars['Int']['output']>;
  /**
   * Estimated cost in US dollars as a floating point number (e.g. 0.00012345 for a
   * sub-cent call). Derived precisely from estimatedCostInMicroUSD / 1_000_000.
   * Returns null if no cost data is available. Useful for reporting and sums
   * without losing precision on small values.
   */
  estimatedCostUsd?: Maybe<Scalars['Float']['output']>;
  /** Wall-clock duration from sentAt to completedAt, in milliseconds. */
  executionTimeInMs?: Maybe<Scalars['Int']['output']>;
  /** Timestamp when the call was recorded as failed. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Full request payload sent to the provider (reserved; not currently populated). */
  fullRequestAsJson?: Maybe<Scalars['JSON']['output']>;
  /** Full response envelope returned by the provider, including headers and raw message structure. */
  fullResponseAsJson?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Serialized input parameters sent to the AI SDK. Stored in AI SDK CoreMessage
   * format so the record can be replayed via process().
   */
  inputAsJson?: Maybe<Scalars['JSON']['output']>;
  /**
   * Number of input tokens (prompt + messages + system) for this action.
   * Denormalized from the raw metrics for convenient querying and aggregation.
   */
  inputTokens?: Maybe<Scalars['Int']['output']>;
  /** Typed view of token usage metrics parsed from metricsAsJson. */
  metrics?: Maybe<ScoAiActionMetrics>;
  /** Raw token usage returned by the provider. Use the metrics field for a typed view of this data. */
  metricsAsJson?: Maybe<Scalars['JSON']['output']>;
  /** Model identifier within the provider (e.g. "gemini-2.5-flash"). */
  modelId?: Maybe<Scalars['String']['output']>;
  /** AI SDK operation that was performed: generateText, streamText, generateObject, or streamObject. */
  operation?: Maybe<Scalars['String']['output']>;
  /**
   * Output from the AI provider. For text operations this is the generated text
   * string; for object operations this is the structured object; for streaming
   * operations this is updated incrementally.
   */
  outputAsJson?: Maybe<Scalars['JSON']['output']>;
  /** Number of output tokens generated for this action. Denormalized from the raw metrics. */
  outputTokens?: Maybe<Scalars['Int']['output']>;
  /** AI provider identifier (e.g. "google", "openai", "anthropic", "deepseek"). */
  provider?: Maybe<Scalars['String']['output']>;
  /**
   * Reasoning / chain-of-thought tokens (for models that expose them, e.g. OpenAI
   * o-series). Denormalized from metrics.outputTokenDetails.reasoningTokens or legacy alias.
   */
  reasoningTokens?: Maybe<Scalars['Int']['output']>;
  /** Optional sub-key distinguishing multiple AI actions on the same related entity (e.g. "summary" vs "review"). */
  relatedModelContextKey?: Maybe<Scalars['String']['output']>;
  /** UUID of the related entity identified by relatedModelType. */
  relatedModelId?: Maybe<Scalars['String']['output']>;
  /** Sequelize model name of the entity this action is associated with (e.g. "Comment", "Company"). */
  relatedModelType?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the request was dispatched to the AI provider. */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Lifecycle status: "pending" while the call is in flight, "success" on completion, "error" on failure. */
  status?: Maybe<Scalars['String']['output']>;
  /** Total tokens for the action (input + output + reasoning when present). Denormalized / derived from the raw metrics. */
  totalTokens?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the most recent update to this record. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who initiated this action, if authenticated. */
  user?: Maybe<ScoUser>;
  /** UUID of the user who initiated this action, if authenticated. */
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoAiActionCollection = {
  __typename?: 'ScoAiActionCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoAiAction>>;
  pagination: Pagination;
};

/** Token usage metrics for a completed AI action, as reported by the provider. */
export type ScoAiActionMetrics = {
  __typename?: 'ScoAiActionMetrics';
  /** Input tokens served from the provider's prompt cache (cache hits/reads). These are typically billed at a lower rate. */
  cacheReadInputTokens?: Maybe<Scalars['Int']['output']>;
  /** Number of tokens in the input (prompt + messages + system). */
  inputTokens?: Maybe<Scalars['Int']['output']>;
  /** Number of tokens generated in the response. */
  outputTokens?: Maybe<Scalars['Int']['output']>;
  /** Tokens consumed by extended reasoning / chain-of-thought, if the model supports it. */
  reasoningTokens?: Maybe<Scalars['Int']['output']>;
  /** Total tokens consumed by the call (inputTokens + outputTokens + reasoningTokens). */
  totalTokens?: Maybe<Scalars['Int']['output']>;
};

export type ScoAiActionUpdatedSubscriptionPayload = {
  __typename?: 'ScoAiActionUpdatedSubscriptionPayload';
  aiAction?: Maybe<ScoAiAction>;
  aiActionId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** One model’s estimated AI cost for a single calendar day. */
export type ScoAiCostDailyByModel = {
  __typename?: 'ScoAiCostDailyByModel';
  /** Number of AiAction rows in this day + model bucket. */
  actionCount?: Maybe<Scalars['Int']['output']>;
  /** Sum of estimatedCostInMicroUSD for this day + model. Float so large range totals do not overflow GraphQL Int. */
  costInMicroUSD?: Maybe<Scalars['Float']['output']>;
  /** Calendar day for this bucket (start of day). */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Same cost as US dollars (costInMicroUSD / 1_000_000). */
  estimatedCostUsd?: Maybe<Scalars['Float']['output']>;
  /** Model identifier within the provider (e.g. "gemini-2.5-flash"). */
  modelId?: Maybe<Scalars['String']['output']>;
  /** AI provider identifier (e.g. "google", "openai"). */
  provider?: Maybe<Scalars['String']['output']>;
};

/** Admin AI spend report for a date range: daily cost by model plus the top users by cost. */
export type ScoAiCostReport = {
  __typename?: 'ScoAiCostReport';
  /** Per-day, per-model cost buckets used to chart stacked spend. */
  dailyByModel: Array<ScoAiCostDailyByModel>;
  /** Inclusive end of the reporting window (end of day). */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Inclusive start of the reporting window (start of day). */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Top users by estimated cost descending (default 50). */
  topUsers: Array<ScoAiCostUser>;
  /** Number of AiAction rows in the window. */
  totalActionCount?: Maybe<Scalars['Int']['output']>;
  /** Sum of estimatedCostInMicroUSD across all AiAction rows in the window. */
  totalCostInMicroUSD?: Maybe<Scalars['Float']['output']>;
  /** Total estimated cost in US dollars. */
  totalCostUsd?: Maybe<Scalars['Float']['output']>;
  /** Distinct provider+model pairs with spend in the window. */
  uniqueModelCount?: Maybe<Scalars['Int']['output']>;
  /** Distinct authenticated userIds with at least one AiAction in the window. */
  uniqueUserCount?: Maybe<Scalars['Int']['output']>;
};

/** One user’s estimated AI cost for the report window. */
export type ScoAiCostUser = {
  __typename?: 'ScoAiCostUser';
  /** Number of AiAction rows for this user in the window. */
  actionCount?: Maybe<Scalars['Int']['output']>;
  /** Sum of estimatedCostInMicroUSD for this user in the window. Float so large totals do not overflow GraphQL Int. */
  costInMicroUSD?: Maybe<Scalars['Float']['output']>;
  /** Same cost as US dollars (costInMicroUSD / 1_000_000). */
  estimatedCostUsd?: Maybe<Scalars['Float']['output']>;
  /** Sum of totalTokens for this user in the window. Float so large range totals do not overflow GraphQL Int. */
  totalTokens?: Maybe<Scalars['Float']['output']>;
  /** Resolved user for this row, when userId is present. */
  user?: Maybe<ScoUser>;
  /** User UUID. Null when the spend is from unauthenticated callers. */
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoAnalytics = {
  __typename?: 'ScoAnalytics';
  countEventFieldByValue?: Maybe<Array<Maybe<ScoAnalyticsDataPoint>>>;
  countEventsByPeriod?: Maybe<Array<Maybe<ScoAnalyticsDataPoint>>>;
  eventCatalog?: Maybe<Array<Maybe<ScoAnalyticsEventTable>>>;
  eventFieldKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  eventFields?: Maybe<Array<Maybe<ScoAnalyticsEventField>>>;
  eventTypes?: Maybe<Array<Maybe<ScoAnalyticsEventType>>>;
  funnel?: Maybe<ScoAnalyticsFunnelResult>;
  id: Scalars['ID']['output'];
  report?: Maybe<Array<Maybe<ScoAnalyticsSeriesResult>>>;
};


export type ScoAnalyticsCountEventFieldByValueArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventKey?: InputMaybe<Scalars['String']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type ScoAnalyticsCountEventsByPeriodArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventKey?: InputMaybe<Scalars['String']['input']>;
  groupByPeriod?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type ScoAnalyticsEventCatalogArgs = {
  schema?: InputMaybe<Scalars['String']['input']>;
};


export type ScoAnalyticsEventFieldKeysArgs = {
  schema?: InputMaybe<Scalars['String']['input']>;
};


export type ScoAnalyticsEventFieldsArgs = {
  eventKey: Scalars['String']['input'];
  schema?: InputMaybe<Scalars['String']['input']>;
};


export type ScoAnalyticsEventTypesArgs = {
  schema?: InputMaybe<Scalars['String']['input']>;
};


export type ScoAnalyticsFunnelArgs = {
  input: ScoAnalyticsFunnelInput;
};


export type ScoAnalyticsReportArgs = {
  input: ScoAnalyticsReportInput;
};

export type ScoAnalyticsDataPoint = {
  __typename?: 'ScoAnalyticsDataPoint';
  countAll?: Maybe<Scalars['Int']['output']>;
  countUnique?: Maybe<Scalars['Int']['output']>;
  countUsers?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  eventKey?: Maybe<Scalars['String']['output']>;
  fieldKey?: Maybe<Scalars['String']['output']>;
  fieldValue?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  sumValue?: Maybe<Scalars['Float']['output']>;
};

export type ScoAnalyticsEventField = {
  __typename?: 'ScoAnalyticsEventField';
  dataType?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isNumeric?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ScoAnalyticsEventTable = {
  __typename?: 'ScoAnalyticsEventTable';
  id: Scalars['ID']['output'];
  isCurated?: Maybe<Scalars['Boolean']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScoAnalyticsEventType = {
  __typename?: 'ScoAnalyticsEventType';
  id: Scalars['ID']['output'];
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScoAnalyticsFilterInput = {
  fieldKey: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ScoAnalyticsFunnelInput = {
  conversionWindowHours?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['DateTime']['input'];
  identityKey?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  steps: Array<InputMaybe<ScoAnalyticsFunnelStepInput>>;
};

export type ScoAnalyticsFunnelResult = {
  __typename?: 'ScoAnalyticsFunnelResult';
  identityKey?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  overallConversion?: Maybe<Scalars['Float']['output']>;
  steps?: Maybe<Array<Maybe<ScoAnalyticsFunnelStepResult>>>;
};

export type ScoAnalyticsFunnelStepInput = {
  eventKey: Scalars['String']['input'];
  filters?: InputMaybe<Array<InputMaybe<ScoAnalyticsFilterInput>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
};

export type ScoAnalyticsFunnelStepResult = {
  __typename?: 'ScoAnalyticsFunnelStepResult';
  conversionFromFirst?: Maybe<Scalars['Float']['output']>;
  conversionFromPrevious?: Maybe<Scalars['Float']['output']>;
  countUnique?: Maybe<Scalars['Int']['output']>;
  dropOff?: Maybe<Scalars['Int']['output']>;
  eventKey?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ScoAnalyticsReport = {
  __typename?: 'ScoAnalyticsReport';
  dataPoints?: Maybe<Array<Maybe<ScoAnalyticsDataPoint>>>;
  id: Scalars['ID']['output'];
};

export type ScoAnalyticsReportInput = {
  breakdownFieldKey?: InputMaybe<Scalars['String']['input']>;
  breakdownLimit?: InputMaybe<Scalars['Int']['input']>;
  compareToPreviousPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['DateTime']['input'];
  groupByPeriod?: InputMaybe<Scalars['String']['input']>;
  series: Array<InputMaybe<ScoAnalyticsSeriesInput>>;
  startDate: Scalars['DateTime']['input'];
};

export type ScoAnalyticsSavedReport = ScoNode & {
  __typename?: 'ScoAnalyticsSavedReport';
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUser?: Maybe<ScoUser>;
  createdByUserId?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isPreset?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['String']['output']>;
  scoAnalyticsSavedReportId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUser?: Maybe<ScoUser>;
  updatedByUserId?: Maybe<Scalars['UUID']['output']>;
};

export type ScoAnalyticsSavedReportCollection = {
  __typename?: 'ScoAnalyticsSavedReportCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoAnalyticsSavedReport>>;
  pagination: Pagination;
};

export type ScoAnalyticsSeriesInput = {
  eventKey: Scalars['String']['input'];
  filters?: InputMaybe<Array<InputMaybe<ScoAnalyticsFilterInput>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  sumFieldKey?: InputMaybe<Scalars['String']['input']>;
};

export type ScoAnalyticsSeriesResult = {
  __typename?: 'ScoAnalyticsSeriesResult';
  breakdown?: Maybe<Array<Maybe<ScoAnalyticsDataPoint>>>;
  comparePoints?: Maybe<Array<Maybe<ScoAnalyticsDataPoint>>>;
  compareTotal?: Maybe<Scalars['Float']['output']>;
  eventKey?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  metric?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Array<Maybe<ScoAnalyticsDataPoint>>>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type ScoAsset = {
  __typename?: 'ScoAsset';
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastModified?: Maybe<Scalars['Float']['output']>;
  lqip?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  publicPath: Scalars['String']['output'];
  size?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  viewBox?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ScoAttachment = ScoNode & {
  __typename?: 'ScoAttachment';
  abridgedBody?: Maybe<Scalars['String']['output']>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  authorBio?: Maybe<Scalars['String']['output']>;
  authorImageUrl?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  categorySlug?: Maybe<Scalars['String']['output']>;
  categoryUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featuredImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ScoAttachmentUserPresenceSubscriptionPayload = {
  __typename?: 'ScoAttachmentUserPresenceSubscriptionPayload';
  attachment?: Maybe<ScoAttachment>;
  attachmentId: Scalars['String']['output'];
  attachmentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  isTyping?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** A billing statement. */
export type ScoBillingStatement = ScoNode & {
  __typename?: 'ScoBillingStatement';
  billingStatementId?: Maybe<Scalars['String']['output']>;
  customerCompanyLocation?: Maybe<Scalars['String']['output']>;
  customerCompanyName?: Maybe<Scalars['String']['output']>;
  customerCompanyUrl?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerFirstName?: Maybe<Scalars['String']['output']>;
  customerLastName?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<Maybe<ScoBillingStatementItem>>>;
  id: Scalars['ID']['output'];
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  items?: Maybe<Array<Maybe<ScoBillingStatementItem>>>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paidInCents?: Maybe<Scalars['Int']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  platformIdentifier?: Maybe<Scalars['String']['output']>;
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  refundedInCents?: Maybe<Scalars['Int']['output']>;
  settledAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalInCents?: Maybe<Scalars['Int']['output']>;
};

/** A billing statement item. */
export type ScoBillingStatementItem = ScoNode & {
  __typename?: 'ScoBillingStatementItem';
  amountInCents?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  paymentMethodBrand?: Maybe<Scalars['String']['output']>;
  paymentMethodMaskedId?: Maybe<Scalars['String']['output']>;
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ScoBootcamp = ScoNode & {
  __typename?: 'ScoBootcamp';
  coaches?: Maybe<Array<Maybe<ScoUser>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  introductionHtml?: Maybe<Scalars['String']['output']>;
  isEnrollable?: Maybe<Scalars['Boolean']['output']>;
  lesson?: Maybe<ScoBootcampLesson>;
  lessons?: Maybe<Array<Maybe<ScoBootcampLesson>>>;
  purchaseRequired?: Maybe<Scalars['Boolean']['output']>;
  slackInviteUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  threads?: Maybe<ScoThreadCollection>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ScoBootcampLessonArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
};


export type ScoBootcampThreadsArgs = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  spam?: InputMaybe<Scalars['String']['input']>;
  threadTypeKey?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type ScoBootcampEnrollment = ScoNode & {
  __typename?: 'ScoBootcampEnrollment';
  bootcamp?: Maybe<ScoBootcamp>;
  bootcampEnrollmentId?: Maybe<Scalars['String']['output']>;
  bootcampSlug?: Maybe<Scalars['String']['output']>;
  coachUser?: Maybe<ScoUser>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentUserCanComment?: Maybe<Scalars['Boolean']['output']>;
  currentUserCanEdit?: Maybe<Scalars['Boolean']['output']>;
  currentUserCanView?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  percentComplete?: Maybe<Scalars['Int']['output']>;
  responses?: Maybe<Array<Maybe<ScoBootcampResponse>>>;
  shares?: Maybe<Array<Maybe<ScoBootcampShare>>>;
  statuses?: Maybe<Array<Maybe<ScoBootcampStatus>>>;
  subscriptions?: Maybe<Array<Maybe<ScoSubscription>>>;
  targetCompletionDate?: Maybe<Scalars['DateTime']['output']>;
  thread?: Maybe<ScoThread>;
  threads?: Maybe<ScoThreadCollection>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
};


export type ScoBootcampEnrollmentThreadArgs = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};


export type ScoBootcampEnrollmentThreadsArgs = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  spam?: InputMaybe<Scalars['String']['input']>;
  threadTypeKey?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type ScoBootcampEnrollmentCollection = {
  __typename?: 'ScoBootcampEnrollmentCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoBootcampEnrollment>>;
  pagination: Pagination;
};

export type ScoBootcampLesson = ScoNode & {
  __typename?: 'ScoBootcampLesson';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  number?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  step?: Maybe<ScoBootcampStep>;
  steps?: Maybe<Array<Maybe<ScoBootcampStep>>>;
  title?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};


export type ScoBootcampLessonStepArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
};

export type ScoBootcampPrompt = ScoNode & {
  __typename?: 'ScoBootcampPrompt';
  bootcampLessonSlug?: Maybe<Scalars['String']['output']>;
  bootcampSlug?: Maybe<Scalars['String']['output']>;
  bootcampStepSlug?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  response?: Maybe<ScoBootcampResponse>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ScoBootcampResponse = ScoNode & {
  __typename?: 'ScoBootcampResponse';
  bootcampResponseId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  enrollment?: Maybe<ScoBootcampEnrollment>;
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  prompt?: Maybe<ScoBootcampPrompt>;
  promptSlug?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<ScoThread>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ScoBootcampShare = ScoNode & {
  __typename?: 'ScoBootcampShare';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  bootcampShareId?: Maybe<Scalars['String']['output']>;
  canComment?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  canView?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  enrollment?: Maybe<ScoBootcampEnrollment>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentByUser?: Maybe<ScoUser>;
  sentToEmail?: Maybe<Scalars['String']['output']>;
  sentToName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
};

export type ScoBootcampStatus = ScoNode & {
  __typename?: 'ScoBootcampStatus';
  bootcampStatusId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  enrollment?: Maybe<ScoBootcampEnrollment>;
  id: Scalars['ID']['output'];
  playbackInSeconds?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  stepSlug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoBootcampStep = ScoNode & {
  __typename?: 'ScoBootcampStep';
  description?: Maybe<Scalars['String']['output']>;
  exampleHtml?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructionHtml?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  prompts?: Maybe<Array<Maybe<ScoBootcampPrompt>>>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoStartTime?: Maybe<Scalars['Int']['output']>;
  videoStartTimeFormatted?: Maybe<Scalars['String']['output']>;
};

/** Public Clarity expert preview plus claim status for advisor import. */
export type ScoClarityAdvisorImport = {
  __typename?: 'ScoClarityAdvisorImport';
  canonicalScreenName?: Maybe<Scalars['String']['output']>;
  claimStatus: ScoClarityAdvisorImportClaimStatus;
  expert?: Maybe<ClarityExpert>;
  handle: Scalars['String']['output'];
};

/** Claim state for /advisors/clarity-import/[handle]. Guests never receive claimed_by_me. */
export enum ScoClarityAdvisorImportClaimStatus {
  ClaimedByMe = 'claimed_by_me',
  ClaimedByOther = 'claimed_by_other',
  NotExpert = 'not_expert',
  NotFound = 'not_found',
  Unclaimed = 'unclaimed'
}

export type ScoComment = ScoNode & {
  __typename?: 'ScoComment';
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  canUserAdmin?: Maybe<Scalars['Boolean']['output']>;
  canUserComment?: Maybe<Scalars['Boolean']['output']>;
  canUserDelete?: Maybe<Scalars['Boolean']['output']>;
  canUserEdit?: Maybe<Scalars['Boolean']['output']>;
  canUserFlag?: Maybe<Scalars['Boolean']['output']>;
  canUserLike?: Maybe<Scalars['Boolean']['output']>;
  childComments?: Maybe<ScoCommentCollection>;
  childCommentsCount?: Maybe<Scalars['Int']['output']>;
  commentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<ScoUser>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedByUser?: Maybe<ScoUser>;
  draftOrigin?: Maybe<Scalars['String']['output']>;
  embedsAsJson?: Maybe<Scalars['JSON']['output']>;
  featuredAt?: Maybe<Scalars['DateTime']['output']>;
  featuredByUser?: Maybe<ScoUser>;
  featuredByUserId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<ScoFlagCollection>;
  flagsCount?: Maybe<Scalars['Int']['output']>;
  follows?: Maybe<ScoFollowCollection>;
  followsCount?: Maybe<Scalars['Int']['output']>;
  hasUserCommented?: Maybe<Scalars['Boolean']['output']>;
  hasUserFlagged?: Maybe<Scalars['Boolean']['output']>;
  hasUserFollowed?: Maybe<Scalars['Boolean']['output']>;
  hasUserLiked?: Maybe<Scalars['Boolean']['output']>;
  hasUserViewed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isSpam?: Maybe<Scalars['Boolean']['output']>;
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  lastCommentedAt?: Maybe<Scalars['DateTime']['output']>;
  likes?: Maybe<ScoLikeCollection>;
  likesCount?: Maybe<Scalars['Int']['output']>;
  notifications?: Maybe<ScoNotificationCollection>;
  originKey?: Maybe<Scalars['String']['output']>;
  parentComment?: Maybe<ScoComment>;
  parentCommentId?: Maybe<Scalars['String']['output']>;
  storedFiles?: Maybe<ScoStoredFileCollection>;
  thinking?: Maybe<ScoCommentThinking>;
  thread?: Maybe<ScoThread>;
  threadId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userIsAuthor?: Maybe<Scalars['Boolean']['output']>;
  views?: Maybe<ScoViewCollection>;
  viewsCount?: Maybe<Scalars['Int']['output']>;
  withdrawnAt?: Maybe<Scalars['DateTime']['output']>;
  withdrawnByUserId?: Maybe<Scalars['String']['output']>;
};


export type ScoCommentChildCommentsArgs = {
  afterCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  afterUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  beforeCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  beforeUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  longPollInSeconds?: InputMaybe<Scalars['Int']['input']>;
  maxFlags?: InputMaybe<Scalars['Int']['input']>;
  onlyMyDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPublicComments?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  spam?: InputMaybe<SpamFilter>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};


export type ScoCommentFlagsArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type ScoCommentFollowsArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type ScoCommentLikesArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type ScoCommentNotificationsArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type ScoCommentStoredFilesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoCommentViewsArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ScoCommentCollection = {
  __typename?: 'ScoCommentCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoComment>>;
  pagination: Pagination;
};

/** Model thinking / chain-of-thought associated with an assistant chat comment. Never mixed into body. */
export type ScoCommentThinking = {
  __typename?: 'ScoCommentThinking';
  /** When thinking finished (or the turn finalized). */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When thinking began streaming for this comment. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** idle | streaming | complete | error | unavailable — drives collapsible thinking UI. */
  status: Scalars['String']['output'];
  /** Concatenated reasoning text for display. */
  text?: Maybe<Scalars['String']['output']>;
  /** True when persisted text was truncated for size limits. */
  truncated?: Maybe<Scalars['Boolean']['output']>;
};

export type ScoCompany = ScoNode & {
  __typename?: 'ScoCompany';
  annualRevenue?: Maybe<ScoStaticOption>;
  annualRevenueKey?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  competitionStatement?: Maybe<Scalars['String']['output']>;
  elevatorPitch?: Maybe<Scalars['String']['output']>;
  financialsStatement?: Maybe<Scalars['String']['output']>;
  fundingGoalInDollars?: Maybe<Scalars['Int']['output']>;
  fundingGoalStage?: Maybe<ScoStaticOption>;
  fundingGoalStageKey?: Maybe<Scalars['String']['output']>;
  fundingGoalStatement?: Maybe<Scalars['String']['output']>;
  fundingRaised?: Maybe<ScoStaticOption>;
  fundingRaisedKey?: Maybe<Scalars['String']['output']>;
  fundingStage?: Maybe<ScoStaticOption>;
  fundingStageKey?: Maybe<Scalars['String']['output']>;
  headcount?: Maybe<ScoStaticOption>;
  headcountKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industries?: Maybe<Array<Maybe<ScoIndustry>>>;
  industry?: Maybe<ScoIndustry>;
  industryKey?: Maybe<Scalars['String']['output']>;
  industryKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  location?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountry?: Maybe<ScoStaticOption>;
  locationCountryKey?: Maybe<Scalars['String']['output']>;
  locationPlaceId?: Maybe<Scalars['String']['output']>;
  locationPostalCode?: Maybe<Scalars['String']['output']>;
  locationState?: Maybe<Scalars['String']['output']>;
  locationStreetLine1?: Maybe<Scalars['String']['output']>;
  locationStreetLine2?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketSizeStatement?: Maybe<Scalars['String']['output']>;
  monthlyRevenue?: Maybe<ScoStaticOption>;
  monthlyRevenueKey?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pitchDeckNote?: Maybe<Scalars['String']['output']>;
  pitchDeckUrl?: Maybe<Scalars['String']['output']>;
  problemStatement?: Maybe<Scalars['String']['output']>;
  profileVisibility?: Maybe<ScoStaticOption>;
  profileVisibilityKey?: Maybe<Scalars['String']['output']>;
  solutionStatement?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<ScoStaticOption>;
  stageKey?: Maybe<Scalars['String']['output']>;
  teamStatement?: Maybe<Scalars['String']['output']>;
  tractionStatement?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ScoUser>;
  userMemberships?: Maybe<ScoUserMembershipCollection>;
  users?: Maybe<ScoUserCollection>;
  yearFounded?: Maybe<Scalars['String']['output']>;
};


export type ScoCompanyUserMembershipsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type ScoCompanyUsersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ScoCompanyCollection = {
  __typename?: 'ScoCompanyCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoCompany>>;
  pagination: Pagination;
};

/** The stages of companies. */
export type ScoCompanyStage = ScoNode & {
  __typename?: 'ScoCompanyStage';
  companyStageId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScoContentPermissions = {
  __typename?: 'ScoContentPermissions';
  canAccessAdvisorTeam?: Maybe<Scalars['Boolean']['output']>;
  canAccessChat?: Maybe<Scalars['Boolean']['output']>;
  canAccessCourses?: Maybe<Scalars['Boolean']['output']>;
  canAccessFGAccountManager?: Maybe<Scalars['Boolean']['output']>;
  canAccessFGAdvisor?: Maybe<Scalars['Boolean']['output']>;
  canAccessFGBasicEvents?: Maybe<Scalars['Boolean']['output']>;
  canAccessFGDashboard?: Maybe<Scalars['Boolean']['output']>;
  canAccessFGDiscussions?: Maybe<Scalars['Boolean']['output']>;
  canAccessFGInvestorContacts?: Maybe<Scalars['Boolean']['output']>;
  canAccessFGMemberDirectory?: Maybe<Scalars['Boolean']['output']>;
  canAccessFGOfficeHours?: Maybe<Scalars['Boolean']['output']>;
  canAccessFGPremiumEvents?: Maybe<Scalars['Boolean']['output']>;
  canAccessFGRequests?: Maybe<Scalars['Boolean']['output']>;
  canAccessFGWorkshops?: Maybe<Scalars['Boolean']['output']>;
  canAccessFGZirtual?: Maybe<Scalars['Boolean']['output']>;
  canAccessFundingAccelerator?: Maybe<Scalars['Boolean']['output']>;
  canAccessGetCustomers?: Maybe<Scalars['Boolean']['output']>;
  canAccessInvestorMatching?: Maybe<Scalars['Boolean']['output']>;
  canAccessMemberMatching?: Maybe<Scalars['Boolean']['output']>;
  canAccessPitchDeckAuditor?: Maybe<Scalars['Boolean']['output']>;
  canAccessPitchDeckService?: Maybe<Scalars['Boolean']['output']>;
  canAccessPodcast?: Maybe<Scalars['Boolean']['output']>;
  canAccessPremiumBenefits?: Maybe<Scalars['Boolean']['output']>;
  canAccessVideos?: Maybe<Scalars['Boolean']['output']>;
  canActivateBizplan?: Maybe<Scalars['Boolean']['output']>;
  canActivateFundable?: Maybe<Scalars['Boolean']['output']>;
  canActivateLaunchrock?: Maybe<Scalars['Boolean']['output']>;
  canPreviewCourses?: Maybe<Scalars['Boolean']['output']>;
  canPreviewPodcast?: Maybe<Scalars['Boolean']['output']>;
  canPreviewVideos?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  investorMatchingMaxMessagesPerDay?: Maybe<Scalars['Int']['output']>;
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  sessionEarningsFeeAsPercent?: Maybe<Scalars['Int']['output']>;
};

export type ScoContentTrackEnrollment = ScoNode & {
  __typename?: 'ScoContentTrackEnrollment';
  advisorUser?: Maybe<ScoUser>;
  company?: Maybe<ScoCompany>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  contentTrack?: Maybe<ScoAttachment>;
  contentTrackEnrollmentId?: Maybe<Scalars['String']['output']>;
  contentTrackId?: Maybe<Scalars['String']['output']>;
  contentTrackSlug?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentUserCanComment?: Maybe<Scalars['Boolean']['output']>;
  currentUserCanEdit?: Maybe<Scalars['Boolean']['output']>;
  currentUserCanView?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<ScoIndustry>;
  industryKey?: Maybe<Scalars['String']['output']>;
  percentCompleted?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<ScoContentTrackStatus>;
  responses?: Maybe<Array<Maybe<ScoContentTrackResponse>>>;
  targetCompletionDate?: Maybe<Scalars['DateTime']['output']>;
  threads?: Maybe<ScoThreadCollection>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
  userMemberships?: Maybe<Array<Maybe<ScoUserMembership>>>;
  users?: Maybe<Array<Maybe<ScoUser>>>;
};


export type ScoContentTrackEnrollmentThreadsArgs = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  spam?: InputMaybe<Scalars['String']['input']>;
  threadTypeKey?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type ScoContentTrackEnrollmentCollection = {
  __typename?: 'ScoContentTrackEnrollmentCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoContentTrackEnrollment>>;
  pagination: Pagination;
};

export type ScoContentTrackResponse = ScoNode & {
  __typename?: 'ScoContentTrackResponse';
  completedAt?: Maybe<Scalars['String']['output']>;
  contentTrackId?: Maybe<Scalars['String']['output']>;
  contentTrackResponseId?: Maybe<Scalars['String']['output']>;
  contentTrackSlug?: Maybe<Scalars['String']['output']>;
  contentTrackStepId?: Maybe<Scalars['String']['output']>;
  contentTrackStepSlug?: Maybe<Scalars['String']['output']>;
  contentTrackTaskId?: Maybe<Scalars['String']['output']>;
  contentTrackTaskSlug?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<ScoUser>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  enrollment?: Maybe<ScoContentTrackEnrollment>;
  id: Scalars['ID']['output'];
  startedAt?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<ScoThread>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByIpAddress?: Maybe<Scalars['String']['output']>;
  updatedByUser?: Maybe<ScoUser>;
  updatedByUserId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  valueContext?: Maybe<Scalars['String']['output']>;
  valueFormat?: Maybe<Scalars['String']['output']>;
};

export type ScoContentTrackResponseCollection = {
  __typename?: 'ScoContentTrackResponseCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoContentTrackResponse>>;
  pagination: Pagination;
};

export type ScoContentTrackStatus = ScoNode & {
  __typename?: 'ScoContentTrackStatus';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completionAsPercent?: Maybe<Scalars['Int']['output']>;
  contentTrackStatusId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  responses?: Maybe<Array<Maybe<ScoContentTrackResponse>>>;
  sectionStatuses?: Maybe<Array<Maybe<ScoContentTrackStatus>>>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  stepStatuses?: Maybe<Array<Maybe<ScoContentTrackStatus>>>;
  targetId?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  taskStatuses?: Maybe<Array<Maybe<ScoContentTrackStatus>>>;
  views?: Maybe<Array<Maybe<ScoView>>>;
};

export type ScoCourse = ScoNode & {
  __typename?: 'ScoCourse';
  displayTitle?: Maybe<Scalars['String']['output']>;
  expertAdvice?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  founderStories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageBackgroundColor?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  playbooks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  questions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  slug?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ScoCourseEnrollment = ScoNode & {
  __typename?: 'ScoCourseEnrollment';
  course?: Maybe<ScoPlaybook>;
  courseEnrollmentId?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

/**
 * A CRM desk account (an inbox) as the account picker and the Settings Inboxes tab
 * show it. No consent fields (V2-L6): turning crmEnabled on is the consent. The
 * late threshold is not per inbox (V2-L5: CRM_LATE_HOURS, see lateAfterMinutes on
 * the queue and the report).
 */
export type ScoCrmAccount = {
  __typename?: 'ScoCrmAccount';
  /**
   * The inbox's booking link (V2-L22), stored on its responder tool and given to
   * the drafter as a labeled account fact. Null when unset or when there is no
   * usable responder tool. Set it with setCrmBookingUrl.
   */
  bookingUrl?: Maybe<Scalars['String']['output']>;
  crmEnabled?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /**
   * True when responderToolId names a live tool that sends as this account and is
   * not a sco-admin tool: what the desk, the drafter and setCrmBookingUrl need.
   * setUserCrm refuses to turn an account on without a reply tool.
   */
  hasResponderTool?: Maybe<Scalars['Boolean']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  responderToolId?: Maybe<Scalars['String']['output']>;
  /** That person's name. */
  sentAsName?: Maybe<Scalars['String']['output']>;
  /** Who replies from this inbox go out as: the responder tool's servesUserId. Null without a responder tool. */
  sentAsUserId?: Maybe<Scalars['String']['output']>;
  /**
   * The live, non sco-admin tool that sends as this account (tools.servesUserId),
   * or null. To put an eligible account on the desk whose responderToolId is not
   * set, pass this as setUserCrm.responderToolId.
   */
  servingToolId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmBaseline = {
  __typename?: 'ScoCrmBaseline';
  inboundCount?: Maybe<Scalars['Int']['output']>;
  medianFirstReplySeconds?: Maybe<Scalars['Float']['output']>;
  repliedCount?: Maybe<Scalars['Int']['output']>;
  since?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * The member's company for the CRM aside: option titles with the admin page's key
 * fallback. website is http(s) only, else null.
 */
export type ScoCrmCompany = {
  __typename?: 'ScoCrmCompany';
  fundingRaised?: Maybe<Scalars['String']['output']>;
  fundingStage?: Maybe<Scalars['String']['output']>;
  headcount?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmDraftPreview = {
  __typename?: 'ScoCrmDraftPreview';
  actionKey?: Maybe<Scalars['String']['output']>;
  blockedReason?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  cardTitle?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<ScoCrmPreviewField>>>;
  laneKey?: Maybe<Scalars['String']['output']>;
  missingFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  modelKey?: Maybe<Scalars['String']['output']>;
  promptSections?: Maybe<Array<Maybe<ScoCrmPromptSection>>>;
  ruleName?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  scoringLive?: Maybe<Scalars['Boolean']['output']>;
  steps?: Maybe<Array<Maybe<ScoCrmPreviewStep>>>;
  templateKindKey?: Maybe<Scalars['String']['output']>;
  templateTitle?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmHubspotItem = {
  __typename?: 'ScoCrmHubspotItem';
  at?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmMember = {
  __typename?: 'ScoCrmMember';
  accountDisplayName?: Maybe<Scalars['String']['output']>;
  banned?: Maybe<Scalars['Boolean']['output']>;
  /** The admin user page company (same row and key fallbacks). Null when there is no row or it is empty. */
  company?: Maybe<ScoCrmCompany>;
  /**
   * Every direct chat between this member and any crmEnabled account: account
   * name, last published date and attention state only. Empty under a Tool persona
   * account. Sco admins only.
   */
  conversations?: Maybe<Array<Maybe<ScoCrmMemberConversation>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletionRequested?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  hubspotContactId?: Maybe<Scalars['String']['output']>;
  hubspotFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  hubspotItems?: Maybe<Array<Maybe<ScoCrmHubspotItem>>>;
  hubspotPortalUrl?: Maybe<Scalars['String']['output']>;
  hubspotUnavailableReason?: Maybe<Scalars['String']['output']>;
  inboundCount?: Maybe<Scalars['Int']['output']>;
  /** Last seen on the site (any authenticated request, including staff impersonation). Not activity, and never sent to a model. */
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  latestThreadId?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  outboundCount?: Maybe<Scalars['Int']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /** Same as planTierLabel (a curated member-facing tier, never a legacy generic title or slug). */
  planName?: Maybe<Scalars['String']['output']>;
  /**
   * Curated member-facing tier of the subscription the sheet describes (the newest
   * active one, else the newest). 'a paid plan' when the product has no curated
   * name; null with no subscription or an unknown product.
   */
  planTierLabel?: Maybe<Scalars['String']['output']>;
  /**
   * Effective recurring price for the subscription's own term (coupons and custom
   * pricing applied), e.g. '$3,999 per year'. Null when unsure, one-time, or canceled.
   */
  priceLabel?: Maybe<Scalars['String']['output']>;
  /**
   * Newest five of: tool session started, pitch deck uploaded, event RSVP
   * accepted. Labels are system titles only. Sco admins only.
   */
  productActivity?: Maybe<Array<Maybe<ScoCrmMemberActivity>>>;
  sharedThreadCount?: Maybe<Scalars['Int']['output']>;
  stageLabel?: Maybe<Scalars['String']['output']>;
  /** When subscriptionState is canceled: the cancel date, when known. */
  subscriptionCanceledAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * active | trial | past_due | paused | canceled | inactive | none. active and
   * trial follow Subscription.isActive (the admin Billing badge).
   */
  subscriptionState?: Maybe<Scalars['String']['output']>;
  summaryBody?: Maybe<Scalars['String']['output']>;
  summaryGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** One product event for the CRM aside. label is a system title only (tool or event title), never member text. */
export type ScoCrmMemberActivity = {
  __typename?: 'ScoCrmMemberActivity';
  at?: Maybe<Scalars['DateTime']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** One direct chat between the member and a crmEnabled account (V2-L20). No title, no body, no draft information. */
export type ScoCrmMemberConversation = {
  __typename?: 'ScoCrmMemberConversation';
  accountName?: Maybe<Scalars['String']['output']>;
  accountUserId?: Maybe<Scalars['String']['output']>;
  /** reply-needed | waiting-on-them | done (never draft-ready). Null when another member is this chat's picked member. */
  attentionKey?: Maybe<Scalars['String']['output']>;
  lastPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmMemberMatch = {
  __typename?: 'ScoCrmMemberMatch';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  existingThreadId?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmModelOption = {
  __typename?: 'ScoCrmModelOption';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** The person who has waited longest for a reply in this queue, and the conversation to open. */
export type ScoCrmOldestOwed = {
  __typename?: 'ScoCrmOldestOwed';
  accountUserId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  memberUserId?: Maybe<Scalars['String']['output']>;
  owedSinceAt?: Maybe<Scalars['DateTime']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmPipelineEvent = {
  __typename?: 'ScoCrmPipelineEvent';
  actionKey?: Maybe<Scalars['String']['output']>;
  at?: Maybe<Scalars['DateTime']['output']>;
  inboundCommentId?: Maybe<Scalars['String']['output']>;
  outcomeKey?: Maybe<Scalars['String']['output']>;
  ruleName?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmPreviewField = {
  __typename?: 'ScoCrmPreviewField';
  key?: Maybe<Scalars['String']['output']>;
  referenced?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmPreviewStep = {
  __typename?: 'ScoCrmPreviewStep';
  detail?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmPromptSection = {
  __typename?: 'ScoCrmPromptSection';
  label?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/**
 * People in the queue by the attention of their lead conversation (V2-L14).
 * replyNeeded, draftReady, waiting and done are disjoint and sum to itemCount;
 * late and olderThan30d are owed people counted again.
 */
export type ScoCrmQueueCounts = {
  __typename?: 'ScoCrmQueueCounts';
  done?: Maybe<Scalars['Int']['output']>;
  draftReady?: Maybe<Scalars['Int']['output']>;
  late?: Maybe<Scalars['Int']['output']>;
  olderThan30d?: Maybe<Scalars['Int']['output']>;
  replyNeeded?: Maybe<Scalars['Int']['output']>;
  waiting?: Maybe<Scalars['Int']['output']>;
};

/**
 * CRM Reports (V2-L9) for one inbox or All inboxes over a range: are we answering
 * on time, how much did the AI help, who is waiting longest. Ids, counts and times
 * only. Current-state numbers come from the same reads and attention as the Inbox queue.
 */
export type ScoCrmReport = {
  __typename?: 'ScoCrmReport';
  /** The inbox reported on; null for All inboxes (the crmEnabled accounts the All inboxes queue reads). */
  accountUserId?: Maybe<Scalars['String']['output']>;
  aiHelp?: Maybe<ScoCrmReportAiHelp>;
  /** An owed conversation is late after this many minutes (CRM_LATE_HOURS, V2-L5). */
  lateAfterMinutes?: Maybe<Scalars['Int']['output']>;
  /**
   * The first five owed people in queue order (owed within 30 days first, longest
   * wait first, then people owed for more than 30 days), each with their lead conversation.
   */
  longestWaiting?: Maybe<Array<Maybe<ScoCrmWaitingPerson>>>;
  onTime?: Maybe<ScoCrmReportOnTime>;
  /** 7d, 30d or qtd. */
  range?: Maybe<Scalars['String']['output']>;
  /** End of the range (now). */
  rangeEndAt?: Maybe<Scalars['DateTime']['output']>;
  /** Start of the range: 7 or 30 days before now, or 00:00 UTC on the first day of the current calendar quarter. */
  rangeStartAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * How much did the AI help? From the draft edit tracking on the inboxes' responder
 * tools' runs (V2-L9), in range. One run per member message.
 */
export type ScoCrmReportAiHelp = {
  __typename?: 'ScoCrmReportAiHelp';
  /** AI drafts thrown away in range (Clear, or an emptied box) where no AI draft was then sent. */
  discarded?: Maybe<Scalars['Int']['output']>;
  /** Member messages whose AI draft was generated in range (latest generation). */
  draftsGenerated?: Maybe<Scalars['Int']['output']>;
  /**
   * Replies the rules pipeline sent on its own in range (system origin, Send
   * automatically) that were not recalled. Not counted in any field above.
   */
  sentAutomatically?: Maybe<Scalars['Int']['output']>;
  /** Desk sends in range of an AI draft with more than 15% changed. */
  sentHeavyEdit?: Maybe<Scalars['Int']['output']>;
  /** Desk sends in range of an AI draft with at most 15% of characters changed. */
  sentLightEdit?: Maybe<Scalars['Int']['output']>;
  /** Desk sends in range of an AI draft as written (not recalled). */
  sentUnchanged?: Maybe<Scalars['Int']['output']>;
  /**
   * Desk sends in range linked to a member message with no AI draft to compare
   * against (written by hand, including after a discard). Replies sent outside the
   * desk are not here; see onTime.repliesSent.
   */
  sentWithoutDraft?: Maybe<Scalars['Int']['output']>;
};

/**
 * Are we answering on time? The *Now fields are the Inbox counts at the time of
 * the request (people, by their lead conversation; lateNow and olderThan30dNow are
 * owed people counted again). The other fields cover the report range.
 */
export type ScoCrmReportOnTime = {
  __typename?: 'ScoCrmReportOnTime';
  /** How many of those replies answered an owed set (the sample behind medianFirstReplyMinutes). */
  firstRepliesCount?: Maybe<Scalars['Int']['output']>;
  /** Owed people waiting longer than lateAfterMinutes now. */
  lateNow?: Maybe<Scalars['Int']['output']>;
  /**
   * Median minutes from the first member message of the owed set a reply answered
   * to that reply, over replies in range that answered one. The owed set is the
   * member's messages since the previous staff reply, minus any a no-reply-needed
   * dismissal or support handoff had settled before the reply. Looks back at most
   * 100 messages before the range start per thread. Null when none.
   */
  medianFirstReplyMinutes?: Maybe<Scalars['Int']['output']>;
  /** Owed people whose wait began more than 30 days ago. */
  olderThan30dNow?: Maybe<Scalars['Int']['output']>;
  /** People owed a reply now (Reply needed plus Draft ready). */
  owedNow?: Maybe<Scalars['Int']['output']>;
  /**
   * Published, not withdrawn messages created in range by a staff author
   * (crmEnabled, sco admin or bot) who is not the member, on the inboxes' desk
   * conversations (direct chats of crmEnabled accounts with a member). Follow-ups count.
   */
  repliesSent?: Maybe<Scalars['Int']['output']>;
};

export type ScoCrmResponderTool = {
  __typename?: 'ScoCrmResponderTool';
  modelKey?: Maybe<Scalars['String']['output']>;
  modelOptions?: Maybe<Array<Maybe<ScoCrmModelOption>>>;
  sentAsName?: Maybe<Scalars['String']['output']>;
  sentAsUserId?: Maybe<Scalars['String']['output']>;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  toolId?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmRuleCheck = {
  __typename?: 'ScoCrmRuleCheck';
  actionKey?: Maybe<Scalars['String']['output']>;
  cardTitle?: Maybe<Scalars['String']['output']>;
  laneKey?: Maybe<Scalars['String']['output']>;
  ruleName?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  scoringLive?: Maybe<Scalars['Boolean']['output']>;
  steps?: Maybe<Array<Maybe<ScoCrmPreviewStep>>>;
  templateTitle?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmSavedReply = {
  __typename?: 'ScoCrmSavedReply';
  accountUserId?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  positionIndex?: Maybe<Scalars['Int']['output']>;
  savedReplyId?: Maybe<Scalars['String']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoCrmSwitches = {
  __typename?: 'ScoCrmSwitches';
  autoSendEnvOn?: Maybe<Scalars['Boolean']['output']>;
  draftsOn?: Maybe<Scalars['Boolean']['output']>;
  inboxAutoSend?: Maybe<Scalars['Boolean']['output']>;
  scoringLive?: Maybe<Scalars['Boolean']['output']>;
  teamAutoSend?: Maybe<Scalars['Boolean']['output']>;
};

export type ScoCrmThread = {
  __typename?: 'ScoCrmThread';
  accountDisplayName?: Maybe<Scalars['String']['output']>;
  accountPictureUrl?: Maybe<Scalars['String']['output']>;
  accountUserId?: Maybe<Scalars['String']['output']>;
  actionKey?: Maybe<Scalars['String']['output']>;
  assistanceMode?: Maybe<Scalars['Boolean']['output']>;
  attentionKey?: Maybe<Scalars['String']['output']>;
  commentsCount?: Maybe<Scalars['Int']['output']>;
  dismissReasonKey?: Maybe<Scalars['String']['output']>;
  dismissed?: Maybe<Scalars['Boolean']['output']>;
  dismissedByName?: Maybe<Scalars['String']['output']>;
  doneReasonKey?: Maybe<Scalars['String']['output']>;
  draftBlockedReasonKey?: Maybe<Scalars['String']['output']>;
  draftMissingFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  draftState?: Maybe<Scalars['String']['output']>;
  hasDraft?: Maybe<Scalars['Boolean']['output']>;
  isLate?: Maybe<Scalars['Boolean']['output']>;
  isLead?: Maybe<Scalars['Boolean']['output']>;
  laneKey?: Maybe<Scalars['String']['output']>;
  latestCommentAt?: Maybe<Scalars['DateTime']['output']>;
  latestCommentBody?: Maybe<Scalars['String']['output']>;
  latestCommentByUserId?: Maybe<Scalars['String']['output']>;
  latestCommentFileCount?: Maybe<Scalars['Int']['output']>;
  latestInboundCommentId?: Maybe<Scalars['String']['output']>;
  matchedCommentBody?: Maybe<Scalars['String']['output']>;
  memberDisplayName?: Maybe<Scalars['String']['output']>;
  memberPictureUrl?: Maybe<Scalars['String']['output']>;
  memberUserId?: Maybe<Scalars['String']['output']>;
  olderThan30d?: Maybe<Scalars['Boolean']['output']>;
  outcomeKey?: Maybe<Scalars['String']['output']>;
  overdue?: Maybe<Scalars['Boolean']['output']>;
  owedSinceAt?: Maybe<Scalars['DateTime']['output']>;
  participantUserIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  personKey?: Maybe<Scalars['String']['output']>;
  ruleName?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  supportHandedOff?: Maybe<Scalars['Boolean']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  threadTypeKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
  waitingMinutes?: Maybe<Scalars['Int']['output']>;
};

export type ScoCrmThreadComment = {
  __typename?: 'ScoCrmThreadComment';
  body?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  draftEdited?: Maybe<Scalars['Boolean']['output']>;
  draftGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  draftInboundCommentId?: Maybe<Scalars['String']['output']>;
  draftOrigin?: Maybe<Scalars['String']['output']>;
  draftReferences?: Maybe<Scalars['JSON']['output']>;
  draftSources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  originKey?: Maybe<Scalars['String']['output']>;
  storedFiles?: Maybe<Array<Maybe<ScoStoredFile>>>;
  withdrawnAt?: Maybe<Scalars['DateTime']['output']>;
  withdrawnByUserId?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmThreadRun = {
  __typename?: 'ScoCrmThreadRun';
  actionKey?: Maybe<Scalars['String']['output']>;
  cardTitle?: Maybe<Scalars['String']['output']>;
  checks?: Maybe<Array<Maybe<ScoCrmThreadRunCheck>>>;
  citedCardId?: Maybe<Scalars['String']['output']>;
  dismissReasonKey?: Maybe<Scalars['String']['output']>;
  dismissedAt?: Maybe<Scalars['String']['output']>;
  dismissedByName?: Maybe<Scalars['String']['output']>;
  draftModeKey?: Maybe<Scalars['String']['output']>;
  inboundCommentId?: Maybe<Scalars['String']['output']>;
  laneKey?: Maybe<Scalars['String']['output']>;
  matchedRuleName?: Maybe<Scalars['String']['output']>;
  matchedToolRuleId?: Maybe<Scalars['String']['output']>;
  missingKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  operatorLaneKey?: Maybe<Scalars['String']['output']>;
  operatorPacket?: Maybe<Scalars['String']['output']>;
  outcomeKey?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  replyIncomplete?: Maybe<Scalars['Boolean']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  shadow?: Maybe<Scalars['Boolean']['output']>;
  suggestedBody?: Maybe<Scalars['String']['output']>;
  suggestionSourceKey?: Maybe<Scalars['String']['output']>;
  suggestionSourceLabel?: Maybe<Scalars['String']['output']>;
  templateTitle?: Maybe<Scalars['String']['output']>;
  toolId?: Maybe<Scalars['String']['output']>;
  toolReplyTemplateId?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
  toolRuleRunId?: Maybe<Scalars['String']['output']>;
  winnerName?: Maybe<Scalars['String']['output']>;
  winnerSourceKey?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmThreadRunCheck = {
  __typename?: 'ScoCrmThreadRunCheck';
  name?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmThreadTranscript = {
  __typename?: 'ScoCrmThreadTranscript';
  assistanceMode?: Maybe<Scalars['Boolean']['output']>;
  attentionKey?: Maybe<Scalars['String']['output']>;
  claimExpiresAt?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<Maybe<ScoCrmThreadComment>>>;
  doneReasonKey?: Maybe<Scalars['String']['output']>;
  draftBlockedReasonKey?: Maybe<Scalars['String']['output']>;
  draftGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  draftMissingFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  draftReferences?: Maybe<Scalars['JSON']['output']>;
  draftSources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  draftState?: Maybe<Scalars['String']['output']>;
  draftingBlockedReason?: Maybe<Scalars['String']['output']>;
  isLate?: Maybe<Scalars['Boolean']['output']>;
  lateAfterMinutes?: Maybe<Scalars['Int']['output']>;
  latestInboundCommentId?: Maybe<Scalars['String']['output']>;
  latestRun?: Maybe<ScoCrmThreadRun>;
  olderThan30d?: Maybe<Scalars['Boolean']['output']>;
  owedSinceAt?: Maybe<Scalars['DateTime']['output']>;
  ownedByViewer?: Maybe<Scalars['Boolean']['output']>;
  ownerDisplayName?: Maybe<Scalars['String']['output']>;
  ownerUserId?: Maybe<Scalars['String']['output']>;
  pipelineEvents?: Maybe<Array<Maybe<ScoCrmPipelineEvent>>>;
  refreshedAt?: Maybe<Scalars['String']['output']>;
  savedReplies?: Maybe<Scalars['JSON']['output']>;
  supportOpen?: Maybe<Scalars['Boolean']['output']>;
  supportTicketId?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  threadTypeKey?: Maybe<Scalars['String']['output']>;
  waitingMinutes?: Maybe<Scalars['Int']['output']>;
};

export type ScoCrmToolSession = {
  __typename?: 'ScoCrmToolSession';
  threadId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  toolId?: Maybe<Scalars['String']['output']>;
  toolSessionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoCrmToolSessionPage = {
  __typename?: 'ScoCrmToolSessionPage';
  itemCount?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  sessions?: Maybe<Array<Maybe<ScoCrmToolSession>>>;
};

/** A person owed a reply, with the lead conversation to open. */
export type ScoCrmWaitingPerson = {
  __typename?: 'ScoCrmWaitingPerson';
  accountUserId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  memberUserId?: Maybe<Scalars['String']['output']>;
  owedSinceAt?: Maybe<Scalars['DateTime']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  waitingMinutes?: Maybe<Scalars['Int']['output']>;
};

export type ScoCrmWritingNote = {
  __typename?: 'ScoCrmWritingNote';
  body?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScoCustomerChannel = ScoNode & {
  __typename?: 'ScoCustomerChannel';
  composite?: Maybe<Scalars['Int']['output']>;
  compoundsScore?: Maybe<Scalars['Int']['output']>;
  confidenceScore?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerChannelId?: Maybe<Scalars['String']['output']>;
  customerProfileId?: Maybe<Scalars['String']['output']>;
  customerSearchId?: Maybe<Scalars['String']['output']>;
  easeScore?: Maybe<Scalars['Int']['output']>;
  experiments?: Maybe<ScoCustomerExperimentCollection>;
  fitScore?: Maybe<Scalars['Int']['output']>;
  howToReach?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isStartHere?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parkReason?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  statusKey?: Maybe<Scalars['String']['output']>;
  typeKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  whyThisChannel?: Maybe<Scalars['String']['output']>;
};


export type ScoCustomerChannelExperimentsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoCustomerChannelCollection = {
  __typename?: 'ScoCustomerChannelCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoCustomerChannel>>;
  pagination: Pagination;
};

export type ScoCustomerExperiment = ScoNode & {
  __typename?: 'ScoCustomerExperiment';
  actionText?: Maybe<Scalars['String']['output']>;
  checkins?: Maybe<ScoCustomerExperimentCheckinCollection>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentAnalysis?: Maybe<ScoCustomerExperimentAnalysis>;
  customerChannelId?: Maybe<Scalars['String']['output']>;
  customerChannelMessageId?: Maybe<Scalars['String']['output']>;
  customerChannelOpenerId?: Maybe<Scalars['String']['output']>;
  customerExperimentId?: Maybe<Scalars['String']['output']>;
  customerProfileId?: Maybe<Scalars['String']['output']>;
  customerSearchId?: Maybe<Scalars['String']['output']>;
  customerSearchRunId?: Maybe<Scalars['String']['output']>;
  firstActionAt?: Maybe<Scalars['DateTime']['output']>;
  hypothesis?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  learnByAt?: Maybe<Scalars['DateTime']['output']>;
  metricSlots?: Maybe<Array<Maybe<ScoCustomerExperimentMetricSlot>>>;
  plannedDurationDays?: Maybe<Scalars['Int']['output']>;
  plannedSpendText?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  recipeKey?: Maybe<Scalars['String']['output']>;
  startKitText?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  statusKey?: Maybe<Scalars['String']['output']>;
  successText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ScoCustomerExperimentCheckinsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoCustomerExperimentAnalysis = ScoNode & {
  __typename?: 'ScoCustomerExperimentAnalysis';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  acceptedByUserId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerExperimentAnalysisId?: Maybe<Scalars['String']['output']>;
  customerExperimentId?: Maybe<Scalars['String']['output']>;
  customerSearchRunId?: Maybe<Scalars['String']['output']>;
  diagnosisKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  narrative?: Maybe<Scalars['String']['output']>;
  nextPlayKey?: Maybe<Scalars['String']['output']>;
  slotAssessments?: Maybe<Array<Maybe<ScoCustomerExperimentSlotAssessment>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verdictKey?: Maybe<Scalars['String']['output']>;
};

export type ScoCustomerExperimentCheckin = ScoNode & {
  __typename?: 'ScoCustomerExperimentCheckin';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerExperimentCheckinId?: Maybe<Scalars['String']['output']>;
  customerExperimentId?: Maybe<Scalars['String']['output']>;
  evidenceUrl?: Maybe<Scalars['String']['output']>;
  executionKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kindKey?: Maybe<Scalars['String']['output']>;
  loggedAt?: Maybe<Scalars['DateTime']['output']>;
  loggedByUserId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  observations?: Maybe<Array<Maybe<ScoCustomerExperimentObservation>>>;
  successTextSnapshot?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoCustomerExperimentCheckinCollection = {
  __typename?: 'ScoCustomerExperimentCheckinCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoCustomerExperimentCheckin>>;
  pagination: Pagination;
};

export type ScoCustomerExperimentCollection = {
  __typename?: 'ScoCustomerExperimentCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoCustomerExperiment>>;
  pagination: Pagination;
};

export type ScoCustomerExperimentMetricSlot = ScoNode & {
  __typename?: 'ScoCustomerExperimentMetricSlot';
  comparatorKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerExperimentId?: Maybe<Scalars['String']['output']>;
  customerExperimentMetricSlotId?: Maybe<Scalars['String']['output']>;
  howToCount?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  kindKey?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  targetNumber?: Maybe<Scalars['Float']['output']>;
  targetText?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoCustomerExperimentMetricSlotInput = {
  comparatorKey?: InputMaybe<Scalars['String']['input']>;
  customerExperimentMetricSlotId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  howToCount?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  kindKey?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  targetNumber?: InputMaybe<Scalars['Float']['input']>;
  targetText?: InputMaybe<Scalars['String']['input']>;
};

export type ScoCustomerExperimentObservation = ScoNode & {
  __typename?: 'ScoCustomerExperimentObservation';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerExperimentCheckinId?: Maybe<Scalars['String']['output']>;
  customerExperimentMetricSlotId?: Maybe<Scalars['String']['output']>;
  customerExperimentObservationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  valueNumber?: Maybe<Scalars['Float']['output']>;
  valueText?: Maybe<Scalars['String']['output']>;
  valueYes?: Maybe<Scalars['Boolean']['output']>;
};

export type ScoCustomerExperimentObservationInput = {
  customerExperimentMetricSlotId?: InputMaybe<Scalars['String']['input']>;
  valueNumber?: InputMaybe<Scalars['Float']['input']>;
  valueText?: InputMaybe<Scalars['String']['input']>;
  valueYes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoCustomerExperimentSlotAssessment = ScoNode & {
  __typename?: 'ScoCustomerExperimentSlotAssessment';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerExperimentAnalysisId?: Maybe<Scalars['String']['output']>;
  customerExperimentMetricSlotId?: Maybe<Scalars['String']['output']>;
  customerExperimentSlotAssessmentId?: Maybe<Scalars['String']['output']>;
  hitKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  observedNumber?: Maybe<Scalars['Float']['output']>;
  observedText?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoCustomerKnownIntakeGap = {
  __typename?: 'ScoCustomerKnownIntakeGap';
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ScoCustomerProfile = ScoNode & {
  __typename?: 'ScoCustomerProfile';
  adopterChangedFrom?: Maybe<Scalars['String']['output']>;
  adopterHeadline?: Maybe<Scalars['String']['output']>;
  adopterRatings?: Maybe<Array<Maybe<ScoCustomerProfileAdopterRating>>>;
  adopterRefinedHeadline?: Maybe<Scalars['String']['output']>;
  adopterSignals?: Maybe<Array<Maybe<ScoCustomerProfileAdopterSignal>>>;
  adopterWhyChanged?: Maybe<Scalars['String']['output']>;
  assumptions?: Maybe<Array<Maybe<ScoCustomerProfileAssumption>>>;
  basics?: Maybe<Array<Maybe<ScoCustomerProfileBasic>>>;
  budgetRange?: Maybe<Scalars['String']['output']>;
  champion?: Maybe<Scalars['String']['output']>;
  channels?: Maybe<ScoCustomerChannelCollection>;
  companyId?: Maybe<Scalars['String']['output']>;
  contexts?: Maybe<Array<Maybe<ScoCustomerProfileContext>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerProfileId?: Maybe<Scalars['String']['output']>;
  customerSearchId?: Maybe<Scalars['String']['output']>;
  customerSegmentId?: Maybe<Scalars['String']['output']>;
  evaluationProcess?: Maybe<Scalars['String']['output']>;
  experiments?: Maybe<ScoCustomerExperimentCollection>;
  firstAction?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  heroCaption?: Maybe<Scalars['String']['output']>;
  heroFigure?: Maybe<Scalars['String']['output']>;
  heroNote?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kindKey?: Maybe<Scalars['String']['output']>;
  mustHaves?: Maybe<Array<Maybe<ScoCustomerProfileMustHave>>>;
  name?: Maybe<Scalars['String']['output']>;
  objections?: Maybe<Array<Maybe<ScoCustomerProfileObjection>>>;
  pains?: Maybe<Array<Maybe<ScoCustomerProfilePain>>>;
  qualifyingChecks?: Maybe<Array<Maybe<ScoCustomerProfileQualifyingCheck>>>;
  shareToken?: Maybe<Scalars['String']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  statusKey?: Maybe<Scalars['String']['output']>;
  triggers?: Maybe<Array<Maybe<ScoCustomerProfileTrigger>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  validateFirst?: Maybe<Scalars['String']['output']>;
};


export type ScoCustomerProfileChannelsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoCustomerProfileExperimentsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoCustomerProfileAdopterRating = {
  __typename?: 'ScoCustomerProfileAdopterRating';
  customerProfileAdopterRatingId?: Maybe<Scalars['String']['output']>;
  dimensionKey?: Maybe<Scalars['String']['output']>;
  ratingKey?: Maybe<Scalars['String']['output']>;
  why?: Maybe<Scalars['String']['output']>;
};

export type ScoCustomerProfileAdopterSignal = {
  __typename?: 'ScoCustomerProfileAdopterSignal';
  customerProfileAdopterSignalId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ScoCustomerProfileAssumption = {
  __typename?: 'ScoCustomerProfileAssumption';
  assumption?: Maybe<Scalars['String']['output']>;
  confidenceKey?: Maybe<Scalars['String']['output']>;
  customerProfileAssumptionId?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type ScoCustomerProfileBasic = {
  __typename?: 'ScoCustomerProfileBasic';
  customerProfileBasicId?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ScoCustomerProfileCollection = {
  __typename?: 'ScoCustomerProfileCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoCustomerProfile>>;
  pagination: Pagination;
};

export type ScoCustomerProfileContext = {
  __typename?: 'ScoCustomerProfileContext';
  customerProfileContextId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ScoCustomerProfileMustHave = {
  __typename?: 'ScoCustomerProfileMustHave';
  customerProfileMustHaveId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ScoCustomerProfileObjection = {
  __typename?: 'ScoCustomerProfileObjection';
  customerProfileObjectionId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ScoCustomerProfilePain = {
  __typename?: 'ScoCustomerProfilePain';
  customerProfilePainId?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  voice?: Maybe<Scalars['String']['output']>;
};

export type ScoCustomerProfileQualifyingCheck = {
  __typename?: 'ScoCustomerProfileQualifyingCheck';
  checkText?: Maybe<Scalars['String']['output']>;
  customerProfileQualifyingCheckId?: Maybe<Scalars['String']['output']>;
  dimensionKey?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type ScoCustomerProfileShare = {
  __typename?: 'ScoCustomerProfileShare';
  customerProfileId?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ScoCustomerProfileTrigger = {
  __typename?: 'ScoCustomerProfileTrigger';
  customerProfileTriggerId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ScoCustomerSearch = ScoNode & {
  __typename?: 'ScoCustomerSearch';
  audience?: Maybe<Scalars['String']['output']>;
  company?: Maybe<ScoCompany>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  currentStepKey?: Maybe<Scalars['String']['output']>;
  customerSearchId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasSegments?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  intakeAdvantage?: Maybe<Scalars['String']['output']>;
  intakeGoal?: Maybe<Scalars['String']['output']>;
  intakeProblemWho?: Maybe<Scalars['String']['output']>;
  intakeSell?: Maybe<Scalars['String']['output']>;
  intakeTraction?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  latestRunId?: Maybe<Scalars['String']['output']>;
  oneLiner?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  perfectedPitch?: Maybe<Scalars['String']['output']>;
  problem?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  productAudienceStatement?: Maybe<Scalars['String']['output']>;
  profileCount?: Maybe<Scalars['Int']['output']>;
  profiles?: Maybe<ScoCustomerProfileCollection>;
  runs?: Maybe<ScoCustomerSearchRunCollection>;
  seeds?: Maybe<Array<Maybe<ScoCustomerSearchSeed>>>;
  segments?: Maybe<ScoCustomerSegmentCollection>;
  selectedChannelCount?: Maybe<Scalars['Int']['output']>;
  signupRequest?: Maybe<ScoSignupRequest>;
  signupRequestId?: Maybe<Scalars['String']['output']>;
  siteDescription?: Maybe<Scalars['String']['output']>;
  siteFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  siteHeadline?: Maybe<Scalars['String']['output']>;
  siteSnippet?: Maybe<Scalars['String']['output']>;
  siteTitle?: Maybe<Scalars['String']['output']>;
  siteUrl?: Maybe<Scalars['String']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  statusKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type ScoCustomerSearchProfilesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoCustomerSearchRunsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoCustomerSearchSegmentsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoCustomerSearchCollection = {
  __typename?: 'ScoCustomerSearchCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoCustomerSearch>>;
  pagination: Pagination;
};

export type ScoCustomerSearchRun = ScoNode & {
  __typename?: 'ScoCustomerSearchRun';
  aiAction?: Maybe<ScoAiAction>;
  aiActionId?: Maybe<Scalars['String']['output']>;
  builtFromRunId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerProfileId?: Maybe<Scalars['String']['output']>;
  customerSearchId?: Maybe<Scalars['String']['output']>;
  customerSearchRunId?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Array<Maybe<ScoCustomerSearchRunNote>>>;
  statusKey?: Maybe<Scalars['String']['output']>;
  stepKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoCustomerSearchRunCollection = {
  __typename?: 'ScoCustomerSearchRunCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoCustomerSearchRun>>;
  pagination: Pagination;
};

export type ScoCustomerSearchRunNote = ScoNode & {
  __typename?: 'ScoCustomerSearchRunNote';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerSearchRunId?: Maybe<Scalars['String']['output']>;
  customerSearchRunNoteId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  typeKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoCustomerSearchSeed = ScoNode & {
  __typename?: 'ScoCustomerSearchSeed';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerSearchId?: Maybe<Scalars['String']['output']>;
  customerSearchSeedId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kindKey?: Maybe<Scalars['String']['output']>;
  phrase?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoCustomerSearchUpdatedSubscriptionPayload = {
  __typename?: 'ScoCustomerSearchUpdatedSubscriptionPayload';
  customerSearch?: Maybe<ScoCustomerSearch>;
  customerSearchId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ScoCustomerSegment = ScoNode & {
  __typename?: 'ScoCustomerSegment';
  composite?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerSearchId?: Maybe<Scalars['String']['output']>;
  customerSearchRunId?: Maybe<Scalars['String']['output']>;
  customerSegmentId?: Maybe<Scalars['String']['output']>;
  firstValidation?: Maybe<Scalars['String']['output']>;
  icpSeed?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isLatent?: Maybe<Scalars['Boolean']['output']>;
  isStartHere?: Maybe<Scalars['Boolean']['output']>;
  marketSize?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oneLiner?: Maybe<Scalars['String']['output']>;
  painIntensity?: Maybe<Scalars['Int']['output']>;
  painPoints?: Maybe<Array<Maybe<ScoCustomerSegmentPainPoint>>>;
  position?: Maybe<Scalars['Int']['output']>;
  profileText?: Maybe<Scalars['String']['output']>;
  reachability?: Maybe<Scalars['Int']['output']>;
  rightToWin?: Maybe<Scalars['Int']['output']>;
  sizeText?: Maybe<Scalars['String']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  startHereReason?: Maybe<Scalars['String']['output']>;
  statusKey?: Maybe<Scalars['String']['output']>;
  surpriseNote?: Maybe<Scalars['String']['output']>;
  techOrContext?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  whyTheyFit?: Maybe<Scalars['String']['output']>;
  willingnessToPay?: Maybe<Scalars['Int']['output']>;
};

export type ScoCustomerSegmentCollection = {
  __typename?: 'ScoCustomerSegmentCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoCustomerSegment>>;
  pagination: Pagination;
};

export type ScoCustomerSegmentPainPoint = ScoNode & {
  __typename?: 'ScoCustomerSegmentPainPoint';
  customerSegmentId?: Maybe<Scalars['String']['output']>;
  customerSegmentPainPointId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ScoEmailMessage = ScoNode & {
  __typename?: 'ScoEmailMessage';
  bcc?: Maybe<Scalars['String']['output']>;
  bodyAsHtml?: Maybe<Scalars['String']['output']>;
  bodyAsText?: Maybe<Scalars['String']['output']>;
  bouncedAt?: Maybe<Scalars['DateTime']['output']>;
  cc?: Maybe<Scalars['String']['output']>;
  clickedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  emailMessageEvents?: Maybe<Array<Maybe<ScoEmailMessageEvent>>>;
  emailMessageId?: Maybe<Scalars['String']['output']>;
  emailRecipients?: Maybe<Array<Maybe<ScoEmailRecipient>>>;
  emailSender?: Maybe<ScoEmailSender>;
  emailSenderId?: Maybe<Scalars['String']['output']>;
  errorMessages?: Maybe<Scalars['String']['output']>;
  errorMessagesExplanation?: Maybe<Scalars['String']['output']>;
  failedSendAt?: Maybe<Scalars['DateTime']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  fromUser?: Maybe<ScoUser>;
  fromUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  outboundRoute?: Maybe<Scalars['String']['output']>;
  relatedModelId?: Maybe<Scalars['String']['output']>;
  relatedModelType?: Maybe<Scalars['String']['output']>;
  replyReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  scheduledToSendAt?: Maybe<Scalars['DateTime']['output']>;
  sendStatus?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentByIpAddress?: Maybe<Scalars['String']['output']>;
  sentByUser?: Maybe<ScoUser>;
  sentByUserId?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  templateKey?: Maybe<Scalars['String']['output']>;
  templatePropsAsJson?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  toUser?: Maybe<ScoUser>;
  toUserId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ScoEmailMessageErrorMessagesExplanationArgs = {
  regenerate?: InputMaybe<Scalars['Boolean']['input']>;
  regenerateIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoEmailMessageCollection = {
  __typename?: 'ScoEmailMessageCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoEmailMessage>>;
  pagination: Pagination;
};

export type ScoEmailMessageEvent = ScoNode & {
  __typename?: 'ScoEmailMessageEvent';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<ScoUser>;
  createdByUserAgent?: Maybe<Scalars['String']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  emailMessage?: Maybe<ScoEmailMessage>;
  emailMessageEventId?: Maybe<Scalars['String']['output']>;
  emailMessageId?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  eventUrl?: Maybe<Scalars['String']['output']>;
  headersAsJson?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoEmailRecipient = ScoNode & {
  __typename?: 'ScoEmailRecipient';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailMessageId?: Maybe<Scalars['String']['output']>;
  emailRecipientId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  recipientType?: Maybe<Scalars['String']['output']>;
  relatedModelId?: Maybe<Scalars['String']['output']>;
  relatedModelType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoEmailSender = ScoNode & {
  __typename?: 'ScoEmailSender';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailEngineAccessToken?: Maybe<Scalars['String']['output']>;
  emailEngineAccountAsJson?: Maybe<Scalars['String']['output']>;
  emailEngineAccountId?: Maybe<Scalars['String']['output']>;
  emailEngineAccountLastError?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  emailEngineAccountState?: Maybe<Scalars['String']['output']>;
  emailEngineAccountType?: Maybe<Scalars['String']['output']>;
  emailEngineDeliveryTestAsJson?: Maybe<Scalars['String']['output']>;
  emailEngineDeliveryTestAt?: Maybe<Scalars['DateTime']['output']>;
  emailEngineDeliveryTestId?: Maybe<Scalars['String']['output']>;
  emailEngineDeliveryTestPassed?: Maybe<Scalars['Boolean']['output']>;
  emailProviderKey?: Maybe<Scalars['String']['output']>;
  emailSenderId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imapHost?: Maybe<Scalars['String']['output']>;
  imapIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  imapPassword?: Maybe<Scalars['String']['output']>;
  imapPasswordHash?: Maybe<Scalars['String']['output']>;
  imapPasswordIsSet?: Maybe<Scalars['Boolean']['output']>;
  imapPort?: Maybe<Scalars['Int']['output']>;
  imapSsl?: Maybe<Scalars['Boolean']['output']>;
  imapUsername?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isHealthy?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  smtpHost?: Maybe<Scalars['String']['output']>;
  smtpIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  smtpPassword?: Maybe<Scalars['String']['output']>;
  smtpPasswordHash?: Maybe<Scalars['String']['output']>;
  smtpPasswordIsSet?: Maybe<Scalars['Boolean']['output']>;
  smtpPort?: Maybe<Scalars['Int']['output']>;
  smtpSsl?: Maybe<Scalars['Boolean']['output']>;
  smtpUsername?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoEmailSenderCollection = {
  __typename?: 'ScoEmailSenderCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoEmailSender>>;
  pagination: Pagination;
};

export type ScoEmptyFieldedQuery = {
  __typename?: 'ScoEmptyFieldedQuery';
  field?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ScoEmptyType = ScoNode & {
  __typename?: 'ScoEmptyType';
  id: Scalars['ID']['output'];
};

export type ScoEmptyTypeCollection = {
  __typename?: 'ScoEmptyTypeCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoEmptyType>>;
  pagination: Pagination;
};

export type ScoFlag = ScoNode & {
  __typename?: 'ScoFlag';
  comment?: Maybe<ScoComment>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<ScoUser>;
  deletedByUser?: Maybe<ScoUser>;
  flagId?: Maybe<Scalars['String']['output']>;
  flaggableId?: Maybe<Scalars['String']['output']>;
  flaggableType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<ScoThread>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoFlagCollection = {
  __typename?: 'ScoFlagCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoFlag>>;
  pagination: Pagination;
};

export type ScoFollow = ScoNode & {
  __typename?: 'ScoFollow';
  comment?: Maybe<ScoComment>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<ScoUser>;
  followId?: Maybe<Scalars['String']['output']>;
  followable?: Maybe<ScoAttachment>;
  followableId?: Maybe<Scalars['String']['output']>;
  followableType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  thread?: Maybe<ScoThread>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
};

export type ScoFollowCollection = {
  __typename?: 'ScoFollowCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoFollow>>;
  pagination: Pagination;
};

export type ScoInboxThread = ScoNode & {
  __typename?: 'ScoInboxThread';
  counterpartDisplayName?: Maybe<Scalars['String']['output']>;
  counterpartFullName?: Maybe<Scalars['String']['output']>;
  counterpartPictureUrl?: Maybe<Scalars['String']['output']>;
  counterpartUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  threadTypeKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  toolTitle?: Maybe<Scalars['String']['output']>;
  unreadCommentsCount?: Maybe<Scalars['Int']['output']>;
};

export type ScoInboxThreadCollection = {
  __typename?: 'ScoInboxThreadCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoInboxThread>>;
  pagination: Pagination;
};

export type ScoInboxThreadSubscriptionPayload = {
  __typename?: 'ScoInboxThreadSubscriptionPayload';
  counterpartDisplayName?: Maybe<Scalars['String']['output']>;
  counterpartFullName?: Maybe<Scalars['String']['output']>;
  counterpartPictureUrl?: Maybe<Scalars['String']['output']>;
  counterpartUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  threadTypeKey?: Maybe<Scalars['String']['output']>;
  toolTitle?: Maybe<Scalars['String']['output']>;
  unreadCommentsCount?: Maybe<Scalars['Int']['output']>;
};

/** The industry of companies. */
export type ScoIndustry = ScoNode & {
  __typename?: 'ScoIndustry';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industryId?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScoInvestorMatch = ScoNode & {
  __typename?: 'ScoInvestorMatch';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  directChatThread?: Maybe<ScoThread>;
  id: Scalars['ID']['output'];
  investorMatchId?: Maybe<Scalars['String']['output']>;
  investorSearch?: Maybe<ScoInvestorSearch>;
  investorSearchId?: Maybe<Scalars['String']['output']>;
  matchExplanation?: Maybe<Scalars['String']['output']>;
  matchFactors?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  matchFactorsAsJSON?: Maybe<Scalars['String']['output']>;
  matchScore?: Maybe<Scalars['Int']['output']>;
  matchScoreAsPercent?: Maybe<Scalars['Float']['output']>;
  ratingBySearchingUser?: Maybe<Scalars['Int']['output']>;
  ratingNoteBySearchingUser?: Maybe<Scalars['String']['output']>;
  savedBySearchingUserAt?: Maybe<Scalars['DateTime']['output']>;
  searchingUser?: Maybe<ScoUser>;
  searchingUserId?: Maybe<Scalars['String']['output']>;
  targetInvestorProfile?: Maybe<ScoInvestorProfile>;
  targetInvestorProfileDistanceInMiles?: Maybe<Scalars['Int']['output']>;
  targetInvestorProfileId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ScoInvestorMatchDirectChatThreadArgs = {
  createIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoInvestorMatchMatchExplanationArgs = {
  generate?: InputMaybe<Scalars['Boolean']['input']>;
  generateIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoInvestorMatchCollection = {
  __typename?: 'ScoInvestorMatchCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoInvestorMatch>>;
  pagination: Pagination;
};

export type ScoInvestorMessage = ScoNode & {
  __typename?: 'ScoInvestorMessage';
  bodyAsMarkdown?: Maybe<Scalars['String']['output']>;
  bodyPrompt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  emailMessage?: Maybe<ScoEmailMessage>;
  emailMessages?: Maybe<ScoEmailMessageCollection>;
  emailSender?: Maybe<ScoEmailSender>;
  emailSenderId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  investorMatch?: Maybe<ScoInvestorMatch>;
  investorMatchId?: Maybe<Scalars['String']['output']>;
  investorMessageId?: Maybe<Scalars['String']['output']>;
  investorProfile?: Maybe<ScoInvestorProfile>;
  investorProfileContact?: Maybe<ScoInvestorProfileContact>;
  investorProfileContactId?: Maybe<Scalars['String']['output']>;
  investorProfileMatchId?: Maybe<Scalars['String']['output']>;
  investorSearch?: Maybe<ScoInvestorSearch>;
  investorSearchId?: Maybe<Scalars['String']['output']>;
  scheduledToSendAt?: Maybe<Scalars['DateTime']['output']>;
  sendingUser?: Maybe<ScoUser>;
  sendingUserId?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ScoInvestorMessageEmailMessagesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoInvestorMessageCollection = {
  __typename?: 'ScoInvestorMessageCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoInvestorMessage>>;
  pagination: Pagination;
};

/** Investor-message sends counted against the plan’s daily cap (rolling window). */
export type ScoInvestorMessageUsage = {
  __typename?: 'ScoInvestorMessageUsage';
  /** True when used >= limit. */
  isLimitReached: Scalars['Boolean']['output'];
  /** Plan cap per window (0 without an investor-messaging plan). */
  limit: Scalars['Int']['output'];
  /** Sends left in the window (0 when exhausted). */
  remaining: Scalars['Int']['output'];
  /** When the oldest counted send leaves the window. */
  resetsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Sends scheduled in the window, including queued ones. */
  used: Scalars['Int']['output'];
  /** Length of the rolling window in hours. */
  windowHours: Scalars['Int']['output'];
};

export type ScoInvestorProfile = ScoNode & {
  __typename?: 'ScoInvestorProfile';
  airtableDataAsJSON?: Maybe<Scalars['String']['output']>;
  applicationUrl?: Maybe<Scalars['String']['output']>;
  crunchbaseRank?: Maybe<Scalars['Int']['output']>;
  crunchbaseUrl?: Maybe<Scalars['String']['output']>;
  currentUserHasRequested?: Maybe<Scalars['Boolean']['output']>;
  currentUserHasSaved?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  dryPowderInDollars?: Maybe<Scalars['Float']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  fullDescription?: Maybe<Scalars['String']['output']>;
  hqLatitude?: Maybe<Scalars['Float']['output']>;
  hqLocation?: Maybe<Scalars['String']['output']>;
  hqLocationCity?: Maybe<Scalars['String']['output']>;
  hqLocationCountry?: Maybe<Scalars['String']['output']>;
  hqLocationRegion?: Maybe<Scalars['String']['output']>;
  hqLocationState?: Maybe<Scalars['String']['output']>;
  hqLongitude?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  investmentStages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  investorProfileContacts?: Maybe<Array<Maybe<ScoInvestorProfileContact>>>;
  investorProfileId?: Maybe<Scalars['String']['output']>;
  investorProfileTags?: Maybe<Array<Maybe<ScoInvestorProfileTag>>>;
  investorTags?: Maybe<Array<Maybe<ScoInvestorTag>>>;
  investorTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  maxFundSizeInDollars?: Maybe<Scalars['Float']['output']>;
  maximumDealSizeInDollars?: Maybe<Scalars['Float']['output']>;
  maximumInvestmentInDollars?: Maybe<Scalars['Float']['output']>;
  minimumDealSizeInDollars?: Maybe<Scalars['Float']['output']>;
  minimumInvestmentInDollars?: Maybe<Scalars['Float']['output']>;
  pitchbookUrl?: Maybe<Scalars['String']['output']>;
  preferredIndustries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  preferredIndustriesAndVerticals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  preferredVerticals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primaryInvestorProfileContact?: Maybe<ScoInvestorProfileContact>;
  primaryInvestorType?: Maybe<Scalars['String']['output']>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  suggestedForUser?: Maybe<Scalars['Boolean']['output']>;
  suggestedForUserMatchScore?: Maybe<Scalars['Int']['output']>;
  suggestedForUserReasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  totalInvestmentsCount?: Maybe<Scalars['Int']['output']>;
  totalInvestmentsTTMCount?: Maybe<Scalars['Int']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};


export type ScoInvestorProfileInvestorProfileContactsArgs = {
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhone?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
};


export type ScoInvestorProfileInvestorProfileTagsArgs = {
  investorTagTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ScoInvestorProfileInvestorTagsArgs = {
  investorTagTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ScoInvestorProfileCollection = {
  __typename?: 'ScoInvestorProfileCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoInvestorProfile>>;
  pagination: Pagination;
};

export type ScoInvestorProfileContact = ScoNode & {
  __typename?: 'ScoInvestorProfileContact';
  alternateEmail?: Maybe<Scalars['String']['output']>;
  alternatePhone?: Maybe<Scalars['String']['output']>;
  bestContactMethods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bouncedEmailMessageEventsCount?: Maybe<Scalars['Int']['output']>;
  currentUserHasRequested?: Maybe<Scalars['Boolean']['output']>;
  currentUserHasSaved?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailReputationScore?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  indexPosition?: Maybe<Scalars['Int']['output']>;
  investorProfile?: Maybe<ScoInvestorProfile>;
  investorProfileContactId?: Maybe<Scalars['String']['output']>;
  investorProfileId?: Maybe<Scalars['String']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  positionLevels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  replyCount?: Maybe<Scalars['Int']['output']>;
  replyToneScore?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScoInvestorProfileSearchOptions = {
  __typename?: 'ScoInvestorProfileSearchOptions';
  allCountries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  allIndustries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  allIndustriesAndVerticals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  allInvestmentStages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  allInvestorTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  allRegions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  allVerticals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  popularIndustries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  popularIndustriesAndVerticals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  popularVerticals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ScoInvestorProfileTag = ScoNode & {
  __typename?: 'ScoInvestorProfileTag';
  id: Scalars['ID']['output'];
  investorProfile?: Maybe<ScoInvestorProfile>;
  investorProfileId?: Maybe<Scalars['String']['output']>;
  investorProfileTagId?: Maybe<Scalars['String']['output']>;
  investorTag?: Maybe<ScoInvestorTag>;
  investorTagId?: Maybe<Scalars['String']['output']>;
};

export type ScoInvestorSearch = ScoNode & {
  __typename?: 'ScoInvestorSearch';
  companyElevatorPitch?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyWebsiteUrl?: Maybe<Scalars['String']['output']>;
  competitionStatement?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  emailSender?: Maybe<ScoEmailSender>;
  emailSenderId?: Maybe<Scalars['String']['output']>;
  emailTemplateAttachmentUrl?: Maybe<Scalars['String']['output']>;
  emailTemplateFrom?: Maybe<Scalars['String']['output']>;
  emailTemplateGeneratedBody?: Maybe<Scalars['String']['output']>;
  emailTemplatePrompt?: Maybe<Scalars['String']['output']>;
  emailTemplateSignature?: Maybe<Scalars['String']['output']>;
  emailTemplateSubject?: Maybe<Scalars['String']['output']>;
  financialsStatement?: Maybe<Scalars['String']['output']>;
  fundingGoalInDollars?: Maybe<Scalars['Int']['output']>;
  fundingGoalStage?: Maybe<ScoStaticOption>;
  fundingGoalStageKey?: Maybe<Scalars['String']['output']>;
  fundingGoalStatement?: Maybe<Scalars['String']['output']>;
  fundingGoalStructureKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fundingGoalStructures?: Maybe<Array<Maybe<ScoStaticOption>>>;
  groupRequest?: Maybe<GroupRequest>;
  id: Scalars['ID']['output'];
  investorMatches?: Maybe<ScoInvestorMatchCollection>;
  investorMatchesCount?: Maybe<Scalars['Int']['output']>;
  investorSearchId?: Maybe<Scalars['String']['output']>;
  investorSearchTags?: Maybe<Array<Maybe<ScoInvestorSearchTag>>>;
  investorTagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  investorTags?: Maybe<Array<Maybe<ScoTag>>>;
  isMatchEmailEnabled?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountryKey?: Maybe<Scalars['String']['output']>;
  locationLatitude?: Maybe<Scalars['Float']['output']>;
  locationLongitude?: Maybe<Scalars['Float']['output']>;
  locationRadiusInMiles?: Maybe<Scalars['String']['output']>;
  locationState?: Maybe<Scalars['String']['output']>;
  marketSizeStatement?: Maybe<Scalars['String']['output']>;
  maxMatchScore?: Maybe<Scalars['Int']['output']>;
  metrics?: Maybe<ScoInvestorSearchMetrics>;
  naturalLanguagePrompt?: Maybe<Scalars['String']['output']>;
  nextInvestorMessageSchedulesToSendAt?: Maybe<Scalars['DateTime']['output']>;
  parameterChecksum?: Maybe<Scalars['String']['output']>;
  parametersAsJSON?: Maybe<Scalars['String']['output']>;
  pitchDeckNotes?: Maybe<Scalars['String']['output']>;
  pitchDeckUrl?: Maybe<Scalars['String']['output']>;
  problemStatement?: Maybe<Scalars['String']['output']>;
  processingDescription?: Maybe<Scalars['String']['output']>;
  processingStatus?: Maybe<Scalars['String']['output']>;
  processingUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  relevantInvestorTags?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  requiredInvestorTags?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  savedInvestorMatchesCount?: Maybe<Scalars['Int']['output']>;
  searchingCompany?: Maybe<ScoCompany>;
  searchingCompanyId?: Maybe<Scalars['String']['output']>;
  searchingUser?: Maybe<ScoUser>;
  searchingUserId?: Maybe<Scalars['String']['output']>;
  solutionStatement?: Maybe<Scalars['String']['output']>;
  teamStatement?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tractionStatement?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ScoInvestorSearchInvestorMatchesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoInvestorSearchInvestorSearchTagsArgs = {
  investorTagTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ScoInvestorSearchInvestorTagsArgs = {
  investorTagTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ScoInvestorSearchMaxMatchScoreArgs = {
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoInvestorSearchCollection = {
  __typename?: 'ScoInvestorSearchCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoInvestorSearch>>;
  pagination: Pagination;
};

export type ScoInvestorSearchDraft = ScoNode & {
  __typename?: 'ScoInvestorSearchDraft';
  fundingGoalInDollars?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  investorTags?: Maybe<Array<Maybe<ScoInvestorSearchTag>>>;
  matchedInvestorProfiles?: Maybe<Array<Maybe<ScoInvestorProfile>>>;
  matchedInvestorProfilesCount?: Maybe<Scalars['Int']['output']>;
  naturalLanguagePrompt?: Maybe<Scalars['String']['output']>;
  relevantInvestorTags?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
};

export type ScoInvestorSearchMetrics = ScoNode & {
  __typename?: 'ScoInvestorSearchMetrics';
  bouncedMessagesCount?: Maybe<Scalars['Int']['output']>;
  clickedMessagesCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  openedMessagesCount?: Maybe<Scalars['Int']['output']>;
  repliedMessagesCount?: Maybe<Scalars['Int']['output']>;
  scheduledMessagesCount?: Maybe<Scalars['Int']['output']>;
  sendFailedMessagesCount?: Maybe<Scalars['Int']['output']>;
  sendSucceededMessagesCount?: Maybe<Scalars['Int']['output']>;
  sentMessagesCount?: Maybe<Scalars['Int']['output']>;
};

export type ScoInvestorSearchTag = ScoNode & {
  __typename?: 'ScoInvestorSearchTag';
  id: Scalars['ID']['output'];
  investorSearch?: Maybe<ScoInvestorSearch>;
  investorSearchId?: Maybe<Scalars['String']['output']>;
  investorSearchTagId?: Maybe<Scalars['String']['output']>;
  investorTag?: Maybe<ScoInvestorTag>;
  investorTagId?: Maybe<Scalars['String']['output']>;
  strength?: Maybe<Scalars['Int']['output']>;
};

export type ScoInvestorSearchUpdatedSubscriptionPayload = {
  __typename?: 'ScoInvestorSearchUpdatedSubscriptionPayload';
  id: Scalars['ID']['output'];
  investorSearch?: Maybe<ScoInvestorSearch>;
  investorSearchId?: Maybe<Scalars['String']['output']>;
};

export type ScoInvestorTag = ScoNode & {
  __typename?: 'ScoInvestorTag';
  id: Scalars['ID']['output'];
  investorTagId?: Maybe<Scalars['String']['output']>;
  investorTagTypeKey?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScoLike = ScoNode & {
  __typename?: 'ScoLike';
  comment?: Maybe<ScoComment>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<ScoUser>;
  id: Scalars['ID']['output'];
  likeId?: Maybe<Scalars['String']['output']>;
  likeable?: Maybe<ScoLikeable>;
  likeableId?: Maybe<Scalars['String']['output']>;
  likeableType?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<ScoThread>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoLikeCollection = {
  __typename?: 'ScoLikeCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoLike>>;
  pagination: Pagination;
};

export type ScoLikeable = ScoNode & {
  __typename?: 'ScoLikeable';
  canUserLike?: Maybe<Scalars['Boolean']['output']>;
  hasUserLiked?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  likes?: Maybe<ScoLikeCollection>;
  likesCount?: Maybe<Scalars['Int']['output']>;
};


export type ScoLikeableLikesArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ScoLinkedAccount = ScoNode & {
  __typename?: 'ScoLinkedAccount';
  app?: Maybe<Scalars['String']['output']>;
  companies?: Maybe<Array<Maybe<ScoLinkedAccountCompany>>>;
  email?: Maybe<Scalars['String']['output']>;
  externalUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  signedAppUrl?: Maybe<Scalars['String']['output']>;
  signedCreateCompanyUrl?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ScoUser>;
};

export type ScoLinkedAccountCompany = {
  __typename?: 'ScoLinkedAccountCompany';
  app?: Maybe<Scalars['String']['output']>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type ScoLinkedAccountPermission = ScoNode & {
  __typename?: 'ScoLinkedAccountPermission';
  id: Scalars['ID']['output'];
};

export type ScoLoginAttempt = ScoNode & {
  __typename?: 'ScoLoginAttempt';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  isPasswordSet?: Maybe<Scalars['Boolean']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  loginAttemptId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoLoginAttemptCollection = {
  __typename?: 'ScoLoginAttemptCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoLoginAttempt>>;
  pagination: Pagination;
};

export type ScoNode = {
  id: Scalars['ID']['output'];
};

export type ScoNotification = ScoNode & {
  __typename?: 'ScoNotification';
  actingUser?: Maybe<ScoUser>;
  /** optional comma-delimited list of user ids for grouped notifications */
  actingUserIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  actionAt?: Maybe<Scalars['DateTime']['output']>;
  attachment?: Maybe<ScoAttachment>;
  attachmentAction?: Maybe<Scalars['String']['output']>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentIdOfParent?: Maybe<Scalars['String']['output']>;
  attachmentOwnerUserId?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  attachmentTypeOfParent?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<ScoComment>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  formattedMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  like?: Maybe<ScoLike>;
  message?: Maybe<Scalars['String']['output']>;
  notifiable?: Maybe<ScoAttachment>;
  notifiableAction?: Maybe<Scalars['String']['output']>;
  notifiableId?: Maybe<Scalars['String']['output']>;
  notifiableType?: Maybe<Scalars['String']['output']>;
  notificationId?: Maybe<Scalars['String']['output']>;
  notificationIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  permalinkAbsoluteUrl?: Maybe<Scalars['String']['output']>;
  permalinkUrl?: Maybe<Scalars['String']['output']>;
  pushedAt?: Maybe<Scalars['DateTime']['output']>;
  receivingUser?: Maybe<ScoUser>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ScoNotificationCollection = {
  __typename?: 'ScoNotificationCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoNotification>>;
  pagination: Pagination;
};

export type ScoPeriodStat = {
  __typename?: 'ScoPeriodStat';
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ScoPeriodStatCollection = {
  __typename?: 'ScoPeriodStatCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoPeriodStat>>;
  pagination: Pagination;
};

export type ScoPitchDeck = ScoNode & {
  __typename?: 'ScoPitchDeck';
  analyzedAt?: Maybe<Scalars['DateTime']['output']>;
  auditAiActionId?: Maybe<Scalars['String']['output']>;
  audits?: Maybe<Array<Maybe<ScoPitchDeckAudit>>>;
  classifyAiActionId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<ScoCompany>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deckStoredFile?: Maybe<ScoStoredFile>;
  deckStoredFileId?: Maybe<Scalars['String']['output']>;
  errorAsJson?: Maybe<Scalars['JSON']['output']>;
  groupRequest?: Maybe<GroupRequest>;
  id: Scalars['ID']['output'];
  latestPitchDeckAudit?: Maybe<ScoPitchDeckAudit>;
  latestPitchDeckAuditId?: Maybe<Scalars['String']['output']>;
  overallToolSession?: Maybe<ScoToolSession>;
  overallToolSessionId?: Maybe<Scalars['String']['output']>;
  phaseKey?: Maybe<Scalars['String']['output']>;
  pitchDeckId?: Maybe<Scalars['String']['output']>;
  rulesVersion?: Maybe<Scalars['String']['output']>;
  slideCount?: Maybe<Scalars['Int']['output']>;
  slides?: Maybe<Array<Maybe<ScoPitchDeckSlide>>>;
  statusKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoPitchDeckAudit = ScoNode & {
  __typename?: 'ScoPitchDeckAudit';
  aiAction?: Maybe<ScoAiAction>;
  aiActionId?: Maybe<Scalars['String']['output']>;
  analyzedAt?: Maybe<Scalars['DateTime']['output']>;
  auditTypeKey?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  crossSlideCoherenceAsJson?: Maybe<Scalars['JSON']['output']>;
  errorAsJson?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  overallScore?: Maybe<Scalars['Int']['output']>;
  overallSummary?: Maybe<Scalars['String']['output']>;
  pitchDeck?: Maybe<ScoPitchDeck>;
  pitchDeckAuditId?: Maybe<Scalars['String']['output']>;
  pitchDeckId?: Maybe<Scalars['String']['output']>;
  pitchDeckStoredFile?: Maybe<ScoStoredFile>;
  pitchDeckStoredFileId?: Maybe<Scalars['String']['output']>;
  rulesVersion?: Maybe<Scalars['String']['output']>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  scoreMethodKey?: Maybe<Scalars['String']['output']>;
  slides?: Maybe<Array<Maybe<ScoPitchDeckAuditSlide>>>;
  sourceTypeKey?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  statusKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  wilVerdict?: Maybe<Scalars['String']['output']>;
};

export type ScoPitchDeckAuditSlide = ScoNode & {
  __typename?: 'ScoPitchDeckAuditSlide';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  acceptedByUser?: Maybe<ScoUser>;
  acceptedByUserId?: Maybe<Scalars['String']['output']>;
  acceptedRewrite?: Maybe<Scalars['String']['output']>;
  canonicalPosition?: Maybe<Scalars['Int']['output']>;
  coherenceNote?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deckPosition?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  investorObjection?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<ScoPitchDeckAuditSlideItem>>>;
  pitchDeckAuditId?: Maybe<Scalars['String']['output']>;
  pitchDeckAuditSlideId?: Maybe<Scalars['String']['output']>;
  pitchDeckSlide?: Maybe<ScoPitchDeckSlide>;
  pitchDeckSlideId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  ratingKey?: Maybe<Scalars['String']['output']>;
  ratingLabel?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  scoreMethodKey?: Maybe<Scalars['String']['output']>;
  slideCode?: Maybe<Scalars['String']['output']>;
  slideKey?: Maybe<Scalars['String']['output']>;
  slideLabel?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  suggestedRewrite?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  whatTheySaid?: Maybe<Scalars['String']['output']>;
  whatWorks?: Maybe<Scalars['String']['output']>;
  whatsMissingOrBroken?: Maybe<Scalars['String']['output']>;
};

export type ScoPitchDeckAuditSlideItem = ScoNode & {
  __typename?: 'ScoPitchDeckAuditSlideItem';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  itemTypeKey?: Maybe<Scalars['String']['output']>;
  pitchDeckAuditSlideId?: Maybe<Scalars['String']['output']>;
  pitchDeckAuditSlideItemId?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  ruleWeight?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  targetPhrase?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoPitchDeckAuditUpdatedSubscriptionPayload = {
  __typename?: 'ScoPitchDeckAuditUpdatedSubscriptionPayload';
  id: Scalars['ID']['output'];
  pitchDeckAudit?: Maybe<ScoPitchDeckAudit>;
  pitchDeckAuditId?: Maybe<Scalars['String']['output']>;
};

export type ScoPitchDeckCollection = {
  __typename?: 'ScoPitchDeckCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoPitchDeck>>;
  pagination: Pagination;
};

export type ScoPitchDeckSlide = ScoNode & {
  __typename?: 'ScoPitchDeckSlide';
  bodyText?: Maybe<Scalars['String']['output']>;
  canonicalPosition?: Maybe<Scalars['Int']['output']>;
  classificationKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latestPitchDeckAuditSlide?: Maybe<ScoPitchDeckAuditSlide>;
  latestPitchDeckAuditSlideId?: Maybe<Scalars['String']['output']>;
  pitchDeckId?: Maybe<Scalars['String']['output']>;
  pitchDeckSlideId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  slideCode?: Maybe<Scalars['String']['output']>;
  slideImageStoredFile?: Maybe<ScoStoredFile>;
  slideImageStoredFileId?: Maybe<Scalars['String']['output']>;
  slideImageUrl?: Maybe<Scalars['String']['output']>;
  slideKey?: Maybe<Scalars['String']['output']>;
  slideName?: Maybe<Scalars['String']['output']>;
  slideTitle?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  toolSession?: Maybe<ScoToolSession>;
  toolSessionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoPitchDeckUpdatedSubscriptionPayload = {
  __typename?: 'ScoPitchDeckUpdatedSubscriptionPayload';
  id: Scalars['ID']['output'];
  pitchDeck?: Maybe<ScoPitchDeck>;
  pitchDeckId?: Maybe<Scalars['String']['output']>;
};

export type ScoPlaybook = ScoNode & {
  __typename?: 'ScoPlaybook';
  color?: Maybe<Scalars['String']['output']>;
  comingSoon?: Maybe<Scalars['Boolean']['output']>;
  courseId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  illustration?: Maybe<Scalars['String']['output']>;
  learningPoints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primaryCategorySlug?: Maybe<Scalars['String']['output']>;
  searchScore?: Maybe<Scalars['Int']['output']>;
  sections?: Maybe<Array<Maybe<ScoPlaybookSection>>>;
  seoDescription: Scalars['String']['output'];
  seoTitle: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  teaser?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tldr?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<GroupTopic>;
  topicKey?: Maybe<Scalars['String']['output']>;
};

export type ScoPlaybookPage = ScoNode & {
  __typename?: 'ScoPlaybookPage';
  content?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ScoPlaybookSection = ScoNode & {
  __typename?: 'ScoPlaybookSection';
  badge?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  illustration?: Maybe<Scalars['String']['output']>;
  learningPoints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pages?: Maybe<Array<Maybe<ScoPlaybookPage>>>;
  slug: Scalars['String']['output'];
  teaser?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ScoProduct = ScoNode & {
  __typename?: 'ScoProduct';
  appliedCoupon?: Maybe<ScoProductCoupon>;
  chargebeeConfigAsJson?: Maybe<Scalars['String']['output']>;
  durationInYears?: Maybe<Scalars['Int']['output']>;
  effectiveLegacyProductId?: Maybe<Scalars['String']['output']>;
  effectivePrices?: Maybe<LegacyProductPricing>;
  effectivePricingInCents?: Maybe<ScoProductPricing>;
  effectiveTerm?: Maybe<ScoProductTerm>;
  effectiveTermId?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<LegacyProductFeature>>>;
  hasUserPurchased?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  instanceProductId?: Maybe<Scalars['String']['output']>;
  isPaymentRequired?: Maybe<Scalars['Boolean']['output']>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  listPrices?: Maybe<LegacyProductPricing>;
  monthlyFinancedPrice?: Maybe<Scalars['Float']['output']>;
  monthlyFinancedRatePercentage?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfPayments?: Maybe<Scalars['Int']['output']>;
  parentProductId?: Maybe<Scalars['String']['output']>;
  paywallName?: Maybe<Scalars['String']['output']>;
  paywallOptions?: Maybe<ScoProductPaywallOptions>;
  pricePointId?: Maybe<Scalars['String']['output']>;
  pricingInCents?: Maybe<ScoProductPricing>;
  productId?: Maybe<Scalars['String']['output']>;
  specialTermsNote?: Maybe<Scalars['String']['output']>;
  statementOfWorkUrl?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  term?: Maybe<LegacyProductTerm>;
  termId?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<Maybe<ScoProductTerm>>>;
  termsOfServiceTitle?: Maybe<Scalars['String']['output']>;
  termsOfServiceUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trialDays?: Maybe<Scalars['Int']['output']>;
  trialRequiresCard?: Maybe<Scalars['Boolean']['output']>;
};

export type ScoProductCoupon = {
  __typename?: 'ScoProductCoupon';
  code?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  isPrepaid?: Maybe<Scalars['Boolean']['output']>;
  productIds: Array<Maybe<Scalars['String']['output']>>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  terms?: Maybe<ScoProductCouponTerms>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ScoProductCouponTerms = {
  __typename?: 'ScoProductCouponTerms';
  recurringDiscountAmount?: Maybe<Scalars['Float']['output']>;
  recurringDiscountPercent?: Maybe<Scalars['Float']['output']>;
  signupDiscountAmount?: Maybe<Scalars['Float']['output']>;
  signupDiscountPercent?: Maybe<Scalars['Float']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

export type ScoProductFeature = {
  __typename?: 'ScoProductFeature';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ScoProductPaywallOptions = {
  __typename?: 'ScoProductPaywallOptions';
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<ScoProductPaywallOptions>>>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScoProductPricing = {
  __typename?: 'ScoProductPricing';
  nextAssessmentAt?: Maybe<Scalars['DateTime']['output']>;
  prepaidPeriodRequiresCard?: Maybe<Scalars['Boolean']['output']>;
  prepaidPeriods?: Maybe<Scalars['Int']['output']>;
  prepaidPeriodsUnit?: Maybe<Scalars['String']['output']>;
  recurring?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  signup?: Maybe<Scalars['Int']['output']>;
  trialDays?: Maybe<Scalars['Int']['output']>;
  trialRequiresCard?: Maybe<Scalars['Boolean']['output']>;
};

export type ScoProductTerm = {
  __typename?: 'ScoProductTerm';
  abbreviation?: Maybe<Scalars['String']['output']>;
  everyMonthLabel?: Maybe<Scalars['String']['output']>;
  frequencyLabel?: Maybe<Scalars['String']['output']>;
  months?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pricingInCents?: Maybe<ScoProductPricing>;
  termId?: Maybe<Scalars['String']['output']>;
};

export type ScoPurchaseQuote = ScoNode & {
  __typename?: 'ScoPurchaseQuote';
  chargebeeEstimateAsJson?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  product?: Maybe<ScoProduct>;
  stripeCustomer?: Maybe<StripeCustomer>;
  stripePaymentIntent?: Maybe<StripePaymentIntent>;
  stripeSetupIntent?: Maybe<StripeSetupIntent>;
  subscription?: Maybe<ScoSubscription>;
};

export type ScoRagCollection = ScoNode & {
  __typename?: 'ScoRagCollection';
  chunkConfigAsJson?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  embeddingDimensions?: Maybe<Scalars['Int']['output']>;
  embeddingModelId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  ragCollectionId?: Maybe<Scalars['UUID']['output']>;
  ragSources?: Maybe<ScoRagSourceCollection>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type ScoRagCollectionRagSourcesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ScoRagCollectionCollection = {
  __typename?: 'ScoRagCollectionCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoRagCollection>>;
  pagination: Pagination;
};

export type ScoRagSource = ScoNode & {
  __typename?: 'ScoRagSource';
  authorName?: Maybe<Scalars['String']['output']>;
  chunkCount?: Maybe<Scalars['Int']['output']>;
  contentFieldKey?: Maybe<Scalars['String']['output']>;
  contentHash?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastIndexedAt?: Maybe<Scalars['DateTime']['output']>;
  metadataAsJson?: Maybe<Scalars['JSON']['output']>;
  platformKey?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  ragCollection?: Maybe<ScoRagCollection>;
  ragCollectionId?: Maybe<Scalars['UUID']['output']>;
  ragSourceContent?: Maybe<ScoRagSourceContent>;
  ragSourceId?: Maybe<Scalars['UUID']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sourceTypeKey?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ScoRagSourceCollection = {
  __typename?: 'ScoRagSourceCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoRagSource>>;
  pagination: Pagination;
};

export type ScoRagSourceContent = ScoNode & {
  __typename?: 'ScoRagSourceContent';
  byteLength?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fetchedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ragSourceContentId?: Maybe<Scalars['UUID']['output']>;
  ragSourceId?: Maybe<Scalars['UUID']['output']>;
  rawContent?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoRating = ScoNode & {
  __typename?: 'ScoRating';
  advisorSession?: Maybe<ScoAdvisorSession>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<ScoUser>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  rateableId?: Maybe<Scalars['String']['output']>;
  rateableType?: Maybe<Scalars['String']['output']>;
  ratingId?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoRatingCollection = {
  __typename?: 'ScoRatingCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoRating>>;
  pagination: Pagination;
};

export type ScoSalesEvent = ScoNode & {
  __typename?: 'ScoSalesEvent';
  attributionAsPercent?: Maybe<Scalars['Int']['output']>;
  /** The Beancounter payment this sales event is attributed to, if any. */
  beancounterPayment?: Maybe<BeancounterPayment>;
  /** Foreign key to BeancounterPayment.paymentId when this sales event is attributed to a Beancounter payment. */
  beancounterPaymentId?: Maybe<Scalars['String']['output']>;
  commissionNotes?: Maybe<Scalars['String']['output']>;
  commissionPaidAmountInCents?: Maybe<Scalars['Int']['output']>;
  commissionPaidAt?: Maybe<Scalars['DateTime']['output']>;
  commissionReturnedAmountInCents?: Maybe<Scalars['Int']['output']>;
  commissionReturnedAt?: Maybe<Scalars['DateTime']['output']>;
  commissionValueInCents?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerSubscription?: Maybe<ScoSubscription>;
  customerSubscriptionId?: Maybe<Scalars['String']['output']>;
  customerUser?: Maybe<ScoUser>;
  customerUserId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  salesEventId?: Maybe<Scalars['String']['output']>;
  salesEventTypeKey?: Maybe<Scalars['String']['output']>;
  salesPerson?: Maybe<ScoSalesPerson>;
  salesPersonId?: Maybe<Scalars['String']['output']>;
  sourceNotes?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoSalesEventCollection = {
  __typename?: 'ScoSalesEventCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoSalesEvent>>;
  pagination: Pagination;
};

export type ScoSalesLead = ScoNode & {
  __typename?: 'ScoSalesLead';
  closeContactId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  effectiveCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  effectiveUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hubspotContactId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  salesEvents?: Maybe<Array<Maybe<ScoSalesEvent>>>;
  salesLeadId?: Maybe<Scalars['String']['output']>;
  salesPerson?: Maybe<ScoSalesPerson>;
  salesPersonId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceNotes?: Maybe<Scalars['String']['output']>;
  statusKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoSalesLeadCollection = {
  __typename?: 'ScoSalesLeadCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoSalesLead>>;
  pagination: Pagination;
};

export type ScoSalesPerson = ScoNode & {
  __typename?: 'ScoSalesPerson';
  /**
   * Beancounter transaction lines attributed to this sales person via sales events
   * on the parent payment. Same filter args as beancounterTransactions, with
   * salesPersonId fixed to this person.
   */
  beancounterTransactions?: Maybe<BeancounterTransactionCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hubspotOwnerIdentifier?: Maybe<Scalars['String']['output']>;
  hubspotUserIdentifier?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadUsers?: Maybe<ScoUserCollection>;
  salesEvents?: Maybe<ScoSalesEventCollection>;
  salesPersonId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type ScoSalesPersonBeancounterTransactionsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxValueInCents?: InputMaybe<Scalars['Int']['input']>;
  minValueInCents?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  payerCardLast4?: InputMaybe<Scalars['String']['input']>;
  payerEmail?: InputMaybe<Scalars['String']['input']>;
  payerName?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  recurringType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type ScoSalesPersonLeadUsersArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoSalesPersonSalesEventsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  paymentBrand?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScoSalesPersonCollection = {
  __typename?: 'ScoSalesPersonCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoSalesPerson>>;
  pagination: Pagination;
};

export type ScoSignupRequest = ScoNode & {
  __typename?: 'ScoSignupRequest';
  additionalFields?: Maybe<Scalars['JSON']['output']>;
  additionalFieldsAsJson?: Maybe<Scalars['JSON']['output']>;
  aiActions?: Maybe<ScoAiActionCollection>;
  bodyAsMarkdown?: Maybe<Scalars['String']['output']>;
  companyElevatorPitch?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  convertingSubscription?: Maybe<ScoSubscription>;
  convertingSubscriptionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  createdByIpLocation?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fundingGoalInDollars?: Maybe<Scalars['Int']['output']>;
  funnelIdentifier?: Maybe<Scalars['String']['output']>;
  groupRequest?: Maybe<GroupRequest>;
  groupRequestId?: Maybe<Scalars['String']['output']>;
  groupRequestTypeKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  investorIndustryTagTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  investorVerticalTagTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastProcessedAt?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountryKey?: Maybe<Scalars['String']['output']>;
  locationPlaceId?: Maybe<Scalars['String']['output']>;
  locationPostalCode?: Maybe<Scalars['String']['output']>;
  locationState?: Maybe<Scalars['String']['output']>;
  nextProcessingAt?: Maybe<Scalars['DateTime']['output']>;
  pitchDeckUrl?: Maybe<Scalars['String']['output']>;
  recommendationAsMarkdown?: Maybe<Scalars['String']['output']>;
  recommendedFeaturesAsJson?: Maybe<Scalars['String']['output']>;
  recommendedProductId?: Maybe<Scalars['String']['output']>;
  reportAiAction?: Maybe<ScoAiAction>;
  reportInputAsJson?: Maybe<Scalars['JSON']['output']>;
  reportOutputAsJson?: Maybe<Scalars['JSON']['output']>;
  requestingEmail?: Maybe<Scalars['String']['output']>;
  requestingFullName?: Maybe<Scalars['String']['output']>;
  requestingUser?: Maybe<ScoUser>;
  requestingUserId?: Maybe<Scalars['String']['output']>;
  selectedProductId?: Maybe<Scalars['String']['output']>;
  signupRequestId?: Maybe<Scalars['String']['output']>;
  skillTagTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tagAttachments?: Maybe<Array<Maybe<ScoTagAttachment>>>;
  tagTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<ScoTag>>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ScoSignupRequestAiActionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ScoSignupRequestCollection = {
  __typename?: 'ScoSignupRequestCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoSignupRequest>>;
  pagination: Pagination;
};

export type ScoSignupRequestUpdatedSubscriptionPayload = {
  __typename?: 'ScoSignupRequestUpdatedSubscriptionPayload';
  id: Scalars['ID']['output'];
  signupRequest?: Maybe<ScoSignupRequest>;
  signupRequestId?: Maybe<Scalars['String']['output']>;
};

export type ScoSkill = ScoNode & {
  __typename?: 'ScoSkill';
  category?: Maybe<Scalars['String']['output']>;
  childSkills?: Maybe<Array<Maybe<ScoSkill>>>;
  description?: Maybe<Scalars['String']['output']>;
  hierarchicalTitles?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  id: Scalars['ID']['output'];
  parentSkills?: Maybe<Array<Maybe<ScoSkill>>>;
  popularity?: Maybe<Scalars['Int']['output']>;
  siblingSkills?: Maybe<Array<Maybe<ScoSkill>>>;
  skillId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScoStaticOption = ScoNode & {
  __typename?: 'ScoStaticOption';
  colorHexCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  strength?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ScoStaticOptions = {
  __typename?: 'ScoStaticOptions';
  advisorAgreementStatuses?: Maybe<Array<Maybe<ScoStaticOption>>>;
  advisorCalibers?: Maybe<Array<Maybe<ScoStaticOption>>>;
  advisorCategories?: Maybe<Array<Maybe<ScoStaticOption>>>;
  advisorCompanyStages?: Maybe<Array<Maybe<ScoStaticOption>>>;
  advisorContributionTiers?: Maybe<Array<Maybe<ScoStaticOption>>>;
  advisorWarmIntros?: Maybe<Array<Maybe<ScoStaticOption>>>;
  commitmentTypes?: Maybe<Array<Maybe<ScoStaticOption>>>;
  compensationTypes?: Maybe<Array<Maybe<ScoStaticOption>>>;
  id: Scalars['ID']['output'];
  industries?: Maybe<Array<Maybe<ScoStaticOption>>>;
  pitchDeckCoherenceTypes?: Maybe<Array<Maybe<ScoStaticOption>>>;
  pitchDeckRatings?: Maybe<Array<Maybe<ScoStaticOption>>>;
  pitchDeckRules?: Maybe<Array<Maybe<ScoStaticOption>>>;
  pitchDeckSlideTypes?: Maybe<Array<Maybe<ScoStaticOption>>>;
};

export type ScoStats = ScoNode & {
  __typename?: 'ScoStats';
  id: Scalars['ID']['output'];
  launchrock?: Maybe<LaunchStats>;
};

export type ScoStoredFile = ScoNode & {
  __typename?: 'ScoStoredFile';
  attachment?: Maybe<ScoAttachment>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  contextKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<ScoUser>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fullUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  storageDriver?: Maybe<ScoStaticOption>;
  storageDriverKey?: Maybe<Scalars['String']['output']>;
  storageFileName?: Maybe<Scalars['String']['output']>;
  storageFileSizeInBytes?: Maybe<Scalars['Int']['output']>;
  storagePath?: Maybe<Scalars['String']['output']>;
  storedFileId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoStoredFileCollection = {
  __typename?: 'ScoStoredFileCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoStoredFile>>;
  pagination: Pagination;
};

export type ScoStreamJoinCredentials = {
  __typename?: 'ScoStreamJoinCredentials';
  apiKey?: Maybe<Scalars['String']['output']>;
  callId?: Maybe<Scalars['String']['output']>;
  callType?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type ScoSubscription = ScoNode & {
  __typename?: 'ScoSubscription';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  appliedCouponCode?: Maybe<Scalars['String']['output']>;
  automaticallyResumeAt?: Maybe<Scalars['DateTime']['output']>;
  balanceInCents?: Maybe<Scalars['Int']['output']>;
  calculatedTotalCaptureInCents?: Maybe<Scalars['Int']['output']>;
  calculatedTotalChargebackInCents?: Maybe<Scalars['Int']['output']>;
  calculatedTotalChargebackWonInCents?: Maybe<Scalars['Int']['output']>;
  calculatedTotalNetRevenueInCents?: Maybe<Scalars['Int']['output']>;
  calculatedTotalRefundInCents?: Maybe<Scalars['Int']['output']>;
  calculatedTotalReturnInCents?: Maybe<Scalars['Int']['output']>;
  canBeCanceled?: Maybe<Scalars['Boolean']['output']>;
  cancelPreventedAt?: Maybe<Scalars['DateTime']['output']>;
  cancelPreventionNotes?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  cancellationMessage?: Maybe<Scalars['String']['output']>;
  cancellationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  cardLabel?: Maybe<Scalars['String']['output']>;
  chargebeeCustomerId?: Maybe<Scalars['String']['output']>;
  chargebeeInvoiceId?: Maybe<Scalars['String']['output']>;
  chargebeeItemId?: Maybe<Scalars['String']['output']>;
  chargebeeSubscriptionId?: Maybe<Scalars['String']['output']>;
  chargifyProductId?: Maybe<Scalars['Int']['output']>;
  chargifySubscriptionId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodEndsAt?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStartedAt?: Maybe<Scalars['DateTime']['output']>;
  delayedCancelAt?: Maybe<Scalars['DateTime']['output']>;
  effectivePrices?: Maybe<LegacyProductPricing>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isLifetime?: Maybe<Scalars['Boolean']['output']>;
  monthlyRecurringRevenueInCents?: Maybe<Scalars['Float']['output']>;
  mrrValueInCents?: Maybe<Scalars['Int']['output']>;
  nextAssessmentAmountInCents?: Maybe<Scalars['Int']['output']>;
  nextAssessmentAt?: Maybe<Scalars['DateTime']['output']>;
  product?: Maybe<ScoProduct>;
  productId?: Maybe<Scalars['String']['output']>;
  provisionedAccounts: Array<Maybe<ProvisionedAccount>>;
  salesEvents?: Maybe<Array<Maybe<ScoSalesEvent>>>;
  scoProduct?: Maybe<ScoProduct>;
  signupPaymentId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** All the statements associated with a subscription. */
  statements?: Maybe<Array<Maybe<ScoBillingStatement>>>;
  subscriptionId: Scalars['String']['output'];
  totalRevenueInCents?: Maybe<Scalars['Int']['output']>;
  trialEndedAt?: Maybe<Scalars['DateTime']['output']>;
  trialStartedAt?: Maybe<Scalars['DateTime']['output']>;
  updatePaymentMethodLink?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
};

export type ScoSubscriptionChangeQuote = ScoNode & {
  __typename?: 'ScoSubscriptionChangeQuote';
  addedToNextInvoiceInCents?: Maybe<Scalars['Int']['output']>;
  creditsAppliedInCents?: Maybe<Scalars['Int']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  dueNowInCents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  nextBillingAmountInCents?: Maybe<Scalars['Int']['output']>;
  nextBillingAt?: Maybe<Scalars['DateTime']['output']>;
  product?: Maybe<ScoProduct>;
  prorated?: Maybe<Scalars['Boolean']['output']>;
  subscription?: Maybe<ScoSubscription>;
  subtotalInCents?: Maybe<Scalars['Int']['output']>;
  taxInCents?: Maybe<Scalars['Int']['output']>;
};

export type ScoSubscriptionCollection = {
  __typename?: 'ScoSubscriptionCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoSubscription>>;
  pagination: Pagination;
};

export type ScoTag = ScoNode & {
  __typename?: 'ScoTag';
  category?: Maybe<Scalars['String']['output']>;
  childTags?: Maybe<Array<Maybe<ScoTag>>>;
  colorHexCode?: Maybe<Scalars['String']['output']>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hierarchicalTitles?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  iconImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  investorTagId?: Maybe<Scalars['String']['output']>;
  parentTags?: Maybe<Array<Maybe<ScoTag>>>;
  popularity?: Maybe<Scalars['Int']['output']>;
  primaryParentTagId?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  siblingTags?: Maybe<Array<Maybe<ScoTag>>>;
  skillId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
  tagTypeKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScoTagAttachment = ScoNode & {
  __typename?: 'ScoTagAttachment';
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentTYpe?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  tag?: Maybe<ScoTag>;
  tagAttachmentId?: Maybe<Scalars['String']['output']>;
};

export type ScoTagCollection = {
  __typename?: 'ScoTagCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoTag>>;
  pagination: Pagination;
};

export type ScoTask = ScoNode & {
  __typename?: 'ScoTask';
  assignedToCompany?: Maybe<ScoCompany>;
  assignedToCompanyId?: Maybe<Scalars['String']['output']>;
  assignedToUser?: Maybe<ScoUser>;
  assignedToUserId?: Maybe<Scalars['String']['output']>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  bodyAsMarkdown?: Maybe<Scalars['String']['output']>;
  canUserEdit?: Maybe<Scalars['Boolean']['output']>;
  childTasks?: Maybe<Array<Maybe<ScoTask>>>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<ScoUser>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nextTask?: Maybe<ScoTask>;
  parentTask?: Maybe<ScoTask>;
  parentTaskId?: Maybe<Scalars['String']['output']>;
  priorityIndex?: Maybe<Scalars['Int']['output']>;
  referencedItemComponent?: Maybe<Scalars['String']['output']>;
  referencedItemId?: Maybe<Scalars['String']['output']>;
  referencedItemParametersAsJson?: Maybe<Scalars['String']['output']>;
  referencedItemSlug?: Maybe<Scalars['String']['output']>;
  referencedItemType?: Maybe<Scalars['String']['output']>;
  referencedItemUrl?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  taskTemplate?: Maybe<ScoTaskTemplate>;
  taskTemplateId?: Maybe<Scalars['String']['output']>;
  taskType?: Maybe<ScoStaticOption>;
  taskTypeKey?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<ScoThread>;
  title?: Maybe<Scalars['String']['output']>;
  toolSession?: Maybe<ScoToolSession>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ScoTaskCollection = {
  __typename?: 'ScoTaskCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoTask>>;
  pagination: Pagination;
};

export type ScoTaskTemplate = ScoNode & {
  __typename?: 'ScoTaskTemplate';
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  bodyAsMarkdown?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupRequestType?: Maybe<ScoStaticOption>;
  groupRequestTypeKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  parentTaskTemplate?: Maybe<ScoTaskTemplate>;
  parentTaskTemplateId?: Maybe<Scalars['String']['output']>;
  priorityIndex?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  referencedItemComponent?: Maybe<Scalars['String']['output']>;
  referencedItemId?: Maybe<Scalars['String']['output']>;
  referencedItemIdFieldOnAttachment?: Maybe<Scalars['String']['output']>;
  referencedItemParametersAsJson?: Maybe<Scalars['String']['output']>;
  referencedItemSlug?: Maybe<Scalars['String']['output']>;
  referencedItemType?: Maybe<Scalars['String']['output']>;
  referencedItemUrl?: Maybe<Scalars['String']['output']>;
  taskTemplateId?: Maybe<Scalars['String']['output']>;
  taskType?: Maybe<ScoStaticOption>;
  taskTypeKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoTaskTemplateCollection = {
  __typename?: 'ScoTaskTemplateCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoTaskTemplate>>;
  pagination: Pagination;
};

export type ScoTeamMember = ScoNode & {
  __typename?: 'ScoTeamMember';
  communityCalendlyUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fgCalendlyUrl?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCommunityCoordinator?: Maybe<Scalars['Boolean']['output']>;
  isCommunityOnboarder?: Maybe<Scalars['Boolean']['output']>;
  isFGCoordinator?: Maybe<Scalars['Boolean']['output']>;
  isFGOnboarder?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
};

export type ScoTerm = ScoNode & {
  __typename?: 'ScoTerm';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type ScoThread = ScoNode & {
  __typename?: 'ScoThread';
  attachment?: Maybe<ScoAttachment>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  bestComment?: Maybe<ScoComment>;
  body?: Maybe<Scalars['String']['output']>;
  canUserAdmin?: Maybe<Scalars['Boolean']['output']>;
  canUserComment?: Maybe<Scalars['Boolean']['output']>;
  canUserDelete?: Maybe<Scalars['Boolean']['output']>;
  canUserEdit?: Maybe<Scalars['Boolean']['output']>;
  canUserFlag?: Maybe<Scalars['Boolean']['output']>;
  canUserFollow?: Maybe<Scalars['Boolean']['output']>;
  canUserLike?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<ScoCommentCollection>;
  commentsAndReplies?: Maybe<ScoCommentCollection>;
  commentsAndRepliesCount?: Maybe<Scalars['Int']['output']>;
  commentsCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<ScoUser>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  currentUserUnreadCommentsCount?: Maybe<Scalars['Int']['output']>;
  deletedByUser?: Maybe<ScoUser>;
  deletedByUserId?: Maybe<Scalars['String']['output']>;
  featuredAt?: Maybe<Scalars['DateTime']['output']>;
  featuredByUser?: Maybe<ScoUser>;
  featuredByUserId?: Maybe<Scalars['String']['output']>;
  featuredComments?: Maybe<ScoCommentCollection>;
  flags?: Maybe<ScoFlagCollection>;
  flagsCount?: Maybe<Scalars['Int']['output']>;
  follows?: Maybe<ScoFollowCollection>;
  followsCount?: Maybe<Scalars['Int']['output']>;
  hasUserCommented?: Maybe<Scalars['Boolean']['output']>;
  hasUserFlagged?: Maybe<Scalars['Boolean']['output']>;
  hasUserFollowed?: Maybe<Scalars['Boolean']['output']>;
  hasUserLiked?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  isSpam?: Maybe<Scalars['Boolean']['output']>;
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  lastCommentedAt?: Maybe<Scalars['DateTime']['output']>;
  likes?: Maybe<ScoLikeCollection>;
  likesCount?: Maybe<Scalars['Int']['output']>;
  mostLikedComment?: Maybe<ScoComment>;
  mostRecentComment?: Maybe<ScoComment>;
  mostRepliedComment?: Maybe<ScoComment>;
  slug?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<ScoThreadTag>>>;
  threadId?: Maybe<Scalars['String']['output']>;
  threadTypeKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  toolSession?: Maybe<ScoToolSession>;
  topicTerm?: Maybe<ScoTerm>;
  topicTermSlug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userMemberships?: Maybe<ScoUserMembershipCollection>;
  views?: Maybe<ScoViewCollection>;
  viewsCount?: Maybe<Scalars['Int']['output']>;
};


export type ScoThreadCommentsArgs = {
  afterCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  afterUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  beforeCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  beforeUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  longPollInSeconds?: InputMaybe<Scalars['Int']['input']>;
  maxFlags?: InputMaybe<Scalars['Int']['input']>;
  onlyMyDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPublicComments?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  spam?: InputMaybe<SpamFilter>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};


export type ScoThreadCommentsAndRepliesArgs = {
  afterCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  afterUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  beforeCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  beforeUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  longPollInSeconds?: InputMaybe<Scalars['Int']['input']>;
  maxFlags?: InputMaybe<Scalars['Int']['input']>;
  onlyMyDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPublicComments?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  spam?: InputMaybe<SpamFilter>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};


export type ScoThreadFeaturedCommentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type ScoThreadFlagsArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type ScoThreadFollowsArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type ScoThreadLikesArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type ScoThreadUserMembershipsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoThreadViewsArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ScoThreadCollection = {
  __typename?: 'ScoThreadCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoThread>>;
  pagination: Pagination;
};

export type ScoThreadCommentSubscriptionPayload = {
  __typename?: 'ScoThreadCommentSubscriptionPayload';
  comment?: Maybe<ScoComment>;
  commentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  parentComment?: Maybe<ScoComment>;
  parentCommentId?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<ScoThread>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type ScoThreadTag = ScoNode & {
  __typename?: 'ScoThreadTag';
  id: Scalars['ID']['output'];
  term?: Maybe<ScoTerm>;
  termSlug?: Maybe<Scalars['String']['output']>;
  threadTagId?: Maybe<Scalars['String']['output']>;
};

export type ScoTimeSeries = {
  __typename?: 'ScoTimeSeries';
  usersByDay?: Maybe<ScoPeriodStatCollection>;
};


export type ScoTimeSeriesUsersByDayArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScoTool = ScoNode & {
  __typename?: 'ScoTool';
  aiConfigAsJson?: Maybe<Scalars['JSON']['output']>;
  allowAnonymousSessions?: Maybe<Scalars['Boolean']['output']>;
  audienceKey?: Maybe<Scalars['String']['output']>;
  bodyAsMarkdown?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featuredImageUrl?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  questionBank?: Maybe<Scalars['JSON']['output']>;
  screenshots?: Maybe<ScoStoredFileCollection>;
  servesConsentAt?: Maybe<Scalars['DateTime']['output']>;
  servesConsentByUserId?: Maybe<Scalars['UUID']['output']>;
  servesUser?: Maybe<ScoUser>;
  servesUserId?: Maybe<Scalars['UUID']['output']>;
  slug: Scalars['String']['output'];
  storedFiles?: Maybe<ScoStoredFileCollection>;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  toolCapabilities?: Maybe<ScoToolCapabilityCollection>;
  toolId?: Maybe<Scalars['UUID']['output']>;
  toolInputs?: Maybe<ScoToolInputCollection>;
  toolOutputs?: Maybe<ScoToolOutputCollection>;
  toolSessions?: Maybe<ScoToolSessionCollection>;
  toolType?: Maybe<ScoStaticOption>;
  toolTypeKey?: Maybe<Scalars['String']['output']>;
  toolUser?: Maybe<ScoUser>;
  toolUserId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ScoToolScreenshotsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoToolStoredFilesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoToolToolCapabilitiesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoToolToolInputsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoToolToolOutputsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoToolToolSessionsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ScoToolCapability = ScoNode & {
  __typename?: 'ScoToolCapability';
  authModeKey?: Maybe<Scalars['String']['output']>;
  capabilityTypeKey?: Maybe<Scalars['String']['output']>;
  configAsJson?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  positionIndex?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tool?: Maybe<ScoTool>;
  toolCapabilityId?: Maybe<Scalars['UUID']['output']>;
  toolId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoToolCapabilityCollection = {
  __typename?: 'ScoToolCapabilityCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoToolCapability>>;
  pagination: Pagination;
};

export type ScoToolCollection = {
  __typename?: 'ScoToolCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoTool>>;
  pagination: Pagination;
};

export type ScoToolInput = ScoNode & {
  __typename?: 'ScoToolInput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  positionIndex?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tool?: Maybe<ScoTool>;
  toolId?: Maybe<Scalars['UUID']['output']>;
  toolInputId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoToolInputCollection = {
  __typename?: 'ScoToolInputCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoToolInput>>;
  pagination: Pagination;
};

export type ScoToolKnowledgeCard = ScoNode & {
  __typename?: 'ScoToolKnowledgeCard';
  body?: Maybe<Scalars['String']['output']>;
  cardTypeKey?: Maybe<Scalars['String']['output']>;
  citationKey?: Maybe<Scalars['String']['output']>;
  citedByRules?: Maybe<Array<Maybe<ScoToolKnowledgeCardCitation>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  failure?: Maybe<Scalars['String']['output']>;
  goodLooksLike?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  itemsKey?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  payoff?: Maybe<Scalars['String']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  toolId?: Maybe<Scalars['String']['output']>;
  toolKnowledgeCardId?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A library rule that cites a knowledge card. */
export type ScoToolKnowledgeCardCitation = {
  __typename?: 'ScoToolKnowledgeCardCitation';
  name?: Maybe<Scalars['String']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
};

export type ScoToolKnowledgeCardPage = {
  __typename?: 'ScoToolKnowledgeCardPage';
  cards?: Maybe<Array<Maybe<ScoToolKnowledgeCard>>>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  topics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ScoToolMessageAudit = {
  __typename?: 'ScoToolMessageAudit';
  actorUserId?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['String']['output']>;
  originKey?: Maybe<Scalars['String']['output']>;
  recalledAt?: Maybe<Scalars['DateTime']['output']>;
  recalledByUserId?: Maybe<Scalars['String']['output']>;
  toolMessageAuditId?: Maybe<Scalars['String']['output']>;
  toolRuleBindingId?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
  toolRuleRunId?: Maybe<Scalars['String']['output']>;
  visibleAuthorUserId?: Maybe<Scalars['String']['output']>;
};

export type ScoToolOutput = ScoNode & {
  __typename?: 'ScoToolOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  dataValue?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tool?: Maybe<ScoTool>;
  toolId?: Maybe<Scalars['UUID']['output']>;
  toolOutputId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScoToolOutputCollection = {
  __typename?: 'ScoToolOutputCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoToolOutput>>;
  pagination: Pagination;
};

export type ScoToolReplySettings = {
  __typename?: 'ScoToolReplySettings';
  masterAutoSend?: Maybe<Scalars['Boolean']['output']>;
  toolId?: Maybe<Scalars['String']['output']>;
};

export type ScoToolReplyTemplate = {
  __typename?: 'ScoToolReplyTemplate';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fields?: Maybe<Array<Maybe<ScoToolReplyTemplateField>>>;
  referencedKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  templateKindKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  toolId?: Maybe<Scalars['String']['output']>;
  toolReplyTemplateId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedByRuleIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ScoToolReplyTemplateField = {
  __typename?: 'ScoToolReplyTemplateField';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ScoToolRule = ScoNode & {
  __typename?: 'ScoToolRule';
  bar?: Maybe<Scalars['Int']['output']>;
  catches?: Maybe<Scalars['String']['output']>;
  citedCardId?: Maybe<Scalars['String']['output']>;
  codeCheckKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  draftModeKey?: Maybe<Scalars['String']['output']>;
  evaluatorKey?: Maybe<Scalars['String']['output']>;
  exampleMessage?: Maybe<Scalars['String']['output']>;
  groupKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  laneKey?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  positionIndex?: Maybe<Scalars['Int']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  templateBody?: Maybe<Scalars['String']['output']>;
  templateKindKey?: Maybe<Scalars['String']['output']>;
  toolReplyTemplateId?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  why?: Maybe<Scalars['String']['output']>;
};

export type ScoToolRuleBinding = ScoNode & {
  __typename?: 'ScoToolRuleBinding';
  autoSendEnabled?: Maybe<Scalars['Boolean']['output']>;
  bar?: Maybe<Scalars['Int']['output']>;
  catches?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  templateBody?: Maybe<Scalars['String']['output']>;
  toolId?: Maybe<Scalars['String']['output']>;
  toolReplyTemplateId?: Maybe<Scalars['String']['output']>;
  toolRuleBindingId?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variablesAsJson?: Maybe<Scalars['JSON']['output']>;
};

export type ScoToolRuleBindingSet = {
  __typename?: 'ScoToolRuleBindingSet';
  hardStops?: Maybe<Array<Maybe<ScoToolRuleView>>>;
  lanes?: Maybe<Array<Maybe<ScoToolRuleView>>>;
};

export type ScoToolRuleCount = {
  __typename?: 'ScoToolRuleCount';
  drafted?: Maybe<Scalars['Int']['output']>;
  editedBeforeSend?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recalled?: Maybe<Scalars['Int']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
};

export type ScoToolRuleLaneCount = {
  __typename?: 'ScoToolRuleLaneCount';
  count?: Maybe<Scalars['Int']['output']>;
  laneKey?: Maybe<Scalars['String']['output']>;
};

export type ScoToolRuleMetrics = {
  __typename?: 'ScoToolRuleMetrics';
  automatedReplies?: Maybe<Scalars['Int']['output']>;
  correctlyCategorizedPct?: Maybe<Scalars['Float']['output']>;
  dismissed?: Maybe<Scalars['Int']['output']>;
  drafted?: Maybe<Scalars['Int']['output']>;
  editedBeforeSend?: Maybe<Scalars['Int']['output']>;
  held?: Maybe<Scalars['Int']['output']>;
  laneMix?: Maybe<Array<Maybe<ScoToolRuleLaneCount>>>;
  medianFirstReplyMinutes?: Maybe<Scalars['Float']['output']>;
  messagesIn?: Maybe<Scalars['Int']['output']>;
  paragraph?: Maybe<Scalars['String']['output']>;
  recalled?: Maybe<Scalars['Int']['output']>;
  rules?: Maybe<Array<Maybe<ScoToolRuleCount>>>;
  scopeKey?: Maybe<Scalars['String']['output']>;
  scopeLabel?: Maybe<Scalars['String']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
  silent?: Maybe<Scalars['Int']['output']>;
  staffReplies?: Maybe<Scalars['Int']['output']>;
  toolId?: Maybe<Scalars['String']['output']>;
  toolTitle?: Maybe<Scalars['String']['output']>;
  whatIfCount?: Maybe<Scalars['Int']['output']>;
};

export type ScoToolRuleReadiness = {
  __typename?: 'ScoToolRuleReadiness';
  rules?: Maybe<Array<Maybe<ScoToolRuleReadinessRule>>>;
  toolId?: Maybe<Scalars['String']['output']>;
  visibleSenderName?: Maybe<Scalars['String']['output']>;
};

export type ScoToolRuleReadinessRule = {
  __typename?: 'ScoToolRuleReadinessRule';
  blockers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  explanation?: Maybe<Scalars['String']['output']>;
  finalWording?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  statusKey?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
  visibleSenderName?: Maybe<Scalars['String']['output']>;
};

/**
 * One production run: a member message the walker saw for a responder tool.
 * Message text is null unless the query asked for it and the thread is on the desk.
 */
export type ScoToolRuleRun = {
  __typename?: 'ScoToolRuleRun';
  checks?: Maybe<Array<Maybe<ScoToolRuleRunCheck>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decisionSeconds?: Maybe<Scalars['Int']['output']>;
  draftCommentId?: Maybe<Scalars['String']['output']>;
  draftedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBeforeSend?: Maybe<Scalars['Boolean']['output']>;
  evaluatorKey?: Maybe<Scalars['String']['output']>;
  filledVariablesAsJson?: Maybe<Scalars['JSON']['output']>;
  firstReplyAt?: Maybe<Scalars['DateTime']['output']>;
  firstReplyByUserId?: Maybe<Scalars['String']['output']>;
  firstReplyCommentId?: Maybe<Scalars['String']['output']>;
  firstReplyDelayHours?: Maybe<Scalars['Float']['output']>;
  firstReplySnippet?: Maybe<Scalars['String']['output']>;
  handedToSupportAt?: Maybe<Scalars['DateTime']['output']>;
  inboundAt?: Maybe<Scalars['DateTime']['output']>;
  inboundCommentId?: Maybe<Scalars['String']['output']>;
  inboundSnippet?: Maybe<Scalars['String']['output']>;
  inputTokens?: Maybe<Scalars['Int']['output']>;
  laneKey?: Maybe<Scalars['String']['output']>;
  memberDisplayName?: Maybe<Scalars['String']['output']>;
  memberUserId?: Maybe<Scalars['String']['output']>;
  missingKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  modelId?: Maybe<Scalars['String']['output']>;
  operatorLaneKey?: Maybe<Scalars['String']['output']>;
  outboundCommentId?: Maybe<Scalars['String']['output']>;
  outcomeKey?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  probabilitiesAsJson?: Maybe<Scalars['JSON']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  recalledAt?: Maybe<Scalars['DateTime']['output']>;
  replyUserId?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentOriginKey?: Maybe<Scalars['String']['output']>;
  sentSeconds?: Maybe<Scalars['Int']['output']>;
  shadow?: Maybe<Scalars['Boolean']['output']>;
  suggestedBody?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  threadOnDesk?: Maybe<Scalars['Boolean']['output']>;
  toolId?: Maybe<Scalars['String']['output']>;
  toolRuleBindingId?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
  toolRuleRunId?: Maybe<Scalars['String']['output']>;
  winnerName?: Maybe<Scalars['String']['output']>;
  winnerSourceKey?: Maybe<Scalars['String']['output']>;
};

/** One rule the walker considered for a run, in the order it considered them. */
export type ScoToolRuleRunCheck = {
  __typename?: 'ScoToolRuleRunCheck';
  groupKey?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  ruleUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
};

export type ScoToolRuleRunPage = {
  __typename?: 'ScoToolRuleRunPage';
  itemCount?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  runs?: Maybe<Array<Maybe<ScoToolRuleRun>>>;
  summary?: Maybe<ScoToolRuleRunSummary>;
};

/** How many runs one library rule won for a tool in a range. */
export type ScoToolRuleRunRuleCount = {
  __typename?: 'ScoToolRuleRunRuleCount';
  runCount?: Maybe<Scalars['Int']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
};

/**
 * Counts over every run in the filter, not just the page. Scoped to the rule when
 * toolRuleId is set, otherwise to the whole tool. sentCount leaves out recalled runs.
 */
export type ScoToolRuleRunSummary = {
  __typename?: 'ScoToolRuleRunSummary';
  draftedSentCount?: Maybe<Scalars['Int']['output']>;
  editedCount?: Maybe<Scalars['Int']['output']>;
  editedPct?: Maybe<Scalars['Int']['output']>;
  ruleCounts?: Maybe<Array<Maybe<ScoToolRuleRunRuleCount>>>;
  ruleRunCount?: Maybe<Scalars['Int']['output']>;
  sentCount?: Maybe<Scalars['Int']['output']>;
  sharePct?: Maybe<Scalars['Int']['output']>;
  toolRunCount?: Maybe<Scalars['Int']['output']>;
};

export type ScoToolRuleView = {
  __typename?: 'ScoToolRuleView';
  autoSendBlockedBy?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  autoSendBlockedReason?: Maybe<Scalars['String']['output']>;
  barSource?: Maybe<Scalars['String']['output']>;
  binding?: Maybe<ScoToolRuleBinding>;
  boundCount?: Maybe<Scalars['Int']['output']>;
  catchesSource?: Maybe<Scalars['String']['output']>;
  effectiveBar?: Maybe<Scalars['Int']['output']>;
  effectiveCatches?: Maybe<Scalars['String']['output']>;
  effectiveTemplate?: Maybe<Scalars['String']['output']>;
  effectiveTemplateId?: Maybe<Scalars['String']['output']>;
  effectiveTemplateKindKey?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fields?: Maybe<Array<Maybe<ScoToolRuleViewField>>>;
  missingFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recordKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rule?: Maybe<ScoToolRule>;
  templateSource?: Maybe<Scalars['String']['output']>;
  templateSourceKey?: Maybe<Scalars['String']['output']>;
  usedCount?: Maybe<Scalars['Int']['output']>;
  variableKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  variables?: Maybe<Scalars['JSON']['output']>;
};

export type ScoToolRuleViewField = {
  __typename?: 'ScoToolRuleViewField';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  referenced?: Maybe<Scalars['Boolean']['output']>;
  sourceKey?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ScoToolSession = ScoNode & {
  __typename?: 'ScoToolSession';
  attachedTask?: Maybe<ScoTask>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  generatedSummary?: Maybe<Scalars['String']['output']>;
  generatedSummaryUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inputAsJson?: Maybe<Scalars['JSON']['output']>;
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  outputAsJson?: Maybe<Scalars['JSON']['output']>;
  thread?: Maybe<ScoThread>;
  threadId?: Maybe<Scalars['UUID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tool?: Maybe<ScoTool>;
  toolId?: Maybe<Scalars['UUID']['output']>;
  toolSessionId?: Maybe<Scalars['String']['output']>;
  toolUser?: Maybe<ScoUser>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['UUID']['output']>;
};


export type ScoToolSessionGeneratedSummaryArgs = {
  generateIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  generateIfStale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoToolSessionCollection = {
  __typename?: 'ScoToolSessionCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoToolSession>>;
  pagination: Pagination;
};

export type ScoToolSessionUpdatedSubscriptionPayload = {
  __typename?: 'ScoToolSessionUpdatedSubscriptionPayload';
  toolSession?: Maybe<ScoToolSession>;
  toolSessionId?: Maybe<Scalars['String']['output']>;
};

export type ScoToolTestLabel = {
  __typename?: 'ScoToolTestLabel';
  actualLaneKey?: Maybe<Scalars['String']['output']>;
  expectedLaneKey?: Maybe<Scalars['String']['output']>;
  fired?: Maybe<Scalars['Boolean']['output']>;
  fixtureText?: Maybe<Scalars['String']['output']>;
  resultKey?: Maybe<Scalars['String']['output']>;
  toolRuleId?: Maybe<Scalars['String']['output']>;
  toolTestLabelId?: Maybe<Scalars['String']['output']>;
  toolTestRunId?: Maybe<Scalars['String']['output']>;
};

export type ScoToolTestRun = {
  __typename?: 'ScoToolTestRun';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  acceptedByUserId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  firedCount?: Maybe<Scalars['Int']['output']>;
  labels?: Maybe<Array<Maybe<ScoToolTestLabel>>>;
  modelScored?: Maybe<Scalars['Boolean']['output']>;
  notScoredCount?: Maybe<Scalars['Int']['output']>;
  rightCount?: Maybe<Scalars['Int']['output']>;
  scorerModelId?: Maybe<Scalars['String']['output']>;
  startedByUserId?: Maybe<Scalars['String']['output']>;
  toolId?: Maybe<Scalars['String']['output']>;
  toolTestRunId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wrongCount?: Maybe<Scalars['Int']['output']>;
};

export type ScoToolThreadRead = {
  __typename?: 'ScoToolThreadRead';
  accountUserId?: Maybe<Scalars['String']['output']>;
  actorUserId?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  toolThreadReadId?: Maybe<Scalars['String']['output']>;
};

export type ScoToolTriagePayload = {
  __typename?: 'ScoToolTriagePayload';
  counts?: Maybe<ScoCrmQueueCounts>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  lateAfterMinutes?: Maybe<Scalars['Int']['output']>;
  oldestOwed?: Maybe<ScoCrmOldestOwed>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  search?: Maybe<Scalars['String']['output']>;
  threads?: Maybe<Array<Maybe<ScoCrmThread>>>;
};

export type ScoUser = ScoNode & {
  __typename?: 'ScoUser';
  accountGroups?: Maybe<Array<Maybe<ScoAccountGroup>>>;
  activeSprintNotes?: Maybe<Scalars['String']['output']>;
  activeSprintSlug?: Maybe<Scalars['String']['output']>;
  advisorProfile?: Maybe<ScoAdvisorProfile>;
  advisorWilMessageUsage?: Maybe<ScoAdvisorWilMessageUsage>;
  assignedCommunityCoordinator?: Maybe<ScoTeamMember>;
  assignedCommunityCoordinatorKey?: Maybe<Scalars['String']['output']>;
  assignedCommunityOnboarder?: Maybe<ScoTeamMember>;
  assignedCommunityOnboarderKey?: Maybe<Scalars['String']['output']>;
  assignedFGCoordinator?: Maybe<ScoTeamMember>;
  assignedFGCoordinatorKey?: Maybe<Scalars['String']['output']>;
  assignedFGOnboarder?: Maybe<ScoTeamMember>;
  assignedFGOnboarderKey?: Maybe<Scalars['String']['output']>;
  authTokens?: Maybe<Array<Maybe<ScoUserAuthToken>>>;
  bannedAt?: Maybe<Scalars['DateTime']['output']>;
  bannedReason?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  birthdate?: Maybe<Scalars['DateTime']['output']>;
  bootcampEnrollments?: Maybe<Array<Maybe<ScoBootcampEnrollment>>>;
  bootcampShares?: Maybe<Array<Maybe<ScoBootcampShare>>>;
  canInitiateChatThreads?: Maybe<Scalars['Boolean']['output']>;
  canUserDelete?: Maybe<Scalars['Boolean']['output']>;
  canUserEdit?: Maybe<Scalars['Boolean']['output']>;
  coachingEnrollment?: Maybe<CoachingEnrollment>;
  college?: Maybe<Scalars['String']['output']>;
  commitments?: Maybe<Array<Maybe<GroupCommitment>>>;
  company?: Maybe<ScoCompany>;
  contentPermissions?: Maybe<ScoContentPermissions>;
  contentTrackEnrollments?: Maybe<Array<Maybe<ScoContentTrackEnrollment>>>;
  courseEnrollments?: Maybe<Array<Maybe<ScoCourseEnrollment>>>;
  coverPhotoUrl?: Maybe<Scalars['String']['output']>;
  coverPhotoXInPercent?: Maybe<Scalars['Float']['output']>;
  coverPhotoYInPercent?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  /** Desk inbox flag. Read-only. Null unless the viewer is an isScoAdmin or this user. */
  crmEnabled?: Maybe<Scalars['Boolean']['output']>;
  defaultCouponCode?: Maybe<Scalars['String']['output']>;
  deletionRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  deletionRequestedByIpAddress?: Maybe<Scalars['String']['output']>;
  directChatThreadWithCurrentUser?: Maybe<ScoThread>;
  directChatThreads?: Maybe<ScoThreadCollection>;
  directChatThreadsUnreadComments?: Maybe<Array<Maybe<ScoComment>>>;
  directChatThreadsUnreadCommentsCount?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  emailNotificationSchedule?: Maybe<Scalars['String']['output']>;
  emailSenders?: Maybe<ScoEmailSenderCollection>;
  events?: Maybe<Array<Maybe<GroupEvent>>>;
  expertise?: Maybe<Scalars['String']['output']>;
  fgAccountManager?: Maybe<ScoAdvisor>;
  fgAdvisor?: Maybe<ScoAdvisor>;
  fgAirtableMemberRecordIdentifier?: Maybe<Scalars['String']['output']>;
  fgAppliedAt?: Maybe<Scalars['DateTime']['output']>;
  fgLaunchedAt?: Maybe<Scalars['DateTime']['output']>;
  fgOnboardingCallUrl?: Maybe<Scalars['String']['output']>;
  fgSignupAt?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  founderExperience?: Maybe<Scalars['String']['output']>;
  founderNeeds?: Maybe<Scalars['String']['output']>;
  founderNeedsKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  founderNeedsOther?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  groupCommitments?: Maybe<GroupCommitmentCollection>;
  groupMemberships?: Maybe<Array<Maybe<GroupMember>>>;
  groupRequests?: Maybe<GroupRequestCollection>;
  groupTrackSlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groupTrackStatuses?: Maybe<Array<Maybe<GroupTrackStatus>>>;
  groupedNotifications?: Maybe<Array<Maybe<ScoNotification>>>;
  groups?: Maybe<Array<Maybe<Group>>>;
  hasAdvisorBoard?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  inboundFollows?: Maybe<ScoFollowCollection>;
  inboundFollowsCount?: Maybe<Scalars['Int']['output']>;
  intlPhone?: Maybe<Scalars['String']['output']>;
  investorMessageUsage?: Maybe<ScoInvestorMessageUsage>;
  investorSearches?: Maybe<ScoInvestorSearchCollection>;
  isAccountsAdmin?: Maybe<Scalars['Boolean']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isAdvisor?: Maybe<Scalars['Boolean']['output']>;
  isBanned?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this user has Beancounter admin access (can use beancounterPayments/Transactions/Reports admin APIs). */
  isBeancounterAdmin?: Maybe<Scalars['Boolean']['output']>;
  isCoachingConcierge?: Maybe<Scalars['Boolean']['output']>;
  isCommunityLeader?: Maybe<Scalars['Boolean']['output']>;
  isEmailConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  isFinanceAdmin?: Maybe<Scalars['Boolean']['output']>;
  isFollowedByCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  isFollowedByUser?: Maybe<Scalars['Boolean']['output']>;
  isFollowingUser?: Maybe<Scalars['Boolean']['output']>;
  isFounderCommunityMember?: Maybe<Scalars['Boolean']['output']>;
  isFounderCommunityUser?: Maybe<Scalars['Boolean']['output']>;
  isFounderGroupsMember?: Maybe<Scalars['Boolean']['output']>;
  isFounderGroupsUser?: Maybe<Scalars['Boolean']['output']>;
  isGuest?: Maybe<Scalars['Boolean']['output']>;
  isOpenToNetworking?: Maybe<Scalars['Boolean']['output']>;
  isPasswordSet?: Maybe<Scalars['Boolean']['output']>;
  isPhoneConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  /** The users.isScoAdmin column. Not the isAdmin getter. Null unless the viewer is an isScoAdmin or this user. */
  isScoAdmin?: Maybe<Scalars['Boolean']['output']>;
  isStartupsUnlimitedMember?: Maybe<Scalars['Boolean']['output']>;
  isToolUser?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  learningGoals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkedAccounts?: Maybe<Array<Maybe<ScoLinkedAccount>>>;
  linkedBizplanAccounts?: Maybe<Array<Maybe<ScoLinkedAccount>>>;
  linkedLaunchrockAccounts?: Maybe<Array<Maybe<ScoLinkedAccount>>>;
  linkedin?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountry?: Maybe<ScoStaticOption>;
  locationCountryKey?: Maybe<Scalars['String']['output']>;
  locationLatitude?: Maybe<Scalars['String']['output']>;
  locationLongitude?: Maybe<Scalars['String']['output']>;
  locationPostalCode?: Maybe<Scalars['String']['output']>;
  locationState?: Maybe<Scalars['String']['output']>;
  locationStreetLine1?: Maybe<Scalars['String']['output']>;
  locationStreetLine2?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<ScoNotificationCollection>;
  outboundFollows?: Maybe<ScoFollowCollection>;
  outboundFollowsCount?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneCountryCode?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  pitchDecks?: Maybe<ScoPitchDeckCollection>;
  preferredGroupComposition?: Maybe<Scalars['String']['output']>;
  preferredGroupGoals?: Maybe<Scalars['String']['output']>;
  preferredGroupMeetingFrequency?: Maybe<Scalars['String']['output']>;
  preferredGroupModeration?: Maybe<Scalars['String']['output']>;
  preferredGroupVenue?: Maybe<Scalars['String']['output']>;
  preferredInteractions?: Maybe<Scalars['String']['output']>;
  preferredInteractionsKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  profileVisibility?: Maybe<ScoStaticOption>;
  profileVisibilityKey?: Maybe<Scalars['String']['output']>;
  provisionedAccounts?: Maybe<Array<Maybe<ProvisionedAccount>>>;
  publicEmail?: Maybe<Scalars['String']['output']>;
  purchasedProducts?: Maybe<Array<Maybe<ScoProduct>>>;
  qualityRank?: Maybe<Scalars['Int']['output']>;
  receivedEmailMessages?: Maybe<ScoEmailMessageCollection>;
  remainingInvestorContactRequestsCount?: Maybe<Scalars['Int']['output']>;
  remainingMemberChatsCount?: Maybe<Scalars['Int']['output']>;
  /** Responder tool id for this account. Read-only. Null unless the viewer is an isScoAdmin or this user. */
  responderToolId?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<Array<Maybe<GroupMemberReview>>>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rsvps?: Maybe<Array<Maybe<GroupEventAttendance>>>;
  salesEvents?: Maybe<Array<Maybe<ScoSalesEvent>>>;
  salesLead?: Maybe<ScoSalesLead>;
  salesPerson?: Maybe<ScoSalesPerson>;
  sentEmailMessages?: Maybe<ScoEmailMessageCollection>;
  shortBio?: Maybe<Scalars['String']['output']>;
  signupBrand?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Maybe<ScoSkill>>>;
  slug?: Maybe<Scalars['String']['output']>;
  socialConnections?: Maybe<Array<Maybe<SocialConnection>>>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<Maybe<ScoSubscription>>>;
  title?: Maybe<Scalars['String']['output']>;
  tool?: Maybe<ScoTool>;
  toolSessions?: Maybe<ScoToolSessionCollection>;
  twitter?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userExperiences?: Maybe<Array<Maybe<ScoUserExperience>>>;
  userId: Scalars['String']['output'];
  userMemberships?: Maybe<ScoUserMembershipCollection>;
  userPreferences?: Maybe<Array<Maybe<ScoUserPreference>>>;
  userSearches?: Maybe<ScoUserSearchCollection>;
  userSkills?: Maybe<Array<Maybe<ScoUserSkill>>>;
  userToken?: Maybe<Scalars['String']['output']>;
  workExperience?: Maybe<Scalars['String']['output']>;
};


export type ScoUserAuthTokensArgs = {
  includeRevoked?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserCommitmentsArgs = {
  statuses?: InputMaybe<Array<InputMaybe<RequestStatus>>>;
};


export type ScoUserDirectChatThreadWithCurrentUserArgs = {
  createIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserDirectChatThreadsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserEmailSendersArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserEventsArgs = {
  endDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  startDateTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type ScoUserGroupCommitmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type ScoUserGroupRequestsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserGroupedNotificationsArgs = {
  includeEmailedNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  includeUsersOwnPosts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserInboundFollowsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserInvestorSearchesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserIsFollowedByUserArgs = {
  userId: Scalars['String']['input'];
};


export type ScoUserIsFollowingUserArgs = {
  userId: Scalars['String']['input'];
};


export type ScoUserNotificationsArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type ScoUserOutboundFollowsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  followableType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserOutboundFollowsCountArgs = {
  followableType?: InputMaybe<Scalars['String']['input']>;
};


export type ScoUserPitchDecksArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserReceivedEmailMessagesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserSentEmailMessagesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserToolSessionsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserUserExperiencesArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
};


export type ScoUserUserMembershipsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserUserSearchesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserUserSkillsArgs = {
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
};

export type ScoUserAuthToken = ScoNode & {
  __typename?: 'ScoUserAuthToken';
  canRevealToken: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  scope: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
  tokenPrefix: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userAuthTokenId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ScoUserCollection = {
  __typename?: 'ScoUserCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoUser>>;
  pagination: Pagination;
};

export type ScoUserDevice = ScoNode & {
  __typename?: 'ScoUserDevice';
  deviceIdentifier?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceOS?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  expoPushToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  userDeviceId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoUserDirectChatViewedSubscriptionPayload = {
  __typename?: 'ScoUserDirectChatViewedSubscriptionPayload';
  id: Scalars['ID']['output'];
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoUserExperience = ScoNode & {
  __typename?: 'ScoUserExperience';
  accomplishmentDescription?: Maybe<Scalars['String']['output']>;
  accomplishmentTypeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  experienceTypeKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industryKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  organizationName?: Maybe<Scalars['String']['output']>;
  positionDescription?: Maybe<Scalars['String']['output']>;
  positionTitle?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userExperienceId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoUserMatch = ScoNode & {
  __typename?: 'ScoUserMatch';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  directChatThread?: Maybe<ScoThread>;
  id: Scalars['ID']['output'];
  introChatMessage?: Maybe<Scalars['String']['output']>;
  matchExplanation?: Maybe<Scalars['String']['output']>;
  matchFactors?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  matchFactorsAsJSON?: Maybe<Scalars['String']['output']>;
  matchScore?: Maybe<Scalars['Int']['output']>;
  matchScoreAsPercent?: Maybe<Scalars['Float']['output']>;
  ratingBySearchingUser?: Maybe<Scalars['Int']['output']>;
  ratingByTargetUser?: Maybe<Scalars['Int']['output']>;
  ratingNoteBySearchingUser?: Maybe<Scalars['String']['output']>;
  ratingNoteByTargetUser?: Maybe<Scalars['String']['output']>;
  savedBySearchingUserAt?: Maybe<Scalars['DateTime']['output']>;
  savedByTargetUserAt?: Maybe<Scalars['DateTime']['output']>;
  searchingUser?: Maybe<ScoUser>;
  searchingUserId?: Maybe<Scalars['String']['output']>;
  targetUser?: Maybe<ScoUser>;
  targetUserDistanceInMiles?: Maybe<Scalars['Int']['output']>;
  targetUserId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userMatchId?: Maybe<Scalars['String']['output']>;
  userSearch?: Maybe<ScoUserSearch>;
  userSearchId?: Maybe<Scalars['String']['output']>;
};


export type ScoUserMatchDirectChatThreadArgs = {
  createIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserMatchIntroChatMessageArgs = {
  generate?: InputMaybe<Scalars['Boolean']['input']>;
  generateIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserMatchMatchExplanationArgs = {
  generate?: InputMaybe<Scalars['Boolean']['input']>;
  generateIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoUserMatchCollection = {
  __typename?: 'ScoUserMatchCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoUserMatch>>;
  pagination: Pagination;
};

export type ScoUserMembership = ScoNode & {
  __typename?: 'ScoUserMembership';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  attachment?: Maybe<ScoAttachment>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  canComment?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  canView?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<ScoUser>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentToEmail?: Maybe<Scalars['String']['output']>;
  sentToName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
  userMembershipId?: Maybe<Scalars['String']['output']>;
};

export type ScoUserMembershipCollection = {
  __typename?: 'ScoUserMembershipCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoUserMembership>>;
  pagination: Pagination;
};

export type ScoUserMentionOption = ScoNode & {
  __typename?: 'ScoUserMentionOption';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoUserPreference = ScoNode & {
  __typename?: 'ScoUserPreference';
  id: Scalars['ID']['output'];
  preferenceKey?: Maybe<Scalars['String']['output']>;
  preferenceValueAsJson?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
  userPreferenceId?: Maybe<Scalars['String']['output']>;
};

export type ScoUserPresence = ScoNode & {
  __typename?: 'ScoUserPresence';
  attachmentId?: Maybe<Scalars['String']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  isTyping?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<ScoUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoUserSearch = ScoNode & {
  __typename?: 'ScoUserSearch';
  commitmentTypeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  commitmentTypes?: Maybe<ScoStaticOption>;
  compensationTypeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  compensationTypes?: Maybe<ScoStaticOption>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  groupRequest?: Maybe<GroupRequest>;
  id: Scalars['ID']['output'];
  industryKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isMatchEmailEnabled?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountryKey?: Maybe<Scalars['String']['output']>;
  locationLatitude?: Maybe<Scalars['Float']['output']>;
  locationLongitude?: Maybe<Scalars['Float']['output']>;
  locationRadiusInMiles?: Maybe<Scalars['String']['output']>;
  locationState?: Maybe<Scalars['String']['output']>;
  maxMatchScore?: Maybe<Scalars['Int']['output']>;
  naturalLanguagePrompt?: Maybe<Scalars['String']['output']>;
  parameterChecksum?: Maybe<Scalars['String']['output']>;
  parametersAsJSON?: Maybe<Scalars['String']['output']>;
  processingDescription?: Maybe<Scalars['String']['output']>;
  processingStatus?: Maybe<Scalars['String']['output']>;
  processingUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  relevantSkills?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  requiredSkills?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  searchingUser?: Maybe<ScoUser>;
  searchingUserId?: Maybe<Scalars['String']['output']>;
  skillIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  skills?: Maybe<Array<Maybe<ScoSkill>>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userMatches?: Maybe<ScoUserMatchCollection>;
  userRoleKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userRoles?: Maybe<ScoStaticOption>;
  userSearchId?: Maybe<Scalars['String']['output']>;
};


export type ScoUserSearchMaxMatchScoreArgs = {
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ScoUserSearchUserMatchesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paranoid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoUserSearchCollection = {
  __typename?: 'ScoUserSearchCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoUserSearch>>;
  pagination: Pagination;
};

export type ScoUserSearchDraft = ScoNode & {
  __typename?: 'ScoUserSearchDraft';
  id: Scalars['ID']['output'];
  matchedUsers?: Maybe<Array<Maybe<ScoUser>>>;
  matchedUsersCount?: Maybe<Scalars['Int']['output']>;
  naturalLanguagePrompt?: Maybe<Scalars['String']['output']>;
  relevantSkills?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  requiredSkills?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  skillIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ScoUserSearchUpdatedSubscriptionPayload = {
  __typename?: 'ScoUserSearchUpdatedSubscriptionPayload';
  id: Scalars['ID']['output'];
  userSearch?: Maybe<ScoUserSearch>;
  userSearchId?: Maybe<Scalars['String']['output']>;
};

export type ScoUserSkill = ScoNode & {
  __typename?: 'ScoUserSkill';
  category?: Maybe<Scalars['String']['output']>;
  compensationNotes?: Maybe<Scalars['String']['output']>;
  compensationTypeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  compensationUnit?: Maybe<Scalars['String']['output']>;
  compensationValue?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  experienceNotes?: Maybe<Scalars['String']['output']>;
  experienceStrength?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  skill?: Maybe<ScoTag>;
  skillId?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<ScoTag>;
  tagId?: Maybe<Scalars['String']['output']>;
  timeCommitmentNotes?: Maybe<Scalars['String']['output']>;
  timeCommitmentTypeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timeCommitmentUnit?: Maybe<Scalars['String']['output']>;
  timeCommitmentValue?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userRoleKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userSkillId?: Maybe<Scalars['String']['output']>;
};

export type ScoUserVerification = {
  __typename?: 'ScoUserVerification';
  email?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  isEligibleForPartnerBenefits?: Maybe<Scalars['Boolean']['output']>;
};

export type ScoView = ScoNode & {
  __typename?: 'ScoView';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completionAsPercent?: Maybe<Scalars['Int']['output']>;
  contentTrackEnrollment?: Maybe<ScoContentTrackEnrollment>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByIpAddress?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<ScoUser>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  /** This returns a unique compound ID */
  id: Scalars['ID']['output'];
  parentContext?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  parentType?: Maybe<Scalars['String']['output']>;
  playbackPositionInSeconds?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  viewId?: Maybe<Scalars['String']['output']>;
  viewable?: Maybe<ScoNode>;
  viewableAttachment?: Maybe<ScoAttachment>;
  viewableContext?: Maybe<Scalars['String']['output']>;
  viewableId?: Maybe<Scalars['String']['output']>;
  viewableType?: Maybe<Scalars['String']['output']>;
};

export type ScoViewCollection = {
  __typename?: 'ScoViewCollection';
  aggregates: Array<Maybe<AggregateCalculation>>;
  id: Scalars['ID']['output'];
  items: Array<Maybe<ScoView>>;
  pagination: Pagination;
};

export type ScoreToolTestLabelInput = {
  accountAgeDays?: InputMaybe<Scalars['Int']['input']>;
  expectedLaneKey: Scalars['String']['input'];
  fixtureText: Scalars['String']['input'];
};

export type ScoreToolTestRunInput = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  labels: Array<ScoreToolTestLabelInput>;
  toolId?: InputMaybe<Scalars['String']['input']>;
};

export type ScoreToolTestRunPayload = {
  __typename?: 'ScoreToolTestRunPayload';
  toolTestRun?: Maybe<ScoToolTestRun>;
};

export type SendAdvisorAgreementInput = {
  advisorAgreementId?: InputMaybe<Scalars['String']['input']>;
};

export type SendAdvisorAgreementPayload = {
  __typename?: 'SendAdvisorAgreementPayload';
  advisorAgreement?: Maybe<ScoAdvisorAgreement>;
};

export type SendToolMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  inboundCommentId?: InputMaybe<Scalars['String']['input']>;
  seenInboundCommentId?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
  toolId: Scalars['String']['input'];
};

export type SendToolMessagePayload = {
  __typename?: 'SendToolMessagePayload';
  comment?: Maybe<ScoCrmThreadComment>;
  toolMessageAudit?: Maybe<ScoToolMessageAudit>;
};

export type SetCrmBookingUrlInput = {
  accountUserId: Scalars['String']['input'];
  bookingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SetCrmBookingUrlPayload = {
  __typename?: 'SetCrmBookingUrlPayload';
  accountUserId?: Maybe<Scalars['String']['output']>;
  bookingUrl?: Maybe<Scalars['String']['output']>;
  toolId?: Maybe<Scalars['String']['output']>;
};

export type SetCrmToolModelInput = {
  modelKey?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  toolId: Scalars['String']['input'];
};

export type SetCrmToolModelPayload = {
  __typename?: 'SetCrmToolModelPayload';
  responderTool?: Maybe<ScoCrmResponderTool>;
};

export type SetToolReplySettingsInput = {
  bannedWordsAsJson?: InputMaybe<Scalars['JSON']['input']>;
  masterAutoSend?: InputMaybe<Scalars['Boolean']['input']>;
  toolId?: InputMaybe<Scalars['String']['input']>;
  voiceAsMarkdown?: InputMaybe<Scalars['String']['input']>;
};

export type SetToolReplySettingsPayload = {
  __typename?: 'SetToolReplySettingsPayload';
  bannedWordsAsJson?: Maybe<Scalars['JSON']['output']>;
  masterAutoSend?: Maybe<Scalars['Boolean']['output']>;
  toolId?: Maybe<Scalars['String']['output']>;
  voiceAsMarkdown?: Maybe<Scalars['String']['output']>;
};

export type SetToolRuleRunLaneInput = {
  accountUserId?: InputMaybe<Scalars['String']['input']>;
  operatorLaneKey: Scalars['String']['input'];
  toolRuleRunId: Scalars['String']['input'];
};

export type SetToolRuleRunLanePayload = {
  __typename?: 'SetToolRuleRunLanePayload';
  operatorLaneKey?: Maybe<Scalars['String']['output']>;
  toolRuleRunId?: Maybe<Scalars['String']['output']>;
};

export type SetToolServesInput = {
  consent?: InputMaybe<Scalars['Boolean']['input']>;
  servesUserId?: InputMaybe<Scalars['String']['input']>;
  toolId: Scalars['String']['input'];
};

export type SetToolServesPayload = {
  __typename?: 'SetToolServesPayload';
  tool?: Maybe<ScoTool>;
};

export type SetUserCrmInput = {
  crmEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  responderToolId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type SetUserCrmPayload = {
  __typename?: 'SetUserCrmPayload';
  crmEnabled?: Maybe<Scalars['Boolean']['output']>;
  responderToolId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ScoUser>;
};

export type SocialConnection = ScoNode & {
  __typename?: 'SocialConnection';
  accessToken: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  profileDataAsJson: Scalars['String']['output'];
  profileUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  providerUserId: Scalars['String']['output'];
  /** UUID */
  socialConnectionId: Scalars['String']['output'];
  tagline?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

/** Possible values for filtering spam-marked content types. */
export enum SpamFilter {
  /** Return both(all) results */
  Both = 'BOTH',
  /** Only return ham (non-spam) */
  Ham = 'HAM',
  /** Only return spam */
  Spam = 'SPAM'
}

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  Draft = 'DRAFT',
  /** The Published stage is where you can publish your content to. */
  Published = 'PUBLISHED'
}

export type StartCrmThreadInput = {
  accountUserId: Scalars['String']['input'];
  memberUserId: Scalars['String']['input'];
};

export type StartCrmThreadPayload = {
  __typename?: 'StartCrmThreadPayload';
  accountUserId?: Maybe<Scalars['String']['output']>;
  /** True when a new direct chat was made; false when theirs already existed. */
  created?: Maybe<Scalars['Boolean']['output']>;
  memberUserId?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type StartLegacySubscriptionInput = {
  additionalHubspotFormKey?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  bypassHubspot?: InputMaybe<Scalars['Boolean']['input']>;
  cardCvv?: InputMaybe<Scalars['String']['input']>;
  cardExpiration?: InputMaybe<Scalars['String']['input']>;
  cardExpirationMonth?: InputMaybe<Scalars['String']['input']>;
  cardExpirationYear?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  cardPostalCode?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  noAuth?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pricePointId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  subscribableId?: InputMaybe<Scalars['String']['input']>;
  subscribableType?: InputMaybe<Scalars['String']['input']>;
};

export type StartLegacySubscriptionPayload = {
  __typename?: 'StartLegacySubscriptionPayload';
  nextActionUrl?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<ScoSubscription>;
  user?: Maybe<ScoUser>;
};

export type StripeCustomer = ScoNode & {
  __typename?: 'StripeCustomer';
  dataAsJson?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
};

export type StripePaymentIntent = ScoNode & {
  __typename?: 'StripePaymentIntent';
  dataAsJson?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
};

export type StripeSetupIntent = ScoNode & {
  __typename?: 'StripeSetupIntent';
  dataAsJson?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeSetupIntentId?: Maybe<Scalars['String']['output']>;
};

export type SubmitAwsActivateRequestInput = {
  hubspotFormKey?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitAwsActivateRequestPayload = {
  __typename?: 'SubmitAwsActivateRequestPayload';
  user: ScoUser;
};

export type SubmitCheckoutInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  bypassHubspot?: InputMaybe<Scalars['Boolean']['input']>;
  chargebeePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  chargebeePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  chargebeeToken?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hubspotFormKey?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  noAuth?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pricePointId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  requirePaymentIntent?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentIntentReturnUrl?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  subscribableId?: InputMaybe<Scalars['String']['input']>;
  subscribableType?: InputMaybe<Scalars['String']['input']>;
  termId?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitCheckoutPayload = {
  __typename?: 'SubmitCheckoutPayload';
  chargebeeDataAsJson?: Maybe<Scalars['String']['output']>;
  chargebeePaymentIntentId?: Maybe<Scalars['String']['output']>;
  nextActionUrl?: Maybe<Scalars['String']['output']>;
  stripeDataAsJson?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentStatus?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<ScoSubscription>;
  user?: Maybe<ScoUser>;
};

export type SubmitCoachEntryInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  whatsYourBiggestChallenge?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitFinancingApplicationInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  birthdateDay?: InputMaybe<Scalars['String']['input']>;
  birthdateMonth?: InputMaybe<Scalars['String']['input']>;
  birthdateYear?: InputMaybe<Scalars['String']['input']>;
  cardCvv?: InputMaybe<Scalars['String']['input']>;
  cardExpirationMonth?: InputMaybe<Scalars['String']['input']>;
  cardExpirationYear?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identificationCardNumber?: InputMaybe<Scalars['String']['input']>;
  identificationCardState?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitFinancingApplicationPayload = {
  __typename?: 'SubmitFinancingApplicationPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SubmitGroupRequestInput = {
  groupRequestId: Scalars['String']['input'];
};

export type SubmitGroupRequestPayload = {
  __typename?: 'SubmitGroupRequestPayload';
  groupRequest?: Maybe<GroupRequest>;
};

export type SubmitHubspotFormInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  formFieldsAsJson?: InputMaybe<Scalars['JSON']['input']>;
  hubspotFormId: Scalars['String']['input'];
};

export type SubmitHubspotFormPayload = {
  __typename?: 'SubmitHubspotFormPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SubmitHubspotNoteInput = {
  email: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitHubspotNotePayload = {
  __typename?: 'SubmitHubspotNotePayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SubmitPitchDeckRequestInput = {
  companyFundingGoalInDollars?: InputMaybe<Scalars['String']['input']>;
  companyFundingStageKey?: InputMaybe<Scalars['String']['input']>;
  companyIndustryKey?: InputMaybe<Scalars['String']['input']>;
  companyLocation?: InputMaybe<Scalars['String']['input']>;
  companyLocationCity?: InputMaybe<Scalars['String']['input']>;
  companyLocationCountryKey?: InputMaybe<Scalars['String']['input']>;
  companyLocationState?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyPitchDeckNote?: InputMaybe<Scalars['String']['input']>;
  companyPitchDeckUrl?: InputMaybe<Scalars['String']['input']>;
  hubspotFormKey?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitPitchDeckRequestPayload = {
  __typename?: 'SubmitPitchDeckRequestPayload';
  company?: Maybe<ScoCompany>;
  success?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<ScoUser>;
};

export type SubmitPurchaseInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  actionEffectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  bypassHubspot?: InputMaybe<Scalars['Boolean']['input']>;
  chargebeePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  chargebeeToken?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hubspotFormKey?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  noAuth?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pricePointId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  subscribableId?: InputMaybe<Scalars['String']['input']>;
  subscribableType?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitPurchasePayload = {
  __typename?: 'SubmitPurchasePayload';
  nextActionUrl?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<ScoSubscription>;
  user?: Maybe<ScoUser>;
};

export type SubmitScoCustomerKnownIntakeInput = {
  customerSearchId: Scalars['String']['input'];
  knownWhere?: InputMaybe<Scalars['String']['input']>;
  knownWho?: InputMaybe<Scalars['String']['input']>;
  knownWords?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitScoCustomerKnownIntakePayload = {
  __typename?: 'SubmitScoCustomerKnownIntakePayload';
  customerSearch?: Maybe<ScoCustomerSearch>;
  customerSearchRun?: Maybe<ScoCustomerSearchRun>;
  gaps?: Maybe<Array<Maybe<ScoCustomerKnownIntakeGap>>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  helloWorld?: Maybe<HelloWorldSubscriptionPayload>;
  scoAiActionUpdated?: Maybe<ScoAiActionUpdatedSubscriptionPayload>;
  scoAttachmentUserPresence?: Maybe<ScoAttachmentUserPresenceSubscriptionPayload>;
  scoCustomerSearchUpdated?: Maybe<ScoCustomerSearchUpdatedSubscriptionPayload>;
  scoInboxThread?: Maybe<ScoInboxThreadSubscriptionPayload>;
  scoInvestorSearchUpdated?: Maybe<ScoInvestorSearchUpdatedSubscriptionPayload>;
  scoPitchDeckAuditUpdated?: Maybe<ScoPitchDeckAuditUpdatedSubscriptionPayload>;
  scoPitchDeckUpdated?: Maybe<ScoPitchDeckUpdatedSubscriptionPayload>;
  scoSignupRequestUpdated?: Maybe<ScoSignupRequestUpdatedSubscriptionPayload>;
  scoThreadComment?: Maybe<ScoThreadCommentSubscriptionPayload>;
  scoToolSessionUpdated?: Maybe<ScoToolSessionUpdatedSubscriptionPayload>;
  scoUserDirectChatViewed?: Maybe<ScoUserDirectChatViewedSubscriptionPayload>;
  scoUserSearchUpdated?: Maybe<ScoUserSearchUpdatedSubscriptionPayload>;
};


export type SubscriptionHelloWorldArgs = {
  something?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionScoAiActionUpdatedArgs = {
  aiActionId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionScoAttachmentUserPresenceArgs = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionScoCustomerSearchUpdatedArgs = {
  customerSearchId: Scalars['String']['input'];
};


export type SubscriptionScoInvestorSearchUpdatedArgs = {
  investorSearchId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionScoPitchDeckAuditUpdatedArgs = {
  pitchDeckAuditId: Scalars['String']['input'];
};


export type SubscriptionScoPitchDeckUpdatedArgs = {
  pitchDeckId: Scalars['String']['input'];
};


export type SubscriptionScoSignupRequestUpdatedArgs = {
  signupRequestId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionScoThreadCommentArgs = {
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
};


export type SubscriptionScoToolSessionUpdatedArgs = {
  toolSessionId: Scalars['String']['input'];
};


export type SubscriptionScoUserDirectChatViewedArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionScoUserSearchUpdatedArgs = {
  userSearchId?: InputMaybe<Scalars['String']['input']>;
};

export type SupportArticle = Entity & Node & {
  __typename?: 'SupportArticle';
  body?: Maybe<Scalars['String']['output']>;
  category?: Maybe<SupportCategory>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SupportArticle>;
  /** List of SupportArticle versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  product?: Maybe<ProductName>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SupportArticleCategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SupportArticleCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SupportArticleDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SupportArticleHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SupportArticleProductArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SupportArticlePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SupportArticleScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SupportArticleUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SupportArticleConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SupportArticleWhereUniqueInput;
};

/** A connection to a list of items. */
export type SupportArticleConnection = {
  __typename?: 'SupportArticleConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SupportArticleEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SupportArticleCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<SupportCategoryCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  product?: InputMaybe<ProductNameCreateOneInlineInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SupportArticleCreateManyInlineInput = {
  /** Connect multiple existing SupportArticle documents */
  connect?: InputMaybe<Array<SupportArticleWhereUniqueInput>>;
  /** Create and connect multiple existing SupportArticle documents */
  create?: InputMaybe<Array<SupportArticleCreateInput>>;
};

export type SupportArticleCreateOneInlineInput = {
  /** Connect one existing SupportArticle document */
  connect?: InputMaybe<SupportArticleWhereUniqueInput>;
  /** Create and connect one SupportArticle document */
  create?: InputMaybe<SupportArticleCreateInput>;
};

/** An edge in a connection. */
export type SupportArticleEdge = {
  __typename?: 'SupportArticleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SupportArticle;
};

/** Identifies documents */
export type SupportArticleManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SupportArticleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SupportArticleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SupportArticleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<SupportCategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SupportArticleWhereStageInput>;
  documentInStages_none?: InputMaybe<SupportArticleWhereStageInput>;
  documentInStages_some?: InputMaybe<SupportArticleWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<ProductNameWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SupportArticleOrderByInput {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SupportArticleUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<SupportCategoryUpdateOneInlineInput>;
  product?: InputMaybe<ProductNameUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SupportArticleUpdateManyInlineInput = {
  /** Connect multiple existing SupportArticle documents */
  connect?: InputMaybe<Array<SupportArticleConnectInput>>;
  /** Create and connect multiple SupportArticle documents */
  create?: InputMaybe<Array<SupportArticleCreateInput>>;
  /** Delete multiple SupportArticle documents */
  delete?: InputMaybe<Array<SupportArticleWhereUniqueInput>>;
  /** Disconnect multiple SupportArticle documents */
  disconnect?: InputMaybe<Array<SupportArticleWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SupportArticle documents */
  set?: InputMaybe<Array<SupportArticleWhereUniqueInput>>;
  /** Update multiple SupportArticle documents */
  update?: InputMaybe<Array<SupportArticleUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SupportArticle documents */
  upsert?: InputMaybe<Array<SupportArticleUpsertWithNestedWhereUniqueInput>>;
};

export type SupportArticleUpdateManyInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SupportArticleUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SupportArticleUpdateManyInput;
  /** Document search */
  where: SupportArticleWhereInput;
};

export type SupportArticleUpdateOneInlineInput = {
  /** Connect existing SupportArticle document */
  connect?: InputMaybe<SupportArticleWhereUniqueInput>;
  /** Create and connect one SupportArticle document */
  create?: InputMaybe<SupportArticleCreateInput>;
  /** Delete currently connected SupportArticle document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SupportArticle document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SupportArticle document */
  update?: InputMaybe<SupportArticleUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SupportArticle document */
  upsert?: InputMaybe<SupportArticleUpsertWithNestedWhereUniqueInput>;
};

export type SupportArticleUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SupportArticleUpdateInput;
  /** Unique document search */
  where: SupportArticleWhereUniqueInput;
};

export type SupportArticleUpsertInput = {
  /** Create document if it didn't exist */
  create: SupportArticleCreateInput;
  /** Update document if it exists */
  update: SupportArticleUpdateInput;
};

export type SupportArticleUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SupportArticleUpsertInput;
  /** Unique document search */
  where: SupportArticleWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SupportArticleWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SupportArticleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SupportArticleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SupportArticleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SupportArticleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<SupportCategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SupportArticleWhereStageInput>;
  documentInStages_none?: InputMaybe<SupportArticleWhereStageInput>;
  documentInStages_some?: InputMaybe<SupportArticleWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<ProductNameWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SupportArticleWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SupportArticleWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SupportArticleWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SupportArticleWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SupportArticleWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SupportArticle record uniquely */
export type SupportArticleWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type SupportCategory = Entity & Node & {
  __typename?: 'SupportCategory';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SupportCategory>;
  /** List of SupportCategory versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  supportArticles: Array<SupportArticle>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SupportCategoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SupportCategoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SupportCategoryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SupportCategoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SupportCategoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SupportCategorySupportArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SupportArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SupportArticleWhereInput>;
};


export type SupportCategoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SupportCategoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SupportCategoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type SupportCategoryConnection = {
  __typename?: 'SupportCategoryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SupportCategoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SupportCategoryCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  supportArticles?: InputMaybe<SupportArticleCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SupportCategoryCreateManyInlineInput = {
  /** Connect multiple existing SupportCategory documents */
  connect?: InputMaybe<Array<SupportCategoryWhereUniqueInput>>;
  /** Create and connect multiple existing SupportCategory documents */
  create?: InputMaybe<Array<SupportCategoryCreateInput>>;
};

export type SupportCategoryCreateOneInlineInput = {
  /** Connect one existing SupportCategory document */
  connect?: InputMaybe<SupportCategoryWhereUniqueInput>;
  /** Create and connect one SupportCategory document */
  create?: InputMaybe<SupportCategoryCreateInput>;
};

/** An edge in a connection. */
export type SupportCategoryEdge = {
  __typename?: 'SupportCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SupportCategory;
};

/** Identifies documents */
export type SupportCategoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SupportCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SupportCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SupportCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SupportCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<SupportCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<SupportCategoryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  supportArticles_every?: InputMaybe<SupportArticleWhereInput>;
  supportArticles_none?: InputMaybe<SupportArticleWhereInput>;
  supportArticles_some?: InputMaybe<SupportArticleWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SupportCategoryOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SupportCategoryUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  supportArticles?: InputMaybe<SupportArticleUpdateManyInlineInput>;
};

export type SupportCategoryUpdateManyInlineInput = {
  /** Connect multiple existing SupportCategory documents */
  connect?: InputMaybe<Array<SupportCategoryConnectInput>>;
  /** Create and connect multiple SupportCategory documents */
  create?: InputMaybe<Array<SupportCategoryCreateInput>>;
  /** Delete multiple SupportCategory documents */
  delete?: InputMaybe<Array<SupportCategoryWhereUniqueInput>>;
  /** Disconnect multiple SupportCategory documents */
  disconnect?: InputMaybe<Array<SupportCategoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SupportCategory documents */
  set?: InputMaybe<Array<SupportCategoryWhereUniqueInput>>;
  /** Update multiple SupportCategory documents */
  update?: InputMaybe<Array<SupportCategoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SupportCategory documents */
  upsert?: InputMaybe<Array<SupportCategoryUpsertWithNestedWhereUniqueInput>>;
};

export type SupportCategoryUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type SupportCategoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SupportCategoryUpdateManyInput;
  /** Document search */
  where: SupportCategoryWhereInput;
};

export type SupportCategoryUpdateOneInlineInput = {
  /** Connect existing SupportCategory document */
  connect?: InputMaybe<SupportCategoryWhereUniqueInput>;
  /** Create and connect one SupportCategory document */
  create?: InputMaybe<SupportCategoryCreateInput>;
  /** Delete currently connected SupportCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SupportCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SupportCategory document */
  update?: InputMaybe<SupportCategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SupportCategory document */
  upsert?: InputMaybe<SupportCategoryUpsertWithNestedWhereUniqueInput>;
};

export type SupportCategoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SupportCategoryUpdateInput;
  /** Unique document search */
  where: SupportCategoryWhereUniqueInput;
};

export type SupportCategoryUpsertInput = {
  /** Create document if it didn't exist */
  create: SupportCategoryCreateInput;
  /** Update document if it exists */
  update: SupportCategoryUpdateInput;
};

export type SupportCategoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SupportCategoryUpsertInput;
  /** Unique document search */
  where: SupportCategoryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SupportCategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SupportCategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SupportCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SupportCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SupportCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SupportCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<SupportCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<SupportCategoryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  supportArticles_every?: InputMaybe<SupportArticleWhereInput>;
  supportArticles_none?: InputMaybe<SupportArticleWhereInput>;
  supportArticles_some?: InputMaybe<SupportArticleWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SupportCategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SupportCategoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SupportCategoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SupportCategoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SupportCategoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SupportCategory record uniquely */
export type SupportCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type SyncAdvisorAgreementSignatureInput = {
  advisorAgreementId?: InputMaybe<Scalars['String']['input']>;
};

export type SyncAdvisorAgreementSignaturePayload = {
  __typename?: 'SyncAdvisorAgreementSignaturePayload';
  advisorAgreement?: Maybe<ScoAdvisorAgreement>;
};

export type SyncFgProfileInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SyncFgProfilePayload = {
  __typename?: 'SyncFGProfilePayload';
  redirectTo?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ScoUser>;
};

export type SyncRagCollectionInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  ragCollectionId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SyncRagCollectionPayload = {
  __typename?: 'SyncRagCollectionPayload';
  errorCount?: Maybe<Scalars['Int']['output']>;
  ragCollection?: Maybe<ScoRagCollection>;
  syncedCount?: Maybe<Scalars['Int']['output']>;
};

export enum SystemDateTimeFieldVariation {
  Base = 'BASE',
  Combined = 'COMBINED',
  Localization = 'LOCALIZATION'
}

export type Term = Entity & Node & {
  __typename?: 'Term';
  articles: Array<Article>;
  benefits: Array<Benefit>;
  body?: Maybe<Scalars['String']['output']>;
  businessStage?: Maybe<BusinessStage>;
  color?: Maybe<Color>;
  contentTracks: Array<ContentTrack>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<Term>;
  founderTracks: Array<FounderTrack>;
  /** List of Term versions */
  history: Array<Version>;
  icon?: Maybe<Asset>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  isLexicon?: Maybe<Scalars['Boolean']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  person: Array<Person>;
  podcastEpisodes: Array<PodcastEpisode>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  term?: Maybe<Term>;
  terms: Array<Term>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  videoCourses: Array<VideoCourse>;
  videoLessons: Array<VideoLesson>;
  videoLists: Array<VideoList>;
  videoPlaylists: Array<VideoPlaylist>;
  videos: Array<Video>;
  weight?: Maybe<Scalars['Int']['output']>;
};


export type TermArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ArticleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};


export type TermBenefitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BenefitOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BenefitWhereInput>;
};


export type TermBusinessStageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TermContentTracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContentTrackOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTrackWhereInput>;
};


export type TermCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TermDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TermFounderTracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FounderTrackOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FounderTrackWhereInput>;
};


export type TermHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TermIconArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type TermPersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PersonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonWhereInput>;
};


export type TermPodcastEpisodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PodcastEpisodeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PodcastEpisodeWhereInput>;
};


export type TermPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TermScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TermTermArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TermTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


export type TermUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TermVideoCoursesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoCourseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoCourseWhereInput>;
};


export type TermVideoLessonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoLessonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoLessonWhereInput>;
};


export type TermVideoListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoListWhereInput>;
};


export type TermVideoPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoPlaylistOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoPlaylistWhereInput>;
};


export type TermVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoWhereInput>;
};

export type TermConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TermWhereUniqueInput;
};

/** A connection to a list of items. */
export type TermConnection = {
  __typename?: 'TermConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TermEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TermCreateInput = {
  articles?: InputMaybe<ArticleCreateManyInlineInput>;
  benefits?: InputMaybe<BenefitCreateManyInlineInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  businessStage?: InputMaybe<BusinessStageCreateOneInlineInput>;
  color?: InputMaybe<ColorInput>;
  contentTracks?: InputMaybe<ContentTrackCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  founderTracks?: InputMaybe<FounderTrackCreateManyInlineInput>;
  icon?: InputMaybe<AssetCreateOneInlineInput>;
  isLexicon?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  person?: InputMaybe<PersonCreateManyInlineInput>;
  podcastEpisodes?: InputMaybe<PodcastEpisodeCreateManyInlineInput>;
  slug: Scalars['String']['input'];
  term?: InputMaybe<TermCreateOneInlineInput>;
  terms?: InputMaybe<TermCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoCourses?: InputMaybe<VideoCourseCreateManyInlineInput>;
  videoLessons?: InputMaybe<VideoLessonCreateManyInlineInput>;
  videoLists?: InputMaybe<VideoListCreateManyInlineInput>;
  videoPlaylists?: InputMaybe<VideoPlaylistCreateManyInlineInput>;
  videos?: InputMaybe<VideoCreateManyInlineInput>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type TermCreateManyInlineInput = {
  /** Connect multiple existing Term documents */
  connect?: InputMaybe<Array<TermWhereUniqueInput>>;
  /** Create and connect multiple existing Term documents */
  create?: InputMaybe<Array<TermCreateInput>>;
};

export type TermCreateOneInlineInput = {
  /** Connect one existing Term document */
  connect?: InputMaybe<TermWhereUniqueInput>;
  /** Create and connect one Term document */
  create?: InputMaybe<TermCreateInput>;
};

/** An edge in a connection. */
export type TermEdge = {
  __typename?: 'TermEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Term;
};

/** Identifies documents */
export type TermManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TermWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TermWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TermWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  benefits_every?: InputMaybe<BenefitWhereInput>;
  benefits_none?: InputMaybe<BenefitWhereInput>;
  benefits_some?: InputMaybe<BenefitWhereInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  businessStage?: InputMaybe<BusinessStageWhereInput>;
  contentTracks_every?: InputMaybe<ContentTrackWhereInput>;
  contentTracks_none?: InputMaybe<ContentTrackWhereInput>;
  contentTracks_some?: InputMaybe<ContentTrackWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<TermWhereStageInput>;
  documentInStages_none?: InputMaybe<TermWhereStageInput>;
  documentInStages_some?: InputMaybe<TermWhereStageInput>;
  founderTracks_every?: InputMaybe<FounderTrackWhereInput>;
  founderTracks_none?: InputMaybe<FounderTrackWhereInput>;
  founderTracks_some?: InputMaybe<FounderTrackWhereInput>;
  icon?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isLexicon?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isLexicon_not?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isPrimary_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  person_every?: InputMaybe<PersonWhereInput>;
  person_none?: InputMaybe<PersonWhereInput>;
  person_some?: InputMaybe<PersonWhereInput>;
  podcastEpisodes_every?: InputMaybe<PodcastEpisodeWhereInput>;
  podcastEpisodes_none?: InputMaybe<PodcastEpisodeWhereInput>;
  podcastEpisodes_some?: InputMaybe<PodcastEpisodeWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<TermWhereInput>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoCourses_every?: InputMaybe<VideoCourseWhereInput>;
  videoCourses_none?: InputMaybe<VideoCourseWhereInput>;
  videoCourses_some?: InputMaybe<VideoCourseWhereInput>;
  videoLessons_every?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_none?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_some?: InputMaybe<VideoLessonWhereInput>;
  videoLists_every?: InputMaybe<VideoListWhereInput>;
  videoLists_none?: InputMaybe<VideoListWhereInput>;
  videoLists_some?: InputMaybe<VideoListWhereInput>;
  videoPlaylists_every?: InputMaybe<VideoPlaylistWhereInput>;
  videoPlaylists_none?: InputMaybe<VideoPlaylistWhereInput>;
  videoPlaylists_some?: InputMaybe<VideoPlaylistWhereInput>;
  videos_every?: InputMaybe<VideoWhereInput>;
  videos_none?: InputMaybe<VideoWhereInput>;
  videos_some?: InputMaybe<VideoWhereInput>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  weight_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  weight_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  weight_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  weight_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  weight_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  weight_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  weight_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum TermOrderByInput {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsLexiconAsc = 'isLexicon_ASC',
  IsLexiconDesc = 'isLexicon_DESC',
  IsPrimaryAsc = 'isPrimary_ASC',
  IsPrimaryDesc = 'isPrimary_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WeightAsc = 'weight_ASC',
  WeightDesc = 'weight_DESC'
}

export type TermUpdateInput = {
  articles?: InputMaybe<ArticleUpdateManyInlineInput>;
  benefits?: InputMaybe<BenefitUpdateManyInlineInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  businessStage?: InputMaybe<BusinessStageUpdateOneInlineInput>;
  color?: InputMaybe<ColorInput>;
  contentTracks?: InputMaybe<ContentTrackUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  founderTracks?: InputMaybe<FounderTrackUpdateManyInlineInput>;
  icon?: InputMaybe<AssetUpdateOneInlineInput>;
  isLexicon?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<PersonUpdateManyInlineInput>;
  podcastEpisodes?: InputMaybe<PodcastEpisodeUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<TermUpdateOneInlineInput>;
  terms?: InputMaybe<TermUpdateManyInlineInput>;
  videoCourses?: InputMaybe<VideoCourseUpdateManyInlineInput>;
  videoLessons?: InputMaybe<VideoLessonUpdateManyInlineInput>;
  videoLists?: InputMaybe<VideoListUpdateManyInlineInput>;
  videoPlaylists?: InputMaybe<VideoPlaylistUpdateManyInlineInput>;
  videos?: InputMaybe<VideoUpdateManyInlineInput>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type TermUpdateManyInlineInput = {
  /** Connect multiple existing Term documents */
  connect?: InputMaybe<Array<TermConnectInput>>;
  /** Create and connect multiple Term documents */
  create?: InputMaybe<Array<TermCreateInput>>;
  /** Delete multiple Term documents */
  delete?: InputMaybe<Array<TermWhereUniqueInput>>;
  /** Disconnect multiple Term documents */
  disconnect?: InputMaybe<Array<TermWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Term documents */
  set?: InputMaybe<Array<TermWhereUniqueInput>>;
  /** Update multiple Term documents */
  update?: InputMaybe<Array<TermUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Term documents */
  upsert?: InputMaybe<Array<TermUpsertWithNestedWhereUniqueInput>>;
};

export type TermUpdateManyInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<ColorInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  isLexicon?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type TermUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TermUpdateManyInput;
  /** Document search */
  where: TermWhereInput;
};

export type TermUpdateOneInlineInput = {
  /** Connect existing Term document */
  connect?: InputMaybe<TermWhereUniqueInput>;
  /** Create and connect one Term document */
  create?: InputMaybe<TermCreateInput>;
  /** Delete currently connected Term document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Term document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Term document */
  update?: InputMaybe<TermUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Term document */
  upsert?: InputMaybe<TermUpsertWithNestedWhereUniqueInput>;
};

export type TermUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TermUpdateInput;
  /** Unique document search */
  where: TermWhereUniqueInput;
};

export type TermUpsertInput = {
  /** Create document if it didn't exist */
  create: TermCreateInput;
  /** Update document if it exists */
  update: TermUpdateInput;
};

export type TermUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TermUpsertInput;
  /** Unique document search */
  where: TermWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TermWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TermWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TermWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TermWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TermWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articles_every?: InputMaybe<ArticleWhereInput>;
  articles_none?: InputMaybe<ArticleWhereInput>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  benefits_every?: InputMaybe<BenefitWhereInput>;
  benefits_none?: InputMaybe<BenefitWhereInput>;
  benefits_some?: InputMaybe<BenefitWhereInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  businessStage?: InputMaybe<BusinessStageWhereInput>;
  contentTracks_every?: InputMaybe<ContentTrackWhereInput>;
  contentTracks_none?: InputMaybe<ContentTrackWhereInput>;
  contentTracks_some?: InputMaybe<ContentTrackWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<TermWhereStageInput>;
  documentInStages_none?: InputMaybe<TermWhereStageInput>;
  documentInStages_some?: InputMaybe<TermWhereStageInput>;
  founderTracks_every?: InputMaybe<FounderTrackWhereInput>;
  founderTracks_none?: InputMaybe<FounderTrackWhereInput>;
  founderTracks_some?: InputMaybe<FounderTrackWhereInput>;
  icon?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isLexicon?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isLexicon_not?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isPrimary_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  person_every?: InputMaybe<PersonWhereInput>;
  person_none?: InputMaybe<PersonWhereInput>;
  person_some?: InputMaybe<PersonWhereInput>;
  podcastEpisodes_every?: InputMaybe<PodcastEpisodeWhereInput>;
  podcastEpisodes_none?: InputMaybe<PodcastEpisodeWhereInput>;
  podcastEpisodes_some?: InputMaybe<PodcastEpisodeWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<TermWhereInput>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoCourses_every?: InputMaybe<VideoCourseWhereInput>;
  videoCourses_none?: InputMaybe<VideoCourseWhereInput>;
  videoCourses_some?: InputMaybe<VideoCourseWhereInput>;
  videoLessons_every?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_none?: InputMaybe<VideoLessonWhereInput>;
  videoLessons_some?: InputMaybe<VideoLessonWhereInput>;
  videoLists_every?: InputMaybe<VideoListWhereInput>;
  videoLists_none?: InputMaybe<VideoListWhereInput>;
  videoLists_some?: InputMaybe<VideoListWhereInput>;
  videoPlaylists_every?: InputMaybe<VideoPlaylistWhereInput>;
  videoPlaylists_none?: InputMaybe<VideoPlaylistWhereInput>;
  videoPlaylists_some?: InputMaybe<VideoPlaylistWhereInput>;
  videos_every?: InputMaybe<VideoWhereInput>;
  videos_none?: InputMaybe<VideoWhereInput>;
  videos_some?: InputMaybe<VideoWhereInput>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  weight_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  weight_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  weight_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  weight_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  weight_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  weight_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  weight_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TermWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TermWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TermWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TermWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TermWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Term record uniquely */
export type TermWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleCommentFeaturedInput = {
  commentId?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleCommentFeaturedPayload = {
  __typename?: 'ToggleCommentFeaturedPayload';
  comment?: Maybe<ScoComment>;
};

export type ToggleCommentIsSpamInput = {
  commentId?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleCommentIsSpamPayload = {
  __typename?: 'ToggleCommentIsSpamPayload';
  comment?: Maybe<ScoComment>;
};

export type ToggleFlagInput = {
  flaggableId: Scalars['String']['input'];
  flaggableType: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleFlagPayload = {
  __typename?: 'ToggleFlagPayload';
  comment?: Maybe<ScoComment>;
  flag?: Maybe<ScoFlag>;
  thread?: Maybe<ScoThread>;
};

export type ToggleFollowInput = {
  followableId: Scalars['String']['input'];
  followableType: Scalars['String']['input'];
};

export type ToggleFollowPayload = {
  __typename?: 'ToggleFollowPayload';
  comment?: Maybe<ScoComment>;
  follow?: Maybe<ScoFollow>;
  thread?: Maybe<ScoThread>;
  user?: Maybe<ScoUser>;
  wasCreated?: Maybe<Scalars['Boolean']['output']>;
  wasDeleted?: Maybe<Scalars['Boolean']['output']>;
};

export type ToggleGroupModeratorInput = {
  groupMemberId: Scalars['String']['input'];
};

export type ToggleGroupModeratorPayload = {
  __typename?: 'ToggleGroupModeratorPayload';
  group?: Maybe<Group>;
  membership?: Maybe<GroupMember>;
};

export type ToggleInvestorProfileUserRequestInput = {
  investorProfileContactId: Scalars['String']['input'];
  investorProfileId: Scalars['String']['input'];
};

export type ToggleInvestorProfileUserRequestPayload = {
  __typename?: 'ToggleInvestorProfileUserRequestPayload';
  investorProfile?: Maybe<ScoInvestorProfile>;
  viewer?: Maybe<Viewer>;
};

export type ToggleInvestorProfileUserSaveInput = {
  investorProfileContactId?: InputMaybe<Scalars['String']['input']>;
  investorProfileId: Scalars['String']['input'];
};

export type ToggleInvestorProfileUserSavePayload = {
  __typename?: 'ToggleInvestorProfileUserSavePayload';
  investorProfile?: Maybe<ScoInvestorProfile>;
  viewer?: Maybe<Viewer>;
};

export type ToggleLikeInput = {
  likeableId: Scalars['String']['input'];
  likeableType: Scalars['String']['input'];
};

export type ToggleLikePayload = {
  __typename?: 'ToggleLikePayload';
  comment?: Maybe<ScoComment>;
  like?: Maybe<ScoLike>;
  likeable?: Maybe<ScoLikeable>;
  thread?: Maybe<ScoThread>;
};

export type ToggleThreadFeaturedInput = {
  threadId?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleThreadFeaturedPayload = {
  __typename?: 'ToggleThreadFeaturedPayload';
  thread?: Maybe<ScoThread>;
};

export type ToggleThreadIsSpamInput = {
  threadId?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleThreadIsSpamPayload = {
  __typename?: 'ToggleThreadIsSpamPayload';
  thread?: Maybe<ScoThread>;
};

export type ToolReplyTemplateFieldInput = {
  key: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A Chargify transaction */
export type Transaction = ScoNode & {
  __typename?: 'Transaction';
  amountInCents?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  endingBalanceInCents?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  startingBalanceInCents?: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['Int']['output'];
  success?: Maybe<Scalars['String']['output']>;
  transactionId: Scalars['Int']['output'];
  transactionType?: Maybe<Scalars['String']['output']>;
};

export type UndoToolStudioEditInput = {
  revisionId: Scalars['String']['input'];
};

export type UndoToolStudioEditPayload = {
  __typename?: 'UndoToolStudioEditPayload';
  revisionId?: Maybe<Scalars['String']['output']>;
  undone?: Maybe<Scalars['Boolean']['output']>;
};

export type UnpublishLocaleInput = {
  /** Locales to unpublish */
  locale: Locale;
  /** Stages to unpublish selected locales from */
  stages: Array<Stage>;
};

export type UpdateCoachingEnrollmentCoachInput = {
  coachSlug: Scalars['String']['input'];
  coachingEnrollmentId: Scalars['String']['input'];
};

export type UpdateCoachingEnrollmentCoachPayload = {
  __typename?: 'UpdateCoachingEnrollmentCoachPayload';
  coachingEnrollment?: Maybe<CoachingEnrollment>;
};

export type UpdateCoachingEnrollmentConciergeInput = {
  coachingEnrollmentId: Scalars['String']['input'];
  conciergeId: Scalars['String']['input'];
};

export type UpdateCoachingEnrollmentConciergePayload = {
  __typename?: 'UpdateCoachingEnrollmentConciergePayload';
  coachingEnrollment?: Maybe<CoachingEnrollment>;
};

export type UpdateCommentInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['String']['input'];
  storedFileIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateCommentPayload = {
  __typename?: 'UpdateCommentPayload';
  comment?: Maybe<ScoComment>;
};

export type UpdateGroupEventInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  callUrl?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  groupEventId: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupEventPayload = {
  __typename?: 'UpdateGroupEventPayload';
  event?: Maybe<GroupEvent>;
  group?: Maybe<Group>;
};

export type UpdateGroupGoalInput = {
  assignedToUserId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  groupGoalId: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupGoalPayload = {
  __typename?: 'UpdateGroupGoalPayload';
  goal?: Maybe<GroupGoal>;
  group?: Maybe<Group>;
};

export type UpdateGroupMemberReviewInput = {
  groupMemberReviewId: Scalars['String']['input'];
  iHelped?: InputMaybe<Scalars['Int']['input']>;
  iListened?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  othersHelped?: InputMaybe<Scalars['Int']['input']>;
  othersListened?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGroupMemberReviewPayload = {
  __typename?: 'UpdateGroupMemberReviewPayload';
  review?: Maybe<GroupMemberReview>;
};

export type UpdateProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  coverPhotoXInPercent?: InputMaybe<Scalars['Float']['input']>;
  coverPhotoYInPercent?: InputMaybe<Scalars['Float']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  locationCountryKey?: InputMaybe<Scalars['String']['input']>;
  locationLatitude?: InputMaybe<Scalars['Float']['input']>;
  locationLongitude?: InputMaybe<Scalars['Float']['input']>;
  locationPlaceId?: InputMaybe<Scalars['String']['input']>;
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  locationState?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  profileVisibilityKey?: InputMaybe<Scalars['String']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfilePayload = {
  __typename?: 'UpdateProfilePayload';
  viewer?: Maybe<Viewer>;
};

export type UpdateStatusOfGroupEventInput = {
  deleteEvent?: InputMaybe<Scalars['Boolean']['input']>;
  groupEventId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStatusOfGroupEventPayload = {
  __typename?: 'UpdateStatusOfGroupEventPayload';
  group?: Maybe<Group>;
};

export type UpdateSubscriptionPaymentInput = {
  cardCvv: Scalars['String']['input'];
  cardExpirationMonth: Scalars['Int']['input'];
  cardExpirationYear: Scalars['Int']['input'];
  cardFirstName: Scalars['String']['input'];
  cardLastName: Scalars['String']['input'];
  cardNumber: Scalars['String']['input'];
  cardPostalCode: Scalars['String']['input'];
};

export type UpdateThreadInput = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  tagSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicTermSlug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateThreadPayload = {
  __typename?: 'UpdateThreadPayload';
  thread?: Maybe<ScoThread>;
};

export type UpdateUserActiveSprintInput = {
  activeSprintNotes?: InputMaybe<Scalars['String']['input']>;
  activeSprintSlug?: InputMaybe<Scalars['String']['input']>;
  founderNeedsKeys?: InputMaybe<Scalars['String']['input']>;
  founderNeedsOther?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserActiveSprintPayload = {
  __typename?: 'UpdateUserActiveSprintPayload';
  user?: Maybe<ScoUser>;
  viewer?: Maybe<Viewer>;
};

export type UpdateUserEmailInput = {
  email: Scalars['String']['input'];
  sendConfirmationRequest?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserEmailPayload = {
  __typename?: 'UpdateUserEmailPayload';
  viewer: Viewer;
};

export type UpdateUserLearningGoalsInput = {
  learningGoals: Array<InputMaybe<Scalars['String']['input']>>;
};

export type UpdateUserLearningGoalsPayload = {
  __typename?: 'UpdateUserLearningGoalsPayload';
  user: ScoUser;
};

export type UpdateUserNetworkingSettingInput = {
  isOpenToNetworking?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserNetworkingSettingPayload = {
  __typename?: 'UpdateUserNetworkingSettingPayload';
  user?: Maybe<ScoUser>;
  viewer: Viewer;
};

export type UpdateUserPasswordInput = {
  confirmPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UpdateUserPasswordPayload = {
  __typename?: 'UpdateUserPasswordPayload';
  viewer: Viewer;
};

export type UpdateUserPresenceInput = {
  attachmentId: Scalars['String']['input'];
  attachmentType: Scalars['String']['input'];
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isTyping?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserPresencePayload = {
  __typename?: 'UpdateUserPresencePayload';
  presence?: Maybe<ScoUserPresence>;
};

export type UpsertAdvisorAgreementInput = {
  advisorAgreementId?: InputMaybe<Scalars['String']['input']>;
  advisorEmail?: InputMaybe<Scalars['String']['input']>;
  advisorEngagementId?: InputMaybe<Scalars['String']['input']>;
  advisorEntityName?: InputMaybe<Scalars['String']['input']>;
  advisorName?: InputMaybe<Scalars['String']['input']>;
  advisorTitle?: InputMaybe<Scalars['String']['input']>;
  advisorUserId?: InputMaybe<Scalars['String']['input']>;
  caliberKey?: InputMaybe<Scalars['String']['input']>;
  cashHourlyRateInDollars?: InputMaybe<Scalars['Float']['input']>;
  cliffMonths?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  companyStageKey?: InputMaybe<Scalars['String']['input']>;
  contributionTierKey?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  equityPercent?: InputMaybe<Scalars['Float']['input']>;
  fastTrackApplied?: InputMaybe<Scalars['Boolean']['input']>;
  founderCompanyName?: InputMaybe<Scalars['String']['input']>;
  founderEmail?: InputMaybe<Scalars['String']['input']>;
  founderName?: InputMaybe<Scalars['String']['input']>;
  founderUserId?: InputMaybe<Scalars['String']['input']>;
  hoursPerMonth?: InputMaybe<Scalars['Int']['input']>;
  initiatingPartyKey?: InputMaybe<Scalars['String']['input']>;
  legalTermsAsJson?: InputMaybe<Scalars['JSON']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  termMonths?: InputMaybe<Scalars['Int']['input']>;
  valuationSnapshotInDollars?: InputMaybe<Scalars['Float']['input']>;
  vestingMonths?: InputMaybe<Scalars['Int']['input']>;
  warmIntroKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertAdvisorAgreementPayload = {
  __typename?: 'UpsertAdvisorAgreementPayload';
  advisorAgreement?: Maybe<ScoAdvisorAgreement>;
};

export type UpsertAdvisorEngagementInput = {
  advisorEngagementId?: InputMaybe<Scalars['String']['input']>;
  categoryKey?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  compensationNotes?: InputMaybe<Scalars['String']['input']>;
  compensationTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  industryKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notifyMatches?: InputMaybe<Scalars['Boolean']['input']>;
  skillTagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statusKey?: InputMaybe<Scalars['String']['input']>;
  timeCommitmentNotes?: InputMaybe<Scalars['String']['input']>;
  timeCommitmentTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  whyText?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertAdvisorEngagementPayload = {
  __typename?: 'UpsertAdvisorEngagementPayload';
  advisorEngagement?: Maybe<ScoAdvisorEngagement>;
};

export type UpsertAdvisorProfileInput = {
  advisingNote?: InputMaybe<Scalars['String']['input']>;
  availabilityHoursPerMonth?: InputMaybe<Scalars['Int']['input']>;
  bioForAdvising?: InputMaybe<Scalars['String']['input']>;
  categoryKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  engagementIntroductionIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  engagementIntroductionMessage?: InputMaybe<Scalars['String']['input']>;
  engagementStyleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  isSessionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notableBrands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferredCompensationTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sessionBookingUrl?: InputMaybe<Scalars['String']['input']>;
  sessionFeeWaiveCode?: InputMaybe<Scalars['String']['input']>;
  sessionWeeklyHours?: InputMaybe<Scalars['JSON']['input']>;
  skillTagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitForReview?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  warmIntroKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpsertAdvisorProfilePayload = {
  __typename?: 'UpsertAdvisorProfilePayload';
  advisorProfile?: Maybe<ScoAdvisorProfile>;
};

export type UpsertAttachmentUserPresenceInput = {
  attachmentId: Scalars['String']['input'];
  attachmentType: Scalars['String']['input'];
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isTyping?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertAttachmentUserPresencePayload = {
  __typename?: 'UpsertAttachmentUserPresencePayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpsertBootcampEnrollmentInput = {
  bootcampEnrollmentId?: InputMaybe<Scalars['String']['input']>;
  bootcampSlug: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  targetCompletionDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertBootcampEnrollmentPayload = {
  __typename?: 'UpsertBootcampEnrollmentPayload';
  bootcamp?: Maybe<ScoBootcamp>;
  bootcampEnrollment?: Maybe<ScoBootcampEnrollment>;
  currentUser?: Maybe<ScoUser>;
};

export type UpsertBootcampResponseInput = {
  bootcampEnrollmentId: Scalars['String']['input'];
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  promptSlug: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertBootcampResponsePayload = {
  __typename?: 'UpsertBootcampResponsePayload';
  bootcamp?: Maybe<ScoBootcamp>;
  bootcampEnrollment?: Maybe<ScoBootcampEnrollment>;
  bootcampResponse?: Maybe<ScoBootcampResponse>;
  currentUser?: Maybe<ScoUser>;
};

export type UpsertBootcampShareInput = {
  bootcampEnrollmentId: Scalars['String']['input'];
  bootcampShareId?: InputMaybe<Scalars['String']['input']>;
  canComment?: InputMaybe<Scalars['Boolean']['input']>;
  canEdit?: InputMaybe<Scalars['Boolean']['input']>;
  canView?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  performEmailSend?: InputMaybe<Scalars['Boolean']['input']>;
  sentToEmail?: InputMaybe<Scalars['String']['input']>;
  sentToName?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertBootcampSharePayload = {
  __typename?: 'UpsertBootcampSharePayload';
  bootcamp?: Maybe<ScoBootcamp>;
  bootcampEnrollment?: Maybe<ScoBootcampEnrollment>;
  bootcampShare?: Maybe<ScoBootcampShare>;
  currentUser?: Maybe<ScoUser>;
};

export type UpsertBootcampStatusInput = {
  bootcampEnrollmentId: Scalars['String']['input'];
  bootcampStatusId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  playbackInSeconds?: InputMaybe<Scalars['Int']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stepSlug: Scalars['String']['input'];
};

export type UpsertBootcampStatusPayload = {
  __typename?: 'UpsertBootcampStatusPayload';
  bootcamp?: Maybe<ScoBootcamp>;
  bootcampEnrollment?: Maybe<ScoBootcampEnrollment>;
  bootcampStatus?: Maybe<ScoBootcampStatus>;
  currentUser?: Maybe<ScoUser>;
};

export type UpsertChatCommentInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  storedFileIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  threadId: Scalars['String']['input'];
};

export type UpsertChatCommentPayload = {
  __typename?: 'UpsertChatCommentPayload';
  comment?: Maybe<ScoComment>;
  thread?: Maybe<ScoThread>;
};

export type UpsertCoachingEnrollmentInput = {
  biggestChallenge?: InputMaybe<Scalars['String']['input']>;
  commitment?: InputMaybe<Scalars['String']['input']>;
  goals?: InputMaybe<Scalars['JSON']['input']>;
  hubspotFormKey?: InputMaybe<Scalars['String']['input']>;
  pursuit?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertCoachingEnrollmentPayload = {
  __typename?: 'UpsertCoachingEnrollmentPayload';
  coachingEnrollment: CoachingEnrollment;
  currentUser?: Maybe<ScoUser>;
};

export type UpsertCompanyInput = {
  annualRevenueKey?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  elevatorPitch?: InputMaybe<Scalars['String']['input']>;
  fundingGoalInDollars?: InputMaybe<Scalars['String']['input']>;
  fundingRaisedKey?: InputMaybe<Scalars['String']['input']>;
  fundingStageKey?: InputMaybe<Scalars['String']['input']>;
  headcountKey?: InputMaybe<Scalars['String']['input']>;
  hubspotFormKey?: InputMaybe<Scalars['String']['input']>;
  industryKey?: InputMaybe<Scalars['String']['input']>;
  industryKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  locationCountryKey?: InputMaybe<Scalars['String']['input']>;
  locationLatitude?: InputMaybe<Scalars['Float']['input']>;
  locationLongitude?: InputMaybe<Scalars['Float']['input']>;
  locationPlaceId?: InputMaybe<Scalars['String']['input']>;
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  locationState?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pitchDeckNote?: InputMaybe<Scalars['String']['input']>;
  pitchDeckUrl?: InputMaybe<Scalars['String']['input']>;
  profileVisibilityKey?: InputMaybe<Scalars['String']['input']>;
  stageKey?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  yearFounded?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertCompanyPayload = {
  __typename?: 'UpsertCompanyPayload';
  user: ScoUser;
};

export type UpsertContentTrackEnrollmentInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contentTrackEnrollmentId?: InputMaybe<Scalars['String']['input']>;
  contentTrackId: Scalars['String']['input'];
  contentTrackSlug: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  industryKey?: InputMaybe<Scalars['String']['input']>;
  targetCompletionDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertContentTrackEnrollmentPayload = {
  __typename?: 'UpsertContentTrackEnrollmentPayload';
  contentTrackEnrollment?: Maybe<ScoContentTrackEnrollment>;
  currentUser?: Maybe<ScoUser>;
};

export type UpsertContentTrackResponseInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contentTrackEnrollmentId: Scalars['String']['input'];
  contentTrackId: Scalars['String']['input'];
  contentTrackResponseId?: InputMaybe<Scalars['String']['input']>;
  contentTrackSlug?: InputMaybe<Scalars['String']['input']>;
  contentTrackStepId: Scalars['String']['input'];
  contentTrackStepSlug?: InputMaybe<Scalars['String']['input']>;
  contentTrackTaskId: Scalars['String']['input'];
  contentTrackTaskSlug?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  valueContext?: InputMaybe<Scalars['String']['input']>;
  valueFormat?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertContentTrackResponsePayload = {
  __typename?: 'UpsertContentTrackResponsePayload';
  contentTrackEnrollment?: Maybe<ScoContentTrackEnrollment>;
  contentTrackResponse?: Maybe<ScoContentTrackResponse>;
  currentUser?: Maybe<ScoUser>;
};

export type UpsertCrmSavedReplyInput = {
  accountUserId?: InputMaybe<Scalars['String']['input']>;
  body: Scalars['String']['input'];
  positionIndex?: InputMaybe<Scalars['Int']['input']>;
  savedReplyId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type UpsertCrmSavedReplyPayload = {
  __typename?: 'UpsertCrmSavedReplyPayload';
  savedReply?: Maybe<ScoCrmSavedReply>;
};

export type UpsertDirectChatThreadInput = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  memberUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDirectChatThreadPayload = {
  __typename?: 'UpsertDirectChatThreadPayload';
  thread?: Maybe<ScoThread>;
  viewer?: Maybe<Viewer>;
};

export type UpsertEmailSenderInput = {
  checkDeliveryTest?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailEngineAccessToken?: InputMaybe<Scalars['String']['input']>;
  emailEngineAccountAsJson?: InputMaybe<Scalars['String']['input']>;
  emailEngineAccountId?: InputMaybe<Scalars['String']['input']>;
  emailEngineAccountType?: InputMaybe<Scalars['String']['input']>;
  emailProviderKey?: InputMaybe<Scalars['String']['input']>;
  emailSenderId?: InputMaybe<Scalars['String']['input']>;
  googleToken?: InputMaybe<Scalars['String']['input']>;
  imapHost?: InputMaybe<Scalars['String']['input']>;
  imapIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  imapPassword?: InputMaybe<Scalars['String']['input']>;
  imapPort?: InputMaybe<Scalars['Int']['input']>;
  imapSsl?: InputMaybe<Scalars['Boolean']['input']>;
  imapUsername?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['String']['input']>;
  isHealthy?: InputMaybe<Scalars['String']['input']>;
  microsoftToken?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  refetchEmailEngine?: InputMaybe<Scalars['Boolean']['input']>;
  saveToEmailEngine?: InputMaybe<Scalars['Boolean']['input']>;
  sendDeliveryTest?: InputMaybe<Scalars['Boolean']['input']>;
  smtpHost?: InputMaybe<Scalars['String']['input']>;
  smtpIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  smtpPassword?: InputMaybe<Scalars['String']['input']>;
  smtpPort?: InputMaybe<Scalars['Int']['input']>;
  smtpSsl?: InputMaybe<Scalars['Boolean']['input']>;
  smtpUsername?: InputMaybe<Scalars['String']['input']>;
  testConnection?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertEmailSenderPayload = {
  __typename?: 'UpsertEmailSenderPayload';
  emailSender?: Maybe<ScoEmailSender>;
  errorMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UpsertFgProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  companyAnnualRevenue?: InputMaybe<Scalars['String']['input']>;
  companyElevatorPitch?: InputMaybe<Scalars['String']['input']>;
  companyFundingRaised?: InputMaybe<Scalars['String']['input']>;
  companyIndustry?: InputMaybe<Scalars['String']['input']>;
  companyLocation?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStage?: InputMaybe<Scalars['String']['input']>;
  companyUrl?: InputMaybe<Scalars['String']['input']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  founderNeeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  founderNeedsOther?: InputMaybe<Scalars['String']['input']>;
  hubspotFormKey?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  preferredInteractions?: InputMaybe<Scalars['String']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertFgProfilePayload = {
  __typename?: 'UpsertFGProfilePayload';
  user: ScoUser;
  viewer?: Maybe<Viewer>;
};

export type UpsertGroupCandidateInput = {
  companyAnnualRevenue?: InputMaybe<Scalars['String']['input']>;
  companyElevatorPitch?: InputMaybe<Scalars['String']['input']>;
  companyFundingRaised?: InputMaybe<Scalars['String']['input']>;
  companyHeadcount?: InputMaybe<Scalars['String']['input']>;
  companyIndustry?: InputMaybe<Scalars['String']['input']>;
  companyLocation?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStage?: InputMaybe<Scalars['String']['input']>;
  companyUrl?: InputMaybe<Scalars['String']['input']>;
  companyYearFounded?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  groupCandidateId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userBio?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userFirstName?: InputMaybe<Scalars['String']['input']>;
  userLastName?: InputMaybe<Scalars['String']['input']>;
  userPhone?: InputMaybe<Scalars['String']['input']>;
  userPictureUrl?: InputMaybe<Scalars['String']['input']>;
  userShortBio?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertGroupCandidatePayload = {
  __typename?: 'UpsertGroupCandidatePayload';
  groupCandidate?: Maybe<GroupCandidate>;
};

export type UpsertGroupCommitmentInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  acceptedNotes?: InputMaybe<Scalars['String']['input']>;
  bodyAsMarkdown?: InputMaybe<Scalars['String']['input']>;
  committingCompanyId?: InputMaybe<Scalars['String']['input']>;
  committingUserId?: InputMaybe<Scalars['String']['input']>;
  compensationNotes?: InputMaybe<Scalars['String']['input']>;
  compensationTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fulfilledAt?: InputMaybe<Scalars['DateTime']['input']>;
  fulfillmentNotes?: InputMaybe<Scalars['String']['input']>;
  groupCommitmentId?: InputMaybe<Scalars['String']['input']>;
  groupRequestId?: InputMaybe<Scalars['String']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectionNotes?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeCommitmentNotes?: InputMaybe<Scalars['String']['input']>;
  timeCommitmentTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertGroupCommitmentPayload = {
  __typename?: 'UpsertGroupCommitmentPayload';
  groupCommitment?: Maybe<GroupCommitment>;
};

export type UpsertGroupEventAttendanceInput = {
  attendeeNote?: InputMaybe<Scalars['String']['input']>;
  attending?: InputMaybe<Scalars['Boolean']['input']>;
  attendingUserId?: InputMaybe<Scalars['String']['input']>;
  didAttend?: InputMaybe<Scalars['Boolean']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  groupEventAttendanceId?: InputMaybe<Scalars['String']['input']>;
  groupEventId?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpsertGroupEventAttendancePayload = {
  __typename?: 'UpsertGroupEventAttendancePayload';
  group?: Maybe<Group>;
  groupEvent?: Maybe<GroupEvent>;
  groupEventAttendance?: Maybe<GroupEventAttendance>;
};

export type UpsertGroupEventInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  attendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callUrl?: InputMaybe<Scalars['String']['input']>;
  categoryKey?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  featuredImageUrl?: InputMaybe<Scalars['String']['input']>;
  featuredVideoUrl?: InputMaybe<Scalars['String']['input']>;
  groupEventId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hostInputs?: InputMaybe<Array<InputMaybe<GroupEventHostInput>>>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  maximumAttendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  schedulingUrl?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suggestedTimesAsJSON?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertGroupEventPayload = {
  __typename?: 'UpsertGroupEventPayload';
  group?: Maybe<Group>;
  groupEvent?: Maybe<GroupEvent>;
};

export type UpsertGroupGoalInput = {
  assignedToUserId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  groupGoalId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
};

export type UpsertGroupGoalPayload = {
  __typename?: 'UpsertGroupGoalPayload';
  goal?: Maybe<GroupGoal>;
  group?: Maybe<Group>;
};

export type UpsertGroupInput = {
  appLabel?: InputMaybe<Scalars['String']['input']>;
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  commitmentLabel?: InputMaybe<Scalars['String']['input']>;
  createdByUserId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  requestLabel?: InputMaybe<Scalars['String']['input']>;
  requiredProductId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertGroupMembershipInput = {
  groupId: Scalars['String']['input'];
  isModerator?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertGroupMembershipPayload = {
  __typename?: 'UpsertGroupMembershipPayload';
  group?: Maybe<Group>;
  membership?: Maybe<GroupMember>;
  user?: Maybe<ScoUser>;
};

export type UpsertGroupPayload = {
  __typename?: 'UpsertGroupPayload';
  group?: Maybe<Group>;
};

export type UpsertGroupPostInput = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  authorUserId?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  groupPostId?: InputMaybe<Scalars['String']['input']>;
  groupPostTypeKey?: InputMaybe<Scalars['String']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpsertGroupPostPayload = {
  __typename?: 'UpsertGroupPostPayload';
  group?: Maybe<Group>;
  groupPost?: Maybe<GroupPost>;
};

export type UpsertGroupRequestInput = {
  bodyAsMarkdown?: InputMaybe<Scalars['String']['input']>;
  bodyIsGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  bodyPrompt?: InputMaybe<Scalars['String']['input']>;
  bodyPromptAdditionalItems?: InputMaybe<Scalars['String']['input']>;
  bodyPromptToneKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  compensationNotes?: InputMaybe<Scalars['String']['input']>;
  compensationTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  compensationUnit?: InputMaybe<Scalars['String']['input']>;
  compensationValue?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  featuredAt?: InputMaybe<Scalars['DateTime']['input']>;
  fulfilledAt?: InputMaybe<Scalars['DateTime']['input']>;
  fulfillmentStatusKey?: InputMaybe<Scalars['String']['input']>;
  groupRequestId?: InputMaybe<Scalars['String']['input']>;
  groupRequestTypeKey?: InputMaybe<Scalars['String']['input']>;
  investorIndustryTagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  investorSearchId?: InputMaybe<Scalars['String']['input']>;
  isOpenToRemoteLocation?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountryKey?: InputMaybe<Scalars['String']['input']>;
  locationLatitude?: InputMaybe<Scalars['Float']['input']>;
  locationLongitude?: InputMaybe<Scalars['Float']['input']>;
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  locationRadiusInMiles?: InputMaybe<Scalars['Int']['input']>;
  locationState?: InputMaybe<Scalars['String']['input']>;
  naturalLanguagePrompt?: InputMaybe<Scalars['String']['input']>;
  needExplanation?: InputMaybe<Scalars['String']['input']>;
  publishApprovedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishDeniedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishDeniedNotes?: InputMaybe<Scalars['String']['input']>;
  publishRequestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishRequestedNotes?: InputMaybe<Scalars['String']['input']>;
  publishStatusKey?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  regenerateBody?: InputMaybe<Scalars['Boolean']['input']>;
  regenerateTasks?: InputMaybe<Scalars['Boolean']['input']>;
  regenerateTasksFromTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  requestingCompanyId?: InputMaybe<Scalars['String']['input']>;
  requestingUserId?: InputMaybe<Scalars['String']['input']>;
  skillTagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeCommitmentNotes?: InputMaybe<Scalars['String']['input']>;
  timeCommitmentTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeCommitmentUnit?: InputMaybe<Scalars['String']['input']>;
  timeCommitmentValue?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  upsertCompanyInput?: InputMaybe<UpsertCompanyInput>;
  upsertInvestorSearchInput?: InputMaybe<UpsertInvestorSearchInput>;
  upsertRequestingUserInput?: InputMaybe<UpsertUserInput>;
  upsertUserSearchInput?: InputMaybe<UpsertUserSearchInput>;
  userSearchId?: InputMaybe<Scalars['String']['input']>;
  valueToRequester?: InputMaybe<Scalars['String']['input']>;
  valueToResponder?: InputMaybe<Scalars['String']['input']>;
  visibilityKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertGroupRequestPayload = {
  __typename?: 'UpsertGroupRequestPayload';
  groupRequest?: Maybe<GroupRequest>;
};

export type UpsertGroupTrackStatusInput = {
  attachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  trackPrompt?: InputMaybe<Scalars['String']['input']>;
  trackSlug?: InputMaybe<Scalars['String']['input']>;
  trackStepIdentifier?: InputMaybe<Scalars['String']['input']>;
  trackStepTitle?: InputMaybe<Scalars['String']['input']>;
  trackTaskIdentifier?: InputMaybe<Scalars['String']['input']>;
  trackTaskTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertGroupTrackStatusPayload = {
  __typename?: 'UpsertGroupTrackStatusPayload';
  groupTrackStatus?: Maybe<GroupTrackStatus>;
  user?: Maybe<ScoUser>;
};

export type UpsertInvestorMatchInput = {
  investorMatchId?: InputMaybe<Scalars['String']['input']>;
  ratingBySearchingUser?: InputMaybe<Scalars['Int']['input']>;
  ratingNoteBySearchingUser?: InputMaybe<Scalars['String']['input']>;
  savedBySearchingUserAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpsertInvestorMatchPayload = {
  __typename?: 'UpsertInvestorMatchPayload';
  investorMatch?: Maybe<ScoInvestorMatch>;
};

export type UpsertInvestorMessageInput = {
  bodyAsMarkdown?: InputMaybe<Scalars['String']['input']>;
  bodyPrompt?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailSenderId?: InputMaybe<Scalars['String']['input']>;
  executeResend?: InputMaybe<Scalars['Boolean']['input']>;
  investorMatchId?: InputMaybe<Scalars['String']['input']>;
  investorMessageId?: InputMaybe<Scalars['String']['input']>;
  investorProfileContactId?: InputMaybe<Scalars['String']['input']>;
  investorProfileId?: InputMaybe<Scalars['String']['input']>;
  investorSearchId?: InputMaybe<Scalars['String']['input']>;
  regenerateBody?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleToSend?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledToSendAt?: InputMaybe<Scalars['DateTime']['input']>;
  sendingUserId?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertInvestorMessagePayload = {
  __typename?: 'UpsertInvestorMessagePayload';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  investorMessage?: Maybe<ScoInvestorMessage>;
};

export type UpsertInvestorProfileContactInput = {
  alternateEmail?: InputMaybe<Scalars['String']['input']>;
  alternatePhone?: InputMaybe<Scalars['String']['input']>;
  bestContactMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  indexPosition?: InputMaybe<Scalars['Int']['input']>;
  investorProfileContactId?: InputMaybe<Scalars['String']['input']>;
  investorProfileId: Scalars['String']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  positionLevels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  replyCount?: InputMaybe<Scalars['Int']['input']>;
  replyToneScore?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertInvestorProfileContactPayload = {
  __typename?: 'UpsertInvestorProfileContactPayload';
  investorProfileContact?: Maybe<ScoInvestorProfileContact>;
};

export type UpsertInvestorProfileInput = {
  applicationUrl?: InputMaybe<Scalars['String']['input']>;
  crunchbaseRank?: InputMaybe<Scalars['Int']['input']>;
  crunchbaseUrl?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dryPowderInDollars?: InputMaybe<Scalars['Float']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  fullDescription?: InputMaybe<Scalars['String']['input']>;
  hqLatitude?: InputMaybe<Scalars['Float']['input']>;
  hqLocation?: InputMaybe<Scalars['String']['input']>;
  hqLocationCity?: InputMaybe<Scalars['String']['input']>;
  hqLocationCountry?: InputMaybe<Scalars['String']['input']>;
  hqLocationPlaceId?: InputMaybe<Scalars['String']['input']>;
  hqLocationRegion?: InputMaybe<Scalars['String']['input']>;
  hqLocationState?: InputMaybe<Scalars['String']['input']>;
  hqLongitude?: InputMaybe<Scalars['Float']['input']>;
  investmentStages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  investorProfileId?: InputMaybe<Scalars['String']['input']>;
  investorTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  maxFundSizeInDollars?: InputMaybe<Scalars['Float']['input']>;
  maximumDealSizeInDollars?: InputMaybe<Scalars['Float']['input']>;
  maximumInvestmentInDollars?: InputMaybe<Scalars['Float']['input']>;
  minimumDealSizeInDollars?: InputMaybe<Scalars['Float']['input']>;
  minimumInvestmentInDollars?: InputMaybe<Scalars['Float']['input']>;
  pitchbookUrl?: InputMaybe<Scalars['String']['input']>;
  preferredIndustries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferredVerticals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryInvestorType?: InputMaybe<Scalars['String']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalInvestmentsCount?: InputMaybe<Scalars['Int']['input']>;
  totalInvestmentsTTMCount?: InputMaybe<Scalars['Int']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertInvestorProfilePayload = {
  __typename?: 'UpsertInvestorProfilePayload';
  investorProfile?: Maybe<ScoInvestorProfile>;
};

export type UpsertInvestorSearchInput = {
  companyElevatorPitch?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  competitionStatement?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplateAttachmentUrl?: InputMaybe<Scalars['String']['input']>;
  emailTemplateFrom?: InputMaybe<Scalars['String']['input']>;
  emailTemplateGeneratedBody?: InputMaybe<Scalars['String']['input']>;
  emailTemplatePrompt?: InputMaybe<Scalars['String']['input']>;
  emailTemplateSignature?: InputMaybe<Scalars['String']['input']>;
  emailTemplateSubject?: InputMaybe<Scalars['String']['input']>;
  financialsStatement?: InputMaybe<Scalars['String']['input']>;
  fundingGoalInDollars?: InputMaybe<Scalars['Int']['input']>;
  fundingGoalStageKey?: InputMaybe<Scalars['String']['input']>;
  fundingGoalStatement?: InputMaybe<Scalars['String']['input']>;
  fundingGoalStructureKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  investorSearchId?: InputMaybe<Scalars['String']['input']>;
  investorTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isMatchEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  locationCountryKey?: InputMaybe<Scalars['String']['input']>;
  locationLatitude?: InputMaybe<Scalars['Float']['input']>;
  locationLongitude?: InputMaybe<Scalars['Float']['input']>;
  locationState?: InputMaybe<Scalars['String']['input']>;
  marketSizeStatement?: InputMaybe<Scalars['String']['input']>;
  naturalLanguagePrompt?: InputMaybe<Scalars['String']['input']>;
  parametersAsJSON?: InputMaybe<Scalars['String']['input']>;
  pitchDeckNotes?: InputMaybe<Scalars['String']['input']>;
  pitchDeckUrl?: InputMaybe<Scalars['String']['input']>;
  problemStatement?: InputMaybe<Scalars['String']['input']>;
  reprocess?: InputMaybe<Scalars['Boolean']['input']>;
  reprocessEmailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  reprocessParameters?: InputMaybe<Scalars['Boolean']['input']>;
  reprocessPitchDeck?: InputMaybe<Scalars['Boolean']['input']>;
  requiredInvestorTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requiredInvestorTagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchingCompanyId?: InputMaybe<Scalars['String']['input']>;
  searchingUserId?: InputMaybe<Scalars['String']['input']>;
  solutionStatement?: InputMaybe<Scalars['String']['input']>;
  teamStatement?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tractionStatement?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertInvestorSearchPayload = {
  __typename?: 'UpsertInvestorSearchPayload';
  investorSearch?: Maybe<ScoInvestorSearch>;
};

export type UpsertRagCollectionInput = {
  chunkConfigAsJson?: InputMaybe<Scalars['JSON']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embeddingDimensions?: InputMaybe<Scalars['Int']['input']>;
  embeddingModelId?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  ragCollectionId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertRagCollectionPayload = {
  __typename?: 'UpsertRagCollectionPayload';
  ragCollection?: Maybe<ScoRagCollection>;
};

export type UpsertRagSourceInput = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  contentFieldKey?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  metadataAsJson?: InputMaybe<Scalars['JSON']['input']>;
  platformKey?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ragCollectionId: Scalars['UUID']['input'];
  ragSourceId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sourceTypeKey?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertRagSourcePayload = {
  __typename?: 'UpsertRagSourcePayload';
  ragSource?: Maybe<ScoRagSource>;
};

export type UpsertRatingInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  rateableId: Scalars['String']['input'];
  rateableType: Scalars['String']['input'];
  score: Scalars['Int']['input'];
};

export type UpsertRatingPayload = {
  __typename?: 'UpsertRatingPayload';
  advisorSession?: Maybe<ScoAdvisorSession>;
  rating?: Maybe<ScoRating>;
};

export type UpsertSalesEventInput = {
  attributionAsPercent?: InputMaybe<Scalars['Int']['input']>;
  beancounterPaymentId?: InputMaybe<Scalars['String']['input']>;
  commissionNotes?: InputMaybe<Scalars['String']['input']>;
  commissionPaidAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  commissionPaidAt?: InputMaybe<Scalars['DateTime']['input']>;
  commissionReturnedAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  commissionReturnedAt?: InputMaybe<Scalars['DateTime']['input']>;
  commissionValueInCents?: InputMaybe<Scalars['Int']['input']>;
  createSplitEvent?: InputMaybe<Scalars['Boolean']['input']>;
  customerSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  customerUserId?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  salesEventId?: InputMaybe<Scalars['String']['input']>;
  salesEventTypeKey?: InputMaybe<Scalars['String']['input']>;
  salesPersonId?: InputMaybe<Scalars['String']['input']>;
  sourceNotes?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertSalesEventPayload = {
  __typename?: 'UpsertSalesEventPayload';
  salesEvent?: Maybe<ScoSalesEvent>;
};

export type UpsertScoAiActionInput = {
  /** UUID of an existing AiAction to update. Omit to create a new record. */
  aiActionId?: InputMaybe<Scalars['String']['input']>;
  /** Structured AI call parameters. Preferred over inputAsJson when both are provided. */
  input?: InputMaybe<AiActionInput>;
  /** Raw JSON string of AI call parameters. Fallback when input is not provided. */
  inputAsJson?: InputMaybe<Scalars['String']['input']>;
  /** Model identifier within the provider (e.g. "gemini-2.5-flash"). */
  modelId?: InputMaybe<Scalars['String']['input']>;
  /** AI SDK operation to perform: generateText, streamText, generateObject, or streamObject. */
  operation?: InputMaybe<AiActionOperation>;
  /** When true, execute the AI call synchronously and wait for the result before returning. */
  process?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, queue the AI call to run asynchronously after the mutation returns. */
  processInBackground?: InputMaybe<Scalars['Boolean']['input']>;
  /** AI provider to use: "google", "openai", "anthropic", or "deepseek". */
  provider?: InputMaybe<Scalars['String']['input']>;
  /** Optional sub-key to distinguish multiple AI actions on the same related entity. */
  relatedModelContextKey?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the entity identified by relatedModelType. */
  relatedModelId?: InputMaybe<Scalars['String']['input']>;
  /** Sequelize model name of an entity to associate with this action (e.g. "Comment"). */
  relatedModelType?: InputMaybe<Scalars['String']['input']>;
  /** Associate the action with a specific user UUID. Defaults to the authenticated user. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertScoAiActionPayload = {
  __typename?: 'UpsertScoAiActionPayload';
  aiAction?: Maybe<ScoAiAction>;
};

export type UpsertScoAnalyticsSavedReportInput = {
  config: Scalars['JSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isPreset?: InputMaybe<Scalars['Boolean']['input']>;
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
  schema?: InputMaybe<Scalars['String']['input']>;
  scoAnalyticsSavedReportId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertScoAnalyticsSavedReportPayload = {
  __typename?: 'UpsertScoAnalyticsSavedReportPayload';
  scoAnalyticsSavedReport?: Maybe<ScoAnalyticsSavedReport>;
};

export type UpsertScoCustomerChannelInput = {
  composite?: InputMaybe<Scalars['Int']['input']>;
  compoundsScore?: InputMaybe<Scalars['Int']['input']>;
  confidenceScore?: InputMaybe<Scalars['Int']['input']>;
  customerChannelId?: InputMaybe<Scalars['String']['input']>;
  customerProfileId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  easeScore?: InputMaybe<Scalars['Int']['input']>;
  fitScore?: InputMaybe<Scalars['Int']['input']>;
  howToReach?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parkReason?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  statusKey?: InputMaybe<Scalars['String']['input']>;
  typeKey?: InputMaybe<Scalars['String']['input']>;
  whyThisChannel?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertScoCustomerChannelPayload = {
  __typename?: 'UpsertScoCustomerChannelPayload';
  customerChannel?: Maybe<ScoCustomerChannel>;
  customerSearch?: Maybe<ScoCustomerSearch>;
};

export type UpsertScoCustomerExperimentCheckinInput = {
  customerExperimentCheckinId?: InputMaybe<Scalars['String']['input']>;
  customerExperimentId: Scalars['String']['input'];
  evidenceUrl?: InputMaybe<Scalars['String']['input']>;
  executionKey?: InputMaybe<Scalars['String']['input']>;
  kindKey?: InputMaybe<Scalars['String']['input']>;
  loggedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Array<InputMaybe<ScoCustomerExperimentObservationInput>>>;
  successTextSnapshot?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertScoCustomerExperimentCheckinPayload = {
  __typename?: 'UpsertScoCustomerExperimentCheckinPayload';
  customerExperiment?: Maybe<ScoCustomerExperiment>;
  customerExperimentCheckin?: Maybe<ScoCustomerExperimentCheckin>;
  customerSearch?: Maybe<ScoCustomerSearch>;
};

export type UpsertScoCustomerExperimentInput = {
  actionText?: InputMaybe<Scalars['String']['input']>;
  commit?: InputMaybe<Scalars['Boolean']['input']>;
  customerChannelId?: InputMaybe<Scalars['String']['input']>;
  customerChannelMessageId?: InputMaybe<Scalars['String']['input']>;
  customerChannelOpenerId?: InputMaybe<Scalars['String']['input']>;
  customerExperimentId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  hypothesis?: InputMaybe<Scalars['String']['input']>;
  learnByAt?: InputMaybe<Scalars['DateTime']['input']>;
  metricSlots?: InputMaybe<Array<InputMaybe<ScoCustomerExperimentMetricSlotInput>>>;
  plannedDurationDays?: InputMaybe<Scalars['Int']['input']>;
  plannedSpendText?: InputMaybe<Scalars['String']['input']>;
  recipeKey?: InputMaybe<Scalars['String']['input']>;
  startKitText?: InputMaybe<Scalars['String']['input']>;
  statusKey?: InputMaybe<Scalars['String']['input']>;
  successText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertScoCustomerExperimentPayload = {
  __typename?: 'UpsertScoCustomerExperimentPayload';
  customerExperiment?: Maybe<ScoCustomerExperiment>;
  customerSearch?: Maybe<ScoCustomerSearch>;
};

export type UpsertScoCustomerSearchInput = {
  audience?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  currentStepKey?: InputMaybe<Scalars['String']['input']>;
  customerSearchId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  intakeAdvantage?: InputMaybe<Scalars['String']['input']>;
  intakeGoal?: InputMaybe<Scalars['String']['input']>;
  intakeProblemWho?: InputMaybe<Scalars['String']['input']>;
  intakeSell?: InputMaybe<Scalars['String']['input']>;
  intakeTraction?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oneLiner?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  perfectedPitch?: InputMaybe<Scalars['String']['input']>;
  problem?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  productAudienceStatement?: InputMaybe<Scalars['String']['input']>;
  signupRequestId?: InputMaybe<Scalars['String']['input']>;
  siteDescription?: InputMaybe<Scalars['String']['input']>;
  siteHeadline?: InputMaybe<Scalars['String']['input']>;
  siteSnippet?: InputMaybe<Scalars['String']['input']>;
  siteTitle?: InputMaybe<Scalars['String']['input']>;
  siteUrl?: InputMaybe<Scalars['String']['input']>;
  sourceKey?: InputMaybe<Scalars['String']['input']>;
  statusKey?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertScoCustomerSearchPayload = {
  __typename?: 'UpsertScoCustomerSearchPayload';
  customerSearch?: Maybe<ScoCustomerSearch>;
};

export type UpsertScoPitchDeckAuditInput = {
  analyze?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  pitchDeckAuditId?: InputMaybe<Scalars['String']['input']>;
  pitchDeckId?: InputMaybe<Scalars['String']['input']>;
  storedFileId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertScoPitchDeckAuditPayload = {
  __typename?: 'UpsertScoPitchDeckAuditPayload';
  pitchDeckAudit?: Maybe<ScoPitchDeckAudit>;
};

export type UpsertScoPitchDeckAuditSlideInput = {
  acceptedRewrite?: InputMaybe<Scalars['String']['input']>;
  clearAcceptedRewrite?: InputMaybe<Scalars['Boolean']['input']>;
  pitchDeckAuditSlideId: Scalars['String']['input'];
};

export type UpsertScoPitchDeckAuditSlidePayload = {
  __typename?: 'UpsertScoPitchDeckAuditSlidePayload';
  pitchDeckAuditSlide?: Maybe<ScoPitchDeckAuditSlide>;
};

export type UpsertScoPitchDeckInput = {
  analyze?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  pitchDeckId?: InputMaybe<Scalars['String']['input']>;
  storedFileId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertScoPitchDeckPayload = {
  __typename?: 'UpsertScoPitchDeckPayload';
  pitchDeck?: Maybe<ScoPitchDeck>;
};

export type UpsertSignupRequestInput = {
  additionalFields?: InputMaybe<Scalars['JSON']['input']>;
  analyzeToolChatAndCommit?: InputMaybe<Scalars['Boolean']['input']>;
  bodyAsMarkdown?: InputMaybe<Scalars['String']['input']>;
  commitToGroupRequest?: InputMaybe<Scalars['Boolean']['input']>;
  commitToHubspotNote?: InputMaybe<Scalars['Boolean']['input']>;
  companyElevatorPitch?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  convertedAt?: InputMaybe<Scalars['String']['input']>;
  convertingSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  createdByIpAddress?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['String']['input']>;
  fundingGoalInDollars?: InputMaybe<Scalars['Int']['input']>;
  funnelIdentifier?: InputMaybe<Scalars['String']['input']>;
  groupRequestTypeKey?: InputMaybe<Scalars['String']['input']>;
  investorIndustryTagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastProcessedAt?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountryKey?: InputMaybe<Scalars['String']['input']>;
  locationPlaceId?: InputMaybe<Scalars['String']['input']>;
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  locationState?: InputMaybe<Scalars['String']['input']>;
  nextProcessingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pitchDeckUrl?: InputMaybe<Scalars['String']['input']>;
  recommendationAsMarkdown?: InputMaybe<Scalars['String']['input']>;
  recommendedFeaturesAsJson?: InputMaybe<Scalars['String']['input']>;
  recommendedProductId?: InputMaybe<Scalars['String']['input']>;
  regenerateReport?: InputMaybe<Scalars['Boolean']['input']>;
  reportInputAsJson?: InputMaybe<Scalars['JSON']['input']>;
  reportOutputAsJson?: InputMaybe<Scalars['JSON']['input']>;
  reprocessRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  requestingEmail?: InputMaybe<Scalars['String']['input']>;
  requestingFullName?: InputMaybe<Scalars['String']['input']>;
  requestingUserId?: InputMaybe<Scalars['String']['input']>;
  selectedProductId?: InputMaybe<Scalars['String']['input']>;
  sendReportAsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  signupRequestId?: InputMaybe<Scalars['String']['input']>;
  skillTagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertSignupRequestPayload = {
  __typename?: 'UpsertSignupRequestPayload';
  groupRequest?: Maybe<GroupRequest>;
  reportAiAction?: Maybe<ScoAiAction>;
  signupRequest?: Maybe<ScoSignupRequest>;
};

export type UpsertStoredFileInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  storedFileId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertStoredFilePayload = {
  __typename?: 'UpsertStoredFilePayload';
  storedFile?: Maybe<ScoStoredFile>;
};

export type UpsertTaskInput = {
  assignedToCompanyId?: InputMaybe<Scalars['String']['input']>;
  assignedToUserId?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  bodyAsMarkdown?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  parentTaskId?: InputMaybe<Scalars['String']['input']>;
  priorityIndex?: InputMaybe<Scalars['Int']['input']>;
  referencedItemId?: InputMaybe<Scalars['String']['input']>;
  referencedItemParametersAsJson?: InputMaybe<Scalars['String']['input']>;
  referencedItemSlug?: InputMaybe<Scalars['String']['input']>;
  referencedItemType?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  taskTypeKey?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpsertTaskPayload = {
  __typename?: 'UpsertTaskPayload';
  task?: Maybe<ScoTask>;
};

export type UpsertTaskTemplateInput = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  bodyAsMarkdown?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupRequestTypeKey?: InputMaybe<Scalars['String']['input']>;
  parentTaskTemplateId?: InputMaybe<Scalars['String']['input']>;
  priorityIndex?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  referencedItemComponent?: InputMaybe<Scalars['String']['input']>;
  referencedItemId?: InputMaybe<Scalars['String']['input']>;
  referencedItemIdFieldOnAttachment?: InputMaybe<Scalars['String']['input']>;
  referencedItemParametersAsJson?: InputMaybe<Scalars['String']['input']>;
  referencedItemSlug?: InputMaybe<Scalars['String']['input']>;
  referencedItemType?: InputMaybe<Scalars['String']['input']>;
  taskTemplateId?: InputMaybe<Scalars['String']['input']>;
  taskTypeKey?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateRelatedTasks?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpsertTaskTemplatePayload = {
  __typename?: 'UpsertTaskTemplatePayload';
  taskTemplate?: Maybe<ScoTaskTemplate>;
  tasks?: Maybe<Array<Maybe<ScoTask>>>;
};

export type UpsertThreadInput = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  tagSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  threadSlug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicTermSlug?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertThreadPayload = {
  __typename?: 'UpsertThreadPayload';
  thread?: Maybe<ScoThread>;
};

export type UpsertToolCapabilityInput = {
  authModeKey?: InputMaybe<Scalars['String']['input']>;
  capabilityTypeKey?: InputMaybe<Scalars['String']['input']>;
  configAsJson?: InputMaybe<Scalars['JSON']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  positionIndex?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toolCapabilityId?: InputMaybe<Scalars['String']['input']>;
  toolId: Scalars['UUID']['input'];
};

export type UpsertToolCapabilityPayload = {
  __typename?: 'UpsertToolCapabilityPayload';
  toolCapability?: Maybe<ScoToolCapability>;
};

export type UpsertToolDraftInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  inboundCommentId?: InputMaybe<Scalars['String']['input']>;
  seenInboundCommentId?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
  toolId: Scalars['String']['input'];
};

export type UpsertToolDraftPayload = {
  __typename?: 'UpsertToolDraftPayload';
  comment?: Maybe<ScoCrmThreadComment>;
  discarded?: Maybe<Scalars['Boolean']['output']>;
  unchanged?: Maybe<Scalars['Boolean']['output']>;
};

export type UpsertToolInput = {
  aiConfigAsJson?: InputMaybe<Scalars['JSON']['input']>;
  allowAnonymousSessions?: InputMaybe<Scalars['Boolean']['input']>;
  bodyAsMarkdown?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featuredImageUrl?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toolId?: InputMaybe<Scalars['String']['input']>;
  toolTypeKey?: InputMaybe<Scalars['String']['input']>;
  toolUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertToolInputInput = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  positionIndex?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toolId: Scalars['UUID']['input'];
  toolInputId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertToolInputPayload = {
  __typename?: 'UpsertToolInputPayload';
  toolInput?: Maybe<ScoToolInput>;
};

export type UpsertToolKnowledgeCardInput = {
  cardTypeKey?: InputMaybe<Scalars['String']['input']>;
  failure?: InputMaybe<Scalars['String']['input']>;
  goodLooksLike?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemsKey?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  payoff?: InputMaybe<Scalars['String']['input']>;
  sourceKey?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toolId?: InputMaybe<Scalars['String']['input']>;
  toolKnowledgeCardId?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertToolKnowledgeCardPayload = {
  __typename?: 'UpsertToolKnowledgeCardPayload';
  toolKnowledgeCard?: Maybe<ScoToolKnowledgeCard>;
};

export type UpsertToolOutputInput = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  dataValue?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toolId: Scalars['UUID']['input'];
  toolOutputId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertToolOutputPayload = {
  __typename?: 'UpsertToolOutputPayload';
  toolOutput?: Maybe<ScoToolOutput>;
};

export type UpsertToolPayload = {
  __typename?: 'UpsertToolPayload';
  tool?: Maybe<ScoTool>;
};

export type UpsertToolReplyTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<ToolReplyTemplateFieldInput>>>;
  templateKindKey?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toolId?: InputMaybe<Scalars['String']['input']>;
  toolReplyTemplateId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertToolReplyTemplatePayload = {
  __typename?: 'UpsertToolReplyTemplatePayload';
  clearedAutoSendCount?: Maybe<Scalars['Int']['output']>;
  template?: Maybe<ScoToolReplyTemplate>;
};

export type UpsertToolRuleBindingInput = {
  autoSendEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  bar?: InputMaybe<Scalars['Int']['input']>;
  catches?: InputMaybe<Scalars['String']['input']>;
  clearCatches?: InputMaybe<Scalars['Boolean']['input']>;
  clearTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  confirmHardStop?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  templateBody?: InputMaybe<Scalars['String']['input']>;
  toolId: Scalars['String']['input'];
  toolReplyTemplateId?: InputMaybe<Scalars['String']['input']>;
  toolRuleId: Scalars['String']['input'];
  variablesAsJson?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpsertToolRuleBindingPayload = {
  __typename?: 'UpsertToolRuleBindingPayload';
  revisionId?: Maybe<Scalars['String']['output']>;
  toolRuleBinding?: Maybe<ScoToolRuleBinding>;
};

export type UpsertToolRuleInput = {
  bar?: InputMaybe<Scalars['Int']['input']>;
  catches?: InputMaybe<Scalars['String']['input']>;
  citedCardId?: InputMaybe<Scalars['String']['input']>;
  codeCheckKey?: InputMaybe<Scalars['String']['input']>;
  draftModeKey?: InputMaybe<Scalars['String']['input']>;
  evaluatorKey?: InputMaybe<Scalars['String']['input']>;
  exampleMessage?: InputMaybe<Scalars['String']['input']>;
  groupKey?: InputMaybe<Scalars['String']['input']>;
  laneKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceKey?: InputMaybe<Scalars['String']['input']>;
  templateBody?: InputMaybe<Scalars['String']['input']>;
  templateKindKey?: InputMaybe<Scalars['String']['input']>;
  toolReplyTemplateId?: InputMaybe<Scalars['String']['input']>;
  toolRuleId?: InputMaybe<Scalars['String']['input']>;
  why?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertToolRulePayload = {
  __typename?: 'UpsertToolRulePayload';
  toolRule?: Maybe<ScoToolRule>;
};

export type UpsertToolSessionInput = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  inputAsJson?: InputMaybe<Scalars['JSON']['input']>;
  outputAsJson?: InputMaybe<Scalars['JSON']['input']>;
  threadId?: InputMaybe<Scalars['UUID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toolId?: InputMaybe<Scalars['UUID']['input']>;
  toolSessionId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertToolSessionPayload = {
  __typename?: 'UpsertToolSessionPayload';
  toolSession?: Maybe<ScoToolSession>;
};

export type UpsertUserDeviceInput = {
  deviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceOS?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  deviceUserAgent?: InputMaybe<Scalars['String']['input']>;
  expoPushToken?: InputMaybe<Scalars['String']['input']>;
  userDeviceId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUserDevicePayload = {
  __typename?: 'UpsertUserDevicePayload';
  userDevice?: Maybe<ScoUserDevice>;
};

export type UpsertUserExperienceInput = {
  accomplishmentDescription?: InputMaybe<Scalars['String']['input']>;
  accomplishmentTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  experienceTypeKey?: InputMaybe<Scalars['String']['input']>;
  industryKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  positionDescription?: InputMaybe<Scalars['String']['input']>;
  positionTitle?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userExperienceId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUserExperiencePayload = {
  __typename?: 'UpsertUserExperiencePayload';
  user?: Maybe<ScoUser>;
  userExperience?: Maybe<ScoUserExperience>;
  viewer?: Maybe<Viewer>;
};

export type UpsertUserFounderNeedsInput = {
  founderNeedsKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  founderNeedsOther?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUserFounderNeedsPayload = {
  __typename?: 'UpsertUserFounderNeedsPayload';
  user?: Maybe<ScoUser>;
};

export type UpsertUserInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  coverPhotoXInPercent?: InputMaybe<Scalars['Float']['input']>;
  coverPhotoYInPercent?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  locationCountryKey?: InputMaybe<Scalars['String']['input']>;
  locationLatitude?: InputMaybe<Scalars['Float']['input']>;
  locationLongitude?: InputMaybe<Scalars['Float']['input']>;
  locationPlaceId?: InputMaybe<Scalars['String']['input']>;
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  locationState?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  profileVisibilityKey?: InputMaybe<Scalars['String']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUserMatchInput = {
  ratingBySearchingUser?: InputMaybe<Scalars['Int']['input']>;
  ratingByTargetUser?: InputMaybe<Scalars['Int']['input']>;
  ratingNoteBySearchingUser?: InputMaybe<Scalars['String']['input']>;
  ratingNoteByTargetUser?: InputMaybe<Scalars['String']['input']>;
  savedBySearchingUserAt?: InputMaybe<Scalars['DateTime']['input']>;
  savedByTargetUserAt?: InputMaybe<Scalars['DateTime']['input']>;
  userMatchId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUserMatchPayload = {
  __typename?: 'UpsertUserMatchPayload';
  userMatch?: Maybe<ScoUserMatch>;
};

export type UpsertUserPayload = {
  __typename?: 'UpsertUserPayload';
  user?: Maybe<ScoUser>;
};

export type UpsertUserPreferenceInput = {
  preferenceKey: Scalars['String']['input'];
  preferenceValueAsJson?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUserPreferencePayload = {
  __typename?: 'UpsertUserPreferencePayload';
  user: ScoUser;
  userPreference: ScoUserPreference;
};

export type UpsertUserPreferencesInput = {
  preferences?: InputMaybe<Array<InputMaybe<UpsertUserPreferenceInput>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUserPreferencesPayload = {
  __typename?: 'UpsertUserPreferencesPayload';
  user: ScoUser;
  userPreferences?: Maybe<Array<Maybe<ScoUserPreference>>>;
};

export type UpsertUserPreferredInteractionsInput = {
  preferredInteractionsKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUserPreferredInteractionsPayload = {
  __typename?: 'UpsertUserPreferredInteractionsPayload';
  user?: Maybe<ScoUser>;
};

export type UpsertUserSearchInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  industryKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isMatchEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  locationCountryKey?: InputMaybe<Scalars['String']['input']>;
  locationLatitude?: InputMaybe<Scalars['Float']['input']>;
  locationLongitude?: InputMaybe<Scalars['Float']['input']>;
  locationState?: InputMaybe<Scalars['String']['input']>;
  naturalLanguagePrompt?: InputMaybe<Scalars['String']['input']>;
  parametersAsJSON?: InputMaybe<Scalars['String']['input']>;
  reprocess?: InputMaybe<Scalars['Boolean']['input']>;
  requiredSkillIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requiredSkillTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  userRoleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userSearchId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUserSearchPayload = {
  __typename?: 'UpsertUserSearchPayload';
  userSearch?: Maybe<ScoUserSearch>;
};

export type UpsertUserSkillInput = {
  compensationNotes?: InputMaybe<Scalars['String']['input']>;
  compensationTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  compensationUnit?: InputMaybe<Scalars['String']['input']>;
  compensationValue?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  experienceNotes?: InputMaybe<Scalars['String']['input']>;
  experienceStrength?: InputMaybe<Scalars['Int']['input']>;
  skillId?: InputMaybe<Scalars['String']['input']>;
  timeCommitmentNotes?: InputMaybe<Scalars['String']['input']>;
  timeCommitmentTypeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeCommitmentUnit?: InputMaybe<Scalars['String']['input']>;
  timeCommitmentValue?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userRoleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userSkillId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUserSkillPayload = {
  __typename?: 'UpsertUserSkillPayload';
  user?: Maybe<ScoUser>;
  userSkill?: Maybe<ScoUserSkill>;
};

export type UpsertUserSkillsInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
  userSkills?: InputMaybe<Array<InputMaybe<UpsertUserSkillInput>>>;
};

export type UpsertUserSkillsPayload = {
  __typename?: 'UpsertUserSkillsPayload';
  user?: Maybe<ScoUser>;
  userSkills?: Maybe<Array<Maybe<ScoUserSkill>>>;
};

export type UpsertViewInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completionAsPercent?: InputMaybe<Scalars['Int']['input']>;
  parentContext?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentType?: InputMaybe<Scalars['String']['input']>;
  playbackPositionInSeconds?: InputMaybe<Scalars['Int']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewableContext?: InputMaybe<Scalars['String']['input']>;
  viewableId: Scalars['String']['input'];
  viewableType: Scalars['String']['input'];
};

export type UpsertViewPayload = {
  __typename?: 'UpsertViewPayload';
  view?: Maybe<ScoView>;
};

/** User system model */
export type User = Entity & Node & {
  __typename?: 'User';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** Get the document in other stages */
  documentInStages: Array<User>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Flag to determine if user is active or not */
  isActive: Scalars['Boolean']['output'];
  /** User Kind. Can be either MEMBER, PAT or PUBLIC */
  kind: UserKind;
  /** The username */
  name: Scalars['String']['output'];
  /** Profile Picture url */
  picture?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
};


/** User system model */
export type UserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type UserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: UserWhereUniqueInput;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserCreateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateOneInlineInput = {
  /** Connect one existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

/** System User Kind */
export enum UserKind {
  Member = 'MEMBER',
  Pat = 'PAT',
  Public = 'PUBLIC',
  Webhook = 'WEBHOOK'
}

/** Identifies documents */
export type UserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum UserOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  KindAsc = 'kind_ASC',
  KindDesc = 'kind_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PictureAsc = 'picture_ASC',
  PictureDesc = 'picture_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type UserUpdateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Disconnect multiple User documents */
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing User documents */
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateOneInlineInput = {
  /** Connect existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
  /** Disconnect currently connected User document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Version = {
  __typename?: 'Version';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export type VersionWhereInput = {
  id: Scalars['ID']['input'];
  revision: Scalars['Int']['input'];
  stage: Stage;
};

export type Video = Entity & Node & {
  __typename?: 'Video';
  color?: Maybe<Color>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Video>;
  durationInSeconds?: Maybe<Scalars['Int']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalImageUrl?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<Asset>;
  /** List of Video versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  longDescription?: Maybe<Scalars['String']['output']>;
  people: Array<Person>;
  premieredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  subtitle?: Maybe<Scalars['String']['output']>;
  terms: Array<Term>;
  title: Scalars['String']['output'];
  transcript?: Maybe<Scalars['String']['output']>;
  types: Array<VideoType>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  videoLists: Array<VideoList>;
  videoPreviewUrl?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};


export type VideoCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type VideoFeaturedImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type VideoHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type VideoPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PersonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonWhereInput>;
};


export type VideoPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type VideoTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


export type VideoUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoVideoListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoListWhereInput>;
};

export type VideoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: VideoWhereUniqueInput;
};

/** A connection to a list of items. */
export type VideoConnection = {
  __typename?: 'VideoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VideoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VideoCourse = Entity & Node & {
  __typename?: 'VideoCourse';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<VideoCourse>;
  experts: Array<Person>;
  featuredImage?: Maybe<Asset>;
  /** List of VideoCourse versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Is this video course available to all visitors, not paywalled? */
  isAvailableForFree?: Maybe<Scalars['Boolean']['output']>;
  originalId?: Maybe<Scalars['Int']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  steps: Array<VideoListEntry>;
  synopsis?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms: Array<Term>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  videoCourseListEntries: Array<VideoCourseListEntry>;
};


export type VideoCourseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoCourseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type VideoCourseExpertsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PersonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonWhereInput>;
};


export type VideoCourseFeaturedImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type VideoCourseHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type VideoCoursePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoCourseScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type VideoCourseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoListEntryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoListEntryWhereInput>;
};


export type VideoCourseTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


export type VideoCourseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoCourseVideoCourseListEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoCourseListEntryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoCourseListEntryWhereInput>;
};

export type VideoCourseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: VideoCourseWhereUniqueInput;
};

/** A connection to a list of items. */
export type VideoCourseConnection = {
  __typename?: 'VideoCourseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VideoCourseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VideoCourseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  experts?: InputMaybe<PersonCreateManyInlineInput>;
  featuredImage?: InputMaybe<AssetCreateOneInlineInput>;
  isAvailableForFree?: InputMaybe<Scalars['Boolean']['input']>;
  originalId?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  steps?: InputMaybe<VideoListEntryCreateManyInlineInput>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoCourseListEntries?: InputMaybe<VideoCourseListEntryCreateManyInlineInput>;
};

export type VideoCourseCreateManyInlineInput = {
  /** Connect multiple existing VideoCourse documents */
  connect?: InputMaybe<Array<VideoCourseWhereUniqueInput>>;
  /** Create and connect multiple existing VideoCourse documents */
  create?: InputMaybe<Array<VideoCourseCreateInput>>;
};

export type VideoCourseCreateOneInlineInput = {
  /** Connect one existing VideoCourse document */
  connect?: InputMaybe<VideoCourseWhereUniqueInput>;
  /** Create and connect one VideoCourse document */
  create?: InputMaybe<VideoCourseCreateInput>;
};

/** An edge in a connection. */
export type VideoCourseEdge = {
  __typename?: 'VideoCourseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VideoCourse;
};

export type VideoCourseListEntry = Entity & Node & {
  __typename?: 'VideoCourseListEntry';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<VideoCourseListEntry>;
  /** List of VideoCourseListEntry versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  videoCourse?: Maybe<VideoCourse>;
  videoPlaylists: Array<VideoPlaylist>;
};


export type VideoCourseListEntryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoCourseListEntryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type VideoCourseListEntryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type VideoCourseListEntryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoCourseListEntryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type VideoCourseListEntryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoCourseListEntryVideoCourseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoCourseListEntryVideoPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoPlaylistOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoPlaylistWhereInput>;
};

export type VideoCourseListEntryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: VideoCourseListEntryWhereUniqueInput;
};

/** A connection to a list of items. */
export type VideoCourseListEntryConnection = {
  __typename?: 'VideoCourseListEntryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VideoCourseListEntryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VideoCourseListEntryCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  number: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoCourse?: InputMaybe<VideoCourseCreateOneInlineInput>;
  videoPlaylists?: InputMaybe<VideoPlaylistCreateManyInlineInput>;
};

export type VideoCourseListEntryCreateManyInlineInput = {
  /** Connect multiple existing VideoCourseListEntry documents */
  connect?: InputMaybe<Array<VideoCourseListEntryWhereUniqueInput>>;
  /** Create and connect multiple existing VideoCourseListEntry documents */
  create?: InputMaybe<Array<VideoCourseListEntryCreateInput>>;
};

export type VideoCourseListEntryCreateOneInlineInput = {
  /** Connect one existing VideoCourseListEntry document */
  connect?: InputMaybe<VideoCourseListEntryWhereUniqueInput>;
  /** Create and connect one VideoCourseListEntry document */
  create?: InputMaybe<VideoCourseListEntryCreateInput>;
};

/** An edge in a connection. */
export type VideoCourseListEntryEdge = {
  __typename?: 'VideoCourseListEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VideoCourseListEntry;
};

/** Identifies documents */
export type VideoCourseListEntryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoCourseListEntryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoCourseListEntryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoCourseListEntryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoCourseListEntryWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoCourseListEntryWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoCourseListEntryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  number_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  number_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  number_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  number_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  number_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  number_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  number_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoCourse?: InputMaybe<VideoCourseWhereInput>;
  videoPlaylists_every?: InputMaybe<VideoPlaylistWhereInput>;
  videoPlaylists_none?: InputMaybe<VideoPlaylistWhereInput>;
  videoPlaylists_some?: InputMaybe<VideoPlaylistWhereInput>;
};

export enum VideoCourseListEntryOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NumberAsc = 'number_ASC',
  NumberDesc = 'number_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type VideoCourseListEntryUpdateInput = {
  number?: InputMaybe<Scalars['Int']['input']>;
  videoCourse?: InputMaybe<VideoCourseUpdateOneInlineInput>;
  videoPlaylists?: InputMaybe<VideoPlaylistUpdateManyInlineInput>;
};

export type VideoCourseListEntryUpdateManyInlineInput = {
  /** Connect multiple existing VideoCourseListEntry documents */
  connect?: InputMaybe<Array<VideoCourseListEntryConnectInput>>;
  /** Create and connect multiple VideoCourseListEntry documents */
  create?: InputMaybe<Array<VideoCourseListEntryCreateInput>>;
  /** Delete multiple VideoCourseListEntry documents */
  delete?: InputMaybe<Array<VideoCourseListEntryWhereUniqueInput>>;
  /** Disconnect multiple VideoCourseListEntry documents */
  disconnect?: InputMaybe<Array<VideoCourseListEntryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing VideoCourseListEntry documents */
  set?: InputMaybe<Array<VideoCourseListEntryWhereUniqueInput>>;
  /** Update multiple VideoCourseListEntry documents */
  update?: InputMaybe<Array<VideoCourseListEntryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple VideoCourseListEntry documents */
  upsert?: InputMaybe<Array<VideoCourseListEntryUpsertWithNestedWhereUniqueInput>>;
};

export type VideoCourseListEntryUpdateManyInput = {
  number?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoCourseListEntryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VideoCourseListEntryUpdateManyInput;
  /** Document search */
  where: VideoCourseListEntryWhereInput;
};

export type VideoCourseListEntryUpdateOneInlineInput = {
  /** Connect existing VideoCourseListEntry document */
  connect?: InputMaybe<VideoCourseListEntryWhereUniqueInput>;
  /** Create and connect one VideoCourseListEntry document */
  create?: InputMaybe<VideoCourseListEntryCreateInput>;
  /** Delete currently connected VideoCourseListEntry document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected VideoCourseListEntry document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single VideoCourseListEntry document */
  update?: InputMaybe<VideoCourseListEntryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single VideoCourseListEntry document */
  upsert?: InputMaybe<VideoCourseListEntryUpsertWithNestedWhereUniqueInput>;
};

export type VideoCourseListEntryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VideoCourseListEntryUpdateInput;
  /** Unique document search */
  where: VideoCourseListEntryWhereUniqueInput;
};

export type VideoCourseListEntryUpsertInput = {
  /** Create document if it didn't exist */
  create: VideoCourseListEntryCreateInput;
  /** Update document if it exists */
  update: VideoCourseListEntryUpdateInput;
};

export type VideoCourseListEntryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VideoCourseListEntryUpsertInput;
  /** Unique document search */
  where: VideoCourseListEntryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type VideoCourseListEntryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type VideoCourseListEntryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoCourseListEntryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoCourseListEntryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoCourseListEntryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoCourseListEntryWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoCourseListEntryWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoCourseListEntryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  number_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  number_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  number_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  number_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  number_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  number_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  number_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoCourse?: InputMaybe<VideoCourseWhereInput>;
  videoPlaylists_every?: InputMaybe<VideoPlaylistWhereInput>;
  videoPlaylists_none?: InputMaybe<VideoPlaylistWhereInput>;
  videoPlaylists_some?: InputMaybe<VideoPlaylistWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type VideoCourseListEntryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoCourseListEntryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoCourseListEntryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoCourseListEntryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<VideoCourseListEntryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References VideoCourseListEntry record uniquely */
export type VideoCourseListEntryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type VideoCourseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoCourseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoCourseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoCourseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<VideoCourseWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoCourseWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoCourseWhereStageInput>;
  experts_every?: InputMaybe<PersonWhereInput>;
  experts_none?: InputMaybe<PersonWhereInput>;
  experts_some?: InputMaybe<PersonWhereInput>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isAvailableForFree?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isAvailableForFree_not?: InputMaybe<Scalars['Boolean']['input']>;
  originalId?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  originalId_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  originalId_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  originalId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  originalId_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  originalId_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  originalId_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  originalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  steps_every?: InputMaybe<VideoListEntryWhereInput>;
  steps_none?: InputMaybe<VideoListEntryWhereInput>;
  steps_some?: InputMaybe<VideoListEntryWhereInput>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  synopsis_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  synopsis_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  synopsis_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  synopsis_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  synopsis_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  synopsis_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  synopsis_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  synopsis_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  synopsis_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  teaser_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  teaser_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  teaser_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  teaser_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  teaser_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  teaser_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  teaser_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  teaser_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  teaser_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoCourseListEntries_every?: InputMaybe<VideoCourseListEntryWhereInput>;
  videoCourseListEntries_none?: InputMaybe<VideoCourseListEntryWhereInput>;
  videoCourseListEntries_some?: InputMaybe<VideoCourseListEntryWhereInput>;
};

export enum VideoCourseOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsAvailableForFreeAsc = 'isAvailableForFree_ASC',
  IsAvailableForFreeDesc = 'isAvailableForFree_DESC',
  OriginalIdAsc = 'originalId_ASC',
  OriginalIdDesc = 'originalId_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SynopsisAsc = 'synopsis_ASC',
  SynopsisDesc = 'synopsis_DESC',
  TeaserAsc = 'teaser_ASC',
  TeaserDesc = 'teaser_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type VideoCourseUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  experts?: InputMaybe<PersonUpdateManyInlineInput>;
  featuredImage?: InputMaybe<AssetUpdateOneInlineInput>;
  isAvailableForFree?: InputMaybe<Scalars['Boolean']['input']>;
  originalId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<VideoListEntryUpdateManyInlineInput>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoCourseListEntries?: InputMaybe<VideoCourseListEntryUpdateManyInlineInput>;
};

export type VideoCourseUpdateManyInlineInput = {
  /** Connect multiple existing VideoCourse documents */
  connect?: InputMaybe<Array<VideoCourseConnectInput>>;
  /** Create and connect multiple VideoCourse documents */
  create?: InputMaybe<Array<VideoCourseCreateInput>>;
  /** Delete multiple VideoCourse documents */
  delete?: InputMaybe<Array<VideoCourseWhereUniqueInput>>;
  /** Disconnect multiple VideoCourse documents */
  disconnect?: InputMaybe<Array<VideoCourseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing VideoCourse documents */
  set?: InputMaybe<Array<VideoCourseWhereUniqueInput>>;
  /** Update multiple VideoCourse documents */
  update?: InputMaybe<Array<VideoCourseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple VideoCourse documents */
  upsert?: InputMaybe<Array<VideoCourseUpsertWithNestedWhereUniqueInput>>;
};

export type VideoCourseUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isAvailableForFree?: InputMaybe<Scalars['Boolean']['input']>;
  originalId?: InputMaybe<Scalars['Int']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type VideoCourseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VideoCourseUpdateManyInput;
  /** Document search */
  where: VideoCourseWhereInput;
};

export type VideoCourseUpdateOneInlineInput = {
  /** Connect existing VideoCourse document */
  connect?: InputMaybe<VideoCourseWhereUniqueInput>;
  /** Create and connect one VideoCourse document */
  create?: InputMaybe<VideoCourseCreateInput>;
  /** Delete currently connected VideoCourse document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected VideoCourse document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single VideoCourse document */
  update?: InputMaybe<VideoCourseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single VideoCourse document */
  upsert?: InputMaybe<VideoCourseUpsertWithNestedWhereUniqueInput>;
};

export type VideoCourseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VideoCourseUpdateInput;
  /** Unique document search */
  where: VideoCourseWhereUniqueInput;
};

export type VideoCourseUpsertInput = {
  /** Create document if it didn't exist */
  create: VideoCourseCreateInput;
  /** Update document if it exists */
  update: VideoCourseUpdateInput;
};

export type VideoCourseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VideoCourseUpsertInput;
  /** Unique document search */
  where: VideoCourseWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type VideoCourseWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type VideoCourseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoCourseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoCourseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoCourseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<VideoCourseWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoCourseWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoCourseWhereStageInput>;
  experts_every?: InputMaybe<PersonWhereInput>;
  experts_none?: InputMaybe<PersonWhereInput>;
  experts_some?: InputMaybe<PersonWhereInput>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isAvailableForFree?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isAvailableForFree_not?: InputMaybe<Scalars['Boolean']['input']>;
  originalId?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  originalId_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  originalId_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  originalId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  originalId_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  originalId_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  originalId_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  originalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  steps_every?: InputMaybe<VideoListEntryWhereInput>;
  steps_none?: InputMaybe<VideoListEntryWhereInput>;
  steps_some?: InputMaybe<VideoListEntryWhereInput>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  synopsis_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  synopsis_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  synopsis_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  synopsis_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  synopsis_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  synopsis_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  synopsis_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  synopsis_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  synopsis_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  teaser_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  teaser_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  teaser_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  teaser_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  teaser_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  teaser_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  teaser_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  teaser_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  teaser_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoCourseListEntries_every?: InputMaybe<VideoCourseListEntryWhereInput>;
  videoCourseListEntries_none?: InputMaybe<VideoCourseListEntryWhereInput>;
  videoCourseListEntries_some?: InputMaybe<VideoCourseListEntryWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type VideoCourseWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoCourseWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoCourseWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoCourseWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<VideoCourseWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References VideoCourse record uniquely */
export type VideoCourseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type VideoCreateInput = {
  color?: InputMaybe<ColorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  durationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalImageUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<AssetCreateOneInlineInput>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<PersonCreateManyInlineInput>;
  premieredAt?: InputMaybe<Scalars['DateTime']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermCreateManyInlineInput>;
  title: Scalars['String']['input'];
  transcript?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<VideoType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoLists?: InputMaybe<VideoListCreateManyInlineInput>;
  videoPreviewUrl?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type VideoCreateManyInlineInput = {
  /** Connect multiple existing Video documents */
  connect?: InputMaybe<Array<VideoWhereUniqueInput>>;
  /** Create and connect multiple existing Video documents */
  create?: InputMaybe<Array<VideoCreateInput>>;
};

export type VideoCreateOneInlineInput = {
  /** Connect one existing Video document */
  connect?: InputMaybe<VideoWhereUniqueInput>;
  /** Create and connect one Video document */
  create?: InputMaybe<VideoCreateInput>;
};

/** An edge in a connection. */
export type VideoEdge = {
  __typename?: 'VideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Video;
};

export type VideoLesson = Entity & Node & {
  __typename?: 'VideoLesson';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<VideoLesson>;
  experts: Array<Person>;
  /** List of VideoLesson versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  lessonsLearned: Array<Scalars['String']['output']>;
  links: Array<Link>;
  originalCourseId?: Maybe<Scalars['Int']['output']>;
  originalStepNumber?: Maybe<Scalars['Int']['output']>;
  playlists: Array<Playlist>;
  posterImage?: Maybe<Asset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  subtitle?: Maybe<Scalars['String']['output']>;
  synopsis?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms: Array<Term>;
  title?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  videoDuration?: Maybe<Scalars['Float']['output']>;
  videoHdUrl?: Maybe<Scalars['String']['output']>;
  videoListEntries: Array<VideoListEntry>;
  videoMobileUrl?: Maybe<Scalars['String']['output']>;
  videoPreviewUrl?: Maybe<Scalars['String']['output']>;
  videoSdUrl?: Maybe<Scalars['String']['output']>;
  videoSourceUrl?: Maybe<Scalars['String']['output']>;
};


export type VideoLessonCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoLessonDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type VideoLessonExpertsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PersonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonWhereInput>;
};


export type VideoLessonHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type VideoLessonLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type VideoLessonPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PlaylistOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PlaylistWhereInput>;
};


export type VideoLessonPosterImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type VideoLessonPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoLessonScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type VideoLessonTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


export type VideoLessonUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoLessonVideoListEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoListEntryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoListEntryWhereInput>;
};

export type VideoLessonConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: VideoLessonWhereUniqueInput;
};

/** A connection to a list of items. */
export type VideoLessonConnection = {
  __typename?: 'VideoLessonConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VideoLessonEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VideoLessonCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  experts?: InputMaybe<PersonCreateManyInlineInput>;
  lessonsLearned?: InputMaybe<Array<Scalars['String']['input']>>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  originalCourseId?: InputMaybe<Scalars['Int']['input']>;
  originalStepNumber?: InputMaybe<Scalars['Int']['input']>;
  playlists?: InputMaybe<PlaylistCreateManyInlineInput>;
  posterImage?: InputMaybe<AssetCreateOneInlineInput>;
  slug: Scalars['String']['input'];
  subtitle?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoDuration?: InputMaybe<Scalars['Float']['input']>;
  videoHdUrl?: InputMaybe<Scalars['String']['input']>;
  videoListEntries?: InputMaybe<VideoListEntryCreateManyInlineInput>;
  videoMobileUrl?: InputMaybe<Scalars['String']['input']>;
  videoPreviewUrl?: InputMaybe<Scalars['String']['input']>;
  videoSdUrl?: InputMaybe<Scalars['String']['input']>;
  videoSourceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type VideoLessonCreateManyInlineInput = {
  /** Connect multiple existing VideoLesson documents */
  connect?: InputMaybe<Array<VideoLessonWhereUniqueInput>>;
  /** Create and connect multiple existing VideoLesson documents */
  create?: InputMaybe<Array<VideoLessonCreateInput>>;
};

export type VideoLessonCreateOneInlineInput = {
  /** Connect one existing VideoLesson document */
  connect?: InputMaybe<VideoLessonWhereUniqueInput>;
  /** Create and connect one VideoLesson document */
  create?: InputMaybe<VideoLessonCreateInput>;
};

/** An edge in a connection. */
export type VideoLessonEdge = {
  __typename?: 'VideoLessonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VideoLesson;
};

/** Identifies documents */
export type VideoLessonManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoLessonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoLessonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoLessonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoLessonWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoLessonWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoLessonWhereStageInput>;
  experts_every?: InputMaybe<PersonWhereInput>;
  experts_none?: InputMaybe<PersonWhereInput>;
  experts_some?: InputMaybe<PersonWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  lessonsLearned?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  lessonsLearned_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  lessonsLearned_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  lessonsLearned_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  lessonsLearned_not?: InputMaybe<Array<Scalars['String']['input']>>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  originalCourseId?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  originalCourseId_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  originalCourseId_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  originalCourseId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  originalCourseId_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  originalCourseId_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  originalCourseId_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  originalCourseId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  originalStepNumber?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  originalStepNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  originalStepNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  originalStepNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  originalStepNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  originalStepNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  originalStepNumber_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  originalStepNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  playlists_every?: InputMaybe<PlaylistWhereInput>;
  playlists_none?: InputMaybe<PlaylistWhereInput>;
  playlists_some?: InputMaybe<PlaylistWhereInput>;
  posterImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  synopsis_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  synopsis_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  synopsis_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  synopsis_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  synopsis_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  synopsis_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  synopsis_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  synopsis_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  synopsis_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  teaser_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  teaser_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  teaser_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  teaser_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  teaser_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  teaser_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  teaser_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  teaser_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  teaser_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  transcript_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  transcript_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  transcript_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  transcript_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  transcript_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  transcript_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  transcript_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  transcript_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  transcript_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoDuration?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  videoDuration_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  videoDuration_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  videoDuration_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  videoDuration_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  videoDuration_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  videoDuration_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  videoDuration_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  videoHdUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoHdUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoHdUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoHdUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoHdUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoHdUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoHdUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoHdUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoHdUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoHdUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoListEntries_every?: InputMaybe<VideoListEntryWhereInput>;
  videoListEntries_none?: InputMaybe<VideoListEntryWhereInput>;
  videoListEntries_some?: InputMaybe<VideoListEntryWhereInput>;
  videoMobileUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoMobileUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoMobileUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoMobileUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoMobileUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoMobileUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoMobileUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoMobileUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoMobileUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoMobileUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoPreviewUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoPreviewUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoPreviewUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoPreviewUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoPreviewUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoPreviewUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoPreviewUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoPreviewUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoPreviewUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoPreviewUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoSdUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoSdUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoSdUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoSdUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoSdUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoSdUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoSdUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoSdUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoSdUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoSdUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoSourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoSourceUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoSourceUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoSourceUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoSourceUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoSourceUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoSourceUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoSourceUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoSourceUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoSourceUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum VideoLessonOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LessonsLearnedAsc = 'lessonsLearned_ASC',
  LessonsLearnedDesc = 'lessonsLearned_DESC',
  OriginalCourseIdAsc = 'originalCourseId_ASC',
  OriginalCourseIdDesc = 'originalCourseId_DESC',
  OriginalStepNumberAsc = 'originalStepNumber_ASC',
  OriginalStepNumberDesc = 'originalStepNumber_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SynopsisAsc = 'synopsis_ASC',
  SynopsisDesc = 'synopsis_DESC',
  TeaserAsc = 'teaser_ASC',
  TeaserDesc = 'teaser_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TranscriptAsc = 'transcript_ASC',
  TranscriptDesc = 'transcript_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VideoDurationAsc = 'videoDuration_ASC',
  VideoDurationDesc = 'videoDuration_DESC',
  VideoHdUrlAsc = 'videoHdUrl_ASC',
  VideoHdUrlDesc = 'videoHdUrl_DESC',
  VideoMobileUrlAsc = 'videoMobileUrl_ASC',
  VideoMobileUrlDesc = 'videoMobileUrl_DESC',
  VideoPreviewUrlAsc = 'videoPreviewUrl_ASC',
  VideoPreviewUrlDesc = 'videoPreviewUrl_DESC',
  VideoSdUrlAsc = 'videoSdUrl_ASC',
  VideoSdUrlDesc = 'videoSdUrl_DESC',
  VideoSourceUrlAsc = 'videoSourceUrl_ASC',
  VideoSourceUrlDesc = 'videoSourceUrl_DESC'
}

export type VideoLessonUpdateInput = {
  experts?: InputMaybe<PersonUpdateManyInlineInput>;
  lessonsLearned?: InputMaybe<Array<Scalars['String']['input']>>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  originalCourseId?: InputMaybe<Scalars['Int']['input']>;
  originalStepNumber?: InputMaybe<Scalars['Int']['input']>;
  playlists?: InputMaybe<PlaylistUpdateManyInlineInput>;
  posterImage?: InputMaybe<AssetUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  videoDuration?: InputMaybe<Scalars['Float']['input']>;
  videoHdUrl?: InputMaybe<Scalars['String']['input']>;
  videoListEntries?: InputMaybe<VideoListEntryUpdateManyInlineInput>;
  videoMobileUrl?: InputMaybe<Scalars['String']['input']>;
  videoPreviewUrl?: InputMaybe<Scalars['String']['input']>;
  videoSdUrl?: InputMaybe<Scalars['String']['input']>;
  videoSourceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type VideoLessonUpdateManyInlineInput = {
  /** Connect multiple existing VideoLesson documents */
  connect?: InputMaybe<Array<VideoLessonConnectInput>>;
  /** Create and connect multiple VideoLesson documents */
  create?: InputMaybe<Array<VideoLessonCreateInput>>;
  /** Delete multiple VideoLesson documents */
  delete?: InputMaybe<Array<VideoLessonWhereUniqueInput>>;
  /** Disconnect multiple VideoLesson documents */
  disconnect?: InputMaybe<Array<VideoLessonWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing VideoLesson documents */
  set?: InputMaybe<Array<VideoLessonWhereUniqueInput>>;
  /** Update multiple VideoLesson documents */
  update?: InputMaybe<Array<VideoLessonUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple VideoLesson documents */
  upsert?: InputMaybe<Array<VideoLessonUpsertWithNestedWhereUniqueInput>>;
};

export type VideoLessonUpdateManyInput = {
  lessonsLearned?: InputMaybe<Array<Scalars['String']['input']>>;
  originalCourseId?: InputMaybe<Scalars['Int']['input']>;
  originalStepNumber?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  videoDuration?: InputMaybe<Scalars['Float']['input']>;
  videoHdUrl?: InputMaybe<Scalars['String']['input']>;
  videoMobileUrl?: InputMaybe<Scalars['String']['input']>;
  videoPreviewUrl?: InputMaybe<Scalars['String']['input']>;
  videoSdUrl?: InputMaybe<Scalars['String']['input']>;
  videoSourceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type VideoLessonUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VideoLessonUpdateManyInput;
  /** Document search */
  where: VideoLessonWhereInput;
};

export type VideoLessonUpdateOneInlineInput = {
  /** Connect existing VideoLesson document */
  connect?: InputMaybe<VideoLessonWhereUniqueInput>;
  /** Create and connect one VideoLesson document */
  create?: InputMaybe<VideoLessonCreateInput>;
  /** Delete currently connected VideoLesson document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected VideoLesson document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single VideoLesson document */
  update?: InputMaybe<VideoLessonUpdateWithNestedWhereUniqueInput>;
  /** Upsert single VideoLesson document */
  upsert?: InputMaybe<VideoLessonUpsertWithNestedWhereUniqueInput>;
};

export type VideoLessonUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VideoLessonUpdateInput;
  /** Unique document search */
  where: VideoLessonWhereUniqueInput;
};

export type VideoLessonUpsertInput = {
  /** Create document if it didn't exist */
  create: VideoLessonCreateInput;
  /** Update document if it exists */
  update: VideoLessonUpdateInput;
};

export type VideoLessonUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VideoLessonUpsertInput;
  /** Unique document search */
  where: VideoLessonWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type VideoLessonWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type VideoLessonWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoLessonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoLessonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoLessonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoLessonWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoLessonWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoLessonWhereStageInput>;
  experts_every?: InputMaybe<PersonWhereInput>;
  experts_none?: InputMaybe<PersonWhereInput>;
  experts_some?: InputMaybe<PersonWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  lessonsLearned?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  lessonsLearned_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  lessonsLearned_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  lessonsLearned_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  lessonsLearned_not?: InputMaybe<Array<Scalars['String']['input']>>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  originalCourseId?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  originalCourseId_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  originalCourseId_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  originalCourseId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  originalCourseId_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  originalCourseId_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  originalCourseId_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  originalCourseId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  originalStepNumber?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  originalStepNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  originalStepNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  originalStepNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  originalStepNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  originalStepNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  originalStepNumber_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  originalStepNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  playlists_every?: InputMaybe<PlaylistWhereInput>;
  playlists_none?: InputMaybe<PlaylistWhereInput>;
  playlists_some?: InputMaybe<PlaylistWhereInput>;
  posterImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  synopsis_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  synopsis_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  synopsis_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  synopsis_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  synopsis_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  synopsis_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  synopsis_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  synopsis_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  synopsis_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  teaser_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  teaser_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  teaser_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  teaser_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  teaser_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  teaser_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  teaser_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  teaser_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  teaser_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  transcript_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  transcript_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  transcript_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  transcript_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  transcript_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  transcript_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  transcript_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  transcript_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  transcript_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoDuration?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  videoDuration_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  videoDuration_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  videoDuration_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  videoDuration_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  videoDuration_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  videoDuration_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  videoDuration_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  videoHdUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoHdUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoHdUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoHdUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoHdUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoHdUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoHdUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoHdUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoHdUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoHdUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoListEntries_every?: InputMaybe<VideoListEntryWhereInput>;
  videoListEntries_none?: InputMaybe<VideoListEntryWhereInput>;
  videoListEntries_some?: InputMaybe<VideoListEntryWhereInput>;
  videoMobileUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoMobileUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoMobileUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoMobileUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoMobileUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoMobileUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoMobileUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoMobileUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoMobileUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoMobileUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoPreviewUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoPreviewUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoPreviewUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoPreviewUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoPreviewUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoPreviewUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoPreviewUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoPreviewUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoPreviewUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoPreviewUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoSdUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoSdUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoSdUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoSdUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoSdUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoSdUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoSdUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoSdUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoSdUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoSdUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoSourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoSourceUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoSourceUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoSourceUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoSourceUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoSourceUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoSourceUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoSourceUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoSourceUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoSourceUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type VideoLessonWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoLessonWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoLessonWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoLessonWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<VideoLessonWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References VideoLesson record uniquely */
export type VideoLessonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type VideoList = Entity & Node & {
  __typename?: 'VideoList';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<VideoList>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalImageUrl?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<Asset>;
  /** List of VideoList versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  longDescription?: Maybe<Scalars['String']['output']>;
  people: Array<Person>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  terms: Array<Term>;
  title: Scalars['String']['output'];
  type?: Maybe<VideoListType>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  videos: Array<Video>;
};


export type VideoListCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoListDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type VideoListFeaturedImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type VideoListHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type VideoListPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PersonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonWhereInput>;
};


export type VideoListPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoListScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type VideoListTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


export type VideoListUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoListVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoWhereInput>;
};

export type VideoListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: VideoListWhereUniqueInput;
};

/** A connection to a list of items. */
export type VideoListConnection = {
  __typename?: 'VideoListConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VideoListEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VideoListCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalImageUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<AssetCreateOneInlineInput>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<PersonCreateManyInlineInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  terms?: InputMaybe<TermCreateManyInlineInput>;
  title: Scalars['String']['input'];
  type?: InputMaybe<VideoListType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videos?: InputMaybe<VideoCreateManyInlineInput>;
};

export type VideoListCreateManyInlineInput = {
  /** Connect multiple existing VideoList documents */
  connect?: InputMaybe<Array<VideoListWhereUniqueInput>>;
  /** Create and connect multiple existing VideoList documents */
  create?: InputMaybe<Array<VideoListCreateInput>>;
};

export type VideoListCreateOneInlineInput = {
  /** Connect one existing VideoList document */
  connect?: InputMaybe<VideoListWhereUniqueInput>;
  /** Create and connect one VideoList document */
  create?: InputMaybe<VideoListCreateInput>;
};

/** An edge in a connection. */
export type VideoListEdge = {
  __typename?: 'VideoListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VideoList;
};

/** Assigns a video to another type, with sortable number field. */
export type VideoListEntry = Entity & Node & {
  __typename?: 'VideoListEntry';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<VideoListEntry>;
  /** List of VideoListEntry versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  videoCourse?: Maybe<VideoCourse>;
  videoLesson?: Maybe<VideoLesson>;
};


/** Assigns a video to another type, with sortable number field. */
export type VideoListEntryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Assigns a video to another type, with sortable number field. */
export type VideoListEntryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Assigns a video to another type, with sortable number field. */
export type VideoListEntryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Assigns a video to another type, with sortable number field. */
export type VideoListEntryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Assigns a video to another type, with sortable number field. */
export type VideoListEntryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Assigns a video to another type, with sortable number field. */
export type VideoListEntryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Assigns a video to another type, with sortable number field. */
export type VideoListEntryVideoCourseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Assigns a video to another type, with sortable number field. */
export type VideoListEntryVideoLessonArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type VideoListEntryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: VideoListEntryWhereUniqueInput;
};

/** A connection to a list of items. */
export type VideoListEntryConnection = {
  __typename?: 'VideoListEntryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VideoListEntryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VideoListEntryCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  number: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoCourse?: InputMaybe<VideoCourseCreateOneInlineInput>;
  videoLesson?: InputMaybe<VideoLessonCreateOneInlineInput>;
};

export type VideoListEntryCreateManyInlineInput = {
  /** Connect multiple existing VideoListEntry documents */
  connect?: InputMaybe<Array<VideoListEntryWhereUniqueInput>>;
  /** Create and connect multiple existing VideoListEntry documents */
  create?: InputMaybe<Array<VideoListEntryCreateInput>>;
};

export type VideoListEntryCreateOneInlineInput = {
  /** Connect one existing VideoListEntry document */
  connect?: InputMaybe<VideoListEntryWhereUniqueInput>;
  /** Create and connect one VideoListEntry document */
  create?: InputMaybe<VideoListEntryCreateInput>;
};

/** An edge in a connection. */
export type VideoListEntryEdge = {
  __typename?: 'VideoListEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VideoListEntry;
};

/** Identifies documents */
export type VideoListEntryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoListEntryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoListEntryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoListEntryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoListEntryWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoListEntryWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoListEntryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  number_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  number_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  number_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  number_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  number_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  number_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  number_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoCourse?: InputMaybe<VideoCourseWhereInput>;
  videoLesson?: InputMaybe<VideoLessonWhereInput>;
};

export enum VideoListEntryOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NumberAsc = 'number_ASC',
  NumberDesc = 'number_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type VideoListEntryUpdateInput = {
  number?: InputMaybe<Scalars['Int']['input']>;
  videoCourse?: InputMaybe<VideoCourseUpdateOneInlineInput>;
  videoLesson?: InputMaybe<VideoLessonUpdateOneInlineInput>;
};

export type VideoListEntryUpdateManyInlineInput = {
  /** Connect multiple existing VideoListEntry documents */
  connect?: InputMaybe<Array<VideoListEntryConnectInput>>;
  /** Create and connect multiple VideoListEntry documents */
  create?: InputMaybe<Array<VideoListEntryCreateInput>>;
  /** Delete multiple VideoListEntry documents */
  delete?: InputMaybe<Array<VideoListEntryWhereUniqueInput>>;
  /** Disconnect multiple VideoListEntry documents */
  disconnect?: InputMaybe<Array<VideoListEntryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing VideoListEntry documents */
  set?: InputMaybe<Array<VideoListEntryWhereUniqueInput>>;
  /** Update multiple VideoListEntry documents */
  update?: InputMaybe<Array<VideoListEntryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple VideoListEntry documents */
  upsert?: InputMaybe<Array<VideoListEntryUpsertWithNestedWhereUniqueInput>>;
};

export type VideoListEntryUpdateManyInput = {
  number?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoListEntryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VideoListEntryUpdateManyInput;
  /** Document search */
  where: VideoListEntryWhereInput;
};

export type VideoListEntryUpdateOneInlineInput = {
  /** Connect existing VideoListEntry document */
  connect?: InputMaybe<VideoListEntryWhereUniqueInput>;
  /** Create and connect one VideoListEntry document */
  create?: InputMaybe<VideoListEntryCreateInput>;
  /** Delete currently connected VideoListEntry document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected VideoListEntry document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single VideoListEntry document */
  update?: InputMaybe<VideoListEntryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single VideoListEntry document */
  upsert?: InputMaybe<VideoListEntryUpsertWithNestedWhereUniqueInput>;
};

export type VideoListEntryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VideoListEntryUpdateInput;
  /** Unique document search */
  where: VideoListEntryWhereUniqueInput;
};

export type VideoListEntryUpsertInput = {
  /** Create document if it didn't exist */
  create: VideoListEntryCreateInput;
  /** Update document if it exists */
  update: VideoListEntryUpdateInput;
};

export type VideoListEntryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VideoListEntryUpsertInput;
  /** Unique document search */
  where: VideoListEntryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type VideoListEntryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type VideoListEntryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoListEntryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoListEntryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoListEntryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoListEntryWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoListEntryWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoListEntryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  number_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  number_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  number_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  number_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  number_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  number_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  number_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoCourse?: InputMaybe<VideoCourseWhereInput>;
  videoLesson?: InputMaybe<VideoLessonWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type VideoListEntryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoListEntryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoListEntryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoListEntryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<VideoListEntryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References VideoListEntry record uniquely */
export type VideoListEntryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type VideoListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoListWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoListWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoListWhereStageInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalId_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalImageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalImageUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalImageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalImageUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalImageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalImageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalImageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalImageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalImageUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  longDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  longDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  longDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  longDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  longDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  longDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  longDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  longDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  longDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  people_every?: InputMaybe<PersonWhereInput>;
  people_none?: InputMaybe<PersonWhereInput>;
  people_some?: InputMaybe<PersonWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VideoListType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<VideoListType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<VideoListType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<VideoListType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videos_every?: InputMaybe<VideoWhereInput>;
  videos_none?: InputMaybe<VideoWhereInput>;
  videos_some?: InputMaybe<VideoWhereInput>;
};

export enum VideoListOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  ExternalIdAsc = 'externalId_ASC',
  ExternalIdDesc = 'externalId_DESC',
  ExternalImageUrlAsc = 'externalImageUrl_ASC',
  ExternalImageUrlDesc = 'externalImageUrl_DESC',
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LongDescriptionAsc = 'longDescription_ASC',
  LongDescriptionDesc = 'longDescription_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export enum VideoListType {
  Lesson = 'LESSON',
  Playlist = 'PLAYLIST',
  RecurringSeries = 'RECURRING_SERIES'
}

export type VideoListUpdateInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalImageUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<AssetUpdateOneInlineInput>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<PersonUpdateManyInlineInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VideoListType>;
  videos?: InputMaybe<VideoUpdateManyInlineInput>;
};

export type VideoListUpdateManyInlineInput = {
  /** Connect multiple existing VideoList documents */
  connect?: InputMaybe<Array<VideoListConnectInput>>;
  /** Create and connect multiple VideoList documents */
  create?: InputMaybe<Array<VideoListCreateInput>>;
  /** Delete multiple VideoList documents */
  delete?: InputMaybe<Array<VideoListWhereUniqueInput>>;
  /** Disconnect multiple VideoList documents */
  disconnect?: InputMaybe<Array<VideoListWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing VideoList documents */
  set?: InputMaybe<Array<VideoListWhereUniqueInput>>;
  /** Update multiple VideoList documents */
  update?: InputMaybe<Array<VideoListUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple VideoList documents */
  upsert?: InputMaybe<Array<VideoListUpsertWithNestedWhereUniqueInput>>;
};

export type VideoListUpdateManyInput = {
  externalImageUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VideoListType>;
};

export type VideoListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VideoListUpdateManyInput;
  /** Document search */
  where: VideoListWhereInput;
};

export type VideoListUpdateOneInlineInput = {
  /** Connect existing VideoList document */
  connect?: InputMaybe<VideoListWhereUniqueInput>;
  /** Create and connect one VideoList document */
  create?: InputMaybe<VideoListCreateInput>;
  /** Delete currently connected VideoList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected VideoList document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single VideoList document */
  update?: InputMaybe<VideoListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single VideoList document */
  upsert?: InputMaybe<VideoListUpsertWithNestedWhereUniqueInput>;
};

export type VideoListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VideoListUpdateInput;
  /** Unique document search */
  where: VideoListWhereUniqueInput;
};

export type VideoListUpsertInput = {
  /** Create document if it didn't exist */
  create: VideoListCreateInput;
  /** Update document if it exists */
  update: VideoListUpdateInput;
};

export type VideoListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VideoListUpsertInput;
  /** Unique document search */
  where: VideoListWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type VideoListWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type VideoListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoListWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoListWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoListWhereStageInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalId_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalImageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalImageUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalImageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalImageUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalImageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalImageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalImageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalImageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalImageUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  longDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  longDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  longDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  longDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  longDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  longDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  longDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  longDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  longDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  people_every?: InputMaybe<PersonWhereInput>;
  people_none?: InputMaybe<PersonWhereInput>;
  people_some?: InputMaybe<PersonWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VideoListType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<VideoListType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<VideoListType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<VideoListType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videos_every?: InputMaybe<VideoWhereInput>;
  videos_none?: InputMaybe<VideoWhereInput>;
  videos_some?: InputMaybe<VideoWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type VideoListWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoListWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoListWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoListWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<VideoListWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References VideoList record uniquely */
export type VideoListWhereUniqueInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies documents */
export type VideoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoWhereStageInput>;
  durationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  durationInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  durationInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  durationInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  durationInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  durationInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  durationInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  durationInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalId_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalImageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalImageUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalImageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalImageUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalImageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalImageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalImageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalImageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalImageUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  longDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  longDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  longDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  longDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  longDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  longDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  longDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  longDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  longDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  people_every?: InputMaybe<PersonWhereInput>;
  people_none?: InputMaybe<PersonWhereInput>;
  people_some?: InputMaybe<PersonWhereInput>;
  premieredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  premieredAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  premieredAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  premieredAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  premieredAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  premieredAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  premieredAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  premieredAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  transcript_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  transcript_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  transcript_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  transcript_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  transcript_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  transcript_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  transcript_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  transcript_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  transcript_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  types?: InputMaybe<Array<VideoType>>;
  /** Matches if the field array contains *all* items provided to the filter */
  types_contains_all?: InputMaybe<Array<VideoType>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  types_contains_none?: InputMaybe<Array<VideoType>>;
  /** Matches if the field array contains at least one item provided to the filter */
  types_contains_some?: InputMaybe<Array<VideoType>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  types_not?: InputMaybe<Array<VideoType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoLists_every?: InputMaybe<VideoListWhereInput>;
  videoLists_none?: InputMaybe<VideoListWhereInput>;
  videoLists_some?: InputMaybe<VideoListWhereInput>;
  videoPreviewUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoPreviewUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoPreviewUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoPreviewUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoPreviewUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoPreviewUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoPreviewUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoPreviewUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoPreviewUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoPreviewUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum VideoOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DurationInSecondsAsc = 'durationInSeconds_ASC',
  DurationInSecondsDesc = 'durationInSeconds_DESC',
  ExternalIdAsc = 'externalId_ASC',
  ExternalIdDesc = 'externalId_DESC',
  ExternalImageUrlAsc = 'externalImageUrl_ASC',
  ExternalImageUrlDesc = 'externalImageUrl_DESC',
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LongDescriptionAsc = 'longDescription_ASC',
  LongDescriptionDesc = 'longDescription_DESC',
  PremieredAtAsc = 'premieredAt_ASC',
  PremieredAtDesc = 'premieredAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TranscriptAsc = 'transcript_ASC',
  TranscriptDesc = 'transcript_DESC',
  TypesAsc = 'types_ASC',
  TypesDesc = 'types_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VideoPreviewUrlAsc = 'videoPreviewUrl_ASC',
  VideoPreviewUrlDesc = 'videoPreviewUrl_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type VideoPlaylist = Entity & Node & {
  __typename?: 'VideoPlaylist';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<VideoPlaylist>;
  featuredImage?: Maybe<Asset>;
  /** List of VideoPlaylist versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  lessonsLearned: Array<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  synopsis?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms: Array<Term>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  videoCourses: Array<VideoCourseListEntry>;
};


export type VideoPlaylistCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoPlaylistDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type VideoPlaylistFeaturedImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type VideoPlaylistHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type VideoPlaylistPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoPlaylistScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type VideoPlaylistTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TermOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermWhereInput>;
};


export type VideoPlaylistUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type VideoPlaylistVideoCoursesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<VideoCourseListEntryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoCourseListEntryWhereInput>;
};

export type VideoPlaylistConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: VideoPlaylistWhereUniqueInput;
};

/** A connection to a list of items. */
export type VideoPlaylistConnection = {
  __typename?: 'VideoPlaylistConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VideoPlaylistEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VideoPlaylistCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  featuredImage?: InputMaybe<AssetCreateOneInlineInput>;
  lessonsLearned?: InputMaybe<Array<Scalars['String']['input']>>;
  slug: Scalars['String']['input'];
  synopsis?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoCourses?: InputMaybe<VideoCourseListEntryCreateManyInlineInput>;
};

export type VideoPlaylistCreateManyInlineInput = {
  /** Connect multiple existing VideoPlaylist documents */
  connect?: InputMaybe<Array<VideoPlaylistWhereUniqueInput>>;
  /** Create and connect multiple existing VideoPlaylist documents */
  create?: InputMaybe<Array<VideoPlaylistCreateInput>>;
};

export type VideoPlaylistCreateOneInlineInput = {
  /** Connect one existing VideoPlaylist document */
  connect?: InputMaybe<VideoPlaylistWhereUniqueInput>;
  /** Create and connect one VideoPlaylist document */
  create?: InputMaybe<VideoPlaylistCreateInput>;
};

/** An edge in a connection. */
export type VideoPlaylistEdge = {
  __typename?: 'VideoPlaylistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VideoPlaylist;
};

/** Identifies documents */
export type VideoPlaylistManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoPlaylistWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoPlaylistWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoPlaylistWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoPlaylistWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoPlaylistWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoPlaylistWhereStageInput>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  lessonsLearned?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  lessonsLearned_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  lessonsLearned_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  lessonsLearned_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  lessonsLearned_not?: InputMaybe<Array<Scalars['String']['input']>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  synopsis_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  synopsis_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  synopsis_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  synopsis_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  synopsis_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  synopsis_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  synopsis_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  synopsis_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  synopsis_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  teaser_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  teaser_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  teaser_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  teaser_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  teaser_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  teaser_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  teaser_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  teaser_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  teaser_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoCourses_every?: InputMaybe<VideoCourseListEntryWhereInput>;
  videoCourses_none?: InputMaybe<VideoCourseListEntryWhereInput>;
  videoCourses_some?: InputMaybe<VideoCourseListEntryWhereInput>;
};

export enum VideoPlaylistOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LessonsLearnedAsc = 'lessonsLearned_ASC',
  LessonsLearnedDesc = 'lessonsLearned_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SynopsisAsc = 'synopsis_ASC',
  SynopsisDesc = 'synopsis_DESC',
  TeaserAsc = 'teaser_ASC',
  TeaserDesc = 'teaser_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type VideoPlaylistUpdateInput = {
  featuredImage?: InputMaybe<AssetUpdateOneInlineInput>;
  lessonsLearned?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoCourses?: InputMaybe<VideoCourseListEntryUpdateManyInlineInput>;
};

export type VideoPlaylistUpdateManyInlineInput = {
  /** Connect multiple existing VideoPlaylist documents */
  connect?: InputMaybe<Array<VideoPlaylistConnectInput>>;
  /** Create and connect multiple VideoPlaylist documents */
  create?: InputMaybe<Array<VideoPlaylistCreateInput>>;
  /** Delete multiple VideoPlaylist documents */
  delete?: InputMaybe<Array<VideoPlaylistWhereUniqueInput>>;
  /** Disconnect multiple VideoPlaylist documents */
  disconnect?: InputMaybe<Array<VideoPlaylistWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing VideoPlaylist documents */
  set?: InputMaybe<Array<VideoPlaylistWhereUniqueInput>>;
  /** Update multiple VideoPlaylist documents */
  update?: InputMaybe<Array<VideoPlaylistUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple VideoPlaylist documents */
  upsert?: InputMaybe<Array<VideoPlaylistUpsertWithNestedWhereUniqueInput>>;
};

export type VideoPlaylistUpdateManyInput = {
  lessonsLearned?: InputMaybe<Array<Scalars['String']['input']>>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type VideoPlaylistUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VideoPlaylistUpdateManyInput;
  /** Document search */
  where: VideoPlaylistWhereInput;
};

export type VideoPlaylistUpdateOneInlineInput = {
  /** Connect existing VideoPlaylist document */
  connect?: InputMaybe<VideoPlaylistWhereUniqueInput>;
  /** Create and connect one VideoPlaylist document */
  create?: InputMaybe<VideoPlaylistCreateInput>;
  /** Delete currently connected VideoPlaylist document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected VideoPlaylist document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single VideoPlaylist document */
  update?: InputMaybe<VideoPlaylistUpdateWithNestedWhereUniqueInput>;
  /** Upsert single VideoPlaylist document */
  upsert?: InputMaybe<VideoPlaylistUpsertWithNestedWhereUniqueInput>;
};

export type VideoPlaylistUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VideoPlaylistUpdateInput;
  /** Unique document search */
  where: VideoPlaylistWhereUniqueInput;
};

export type VideoPlaylistUpsertInput = {
  /** Create document if it didn't exist */
  create: VideoPlaylistCreateInput;
  /** Update document if it exists */
  update: VideoPlaylistUpdateInput;
};

export type VideoPlaylistUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VideoPlaylistUpsertInput;
  /** Unique document search */
  where: VideoPlaylistWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type VideoPlaylistWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type VideoPlaylistWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoPlaylistWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoPlaylistWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoPlaylistWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoPlaylistWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoPlaylistWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoPlaylistWhereStageInput>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  lessonsLearned?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  lessonsLearned_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  lessonsLearned_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  lessonsLearned_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  lessonsLearned_not?: InputMaybe<Array<Scalars['String']['input']>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  synopsis_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  synopsis_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  synopsis_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  synopsis_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  synopsis_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  synopsis_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  synopsis_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  synopsis_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  synopsis_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  teaser_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  teaser_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  teaser_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  teaser_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  teaser_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  teaser_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  teaser_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  teaser_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  teaser_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoCourses_every?: InputMaybe<VideoCourseListEntryWhereInput>;
  videoCourses_none?: InputMaybe<VideoCourseListEntryWhereInput>;
  videoCourses_some?: InputMaybe<VideoCourseListEntryWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type VideoPlaylistWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoPlaylistWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoPlaylistWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoPlaylistWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<VideoPlaylistWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References VideoPlaylist record uniquely */
export type VideoPlaylistWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export enum VideoType {
  HowTo = 'HOW_TO',
  Interview = 'INTERVIEW',
  Lesson = 'LESSON',
  PitchDeckReview = 'PITCH_DECK_REVIEW',
  Qa = 'QA'
}

export type VideoUpdateInput = {
  color?: InputMaybe<ColorInput>;
  durationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalImageUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<AssetUpdateOneInlineInput>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<PersonUpdateManyInlineInput>;
  premieredAt?: InputMaybe<Scalars['DateTime']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<TermUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<VideoType>>;
  videoLists?: InputMaybe<VideoListUpdateManyInlineInput>;
  videoPreviewUrl?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type VideoUpdateManyInlineInput = {
  /** Connect multiple existing Video documents */
  connect?: InputMaybe<Array<VideoConnectInput>>;
  /** Create and connect multiple Video documents */
  create?: InputMaybe<Array<VideoCreateInput>>;
  /** Delete multiple Video documents */
  delete?: InputMaybe<Array<VideoWhereUniqueInput>>;
  /** Disconnect multiple Video documents */
  disconnect?: InputMaybe<Array<VideoWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Video documents */
  set?: InputMaybe<Array<VideoWhereUniqueInput>>;
  /** Update multiple Video documents */
  update?: InputMaybe<Array<VideoUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Video documents */
  upsert?: InputMaybe<Array<VideoUpsertWithNestedWhereUniqueInput>>;
};

export type VideoUpdateManyInput = {
  color?: InputMaybe<ColorInput>;
  durationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  externalImageUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  premieredAt?: InputMaybe<Scalars['DateTime']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<VideoType>>;
  videoPreviewUrl?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type VideoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VideoUpdateManyInput;
  /** Document search */
  where: VideoWhereInput;
};

export type VideoUpdateOneInlineInput = {
  /** Connect existing Video document */
  connect?: InputMaybe<VideoWhereUniqueInput>;
  /** Create and connect one Video document */
  create?: InputMaybe<VideoCreateInput>;
  /** Delete currently connected Video document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Video document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Video document */
  update?: InputMaybe<VideoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Video document */
  upsert?: InputMaybe<VideoUpsertWithNestedWhereUniqueInput>;
};

export type VideoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VideoUpdateInput;
  /** Unique document search */
  where: VideoWhereUniqueInput;
};

export type VideoUpsertInput = {
  /** Create document if it didn't exist */
  create: VideoCreateInput;
  /** Update document if it exists */
  update: VideoUpdateInput;
};

export type VideoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VideoUpsertInput;
  /** Unique document search */
  where: VideoWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type VideoWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type VideoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<VideoWhereStageInput>;
  documentInStages_none?: InputMaybe<VideoWhereStageInput>;
  documentInStages_some?: InputMaybe<VideoWhereStageInput>;
  durationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  durationInSeconds_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  durationInSeconds_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  durationInSeconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  durationInSeconds_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  durationInSeconds_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  durationInSeconds_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  durationInSeconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalId_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalImageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalImageUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalImageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalImageUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalImageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalImageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalImageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalImageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalImageUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  longDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  longDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  longDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  longDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  longDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  longDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  longDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  longDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  longDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  people_every?: InputMaybe<PersonWhereInput>;
  people_none?: InputMaybe<PersonWhereInput>;
  people_some?: InputMaybe<PersonWhereInput>;
  premieredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  premieredAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  premieredAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  premieredAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  premieredAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  premieredAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  premieredAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  premieredAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_every?: InputMaybe<TermWhereInput>;
  terms_none?: InputMaybe<TermWhereInput>;
  terms_some?: InputMaybe<TermWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  transcript_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  transcript_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  transcript_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  transcript_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  transcript_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  transcript_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  transcript_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  transcript_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  transcript_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  types?: InputMaybe<Array<VideoType>>;
  /** Matches if the field array contains *all* items provided to the filter */
  types_contains_all?: InputMaybe<Array<VideoType>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  types_contains_none?: InputMaybe<Array<VideoType>>;
  /** Matches if the field array contains at least one item provided to the filter */
  types_contains_some?: InputMaybe<Array<VideoType>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  types_not?: InputMaybe<Array<VideoType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoLists_every?: InputMaybe<VideoListWhereInput>;
  videoLists_none?: InputMaybe<VideoListWhereInput>;
  videoLists_some?: InputMaybe<VideoListWhereInput>;
  videoPreviewUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoPreviewUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoPreviewUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoPreviewUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoPreviewUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoPreviewUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoPreviewUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoPreviewUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoPreviewUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoPreviewUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type VideoWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<VideoWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Video record uniquely */
export type VideoWhereUniqueInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ViewNotificationInput = {
  notificationId: Scalars['String']['input'];
};

export type ViewNotificationPayload = {
  __typename?: 'ViewNotificationPayload';
  notification?: Maybe<ScoNotification>;
  view?: Maybe<ScoView>;
};

export type Viewer = {
  __typename?: 'Viewer';
  currentUser?: Maybe<ScoUser>;
  id: Scalars['ID']['output'];
  redeemPasswordResetToken?: Maybe<ScoUser>;
};


export type ViewerRedeemPasswordResetTokenArgs = {
  token: Scalars['String']['input'];
};

export type WithdrawBoardInviteInput = {
  advisorEngagementId?: InputMaybe<Scalars['String']['input']>;
};

export type WithdrawBoardInvitePayload = {
  __typename?: 'WithdrawBoardInvitePayload';
  advisorEngagement?: Maybe<ScoAdvisorEngagement>;
};

export enum _FilterKind {
  And = 'AND',
  Not = 'NOT',
  Or = 'OR',
  Contains = 'contains',
  ContainsAll = 'contains_all',
  ContainsNone = 'contains_none',
  ContainsSome = 'contains_some',
  DescendantsOf = 'descendants_of',
  EndsWith = 'ends_with',
  Eq = 'eq',
  EqNot = 'eq_not',
  Gt = 'gt',
  Gte = 'gte',
  In = 'in',
  JsonPathExists = 'json_path_exists',
  JsonValueRecursive = 'json_value_recursive',
  Lt = 'lt',
  Lte = 'lte',
  NotContains = 'not_contains',
  NotEndsWith = 'not_ends_with',
  NotIn = 'not_in',
  NotStartsWith = 'not_starts_with',
  RelationalEvery = 'relational_every',
  RelationalNone = 'relational_none',
  RelationalSingle = 'relational_single',
  RelationalSome = 'relational_some',
  Search = 'search',
  StartsWith = 'starts_with',
  UnionEmpty = 'union_empty',
  UnionEvery = 'union_every',
  UnionNone = 'union_none',
  UnionSingle = 'union_single',
  UnionSome = 'union_some'
}

export enum _MutationInputFieldKind {
  Enum = 'enum',
  Relation = 'relation',
  RichText = 'richText',
  RichTextWithEmbeds = 'richTextWithEmbeds',
  Scalar = 'scalar',
  Union = 'union',
  Virtual = 'virtual'
}

export enum _MutationKind {
  Create = 'create',
  Delete = 'delete',
  DeleteMany = 'deleteMany',
  Publish = 'publish',
  PublishMany = 'publishMany',
  SchedulePublish = 'schedulePublish',
  ScheduleUnpublish = 'scheduleUnpublish',
  Unpublish = 'unpublish',
  UnpublishMany = 'unpublishMany',
  Update = 'update',
  UpdateMany = 'updateMany',
  Upsert = 'upsert'
}

export enum _OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum _RelationInputCardinality {
  Many = 'many',
  One = 'one'
}

export enum _RelationInputKind {
  Create = 'create',
  Update = 'update'
}

export enum _RelationKind {
  Regular = 'regular',
  Union = 'union'
}

export enum _SystemDateTimeFieldVariation {
  Base = 'base',
  Combined = 'combined',
  Localization = 'localization'
}
